webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_NiceData__ = __webpack_require__(15);

















var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getUserId',
        value: function getUserId() {
            if (__WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.auth().currentUser) return __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.auth().currentUser.uid;else return null;
        }
    }, {
        key: 'isInsightUser',
        value: function isInsightUser(user) {
            if (!user) user = this.getUser();

            var uid = user.uid || user.key || user._key || (user.meta ? user.meta.key : 'no_user_key');

            var processors = __WEBPACK_IMPORTED_MODULE_13__helpers_LookupData__["a" /* default */].processors();
            if (!user.email) return false;
            if (processors.findIndex(function (o) {
                return o.email == user.email;
            }) > -1) return true;
            if (processors.findIndex(function (o) {
                return o.uid == uid;
            }) > -1) return true;

            return false;
        }
    }, {
        key: 'isAdministrator',
        value: function isAdministrator() {
            var userEmail = this.getUserEmail();

            return userEmail == 'matt.ireland.home@gmail.com' || userEmail == 'shannon.mcleish@insightprocessing.com.au';
        }
    }, {
        key: 'fetchUser',
        value: function fetchUser() {
            var timeToWait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
            var allowGoogleUser = arguments[1];

            var self = this;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var nextTimeToWait = timeToWait;
                if (nextTimeToWait < 5000) nextTimeToWait *= 1.3;
                var user = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.user;

                var str = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */];

                if (user && user.firstName && (user.office || allowGoogleUser)) {
                    console.log('fetchUser returns', user);
                    resolve(user);
                } else {
                    str.commit('startLoading', 'User');
                    console.log('fetchUser is waiting...(' + Math.round(timeToWait / 100) / 10 + 's)');
                    setTimeout(function () {
                        str.commit('stopLoading', 'User');
                        self.fetchUser(nextTimeToWait, allowGoogleUser).then(function (user) {
                            resolve(user);
                        });
                    }, timeToWait);
                }
            });
        }
    }, {
        key: 'getSettings',
        value: function getSettings(group) {
            var self = this;
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var user = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.user;
                var tenantKey = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantKey;

                if (!user || !user.uid) {
                    console.log('getSettings > no user');
                    return;
                }

                var ref = __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.database().ref('users').child(user.uid).child('offices').child(tenantKey).child('preferences').child(group);
                console.log('getSettings', ref.toString());
                ref.once('value', function (snap) {
                    resolve(snap.val() || {});
                });
            });
        }
    }, {
        key: 'loading',
        value: function loading() {
            return __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.loading;
        }
    }, {
        key: 'getStamp',
        value: function getStamp() {
            var user = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.user;
            var stamp = {};

            stamp.date = __WEBPACK_IMPORTED_MODULE_10__DateHelpers__["a" /* default */].todayString();
            stamp.time = __WEBPACK_IMPORTED_MODULE_10__DateHelpers__["a" /* default */].timeString();
            stamp.firstName = user.firstName || null;
            stamp.lastName = user.lastName || null;
            stamp.userKey = user.uid || null;
            return stamp;
        }
    }, {
        key: 'formatStamp',
        value: function formatStamp(stamp) {
            if (!stamp) return '';

            var str = stamp.firstName || '';

            var datePart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["a" /* format */])(__WEBPACK_IMPORTED_MODULE_10__DateHelpers__["a" /* default */].backwardsToDate(stamp.date), 'd/M');
            if (__WEBPACK_IMPORTED_MODULE_10__DateHelpers__["a" /* default */].isToday(stamp.date)) datePart = 'Today';

            if (stamp.date) str += ' (' + datePart + '@' + stamp.time.replace(/^0+/, '') + ')';

            if (str) str = ' - ' + str;

            return str;
        }
    }, {
        key: 'officeName',
        value: function officeName() {
            return this.officeNameFromKey(__WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantKey);
        }
    }, {
        key: 'officeNameFromKey',
        value: function officeNameFromKey(key) {
            var office = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.offices.find(function (o) {
                return o.meta.key == key;
            });
            if (!office) return '';
            return office.name;
        }
    }, {
        key: 'preferredOffice',
        value: function preferredOffice() {
            var offices = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.officesActive;
            var defaultTenant = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantDefault;

            if (!offices || !defaultTenant) {
                return '999';
            }

            var office = offices.find(function (o) {
                return o.meta.key == defaultTenant.key;
            });
            if (office) return office;

            return offices[0];
        }
    }, {
        key: 'getTenantKey',
        value: function getTenantKey() {
            return __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantKey;
        }
    }, {
        key: 'getTenantRef',
        value: function getTenantRef(key) {
            var tenantKey = key || this.getTenantKey();
            if (!tenantKey) {
                console.log('Cant get tennant id');
            }

            return __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.database().ref('tenants').child(tenantKey);
        }
    }, {
        key: 'getOfficesWithRefs',
        value: function getOfficesWithRefs() {
            var _this = this;

            var offices = __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.officesActive;
            offices.forEach(function (office) {
                office.ref = _this.getRootRef().child('tenants').child(office.meta.key);
            });
            return offices;
        }
    }, {
        key: 'getTransactionRef',
        value: function getTransactionRef(transactionKey, tenantKey) {
            transactionKey = transactionKey || this.getTransactionKey();
            return this.getTenantRef(tenantKey).child('transactions').child(transactionKey);
        }
    }, {
        key: 'getTransactionSummaryRef',
        value: function getTransactionSummaryRef() {
            return this.getTenantRef().child('transactionSummary');
        }
    }, {
        key: 'getTransactionKey',
        value: function getTransactionKey() {
            return __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.transaction.key;
        }
    }, {
        key: 'getTransactionDetails',
        value: function getTransactionDetails() {
            return __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.transaction;
        }
    }, {
        key: 'getRootRef',
        value: function getRootRef() {
            return __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.database().ref();
        }
    }, {
        key: 'getUserRef',
        value: function getUserRef() {
            var uid = this.getUserId();

            return this.getRootRef().child('users').child(uid);
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            return __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.user;
        }
    }, {
        key: 'getUserEmail',
        value: function getUserEmail() {
            var user = __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.auth().currentUser;
            if (user) return user.email;else return null;
        }
    }, {
        key: 'getPreferencesRef',
        value: function getPreferencesRef(tenantKey, uid) {
            tenantKey = tenantKey || this.getTenantKey();
            uid = uid || this.getUserId();
            return this.getRootRef().child('users').child(uid).child('offices').child(tenantKey).child('preferences');
        }
    }, {
        key: 'getPreferencesGroup',
        value: function getPreferencesGroup(tenantKey, uid, group) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = _this2.getPreferencesRef(tenantKey, uid).child(group);
                __WEBPACK_IMPORTED_MODULE_14__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (group) {
                    if (!group) group = {};
                    resolve(group);
                });
            });
        }
    }, {
        key: 'getRoles',
        value: function getRoles() {
            return ['Client', 'Referrer', 'Solicitor', 'Agent', 'Builder', 'Guarantor', 'Consultant', 'Supplier Contact'];
        }
    }, {
        key: 'activityTypes',
        value: function activityTypes() {
            return [{ id: 'c', name: 'Comment' }, { id: 't', name: 'Task' }, { id: 'e', name: 'Email' }, { id: 's', name: 'SMS Message' }, { id: 'k', name: 'Link' }, { id: 'd', name: 'Document' }, { id: 'sw', name: 'Switch' }, { id: 'sl', name: 'Slider' }, { id: 'tb', name: 'Textbox' }, { id: 'dt', name: 'Date' }, { id: 'li', name: 'List' }, { id: 'f', name: 'File' }, { id: 'i', name: 'Information' }, { id: 'ct', name: 'Contact' }];
        }
    }, {
        key: 'transactionFlags',
        value: function transactionFlags() {
            return ['First Home Owner', 'Purchase', 'Refinance', 'Guarantor', 'Construction'];
        }
    }, {
        key: 'suppliers',
        value: function suppliers() {
            return ['ANZ', 'CBA', 'ING Direct', 'Macquarie', 'Mortgage Choice', 'NAB', 'Suncorp', 'Westpac'];
        }
    }, {
        key: 'unionByKey',
        value: function unionByKey(arr1, arr2) {
            var union = arr1.concat(arr2);

            for (var i = 0; i < union.length; i++) {
                for (var j = i + 1; j < union.length; j++) {
                    if (union[i].key === union[j].key) {
                        union.splice(j, 1);
                        j--;
                    }
                }
            }
            return union;
        }
    }, {
        key: 'unionById',
        value: function unionById(arr1, arr2) {
            var union = arr1.concat(arr2);

            for (var i = 0; i < union.length; i++) {
                for (var j = i + 1; j < union.length; j++) {
                    if (union[i]._id === union[j]._id) {
                        union.splice(j, 1);
                        j--;
                    }
                }
            }
            return union;
        }
    }, {
        key: 'templateTransactionKey',
        value: function templateTransactionKey() {
            return '-Kv4G-2oujQGP7DUvT4T';
        }
    }, {
        key: 'getKey',
        value: function getKey() {
            return __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.database().ref().push().key;
        }
    }, {
        key: 'initialiseTenant',
        value: function initialiseTenant(tenantKey, onlyIfEmpty) {
            if (onlyIfEmpty) {
                if (!__WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantKey) {
                    console.log('initialiseTenant > First time set to ' + tenantKey);
                    __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].commit('setTenant', { key: tenantKey });
                } else return;
            }

            if (tenantKey != __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantKey) {
                console.log('initialiseTenant > Switching tenant from ' + __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].getters.tenantKey + ' to ' + tenantKey);
                __WEBPACK_IMPORTED_MODULE_9__store_Store__["a" /* default */].commit('setTenant', { key: tenantKey });
            }
        }
    }, {
        key: 'saveActivity',
        value: function saveActivity(activity) {

            var key = activity['.key'];
            if (!key) key = this.getTenantRef().push().key;

            delete activity['.key'];

            activity.stamp = this.getStamp();

            if (!activity.sortKey) activity.sortKey = __WEBPACK_IMPORTED_MODULE_4__StringHelpers__["a" /* default */].sortKey();

            console.log('DataHelpers > saveActivity', activity);
            var ref = this.getTenantRef().child('transactions').child(activity.transactionKey).child('activities').child(key);
            ref.update(activity);
        }
    }, {
        key: 'saveTransaction',
        value: function saveTransaction(transaction) {
            var _this3 = this;

            console.log('DataHelpers > saveTransaction', transaction);
            var transactionKey = transaction['.key'];
            if (!transactionKey) transactionKey = this.getTenantRef().push().key;

            var tran = __WEBPACK_IMPORTED_MODULE_5__FirebaseHelpers__["a" /* default */].cloneWithoutKey(transaction);

            tran.stamp = this.getStamp();

            var ref = this.getTenantRef().child('transactions').child(transactionKey).child('details');

            ref.update(tran);

            var templateRef = this.getTenantRef().child('transactionTemplates').child(transactionKey);
            var templateObj = tran.isTemplate ? tran : {};
            templateRef.set(templateObj);

            var peopleRef = this.getTenantRef().child('transactions').child(transactionKey).child('people');
            peopleRef.once('value', function (peopleSnap) {
                peopleSnap.forEach(function (itemSnap) {
                    var contactKey = itemSnap.key;
                    var ref = _this3.getTenantRef().child('contactTransactions').child(contactKey).child(transactionKey);
                    ref.update({ description: transaction.description });
                });
            });
        }
    }, {
        key: 'checkFilter',
        value: function checkFilter(importItem, fields) {
            var match = true;
            var result = 'DataHelpers > checkFilter (' + importItem.title + ')';

            if (importItem.filterParameters) {
                for (var parameter in importItem.filterParameters) {
                    var field = void 0;
                    if (fields && fields.length) field = fields.find(function (o) {
                        return o.parameter == parameter;
                    });else match = false;

                    if (match && importItem.filterParameters[parameter] == 'include') {
                        if (!field || !field.answer == true) match = false;
                    }
                    if (match && importItem.filterParameters[parameter] == 'exclude') {
                        if (field && field.answer == true) match = false;
                    }
                }
            }

            if (importItem.filterSuppliers) {

                var transactionSupplierObject = fields.find(function (o) {
                    return o.parameter == 'Supplier';
                });
                if (!transactionSupplierObject) {
                    console.log('No supplier to filter on');
                    match = false;
                } else {

                    var transactionSupplier = transactionSupplierObject.answer;

                    console.log('Filtering supplier', transactionSupplier);

                    if (importItem.filterSuppliers[transactionSupplier] != 'include') {
                        match = false;
                    }
                    if (importItem.filterSuppliers[transactionSupplier] == 'exclude') {
                        match = false;
                    }
                }
            }

            if (match) result += ' OK';else result += ' Reject';

            console.log(result);

            return match;
        }
    }, {
        key: 'checkImport',
        value: function checkImport(importItem, fields) {

            if (!importItem.filter) return true;

            var importInclude = importItem.filter.include;
            if (importInclude) {

                for (var importParameter in importInclude) {

                    var transactionValue = fields[importParameter];
                    if (!transactionValue) return false;

                    var found = false;
                    var importValues = importInclude[importParameter];
                    for (var importValue in importValues) {
                        if (importValue == transactionValue) found = true;
                    }

                    if (!found) return false;
                }
            }
            return true;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_esm__ = __webpack_require__(17);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'isMobileNumber',
        value: function isMobileNumber(str) {
            var phoneNumber = str.replace(/\D/g, '');
            if (phoneNumber.indexOf('04') != 0) return false;

            return phoneNumber.length == 10;
        }
    }, {
        key: 'capitalizeFirstLetter',
        value: function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }, {
        key: 'removeSpaces',
        value: function removeSpaces(str) {
            return str.replace(/\s/g, '_');
        }
    }, {
        key: 'restoreSpaces',
        value: function restoreSpaces(str) {
            return str.replace(/\_/g, ' ');
        }
    }, {
        key: 'sentenceJoin',
        value: function sentenceJoin(array) {
            if (!array || array.length < 1) return '';

            var returnValue = '';
            for (var n = 0; n < array.length; n++) {
                var currentItem = array[n];
                if (currentItem) {
                    returnValue += currentItem;
                    if (n == array.length - 2) returnValue += ' and ';else if (n < array.length - 2) returnValue += ', ';
                }
            }

            return returnValue;
        }
    }, {
        key: 'acronym',
        value: function acronym(string) {
            var arr = string.split(' ');
            var initialArray = arr.map(function (i) {
                return i.substr(0, 1);
            });
            return initialArray.join('');
        }
    }, {
        key: 'toKebabCase',
        value: function toKebabCase(str) {
            return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase().replace(' ', '-');
        }
    }, {
        key: 'toSnakeCase',
        value: function toSnakeCase(str) {
            return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
                return x.toLowerCase();
            }).join('_');
        }
    }, {
        key: 'snakeToNormal',
        value: function snakeToNormal(str) {
            return this.toTitleCase(str.replace('_', ' '));
        }
    }, {
        key: 'toTitleCase',
        value: function toTitleCase(str) {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
    }, {
        key: 'toCamelCase',
        value: function toCamelCase(str) {
            if (!str) return '';
            str = str.replace(/\./g, ' ');
            return str.toLowerCase().replace(/(?:^\w|[A-Z]|\b\w)/g, function (ltr, idx) {
                return idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase();
            }).replace(/\s+/g, '');
        }
    }, {
        key: 'camelToNormal',
        value: function camelToNormal(str) {
            var result = '';
            var prevLower = false;
            for (var i = 0; i < str.length; i++) {
                var currentChar = str.charAt(i);
                var currentLower = this.isLowerCase(currentChar);
                if (prevLower && !currentLower) result += ' ';
                result += currentChar;
                prevLower = currentLower;
            }
            return this.capitalizeFirstLetter(result);
        }
    }, {
        key: 'isAlphabetic',
        value: function isAlphabetic(str) {
            return str && /^[a-zA-Z]+$/.test(str);
        }
    }, {
        key: 'isUpperCase',
        value: function isUpperCase(str) {
            return this.isAlphabetic(str) && str == str.toUpperCase();
        }
    }, {
        key: 'isLowerCase',
        value: function isLowerCase(str) {
            return this.isAlphabetic(str) && str == str.toLowerCase();
        }
    }, {
        key: 'dueString',
        value: function dueString(date) {
            if (!date) return 'Not Scheduled';

            return 'Due ' + __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].fromNow(date).toLowerCase();
        }
    }, {
        key: 'sortKey',
        value: function sortKey() {
            return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(new Date(), 'yyMMddHHmmssSS'));
        }
    }, {
        key: 'randomString',
        value: function randomString(length) {
            var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var result = '';
            for (var i = length; i > 0; --i) {
                result += chars[Math.floor(Math.random() * chars.length)];
            }return result;
        }
    }, {
        key: 'firstWord',
        value: function firstWord(str) {
            if (!str) return '';
            return str.split(' ')[0].trim();
        }
    }, {
        key: 'dateStamp',
        value: function dateStamp() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(new Date(), 'yy-MM-dd');
        }
    }, {
        key: 'replaceAt',
        value: function replaceAt(str, index, replacement) {
            return str.substr(0, index) + replacement + str.substr(index + replacement.length);
        }
    }, {
        key: 'formatPercent',
        value: function formatPercent(num) {
            if (!num) return 'Nil';

            return (num * 100).toString() + '%';
        }
    }, {
        key: 'formatPhone',
        value: function formatPhone(phoneNumber) {
            if (!phoneNumber) return '';
            var s = phoneNumber.replace(/\D/g, '');
            var arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(s));
            if (arr.length == 10 && arr[0] == '0') {
                if (arr[1] == '4') {
                    phoneNumber = '04' + arr[2] + arr[3] + ' ' + arr[4] + arr[5] + arr[6] + ' ' + arr[7] + arr[8] + arr[9];
                    console.log(phoneNumber);
                } else phoneNumber = '0' + arr[1] + ' ' + arr[2] + arr[3] + arr[4] + arr[5] + ' ' + arr[6] + arr[7] + arr[8] + arr[9];
            }
            return phoneNumber;
        }
    }, {
        key: 'formatMailTo',
        value: function formatMailTo(email) {
            if (!this.isEmail(email)) return '';
            return '<a style="color:#1976d2!important" href="mailto:' + email + '">' + email + '</a>';
        }
    }, {
        key: 'formatNumber',
        value: function formatNumber(num) {
            if (!num) return '';
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }, {
        key: 'blockReturns',
        value: function blockReturns(value) {
            return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    }, {
        key: 'formatFloat',
        value: function formatFloat(value) {
            if (!value) return '';

            var newVal = value.toString().replace(/[^0-9\.]+/g, '');
            return parseFloat(newVal);
        }
    }, {
        key: 'formatInteger',
        value: function formatInteger(value) {
            if (!value) return '';

            var newVal = value.toString().replace(/[^0-9.]/g, '');
            return parseInt(newVal);
        }
    }, {
        key: 'formatCurrency',
        value: function formatCurrency(num) {
            if (!num || isNaN(num)) return '';

            num = this.formatInteger(num);

            var p = num.toFixed(2).split(".");
            return "$" + p[0].split("").reverse().reduce(function (acc, num, i, orig) {
                return num == "-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
            }, "");
        }
    }, {
        key: 'formatCurrencyWithCents',
        value: function formatCurrencyWithCents(num) {
            if (!num || isNaN(num)) return '';

            num = parseFloat(num);

            var p = num.toFixed(2).split(".");
            return "$" + p[0].split("").reverse().reduce(function (acc, num, i, orig) {
                return num == "-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
            }, "") + "." + p[1];
        }
    }, {
        key: 'rootPath',
        value: function rootPath() {
            var path = window.location.protocol + "//" + window.location.host + "/";

            return path;
        }
    }, {
        key: 'linkToTaco',
        value: function linkToTaco(path, text) {
            return '<a href="' + this.rootPath() + path + '" target="_blank" style="text-decoration:none;margin:0 auto;">' + '<div style="padding:7px 12px;background-color:#1976d2;color:white;border-radius:4px;cursor:pointer;user-select:none;display:inline-block;margin: 0 auto">' + text + '</div>' + '</a>';
        }
    }, {
        key: 'imagePath',
        value: function imagePath() {
            return this.rootPath() + 'static/images/';
        }
    }, {
        key: 'truncate',
        value: function truncate(str, len) {
            return str.length > len ? str.substr(0, len - 1) : str;
        }
    }, {
        key: 'truncateDots',
        value: function truncateDots(str, len) {
            if (!str || str.length < len) return str;
            return this.truncate(str, len) + '...';
        }
    }, {
        key: 'mentions',
        value: function mentions(str) {
            var rx = /(?:^|\s)(@[a-z0-9]\w*)/gi;
            var results = str.match(rx) || [];
            return results.map(function (word) {
                return word.trim();
            });
        }
    }, {
        key: 'hashtags',
        value: function hashtags(str) {
            var rx = /(?:^|\s)(#[a-z0-9]\w*)/gi;
            var results = str.match(rx) || [];
            return results.map(function (word) {
                return word.trim();
            });
        }
    }, {
        key: 'isEmail',
        value: function isEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: 'removeHtml',
        value: function removeHtml(htmlString) {
            var omitNewLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!omitNewLines) htmlString = htmlString.replace(/<br\s*[\/]?>/gi, "\n");
            var div = document.createElement("div");
            div.innerHTML = htmlString;
            return div.textContent || div.innerText || "";
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns__ = __webpack_require__(17);
















var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'openWindowWithHtml',
        value: function openWindowWithHtml(title, html) {
            var win = window.open("", title, "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400,height=300,top=" + (screen.height - 200) / 2 + ",left=" + (screen.width - 150) / 2);
            win.document.title = title || 'Taco Snippet';
            win.document.body.innerHTML = html;
        }
    }, {
        key: 'printHtml',
        value: function printHtml(html) {
            var winHeight = 530;
            var winWidth = 800;


            var winLeft = screen.width / 2 - winWidth / 2;
            var winTop = screen.height / 2 - winHeight / 2;

            var mywindow = window.open('', 'PRINT', 'height=' + winHeight + ',width=' + winWidth + ',top=' + winTop + ',left=' + winLeft);

            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('</head><body >');

            mywindow.document.write(html);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();

            mywindow.print();
            mywindow.close();

            return true;
        }
    }, {
        key: 'focusById',
        value: function focusById(id) {
            setTimeout(function () {
                var region = document.getElementById(id);
                if (!region) {
                    console.log('focusById id not found', id);
                    return;
                }
                try {
                    region.focus();
                } catch (e) {}
                var targetInput = region.getElementsByTagName('input')[0];
                if (targetInput) targetInput.focus();
            }, 200);
        }
    }, {
        key: 'focus',
        value: function focus(context, refName) {
            var select = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var _this = this;

            var preventScroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var retry = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

            if (this.isMobile()) return;
            setTimeout(function () {
                var targetComponent = context.$refs[refName];
                if (targetComponent) {
                    var targetInput = targetComponent.focus ? targetComponent : targetComponent.$el.getElementsByTagName('input')[0];

                    targetInput.focus({
                        preventScroll: preventScroll
                    });

                    if (retry) console.log('focus set after ' + retry + ' retries');

                    if (select) {
                        targetInput.select();
                    }
                } else {
                    if (retry > 3) console.log('Cant set focus...retry count exceeded for ref' + refName);else _this.focus(context, refName, select, preventScroll, retry + 1);
                }
            }, 200);
        }
    }, {
        key: 'log',
        value: function log() {
            var _console;

            (_console = console).log.apply(_console, arguments);
        }
    }, {
        key: 'isPhoneNumber',
        value: function isPhoneNumber(str) {
            if (!str) return false;
            str = str.replace(/\D/g, '');
            return str.length == 10 && str.charAt(0) == '0';
        }
    }, {
        key: 'toFaxAddress',
        value: function toFaxAddress(faxNumber) {

            faxNumber = faxNumber.replace(/\D/g, '').replace('0', '61');

            if (faxNumber.length != 11) {
                console.error('Invalid fax no provided', faxNumber);
                return;
            }

            return faxNumber + '@fax.utbox.net';
        }
    }, {
        key: 'sendSMS',
        value: function sendSMS(message, mobile) {

            console.log('Utilities > sendSMS (ACTIVE)', message, mobile);


            mobile = mobile.replace(/\D/g, '').replace('0', '61');

            if (mobile.length != 11) {
                console.error('Invalid mobile provided', mobile);
                return;
            }

            var to = mobile + '@sms.utbox.net';

            var email = {
                to: to,
                subject: message,
                body: message
            };

            __WEBPACK_IMPORTED_MODULE_9__EmailHelpers__["a" /* default */].sendEmail(email);

            return;
        }
    }, {
        key: 'isMobile',
        value: function isMobile() {
            var result = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            return result;
        }
    }, {
        key: 'clearProperties',
        value: function clearProperties(obj) {
            console.log('Clearing properties for', obj);
            for (var property in obj) {
                if (obj.hasOwnProperty(property)) {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(obj, property, null);
                }
            }
        }
    }, {
        key: 'removeUndefinedProperties',
        value: function removeUndefinedProperties(obj) {
            for (var property in obj) {
                if (obj.hasOwnProperty(property)) {
                    if (typeof obj[property] == 'undefined') {
                        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(obj, property, null);
                        console.log('*WARN* Utilities > removeUndefinedProperties replaced null', property);
                    }
                    if (typeof obj[property] == 'NaN') {
                        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(obj, property, null);
                        console.log('*WARN* Utilities > removeUndefinedProperties replaced Nan', property);
                    }
                }
            }
        }
    }, {
        key: 'copyProperties',
        value: function copyProperties(sourceObj, destObj) {
            console.log('Utilities > copyProperties');

            for (var property in sourceObj) {
                if (sourceObj.hasOwnProperty(property)) {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(destObj, property, sourceObj[property]);
                }
            }
        }
    }, {
        key: 'assignProperty',
        value: function assignProperty(fromObject, fromProperty, toObject, toProperty) {

            if (!fromObject) return;
            if (fromObject[fromProperty] == null) return;
            if (!toProperty) toProperty = fromProperty;

            toObject[toProperty] = fromObject[fromProperty];
        }
    }, {
        key: 'transferProperties',
        value: function transferProperties(sourceObj, destObj) {
            for (var property in sourceObj) {
                if (sourceObj.hasOwnProperty(property) && destObj.hasOwnProperty(property)) {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(destObj, property, sourceObj[property]);
                }
            }
        }
    }, {
        key: 'clone',
        value: function clone(obj) {
            if (!obj) {
                console.log('Utilities > clone > returning empty object as nothing passed');
                return {};
            }

            return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(obj));
        }
    }, {
        key: 'blobToDataURL',
        value: function blobToDataURL(blob, callback) {
            var a = new FileReader();
            a.onload = function (e) {
                callback(e.target.result);
            };
            a.readAsDataURL(blob);
        }
    }, {
        key: 'checkIfThisWasDone',
        value: function checkIfThisWasDone(identifier) {
            var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getRootRef().child('app/temp/' + identifier);
                __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (record) {
                    if (!record) record = {
                        identifier: identifier,
                        timestamp: '2019-01-01 00:00',
                        meta: {
                            key: identifier,
                            path: 'app/temp'
                        }
                    };

                    var diff = Math.abs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_date_fns__["t" /* differenceInMinutes */])(__WEBPACK_IMPORTED_MODULE_12__DateHelpers__["a" /* default */].backwardsToDate(record.timestamp), new Date()));

                    if (diff > minutes) {
                        record.timestamp = __WEBPACK_IMPORTED_MODULE_12__DateHelpers__["a" /* default */].nowString();
                        __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].saveItem(record);
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                });
            });
        }
    }, {
        key: 'emptyObject',
        value: function emptyObject(obj) {
            for (var member in obj) {
                delete obj[member];
            }
        }
    }, {
        key: 'emptyArray',
        value: function emptyArray(arr) {
            while (arr.length > 0) {
                arr.pop();
            }
        }
    }, {
        key: 'objectToArray',
        value: function objectToArray(obj) {

            var arr = [];
            for (var item in obj) {
                if (obj.hasOwnProperty(item)) arr.push(item);
            }
            return arr;
        }
    }, {
        key: 'objectToObjectArray',
        value: function objectToObjectArray(obj) {

            var arr = [];
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) arr.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj[prop], { '.key': prop }));
            }
            return arr;
        }
    }, {
        key: 'arrayToObject',
        value: function arrayToObject(array) {
            var obj = {};
            array.forEach(function (item) {
                obj[item] = true;
            });
            return obj;
        }
    }, {
        key: 'copyObject',
        value: function copyObject(sourceObj) {
            delete sourceObj['.key'];
            delete sourceObj['key'];
            delete sourceObj['__proto__'];
            for (var property in sourceObj) {
                if (sourceObj.hasOwnProperty(property)) {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(destObj, property, sourceObj[property]);
                }
            }
        }
    }, {
        key: 'arrayToggle',
        value: function arrayToggle(array, value) {
            var index = array.indexOf(value);

            if (index === -1) {
                array.push(value);
            } else {
                array.splice(index, 1);
            }
        }
    }, {
        key: 'objectToggle',
        value: function objectToggle(object, property) {
            if (object[property]) {
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(object, property, null);
            } else {
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(object, property, true);
            }
        }
    }, {
        key: 'arrayNextObject',
        value: function arrayNextObject(currentObject, array) {
            var currentIndex = array.findIndex(function (o) {
                return o.key == currentObject.key;
            });
            return array[currentIndex + 1] || null;
        }
    }, {
        key: 'arrayPreviousObject',
        value: function arrayPreviousObject(currentObject, array) {
            var currentIndex = array.findIndex(function (o) {
                return o.key == currentObject.key;
            });
            return array[currentIndex - 1] || null;
        }
    }, {
        key: 'newOrderBefore',
        value: function newOrderBefore(currentObject, array) {
            var currentOrder = parseInt(currentObject.order || 1000000);

            var siblings = array.filter(function (o) {
                return o.parent == currentObject.parent;
            }).sort(__WEBPACK_IMPORTED_MODULE_8__OrderHelpers__["a" /* default */].sortAscending);
            var previousObject = this.arrayPreviousObject(currentObject, siblings);
            var previousOrder = parseInt(previousObject ? previousObject.order : 0 - __WEBPACK_IMPORTED_MODULE_7__StringHelpers__["a" /* default */].sortKey());

            return parseInt((currentOrder + previousOrder) / 2);
        }
    }, {
        key: 'newOrderAfter',
        value: function newOrderAfter(currentObject, array) {
            var currentOrder = parseInt(currentObject.order || 1000000);

            var siblings = array.filter(function (o) {
                return o.parent == currentObject.parent;
            }).sort(__WEBPACK_IMPORTED_MODULE_8__OrderHelpers__["a" /* default */].sortAscending);
            var nextObject = this.arrayNextObject(currentObject, siblings);
            var nextOrder = parseInt(nextObject ? nextObject.order : __WEBPACK_IMPORTED_MODULE_7__StringHelpers__["a" /* default */].sortKey());

            return parseInt((currentOrder + nextOrder) / 2);
        }
    }, {
        key: 'updateObjectArray',
        value: function updateObjectArray(obj, arr) {

            var idx = arr.findIndex(function (o) {
                return o.key == obj.key;
            });

            if (idx >= 0) {
                console.log('updateObjectArray > index found', idx);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(arr, idx, obj);
            } else {

                console.log('updateObjectArray > adding new row', obj);

                arr.push(obj);
            }
        }
    }, {
        key: 'isObject',
        value: function isObject(value) {
            return value !== null && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object';
        }
    }, {
        key: 'objectListToArray',
        value: function objectListToArray(obj) {

            var arr = [];
            for (var item in obj) {
                if (obj.hasOwnProperty(item)) {
                    var newItem = obj[item];
                    newItem.meta = {};
                    newItem.meta.key = item;
                    arr.push(newItem);
                }
            }
            return arr;
        }
    }, {
        key: 'getPropertySafely',
        value: function getPropertySafely(obj, propertyName) {
            if (!obj) return null;
            return obj[propertyName];
        }
    }, {
        key: 'objectDeepSet',
        value: function objectDeepSet(obj, path, value) {

            if (typeof value == 'undefined') return;

            var pieces = path.split('/');
            var deepObj = obj;
            for (var n = 0; n < pieces.length; n++) {
                var piece = pieces[n];
                if (n < pieces.length - 1) {
                    if (!deepObj[piece]) __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(deepObj, piece, {});
                    deepObj = deepObj[piece];
                } else {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(deepObj, piece, value);
                }
            }
        }
    }, {
        key: 'objectDeepGet',
        value: function objectDeepGet(obj, path) {
            var pieces = void 0;
            if (Array.isArray(path)) pieces = path;else pieces = path.split('/');

            var deepObj = obj;

            for (var n = 0; n < pieces.length; n++) {
                var piece = pieces[n];
                if (!deepObj[piece]) {
                    return null;
                }
                deepObj = deepObj[piece];
            }
            return deepObj;
        }
    }]);

    return _class;
}();

_class.debounce = function (fn, time) {
    var timeout = void 0;

    return function () {
        var _this2 = this,
            _arguments = arguments;

        var functionCall = function functionCall() {
            return fn.apply(_this2, _arguments);
        };

        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
    };
};

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__AlgoliaHelpers__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__CloudHelpers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__TeamHelpers__ = __webpack_require__(50);






























var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchRelationships',
        value: function fetchRelationships(contact) {
            var team = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getItemTeam(contact);
            var ref = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getCollectionDataRef(team, 'relationships').where('primaryId', '==', contact._id);
            return __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].fetchCollection(ref);
        }
    }, {
        key: 'contactPartnerId',
        value: function contactPartnerId(contact) {
            var partnerRelationship = contact.relationships.find(function (o) {
                return o.relationship == 'Partner';
            });
            if (partnerRelationship) return partnerRelationship.contactId;else return null;
        }
    }, {
        key: 'fetchCoupleRelationships',
        value: function fetchCoupleRelationships(contact1, contact2) {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var team = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getItemTeam(contact1);
                var ref1 = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getCollectionDataRef(team, 'relationships').where('primaryId', '==', contact1._id).where('relatedId', '==', contact2._id);
                var ref2 = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getCollectionDataRef(team, 'relationships').where('primaryId', '==', contact2._id).where('relatedId', '==', contact1._id);
                var p1 = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].fetchCollection(ref1);
                var p2 = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].fetchCollection(ref2);
                __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.all([p1, p2]).then(function (results) {
                    resolve([].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(results[0]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(results[1])));
                });
            });
        }
    }, {
        key: 'contactsArePartners',
        value: function contactsArePartners(contact1, contact2) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.fetchPartnershipRows(contact1, contact2).then(function (partnerships) {
                    resolve(partnerships.length > 0);
                });
            });
        }
    }, {
        key: 'makePartners',
        value: function makePartners(contact1, contact2, relationships) {
            this.relateContacts(contact1, 'Partner', contact2, 'Partner', relationships);
        }
    }, {
        key: 'separatePartners',
        value: function separatePartners(contact1, contact2, relationships) {
            var partnerRelationship = relationships.find(function (o) {
                return o.relatedRelationship == 'Partner';
            });
            while (partnerRelationship) {
                __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].deleteObjectFromArray(partnerRelationship, relationships);
                __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].deleteItem(partnerRelationship);
                partnerRelationship = relationships.find(function (o) {
                    return o.relatedRelationship == 'Partner';
                });
            }

            this.saveHasPartnerTag(contact1, null);
            this.saveHasPartnerTag(contact2, null);

            console.log('Separated...');
        }
    }, {
        key: 'relateContacts',
        value: function relateContacts(contact1, relationship1, contact2, relationship2, relationships) {

            var t1 = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getItemTeam(contact1);
            var t2 = __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getItemTeam(contact2);

            if (t1 != t2) throw 'Cannot relate contacts from different teams';

            var r1 = {
                _id: __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getId(),
                _team: t1,
                _collection: 'relationships',
                name: contact1.firstName + ' and ' + contact2.firstName,
                primaryId: contact1._id,
                primaryFirstName: contact1.firstName,
                primaryLastname: contact1.lastName,
                relatedId: contact2._id,
                relatedRelationship: relationship2,
                relatedFirstName: contact2.firstName,
                relatedLastName: contact2.lastName,
                relatedImage: contact2.image
            };

            var r2 = {
                _id: __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].getId(),
                _team: t1,
                _collection: 'relationships',
                name: contact2.firstName + ' and ' + contact1.firstName,
                primaryId: contact2._id,
                primaryFirstName: contact2.firstName,
                primaryLastname: contact2.lastName,
                relatedId: contact1._id,
                relatedRelationship: relationship1,
                relatedFirstName: contact1.firstName,
                relatedLastName: contact1.lastName,
                relatedImage: contact1.image
            };

            relationships.push(r1);
            relationships.push(r2);
            __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].saveItem(r1);
            __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].saveItem(r2);

            if (relationship1 == 'Partner') {
                this.saveHasPartnerTag(contact1, true);
                this.saveHasPartnerTag(contact2, true);
            }

            console.log('Related contacts');
        }
    }, {
        key: 'saveHasPartnerTag',
        value: function saveHasPartnerTag(contact, value) {
            __WEBPACK_IMPORTED_MODULE_25_vue__["default"].set(contact, 'hasPartner', value);
            __WEBPACK_IMPORTED_MODULE_24__data_Firestore__["a" /* default */].saveItem(contact);
        }
    }, {
        key: 'mergeContactCards',
        value: function mergeContactCards(role, elements) {
            var _this2 = this;

            var matchingElements = __WEBPACK_IMPORTED_MODULE_17__ElementHelpers__["a" /* default */].contactElementsForRole(role, elements);
            var str = '';
            matchingElements.forEach(function (element) {
                str += _this2.contactCard(element.contact);
            });
            return str;
        }
    }, {
        key: 'contactCard',
        value: function contactCard(contact) {
            var img = contact.image || '';
            var initials = '';
            if (img.indexOf('random') > -1) img = '';
            if (!img) initials = __WEBPACK_IMPORTED_MODULE_18__ContactHelpers__["a" /* default */].initials(contact);
            var str = '\n        <table>\n            <tr>\n                <td rowspan="2" valign="top" style="padding:0 10px">\n                    <div style="background-color:#03a9f4;background-image:url(' + img + ');border-radius:25px;width:50px;height:50px;border:solid 2px #eee;background-size: cover;background-position: center center;background-repeat: no-repeat;font-size:20px;color:white;padding:6px 10px;">' + initials + '</div>\n                </td>\n                <td style="background-color:#ddd;border-radius:5px;padding:3px 10px;font-weight:bold;border:solid 1px #bbb;" >\n                    ' + __WEBPACK_IMPORTED_MODULE_18__ContactHelpers__["a" /* default */].fullName(contact) + '\n                </td>\n            </tr>\n            <tr>\n                <td>\n                    [contact_details]\n                </td>\n            </tr>\n        </table>';
            return str.replace('[contact_details]', this.contactDetails(contact));
        }
    }, {
        key: 'contactDetails',
        value: function contactDetails(contact) {
            var str = '<table>';
            str = this.addDetail(str, 'M', __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].formatPhone(contact.mobile));
            str = this.addDetail(str, 'T', __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].formatPhone(contact.phone));
            str = this.addDetail(str, 'E', __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].formatMailTo(contact.email));
            str = str + '</table>';
            return str;
        }
    }, {
        key: 'addDetail',
        value: function addDetail(str, heading, value) {
            if (!value) return str;
            str += '\n        <tr style="">\n            <td style="color:#888;font-weight:bold;margin-right:10px;width:1%;text-align:right;padding-right:5px;">' + heading + '</td>\n            <td style="color:#555">' + value + '</td>\n        </tr>';
            return str;
        }
    }, {
        key: 'namesToContacts',
        value: function namesToContacts(nameString) {
            if (!nameString) return [];

            var contacts = [];
            var previousLastName = '';
            nameString = nameString.replace(/ and /gi, ',').replace(/ \& /, ',');
            var fullNames = nameString.split(',');
            fullNames.reverse();
            fullNames.forEach(function (fullName) {
                var names = fullName.trim().split(' ');
                var lastName = names[names.length - 1].trim();

                if (names.length > 2) {

                    var middleName = names[names.length - 2];
                    if (__WEBPACK_IMPORTED_MODULE_21__ArrayHelpers__["a" /* default */].textInArray(middleName, ['Mc', 'Mac', 'Van', 'Von'])) lastName = middleName + ' ' + lastName;
                }

                if (names.length < 2) lastName = previousLastName || '';else previousLastName = lastName;

                var firstName = fullName.replace(lastName, '').trim();
                contacts.unshift({ firstName: firstName, lastName: lastName });
            });
            return contacts;
        }
    }, {
        key: 'setInitialGender',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(model) {
                var vm;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = this;

                                if (!(!model.firstName || model.firstName.length < 3 || model.gender)) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:

                                console.log('gender check');

                                _context.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_27__CloudHelpers__["a" /* default */].getGender(model.firstName);

                            case 6:
                                model.gender = _context.sent;

                                model.image = this.getGenderImage(model.gender);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function setInitialGender(_x) {
                return _ref.apply(this, arguments);
            }

            return setInitialGender;
        }()
    }, {
        key: 'getGenderImage',
        value: function getGenderImage(gender) {
            var menWomen = gender == 'Male' ? 'men' : 'women';
            var randomNumber = __WEBPACK_IMPORTED_MODULE_9__NumberHelpers__["a" /* default */].randomInt(99);
            return 'https://randomuser.me/api/portraits/' + menWomen + '/' + randomNumber + '.jpg';
        }
    }, {
        key: 'getGender',
        value: function getGender(firstName) {
            return __WEBPACK_IMPORTED_MODULE_27__CloudHelpers__["a" /* default */].getGender(firstName);
        }
    }, {
        key: 'getSampleImage',
        value: function getSampleImage(gender) {

            if (!gender) return '';

            var menWomen = gender == 'Male' ? 'men' : 'women';
            var randomNumber = __WEBPACK_IMPORTED_MODULE_9__NumberHelpers__["a" /* default */].randomInt(99);
            return 'https://randomuser.me/api/portraits/' + menWomen + '/' + randomNumber + '.jpg';
        }
    }, {
        key: 'getContactImage',
        value: function getContactImage(contact, blankAvatars) {

            if (blankAvatars && contact.image && contact.image.indexOf('random') > -1) {
                var gender = contact.gender || 'Male';
                return '/static/images/' + gender + '.jpg';
            } else return contact.image;
        }
    }, {
        key: 'simplifyContact',
        value: function simplifyContact(sourceContact) {
            if (!sourceContact) return null;

            var contact = {
                firstName: sourceContact.firstName || '',
                preferredName: sourceContact.preferredName || '',
                lastName: sourceContact.lastName || '',
                gender: sourceContact.gender || '',
                email: sourceContact.email || '',
                fax: sourceContact.fax || '',
                mobile: sourceContact.mobile || '',
                phone: sourceContact.phone || '',
                image: sourceContact.image || '',
                address: sourceContact.address || '',
                dob: sourceContact.dob || '',
                middleName: sourceContact.middleName || '',
                notes: sourceContact.notes || '',
                openedAt: __WEBPACK_IMPORTED_MODULE_23__DateHelpers__["a" /* default */].nowString()
            };
            return contact;
        }
    }, {
        key: 'createFaxContact',
        value: function createFaxContact(contact) {
            var faxContact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contact);
            faxContact.key = faxContact.key + 'f';
            faxContact.email = __WEBPACK_IMPORTED_MODULE_19__Utilities__["a" /* default */].toFaxAddress(contact.fax);
            faxContact.fullName = faxContact.fullName || this.fullName(contact) + ' (Fax)';
            return faxContact;
        }
    }, {
        key: 'saveContact',
        value: function saveContact(contactToSave) {

            var contact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contactToSave);

            console.log('ContactHelpers > saveContact');

            var vm = this;
            var tenantKey = __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].safelyGetTenant(contact);
            var key = __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].safelyGetKey(contact);
            var isExisting = true;

            if (!key) {
                isExisting = false;

                key = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getKey();
            }

            delete contact['.key'];
            delete contact['key'];
            delete contact['role'];
            delete contact['meta'];


            contact.tenantKey = contact.tenantKey || tenantKey;

            var me = __WEBPACK_IMPORTED_MODULE_16__store_Store__["a" /* default */].getters.user;

            if (!contact.owner) {
                contact.owner = {
                    key: me.uid,
                    firstName: me.firstName,
                    lastName: me.lastName
                };
            }

            this.formatMobileForContact(contact);

            var tenantRef = __WEBPACK_IMPORTED_MODULE_13_firebase_app___default.a.database().ref('tenants/' + tenantKey);

            tenantRef.child('contacts').child(key).update(contact);

            var simpleContact = this.simplifyContact(contact);

            this.saveToAlgolia(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contact, { key: key, tenantKey: tenantKey }));

            if (!isExisting) {
                return;
            }

            tenantRef.child('contacts').child(key).once('value', function (snap) {
                var dbContact = snap.val();
                if (dbContact.partner) {
                    var partnerKey = dbContact.partner.key;
                    tenantRef.child('contacts').child(partnerKey).child('partner').update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, simpleContact, { key: key }));
                }
            });

            tenantRef.child('contactTransactions').child(key).on('child_added', function (snap) {
                console.log('Updating contacts in transaction', snap.key);

                var transactionRef = tenantRef.child('transactions').child(snap.key);

                transactionRef.child('elements').orderByChild('contactKey').equalTo(key).once('value', function (elSnap) {
                    elSnap.forEach(function (elementSnap) {
                        transactionRef.child('elements').child(elementSnap.key).child('contact').update(simpleContact);
                        vm.updateContactInStore(elementSnap.key, simpleContact);
                    });
                });
            });
        }
    }, {
        key: 'saveToAlgolia',
        value: function saveToAlgolia(contact) {
            var algoliaObj = this.contactToAlgoliaContact(contact);

            __WEBPACK_IMPORTED_MODULE_22__AlgoliaHelpers__["a" /* default */].saveToIndex('contacts_' + contact.tenantKey, algoliaObj);
        }
    }, {
        key: 'saveListToAlgolia',
        value: function saveListToAlgolia(arr) {
            var _this3 = this;

            var output = [];
            arr.forEach(function (contact) {
                output.push(_this3.contactToAlgoliaContact(contact));
            });
            console.log('output is ', output);
            __WEBPACK_IMPORTED_MODULE_22__AlgoliaHelpers__["a" /* default */].saveListToIndex('contacts_' + __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantKey(), output);
        }
    }, {
        key: 'contactToAlgoliaContact',
        value: function contactToAlgoliaContact(contact) {
            var a = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contact);
            a.objectID = __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].safelyGetKey(contact);
            a.initials = this.initials(contact);
            a.tenantKey = __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].safelyGetTenant(contact);

            return a;
        }
    }, {
        key: 'updateOpenedDate',
        value: function updateOpenedDate(item) {
            setTimeout(function () {
                var savePath = void 0;
                var key = void 0;
                if (item.meta && item.meta.key) {
                    savePath = item.meta.path;
                    key = item.meta.key;
                } else if (item.key) {
                    key = item.key;
                    savePath = 'tenants/' + item.tenantKey + '/contacts';
                } else if (item.objectID) {
                    key = item.objectID;
                    savePath = 'tenants/' + item.tenantKey + '/contacts';
                }
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getRootRef().child(savePath).child(key);
                ref.update({ 'openedAt': __WEBPACK_IMPORTED_MODULE_23__DateHelpers__["a" /* default */].nowString() });
            }, 200);
        }
    }, {
        key: 'formatMobileForContact',
        value: function formatMobileForContact(contact) {
            if (contact && contact.mobile) {
                contact.mobile = contact.mobile.replace(/\D/g, '');
                contact.mobileSearch = contact.mobile.substr(contact.mobile.length - 3);
            }
        }
    }, {
        key: 'updateContactInStore',
        value: function updateContactInStore(key, contact) {
            var elements = __WEBPACK_IMPORTED_MODULE_16__store_Store__["a" /* default */].getters.elements;
            if (!elements) return;

            var element = elements.find(function (o) {
                return o.key == key;
            });
            if (!element) return;

            element.contact = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(element.contact, contact);
            __WEBPACK_IMPORTED_MODULE_16__store_Store__["a" /* default */].commit('saveElement', element);
        }
    }, {
        key: 'deleteContact',
        value: function deleteContact(contact) {
            console.log('ContactHelpers > deleteContact');

            if (contact.user) {
                __WEBPACK_IMPORTED_MODULE_26__AlertHelpers__["a" /* default */].showAlert('Cannot delete a user record');
                return;
            }

            if (!contact.meta) {
                console.error('no meta in deletecontact');
                debugger;
                return;
            }

            var tenantKey = contact.meta.tenantKey;
            var key = contact.meta.key;

            var tenantRef = __WEBPACK_IMPORTED_MODULE_13_firebase_app___default.a.database().ref('tenants/' + tenantKey);
            tenantRef.child('contacts').child(key).remove();
        }
    }, {
        key: 'cacheContact',
        value: function cacheContact(contact) {
            setTimeout(function () {
                var recent = { tenantKey: __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantKey(), key: contact.key };
                __WEBPACK_IMPORTED_MODULE_16__store_Store__["a" /* default */].commit('addRecentContactForUser', recent);
            }, 1500);
        }
    }, {
        key: 'linkContact',
        value: function linkContact(transactionKey, contact, role) {
            console.log('linkContact', contact, role);
            var newElement = {};
            newElement.type = 'Contact';
            newElement.role = role;
            newElement.title = role;

            newElement.name = __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].toSnakeCase(role);
            newElement.contact = __WEBPACK_IMPORTED_MODULE_12__FirebaseHelpers__["a" /* default */].cloneWithoutKey(contact);
            newElement.value = __WEBPACK_IMPORTED_MODULE_18__ContactHelpers__["a" /* default */].fullName(contact);
            newElement.contactKey = contact.meta.key;
            newElement.transactionKey = transactionKey;
            __WEBPACK_IMPORTED_MODULE_17__ElementHelpers__["a" /* default */].saveElement(newElement);
            return newElement;
        }
    }, {
        key: 'replaceContact',
        value: function replaceContact(transactionKey, contact, role, elements) {
            var existingElement = __WEBPACK_IMPORTED_MODULE_17__ElementHelpers__["a" /* default */].singleContactElementForRole(role, elements);
            if (!existingElement) {
                existingElement = this.linkContact(transactionKey, contact, role);
                return existingElement;
            }
            existingElement.contact = __WEBPACK_IMPORTED_MODULE_18__ContactHelpers__["a" /* default */].simplifyContact(contact);
            existingElement.value = __WEBPACK_IMPORTED_MODULE_18__ContactHelpers__["a" /* default */].fullName(contact);
            existingElement.contactKey = contact.key;
            __WEBPACK_IMPORTED_MODULE_17__ElementHelpers__["a" /* default */].saveElement(existingElement);
            return existingElement;
        }
    }, {
        key: 'fetchTransactionContactElement',
        value: function fetchTransactionContactElement(transactionKey, contactKey) {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!transactionKey) {
                    console.error('fetchTransactionContactElement > No transaction key');
                    reject('No transaction key');
                }
                if (!contactKey) {
                    console.error('fetchTransactionContactElement > No contact key');
                    reject('No contact key');
                }
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantRef().child('transactions').child(transactionKey).child('elements');
                ref.orderByChild('contactKey').equalTo(contactKey).once('value', function (snap) {
                    var elements = __WEBPACK_IMPORTED_MODULE_12__FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                    if (!elements.length) resolve(null);else resolve(elements[0]);
                });
            });
        }
    }, {
        key: 'unlinkContact',
        value: function unlinkContact(transactionKey, contactKey) {
            console.log('ContactHelpers > unlinkContact (t,c)', transactionKey, contactKey);

            var tenantKey = __WEBPACK_IMPORTED_MODULE_16__store_Store__["a" /* default */].getters.tenantKey;

            var tenantRef = __WEBPACK_IMPORTED_MODULE_13_firebase_app___default.a.database().ref('tenants/' + tenantKey);

            tenantRef.child('contactTransactions').child(contactKey).child(transactionKey).remove();
            tenantRef.child('transactions').child(transactionKey).child('people').child(contactKey).remove();
        }
    }, {
        key: 'loadingContact',
        value: function loadingContact() {
            return {
                key: 0,
                '.key': 0,
                firstName: 'Loading',
                lastName: '',
                image: '/static/images/loader-basic.gif'
            };
        }
    }, {
        key: 'contactFromUser',
        value: function contactFromUser(usr) {

            var contact = {
                email: usr.email || null,
                mobile: usr.mobile || null,
                image: usr.photoURL || null,
                uid: usr.uid || null
            };

            var namesArr = usr.displayName.split(' ');
            contact.firstName = namesArr[0] || null;
            contact.lastName = namesArr[1] || null;

            return contact;
        }
    }, {
        key: 'fullName',
        value: function fullName(contact) {
            if (!contact) return '';

            var name = (contact.firstName || '') + (contact.firstName && contact.lastName ? ' ' : '') + (contact.lastName || '');

            if (!name) name = contact.business;

            return name;
        }
    }, {
        key: 'phoneNumbers',
        value: function phoneNumbers(contact) {
            if (!contact) return '';

            return (this.formatMobile(contact.mobile) || '') + (contact.mobile && contact.phone ? ', ' : '') + (contact.phone || '');
        }
    }, {
        key: 'bestNumber',
        value: function bestNumber(contact) {
            if (!contact) return '';

            if (contact.mobile) return this.formatMobile(contact.mobile) || '';

            if (contact.phone) return contact.phone || '';
        }
    }, {
        key: 'formatMobile',
        value: function formatMobile(mobile) {
            if (!mobile) return '';
            mobile = mobile.replace(/\D/g, '');
            return mobile.substr(0, 4) + ' ' + mobile.substr(4, 3) + ' ' + mobile.substr(7);
        }
    }, {
        key: 'initials',
        value: function initials(contact) {

            if (!contact) return '';

            return (contact.firstName ? contact.firstName.charAt(0) : '?') + (contact.lastName ? contact.lastName.charAt(0) : '?');
        }
    }, {
        key: 'combineClientsNames',
        value: function combineClientsNames(clients) {

            if (!clients || !clients.length) {
                console.log('combineClientsNames was passed nothing');
                return '';
            }

            if (clients.length == 1) return this.fullName(clients[0]);
            if (clients.length == 2) {
                if (clients[0].lastName == clients[1].lastName) return clients[0].firstName + ' and ' + clients[1].firstName + ' ' + clients[0].lastName;else return this.fullName(clients[0]) + ' and ' + this.fullName(clients[1]);
            }
            return __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].sentenceJoin(clients.map(function (o) {
                return o.firstName;
            }));
        }
    }, {
        key: 'contactDetailsToText',
        value: function contactDetailsToText(contact) {
            var str = this.fullName(contact);
            if (contact.mobile) str += ' ' + contact.mobile;
            if (contact.email) str += ' ' + contact.email;
            return str;
        }
    }, {
        key: 'greetingFromContacts',
        value: function greetingFromContacts(contactsArray) {
            if (!contactsArray || !contactsArray.length) return '';

            var preferredNameArray = contactsArray.map(function (o) {
                return o.preferredName || o.firstName;
            }).filter(function (item) {
                return item;
            });
            return __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].sentenceJoin(preferredNameArray);
        }
    }, {
        key: 'getUsers',
        value: function getUsers() {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var tenantKey = __WEBPACK_IMPORTED_MODULE_16__store_Store__["a" /* default */].getters.tenantKey;
                var users = [];

                var ref = __WEBPACK_IMPORTED_MODULE_13_firebase_app___default.a.database().ref('tenants').child(tenantKey).child('contacts').orderByChild('user').equalTo(true);
                var vm = this;

                ref.once('value', function (snap) {
                    snap.forEach(function (item) {
                        var user = {
                            uid: item.key,
                            firstName: item.val().firstName,
                            lastName: item.val().lastName,

                            name: item.val().firstName + ' ' + item.val().lastName,
                            email: item.val().email,
                            image: item.val().image
                        };
                        users.push(user);
                    });
                    users = users.sort(function (a, b) {
                        return a.name > b.name;
                    });
                    resolve(users);
                });
            });
        }
    }, {
        key: 'fetchUsersForOffice',
        value: function fetchUsersForOffice(officeKey) {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!officeKey) resolve([]);
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getRootRef().child('tenants').child(officeKey).child('contacts').orderByChild('user').equalTo(true);

                ref.once('value', function (snap) {
                    var users = __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
                    resolve(users);
                });
            });
        }
    }, {
        key: 'capitalizeForSearching',
        value: function capitalizeForSearching(term) {
            term = __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].capitalizeFirstLetter(term);

            if (term.substr(0, 2) == 'Mc') {
                var newChar = term.charAt(2).toUpperCase();
                term = __WEBPACK_IMPORTED_MODULE_10__StringHelpers__["a" /* default */].replaceAt(term, 2, newChar);
            }
            return term;
        }
    }, {
        key: 'searchNames',
        value: function searchNames(term) {

            var names = term.split(' ').sort(function (a, b) {
                return b.length - a.length;
            });

            var primaryName = this.capitalizeForSearching(names[0]);


            var secondaryName = '';
            if (names.length > 1) secondaryName = this.capitalizeForSearching(names[1]);

            return { primaryName: primaryName, secondaryName: secondaryName };
        }
    }, {
        key: 'isMobileSearch',
        value: function isMobileSearch(str) {
            var result = str && str.length == 3 && __WEBPACK_IMPORTED_MODULE_9__NumberHelpers__["a" /* default */].isNumeric(str);
            return result;
        }
    }, {
        key: 'searchAnalysis',
        value: function searchAnalysis(term) {
            if (!term) return { type: 'recent' };
            if (term.length < 3) return { type: 'waiting' };
            if (term && term.length == 3 && __WEBPACK_IMPORTED_MODULE_9__NumberHelpers__["a" /* default */].isNumeric(term)) return { type: 'mobile', search: term };

            var result = this.searchNames(term);
            result.type = 'names';
            return result;
        }
    }, {
        key: 'fetchContactByEmail',
        value: function fetchContactByEmail(email) {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantRef().child('contacts').orderByChild('email').equalTo(email);
                ref.once('value', function (snap) {
                    var contacts = __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);

                    if (contacts.length < 1) {
                        var err = 'fetchContactByEmail fails...no contact found with email ' + email;
                        console.log(err);
                        reject(err);
                    } else if (contacts.length > 1) {
                        var _err = 'fetchContactByEmail fails...multiple contacts found with email ' + email;
                        console.log(_err);
                        reject(_err);
                    } else {
                        resolve(contacts[0]);
                    }
                });
            });
        }
    }, {
        key: 'fetchContact',
        value: function fetchContact(key) {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantRef().child('contacts').child(key);
                __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (contact) {
                    resolve(contact);
                });
            });
        }
    }, {
        key: 'copyTransactionContactToOffices',
        value: function copyTransactionContactToOffices(transactionContact, officeKey) {
            var newTransactionContact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, transactionContact);
            var fromKey = transactionContact.tenantKey;
            var newPath = 'tenants/' + transactionContact.tenantKey + '/transactions/' + transactionContact.transactionKey + '/elements';
            var newKey = transactionContact.key;
            newTransactionContact.tenantKey = officeKey;
            delete newTransactionContact['key'];
            delete newTransactionContact['.key'];
            newTransactionContact.meta = {
                path: newPath,
                key: newKey
            };

            __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].saveItem(newTransactionContact);

            var contactRef = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantRef(fromKey).child('contacts').child(transactionContact.contactKey);
            __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].fetchItemSingle(contactRef).then(function (contact) {
                var newContact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contact);
                newContact.meta.path = contact.meta.path.replace(fromKey, officeKey);
                __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].saveItem(newContact);
            });
        }
    }, {
        key: 'checkForDuplicates',
        value: function checkForDuplicates(firstName, lastName) {
            return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_11__DataHelpers__["a" /* default */].getTenantRef().child('contacts').orderByChild('lastName').equalTo(lastName);
                __WEBPACK_IMPORTED_MODULE_20__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (contacts) {
                    var match = contacts.find(function (o) {
                        return o.firstName == firstName;
                    });
                    if (match) resolve(match);else resolve(false);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dateFormats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_NumberHelpers__ = __webpack_require__(24);









var dateFormats = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default()({
    BACKWARDS: 'yyyy-MM-dd',
    AUSTRALIAN: 'dd/MM/yy',
    DAY_ONLY: 'EEEE',
    TIME_ONLY: 'HH:mm',
    BACKWARDS_WITH_TIME: 'yyyy-MM-dd HH:mm',
    YEAR_MONTH: 'yyyy-MM'
});

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'expandYear',
        value: function expandYear(yr) {
            try {
                yr = parseInt(yr);
            } catch (e) {
                yr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["c" /* getYear */])(new Date());
            }
            if (yr < 40) yr = 2000 + yr;else if (yr < 100) yr = 1900 + yr;else if (yr < 1900) yr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["c" /* getYear */])(new Date());

            return yr;
        }
    }, {
        key: 'toDate',
        value: function toDate(anyFormat) {
            if (!anyFormat || anyFormat === true) {
                return null;
            }

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["d" /* isDate */])(anyFormat)) {
                return anyFormat;
            }

            if (__WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].isObject(anyFormat) && anyFormat.seconds) {
                return anyFormat.toDate();
            }

            if (anyFormat.length > 9 && anyFormat.charAt(4) == '-' && anyFormat.charAt(7) == '-') return this.backwardsToDate(anyFormat);

            var slashArr = anyFormat.toString().split('/');
            if (slashArr.length > 1) {
                var day = slashArr[0];
                var month = slashArr[1];
                var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["c" /* getYear */])(new Date());
                if (slashArr.length > 2) year = this.expandYear(slashArr[2]);
                return new Date(year, month - 1, day);
            }

            return new Date(anyFormat);
        }
    }, {
        key: 'businessDaysFromNow',
        value: function businessDaysFromNow(days) {
            return this.businessDaysAdd(new Date(), days);
        }
    }, {
        key: 'businessDaysAdd',
        value: function businessDaysAdd(dt, days) {

            var inc = 1;
            if (days < 0) {
                days = Math.abs(days);
                inc = -1;
            }
            var i = 0;
            while (i != days) {
                dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(dt, inc);
                if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["f" /* isWeekend */])(dt)) i++;
            }
            return dt;
        }
    }, {
        key: 'timeAgo',
        value: function timeAgo(anyDateFormat) {
            var date = this.toDate(anyDateFormat);
            if (!date) return 'Just now';
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["g" /* formatDistanceToNow */])(date) + ' ago';
        }
    }, {
        key: 'smartDaysFromNow',
        value: function smartDaysFromNow(days) {
            if (!days) days = 0;

            var dt = void 0;
            if (days > 6) dt = this.bumpIfWeekend(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(new Date(), days));else dt = this.businessDaysFromNow(days);

            return dt;
        }
    }, {
        key: 'bumpIfWeekend',
        value: function bumpIfWeekend(dt) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["h" /* isSaturday */])(dt)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(dt, 2);
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["i" /* isSunday */])(dt)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(dt, 1);
            return dt;
        }
    }, {
        key: 'isToday',
        value: function isToday(dateString) {
            var dt1 = new Date(dateString);
            var dt2 = new Date();
            return dt1.toDateString() == dt2.toDateString();
        }
    }, {
        key: 'tomorrowString',
        value: function tomorrowString() {
            var tomorrow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(new Date(), 1);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(tomorrow, dateFormats.BACKWARDS);
        }
    }, {
        key: 'yesterdayString',
        value: function yesterdayString() {
            var yesterday = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(new Date(), -1);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(yesterday, dateFormats.BACKWARDS);
        }
    }, {
        key: 'todayString',
        value: function todayString() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(new Date(), dateFormats.BACKWARDS);
        }
    }, {
        key: 'yearMonth',
        value: function yearMonth() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(date, dateFormats.YEAR_MONTH);
        }
    }, {
        key: 'timeString',
        value: function timeString() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(new Date(), 'HH:mm');
        }
    }, {
        key: 'nowString',
        value: function nowString() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(date, dateFormats.BACKWARDS_WITH_TIME);
        }
    }, {
        key: 'auToBackwards',
        value: function auToBackwards(auString) {
            if (!auString) return '';
            var arr = auString.split('/');
            var dateObj = new Date(2000 + parseInt(arr[2]), arr[1] - 1, arr[0]);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dateObj, dateFormats.BACKWARDS);
        }
    }, {
        key: 'dateToBackwards',
        value: function dateToBackwards(dateObj) {
            if (!dateObj || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["d" /* isDate */])(dateObj)) return '';
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dateObj, dateFormats.BACKWARDS);
        }
    }, {
        key: 'backwardsToAu',
        value: function backwardsToAu(backwardsDateString) {
            if (!backwardsDateString) return '';

            var dateObj = new Date(backwardsDateString);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dateObj, 'dd/MM/yy');
        }
    }, {
        key: 'dateTimeToText',
        value: function dateTimeToText(str) {
            var result = void 0;
            if (!str) return '* No Time *';

            var arr = str.split(' ');
            var date = arr[0].trim();
            var dateObj = new Date(date);
            result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dateObj, 'EEEE dd/MM/yy');

            if (arr.length > 1) {
                var time = arr[1].trim();
                result += ' at ' + time;
            }
            return result;
        }
    }, {
        key: 'backwardsToDate',
        value: function backwardsToDate(dateStr) {
            if (!dateStr) return null;
            var dateArr = dateStr.split('-');
            if (dateArr.length != 3) return null;
            var y = parseInt(dateArr[0]);
            var m = parseInt(dateArr[1]) - 1;
            var d = parseInt(dateArr[2]);

            return new Date(y, m, d);
        }
    }, {
        key: 'dateToAu',
        value: function dateToAu(dt) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dt, dateFormats.AUSTRALIAN);
        }
    }, {
        key: 'convertDate',
        value: function convertDate(dateString, fromFormat, toFormat) {
            var dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["j" /* parse */])(dateString, fromFormat, new Date());
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dt, toFormat);
        }
    }, {
        key: 'findDayInString',
        value: function findDayInString(str) {
            var returnObj = {
                found: false
            };
            var matches = str.match(/\b(mon|tue|wed|thu|fri|sat|sun)\b/);
            if (!matches) {
                var _matches = str.match(/\btoday\b/);
                if (!_matches) return returnObj;
                returnObj.found = true;
                returnObj.words = 'today';
                returnObj.date = new Date();
                returnObj.remaining = str.replace('today', '').trim();
                return returnObj;
            }

            var day = matches[0];
            for (var n = 1; n < 8; n++) {
                var dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(new Date(), n);
                var dayToTest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dt, 'EEEE').toLowerCase();
                if (dayToTest.startsWith(day)) {
                    returnObj.found = true;
                    returnObj.date = dt;
                    returnObj.words = dayToTest;
                    returnObj.remaining = str.replace(day, '').trim();
                }
            }
            return returnObj;
        }
    }, {
        key: 'findDateInString',
        value: function findDateInString(str) {
            var returnObj = {
                found: false
            };
            var matches = str.match(/\d{1,2}\/\d{1,2}(\/\d{2,4})?/);
            if (!matches) return returnObj;

            var dmyString = matches[0];
            var dmyArray = dmyString.split('/');

            var d = void 0,
                m = void 0,
                y = void 0;

            var _dmyArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(dmyArray, 3);

            d = _dmyArray[0];
            m = _dmyArray[1];
            y = _dmyArray[2];

            if (!y) y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["c" /* getYear */])(new Date());

            y = parseInt(y);

            if (y < 50) y = y + 2000;else if (y < 100) y = 1900 + y;

            if (y < 1950 || y > 2050) return returnObj;

            if (m < 1 || m > 12) return returnObj;

            if (d < 1 || d > 31) return returnObj;

            var dt = new Date(y, m - 1, d);
            if (!dt) return returnObj;

            returnObj.found = true;
            returnObj.date = dt;
            returnObj.remaining = str.replace(dmyString, '').trim();
            returnObj.words = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["k" /* formatDistance */])(new Date(), dt);

            return returnObj;
        }
    }, {
        key: 'findTimeframeInString',
        value: function findTimeframeInString(str) {
            var baseDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

            var resultObj = this.findDateInString(str);
            if (resultObj.found) {
                return resultObj;
            }

            resultObj = this.findDayInString(str);
            if (resultObj.found) return resultObj;

            var matches = str.match(/\s*\d+[dmwy]/);
            if (!matches) return { date: baseDate, words: 'today', remaining: str, found: false };

            var match = matches[0];
            var period = parseInt(match);
            var unit = match.match(/[a-z]/);
            var remainingString = str.replace(match, '').trim();
            var endDate = void 0;
            var unitInWords = void 0;

            if (unit == 'd') {
                if (period > 6) endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(baseDate, period);else endDate = this.businessDaysAdd(baseDate, period);
                unitInWords = 'days';
            }
            if (unit == 'w') {
                endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["l" /* addWeeks */])(baseDate, period);
                unitInWords = 'weeks';
            }
            if (unit == 'm') {
                endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["m" /* addMonths */])(baseDate, period);
                unitInWords = 'months';
            }
            if (unit == 'y') {
                endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["n" /* addYears */])(baseDate, period);
                unitInWords = 'years';
            }

            return {
                remaining: remainingString,
                words: period + ' ' + unitInWords,
                date: endDate,
                found: true
            };
        }
    }, {
        key: 'dateOfDay',
        value: function dateOfDay(day) {
            day = day.toLowerCase();
            for (var n = 1; n < 8; n++) {
                var dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(new Date(), n);
                var dayToTest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dt, 'EEEE').toLowerCase();
                if (dayToTest.startsWith(day)) return dt;
            }
            return null;
        }
    }, {
        key: 'isValidDate',
        value: function isValidDate(date) {
            return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date) && date > new Date(1950, 1, 1) && date < new Date(2050, 1, 1);
        }
    }, {
        key: 'nextFiveWorkingDays',
        value: function nextFiveWorkingDays() {

            var returnDates = [];
            var i = 0;
            while (returnDates.length < 5) {

                var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */])(new Date(), i);

                var day = {
                    date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(date, dateFormats.BACKWARDS),
                    day: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(date, 'EEEE')
                };
                if (day.day != 'Saturday' && day.day != 'Sunday') returnDates.push(day);
                i++;
            }
            return returnDates;
        }
    }, {
        key: 'fromNow',
        value: function fromNow(anyFormat) {

            var date = this.toDate(anyFormat);

            if (!date) return '';

            if (!this.isValidDate(date) || date == 'Invalid Date') {
                console.error('fromNow was passed an invalid date', date);
            }

            var weekDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(date, 'EEEE');

            var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["o" /* differenceInCalendarDays */])(date, new Date());

            if (days == 0) return 'Today';else if (days == 1) return 'Tomorrow';else if (days == -1) return 'Yesterday';else if (days < 0) return Math.abs(days) + ' days ago';else if (days > 0 && days < 7) return weekDay;else return 'In ' + days + ' days';
        }
    }]);

    return _class;
}();

_class.convertToDuration = function (secondsAmount) {
    var normalizeTime = function normalizeTime(time) {
        return time.length === 1 ? '0' + time : time;
    };

    var SECONDS_TO_MILLISECONDS_COEFF = 1000;
    var MINUTES_IN_HOUR = 60;

    var milliseconds = secondsAmount * SECONDS_TO_MILLISECONDS_COEFF;

    var date = new Date(milliseconds);
    var timezoneDiff = date.getTimezoneOffset() / MINUTES_IN_HOUR;
    var dateWithoutTimezoneDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["p" /* addHours */])(date, timezoneDiff);

    var hours = normalizeTime(String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["q" /* getHours */])(dateWithoutTimezoneDiff)));
    var minutes = normalizeTime(String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["r" /* getMinutes */])(dateWithoutTimezoneDiff)));
    var seconds = normalizeTime(String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["s" /* getSeconds */])(dateWithoutTimezoneDiff)));

    var hoursOutput = hours !== '00' ? hours + ':' : '';

    return '' + hoursOutput + minutes + ':' + seconds;
};

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_Store__ = __webpack_require__(31);






var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'showAlert',
        value: function showAlert(message, options) {
            var alertObj = void 0;
            if (options) alertObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, { message: message, visible: true });else alertObj = { message: message, visible: true };

            alertObj.timeout = alertObj.timeout || 7000;

            if (alertObj.button == null) {
                alertObj.button = alertObj.timeout > 9000;
            }

            __WEBPACK_IMPORTED_MODULE_3__store_Store__["a" /* default */].dispatch('showAlert', alertObj);
        }
    }, {
        key: 'clearAlert',
        value: function clearAlert() {
            __WEBPACK_IMPORTED_MODULE_3__store_Store__["a" /* default */].dispatch('clearAlert');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_NiceData__ = __webpack_require__(15);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'pushKeyToDateString',
        value: function pushKeyToDateString(id) {
            var PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";
            id = id.substring(0, 8);
            var timestamp = 0;
            for (var i = 0; i < id.length; i++) {
                var c = id.charAt(i);
                timestamp = timestamp * 64 + PUSH_CHARS.indexOf(c);
            }
            return timestamp;
        }
    }, {
        key: 'snapshotToArray',
        value: function snapshotToArray(snapshot, reverse) {
            var returnArr = [];

            snapshot.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item['.key'] = childSnapshot.key;
                item.key = childSnapshot.key;
                if (reverse) returnArr.unshift(item);else returnArr.push(item);
            });

            return returnArr;
        }
    }, {
        key: 'snapshotToObject',
        value: function snapshotToObject(snapshot) {
            var objArray = this.snapshotToArray(snapshot);
            if (objArray.length > 0) return objArray[0];else return null;
        }
    }, {
        key: 'arrayToFirebaseObject',
        value: function arrayToFirebaseObject(array) {
            var _this = this;

            var obj = {};
            array.forEach(function (item) {
                var key = item['key'] || item['.key'];
                var newItem = _this.cloneWithoutKey(item);
                obj[key] = newItem;
            });
            return obj;
        }
    }, {
        key: 'snapItemToObject',
        value: function snapItemToObject(snap) {

            var obj = { item: {}, key: snap.key };
            for (var fld in snap.val()) {
                if (!fld.startsWith('_')) {
                    obj.item[fld] = snap.val()[fld];
                }
            }
            return obj;
        }
    }, {
        key: 'snapToObject',
        value: function snapToObject(snap) {

            var obj = { key: snap.key };
            for (var fld in snap.val()) {
                if (!fld.startsWith('_')) {
                    obj[fld] = snap.val()[fld];
                }
            }
            return obj;
        }
    }, {
        key: 'snapshotPushArray',
        value: function snapshotPushArray(snapshot, array) {
            if (!array) console.error('snapshotPushArray > No array passed');

            snapshot.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item['.key'] = childSnapshot.key;
                item.key = childSnapshot.key;
                array.push(item);
            });
        }
    }, {
        key: 'cloneWithoutKey',
        value: function cloneWithoutKey(item) {

            var returnItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
            delete returnItem['.key'];
            delete returnItem['key'];
            delete returnItem['meta'];
            return returnItem;
        }
    }, {
        key: 'firebaseConsolePathFromRefString',
        value: function firebaseConsolePathFromRefString(str) {
            return this.firebaseConsolePath() + '/' + this.firebasePathFromRefString(str);
        }
    }, {
        key: 'firebasePathFromRefString',
        value: function firebasePathFromRefString(str) {
            if (!str) {
                console.error('No string passed to FirebaseHelpers > firebasePathFromRefString');
                return '';
            }

            return str.replace('https://photon-6d209.firebaseio.com/', '');
        }
    }, {
        key: 'firebaseConsolePath',
        value: function firebaseConsolePath() {
            return 'https://console.firebase.google.com/u/0/project/photon-6d209/database/photon-6d209/data';
        }
    }, {
        key: 'viewInConsole',
        value: function viewInConsole(pathString) {
            pathString = this.firebaseConsolePath() + '/' + pathString;
            window.open(pathString, '_blank');
        }
    }, {
        key: 'saveToFirebase',
        value: function saveToFirebase(obj, ref) {

            if (!obj) {
                console.log('saveToFirebase - Nothing to save');
                return;
            }

            if (obj.delete) {
                ref.child(obj.key).remove();
                return;
            }

            var newElement = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, obj);
            var key = newElement.key || newElement['.key'] || __WEBPACK_IMPORTED_MODULE_5__DataHelpers__["a" /* default */].getKey();
            newElement.stamp = __WEBPACK_IMPORTED_MODULE_5__DataHelpers__["a" /* default */].getStamp();

            delete newElement['key'];
            delete newElement['.key'];
            delete newElement['selected'];
            console.log('saveToFirebase - Saving', newElement, ref.toString());
            ref.child(key).update(newElement);
        }
    }, {
        key: 'deleteFromFirebase',
        value: function deleteFromFirebase(obj, ref) {

            if (!obj) {
                console.log('x  rebase - Nothing to delete');
                return;
            }
            console.log('deleting from firebase', ref.toString());

            ref.child(obj.key || obj.meta.key).remove();
        }
    }, {
        key: 'copyItem',
        value: function copyItem(fromRef, toRef, itemKey) {
            var preserveKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                fromRef.child(itemKey).once(function (snap) {
                    var item = snap.val();
                    if (!item) reject('copyItem could not find the item to copy');
                    var key = preserveKey ? snap.key : __WEBPACK_IMPORTED_MODULE_5__DataHelpers__["a" /* default */].getKey;
                    toRef.child(key).set(item);

                    resolve(item);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_AppHelpers__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_OrderHelpers__ = __webpack_require__(29);











var db = __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* default */].database();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchItemSingle',
        value: function fetchItemSingle(ref) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var obj = _this.objectFromSnapshot(snap);
                    resolve(obj);
                });
            });
        }
    }, {
        key: 'fetchValue',
        value: function fetchValue(ref) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var result = snap.val();
                    resolve(result);
                });
            });
        }
    }, {
        key: 'fetchItemByName',
        value: function fetchItemByName(baseRef, name) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                baseRef.orderByChild('name').equalTo(name).once('value', function (snap) {
                    var objects = _this2.arrayFromSnapshot(snap);
                    if (objects && objects.length) resolve(objects[0]);else resolve(null);
                });
            });
        }
    }, {
        key: 'objectFromSnapshot',
        value: function objectFromSnapshot(snap) {
            var item = snap.val();
            if (!item) return null;
            item.meta = {};
            item.meta.key = snap.key;
            var pathArray = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(snap.ref.path.pieces_));
            if (pathArray.length > 2 && pathArray[0] == 'tenants') item.meta.tenantKey = pathArray[1];

            pathArray.pop();
            item.meta.path = pathArray.join('/');
            return item;
        }
    }, {
        key: 'fetchItemsFromFirebase',
        value: function fetchItemsFromFirebase(ref) {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    resolve(_this3.arrayFromSnapshot(snap));
                }, function (err) {
                    throw new Error('Cannot fetch items. ' + err);
                });
            });
        }
    }, {
        key: 'arrayFromSnapshot',
        value: function arrayFromSnapshot(snap) {
            var returnArr = [];
            var ordered = false;

            snap.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item.meta = {};
                item.meta.key = childSnapshot.key;
                var pathArray = snap.ref.path.pieces_;
                if (pathArray.length > 2 && pathArray[0] == 'tenants') item.meta.tenantKey = pathArray[1];

                if (item.order) ordered = true;

                item.meta.path = pathArray.join('/');

                returnArr.push(item);
            });
            if (ordered) returnArr = returnArr.sort(__WEBPACK_IMPORTED_MODULE_9__helpers_OrderHelpers__["a" /* default */].sortByOrder);

            return returnArr;
        }
    }, {
        key: 'safelyGetKey',
        value: function safelyGetKey(obj) {
            var key = void 0;
            if (obj.meta && obj.meta.key) key = obj.meta.key;

            var oldKey = obj['.key'] || obj.key;

            if (oldKey) {
                if (!key) {
                    console.log('safelyGetKey ONLY has old key', obj);
                    key = oldKey;
                } else console.log('safelyGetKey has redundant old key', obj);
            }

            if (!key && obj.objectID) key = obj.objectID;

            if (!key && obj.uid) key = obj.uid;

            return key;
        }
    }, {
        key: 'safelyGetTenant',
        value: function safelyGetTenant(obj) {

            if (!obj) return __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].getters.tenantKey;

            if (obj.meta && obj.meta.tenantKey) return obj.meta.tenantKey;else if (obj.tenantKey) return obj.tenantKey;else return __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].getters.tenantKey;
        }
    }, {
        key: 'fetchItems',
        value: function fetchItems(ref, storeName, localVariable) {
            if (__WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].state[storeName].length) {
                console.log('fetchItems from cache', storeName);
                localVariable = __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].state[storeName];
                return;
            }
            this.fetchItemsFromFirebase(ref).then(function (items) {
                console.log('fetchItems from db', storeName);

                var payload = {
                    name: storeName,
                    data: items
                };
                __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('saveItems', payload);
                localVariable = items;
            });
        }
    }, {
        key: 'saveFieldToFirebase',
        value: function saveFieldToFirebase(ref, x) {}
    }, {
        key: 'firebaseRefToPath',
        value: function firebaseRefToPath(ref) {
            var refStr = ref.toString();
            var refArr = refStr.split(/\//).slice(3).join('/');
            return refArr;
        }
    }, {
        key: 'firebaseRefToKey',
        value: function firebaseRefToKey(ref) {
            var pathArray = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(ref.path.pieces_));
            pathArray.pop();
            return pathArray.join("/");
        }
    }, {
        key: 'snapshotToArray',
        value: function snapshotToArray(snapshot) {
            var returnArr = [];

            snapshot.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item.key = childSnapshot.key;
                returnArr.push(item);
            });

            return returnArr;
        }
    }, {
        key: 'makeItem',
        value: function makeItem(ref) {
            return {
                meta: {
                    key: __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: ref.toString().split('/').splice(3).join('/')
                }
            };
        }
    }, {
        key: 'makeRecord',
        value: function makeRecord(table) {
            var _this4 = this;

            var record = {};
            table.fields.forEach(function (field) {
                record[field.name] = null;
                if (field.default) {
                    record[field.name] = _this4.defaultValue(field.default);
                }
                record.meta = {
                    key: __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: table.ref.toString().split('/').splice(3).join('/')
                };
            });
            return record;
        }
    }, {
        key: 'defaultValue',
        value: function defaultValue(field) {
            if (field == '[tenantKey]') return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getTenantKey();
            if (field == '[stamp]') return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getStamp();
        }
    }, {
        key: 'saveItem',
        value: function saveItem(item) {
            var savePath = item.meta.path;
            var ref = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child(savePath).child(item.meta.key);
            var newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);

            if (newItem.meta.savePosition && !newItem.order) {
                newItem.order = __WEBPACK_IMPORTED_MODULE_9__helpers_OrderHelpers__["a" /* default */].orderKey();
                if (newItem.meta.savePosition == 'top') newItem.order = 0 - newItem.order;
            }

            delete newItem.meta;

            if (this.debugMode()) {
                console.log('*** DEBUG MODE ***');
                console.log('Would normally save object', newItem);
                console.log('To path', savePath);
                return;
            }

            ref.update(newItem);
        }
    }, {
        key: 'debugMode',
        value: function debugMode() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_AppHelpers__["a" /* default */].getApplicationData('debugMode');
        }
    }, {
        key: 'saveField',
        value: function saveField(ref, value) {
            ref.set(value);
        }
    }, {
        key: 'deleteItem',
        value: function deleteItem(item) {
            var ref = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child(item.meta.path).child(item.meta.key);
            ref.remove();
        }
    }, {
        key: 'copyItems',
        value: function copyItems(fromRef, toRef) {
            var _this5 = this;

            var toPath = this.firebaseRefToPath(toRef);
            this.fetchItemsFromFirebase(fromRef).then(function (fromItems) {
                fromItems.forEach(function (item) {
                    item.meta.path = toPath;
                    _this5.saveItem(item);
                });
                console.log('copyItems reports ' + fromItems.length + ' items copied from ' + _this5.firebaseRefToPath(fromRef) + ' to ' + toPath + '.');
            });
        }
    }, {
        key: 'copySingleItem',
        value: function copySingleItem(fromRef, toRef) {
            var _this6 = this;

            var toPath = this.firebaseRefToPath(toRef);
            var toKey = this.firebaseRefToKey(toRef);
            this.fetchItemSingle(fromRef).then(function (fromItem) {
                fromItem.meta.path = toPath;
                fromItem.meta.key = toKey;
                _this6.saveItem(item);
                console.log('copySingleItem copied from ' + _this6.firebaseRefToPath(fromItemRef) + ' to ' + toPath + '.', fromItem);
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StringHelpers__ = __webpack_require__(5);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'randomInt',
        value: function randomInt(max) {
            if (!max) max = 10;
            return Math.floor(Math.random() * max) + 1;
        }
    }, {
        key: 'randomIntRange',
        value: function randomIntRange(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
    }, {
        key: 'isNumeric',
        value: function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
    }, {
        key: 'numbersFromString',
        value: function numbersFromString(str) {
            return str.replace(/[^\d.-]/g, '');
        }
    }, {
        key: 'abbreviateNumber',
        value: function abbreviateNumber(number) {
            number = parseInt(number);

            if (number % 1000 > 0) return __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].formatNumber(number);

            if (number >= 1000000) return (Math.round(number / 1000) / 1000).toString() + 'm';
            if (number >= 1000) return (Math.round(number / 100) / 10).toString() + 'k';
            return number;
        }
    }, {
        key: 'isEven',
        value: function isEven(n) {
            n = Number(n);
            return n === 0 || !!(n && !(n % 2));
        }
    }, {
        key: 'isOdd',
        value: function isOdd(n) {
            return this.isEven(Number(n) + 1);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1129)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(2517),
  /* scopeId */
  "data-v-3e81e058",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_CollectionsStore__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Actions__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__helpers_NumberHelpers__ = __webpack_require__(24);






























var db = __WEBPACK_IMPORTED_MODULE_14_firebase_app___default.a.database();
var fs = __WEBPACK_IMPORTED_MODULE_14_firebase_app___default.a.firestore();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getFirestore',
        value: function getFirestore() {
            return fs;
        }
    }, {
        key: 'deleteToken',
        value: function deleteToken() {
            return __WEBPACK_IMPORTED_MODULE_14_firebase_app___default.a.firestore.FieldValue.delete();
        }
    }, {
        key: 'getId',
        value: function getId() {
            return fs.collection('teams').doc().id;
        }
    }, {
        key: 'getDocumentRef',
        value: function getDocumentRef(path) {
            return fs.doc(path);
        }
    }, {
        key: 'getTeamRef',
        value: function getTeamRef(team) {
            return fs.collection('teams').doc(team);
        }
    }, {
        key: 'getCollectionDocumentRef',
        value: function getCollectionDocumentRef(team, collection) {
            return this.getTeamRef(team).collection('collections').doc(collection);
        }
    }, {
        key: 'getCollectionDataRef',
        value: function getCollectionDataRef(team, collection) {
            return this.getCollectionDocumentRef(team, collection).collection('data');
        }
    }, {
        key: 'getCollectionDocumentRefFromPath',
        value: function getCollectionDocumentRefFromPath(path) {
            return fs.collection(path);
        }
    }, {
        key: 'getItemRef',
        value: function getItemRef(item) {
            var ref = void 0;
            if (item._team && item._collection) ref = this.getCollectionDocumentRef(item._team, item._collection).collection('data').doc(item._id);else if (item._path) ref = fs.collection(item._path).doc(item._id);else {
                ref = null;
            }
            return ref;
        }
    }, {
        key: 'getItemTeam',
        value: function getItemTeam(item) {
            if (item._team) return item._team;
            if (item._path) {
                var pathArr = item._path.split('/');
                if (pathArr[0] == 'teams' && pathArr.length > 1) return pathArr[1];
            }
            return null;
        }
    }, {
        key: 'replaceDataInPath',
        value: function replaceDataInPath(path, replacement) {
            var arr = path.split('/');
            arr.pop();
            var newPath = arr.join('/') + '/' + replacement;
            return newPath;
        }
    }, {
        key: 'runAction',
        value: function runAction(action, item) {

            var expression = this.merge(action.expression, item);
            var result = '';
            try {
                result = eval(expression);
            } catch (e) {
                result = expression;
            }

            console.log('result is ', result);
            var fieldSlug = __WEBPACK_IMPORTED_MODULE_22__helpers_StringHelpers__["a" /* default */].toCamelCase(action.field);

            if (action.type == 'Set Field Value') {
                item[fieldSlug] = result;
            }
        }
    }, {
        key: 'merge',
        value: function merge(expression, item) {
            var mergeItems = __WEBPACK_IMPORTED_MODULE_20__helpers_MergeHelpers__["a" /* default */].findMergeFields(expression);

            mergeItems.forEach(function (mergeItem) {
                var fieldSlug = __WEBPACK_IMPORTED_MODULE_22__helpers_StringHelpers__["a" /* default */].toCamelCase(mergeItem);
                var fieldInBrackets = '(\\[' + mergeItem + '\\])';
                var replacement = item[fieldSlug] || '';
                var re = new RegExp(fieldInBrackets, 'gi');
                expression = expression.replace(re, replacement);
            });

            return expression;
        }
    }, {
        key: 'itemCollectionDetails',
        value: function itemCollectionDetails(item) {
            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                resolve('value');
            });
        }
    }, {
        key: 'truncateLastSegment',
        value: function truncateLastSegment(path) {
            var newLength = path.split('/').length - 1;
            return this.truncatePath(path, newLength);
        }
    }, {
        key: 'truncatePath',
        value: function truncatePath(path, length) {
            return path.split('/').splice(0, length).join('/');
        }
    }, {
        key: 'shortPath',
        value: function shortPath(path) {
            var arr = path.split('/');
            var shortArr = arr.filter(function (x, i) {
                return i % 2;
            });
            var result = shortArr.join('/');
            return result;
        }
    }, {
        key: 'logChanges',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee(changes) {
                var log, docPath, ref, doc;
                return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_keys___default()(changes.values).length) {
                                    _context.next = 3;
                                    break;
                                }

                                console.log('logChanges: No changes made. Logging not needed.');
                                return _context.abrupt('return');

                            case 3:
                                log = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, changes);
                                docPath = this.truncatePath(changes.path, 4);
                                ref = fs.doc(docPath);
                                _context.next = 8;
                                return this.fetchDocument(ref);

                            case 8:
                                doc = _context.sent;


                                if (doc.logChanges) {
                                    log._path = this.truncatePath(changes.path, 3) + '/logs/data';

                                    this.saveItem(log);
                                }

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function logChanges(_x) {
                return _ref.apply(this, arguments);
            }

            return logChanges;
        }()
    }, {
        key: 'saveAndAction',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee2(item) {
                var changes;
                return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                changes = this.getChanges(item);
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_25__Actions__["a" /* default */].runActions(item);

                            case 3:
                                this.saveItem(item);
                                this.logChanges(changes);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function saveAndAction(_x2) {
                return _ref2.apply(this, arguments);
            }

            return saveAndAction;
        }()
    }, {
        key: 'firebaseConsolePath',
        value: function firebaseConsolePath() {
            return 'https://console.firebase.google.com/u/0/project/photon-6d209/database/firestore/data';
        }
    }, {
        key: 'consoleLogPath',
        value: function consoleLogPath(item) {
            console.log(this.firebaseConsolePath() + item._path + '/' + item._id);
        }
    }, {
        key: 'openConsole',
        value: function openConsole(path) {
            path = this.firebaseConsolePath() + '/' + path;
            window.open(path, '_blank');
        }
    }, {
        key: 'saveItem',
        value: function saveItem(item) {
            var _this = this;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { merge: true };

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var newRecord = false;
                if (!item._id) {
                    newRecord = true;
                    item._id = _this.getId();
                }

                if (item._new) newRecord = true;

                var ref = _this.getItemRef(item);
                if (!ref) {
                    console.log('saveItem: Not saved. Cannot get a ref from this items path', item);
                    return;
                }

                _this.addTimestamp(item);
                _this.addAuthor(item);

                var newItem = _this.removeMeta(item);
                _this.removeNullsForStorage(newItem);
                _this.removeNulls(item);

                ref.set(newItem, { merge: options.merge }).then(function () {
                    console.log('saveItem > success saving ' + (item.name || item._id), _this.firebaseConsolePath() + ref.path);
                    resolve(item);
                }).catch(function (err) {
                    console.log('saveItem *** FAIL *** ', err);
                    console.log(item);
                    reject(err);
                });
            });
        }
    }, {
        key: 'addTimestamp',
        value: function addTimestamp(item) {
            var ts = __WEBPACK_IMPORTED_MODULE_14_firebase_app___default.a.firestore.FieldValue.serverTimestamp();
            if (!item.createdAt) item.createdAt = ts;

            item.updatedAt = ts;
        }
    }, {
        key: 'addAuthor',
        value: function addAuthor(item) {
            var myUserId = __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].getUserId();
            if (!item.createdBy) item.createdBy = myUserId;

            item.updatedBy = myUserId;
        }
    }, {
        key: 'addOwner',
        value: function addOwner(item) {
            var myUserId = __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].getUserId();
            if (!item.owner) item.owner = myUserId;
        }
    }, {
        key: 'loadOffices',
        value: function loadOffices(db) {
            var ref = __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].getRootRef().child('tables/global/offices/data');
            var officesArr = [];
            this.streamCollection(ref, officesArr);
        }
    }, {
        key: 'fetchCollection',
        value: function fetchCollection(ref) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.onSnapshot(function (snap) {
                    var arr = [];
                    snap.storePath = true;
                    _this2.snapshotFillArray(snap, arr);
                    if (!arr.length) {
                        console.log('fetchCollection returned empty array for ref:', ref);
                    }
                    resolve(arr);
                }, function (err) {
                    console.log('Error in fetchCollection:', err.message, 'Trying to load data from', ref.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                });
            });
        }
    }, {
        key: 'streamCollection',
        value: function streamCollection(ref, arr) {
            var _this3 = this;

            var preferences = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!ref.jd.limit) ref = ref.limit(10);

                ref.onSnapshot(function (snap) {
                    if (snap.empty) {
                        console.log('streamCollection returns empty snapshot');
                    }
                    snap.storePath = true;
                    _this3.snapshotFillArray(snap, arr, preferences);
                    resolve(arr);
                }, function (err) {
                    __WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].emptyArray(arr);
                    console.log('Error in streamCollection:', err.message, 'Trying to load data from', ref.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                    reject(err.message);
                });
            });
        }
    }, {
        key: 'streamDocument',
        value: function streamDocument(ref, item) {
            var preferences = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                __WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].emptyObject(item);
                ref.onSnapshot(function (snap) {
                    if (!snap.exists) return;
                    var newData = snap.data() || {};
                    __WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].copyProperties(newData, item);
                    __WEBPACK_IMPORTED_MODULE_21_vue__["default"].set(item, '_id', snap.id);
                    __WEBPACK_IMPORTED_MODULE_21_vue__["default"].set(item, '_path', snap.ref.path);
                    resolve('done');
                }, function (err) {
                    item = {};
                    console.log('Error in streamDocument:', err.message, 'Trying to load data from', ref.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                    reject(err.message);
                });
            });
        }
    }, {
        key: 'ref',
        value: function ref(path) {
            if (__WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].isObject(path)) path = this.objectToPath(path);

            if (__WEBPACK_IMPORTED_MODULE_27__helpers_NumberHelpers__["a" /* default */].isOdd(path.split('/').length)) return fs.collection(path);else return fs.doc(path);
        }
    }, {
        key: 'fetch',
        value: function fetch(ref) {
            var path = ref.path;
            if (ref._query || __WEBPACK_IMPORTED_MODULE_27__helpers_NumberHelpers__["a" /* default */].isOdd(path.split('/').length)) return this.fetchCollection(ref);else return this.fetchDocument(ref);
        }
    }, {
        key: 'objectToPath',
        value: function objectToPath(object) {
            object.team = object.team || 'xxxxxxx';
            if (!object.collection) throw 'objectToPath > Collection not specified';
            var path = 'teams/' + object.team + '/collections/' + object.collection + '/data';

            if (object.id) path += '/' + object.id;

            return path;
        }
    }, {
        key: 'fetchDocument',
        value: function fetchDocument(ref) {
            var _this4 = this;

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.get().then(function (doc) {
                    if (doc.exists) {
                        var document = doc.data();
                        document = _this4.convertDates(document);

                        __WEBPACK_IMPORTED_MODULE_21_vue__["default"].set(document, '_id', doc.id);
                        __WEBPACK_IMPORTED_MODULE_21_vue__["default"].set(document, '_path', doc.ref.path.replace('/' + doc.id, ''));
                        resolve(document);
                    } else {
                        resolve(null);
                    }
                }, function (err) {
                    console.log('Error in streamDocument:', err.message, 'Trying to load data from', ref.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                    reject(err.message);
                });
            });
        }
    }, {
        key: 'fetchMulti',
        value: function fetchMulti(refsArray) {
            var _this5 = this;

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                    var promises, results, mergedItems;
                    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    promises = [];

                                    refsArray.forEach(function (ref) {
                                        promises.push(_this5.fetchCollection(ref));
                                    });
                                    _context3.next = 4;
                                    return __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a.all(promises);

                                case 4:
                                    results = _context3.sent;
                                    mergedItems = [];

                                    results.forEach(function (arr) {
                                        mergedItems = __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].unionById(mergedItems, arr);
                                    });
                                    resolve(mergedItems);

                                case 8:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this5);
                }));

                return function (_x6, _x7) {
                    return _ref3.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'streamToStore',
        value: function streamToStore(team, collection, preferences) {
            var _this6 = this;

            var collectionRef = this.getCollectionDocumentRef(team, collection);

            var p1 = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var dataRef = collectionRef.collection('data').orderBy('createdAt', 'desc');

                dataRef.onSnapshot(function (snap) {

                    snap.storeTeamAndCollection = true;

                    var data = [];
                    _this6.snapshotFillArray(snap, data);
                    var count = data.length;
                    var payload = {
                        team: team, collection: collection, data: data, count: count
                    };

                    __WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].commit('setCollection', payload);
                    resolve(data);
                }, function (err) {
                    console.log('Error in streamToStore:', err.message, 'Trying to load data from', dataRef.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                });
            });

            var p2 = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var fieldsRef = collectionRef.collection('fields');

                fieldsRef.onSnapshot(function (snap) {

                    snap.storePath = true;

                    var fields = [];
                    _this6.snapshotFillArray(snap, fields);
                    var payload = {
                        team: team, collection: collection, fields: fields
                    };

                    __WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].commit('setCollection', payload);
                    resolve(fields);
                }, function (err) {
                    console.log('Error in streamToStore:', err.message, 'Trying to load data from', fieldsRef.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                });
            });

            var p3 = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var actionRef = collectionRef.collection('actions');

                actionRef.onSnapshot(function (snap) {

                    var actions = [];
                    _this6.snapshotFillArray(snap, actions);
                    var payload = {
                        team: team, collection: collection, actions: actions
                    };

                    __WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].commit('setCollection', payload);
                    resolve(actions);
                }, function (err) {
                    console.log('Error in streamToStore:', err.message, 'Trying to load data from', actionRef.path);
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                });
            });
        }
    }, {
        key: 'snapshotFillArray',
        value: function snapshotFillArray(snap, arr) {
            var _this7 = this;

            var preferences = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!arr) debugger;

            var ordered = false;

            if (!preferences.keepArray) {
                for (var i = arr.length; i > 0; i--) {
                    arr.pop();
                }
            }

            snap.forEach(function (docSnapshot) {
                var item = docSnapshot.data();
                item._id = docSnapshot.id;

                if (snap.storePath) item._path = _this7.truncateLastSegment(docSnapshot.ref.path);

                if (snap.storeTeamAndCollection) {
                    var pathArray = docSnapshot.ref.path.split('/');
                    item._team = pathArray[1];
                    item._collection = pathArray[3];
                }

                if (item.order) ordered = true;

                if (preferences.reverse) arr.unshift(item);else arr.push(item);
            });

            if (ordered) arr = arr.sort(__WEBPACK_IMPORTED_MODULE_19__helpers_OrderHelpers__["a" /* default */].sortByOrder);
        }
    }, {
        key: 'deleteItem',
        value: function deleteItem(item) {
            var ref = this.getItemRef(item);
            ref.delete().then(function () {
                console.log('Firestore > deleteItem: deleted at', ref.path);
            });
        }
    }, {
        key: 'removeMeta',
        value: function removeMeta(obj) {
            var newObj = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, obj);
            for (var prop in newObj) {
                if (prop.substr(0, 1) == '_') delete newObj[prop];
            }
            return newObj;
        }
    }, {
        key: 'convertDates',
        value: function convertDates(firebaseObject) {
            var _this8 = this;

            if (!firebaseObject) return null;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(firebaseObject)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref4 = _step.value;

                    var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);

                    var key = _ref5[0];
                    var value = _ref5[1];

                    if (value && Array.isArray(value)) firebaseObject[key] = value.map(function (item) {
                        return _this8.convertDates(item);
                    });

                    if (value && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
                        firebaseObject[key] = this.convertDates(value);
                    }

                    if (value && value.toDate) {
                        firebaseObject[key] = value.toDate();
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return firebaseObject;
        }
    }, {
        key: 'removeNullsForStorage',
        value: function removeNullsForStorage(obj) {
            for (var prop in obj) {
                if (obj[prop] === null) obj[prop] = this.deleteToken();
            }
        }
    }, {
        key: 'removeNulls',
        value: function removeNulls(obj) {
            for (var prop in obj) {
                if (obj[prop] === null) delete obj[prop];
            }
        }
    }, {
        key: 'cloneForEdit',
        value: function cloneForEdit(obj) {
            var newObj = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, obj);
            var originalObj = this.removeMeta(obj);
            newObj._originalValues = originalObj;
            return newObj;
        }
    }, {
        key: 'getChanges',
        value: function getChanges(oldObj, newObj) {
            var oldValues = this.removeMeta(oldObj);
            var newValues = this.removeMeta(newObj);
            var result = { values: {}, changes: [], description: '', hasChanges: false };
            for (var field in newValues) {
                var oldValue = oldValues[field];
                var newValue = newValues[field];

                if (oldValue != newValue) {
                    result.hasChanges = true;
                    result.name = item.name || item.text || item._id;
                    result.id = item._id;
                    result.values[field] = newValue;

                    var oldValueToSave = this.noUndefined(oldValue);
                    result.changes.push({ field: field, oldValue: oldValueToSave, newValue: newValue });

                    result.description += this.describeChange(field, oldValue, newValue);
                    result.path = item._path;
                    result.uid = __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].getUserId();
                }
            }
            return result;
        }
    }, {
        key: 'noUndefined',
        value: function noUndefined(val) {
            if (typeof val == 'undefined') return '[empty]';
            return val;
        }
    }, {
        key: 'describeChange',
        value: function describeChange(field, oldValue, newValue) {
            var o = oldValue;
            var n = newValue;
            if (__WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].isObject(o)) o = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(o);
            if (__WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].isObject(n)) n = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(n);
            return '\'' + field + '\' changed from \'' + o + '\' to \'' + n + '\'. ';
        }
    }, {
        key: 'deleteObjectFromArray',
        value: function deleteObjectFromArray(obj, arr) {

            var idx = arr.findIndex(function (o) {
                return o._id == obj._id;
            });
            if (idx >= 0) arr.splice(idx, 1);else __WEBPACK_IMPORTED_MODULE_24__helpers_Utilities__["a" /* default */].log('Firestore > deleteObjectFromArray > Cant find object', obj);
        }
    }, {
        key: 'fetchValue',
        value: function fetchValue(ref) {
            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var result = snap.val();
                    resolve(result);
                });
            });
        }
    }, {
        key: 'fetchItemByName',
        value: function fetchItemByName(baseRef, name) {
            var _this9 = this;

            return new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                baseRef.orderByChild('name').equalTo(name).once('value', function (snap) {
                    var objects = _this9.arrayFromSnapshot(snap);
                    if (objects && objects.length) resolve(objects[0]);else resolve(null);
                });
            });
        }
    }, {
        key: 'objectFromSnapshot',
        value: function objectFromSnapshot(snap) {
            var item = snap.val();
            if (!item) return null;
            item.meta = {};
            item.meta.id = snap.id;
            var pathArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(snap.ref.path.pieces_));
            if (pathArray.length > 2 && pathArray[0] == 'tenants') item.meta.tenantKey = pathArray[1];

            pathArray.pop();
            item.meta.path = pathArray.join('/');
            return item;
        }
    }, {
        key: 'safelyGetTenant',
        value: function safelyGetTenant(obj) {
            if (obj && obj.meta && obj.meta.tenantKey) return obj.meta.tenantKey;else return __WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].getters.tenantKey;
        }
    }, {
        key: 'fetchItems',
        value: function fetchItems(ref, storeName, localVariable) {
            if (__WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].state[storeName].length) {
                console.log('fetchItems from cache', storeName);
                localVariable = __WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].state[storeName];
                return;
            }
            this.fetchItemsFromFirebase(ref).then(function (items) {
                console.log('fetchItems from db', storeName);

                var payload = {
                    name: storeName,
                    data: items
                };
                __WEBPACK_IMPORTED_MODULE_17__store_Store__["a" /* default */].commit('saveItems', payload);
                localVariable = items;
            });
        }
    }, {
        key: 'saveFieldToFirebase',
        value: function saveFieldToFirebase(ref, x) {}
    }, {
        key: 'firebaseRefToPath',
        value: function firebaseRefToPath(ref) {
            var refStr = ref.toString();
            var refArr = refStr.split(/\//).slice(3).join('/');
            return refArr;
        }
    }, {
        key: 'firebaseRefToKey',
        value: function firebaseRefToKey(ref) {
            var pathArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ref.path.pieces_));
            pathArray.pop();
            return pathArray.join("/");
        }
    }, {
        key: 'defaultValue',
        value: function defaultValue(field) {
            if (field == '[tenantKey]') return __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].getTenantKey();
            if (field == '[stamp]') return __WEBPACK_IMPORTED_MODULE_18__helpers_DataHelpers__["a" /* default */].getStamp();
        }
    }, {
        key: 'saveField',
        value: function saveField(ref, value) {
            ref.set(value);
        }
    }, {
        key: 'copyItems',
        value: function copyItems(fromRef, toRef) {
            var _this10 = this;

            var toPath = this.firebaseRefToPath(toRef);
            this.fetchItemsFromFirebase(fromRef).then(function (fromItems) {
                fromItems.forEach(function (item) {
                    item.meta.path = toPath;
                    _this10.saveItem(item);
                });
                console.log('copyItems reports ' + fromItems.length + ' items copied from ' + _this10.firebaseRefToPath(fromRef) + ' to ' + toPath + '.');
            });
        }
    }, {
        key: 'copySingleItem',
        value: function copySingleItem(fromRef, toRef) {
            var _this11 = this;

            var toPath = this.firebaseRefToPath(toRef);
            var toKey = this.firebaseRefToKey(toRef);
            this.fetchItemSingle(fromRef).then(function (fromItem) {
                fromItem.meta.path = toPath;
                fromItem.meta.id = toKey;
                _this11.saveItem(item);
                console.log('copySingleItem copied from ' + _this11.firebaseRefToPath(fromItemRef) + ' to ' + toPath + '.', fromItem);
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(17);





var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
    key: 'getAverageOrder',
    value: function getAverageOrder(e) {
      var prevOrder = void 0,
          nextOrder = void 0,
          newOrder = void 0;

      if (e.item.previousSibling && e.item.previousSibling.dataset.order) prevOrder = e.item.previousSibling.dataset.order;

      console.log('prevOrder', __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].formatNumber(prevOrder));

      if (e.item.nextSibling && e.item.nextSibling.dataset.order) nextOrder = e.item.nextSibling.dataset.order;

      console.log('nextOrder', __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].formatNumber(nextOrder));

      if (!prevOrder) newOrder = 0 - __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].sortKey() + 1000;else if (!nextOrder) newOrder = __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].sortKey();else newOrder = Math.round((parseInt(prevOrder) + parseInt(nextOrder)) / 2);

      e.item.dataset.order = newOrder;

      console.log('newOrder', __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].formatNumber(newOrder));

      return newOrder;
    }
  }, {
    key: 'orderKey',
    value: function orderKey() {
      return parseInt(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["a" /* format */])(new Date(), 'yyMMddHHmmss')) * 100;
    }
  }, {
    key: 'sortAscending',
    value: function sortAscending(a, b) {
      if (b.alwaysLast) {
        return -1;
      }
      if (a.alwaysLast) {
        return 1;
      }

      if (!a.order || a.order < b.order) {
        return -1;
      }
      if (!b.order || a.order > b.order) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByTimestampDescending',
    value: function sortByTimestampDescending(a, b) {

      if (!b.stamp || !b.stamp.date || b.stamp.date < a.stamp.date) {
        return -1;
      }
      if (!a.stamp || !a.stamp.date || b.stamp.date > a.stamp.date) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByCreatedAtDescending',
    value: function sortByCreatedAtDescending(a, b) {

      if (!b.createdAt.seconds || !b.createdAt.seconds || b.createdAt.seconds < a.createdAt.seconds) {
        return -1;
      }
      if (!a.createdAt.seconds || !a.createdAt.seconds || b.createdAt.seconds > a.createdAt.seconds) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByOpenedAtDescending',
    value: function sortByOpenedAtDescending(a, b) {

      if (!b.openedAt || b.openedAt < a.openedAt) {
        return -1;
      }
      if (!a.openedAt || b.openedAt > a.openedAt) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByDate',
    value: function sortByDate(a, b) {

      if (!a.date || a.date < b.date) {
        return -1;
      }
      if (!b.date || a.date > b.date) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByName',
    value: function sortByName(a, b) {

      if (!a.name || a.name < b.name) {
        return -1;
      }
      if (!b.name || a.name > b.name) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByTitle',
    value: function sortByTitle(a, b) {

      if (!a.title || a.title < b.title) {
        return -1;
      }
      if (!b.title || a.title > b.title) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByOrder',
    value: function sortByOrder(a, b) {

      if (!a.order || a.order < b.order) {
        return -1;
      }
      if (!b.order || a.order > b.order) {
        return 1;
      }
      return 0;
    }
  }, {
    key: 'sortByField',
    value: function sortByField(a, b, field) {
      if (!a[field] || a[field] < b[field]) {
        return -1;
      }
      if (!b[field] || a[field] > b[field]) {
        return 1;
      }
      return 0;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(6);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getMasterKey',
        value: function getMasterKey() {
            return '-LG-kkb1y_ZwFJ9GYSZj';
        }
    }, {
        key: 'operators',
        value: function operators() {
            return [{ code: 'e', name: 'Equals' }, { code: 'ne', name: 'Not Equal' }];
        }
    }, {
        key: 'officeTeams',
        value: function officeTeams() {
            return {
                '1': 'Mortgage Choice Currimundi',
                '002': 'Mortgage Choice Buderim'
            };
        }
    }, {
        key: 'relationships',
        value: function relationships() {
            return [{ text: 'Partner', relatedText: 'Partner' }, { text: 'Parent', relatedText: 'Child' }, { text: 'Child', relatedText: 'Parent' }, { text: 'Friend', relatedText: 'Friend' }, { text: 'Client', relatedText: 'Consultant' }, { text: 'Consultant', relatedText: 'Client' }];
        }
    }, {
        key: 'processors',
        value: function processors() {
            return [{
                email: 'billing@insightprocessing.com.au',
                abn: '18 154 499 025 (Insight Processing Services Trust)',
                account: 'BSB: 064462, A/C: 10254283',
                rate: 0.0
            }, {
                email: 'matt.ireland.home@gmail.com',
                abn: '1234567890',
                account: 'BSB: 000000, A/C: 12345678',
                rate: 0.15
            }, {
                email: 'vicki.renouf@insightprocessing.com.au',
                abn: '92156674105',
                account: 'BSB: 014504, A/C: 300856871',
                rate: 0.15
            }, {
                uid: 'mMJSgZ2W2XgT0JUfOG1mNnbd7OE2',
                email: 'shannon.mcleish@insightprocessing.com.au',
                abn: '80 823 244 516',
                account: 'BSB: 064462, A/C: 10307269',
                rate: 0.1,
                address: 'PO Box 369, Dalby Qld 4405'
            }, {
                uid: 'bPZAmX6EbKSVWA6fJ3RkCeVUv8i1',
                email: 'kate.gorman@insightprocessing.com.au',
                abn: '56 793 528 824',
                account: 'BSB:306-134 Acc:0947 027',
                rate: 0.15,
                address: '46 Hickford St, Brunswick East VIC 3057'
            }, {
                uid: 'a2Sy21W9MwcuvkS2Sjn4AIB8RQF2',
                email: 'damian.simmons@insightprocessing.com.au',
                abn: '93 156 970 364',
                account: 'BSB:814-282 Acc:50576773',
                rate: 0.1,
                address: '2 Torana Ct, South Bingera Q 4670'
            }, {
                uid: 'JqYWK2x7bkSZjNfyzjSqLimhGRz2',
                email: 'tess.pitcher@insightprocessing.com.au',
                abn: '94 130 145 517',
                entity: 'Pitcher Family Trust',
                account: 'BSB:014616 Acc: 151207703',
                rate: 0.15,
                address: '10 Cary Street, Woombye QLD'
            }, {
                email: 'tess.pitcher1@mortgagechoice.com.au',
                uid: 'JqYWK2x7bkSZjNfyzjSqLimhGRz2',
                abn: '94 130 145 517',
                entity: 'Pitcher Family Trust',
                account: 'BSB:014616 Acc:151207703',
                rate: 0.15,
                address: '10 Cary Street, Woombye QLD'
            }, {
                email: 'nic.papandrea@insightprocessing.com.au',
                uid: 'dF1F48bHkSaT8cFCQzIwafsPcCH3',
                abn: '75 169 776 194 (Henj Pty Ltd)',
                account: 'BSB:084 004  Acc: 91-693-3767',
                rate: 0.15,
                address: '8 Waterford Ct, Maroochydore 4558'
            }, {
                email: 'kristin.mcleish@insightprocessing.com.au',
                abn: '91 786 286 393',
                account: 'BSB:064462 Acc:10254283',
                rate: 0.15,
                address: '139 Queen Street, Maryborough QLD 4650'
            }, {
                uid: 'P1iLuvCOHWatoTJNAaoEXqWhP0v2',
                email: 'hayley.wyatt@insightprocessing.com.au',
                abn: '62 639 442 286',
                account: 'BSB 085-005 Acct 309353592',
                rate: 0.1,
                address: '38 Chapel Road Modbury North SA 5092'
            }, {
                uid: 'MOuMD8KFKZV9yxVZPe2FQRbpfF93',
                email: 'robynne.duncan@insightprocessing.com.au',
                abn: '95 625 020 028',
                account: 'BSB 533-000 Acct 10656328',
                rate: 0.15,
                entity: 'Hunter Commercial Pty Ltd',
                address: 'PO Box 91 Maroochydore Q 4558'
            }, {
                uid: 'FCXzwTED9WRM6bZFvExHCEq0cyG3',
                email: 'kim.robinson@insightprocessing.com.au',
                abn: '68 572 795 443',
                account: 'BSB 484-799 Acct 052368080',
                rate: 0.15,
                entity: 'Kim Robinson',
                address: '16 Clive St, Tenterfield NSW  2372'
            }, {
                email: 'matt.driscoll@insightprocessing.com.au',
                abn: '75 629 059 516',
                account: 'BSB:xxxx Acc:xxxxx',
                rate: 0.15
            }, {
                email: 'linda.carr@insightprocessing.com.au',
                abn: '43 806 290 094',
                account: 'BSB:734 655 Acc:596 047',
                rate: 0.15,
                address: '79 Neurum Rd, Yaroomba Q 4573'
            }, {
                email: 'shelly.hope@insightprocessing.com.au',
                abn: '56 918 763 572',
                account: 'BSB:923 100 Acc:305472219',
                rate: 0.15,
                address: '84 Tooley Street, Maryborough Q 4650'
            }, {
                uid: 'opv1HwNvyHYAVUO8ZazZ5i2rLWT2',
                email: 'tiani.cantwell@insightprocessing.com.au',
                abn: '45 737 219 858',
                account: 'BSB:923 100 Acc:3061 34846',
                rate: 0.15,
                address: 'Unit1, 21-25 Garners Avenue, Marrickville NSW 2204'
            }, {
                uid: '1tLZJ6exz2hNFjJmUYYn2QKtsCb2',
                email: 'nicole.hogan@insightprocessing.com.au',
                abn: '81 552 384 365',
                account: 'BSB:082-155 Acc:75-105-1407',
                rate: 0.15,
                address: '5/11-13 Myahgah Road, Mosman NSW 2088'
            }, {
                uid: 'NPlRptCknbcMmdo74EDNA8JnIHg1',
                email: 'juliet.welsh@insightprocessing.com.au',
                abn: '91156727792',
                account: 'BSB 734 065, Acc 602910',
                rate: 0.15,
                address: ''
            }, {
                uid: 'HM78oWztxgh6rvTM5fSLlczP1by2',
                email: 'daniel.hausler@insightprocessing.com.au',
                abn: '35759660448',
                account: 'BSB 014512, Acc 321980767',
                rate: 0.15,
                address: '11/55 Buderim Ave Mooloolaba QLD 4557'
            }, {
                uid: 'ER0TdSKsRdd3SM57qatRoRirD083',
                email: 'vikki.hanning@insightprocessing.com.au',
                abn: '80 646 466 444',
                account: 'BSB 062-692, Acc 42910332',
                rate: 0.1,
                address: '2/65 Dane St, East Victoria Park, WA 6101'
            }];
        }
    }, {
        key: 'snippets',
        value: function snippets() {
            return [{
                title: 'Emailed Client',
                text: 'Emailed client',
                category: 'Comments'
            }, {
                title: 'Called Client',
                text: 'Called client. Spoke with client.',
                category: 'Comments'
            }, {
                title: 'Called No Answer',
                text: 'Called client. No Answer.',
                category: 'Comments'
            }, {
                title: 'Called Voicemail',
                text: 'Called client. Left voicemail.',
                category: 'Comments'
            }, {
                title: 'Called with Update',
                text: 'Called client. Updated on progress.',
                category: 'Comments'
            }, {
                title: 'Called Lender',
                text: 'Called lender for update.',
                category: 'Comments'
            }];
        }
    }, {
        key: 'outstandingStatuses',
        value: function outstandingStatuses() {
            return ['Waiting for Client', 'Waiting for Broker', 'Waiting for Processor', 'Lender to Complete', 'Ready to Send', 'Settlement Condition', 'Sent'];
        }
    }, {
        key: 'lenders',
        value: function lenders() {
            return [{ name: 'ANZ' }, { name: 'CBA' }, { name: 'Westpac' }, { name: 'NAB' }, { name: 'Pepper' }, { name: 'Suncorp' }, { name: 'St George' }, { name: 'Heritage' }, { name: 'ING Direct' }, { name: 'Macquarie' }];
        }
    }]);

    return _class;
}();

_class.fieldTypes = [{ name: 'Text', control: 'Text' }, { name: 'Number', control: 'Number' }, { name: 'List', control: 'Dropdown' }, { name: 'Currency', control: 'Currency' }, { name: 'Date', control: 'Date' }, { name: 'True/False', control: 'Checkbox' }, { name: 'Html', control: 'Html' }, { name: 'Parent Table', control: 'Dropdown' }, { name: 'Child Table', control: 'Dropdown' }, { name: 'Calculated', control: 'Text' }, { name: 'File', control: 'Upload' }, { name: 'Image', control: 'Image' }];
_class.controlTypes = [{ name: 'Text', field: 'Text' }, { name: 'Text', field: 'Calculated' }, { name: 'Number', field: 'Number' }, { name: 'Dropdown', field: 'List' }, { name: 'Currency', field: 'Currency' }, { name: 'Date', field: 'Date' }, { name: 'Checkbox', field: 'True/False' }, { name: 'Switch', field: 'True/False' }, { name: 'Options', field: 'List' }, { name: 'Html', field: 'Html' }, { name: 'Upload', field: 'File' }, { name: 'Image', field: 'Image' }];
_class.actionTypes = [{ name: 'Set Field Value' }];
_class.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TemplatesStore__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContactsStore__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GroupsStore__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ClipboardStore__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TransactionsStore__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ElementsStore__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TasksStore__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AlertsStore__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CollectionsStore__ = __webpack_require__(144);





















var db = __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* default */].database();

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
    modules: {
        templates: __WEBPACK_IMPORTED_MODULE_9__TemplatesStore__["a" /* default */],
        transactions: __WEBPACK_IMPORTED_MODULE_13__TransactionsStore__["a" /* default */],
        contacts: __WEBPACK_IMPORTED_MODULE_10__ContactsStore__["a" /* default */],

        groups: __WEBPACK_IMPORTED_MODULE_11__GroupsStore__["a" /* default */],
        clipboard: __WEBPACK_IMPORTED_MODULE_12__ClipboardStore__["a" /* default */],
        elements: __WEBPACK_IMPORTED_MODULE_14__ElementsStore__["a" /* default */],
        tasks: __WEBPACK_IMPORTED_MODULE_15__TasksStore__["a" /* default */],
        alerts: __WEBPACK_IMPORTED_MODULE_16__AlertsStore__["a" /* default */],
        collections: __WEBPACK_IMPORTED_MODULE_17__CollectionsStore__["a" /* default */]
    },

    state: {
        status: {},
        tenant: null,
        tenantDefault: null,
        user: null,
        offices: [],
        loginStatus: null,
        loading: false,
        loadingItems: [],
        step: null,
        transactionFields: [],

        loadedTemplates: false,
        dialogHeight: 500,
        designMode: false,
        selectedKeys: {},
        pageData: {},
        applicationData: {}
    },
    mutations: {
        setSelectedKeys: function setSelectedKeys(state, _ref) {
            var code = _ref.code,
                keys = _ref.keys;

            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.selectedKeys, code, keys);
        },
        setPageData: function setPageData(state, _ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.pageData, name, value);
        },
        clearPageData: function clearPageData(state) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'pageData', {});
        },
        setApplicationData: function setApplicationData(state, _ref3) {
            var name = _ref3.name,
                value = _ref3.value;

            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.applicationData, name, value);
        },
        clearApplicationData: function clearApplicationData(state) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'applicationData', {});
        },
        saveItems: function saveItems(state, payload) {
            state[payload.name] = payload.data;
        },
        setOfficeActive: function setOfficeActive(state, _ref4) {
            var officeNumber = _ref4.officeNumber,
                value = _ref4.value;

            var office = state.offices.find(function (o) {
                return o.meta.key == officeNumber;
            });
            if (office) office.active = value;
        },
        status: function status(state, payload) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.status, payload.name, payload.status);
        },
        dialogHeight: function dialogHeight(state, payload) {
            state.dialogHeight = payload;
        },
        setUser: function setUser(state, user) {
            state.user = user;
        },
        setOffices: function setOffices(state, offices) {
            state.offices = offices;
        },
        setLoading: function setLoading(state, loading) {
            state.loading = loading;
        },
        loginStatus: function loginStatus(state, _loginStatus) {
            state.loginStatus = _loginStatus;
            localStorage.setItem('loginStatus', _loginStatus);
        },
        startLoading: function startLoading(state, description) {
            state.loadingItems.push(description);
        },
        stopLoading: function stopLoading(state, description) {
            if (description) {

                var position = state.loadingItems.indexOf(description);
                if (position > -1) state.loadingItems.splice(position, 1);
            } else state.loadingItems = [];
        },
        setTenant: function setTenant(state, tenant) {
            state.tenant = tenant;
            localStorage.setItem('tenant', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tenant));
        },
        setTenantDefault: function setTenantDefault(state, tenantDefault) {
            state.tenantDefault = tenantDefault;
        },
        setStep: function setStep(state, step) {
            state.step = step;
        },
        setDesignMode: function setDesignMode(state, newValue) {
            state.designMode = newValue;
        },
        setTransactionFields: function setTransactionFields(state, transactionFields) {
            state.transactionFields = transactionFields;
        }
    },

    actions: {
        loadTemplates: function loadTemplates(context) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (context.getters.loadedTemplates) resolve(context.getters.templates);

                var ref = db.ref('tenants/' + context.getters.tenantKey + '/templates');
                ref.on('value', function (snap) {
                    console.log('store > loadedTemplates');
                    var templates = __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap).sort(function (a, b) {
                        if (a.group < b.group) return -1;
                        if (a.group > b.group) return 1;
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    });
                    context.commit('templates', templates);
                    context.commit('loadedTemplates', true);
                    resolve(templates);
                });
            });
        },
        saveTemplate: function saveTemplate(context, payload) {
            var key = payload.key || payload['.key'] || __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getKey();
            var ref = db.ref('tenants/' + context.getters.tenantKey + '/templates/' + key);
            ref.update(__WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(payload));
        },
        deleteTemplate: function deleteTemplate(context, payload) {
            var key = payload.key || payload['.key'];
            var ref = db.ref('tenants/' + context.getters.tenantKey + '/templates/' + key);
            ref.remove();
        }
    },

    getters: {

        dialogHeight: function dialogHeight(state) {
            return function (dialogHeight) {
                return state.dialogHeight;
            };
        },

        getSelectedKeys: function getSelectedKeys(state) {
            return function (code) {
                return state.selectedKeys[code] || [];
            };
        },
        getPageData: function getPageData(state) {
            return function (name) {
                return state.pageData[name] || null;
            };
        },
        getApplicationData: function getApplicationData(state) {
            return function (name) {
                return state.applicationData[name] || null;
            };
        },

        status: function status(state) {
            return function (status) {
                return state.status[status] || '';
            };
        },

        tenant: function tenant(state) {
            if (!state.tenant || !state.tenant.key) state.tenant = JSON.parse(localStorage.getItem('tenant'));
            if (!state.tenant || !state.tenant.key) return { key: 0 };
            return state.tenant;
        },
        tenantDefault: function tenantDefault(state) {
            return state.tenantDefault;
        },
        tenantKey: function tenantKey(state, getters) {
            return getters.tenant.key;
        },
        user: function user(state) {
            if (state.user) return state.user;else return {
                firstName: '',
                lastName: '',
                image: '',
                mobile: '',
                email: '',
                uid: '',
                offices: []
            };
        },

        offices: function offices(state) {
            return state.offices;
        },

        officesActive: function officesActive(state, getters) {
            return getters.offices.filter(function (o) {
                return o.active;
            });
        },

        loginStatus: function loginStatus(state) {
            if (state.loginStatus) return state.loginStatus;else {
                return localStorage.getItem('loginStatus');
            }
        },
        uid: function uid(state) {
            if (state.user) return state.user.uid;else return '';
        },
        userFullName: function userFullName(state) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].fullName(state.user);
        },
        loading: function loading(state) {
            return state.loading;
        },

        loadingMessage: function loadingMessage(state) {
            if (state.loadingItems.length == 0) return '';

            return 'Loading ' + state.loadingItems.join(', ');
        },
        step: function step(state) {
            return state.step;
        },

        designMode: function designMode(state) {
            return state.designMode;
        },
        transactionFields: function transactionFields(state) {
            return state.transactionFields;
        }

    }

}));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(2534),
  /* scopeId */
  "data-v-49c67524",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoanHelpers__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns__ = __webpack_require__(17);
















var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getElementInstance',
        value: function getElementInstance(name) {
            var segmentArray = name.split('_');
            var instance = segmentArray[segmentArray.length - 1];
            return parseInt(instance);
        }
    }, {
        key: 'merge',
        value: function merge(str, elements, options) {
            return this.mergeAndAttach(str, elements, options).text;
        }
    }, {
        key: 'mergeAndAttach',
        value: function mergeAndAttach(str, elements, options) {

            var mf = this.findMergeFields(str);
            console.log(mf);

            var attachments = [];

            var instance = 0;
            if (options && options.element) instance = this.getElementInstance(options.element.name);

            if (!str || !str.match) {
                return { text: '', attachments: [] };
            }

            var match = str.match(/\[(.*?)\]/i);

            if (!match) return { text: str };

            while (match) {
                var replacement = void 0;
                var innerMatch = match[1];
                var mergeFieldArray = innerMatch.split('|').map(function (item) {
                    return item.trim();
                });
                var mergeField = mergeFieldArray[0];
                var transformsArray = mergeFieldArray.splice(1);
                if (mergeField.startsWith('outstandings')) {
                    var outstandingResult = this.formatOutstanding(mergeField, elements);
                    replacement = outstandingResult.text;
                    this.addUniqueAttachments(outstandingResult.attachments, attachments);
                }

                if (!replacement) replacement = this.specialField(mergeField, elements);

                if (!replacement && options) replacement = options[mergeField.toLowerCase()];

                var result = { found: false, text: '', attachments: [] };

                if (!replacement && elements && instance > 1) {
                    result = this.lookupItem(mergeField.toLowerCase() + '_' + instance.toString(), elements);
                    replacement = result.text;

                    this.addUniqueAttachments(result.attachments, attachments);
                }

                if (mergeField == 'email_button') {
                    var role = transformsArray[0];
                    var group = transformsArray[1];
                    var template = transformsArray[2];
                    var tenantKey = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantKey();
                    var transactionKey = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTransactionKey();
                    var path = tenantKey + '/transaction/' + transactionKey + '?a=email&g=' + group + '&t=' + template + '&r=' + role;
                    replacement = __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].linkToTaco(path, 'Email ' + role);
                }

                if (mergeField == 'contact_card') {
                    var _role = transformsArray[0];
                    replacement = __WEBPACK_IMPORTED_MODULE_7__ContactHelpers__["a" /* default */].mergeContactCards(_role, elements);
                }

                if (!replacement && !result.found && elements) {
                    result = this.lookupItem(mergeField.toLowerCase(), elements);
                    replacement = result.text;

                    this.addUniqueAttachments(result.attachments, attachments);
                }

                for (var n = 0; n < transformsArray.length; n++) {
                    var transform = transformsArray[n].toLowerCase();
                    replacement = this.transformField(transform, replacement);
                }

                if (!replacement && !result.found) replacement = '{{' + mergeField + '}}';

                str = str.replace(match[0], replacement);
                match = str.match(/\[(.*?)\]/i);
            }
            str = str.replace(/{{/g, '[').replace(/}}/g, ']');

            match = str.match(/IF\((.*?)ENDIF/);

            while (match) {

                var conditionalText = match[0];
                var expression = match[1].split(')')[0].trim().toLowerCase().replace(/&amp;/g, '&');

                var expressionMatch = expression.match(/\[(.*?)\]/i);
                while (expressionMatch) {
                    expression = expression.replace(expressionMatch[0], '');
                    expressionMatch = expression.match(/\[(.*?)\]/i);
                }

                var newText = '';
                var expressionResult = void 0;

                try {
                    expressionResult = eval(expression);
                } catch (e) {
                    expressionResult = false;
                }
                if (expressionResult) newText = match[1].split(')')[1].replace('ENDIF', '');

                str = str.replace(conditionalText, newText);
                match = str.match(/IF\((.*?)ENDIF/);
            }

            match = str.match(/\<FORMULA\>(.*?)\<\/FORMULA\>/);
            while (match) {
                var outerMatch = match[0];
                var formulaExpression = match[1];
                var evaluation = '(?)';
                try {

                    evaluation = eval(formulaExpression);
                } catch (err) {
                    console.log('Formula evaluation failed on ' + formulaExpression);
                }

                str = str.replace(outerMatch, evaluation);
                match = str.match(/\<FORMULA\>(.*?)\<\/FORMULA\>/);
            }

            str = str.replace(/1==1/g, '');

            return { text: str, attachments: attachments };
        }
    }, {
        key: 'findMergeBlocks',
        value: function findMergeBlocks(text, startWord, endWord) {
            var re = new RegExp(startWord + '(.*?)' + endWord, 'g');
            var matches = text.match(re) || [];
            var results = [];

            matches.forEach(function (block) {

                var expressions = block.match(/\(.*?\)/g);
                if (expressions.length) {
                    var outerExpression = expressions[0];
                    var innerExpression = outerExpression.replace('(', '').replace(')', '');
                    var content = block.replace(outerExpression, '').replace(startWord, '').replace(endWord, '');
                    results.push({
                        outerExpression: outerExpression,
                        innerExpression: innerExpression,
                        content: content
                    });
                }
            });

            console.log(results);
            return matches;
        }
    }, {
        key: 'addUniqueAttachments',
        value: function addUniqueAttachments(fromArray, toArray) {
            fromArray.forEach(function (attachmentObject) {
                var existing = toArray.find(function (o) {
                    return o.path == attachmentObject.path;
                });
                if (!existing) toArray.push(attachmentObject);
            });
        }
    }, {
        key: 'transformField',
        value: function transformField(transform, replacement) {

            if (transform == 'lower') return replacement.toLowerCase();
            if (transform == 'integer') return __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].formatInteger(replacement);
            if (transform == 'first') return __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].firstWord(replacement);
            if (transform == 'days') {
                var dateStr = replacement.split(' ')[1];
                var dateVal = __WEBPACK_IMPORTED_MODULE_4__DateHelpers__["a" /* default */].toDate(dateStr);
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["o" /* differenceInCalendarDays */])(dateVal, new Date());
            } else return replacement;
        }
    }, {
        key: 'lookupItem',
        value: function lookupItem(value, elements) {
            var _this = this;

            var matchingElements = elements.filter(function (o) {
                return o.name && o.value && o.name.toLowerCase() == value.toLowerCase();
            });
            var result = {
                found: false,
                attachments: [],
                replacements: [],
                text: ''
            };
            var resultArray = [];
            var resultAttachments = [];

            matchingElements.forEach(function (element) {
                if (element.type == "File") {
                    result.attachments.push({
                        path: element.value,
                        name: __WEBPACK_IMPORTED_MODULE_11__FileHelpers__["a" /* default */].fileNameFromStoragePath(element.value),
                        fileName: element.fileName
                    });
                    result.replacements.push('1==1');
                    result.found = true;
                } else {
                        result.replacements.push(_this.formatElement(element));
                        result.found = true;
                    }
            });

            result.text = __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].sentenceJoin(result.replacements);

            return result;
        }
    }, {
        key: 'formatElement',
        value: function formatElement(element, elements) {

            var result = '';
            if (element.type == 'File') result = this.formatFileLink(element);else if (element.type == 'Html') result = this.merge(element.value, elements);else if (element.type == 'LoanAttributes') result = __WEBPACK_IMPORTED_MODULE_9__ElementHelpers__["a" /* default */].loanAttributes();else if (element.type == 'Currency') result = __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].formatCurrency(element.value);else if (element.type == 'Checkbox') result = element.value ? 'Yes' : 'No';else if (element.type == 'Contact') result = __WEBPACK_IMPORTED_MODULE_7__ContactHelpers__["a" /* default */].fullName(element.contact);else if (element.type == 'Outstanding') result = '<b>' + element.text + '</b><br>' + element.response + '<br>';else if (element.type == 'Date' && element.value) result = __WEBPACK_IMPORTED_MODULE_4__DateHelpers__["a" /* default */].convertDate(element.value, __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS, 'EEEE d MMM');else if (element.type == 'DateTime' && element.value) result = __WEBPACK_IMPORTED_MODULE_4__DateHelpers__["a" /* default */].dateTimeToText(element.value);else if (element.type == 'Rating') result = element.value.toString() + ' stars';else if (element.value && element.value.startsWith('http')) result = '<a target="blank" style="color:white;text-decoration:none" href="' + element.value + '"><div @click.stop.prevent style="text-align:center;background-color:#42A5F5;padding:3px 10px 3px 10px;border-radius:13px;font-size:12px;font-weight:500;display:inline-block;max-width:200px;" title="' + element.value + '">' + element.title + '</div></a>';else result = element.value;

            return result;
        }
    }, {
        key: 'formatFileLink',
        value: function formatFileLink(element) {
            return '<a href="' + element.value + '" title="' + element.title + '" style="text-decoration:none"><img width="20" style="vertical-align:middle" src="' + __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].imagePath() + 'pdf-icon.png' + '"/>&nbsp;&nbsp;' + (element.fileName || element.title) + '</a>&nbsp;&nbsp;';
        }
    }, {
        key: 'formatLink',
        value: function formatLink(element) {
            return '<a href="' + element.value + '" style="text-decoration:none"><img width="20" style="vertical-align:middle" src="' + __WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].imagePath() + 'pdf-icon.png' + '"/>&nbsp;&nbsp;' + element.title + '</a>&nbsp;&nbsp;';
        }
    }, {
        key: 'specialField',
        value: function specialField(mergeField, elements) {
            if (mergeField == 'transaction_link') {
                return '<a href="' + window.location.href + '" target="_blank" >Transaction</a>';
            }
            if (mergeField == 'loan_structure') {
                var loanElement = __WEBPACK_IMPORTED_MODULE_10__LoanHelpers__["a" /* default */].loanElement();

                if (loanElement.version == 2) {
                    return loanElement.value;
                } else {
                    var diagramDetails = __WEBPACK_IMPORTED_MODULE_10__LoanHelpers__["a" /* default */].diagramDetails(loanElement.diagram);
                    return __WEBPACK_IMPORTED_MODULE_10__LoanHelpers__["a" /* default */].diagramDescription(diagramDetails);
                }
            }
        }
    }, {
        key: 'formatOutstanding',
        value: function formatOutstanding(mergeField, elements) {
            var _this2 = this;

            var result = {
                replacements: [],
                attachments: [],
                text: ''
            };

            if (mergeField == 'outstandings_to_client') {

                var filteredElements = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Waiting for Client';
                });

                filteredElements.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_sent') {
                var _filteredElements = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Sent';
                });

                _filteredElements.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_settlement') {

                var _filteredElements2 = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Settlement Condition';
                });

                _filteredElements2.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_broker') {

                var _filteredElements3 = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Waiting for Broker';
                });

                _filteredElements3.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_processor') {

                var _filteredElements4 = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Waiting for Processor';
                });

                _filteredElements4.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_lender') {

                var _filteredElements5 = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Lender to Complete';
                });

                _filteredElements5.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_to_lender') {
                var _filteredElements6 = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status == 'Ready to Send';
                });

                _filteredElements6.forEach(function (element) {
                    var outputStr = '<b>' + element.text + '</b>';
                    outputStr += element.response ? '<br>' + element.response : '';
                    var fileElements = __WEBPACK_IMPORTED_MODULE_9__ElementHelpers__["a" /* default */].filesForElement(element, elements);
                    if (fileElements.length) {
                        outputStr += '<br><br>See attached: ';
                        fileElements.forEach(function (fileElement) {
                            outputStr += fileElement.title + ' ';

                            result.attachments.push({
                                path: fileElement.value,
                                name: __WEBPACK_IMPORTED_MODULE_11__FileHelpers__["a" /* default */].fileNameFromStoragePath(fileElement.value)
                            });
                        });
                    }
                    result.replacements.push(outputStr);
                });

                if (result.replacements.length) {
                    result.text = result.replacements.join('<br><br>');
                    return result;
                }
            }

            if (mergeField == 'outstandings') {
                var _filteredElements7 = elements.filter(function (o) {
                    return o.name == 'outstanding' && o.status != 'Sent';
                });

                _filteredElements7.forEach(function (element) {
                    var outputStr = '<b>' + element.text + '</b> (' + element.status + ')';
                    outputStr += element.response ? '<br>' + element.response : '';
                    var fileElements = __WEBPACK_IMPORTED_MODULE_9__ElementHelpers__["a" /* default */].filesForElement(element, elements);
                    outputStr += fileElements.length ? '<br>' : '';
                    fileElements.forEach(function (fileElement) {
                        outputStr += _this2.formatFileLink(fileElement);
                    });
                    result.replacements.push(outputStr);
                });
            }

            if (mergeField == 'outstandings_text') {
                var _filteredElements8 = elements.filter(function (o) {
                    return o.name == 'outstanding';
                });

                _filteredElements8.forEach(function (element) {
                    var outputStr = element.text;
                    result.replacements.push(outputStr);
                });

                if (result.replacements.length) {
                    result.text = result.replacements.join('<br/>');
                    return result;
                }
            }

            if (result.replacements.length) {
                result.text = '<ul><li>' + result.replacements.join('</li><li>') + '</li></ul>';
                result.text = result.text.replace(/'/g, '');
            }

            return result;
        }
    }, {
        key: 'lookup',
        value: function lookup(str) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var match = str.match(/LOOKUP\((.*?)\)/i);

                var _loop = function _loop() {

                    var innerMatch = match[1];
                    var outerMatch = match[0];
                    var innerMatchBrackets = '{{' + innerMatch + '}}';

                    str = str.replace(outerMatch, innerMatchBrackets);

                    if (innerMatch.indexOf('[') < 0) {
                        var ref = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantRef().child('data').child(innerMatch);

                        ref.once('value', function (snap) {
                            var result = snap.val() || '* Not Found *';
                            resolve(str.replace(innerMatchBrackets, result));
                        });
                    } else resolve(str.replace(innerMatchBrackets, '* More Info Needed *'));

                    match = str.match(/LOOKUP\((.*?)\)/i);
                };

                while (match) {
                    _loop();
                }
            });
        }
    }, {
        key: 'isFormula',
        value: function isFormula(str) {
            str = str || '';

            if (str.indexOf("'") > -1 || str.indexOf("[") > -1) return true;

            return false;
        }
    }, {
        key: 'parseFormula',
        value: function parseFormula(str, elements) {

            str = str || '';

            if (!elements || elements.length < 1) {
                return "No elements passed";
            }

            if (!this.isFormula(str)) return str;

            var mergeFields = this.findMergeFields(str);
            var parsedString = this.replaceMergeFields(str, mergeFields, elements);

            try {
                return eval(parsedString);
            } catch (err) {
                console.log('Invalid formula', err);
                return 'Invalid formula';
            }
        }
    }, {
        key: 'findMergeFields',
        value: function findMergeFields(searchString) {

            var matches = {};
            var match = void 0;

            do {
                match = String(searchString).match(/\[(.*?)\]/i);
                if (!match) break;

                var _innerMatch = match[1];
                var outerMatch = match[0];

                matches[_innerMatch] = true;
                searchString = searchString.replace(outerMatch, '');
            } while (match);

            return __WEBPACK_IMPORTED_MODULE_8__Utilities__["a" /* default */].objectToArray(matches);
        }
    }, {
        key: 'replaceMergeFields',
        value: function replaceMergeFields(str, mergeFieldsArray, elements) {
            mergeFieldsArray.forEach(function (mergeField) {
                var matchingObject = elements.find(function (o) {
                    return o.name == mergeField;
                });
                if (matchingObject) {
                    var matchingValue = matchingObject.value;
                    var searchString = '[' + mergeField + ']';
                    str = str.replace(searchString, matchingValue);
                }
            });
            return str;
        }
    }, {
        key: 'getDateMerge',
        value: function getDateMerge(field) {
            today = new Date();
            days = 1000 * 60 * 60 * 24;
            if (field == 'today') return __WEBPACK_IMPORTED_MODULE_4__DateHelpers__["a" /* default */].todayString();else if (field == 'tomorrow') return __WEBPACK_IMPORTED_MODULE_4__DateHelpers__["a" /* default */].tomorrowString();
            return null;
        }
    }, {
        key: 'simpleMerge',
        value: function simpleMerge(text, mergeItems) {
            for (var name in mergeItems) {
                text = text.replace('[' + name + ']', mergeItems[name] || '');
            }
            return text;
        }
    }, {
        key: 'mergeRecord',
        value: function mergeRecord(str, mergeFieldsArray, record) {

            mergeFieldsArray.forEach(function (mergeField) {
                str = str.replace(/=/g, '==').replace(/====/g, '==');
                str = str.replace(/OR/g, '||').replace(/AND/g, '&&');

                str = str.replace('[tenantKey]', __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantKey());

                var replacement = record[mergeField];
                if (replacement != null) str = str.replace('[' + mergeField + ']', replacement);else str = str.replace('[' + mergeField + ']', '"Not found: ' + mergeField + '"');
            });
            return str;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_NumberHelpers__ = __webpack_require__(24);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'moveItem',
        value: function moveItem(arr, fromIndex, toIndex) {
            var element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
        }
    }, {
        key: 'randomFromArray',
        value: function randomFromArray(arr) {
            var random = __WEBPACK_IMPORTED_MODULE_2__helpers_NumberHelpers__["a" /* default */].randomInt(arr.length) - 1;
            return arr[random];
        }
    }, {
        key: 'pushUnique',
        value: function pushUnique(item, array) {
            if (array.indexOf(item) == -1) array.push(item);
        }
    }, {
        key: 'unshiftUnique',
        value: function unshiftUnique(item, array) {
            if (array.indexOf(item) == -1) array.unshift(item);
        }
    }, {
        key: 'deleteItem',
        value: function deleteItem(item, array) {
            var idx = array.indexOf(item);
            if (idx > -1) array.splice(idx, 1);
        }
    }, {
        key: 'textInArray',
        value: function textInArray(text, array) {
            var result = false;
            array.forEach(function (item) {
                if (item.indexOf(text) > -1) result = true;
            });
            return result;
        }
    }, {
        key: 'textContainsAnyItem',
        value: function textContainsAnyItem(text, array) {
            var result = false;
            array.forEach(function (item) {
                if (text.indexOf(item) > -1) result = true;
            });
            return result;
        }
    }, {
        key: 'findByName',
        value: function findByName(arr, name) {
            var obj = arr.find(function (o) {
                return o.name == name;
            });
            if (!obj) {
                console.log('ArrayHelpers > findByName couldnt find the name ' + name + ' in ', arr);
                return null;
            }
            return obj;
        }
    }, {
        key: 'toggleInArray',
        value: function toggleInArray(arr, str) {
            var pos = arr.indexOf(str);
            if (pos > -1) arr.splice(pos, 1);else arr.push(str);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1040)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(2427),
  /* scopeId */
  "data-v-02e4eadc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoanHelpers__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SelectionHelpers__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_NiceData__ = __webpack_require__(15);

















var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'loanAttributes',
        value: function loanAttributes() {
            var attributes = [];
            if (this.getValueFromName('purchase')) attributes.push('Purchase');
            if (this.getValueFromName('first_home')) attributes.push('First Home');
            if (this.getValueFromName('refinance')) attributes.push('Refinance');
            if (this.getValueFromName('guarantor')) attributes.push('Guarantor');
            if (this.getValueFromName('preapproval')) attributes.push('Preapproval');
            return __WEBPACK_IMPORTED_MODULE_8__StringHelpers__["a" /* default */].sentenceJoin(attributes);
        }
    }, {
        key: 'getElements',
        value: function getElements() {
            var elements = __WEBPACK_IMPORTED_MODULE_10__store_Store__["a" /* default */].getters.elements;
            return elements;
        }
    }, {
        key: 'getValueFromName',
        value: function getValueFromName(name) {
            var element = this.getElements().find(function (o) {
                return o.name == name;
            });
            return element ? element.value || '' : '';
        }
    }, {
        key: 'getMasters',
        value: function getMasters(masterKey) {
            var masters = __WEBPACK_IMPORTED_MODULE_10__store_Store__["a" /* default */].getters.masters[masterKey];


            if (!masters) return [];

            return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(masters));
        }
    }, {
        key: 'uniqueName',
        value: function uniqueName(originalName, existingNames) {
            existingNames = existingNames.filter(function (name) {
                return name;
            });
            if (!originalName) return null;
            var name = originalName.replace(/\s|-/g, '_').toLowerCase();
            var baseName = this.getBaseElementName(name);
            var n = 1;
            while (existingNames.find(function (existingName) {
                return existingName == name;
            })) {
                n++;
                name = baseName + '_' + n;
            }
            return name;
        }
    }, {
        key: 'getBaseElementName',
        value: function getBaseElementName(name) {
            if (!name) return null;

            var nameArray = name.split('_');
            if (nameArray.length == 1) return name;

            var lastSegment = nameArray[nameArray.length - 1];
            if (!__WEBPACK_IMPORTED_MODULE_6__NumberHelpers__["a" /* default */].isNumeric(lastSegment)) return name;

            nameArray.splice(nameArray.length - 1, 1);
            return nameArray.join('_');
        }
    }, {
        key: 'contactElementsForRole',
        value: function contactElementsForRole(role, elements) {
            return elements.filter(function (o) {
                return o.role == role && o.type == 'Contact';
            });
        }
    }, {
        key: 'fetchContactsForRole',
        value: function fetchContactsForRole(transactionKey, role) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_13__DataHelpers__["a" /* default */].getTransactionRef(transactionKey).child('elements').orderByChild('type').equalTo('Contact');
                __WEBPACK_IMPORTED_MODULE_14__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (contactElements) {
                    var filteredElements = contactElements.filter(function (o) {
                        return o.role == role;
                    });
                    var contacts = filteredElements.map(function (e) {
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, e.contact, { key: e.meta.key });
                    });
                    resolve(contacts);
                });
            });
        }
    }, {
        key: 'singleContactElementForRole',
        value: function singleContactElementForRole(role, elements) {
            var contactElements = this.contactElementsForRole(role, elements);
            if (contactElements.length == 0) return null;
            return contactElements[0];
        }
    }, {
        key: 'singleContactForRole',
        value: function singleContactForRole(role, elements) {

            var el = this.singleContactElementForRole(role, elements);
            if (el) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, el.contact, { key: el.contactKey, uid: el.contactKey });else return null;
        }
    }, {
        key: 'contactElementsUnique',
        value: function contactElementsUnique(elements) {
            var uniqueElements = [];
            var contactElements = elements.filter(function (o) {
                return o.type == 'Contact';
            });
            contactElements.forEach(function (el) {
                var existingIndex = uniqueElements.findIndex(function (o) {
                    return o.contactKey == el.contactKey;
                });
                if (existingIndex >= 0) {
                    uniqueElements[existingIndex].roles.push(el.role);
                } else uniqueElements.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, el, { roles: [el.role] }));
            });
            return uniqueElements;
        }
    }, {
        key: 'filesForElement',
        value: function filesForElement(element, elements) {

            var linkedFileKeys = element.linkedFileKeys || [];

            var fileElementsOld = elements.filter(function (o) {
                return o.type == 'File' && o.triggerElementKey == element.key;
            });
            fileElementsOld.forEach(function (file) {
                __WEBPACK_IMPORTED_MODULE_7__ArrayHelpers__["a" /* default */].pushUnique(file.key, linkedFileKeys);
            });

            var fileElements = elements.filter(function (element) {
                return element.type == 'File' && linkedFileKeys.indexOf(element.key) > -1;
            });

            return fileElements;
        }
    }, {
        key: 'saveElement',
        value: function saveElement(element) {
            console.log('saveElement', element);
            __WEBPACK_IMPORTED_MODULE_10__store_Store__["a" /* default */].dispatch('saveElement', element);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(2497),
  /* scopeId */
  "data-v-2ee1efbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);






var db = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchItemSingle',
        value: function fetchItemSingle(ref) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var obj = { key: snap.key };
                    for (var fld in snap.val()) {
                        if (!fld.startsWith('_')) {
                            obj[fld] = snap.val()[fld];
                        }
                    }
                    resolve(obj);
                });
            });
        }
    }, {
        key: 'snapToObj',
        value: function snapToObj(snap) {
            var obj = { key: snap.key };
            for (var fld in snap.val()) {
                if (!fld.startsWith('_')) {
                    obj[fld] = snap.val()[fld];
                }
            }
            return obj;
        }
    }, {
        key: 'fetchItems',
        value: function fetchItems(ref) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var returnArr = [];
                    snap.forEach(function (childSnapshot) {
                        var item = childSnapshot.val();
                        item.key = childSnapshot.key;
                        returnArr.push(item);
                    });
                    resolve(returnArr);
                });
            });
        }
    }, {
        key: 'fetchItemsToStore',
        value: function fetchItemsToStore(ref) {
            this.fetchItems(ref).then(function (items) {});
        }
    }, {
        key: 'snapshotToArray',
        value: function snapshotToArray(snapshot) {
            var returnArr = [];

            snapshot.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item.key = childSnapshot.key;
                returnArr.push(item);
            });

            return returnArr;
        }
    }, {
        key: 'saveItem',
        value: function saveItem(item, ref) {
            __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(item, ref);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(21);




__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp({
    apiKey: "AIzaSyDpqlA9Rm67VW6jnC-ZzxYZZNyW3CekVMQ",
    authDomain: "photon-6d209.firebaseapp.com",
    databaseURL: "https://photon-6d209.firebaseio.com",
    projectId: "photon-6d209",
    storageBucket: "photon-6d209.appspot.com",
    messagingSenderId: "729201786634"
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a);

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1093)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(2480),
  /* scopeId */
  "data-v-2264468a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1153)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(2541),
  /* scopeId */
  "data-v-4ff8850b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DataHelpers__ = __webpack_require__(3);















var testEmail = {
    SecureToken: "141b017c-9734-42db-a768-4a8feda70363",
    To: "matt.ireland@mortgagechoice.com.au",
    From: "matt@ireland.mx",
    FromName: 'Matt Ireland',
    ReplyAddress: 'matt.ireland.home@gmail.com',
    Subject: "Testing 456",
    Body: "this is the body (with attachments).",
    Attachments: [{
        name: "MyTestPDF.pdf",
        path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2Fdoc20180928120918.pdf?alt=media&token=ef696acf-5a0a-4e34-b015-46ae670c81b4"
    }, {
        name: "ANZ.jpg",
        path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2FANZ.jpg?alt=media&token=147ca574-4cb8-45a9-a825-d16a67391746"
    }]
};

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'sendTest',
        value: function sendTest() {
            this.sendEmail({
                to: 'matt.ireland@mortgagechoice.com.au',
                from: 'matt@ireland.mx',
                subject: 'Testing ABC',
                body: 'This is a <b>test</b> with html body',
                attachments: [{
                    name: "MyTestPDF.pdf",
                    path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2Fdoc20180928120918.pdf?alt=media&token=ef696acf-5a0a-4e34-b015-46ae670c81b4"
                }, {
                    name: "ANZ.jpg",
                    path: "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-LO0RZ0J2WW6PAhSfLR2%2FANZ.jpg?alt=media&token=147ca574-4cb8-45a9-a825-d16a67391746"
                }]
            }).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__["a" /* default */].showAlert('Email sent with message: ' + result);
            });
        }
    }, {
        key: 'sendEmail',
        value: function sendEmail(email) {
            var self = this;
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var smtpEmail = {
                    SecureToken: "141b017c-9734-42db-a768-4a8feda70363",

                    From: email.from || __WEBPACK_IMPORTED_MODULE_4__store_Store__["a" /* default */].getters.user.email,
                    FromName: email.fromName || __WEBPACK_IMPORTED_MODULE_4__store_Store__["a" /* default */].getters.userFullName,
                    Subject: email.subject,
                    Body: email.body + '<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><div style="text-align:center;padding:20px;color:#bbb;font-size:9px;">This message may contain legally privileged, confidential and/or copyrighted information. If you are not the intended recipient of this message, please immediately notify the sender and delete the email and any attachments, and any copies without dissemination or use. Receipt by an unintended recipient does not waive legal professional privilege. Any views expressed in this message are those of the individual  sender, except where the sender specifically, and with authority, states them to be the views of the sender or a related company. No representation, warranty or guarantee is made that this email or any attachment is free from viruses, errors, interference or other defect. This notice should not be deleted or altered. Message composed and sent via {accountaddress}. <a href="{unsubscribe}" style="color:#bbb!important;font-size:9px">Unsubscribe</a></div>'
                };
                if (email.to) smtpEmail.To = email.to;
                if (email.cc) smtpEmail.Cc = email.cc;
                if (email.bcc) smtpEmail.Bcc = email.bcc;

                if (email.attachments) smtpEmail.Attachments = email.attachments;

                if (email.reply) smtpEmail.ReplyAddress = email.reply;

                Email.send(smtpEmail).then(function (message) {

                    email.result = message;
                    if (message != 'OK') {
                        debugger;
                        __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__["a" /* default */].showAlert('Email failed: ' + message);
                    }

                    resolve(message);
                });

                if (email.copyMe) {
                    debugger;
                    smtpEmail.body = '*** The following was sent to ' + smtpEmail.to.join(',') + '<BR/>' + smtpEmail.body;
                    smtpEmail.to = [__WEBPACK_IMPORTED_MODULE_12__DataHelpers__["a" /* default */].getUserEmail()];
                    smtpEmail.cc = null;
                    smtpEmail.bcc = null;
                    smtpEmail.subject = 'TACO-SENT: ' + smtpEmail.subject;
                }
            });
        }
    }, {
        key: 'sendEmailJS',
        value: function sendEmailJS(email) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var service = email.service || 'default_service';
                var template = 'taco';

                var jsEmail = {};

                if (!email.to || !email.body || !email.subject) {
                    console.error('Invalid email', email);
                    return;
                }

                var attachmentsString = '';

                if (email.attachments && email.attachments.length) {
                    email.attachments.forEach(function (attachment) {
                        var str = '<a href="' + attachment.path + '" style="display:inline-block;padding:10px;border-radius:4px;color:white;background-color:#1c75d2;text-decoration:none;margin:8px;" target="_blank">' + attachment.name + '</a>';
                        attachmentsString += str;
                    });
                }

                jsEmail.body = email.body;
                if (attachmentsString) jsEmail.body = attachmentsString + '<br/><br/>' + jsEmail.body;

                jsEmail.to = email.to;
                jsEmail.subject = email.subject || '';
                jsEmail.from = email.from || _this.Store.getters.user.email;
                jsEmail.reply = email.from;
                jsEmail.fromName = email.fromName || _this.Store.getters.userFullName;

                emailjs.send(service, template, jsEmail).then(function (response) {
                    resolve(response);
                });
            });
        }
    }, {
        key: 'emailViaCloudExtensions',
        value: function emailViaCloudExtensions(to, from, fromName, subject, html, attachments) {

            var attachmentsHtml = this.attachmentsToHtml(attachments);

            var cloudEmail = {
                to: to.join(';'),
                from: '"' + fromName + '"<' + from + '>',
                message: {
                    subject: subject,
                    html: attachmentsHtml + html
                },
                _path: 'mail'
            };
            __WEBPACK_IMPORTED_MODULE_10__data_Firestore__["a" /* default */].saveItem(cloudEmail);
        }
    }, {
        key: 'queueEmail',
        value: function queueEmail(email) {

            var mailLog = {};
            if (email.provider) {
                mailLog.provider = email.provider;
                delete email.provider;
            }

            mailLog.email = email;
            mailLog._path = 'teams/global/collections/mail/data';
            mailLog.statuses = { queued: true, queued_date: new Date() };
            mailLog.activities = [{ event: 'queued', time: new Date() }];
            mailLog._id = __WEBPACK_IMPORTED_MODULE_10__data_Firestore__["a" /* default */].getId();
            __WEBPACK_IMPORTED_MODULE_10__data_Firestore__["a" /* default */].saveItem(mailLog).then(function (result) {}).catch(function (err) {
                console.error(err, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(email));
                __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__["a" /* default */].showAlert(err);
            });
            return mailLog._id;
        }
    }, {
        key: 'attachmentsToHtml',
        value: function attachmentsToHtml(attachments) {
            var attachmentsString = '\n    <div>\n    ';
            attachments.forEach(function (attachment) {
                var str = '\n        <a href="' + attachment.path + '" style="display:inline-block;padding:10px;border-radius:4px;color:white;background-color:#1c75d2;text-decoration:none;margin:8px;" target="_blank">\n            ' + attachment.name + '\n        </a>';
                attachmentsString += str;
            });
            attachmentsString += '</div>';
            return attachmentsString;
        }
    }, {
        key: 'emailButton',
        value: function emailButton(relativePath, text) {
            var path = 'https://taco.insightprocessing.com.au/' + relativePath;
            return '\n    <a href="' + path + '" target="_blank">\n        <button style="background-color:#1c75d2;padding:8px 14px;border-radius:16px;font-size:14px;color:white;font-weight:500;letter-spacing:.0892857143em;justify-content:center;text-transform:uppercase;">\n            ' + text + '\n        </button>\n    </a>';
        }
    }, {
        key: 'createEmail',
        value: function createEmail() {
            var email = {
                to: '',
                cc: '',
                bcc: '',
                from: '',
                fromName: '',
                reply: '',
                subject: '',
                body: ''
            };
            return email;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_NiceData__ = __webpack_require__(15);
















var SETTINGS_COLLECTION = 'teamSettings';

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchUserId',
        value: function fetchUserId() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                console.log('TeamHelpers > fetchUserId');
                var user = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().currentUser;
                if (user) resolve(user.uid);else setTimeout(function () {
                    _this.fetchUserId().then(function (uid) {
                        resolve(uid);
                    });
                }, 300);
            });
        }
    }, {
        key: 'setPrimaryTeam',
        value: function setPrimaryTeam(name) {
            var uid = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getUserId();
            var user = {
                _id: uid,
                _path: 'users',
                primaryTeam: name
            };
            __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].saveItem(user);
        }
    }, {
        key: 'streamUser',
        value: function streamUser(user) {
            var uid = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getUserId();
            var ref = __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].getFirestore().doc('users/' + uid);
            __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].streamDocument(ref, user);
        }
    }, {
        key: 'fetchActiveTeams',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var uid, ref;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.fetchUserId();

                            case 2:
                                uid = _context.sent;
                                ref = __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].getCollectionDocumentRefFromPath('users/' + uid + '/teams').where('active', '==', true);
                                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].fetchCollection(ref));

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchActiveTeams() {
                return _ref.apply(this, arguments);
            }

            return fetchActiveTeams;
        }()
    }, {
        key: 'activateTeam',
        value: function activateTeam(name, primary) {
            var uid = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getUserId();
            var team = {
                _id: name,
                _path: 'users/' + uid + '/teams',
                active: true,
                primary: __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].deleteToken()
            };
            __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].saveItem(team);
        }
    }, {
        key: 'deactivateTeam',
        value: function deactivateTeam(name) {
            var uid = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getUserId();
            var team = {
                _id: name,
                _path: 'users/' + uid + '/teams',
                active: false,
                primary: __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].deleteToken()
            };
            __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].saveItem(team);
        }
    }, {
        key: 'officeNumberToName',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(number) {
                var ref;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                ref = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getRootRef().child('invites/' + number + '/name');
                                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_12__data_NiceData__["a" /* default */].fetchValue(ref));

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function officeNumberToName(_x) {
                return _ref2.apply(this, arguments);
            }

            return officeNumberToName;
        }()
    }, {
        key: 'fetchTeamName',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var officeNumber, officeName, teamName;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                officeNumber = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getTenantKey();
                                _context3.next = 3;
                                return this.officeNumberToName(officeNumber);

                            case 3:
                                officeName = _context3.sent;
                                teamName = __WEBPACK_IMPORTED_MODULE_11__StringHelpers__["a" /* default */].toCamelCase(officeName);
                                return _context3.abrupt('return', teamName);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTeamName() {
                return _ref3.apply(this, arguments);
            }

            return fetchTeamName;
        }()
    }, {
        key: 'saveTeamSettings',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(settings) {
                var officeNumber, officeName;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                officeNumber = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getTenantKey();
                                _context4.next = 3;
                                return this.officeNumberToName(officeNumber);

                            case 3:
                                officeName = _context4.sent;

                                settings._team = __WEBPACK_IMPORTED_MODULE_11__StringHelpers__["a" /* default */].toCamelCase(officeName);
                                settings._collection = SETTINGS_COLLECTION;
                                settings._id = 'settings';

                                __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].saveItem(settings);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function saveTeamSettings(_x2) {
                return _ref4.apply(this, arguments);
            }

            return saveTeamSettings;
        }()
    }, {
        key: 'fetchTeamSettings',
        value: function () {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var _this2 = this;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
                                    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
                                        var officeNumber, officeName, team, ref, settingsArr, settings;
                                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                            while (1) {
                                                switch (_context5.prev = _context5.next) {
                                                    case 0:
                                                        officeNumber = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getTenantKey();
                                                        _context5.next = 3;
                                                        return _this2.officeNumberToName(officeNumber);

                                                    case 3:
                                                        officeName = _context5.sent;
                                                        team = __WEBPACK_IMPORTED_MODULE_11__StringHelpers__["a" /* default */].toCamelCase(officeName);
                                                        ref = __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].getCollectionDataRef(team, SETTINGS_COLLECTION);
                                                        _context5.next = 8;
                                                        return __WEBPACK_IMPORTED_MODULE_7__data_Firestore__["a" /* default */].fetchCollection(ref);

                                                    case 8:
                                                        settingsArr = _context5.sent;
                                                        settings = {};

                                                        if (settingsArr.length) settings = settingsArr[0];
                                                        resolve(settings);

                                                    case 12:
                                                    case 'end':
                                                        return _context5.stop();
                                                }
                                            }
                                        }, _callee5, _this2);
                                    }));

                                    return function (_x3, _x4) {
                                        return _ref6.apply(this, arguments);
                                    };
                                }()));

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTeamSettings() {
                return _ref5.apply(this, arguments);
            }

            return fetchTeamSettings;
        }()
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1092)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(2479),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_storage__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(18);














var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fileToDataUrl',
        value: function fileToDataUrl(file) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var fileReader = new FileReader();
                fileReader.addEventListener('load', function () {
                    resolve(fileReader.result);
                });
                fileReader.readAsDataURL(file);
            });
        }
    }, {
        key: 'storeFiles',
        value: function storeFiles(browserFiles, path, startCallback, statusCallback, finishCallback) {
            var _this = this;

            var uploadList = browserFiles.map(function (file) {
                return {
                    _file: file,
                    name: _this.transformFilename(file.name),
                    size: file.size,
                    type: file.type,
                    lastModified: file.lastModifiedDate,
                    progress: 0
                };
            });

            startCallback(uploadList);

            uploadList.forEach(function (upload) {
                var fileObj = upload._file;
                delete upload._file;
                _this.fileToFirebase(fileObj, path + '/' + upload.name, function (progress) {
                    upload.progress = progress;
                }).then(function (url) {
                    upload.url = url;
                    if (_this.finishedUploading(uploadList)) finishCallback(uploadList);
                });
            });
        }
    }, {
        key: 'finishedUploading',
        value: function finishedUploading(list) {
            var inProgress = list.find(function (o) {
                return !o.url;
            });
            return !Boolean(inProgress);
        }
    }, {
        key: 'filesToFirebase',
        value: function filesToFirebase(files, path) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var uploadCount = 0;
                var fileGroup = [];

                var _loop = function _loop() {
                    var file = files[n];

                    if (file.size > 7500000) {
                        __WEBPACK_IMPORTED_MODULE_10__AlertHelpers__["a" /* default */].showAlert('File size is too big:' + file.name);
                        uploadCount++;
                        if (uploadCount == files.length) resolve(fileGroup);
                        return 'continue';
                    }

                    console.log('Uploading ' + file.name);

                    var fileName = _this2.transformFilename(file.name);

                    _this2.fileToFirebase(file, path + '/' + fileName).then(function (url) {
                        fileGroup.push({
                            url: url,
                            size: file.size,
                            originalName: file.name
                        });
                        uploadCount++;
                        if (uploadCount == files.length) resolve(fileGroup);
                    });
                };

                for (var n = 0; n < files.length; n++) {
                    var _ret = _loop();

                    if (_ret === 'continue') continue;
                }
            });
        }
    }, {
        key: 'fileToFirebase',
        value: function fileToFirebase(file, path, statusCallback) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var uploadTask = __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.storage().ref(path).put(file);

                uploadTask.on('state_changed', function (snapshot) {
                    var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                    if (statusCallback) {
                        statusCallback(Math.round(progress));
                    }
                }, function (err) {}, function () {
                    uploadTask.snapshot.ref.getDownloadURL().then(function (url) {
                        resolve(url);
                    });
                });
            });
        }
    }, {
        key: 'removeFileExtension',
        value: function removeFileExtension(fileName) {
            var arr = fileName.split('.');
            if (arr.length > 1) arr.pop();
            return arr.join('.');
        }
    }, {
        key: 'getFileExtension',
        value: function getFileExtension(fileName) {
            var arr = fileName.split('.');
            if (arr.length < 2) return '';
            return arr[arr.length - 1];
        }
    }, {
        key: 'transformFilename',
        value: function transformFilename(fileName) {
            var result = this.removeFileExtension(fileName);
            result = result.replace(/\W/gi, '-');
            result = result.substring(0, 16);

            result = result + '-' + __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__["a" /* default */].randomString(6);
            result = result + '.' + this.getFileExtension(fileName);
            return result.toLowerCase();
        }
    }, {
        key: 'cleanFilename',
        value: function cleanFilename(fileName) {
            var result = this.removeFileExtension(fileName);
            result = result.replace(/[^a-zA-Z\d\s:]/g, ' ');
            result = __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__["a" /* default */].toTitleCase(result);
            return result;
        }
    }, {
        key: 'fileNameFromStoragePath',
        value: function fileNameFromStoragePath(path) {

            if (!path) return '';

            return path.replace(/\%2F/g, '/').split('/').slice(-1).pop().split('?')[0].replace(/\%20/g, ' ');
        }
    }, {
        key: 'deleteFirebaseFile',
        value: function deleteFirebaseFile(url) {
            var ref = __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.storage().refFromURL(url);
            ref.delete();
        }
    }, {
        key: 'downloadObject',
        value: function downloadObject(exportObj, exportName) {
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(exportObj));
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href", dataStr);
            downloadAnchorNode.setAttribute("download", exportName + ".json");
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);









var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'unshiftUnique',
        value: function unshiftUnique(array, object) {
            var idx = array.findIndex(function (o) {
                return o.key == object.key;
            });
            if (idx == -1) array.unshift(object);
        }
    }, {
        key: 'prepareSave',
        value: function prepareSave(obj) {
            var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
            if (!newObj.key) {
                newObj.key = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getKey();
            }
            newObj.stamp = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getStamp();
            return newObj;
        }
    }, {
        key: 'save',
        value: function save(obj, arr, position) {
            if (this.update(obj, arr)) return;

            var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
            if (position === 0) arr.unshift(newObj);else arr.push(newObj);
        }
    }, {
        key: 'update',
        value: function update(obj, arr) {
            var idx = arr.findIndex(function (o) {
                return o.key == (obj.key || obj.meta.key);
            });
            if (idx >= 0) {
                var existingObj = arr[idx];
                var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existingObj, obj);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(arr, idx, newObj);
                return true;
            } else return false;
        }
    }, {
        key: 'saveToArray',
        value: function saveToArray(obj, arr, position) {
            var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
            newObj.key = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getKey();
            newObj.stamp = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getStamp();
            if (position == 0) arr.unshift(newObj);else arr.push(newObj);
            return newObj;
        }
    }, {
        key: 'delete',
        value: function _delete(obj, arr) {

            var idx = arr.findIndex(function (o) {
                return o.key == (obj.key || obj.meta.key);
            });
            if (idx >= 0) arr.splice(idx, 1);else __WEBPACK_IMPORTED_MODULE_5__Utilities__["a" /* default */].log('ListHelpers > delete > Cant find object', obj);
        }
    }, {
        key: 'selectSingle',
        value: function selectSingle(obj, array) {
            var previouslySelected = Boolean(obj.selected);

            this.unselectAll(array);
            this.changeSelection(obj, !previouslySelected);
        }
    }, {
        key: 'selectMulti',
        value: function selectMulti(obj) {
            this.changeSelection(obj);
        }
    }, {
        key: 'selectRange',
        value: function selectRange(obj, array) {
            var selectedItems = this.getSelectedItems(array);
            if (selectedItems.length < 1) {
                this.changeSelection(obj);
                return;
            }
            var lastSelected = selectedItems[selectedItems.length - 1];
            var index1 = array.indexOf(lastSelected);
            var index2 = array.indexOf(obj);

            var lowerIndex = Math.min(index1, index2);
            var upperIndex = Math.max(index1, index2);

            for (var n = lowerIndex; n <= upperIndex; n++) {
                var _obj = array[n];
                this.changeSelection(_obj, true);
            }
        }
    }, {
        key: 'changeSelection',
        value: function changeSelection(obj, value) {
            if (value == null) value = !Boolean(obj.selected);

            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(obj, 'selected', value);
        }
    }, {
        key: 'getSelectedItems',
        value: function getSelectedItems(array) {
            return array.filter(function (o) {
                return o.selected;
            });
        }
    }, {
        key: 'unselectAll',
        value: function unselectAll(array) {
            var _this = this;

            this.getSelectedItems(array).forEach(function (item) {
                _this.changeSelection(item, false);
            });
        }
    }, {
        key: 'selectedOrClicked',
        value: function selectedOrClicked(obj, selectedObjects) {
            var idx = selectedObjects.findIndex(function (o) {
                return o.key == obj.key;
            });
            if (idx >= 0) return selectedObjects;else return [obj];
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1158)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(2546),
  /* scopeId */
  "data-v-51b5d3d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_Store__ = __webpack_require__(31);






var ScrollHelpers = function () {
    function ScrollHelpers() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ScrollHelpers);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ScrollHelpers, null, [{
        key: 'officesList',
        value: function officesList() {
            var offices = [];
            var userKey = __WEBPACK_IMPORTED_MODULE_4__store_Store__["a" /* default */].getters.uid;
            if (userKey) {
                var ref = __WEBPACK_IMPORTED_MODULE_2__DataHelpers__["a" /* default */].getRootRef().child('users').child(userKey).child('offices');
                console.log('UserHelpers > officesList > Ref', ref.toString());
                ref.on('value', function (snap) {
                    offices = __WEBPACK_IMPORTED_MODULE_3__FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                });
            }
            return offices;
        }
    }, {
        key: 'scrollStop',
        value: function scrollStop(el, callback) {
            if (!callback || typeof callback !== 'function') return;

            var isScrolling;

            el.addEventListener('scroll', function (event) {
                window.clearTimeout(isScrolling);

                isScrolling = setTimeout(function () {
                    callback();
                }, 700);
            }, false);
        }
    }, {
        key: 'isElementInViewport',
        value: function isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        }
    }, {
        key: 'getFirstVisibleElement',
        value: function getFirstVisibleElement(parent, className) {
            var children = parent.getElementsByClassName(className);
            for (var n = 0; n < children.length; n++) {
                var child = children[n];
                if (this.isElementInViewport(child)) {
                    return child;
                }
            }
            return null;
        }
    }]);

    return ScrollHelpers;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScrollHelpers);

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1121)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(2509),
  /* scopeId */
  "data-v-3a8907b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1069)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(2456),
  /* scopeId */
  "data-v-13105211",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_Store__ = __webpack_require__(31);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'setPageData',
        value: function setPageData(name, value) {
            __WEBPACK_IMPORTED_MODULE_2__store_Store__["a" /* default */].commit('setPageData', { name: name, value: value });
        }
    }, {
        key: 'getPageData',
        value: function getPageData(name) {
            return __WEBPACK_IMPORTED_MODULE_2__store_Store__["a" /* default */].getters.getPageData(name);
        }
    }, {
        key: 'clearPageData',
        value: function clearPageData() {
            __WEBPACK_IMPORTED_MODULE_2__store_Store__["a" /* default */].commit('clearPageData');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1107)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(2495),
  /* scopeId */
  "data-v-2d3c1e21",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1127)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(2515),
  /* scopeId */
  "data-v-3da9a6ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1108)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(2496),
  /* scopeId */
  "data-v-2e08d1b5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(2601),
  /* scopeId */
  "data-v-72ee5eea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1249)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(2638),
  /* scopeId */
  "data-v-a60e0b6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__ = __webpack_require__(24);









var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'loanElement',
        value: function loanElement() {

            var loanElement = __WEBPACK_IMPORTED_MODULE_4__store_Store__["a" /* default */].getters.elements.find(function (o) {
                return o.widget == 'Loan Diagram';
            });
            if (!loanElement) loanElement = {
                diagram: [{ loans: [], properties: [] }]
            };
            return loanElement;
        }
    }, {
        key: 'allLoans',
        value: function allLoans() {

            var loans = [];

            var groups = this.loanDiagram();
            groups.forEach(function (group) {
                loans = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(loans), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(group.loans));
            });
            return loans;
        }
    }, {
        key: 'newMoney',
        value: function newMoney() {
            var total = 0;
            this.allLoans.forEach(function (loan) {
                var amt = loan.newMoney;

                if (!amt) {
                    amt = loan.amount;
                    if (loan.lmiType == 'Capitalised') amt += loan.lmi;
                }
                total += amt;
            });
            return total;
        }
    }, {
        key: 'allProperties',
        value: function allProperties() {
            var properties = [];
            this.loanDiagram().forEach(function (group) {
                properties = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(properties), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(group.properties));
            });
            return properties;
        }
    }, {
        key: 'anyFixedLoans',
        value: function anyFixedLoans() {
            return Boolean(this.allLoans().find(function (o) {
                return o.fixed > 0;
            }));
        }
    }, {
        key: 'anyioLoans',
        value: function anyioLoans() {
            return Boolean(this.allLoans().find(function (o) {
                return o.io > 0;
            }));
        }
    }, {
        key: 'anyLMI',
        value: function anyLMI() {
            return Boolean(this.allLoans().find(function (o) {
                return o.lmiType == 'Capitalised' || o.lmiType == 'Included';
            }));
        }
    }, {
        key: 'anyOwnerOccupied',
        value: function anyOwnerOccupied() {
            return Boolean(this.allProperties().find(function (o) {
                return !o.investment;
            }));
        }
    }, {
        key: 'anyInvestmentProperties',
        value: function anyInvestmentProperties() {
            return Boolean(this.allProperties().find(function (o) {
                return o.investment;
            }));
        }
    }, {
        key: 'totalLending',
        value: function totalLending() {
            return this.allLoans().reduce(function (a, b) {
                return a + b.amount;
            }, 0);
        }
    }, {
        key: 'diagramDetails',
        value: function diagramDetails(diagramData) {
            return diagramData.map(function (group) {
                var returnGroup = {
                    propertyTotal: group.properties.map(function (o) {
                        return o.value;
                    }).reduce(function (a, b) {
                        return a + b;
                    }),

                    loanTotal: group.loans.map(function (o) {
                        return o.amount;
                    }).reduce(function (a, b) {
                        return a + b;
                    })
                };

                var returnLoans = group.loans.map(function (loan) {

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, loan, {
                        meta: {
                            width: Math.round(loan.amount / returnGroup.propertyTotal * 10000) / 100,
                            get title() {
                                var result = this.amountDescription;
                                if (loan.rate) result += ' @ ' + loan.rate.toString() + '%';
                                if (loan.years && loan.years < 30) result += ' over ' + loan.years.toString() + 'yrs';
                                return result;
                            },
                            get description() {
                                var result = '';

                                result += loan.newMoney ? ' New:' + __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__["a" /* default */].abbreviateNumber(loan.newMoney) : '';
                                result += loan.investment ? ' Investment' : ' Owner occupied';
                                result += loan.fixed ? ' ' + loan.fixed + 'y fixed' : ' variable';
                                result += loan.rateLock ? ' RATE LOCK' : '';
                                result += loan.io ? ', ' + loan.io + 'y IO' : ', P&I';
                                result += loan.product ? ' - ' + loan.product : '';
                                if (!loan.years || loan.years == 30) result += ' over 30 years';

                                return result;
                            },
                            get amountTotal() {
                                if (!loan.lmi || loan.lmiType == 'Included') return loan.amount;

                                return loan.amount + loan.lmi;
                            },

                            get amountBase() {
                                if (!loan.lmi || loan.lmiType == 'Capitalised') return loan.amount;

                                return loan.amount - loan.lmi;
                            },

                            get amountDescription() {
                                var result = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].formatCurrency(this.amountTotal);
                                if (loan.lmi) {
                                    result += ' (' + __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__["a" /* default */].abbreviateNumber(this.amountBase) + ' + ' + __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__["a" /* default */].abbreviateNumber(loan.lmi) + ' lmi)';
                                }
                                return result;
                            }
                        }
                    });
                });

                var returnProperties = group.properties.map(function (property) {

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, property, {
                        meta: {
                            width: Math.round(property.value / returnGroup.propertyTotal * 10000) / 100,
                            get description() {
                                var result = '';
                                if (property.address) result += property.address;
                                if (property.investment) result += ' (INV)';else result += ' (HOME)';
                                if (property.existing) result += ' (EXISTING)';
                                return result;
                            }
                        }
                    });
                });

                returnGroup.loans = returnLoans;
                returnGroup.properties = returnProperties;
                returnGroup.lvr = Math.round(returnGroup.loanTotal / returnGroup.propertyTotal * 10000) / 100;

                return returnGroup;
            });
        }
    }, {
        key: 'diagramDescription',
        value: function diagramDescription(diagramData) {

            var html = '';
            diagramData.forEach(function (group, groupIndex) {
                if (diagramData.length > 1) html += '<b><u>Transaction ' + (groupIndex + 1) + '</u></b><br/>';
                group.loans.forEach(function (loan, loanIndex) {
                    html += '<b>' + loan.meta.title + '</b><br/>';
                    html += '- ' + loan.meta.description;
                    if (loan.product) html += ' | ' + loan.product;
                    html += '<br/>';
                });
                html += '<b>Security</b><br/>';
                group.properties.forEach(function (property, index) {
                    html += __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].formatCurrency(property.value);
                    if (property.address) html += ' - ' + property.address;
                    html += '&nbsp;(' + (property.investment ? 'INV' : 'OO') + (property.existing ? '/EXISTING' : '') + ')';
                    html += '<br/>';
                });
                html += '<br/>';
            });

            html = html.wrap('<div>', '</div>');
            return html;
        }
    }, {
        key: 'diagramPicture',
        value: function diagramPicture(diagramData) {
            var _this = this;

            var html = '';
            diagramData.forEach(function (group) {
                html += '<div style="margin:2px 0px;border:dotted 3px #ddd;border-radius:8px"><table style="width:100%"><tr>';
                group.loans.forEach(function (loan) {
                    html += '<td style="' + _this.generateLoanStyle(loan) + '" \n                    title="' + loan.meta.title + ' | ' + loan.meta.description + '">\n                    ' + __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__["a" /* default */].abbreviateNumber(loan.meta.amountTotal) + '</td>';
                });

                html += '<td style="border:solid 2px white;padding:4px 6px;width:' + (100 - group.lvr) + ';border-radius:7px;%">' + group.lvr + '%</td>';

                html += '</tr></table><table style="width:100%"><tr>';
                group.properties.forEach(function (property) {
                    html += '<td style="' + _this.generatPropertyStyle(property) + '" title="' + property.meta.description + '">\n                    ' + __WEBPACK_IMPORTED_MODULE_6__NumberHelpers__["a" /* default */].abbreviateNumber(property.value) + ' \n                    </td>';
                });

                html += '</tr></table></div>';
            });

            html = html.wrap('<div style="max-width:400px;">', '</div>');
            return html;
        }
    }, {
        key: 'generateLoanStyle',
        value: function generateLoanStyle(loan) {
            var style = 'border:solid 2px white;color:white;padding:4px 6px;border-radius:7px;';
            if (loan.investment) style += 'background-color:#5c6bc0;';else style += 'background-color:#42a5f5;';
            style += "width:" + loan.meta.width + '%;';
            return style;
        }
    }, {
        key: 'generatPropertyStyle',
        value: function generatPropertyStyle(property) {
            var style = 'border: solid 2px white;color:white;padding:4px 6px;border-radius:7px;';
            if (property.investment) style += 'background-color:#ef6c00;';else style += 'background-color:#ff9800;';
            style += "width:" + property.meta.width + '%;';
            return style;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_Store__ = __webpack_require__(31);






var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'setQueryParameter',
        value: function setQueryParameter(context, parameter, value) {
            var newQuery = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, context.$route.query);
            newQuery[parameter] = value;
            context.$router.replace({ query: newQuery });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_NiceData__ = __webpack_require__(15);









var db = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchTemplate',
        value: function fetchTemplate(tenantKey, templateName) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = void 0;
                if (tenantKey == 'global') ref = __WEBPACK_IMPORTED_MODULE_6__DataHelpers__["a" /* default */].getRootRef().child('app').child('templates').orderByChild('name').equalTo(templateName);else ref = __WEBPACK_IMPORTED_MODULE_6__DataHelpers__["a" /* default */].getTenantRef(tenantKey).child('templates').orderByChild('name').equalTo(templateName);

                ref.once('value', function (snap) {
                    var templates = __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
                    var template = void 0;
                    if (templates.length < 1) template = null;else if (templates.length > 1) {
                        template = templates[0];
                        console.log('fetchTemplate > duplicate templates found, but continuing...', templates);
                    } else template = templates[0];

                    resolve(template);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__ = __webpack_require__(6);
















var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'savePageValues',
        value: function savePageValues(page) {

            if (!page.rowKey) {
                console.log('savePageValues > No row key provided');
            }

            var table = page.table || 'temp';
            var rowKey = page.rowKey;
            var scope = page.scope || 'local';

            var row = {};
            page.elements.forEach(function (element) {
                row[element.fieldPos] = element.value;
            });

            var ref = this.fbRef(this.tablePath(scope, table) + '/data/' + rowKey);

            ref.set(row);

            console.log('ScreenData > savePageValues saved to:', __WEBPACK_IMPORTED_MODULE_13__helpers_FirebaseHelpers__["a" /* default */].firebaseConsolePathFromRefString(ref.toString()));
        }
    }, {
        key: 'pageToRecord',
        value: function pageToRecord(page) {
            var row = {};
            page.elements.forEach(function (field) {
                row[field.name] = field.value;
            });
            return row;
        }
    }, {
        key: 'tablePath',
        value: function tablePath(scope, table) {
            return 'tables' + '/' + scope + '/' + table;
        }
    }, {
        key: 'globalTablePath',
        value: function globalTablePath(table) {
            return this.tablePath('global', table);
        }
    }, {
        key: 'fbRef',
        value: function fbRef(path) {
            return __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.database().ref(path);
        }
    }, {
        key: 'deleteRecord',
        value: function deleteRecord(scope, table, rowKey) {
            var ref = this.fbRef(this.tablePath(scope, table)).child('data').child(rowKey);
            ref.remove();
        }
    }, {
        key: 'deleteRecordSafely',
        value: function deleteRecordSafely(scope, table, rowKey) {
            var ref = this.fbRef(this.tablePath(scope, table)).child('data').child(rowKey);
            ref.remove();
        }
    }, {
        key: 'saveFieldValue',
        value: function saveFieldValue(scope, table, rowKey, fieldName, value) {

            var tableRef = this.fbRef(this.tablePath(scope, table));
            var fieldRef = tableRef.child('fields').orderByChild('fieldName').equalTo(fieldName);
            fieldRef.once('value', function (snap) {
                var field = __WEBPACK_IMPORTED_MODULE_13__helpers_FirebaseHelpers__["a" /* default */].snapshotToObject(snap);
                if (field) {
                    var storageKey = field.fieldPos;
                    console.log('storing to field called ' + storageKey);
                    var dataRef = tableRef.child('data').child(rowKey).child(storageKey);
                    console.log('saveFieldValue', dataRef.toString(), value);
                    dataRef.set(value);
                }
            });
        }
    }, {
        key: 'injectTable',
        value: function injectTable(table, parameters) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var tablePath = _this.tablePath(parameters.scope, parameters.table);
                var fieldRef = _this.fbRef(tablePath + '/fields');
                var dataRef = _this.fbRef(tablePath + '/data');

                var startTime = new Date();

                fieldRef.on('value', function (snap) {
                    var fields = _this.snapshotToCollection(snap);

                    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(table, 'fields', fields);

                    if (parameters.orderBy) {
                        var fbOrderBy = __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].getPropertySafely(table.fields.find(function (o) {
                            return o.fieldName == parameters.orderBy;
                        }), 'fieldPos');

                        dataRef = dataRef.orderByChild(fbOrderBy);
                        if (parameters.startAt) dataRef = dataRef.startAt(parameters.startAt);
                        if (parameters.endAt) dataRef = dataRef.endAt(parameters.endAt);
                    }

                    dataRef = dataRef.limitToFirst(parameters.limit || 200);
                    dataRef.on('value', function (snap) {
                        var records = _this.snapshotToArrayTranslated(snap, table.fields);
                        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].set(table, 'records', records);
                        var endTime = new Date();

                        var result = {
                            path: __WEBPACK_IMPORTED_MODULE_13__helpers_FirebaseHelpers__["a" /* default */].firebasePathFromRefString(dataRef.toString()),
                            count: records.length,
                            time: (endTime - startTime).toString() + 'ms'
                        };
                        resolve(result);
                    });
                }, function (error) {
                    console.error(error);
                    reject(error);
                    debugger;
                });
            });
        }
    }, {
        key: 'tableDataToDisplay',
        value: function tableDataToDisplay(tableData) {
            var _this2 = this;

            var toArray = [];
            tableData.records.forEach(function (record) {
                var properties = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tableData.fields);
                var toObj = {};
                properties.forEach(function (property) {
                    var value = record[property];
                    var type = tableData.fields[property].type;
                    toObj[property] = _this2.formatForDisplay(value, type);
                });
                toArray.push(toObj);
            });

            return {
                fields: tableData.fields,
                records: toArray
            };
        }
    }, {
        key: 'formatForDisplay',
        value: function formatForDisplay(value, type) {
            if (typeof value === 'undefined') return '';

            if (type == 'Date') return __WEBPACK_IMPORTED_MODULE_10__helpers_DateHelpers__["a" /* default */].backwardsToAu(value);
            if (type == 'Currency') return __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].formatCurrency(value);
            if (type == 'Contact') return __WEBPACK_IMPORTED_MODULE_12__helpers_ContactHelpers__["a" /* default */].fullName(value);
            return value;
        }
    }, {
        key: 'snapshotToArrayTranslated',
        value: function snapshotToArrayTranslated(snap, fields) {
            var toArray = [];
            snap.forEach(function (childSnapshot) {
                var toRecord = {};

                var fromRecord = childSnapshot.val();

                var _loop = function _loop(prop) {
                    var field = fields.find(function (o) {
                        return o.fieldPos == prop;
                    });

                    var value = fromRecord[prop];

                    toRecord[field.fieldName] = value;
                };

                for (var prop in fromRecord) {
                    _loop(prop);
                }
                toRecord.key = childSnapshot.key;
                toArray.push(toRecord);
            });
            return toArray;
        }
    }, {
        key: 'translateFields',
        value: function translateFields(fieldObject) {

            var toObject = {};
            for (var prop in fieldObject) {
                var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldObject[prop]);
                var name = obj.name;
                delete obj.name;
                obj.fieldPos = prop;
                obj.title = obj.title || __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].snakeToNormal(name);
                toObject[name] = obj;
            }
            return toObject;
        }
    }, {
        key: 'createTableDataProperties',
        value: function createTableDataProperties() {
            return {
                scope: null,
                table: null,
                orderBy: null,
                startAt: null,
                endAt: null
            };
        }
    }, {
        key: 'snapshotToCollection',
        value: function snapshotToCollection(snap) {
            var returnArr = [];
            snap.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item['.key'] = childSnapshot.key;
                returnArr.push(item);
            });
            return returnArr;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(2574),
  /* scopeId */
  "data-v-5f24e749",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1264)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(2653),
  /* scopeId */
  "data-v-c23c0fba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(2584),
  /* scopeId */
  "data-v-693ba0ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1080)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(2467),
  /* scopeId */
  "data-v-18a82a3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1157)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(2545),
  /* scopeId */
  "data-v-5189337a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(2606),
  /* scopeId */
  "data-v-74cbb23a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(2594),
  /* scopeId */
  "data-v-6e15ec35",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Firestore__ = __webpack_require__(27);









var fs = __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.firestore();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this._items = [];
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'ref',
        value: function ref(path) {
            this._path = path;
            var segments = path.split('/');
            var numSegments = segments.length;

            if (__WEBPACK_IMPORTED_MODULE_6__helpers_NumberHelpers__["a" /* default */].isOdd(numSegments)) {
                this._baseRef = fs.collection(path);
                this._ref = this._baseRef;
                this._single = false;
            } else {
                    var base = segments.slice(0, numSegments - 1).join('/');
                    this._id = segments[numSegments - 1];
                    this._baseRef = fs.collection(base);
                    this._ref = this._baseRef.doc(this._id);
                    this._single = true;
                }
            return this;
        }
    }, {
        key: 'where',
        value: function where(field, operator, val) {
            this._ref = this._baseRef.where(field, operator, val);
            return this;
        }
    }, {
        key: 'fetch',
        value: function fetch() {
            var _this = this;

            var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (_this._single) {
                    _this._ref.get().then(function (doc) {
                        if (doc.exists) {
                            Vue.set(_this, '_item', doc.data());
                            resolve(doc.data());
                        } else {
                            _this._item = {};
                            resolve({});
                        }
                    });
                } else {
                    _this._ref.limit(limit).get().then(function (snap) {

                        snap.forEach(function (doc) {
                            var item = __WEBPACK_IMPORTED_MODULE_7__Firestore__["a" /* default */].convertDates(doc.data());
                            item._id = doc.id;
                            item._db = _this;
                            _this._items.push(item);
                        });
                        resolve(_this._items);
                    });
                }
            });
        }
    }, {
        key: 'saveItem',
        value: function saveItem(item) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var id = item._id;
            item = prepareItemForStorage(item);
            if (options.timestamp) __WEBPACK_IMPORTED_MODULE_7__Firestore__["a" /* default */].addTimestamp(item);
            if (options.author) __WEBPACK_IMPORTED_MODULE_7__Firestore__["a" /* default */].addAuthor(item);
            if (options.owner) __WEBPACK_IMPORTED_MODULE_7__Firestore__["a" /* default */].addOwner(item);

            console.log('Db.saveItem is saving...', item);

            this._baseRef.doc(id).set(item);
        }
    }, {
        key: 'items',
        get: function get() {
            return this._items || [];
        },
        set: function set(newVal) {
            this._items = newVal;
        }
    }, {
        key: 'item',
        get: function get() {
            return this._item || {};
        },
        set: function set(newVal) {
            this._item = newVal;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);


var prepareItemForStorage = function prepareItemForStorage(obj) {
    var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
    for (var prop in newObj) {
        if (prop.substr(0, 1) == '_') delete newObj[prop];
    }
    return newObj;
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Security__ = __webpack_require__(138);














var fs = __WEBPACK_IMPORTED_MODULE_7_firebase_app___default.a.firestore();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchDocument',
        value: function fetchDocument(docPath, id) {
            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = fs.doc(docPath + '/' + id);
                ref.get().then(function (doc) {

                    if (doc.exists) {
                        resolve(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, doc.data(), {
                            _id: doc.id,
                            _path: docPath
                        }));
                    } else {
                        resolve(null);
                    }
                }).catch(function (err) {
                    __WEBPACK_IMPORTED_MODULE_11__helpers_AlertHelpers__["a" /* default */].showAlert(err.message);
                    console.log('Error during fetchDocument', err);
                    reject(err.message);
                });
            });
        }
    }, {
        key: 'fetchCollection',
        value: function fetchCollection(collectionPath) {
            var _this = this;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var ref, whereArr;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    ref = fs.collection(collectionPath);
                                    whereArr = options.where || [];

                                    whereArr.forEach(function (where) {
                                        ref = ref.where(where.field, where.operator, where.value);
                                    });

                                    ref.get().then(function (snap) {
                                        var arr = [];
                                        snap.forEach(function (doc) {
                                            var newItem = doc.data();
                                            newItem._id = doc.id;
                                            newItem._path = collectionPath;
                                            arr.push(newItem);
                                        });
                                        resolve(arr);
                                    });

                                case 4:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x2, _x3) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'fetchDocumentByCode',
        value: function fetchDocumentByCode(collectionPath, code) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
                    var items;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.next = 2;
                                    return _this2.fetchCollection(collectionPath, { where: [{ field: 'code', operator: '==', value: code }] });

                                case 2:
                                    items = _context2.sent;

                                    if (items && items.length) resolve(items[0]);else resolve(null);

                                case 4:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this2);
                }));

                return function (_x4, _x5) {
                    return _ref2.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'saveDocument',
        value: function saveDocument(doc) {
            var docPath = doc._path + '/' + doc._id;
            doc = prepareItemForStorage(doc);
            var ref = fs.doc(docPath);
            console.groupCollapsed('saveDocument');
            console.log('saveDocument', doc);
            console.log(this.getConsolePath(docPath));
            console.groupEnd();
            ref.set(doc, { merge: true });
        }
    }, {
        key: 'newId',
        value: function newId() {
            return fs.collection('teams').doc().id;
        }
    }, {
        key: 'me',
        value: function me() {
            return __WEBPACK_IMPORTED_MODULE_7_firebase_app___default.a.auth().currentUser;
        }
    }, {
        key: 'getConsolePath',
        value: function getConsolePath(docPath) {
            var base = 'https://console.firebase.google.com/u/0/project/photon-6d209/firestore/data';
            return base + (docPath ? '/' + docPath : '');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);


var prepareItemForStorage = function prepareItemForStorage(obj) {
    var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
    for (var prop in newObj) {
        if (prop.substr(0, 1) == '_') delete newObj[prop];
    }
    return newObj;
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_functions__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StringHelpers__ = __webpack_require__(5);









var CloudHelpers = function () {
    function CloudHelpers() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CloudHelpers);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CloudHelpers, null, [{
        key: 'validateEmail',
        value: function validateEmail(email) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!__WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].isEmail(email)) {
                    resolve('Invalid email format');
                    return;
                }

                console.log('Validating');

                var validateEmail = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.functions().httpsCallable('validateEmail');
                validateEmail(email).then(function (response) {
                    if (response.data.result == 'valid') {
                        console.log('Valid');
                        resolve('');
                    } else {
                        console.log(response.data.message);
                        resolve(response.data.message);
                    }
                }).catch(function (err) {
                    console.log(err);
                    resolve(err);
                });
            });
        }
    }, {
        key: 'getGender',
        value: function getGender(firstName) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!firstName) {
                    resolve('');
                    return;
                }

                var getGender = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.functions().httpsCallable('getGender');
                getGender(firstName).then(function (response) {
                    resolve(__WEBPACK_IMPORTED_MODULE_6__StringHelpers__["a" /* default */].capitalizeFirstLetter(response.data));
                }).catch(function (err) {
                    resolve('');
                });
            });
        }
    }]);

    return CloudHelpers;
}();

/* harmony default export */ __webpack_exports__["a"] = (CloudHelpers);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'isSectionValid',
        value: function isSectionValid(section) {
            var valid = true;
            section.fields.forEach(function (field) {

                if (field.required && !field.value) {
                    valid = false;
                    return;
                }
            });
            return valid;
        }
    }, {
        key: 'isPageValid',
        value: function isPageValid(page) {
            var _this = this;

            var valid = true;
            page.sections.forEach(function (section) {
                if (!_this.isSectionValid(section)) {
                    valid = false;
                    return;
                }
            });
            return valid;
        }
    }, {
        key: 'getSectionField',
        value: function getSectionField(section, name) {
            return section.fields.find(function (o) {
                return o.name == name;
            }) || null;
        }
    }, {
        key: 'parseOptions',
        value: function parseOptions(options) {
            if (!options) return [];
            if (Array.isArray(options)) return options;

            return (options || String('')).split(',').map(function (s) {
                return s.trim();
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1156)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(2544),
  /* scopeId */
  "data-v-50eee856",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1042)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(2429),
  /* scopeId */
  "data-v-03293a14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1177)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(2565),
  /* scopeId */
  "data-v-5b7e4c2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1075)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(2462),
  /* scopeId */
  "data-v-15d72344",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1098)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(2485),
  /* scopeId */
  "data-v-23c85a38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(2522),
  /* scopeId */
  "data-v-402879e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(2576),
  /* scopeId */
  "data-v-5ff903c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_FirebaseHelpers__ = __webpack_require__(14);









var db = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchContactSingle',
        value: function fetchContactSingle(contactKey) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contacts');
                __WEBPACK_IMPORTED_MODULE_5__FireData__["a" /* default */].fetchItemSingle(ref.child(contactKey)).then(function (contact) {
                    resolve(contact);
                });
            });
        }
    }, {
        key: 'fetchUsers',
        value: function fetchUsers() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var r = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef();
                console.log('tenant is ', r.toString());
                var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contacts').orderByChild('user').equalTo(true);
                __WEBPACK_IMPORTED_MODULE_5__FireData__["a" /* default */].fetchItems(ref).then(function (users) {
                    users.forEach(function (user) {
                        user.uid = user.key;
                    });
                    resolve(users);
                });
            });
        }
    }, {
        key: 'fetchContactsForRole',
        value: function fetchContactsForRole(role) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contacts');

                if (role) ref = ref.orderByChild('groups/' + role).equalTo(true);else ref = ref.orderByChild('user').equalTo(true);

                ref = ref.limitToFirst(20);

                ref.once('value', function (snap) {
                    var elements = _this.snapshotToArray(snap);
                    resolve(elements.filter(function (c) {
                        return c.user;
                    }));
                });
            });
        }
    }, {
        key: 'snapshotToArray',
        value: function snapshotToArray(snapshot) {
            var returnArr = [];
            snapshot.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item.key = childSnapshot.key;
                item.uid = childSnapshot.key;
                item.meta = {
                    key: childSnapshot.key
                };
                returnArr.push(item);
            });

            return returnArr;
        }
    }, {
        key: 'contactTransactionAdd',
        value: function contactTransactionAdd(contactKey, transactionKey) {
            var transactionRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('transactions').child(transactionKey).child('details');
            __WEBPACK_IMPORTED_MODULE_5__FireData__["a" /* default */].fetchItemSingle(transactionRef).then(function (transaction) {
                transaction.key = transactionKey;
                var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contactTransactions').child(contactKey);
                __WEBPACK_IMPORTED_MODULE_5__FireData__["a" /* default */].saveItem(transaction, ref);
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__ = __webpack_require__(12);










var fs = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.firestore();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getMyId',
        value: function getMyId() {
            var user = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser;
            if (user) return __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().currentUser.uid;else return null;
        }
    }, {
        key: 'canWrite',
        value: function canWrite(doc, uid) {
            if (!doc || !doc.permissions || !doc.permissions.editors) return false;

            if (!uid) uid = this.getMyId();

            if (!uid) return false;

            return Boolean(doc.permissions.editors.indexOf(uid) > -1);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);


var prepareItemForStorage = function prepareItemForStorage(obj) {
    var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
    for (var prop in newObj) {
        if (prop.substr(0, 1) == '_') delete newObj[prop];
    }
    return newObj;
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_Store__ = __webpack_require__(31);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'setApplicationData',
        value: function setApplicationData(name, value) {
            __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('setApplicationData', { name: name, value: value });
        }
    }, {
        key: 'getApplicationData',
        value: function getApplicationData(name) {
            return __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].getters.getApplicationData(name);
        }
    }, {
        key: 'clearApplicationData',
        value: function clearApplicationData() {
            __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('clearApplicationData');
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var CollectionHelpers = function () {
    function CollectionHelpers() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CollectionHelpers);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CollectionHelpers, null, [{
        key: "lookupValue",
        value: function lookupValue(collection, propertyName, findValue, returnValue) {
            var objFound = collection.find(function (o) {
                return o[propertyName] == findValue;
            });
            return objFound[returnValue];
        }
    }, {
        key: "getMostRecentItem",
        value: function getMostRecentItem(collection) {
            var maxDate = null;
            var mostRecent = null;
            collection.forEach(function (item) {
                var dt = item.created || item.createdAt || item.date;
                if (dt > maxDate || maxDate == null) {
                    maxDate = dt;
                    mostRecent = item;
                }
            });
            return mostRecent;
        }
    }, {
        key: "insertOrMoveToTop",
        value: function insertOrMoveToTop(item, arr) {
            var idx = arr.findIndex(function (o) {
                return o._id == item._id;
            });
            if (idx > -1) arr.splice(idx, 1);
            arr.unshift(item);
        }
    }]);

    return CollectionHelpers;
}();

/* harmony default export */ __webpack_exports__["a"] = (CollectionHelpers);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(18);







var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'cleanTagName',
        value: function cleanTagName(tagName) {
            if (!tagName) return '';
            var newTagName = tagName.toLowerCase().replace(' ', '_').trim();
            return newTagName;
        }
    }, {
        key: 'addTag',
        value: function addTag(tagObj, name) {
            var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();

            var tagName = this.cleanTagName(name);
            var dateLabel = tagName + '-date';
            var userLabel = tagName + '-user';
            var userName = __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__["a" /* default */].fullName(__WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getUser());
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(tagObj, tagName, true);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(tagObj, dateLabel, date);
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(tagObj, userLabel, userName);
        }
    }, {
        key: 'tagExists',
        value: function tagExists(tagObj, name) {
            var tagName = this.cleanTagName(name);
            if (!tagObj) return false;
            return !!tagObj[tagName];
        }
    }, {
        key: 'tagDate',
        value: function tagDate(tagObj, name) {
            var tagName = this.cleanTagName(name) + '-date';

            if (!tagObj) return null;
            return tagObj[tagName] || null;
        }
    }, {
        key: 'tagUser',
        value: function tagUser(tagObj, name) {
            var tagName = this.cleanTagName(name) + '-user';

            if (!tagObj) return null;
            return tagObj[tagName] || null;
        }
    }, {
        key: 'itemsWithTag',
        value: function itemsWithTag(arr, tagName) {
            return arr.filter(function (o) {
                return o.tags && o.tags[tagName];
            });
        }
    }, {
        key: 'itemsWithoutTag',
        value: function itemsWithoutTag(arr, tagName) {
            return arr.filter(function (o) {
                return !o.tags || !o.tags[tagName];
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'renameTransaction',
        value: function renameTransaction(transactionKey, description) {
            if (!transactionKey) {
                console.error('No transaction to update');
                return;
            }
            if (!description) {
                console.error('No description to update');
                return;
            }

            var tenantRef = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantRef();
            var transactionRef = tenantRef.child('transactions/' + transactionKey);

            var contactRef = transactionRef.child('elements').orderByChild('type').equalTo('Contact');

            __WEBPACK_IMPORTED_MODULE_4__data_FireData__["a" /* default */].fetchItems(contactRef).then(function (contactElements) {
                contactElements.filter(function (o) {
                    return o.role == 'Client';
                }).forEach(function (contactElement) {
                    tenantRef.child('contactTransactions/' + contactElement.contactKey + '/' + transactionKey).child('description').set(description);
                });

                transactionRef.child('details').child('description').set(description);
            });
        }
    }, {
        key: 'deleteTransaction',
        value: function deleteTransaction(transactionKey) {
            if (!transactionKey) {
                console.error('No transaction to delete');
                return;
            }

            var tenantRef = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantRef();
            var transactionRef = tenantRef.child('transactions/' + transactionKey);

            var contactRef = transactionRef.child('elements').orderByChild('type').equalTo('Contact');

            __WEBPACK_IMPORTED_MODULE_4__data_FireData__["a" /* default */].fetchItems(contactRef).then(function (contactElements) {
                contactElements.filter(function (o) {
                    return o.role == 'Client';
                }).forEach(function (contactElement) {

                    tenantRef.child('contactTransactions/' + contactElement.contactKey + '/' + transactionKey).remove();
                });

                transactionRef.remove();
            });
        }
    }, {
        key: 'makeTemplate',
        value: function makeTemplate(transactionKey) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!transactionKey) {
                    console.error('No transaction to make into template');
                    return;
                }

                var tenantRef = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantRef();
                var transactionRef = tenantRef.child('transactions/' + transactionKey + '/details');
                transactionRef.child('isTemplate').set(true);

                __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].fetchItemSingle(transactionRef).then(function (transactionDetails) {

                    transactionRef.child('originalMasterKey').set(transactionDetails.masterKey);
                    transactionRef.child('masterKey').set(transactionKey);
                    var transactionTemplatesRef = tenantRef.child('transactionTemplates').child(transactionKey);
                    transactionTemplatesRef.update({
                        clients: transactionDetails.clients,
                        description: transactionDetails.description
                    }).then(function (result) {
                        resolve(result);
                    });
                });
            });
        }
    }, {
        key: 'removeTemplate',
        value: function removeTemplate(transactionKey) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (!transactionKey) {
                    console.error('No transaction to remove from template');
                    return;
                }

                var tenantRef = __WEBPACK_IMPORTED_MODULE_3__DataHelpers__["a" /* default */].getTenantRef();
                var transactionRef = tenantRef.child('transactions/' + transactionKey + '/details');

                transactionRef.child('isTemplate').remove();

                __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].fetchItemSingle(transactionRef).then(function (transactionDetails) {
                    transactionRef.child('masterKey').set(transactionDetails.originalMasterKey);
                    transactionRef.child('originalMasterKey').remove;
                });

                var transactionTemplatesRef = tenantRef.child('transactionTemplates').child(transactionKey);
                transactionTemplatesRef.remove();

                setTimeout(function () {
                    resolve('template removed');
                }, 500);
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_Store__ = __webpack_require__(31);







var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getChecklistRef',
        value: function getChecklistRef() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist');
        }
    }, {
        key: 'deleteChecklist',
        value: function deleteChecklist(key) {
            var dataRef = this.getChecklistRef().child('data').child(key);
            dataRef.remove();
            var listRef = this.getChecklistRef().child('list').child(key);
            listRef.remove();
        }
    }, {
        key: 'deleteDocument',
        value: function deleteDocument(checklistKey, documentKey) {
            var dataRef = this.getChecklistRef().child('data').child(checklistKey).child('data').child(documentKey);
            dataRef.remove();
        }
    }, {
        key: 'deleteOption',
        value: function deleteOption(checklistKey, optionKey) {
            var dataRef = this.getChecklistRef().child('data').child(checklistKey).child('data').child(documentKey);
            dataRef.remove();
        }
    }, {
        key: 'fetchPolicyForDocument',
        value: function fetchPolicyForDocument(document) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var checklistKey = document.meta.path.split('/')[3];
                var optionRef = _this.getChecklistRef().child('data').child(checklistKey).child('options').child(document.optionKey);
                __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemSingle(optionRef).then(function (option) {

                    var policyRef = _this.getChecklistRef().child('data').child(checklistKey).child('policies').child(option.policyKey);
                    __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemSingle(policyRef).then(function (policy) {
                        resolve(policy);
                    });
                });
            });
        }
    }, {
        key: 'deletePolicyCascade',
        value: function deletePolicyCascade(policy) {
            var _this2 = this;

            var checklistKey = policy.meta.path.split('/')[3];
            var categoryName = policy.category;

            var optionsRef = this.getChecklistRef().child('data').child(checklistKey).child('options').orderByChild('policyKey').equalTo(policy.meta.key);
            __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemsFromFirebase(optionsRef).then(function (options) {
                options.forEach(function (option) {
                    var documentsRef = _this2.getChecklistRef().child('data').child(checklistKey).child('documents').orderByChild('optionKey').equalTo(option.meta.key);
                    __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemsFromFirebase(documentsRef).then(function (documents) {
                        documents.forEach(function (document) {
                            __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].deleteItem(document);
                        });
                    });
                    __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].deleteItem(option);
                });
            });
            __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].deleteItem(policy);

            var otherPoliciesRef = this.getChecklistRef().child('data').child(checklistKey).child('policies').orderByChild('category').equalTo(categoryName);

            __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemsFromFirebase(otherPoliciesRef).then(function (policies) {

                if (policies.length < 1) {
                    var categoriesRef = _this2.getChecklistRef().child('data').child(checklistKey).child('categories').orderByChild('name').equalTo(categoryName);
                    __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemsFromFirebase(categoriesRef).then(function (categories) {
                        categories.forEach(function (category) {
                            __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].deleteItem(category);
                        });
                    });
                }
            });
        }
    }, {
        key: 'fetchChecklistTask',
        value: function fetchChecklistTask(tenantKey, checklistKey) {
            console.log('fetchChecklistTask', tenantKey, checklistKey);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var followUpRef = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef(tenantKey).child('tasks').orderByChild('transactionKey').equalTo(checklistKey);
                __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemsFromFirebase(followUpRef).then(function (tasks) {
                    var followUpTask = tasks.find(function (o) {
                        return o.code == 'document-checklist';
                    });


                    if (followUpTask) resolve(followUpTask);
                }).catch(function (e) {
                    console.error(e);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_Data4__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__ = __webpack_require__(6);







var db = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].database();

var state = {
    collections: {}
};

var getters = {

    collections: function collections(state) {
        return state.collections;
    },

    getCollectionData: function getCollectionData(state) {
        return function (teamName, collectionName) {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].objectDeepGet(state.collections, [teamName, collectionName, 'data']) || [];
        };
    },

    getCollection: function getCollection(state) {
        return function (teamName, collectionName) {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].objectDeepGet(state.collections, [teamName, collectionName]) || [];
        };
    }

};

var mutations = {
    setCollection: function setCollection(state, payload) {

        var collectionPath = 'collections/' + payload.team + '/' + payload.collection;

        __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].objectDeepSet(state, collectionPath + '/data', payload.data);
        __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].objectDeepSet(state, collectionPath + '/fields', payload.fields);
        __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].objectDeepSet(state, collectionPath + '/actions', payload.actions);
        __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].objectDeepSet(state, collectionPath + '/count', payload.count);
    }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__ = __webpack_require__(5);














var db = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database();

var state = {
    tabs: [],
    elements: [],
    fields: [],
    triggers: [],
    selectedElement: {},
    deletingElement: {},
    selectedSection: null,
    selectedTab: null,

    uploadingCount: 0
};

var getters = {

    tabs: function tabs(state) {
        return state.tabs;
    },

    selectedTab: function selectedTab(state) {
        return state.selectedTab;
    },
    elements: function elements(state) {
        return state.elements;
    },
    uploadingCount: function uploadingCount(state) {
        return state.uploadingCount;
    },

    transactionContacts: function transactionContacts(state) {
        return state.elements.filter(function (o) {
            return o.type == 'Contact' && o.contact;
        }).map(function (o) {
            return {
                key: o.contactKey,
                email: o.contact.email,
                mobile: o.contact.mobile,
                fax: o.contact.fax,
                firstName: o.contact.firstName,
                preferredName: o.contact.preferredName || null,
                lastName: o.contact.lastName,
                fullName: __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].fullName(o.contact),
                role: o.role,
                image: o.contact.image
            };
        });
    },

    selectedElement: function selectedElement(state) {
        return state.selectedElement;
    },
    selectedSection: function selectedSection(state) {
        return state.selectedSection;
    },
    deletingElement: function deletingElement(state) {
        return state.deletingElement;
    },
    fields: function fields(state) {
        return state.fields;
    },
    triggers: function triggers(state) {
        return state.triggers;
    },
    fieldIdentifiers: function fieldIdentifiers(state) {
        return state.fields.map(function (o) {
            return o.identifier;
        });
    }
};

var actions = {
    saveElement: function saveElement(context, obj) {
        __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].log('ElementsStore > saveElement', obj);
        obj.transactionKey = obj.transactionKey || context.getters.transaction.key;
        obj.tenantKey = context.getters.tenantKey;
        var newObj = __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].prepareSave(obj);
        context.commit('saveElement', newObj);
        var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('elements');
        __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(newObj, ref);
    },
    updateElementValue: function updateElementValue(context, obj) {
        var newObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, obj);
        context.commit('saveElement', newObj);
        var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('elements');
        __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(newObj, ref);
    },
    deleteElement: function deleteElement(context, obj) {
        __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].log('ElementsStore > deleteElement', obj);
        context.commit('deleteElement', obj);
        var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('elements');
        __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].deleteFromFirebase(obj, ref);
    },
    deleteTab: function deleteTab(context, obj) {
        __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].log('ElementsStore > deleteTab', obj);
        context.commit('deleteTab', obj);
        var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('tabs');
        __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].deleteFromFirebase(obj, ref);
    },
    selectTab: function selectTab(context, obj) {
        context.commit('setSelectedTab', obj);
        context.commit('setSelectedTask', null);
        context.commit('allCommentsMode', false);
    },
    selectSection: function selectSection(context, obj) {
        context.commit('setSelectedSection', obj);
        context.commit('setSelectedTask', null);
        context.commit('allCommentsMode', false);
    },
    uploadFiles: function uploadFiles(context, _ref) {
        var files = _ref.files,
            element = _ref.element;

        var _loop = function _loop() {
            var file = files[n];

            if (file.size > 7500000) {
                __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__["a" /* default */].showAlert('File size is too big:' + file.name);
                return 'continue';
            }
            console.log('Uploading ' + file.name);

            context.commit('uploadingCountIncrement');

            var originalName = file.name;
            var name = element && element.targetName ? element.targetName : originalName;
            var fileName = __WEBPACK_IMPORTED_MODULE_11__helpers_FileHelpers__["a" /* default */].cleanFilename(name);

            var fileElement = {
                key: __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getKey(),
                originalName: originalName,
                name: name,
                fileName: fileName,
                tabKey: 'settings',
                transactionKey: __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionKey(),
                type: 'File',
                title: fileName,
                loading: true,
                url: null
            };
            context.dispatch('saveElement', fileElement);

            var transactionKey = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionKey();
            __WEBPACK_IMPORTED_MODULE_11__helpers_FileHelpers__["a" /* default */].fileToFirebase(file, 'transactions/' + transactionKey + '/' + file.name, function (progress) {
                console.log('PROGRESS', progress);
                fileElement.progress = progress;
                context.dispatch('saveElement', fileElement);
            }).then(function (url) {
                fileElement.value = url;
                fileElement.loading = null;
                fileElement.progress = null;
                context.dispatch('saveElement', fileElement);
                context.commit('uploadingCountDecrement');
            });

            if (!element) return 'continue';

            if (!element.linkedFileKeys) element.linkedFileKeys = [];

            element.linkedFileKeys.push(fileElement.key);
            context.dispatch('saveElement', element);
        };

        for (var n = 0; n < files.length; n++) {
            var _ret = _loop();

            if (_ret === 'continue') continue;
        }
    },
    loadTabs: function loadTabs(context) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/transactions/' + context.getters.transaction.key + '/elements');
            ref.orderByChild('type').equalTo('Tab').once('value', function (snap) {
                console.log('store > loadTabs (first load)');
                var tabs = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap).sort(__WEBPACK_IMPORTED_MODULE_10__helpers_OrderHelpers__["a" /* default */].sortAscending);
                context.commit('appendElements', tabs);
                resolve('loaded');
            });
        });
    },
    loadAllElements: function loadAllElements(context) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/transactions/' + context.getters.transaction.key + '/elements');
            ref.once('value', function (snap) {
                console.log('store > loadAllElements (first load)');
                var elements = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                context.commit('setElements', elements);
                resolve('loaded');
            });
        });
    },
    fetchElementsByType: function fetchElementsByType(context, type) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var ref = db.ref('tenants/' + context.getters.tenantKey + '/transactions/' + context.getters.transaction.key + '/elements');
            ref.orderByChild('type').equalTo(type).once('value', function (snap) {
                console.log('store > fetchElementsByType');
                var elements = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                resolve(elements);
            });
        });
    }
};

var mutations = {
    deleteElement: function deleteElement(state, element) {
        __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].delete(element, state.elements);
    },
    setSelectedSection: function setSelectedSection(state, newVal) {
        state.selectedSection = newVal;
    },
    setElements: function setElements(state, elements) {
        state.elements = elements;
    },
    appendElements: function appendElements(state, elements) {
        state.elements = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(elements), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.elements));
    },
    setSelectedElement: function setSelectedElement(state, newVal) {
        state.selectedElement = newVal;
    },
    setDeletingElement: function setDeletingElement(state, newVal) {
        state.deletingElement = newVal;
        setTimeout(function () {
            state.deletingElement = null;
        }, 4000);
    },
    saveElement: function saveElement(state, element) {
        __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].save(element, state.elements);
    },
    deleteTab: function deleteTab(state, tab) {
        __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].delete(tab, state.tabs);
    },
    setTabs: function setTabs(state, newVal) {
        state.tabs = newVal;
    },
    setSelectedTab: function setSelectedTab(state, newVal) {
        state.selectedTab = newVal;
    },
    uploadingCount: function uploadingCount(state, newVal) {
        state.uploadingCount = newVal;
    },
    uploadingCountIncrement: function uploadingCountIncrement(state, newVal) {
        state.uploadingCount++;
    },
    uploadingCountDecrement: function uploadingCountDecrement(state, newVal) {
        if (state.uploadingCount > 0) state.uploadingCount--;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1278)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(2667),
  /* scopeId */
  "data-v-ef8409c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1106)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(2494),
  /* scopeId */
  "data-v-2d145cf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(2589),
  /* scopeId */
  "data-v-69fe6579",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__ = __webpack_require__(5);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'evalInContext',
        value: function evalInContext(js, context) {

            this.addCommonFunctions(context);

            var expression = js.replace(/\$/g, 'this.');

            return function () {
                var result = void 0;
                try {
                    result = eval(expression);
                } catch (e) {
                    result = 'EVAL_ERR';
                }
                return result;
            }.call(context);
        }
    }, {
        key: 'addCommonFunctions',
        value: function addCommonFunctions(context) {
            context.currency = function (val) {
                return __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].formatCurrency(val);
            };

            context.brackets = function (val, suffix) {
                if (!val) return val;
                return '(' + val + (suffix || '') + ')';
            };
        }
    }, {
        key: 'processExpressions',
        value: function processExpressions(str, context, schemas) {
            var _this = this;

            if (str.indexOf('[') < 0) return str;

            var expressionArray = this.findExpressions(str);
            var newStr = str;
            expressionArray.forEach(function (expression) {
                var result = _this.evalInContext(expression, context);
                newStr = newStr.replace('[' + expression + ']', result);
            });

            if (newStr == 'false' || newStr == 'EVAL_ERR' || newStr == 'null' || newStr == 'undefined') return false;

            return newStr.replace(/null/g, '').trim();
        }
    }, {
        key: 'findExpressions',
        value: function findExpressions(searchString) {

            var matches = {};
            var match = void 0;

            do {
                match = String(searchString).match(/\[(.*?)\]/i);
                if (!match) break;

                var innerMatch = match[1];
                var outerMatch = match[0];

                matches[innerMatch] = true;
                searchString = searchString.replace(outerMatch, '');
            } while (match);

            return __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].objectToArray(matches);
        }
    }, {
        key: 'trueLabels',
        value: function trueLabels(schemas, value) {
            var labelArray = [];
            schemas.forEach(function (schema) {
                if (value[schema.name] === true || value[schema.name + '_exists']) {
                    labelArray.push(schema.title || schema.label || schema.name);
                }
            });

            return labelArray.join(', ') || 'None';
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_algoliasearch__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_algoliasearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_algoliasearch__);






var algoliaClient = __WEBPACK_IMPORTED_MODULE_2_algoliasearch___default()('YAAAUS4GNX', '3f4f7382331db6370f76a327aaf70326');

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getContactIndex',
        value: function getContactIndex(tenantKey) {
            return algoliaClient.initIndex('contacts_' + tenantKey);
        }
    }, {
        key: 'saveToIndex',
        value: function saveToIndex(indexName, obj) {
            var index = algoliaClient.initIndex(indexName);
            index.saveObject(obj).then(function (_ref) {
                var objectID = _ref.objectID;

                console.log('Saved to Algolia');
            });
        }
    }, {
        key: 'saveListToIndex',
        value: function saveListToIndex(indexName, arr) {
            var index = algoliaClient.initIndex(indexName);
            index.saveObjects(arr).then(function (_ref2) {
                var objectIDs = _ref2.objectIDs;

                console.log('Saved ' + arr.length + ' items to Algolia');
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__ = __webpack_require__(724);














var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchLoanStructure',
        value: function fetchLoanStructure(transactionKey) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var ref, el;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    ref = __WEBPACK_IMPORTED_MODULE_10__helpers_DataHelpers__["a" /* default */].getTransactionRef(transactionKey).child('elements');
                                    _context.next = 3;
                                    return __WEBPACK_IMPORTED_MODULE_9__data_NiceData__["a" /* default */].fetchItemByName(ref, 'loan_diagram');

                                case 3:
                                    el = _context.sent;

                                    if (!el) reject('Loan diagram element not found');
                                    resolve(el.diagram);

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'allLoans',
        value: function allLoans(structure) {
            var loans = [];
            structure.forEach(function (group) {
                loans = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(loans), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(group.loans));
            });
            return loans;
        }
    }, {
        key: 'loanNewMoney',
        value: function loanNewMoney(loan) {
            var amt = loan.newMoney;

            if (!amt) {
                amt = loan.amount;
                if (loan.lmiType == 'Capitalised') amt += loan.lmi;
            }
            return amt;
        }
    }, {
        key: 'loanTotalAmount',
        value: function loanTotalAmount(loan) {
            var total = loan.amount;
            if (loan.lmiType == 'Capitalised') total += loan.lmi;
            return total;
        }
    }, {
        key: 'loanSummary',
        value: function loanSummary(structure) {
            var _this2 = this;

            var loans = this.allLoans(structure);
            var summary = {
                newMoney: { title: 'New Money', format: 'Currency', value: 0, id: 'newMoney', name: 'total_new_money', dashboards: true },
                lmi: { title: 'Mortgage Insurance', format: 'Currency', value: 0, id: 'lmi', name: 'total_lmi' },
                io: { title: 'Interest Only', format: 'Currency', value: 0, id: 'io', name: 'total_io' },
                fixed: { title: 'Fixed Rate', format: 'Currency', value: 0, id: 'fixed', name: 'total_fixed' },
                ownerOccupied: { title: 'Owner Occupied', format: 'Currency', value: 0, id: 'ownerOccupied', name: 'total_owner_occupied' },
                investment: { title: 'Investment', format: 'Currency', value: 0, id: 'investment', name: 'total_investment' },
                rateLock: { title: 'Rate Lock', format: 'Currency', value: 0, id: 'rateLock', name: 'total_rate_lock' },
                special: { title: 'Special', format: 'Currency', value: 0, id: 'special', name: 'total_special' },
                package: { title: 'Pro Package', format: 'Currency', value: 0, id: 'package', name: 'total_package' },
                purchaseAddress: { title: 'Purchase Address', format: 'String', value: this.purchaseAddress(structure), id: 'purchase_address', name: 'purchase_address' }
            };
            loans.forEach(function (loan) {
                var totalLoan = _this2.loanTotalAmount(loan);
                summary.newMoney.value += _this2.loanNewMoney(loan);
                summary.lmi.value += loan.lmi || 0;
                summary.io.value += loan.io ? totalLoan : 0;
                summary.fixed.value += loan.fixed ? totalLoan : 0;
                summary.ownerOccupied.value += !loan.investment ? totalLoan : 0;
                summary.investment.value += loan.investment ? totalLoan : 0;
                summary.rateLock.value += loan.rateLock ? totalLoan : 0;
                summary.special.value += loan.special ? totalLoan : 0;
                summary.package.value += loan.package ? totalLoan : 0;
            });
            return summary;
        }
    }, {
        key: 'purchaseAddress',
        value: function purchaseAddress(structure) {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelpers__["a" /* default */].sentenceJoin(this.allProperties(structure).filter(function (property) {
                return !property.existing;
            }).map(function (property) {
                return property.address;
            }));
        }
    }, {
        key: 'loanSummaryValue',
        value: function loanSummaryValue(structure, name) {
            var summary = this.loanSummary(structure);
            var item = summary.find(function (o) {
                return o.name == name;
            });
            if (item) return item.value;else return '';
        }
    }, {
        key: 'allProperties',
        value: function allProperties(structure) {
            var properties = [];
            structure.forEach(function (group) {
                properties = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(properties), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(group.properties));
            });
            return properties;
        }
    }, {
        key: 'diagramDescription',
        value: function diagramDescription(structureEnhanced) {
            var obj = {};
            structureEnhanced.forEach(function (group, groupIndex) {
                if (structureEnhanced.length > 1) {
                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, 'Transaction ' + (groupIndex + 1), { bold: true, underline: true, newline: true });
                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, '', { newline: true });
                }
                group.loans.forEach(function (loan, loanIndex) {
                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, loan.meta.title, { bold: true, newline: true });
                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, '- ' + loan.meta.description);

                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, '', { newline: true });
                });
                obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, 'Security', { newline: true, bold: true });
                group.properties.forEach(function (property, index) {
                    var propertyValue = __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelpers__["a" /* default */].formatCurrency(property.value);
                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, propertyValue);
                    if (property.address) obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, ' - ' + property.address);
                    var p1 = ' (' + (property.investment ? 'INV' : 'OO') + (property.existing ? '/EXISTING' : '') + ')';
                    obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, p1, { newline: true });
                });
                obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, '', { newline: true });
            });
            return obj;
        }
    }, {
        key: 'loanSummaryDescription',
        value: function loanSummaryDescription(structure) {
            var obj = {};
            obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, 'Loan Summary', { bold: true, underline: true, newline: true });
            obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, '', { newline: true });

            var summary = this.loanSummary(structure);
            for (var prop in summary) {
                var item = summary[prop];
                var valueStr = item.value;
                if (item.format == 'Currency') valueStr = __WEBPACK_IMPORTED_MODULE_7__helpers_StringHelpers__["a" /* default */].formatCurrency(valueStr);
                obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, item.name + ':  ', { bold: true });
                obj = __WEBPACK_IMPORTED_MODULE_11__helpers_MultiFormat__["a" /* default */].append(obj, '' + valueStr, { newline: true });
            }
            return obj;
        }
    }, {
        key: 'loanPayment',
        value: function loanPayment(loan) {
            if (!loan.amount || !loan.rate) return 0;
            if (loan.io) {
                return loan.amount * loan.rate / 100 / 12;
            }
            if (!loan.years) return 0;
            return this.monthlyPayment(loan.amount, loan.rate, loan.years);
        }
    }, {
        key: 'monthlyPayment',
        value: function monthlyPayment(balance, rate, years) {
            var ir = rate / 100 / 12;
            var np = years * 12;
            var pv = 0 - balance;
            var fv = 0;
            var type = 0;

            var pmt = void 0,
                pvif = void 0;

            fv || (fv = 0);
            type || (type = 0);

            if (ir === 0) return -(pv + fv) / np;

            pvif = Math.pow(1 + ir, np);
            pmt = -ir * pv * (pvif + fv) / (pvif - 1);

            if (type === 1) pmt /= 1 + ir;

            return pmt;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'setTenant',
        value: function setTenant(tenantKey) {
            if (tenantKey == __WEBPACK_IMPORTED_MODULE_3__store_Store__["a" /* default */].getters.tenantKey) return;

            __WEBPACK_IMPORTED_MODULE_3__store_Store__["a" /* default */].commit('setTenant', { key: tenantKey });
            console.log('Tenant changed to ' + tenantKey);
        }
    }, {
        key: 'fetchInvite',
        value: function fetchInvite(tenantKey) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getRootRef().child('invites').child(tenantKey);
                __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (item) {
                    resolve(item);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1114)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(2502),
  /* scopeId */
  "data-v-32b79abc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1151)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(2539),
  /* scopeId */
  "data-v-4edc3f02",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(2493),
  /* scopeId */
  "data-v-2ce3a773",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(2588),
  /* scopeId */
  "data-v-69db288a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(2607),
  /* scopeId */
  "data-v-74f763d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1104)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(2492),
  /* scopeId */
  "data-v-2c816eff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1168)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(2556),
  /* scopeId */
  "data-v-57a4b9d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1174)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(2562),
  /* scopeId */
  "data-v-59c42757",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1052)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(2439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1058)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(2445),
  /* scopeId */
  "data-v-0c56009d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1091)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(2478),
  /* scopeId */
  "data-v-210dc8a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1124)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(2512),
  /* scopeId */
  "data-v-3cf2be07",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1268)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(2657),
  /* scopeId */
  "data-v-c79cb042",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Firestore__ = __webpack_require__(27);









var fs = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.firestore();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'runActions',
        value: function runActions(item) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var actionsPath = __WEBPACK_IMPORTED_MODULE_7__Firestore__["a" /* default */].replaceDataInPath(item._path, 'actions');
                var ref = fs.collection(actionsPath);
                __WEBPACK_IMPORTED_MODULE_7__Firestore__["a" /* default */].fetchCollection(ref).then(function (actions) {
                    actions.forEach(function (action) {
                        _this.runAction(action, item);
                    });
                    resolve(item);
                });
            });
        }
    }, {
        key: 'runAction',
        value: function runAction(action, item) {

            var expression = this.merge(action.expression, item);
            var result = '';
            try {
                result = eval(expression);
            } catch (e) {
                result = expression;
            }

            console.log('result is ', result);
            var fieldSlug = __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].toCamelCase(action.field);

            if (action.type == 'Set Field Value') {
                item[fieldSlug] = result;
            }
        }
    }, {
        key: 'merge',
        value: function merge(expression, item) {
            var mergeItems = __WEBPACK_IMPORTED_MODULE_5__helpers_MergeHelpers__["a" /* default */].findMergeFields(expression);

            mergeItems.forEach(function (mergeItem) {
                var fieldSlug = __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].toCamelCase(mergeItem);
                var fieldInBrackets = '(\\[' + mergeItem + '\\])';
                var replacement = item[fieldSlug] || '';
                var re = new RegExp(fieldInBrackets, 'gi');
                expression = expression.replace(re, replacement);
            });

            return expression;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_CollectionsStore__ = __webpack_require__(144);













var db = __WEBPACK_IMPORTED_MODULE_5__firebase__["a" /* default */].database();

var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'loadOffices',
        value: function loadOffices(db) {
            var ref = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('tables/global/offices/data');
            var officesArr = [];
            this.streamCollection(ref, officesArr);
        }
    }, {
        key: 'streamCollection',
        value: function streamCollection(ref, arr) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.on('value', function (snap) {
                    _this.snapshotFillArray(snap, arr);
                    resolve(arr);
                });
            });
        }
    }, {
        key: 'tableToRef',
        value: function tableToRef(office, table) {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('tables').child(office).child(table);
        }
    }, {
        key: 'streamToStore',
        value: function streamToStore(office, table, preferences) {
            var _this2 = this;

            var tableRef = this.tableToRef(office, table);

            var p1 = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var dataRef = tableRef.child('data');

                dataRef.on('value', function (snap) {

                    var data = [];
                    _this2.snapshotFillArray(snap, data);
                    var count = data.length;
                    var payload = {
                        office: office, table: table, data: data, count: count
                    };

                    __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('setTable', payload);
                    resolve(data);
                });
            });

            var p2 = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var fieldsRef = tableRef.child('fields');

                fieldsRef.on('value', function (snap) {

                    var fields = [];
                    _this2.snapshotFillArray(snap, fields);
                    var payload = {
                        office: office, table: table, fields: fields
                    };

                    __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('setTable', payload);
                    resolve(fields);
                });
            });

            var p3 = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                var relationshipsRef = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('tables').child(office).child('relationships');

                relationshipsRef.on('value', function (snap) {

                    var relationships = [];
                    _this2.snapshotFillArray(snap, relationships);
                    var payload = {
                        office: office, table: table, relationships: relationships
                    };

                    __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('setTable', payload);
                    resolve(relationships);
                });
            });
        }
    }, {
        key: 'snapshotFillArray',
        value: function snapshotFillArray(snap, arr) {
            if (!arr) debugger;

            var ordered = false;

            for (var i = arr.length; i > 0; i--) {
                arr.pop();
            }

            snap.forEach(function (childSnapshot) {
                var item = childSnapshot.val();
                item._key = childSnapshot.key;
                var pathArray = snap.ref.path.pieces_;

                if (item.order) ordered = true;

                item._path = pathArray.join('/');

                arr.push(item);
            });

            if (ordered) arr = arr.sort(__WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__["a" /* default */].sortByOrder);
        }
    }, {
        key: 'saveItem',
        value: function saveItem(item) {
            item._key = item._key || __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getKey();
            var ref = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child(item._path).child(item._key);
            var newItem = this.removeMeta(item);
            console.log('Data4 > saveItem storing item to ' + ref.toString(), newItem);
            ref.update(newItem);
        }
    }, {
        key: 'deleteItem',
        value: function deleteItem(item) {
            var ref = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child(item._path).child(item._key);
            console.log('Data4 > deleteItem' + ref.toString());
            ref.remove();
        }
    }, {
        key: 'removeMeta',
        value: function removeMeta(obj) {
            var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, obj);
            for (var prop in newObj) {
                if (prop.substr(0, 1) == '_') delete newObj[prop];
            }
            return newObj;
        }
    }, {
        key: 'fetchItemSingle',
        value: function fetchItemSingle(ref) {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var obj = _this3.objectFromSnapshot(snap);
                    resolve(obj);
                });
            });
        }
    }, {
        key: 'fetchValue',
        value: function fetchValue(ref) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    var result = snap.val();
                    resolve(result);
                });
            });
        }
    }, {
        key: 'fetchItemByName',
        value: function fetchItemByName(baseRef, name) {
            var _this4 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                baseRef.orderByChild('name').equalTo(name).once('value', function (snap) {
                    var objects = _this4.arrayFromSnapshot(snap);
                    if (objects && objects.length) resolve(objects[0]);else resolve(null);
                });
            });
        }
    }, {
        key: 'objectFromSnapshot',
        value: function objectFromSnapshot(snap) {
            var item = snap.val();
            if (!item) return null;
            item.meta = {};
            item.meta.key = snap.key;
            var pathArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(snap.ref.path.pieces_));
            if (pathArray.length > 2 && pathArray[0] == 'tenants') item.meta.tenantKey = pathArray[1];

            pathArray.pop();
            item.meta.path = pathArray.join('/');
            return item;
        }
    }, {
        key: 'fetchItemsFromFirebase',
        value: function fetchItemsFromFirebase(ref) {
            var _this5 = this;

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.once('value', function (snap) {
                    resolve(_this5.arrayFromSnapshot(snap));
                });
            });
        }
    }, {
        key: 'safelyGetKey',
        value: function safelyGetKey(obj) {
            var key = void 0;

            if (obj._key) return obj._key;

            if (obj.meta && obj.meta.key) key = obj.meta.key;

            var oldKey = obj['.key'] || obj.key;

            if (oldKey) {
                if (!key) {
                    console.log('safelyGetKey ONLY has old key', obj);
                    key = oldKey;
                } else console.log('safelyGetKey has redundant old key', obj);
            }

            return key;
        }
    }, {
        key: 'safelyGetTenant',
        value: function safelyGetTenant(obj) {
            if (obj && obj.meta && obj.meta.tenantKey) return obj.meta.tenantKey;else return __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].getters.tenantKey;
        }
    }, {
        key: 'fetchItems',
        value: function fetchItems(ref, storeName, localVariable) {
            if (__WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].state[storeName].length) {
                console.log('fetchItems from cache', storeName);
                localVariable = __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].state[storeName];
                return;
            }
            this.fetchItemsFromFirebase(ref).then(function (items) {
                console.log('fetchItems from db', storeName);

                var payload = {
                    name: storeName,
                    data: items
                };
                __WEBPACK_IMPORTED_MODULE_6__store_Store__["a" /* default */].commit('saveItems', payload);
                localVariable = items;
            });
        }
    }, {
        key: 'saveFieldToFirebase',
        value: function saveFieldToFirebase(ref, x) {}
    }, {
        key: 'firebaseRefToPath',
        value: function firebaseRefToPath(ref) {
            var refStr = ref.toString();
            var refArr = refStr.split(/\//).slice(3).join('/');
            return refArr;
        }
    }, {
        key: 'firebaseRefToKey',
        value: function firebaseRefToKey(ref) {
            var pathArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ref.path.pieces_));
            pathArray.pop();
            return pathArray.join("/");
        }
    }, {
        key: 'defaultValue',
        value: function defaultValue(field) {
            if (field == '[tenantKey]') return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getTenantKey();
            if (field == '[stamp]') return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getStamp();
        }
    }, {
        key: 'saveField',
        value: function saveField(ref, value) {
            ref.set(value);
        }
    }, {
        key: 'copyItems',
        value: function copyItems(fromRef, toRef) {
            var _this6 = this;

            var toPath = this.firebaseRefToPath(toRef);
            this.fetchItemsFromFirebase(fromRef).then(function (fromItems) {
                fromItems.forEach(function (item) {
                    item.meta.path = toPath;
                    _this6.saveItem(item);
                });
                console.log('copyItems reports ' + fromItems.length + ' items copied from ' + _this6.firebaseRefToPath(fromRef) + ' to ' + toPath + '.');
            });
        }
    }, {
        key: 'copySingleItem',
        value: function copySingleItem(fromRef, toRef) {
            var _this7 = this;

            var toPath = this.firebaseRefToPath(toRef);
            var toKey = this.firebaseRefToKey(toRef);
            this.fetchItemSingle(fromRef).then(function (fromItem) {
                fromItem.meta.path = toPath;
                fromItem.meta.key = toKey;
                _this7.saveItem(item);
                console.log('copySingleItem copied from ' + _this7.firebaseRefToPath(fromItemRef) + ' to ' + toPath + '.', fromItem);
            });
        }
    }]);

    return _class;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (_class);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_Firestore__ = __webpack_require__(27);






var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'saveFlow',
        value: function saveFlow(flow) {
            flow._path = 'workflows';
            __WEBPACK_IMPORTED_MODULE_3__data_Firestore__["a" /* default */].saveItem(flow);
        }
    }, {
        key: 'fetchFlow',
        value: function fetchFlow(id) {
            var ref = __WEBPACK_IMPORTED_MODULE_3__data_Firestore__["a" /* default */].getDocumentRef('workflows/' + id);
            return __WEBPACK_IMPORTED_MODULE_3__data_Firestore__["a" /* default */].fetch(ref);
        }
    }, {
        key: 'flowSummary',
        value: function flowSummary(workflow) {
            return workflow.steps.map(function (step) {
                return {
                    'title': StringHelpers.truncateDots(step.title, 10),
                    'value': StringHelpers.truncateDots(step.value, 10),
                    'type': step.type
                };
            });
        }
    }, {
        key: 'getLastItem',
        value: function getLastItem(objArr) {}
    }, {
        key: 'getIndex',
        value: function getIndex(item) {}
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_TagStatusHelpers__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AlertHelpers__ = __webpack_require__(12);









var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'saveInvoiceTags',
        value: function saveInvoiceTags(charge) {
            var obj = {
                tags: charge.tags,
                meta: charge.meta
            };
            __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].saveItem(obj);
        }
    }, {
        key: 'saveCharge',
        value: function saveCharge(charge) {
            var from = charge.from,
                to = charge.to;

            var fromKey = __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].safelyGetKey(from);
            var toKey = __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].safelyGetKey(to);

            if (!fromKey || !toKey) {
                __WEBPACK_IMPORTED_MODULE_7__AlertHelpers__["a" /* default */].showAlert('Missing User Key - CHARGE NOT SAVED');
                return;
            }

            from.key = fromKey;
            to.key = toKey;

            var fromTo = fromKey + '-' + toKey;
            var month = __WEBPACK_IMPORTED_MODULE_4__helpers_DateHelpers__["a" /* default */].yearMonth(__WEBPACK_IMPORTED_MODULE_4__helpers_DateHelpers__["a" /* default */].backwardsToDate(charge.date));
            var invoice = {
                month: month,
                from: from,
                to: to,
                status: 'outstanding',
                meta: {
                    path: 'app/billing/' + month + '/invoices',
                    key: fromTo
                },
                tags: {}
            };
            __WEBPACK_IMPORTED_MODULE_5__helpers_TagStatusHelpers__["a" /* default */].addTag(invoice.tags, 'created');

            if (__WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].isInsightUser(invoice.to)) charge.internal = true;

            if (charge.internal) {
                invoice.internal = true;
                __WEBPACK_IMPORTED_MODULE_5__helpers_TagStatusHelpers__["a" /* default */].addTag(invoice.tags, 'validation requested');
                __WEBPACK_IMPORTED_MODULE_5__helpers_TagStatusHelpers__["a" /* default */].addTag(invoice.tags, 'valid');
                __WEBPACK_IMPORTED_MODULE_5__helpers_TagStatusHelpers__["a" /* default */].addTag(invoice.tags, 'insight invoice made');
            }

            charge.stamp = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getStamp();

            __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].saveItem(invoice);

            var newCharge = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, charge);
            delete newCharge.from;
            delete newCharge.to;
            newCharge.invoice = fromTo;
            newCharge.meta = {
                path: 'app/billing/' + month + '/charges',
                key: __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getKey()
            };

            __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].saveItem(newCharge);
        }
    }, {
        key: 'stages',
        get: function get() {
            return [{ name: 'Created', visible: true }, { name: 'Validation Requested' }, { name: 'Valid', visible: true }, { name: 'Insight Invoice Made' }, { name: 'Sent', visible: true }, { name: 'Reminder Sent' }, { name: 'Paid', visible: true }];
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LookupData__ = __webpack_require__(30);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'filterObjectToArray',
        value: function filterObjectToArray(filterObject) {
            var operators = __WEBPACK_IMPORTED_MODULE_3__LookupData__["a" /* default */].operators();
            var arr = [];
            for (var nameProp in filterObject) {
                if (filterObject.hasOwnProperty(nameProp)) {
                    var name = nameProp;
                    var nameTree = filterObject[nameProp];
                    for (var typeProp in nameTree) {
                        if (nameTree.hasOwnProperty(typeProp)) {
                            (function () {
                                var type = __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].capitalizeFirstLetter(typeProp);
                                var typeTree = nameTree[typeProp];
                                var operator = typeTree['operator'];
                                operator = operators.find(function (o) {
                                    return o.code == operator;
                                }).name;
                                var values = typeTree['values'];

                                arr.push({
                                    name: name,
                                    type: type,
                                    operator: operator,
                                    values: values
                                });
                            })();
                        }
                    }
                }
            }
            return arr;
        }
    }, {
        key: 'filterArrayToObject',
        value: function filterArrayToObject(filterArray) {

            var filterObject = {};

            filterArray.forEach(function (filterRecord) {
                var typeString = filterRecord.type.toLowerCase();
                var operatorString = __WEBPACK_IMPORTED_MODULE_2__StringHelpers__["a" /* default */].acronym(filterRecord.operator).toLowerCase();
                var valuesArray = filterRecord.values;

                filterObject[filterRecord.name] = filterObject[filterRecord.name] || {};
                filterObject[filterRecord.name][typeString] = {};
                filterObject[filterRecord.name][typeString]['operator'] = operatorString;
                filterObject[filterRecord.name][typeString]['values'] = valuesArray;
            });
            return filterObject;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);









var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'log',
        value: function log(logItem) {
            if (typeof logItem == 'undefined') logItem.value = null;

            setTimeout(function () {
                var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers_js__["a" /* default */].getTenantRef().child('log');
                logItem.stamp = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers_js__["a" /* default */].getStamp();
                console.log('logging change...', logItem);
                ref.push(logItem);
            }, 1300);
        }
    }, {
        key: 'createLogItem',
        value: function createLogItem() {
            return {
                type: null,
                tenantKey: null,
                transactionKey: null,
                transactionClients: null,
                elementKey: null,
                elementTitle: null,
                elementIndex: null,
                value: null,
                userKey: __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers_js__["a" /* default */].getUserId(),
                stamp: __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers_js__["a" /* default */].getStamp(),
                result: null

            };
        }
    }, {
        key: 'createListItem',
        value: function createListItem(logItem) {
            var item = __WEBPACK_IMPORTED_MODULE_4__Utilities_js__["a" /* default */].clone(logItem);
            var listIcon = 'email';
            var listTitle = 'Email Sent';
            if (item.result && item.result != 'OK') {
                listIcon = 'error_outline';
                listTitle = 'Failed Email';
            }

            item.meta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item.meta, {
                listKey: item.meta.key,
                listTitle: listTitle + ' by ' + item.stamp.firstName + ' on ' + __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].convertDate(item.stamp.date, __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS, 'd/M'),
                listDetails: item.stamp.time + ' ' + item.email.subject,
                listIcon: listIcon
            });

            return item;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(18);





var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'addToArray',
        value: function addToArray(arr, item, options) {

            if (!this.validateArrayAndItem(arr, item)) return;
            this.markupItem(item);

            item._array = arr;
            arr.push(item);
        }
    }, {
        key: 'isLastItem',
        value: function isLastItem(arr, item) {
            if (!this.validateArrayAndItem(arr, item)) return;

            var lastItem = this.getLastItem(arr);
            return Boolean(lastItem._id == item._id);
        }
    }, {
        key: 'getLastItem',
        value: function getLastItem(arr) {
            return arr[arr.length - 1];
        }
    }, {
        key: 'markupItem',
        value: function markupItem(item) {
            item._id = item._id || __WEBPACK_IMPORTED_MODULE_2__data_Firestore__["a" /* default */].getId();
        }
    }, {
        key: 'validateArrayAndItem',
        value: function validateArrayAndItem(arr, item) {
            if (!arr || !item) {
                console.log('validateArrayAndItem was passed an invalid parameter', arr, item);
                return false;
            }
            return true;
        }
    }, {
        key: 'getNextItem',
        value: function getNextItem(arr, item) {
            if (!this.validateArrayAndItem(arr, item)) return;

            var idx = arr.findIndex(function (o) {
                return o._id == item._id;
            });
            if (idx < arr.length - 1) return arr[idx + 1];else return null;
        }
    }, {
        key: 'getPreviousItem',
        value: function getPreviousItem(arr, item) {
            if (!this.validateArrayAndItem(arr, item)) return;

            var idx = arr.findIndex(function (o) {
                return o._id == item._id;
            });
            if (idx > 0) return arr[idx - 1];else return null;
        }
    }, {
        key: 'selectOneOrToggle',
        value: function selectOneOrToggle(arr, item) {
            var selectedItems = this.getSelected(arr);
            if (selectedItems.length > 1) this.selectOne(arr, step);else this.toggleSelection(step);
        }
    }, {
        key: 'toggleSelection',
        value: function toggleSelection(item) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, '_selected', !item._selected);
        }
    }, {
        key: 'selectItem',
        value: function selectItem(item) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, '_selected', true);
        }
    }, {
        key: 'selectOne',
        value: function selectOne(arr, selectItem) {
            this.unselectAll(arr);
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(selectItem, '_selected', true);
        }
    }, {
        key: 'getSelected',
        value: function getSelected(arr) {
            return arr.filter(function (o) {
                return o._selected;
            });
        }
    }, {
        key: 'unselectAll',
        value: function unselectAll(arr) {
            arr.forEach(function (item) {
                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(item, '_selected', false);
            });
        }
    }, {
        key: 'selectRange',
        value: function selectRange(arr, step) {

            var indexes = [];
            var stepIndex = arr.findIndex(function (o) {
                return o._id == step._id;
            });
            indexes.push(stepIndex);

            var selectedItems = this.getSelected(arr);
            var firstSelectedItem = selectedItems[0];
            var lastSelectedItem = this.getLastItem(selectedItems);

            var lowestIndex = arr.findIndex(function (o) {
                return o._id == firstSelectedItem._id;
            });
            var highestIndex = arr.findIndex(function (o) {
                return o._id == lastSelectedItem._id;
            });

            indexes.push(lowestIndex);
            indexes.push(highestIndex);

            var min = Math.min.apply(Math, indexes);
            var max = Math.max.apply(Math, indexes);

            for (var n = min; n <= max; n++) {
                this.selectItem(arr[n]);
            }
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(18);










var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'saveSelectedKeys',
        value: function saveSelectedKeys(code, keys) {}
    }, {
        key: 'getSelectedKeys',
        value: function getSelectedKeys(code, keys) {}
    }], [{
        key: 'select',
        value: function select(key, selectedKeys) {
            __WEBPACK_IMPORTED_MODULE_5__ArrayHelpers__["a" /* default */].pushUnique(key, selectedKeys);
        }
    }, {
        key: 'unselect',
        value: function unselect(key, selectedKeys) {
            __WEBPACK_IMPORTED_MODULE_5__ArrayHelpers__["a" /* default */].deleteItem(key, selectedKeys);
        }
    }, {
        key: 'toggleItem',
        value: function toggleItem(item, array) {
            var idx = array.indexOf(item);
            if (idx == -1) array.push(item);else array.splice(idx, 1);
        }
    }, {
        key: 'prepareSave',
        value: function prepareSave(obj) {
            var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
            if (!newObj.key) {
                newObj.key = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getKey();
            }
            newObj.stamp = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getStamp();
            return newObj;
        }
    }, {
        key: 'save',
        value: function save(obj, arr, position) {
            var idx = arr.findIndex(function (o) {
                return o.key == obj.key;
            });
            if (idx >= 0) {
                var existingObj = arr[idx];
                var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existingObj, obj);
                __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(arr, idx, newObj);
            } else {
                var _newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
                if (position === 0) arr.unshift(_newObj);else arr.push(_newObj);
            }
        }
    }, {
        key: 'saveToArray',
        value: function saveToArray(obj, arr, position) {
            var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj);
            newObj.key = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getKey();
            newObj.stamp = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getStamp();
            if (position == 0) arr.unshift(newObj);else arr.push(newObj);
            return newObj;
        }
    }, {
        key: 'delete',
        value: function _delete(obj, arr) {

            var idx = arr.findIndex(function (o) {
                return o.key == obj.key;
            });
            if (idx >= 0) arr.splice(idx, 1);else __WEBPACK_IMPORTED_MODULE_6__Utilities__["a" /* default */].log('ListHelpers > delete > Cant find object', obj);
        }
    }, {
        key: 'isSelected',
        value: function isSelected(key, selectedKeys) {
            return selectedKeys.indexOf(key) > -1;
        }
    }, {
        key: 'selectSingle',
        value: function selectSingle(key, selectedKeys) {
            var previouslySelected = this.isSelected(key, selectedKeys);
            var multipleSelected = selectedKeys.length > 1;

            selectedKeys.splice(0, selectedKeys.length);

            if (!previouslySelected || multipleSelected) this.select(key, selectedKeys);
        }
    }, {
        key: 'selectMulti',
        value: function selectMulti(key, selectedKeys) {
            this.toggleItem(key, selectedKeys);
        }
    }, {
        key: 'selectRange',
        value: function selectRange(key, selectedKeys, allKeys) {
            if (selectedKeys.length < 1) {
                this.select(key, selectedKeys);
                return;
            }
            var reachedSelected = false;
            var reachedCurrent = false;
            var shouldSelect = false;
            var loopKey = void 0;

            for (var n = 0; n < allKeys.length; n++) {
                loopKey = allKeys[n];

                if (this.isSelected(loopKey, selectedKeys)) reachedSelected = true;

                if (loopKey == key) reachedCurrent = true;

                if (reachedCurrent || reachedSelected) this.select(loopKey, selectedKeys);

                if (reachedCurrent && reachedSelected) break;
            }
        }
    }, {
        key: 'changeSelection',
        value: function changeSelection(key, value, selectedKeys) {
            if (value == null) value = !Boolean(obj.selected);

            this.select(key, selectedKeys);
        }
    }, {
        key: 'getSelectedItems',
        value: function getSelectedItems(items, selectedKeys) {
            return items.filter(function (o) {
                return selectedKeys.indexOf(o.key) > -1;
            });
        }
    }, {
        key: 'unselectAll',
        value: function unselectAll(array) {
            var _this = this;

            this.getSelectedItems(array).forEach(function (item) {
                _this.changeSelection(item, false);
            });
        }
    }, {
        key: 'selectedOrClicked',
        value: function selectedOrClicked(obj, selectedObjects) {
            var idx = selectedObjects.findIndex(function (o) {
                return o.key == obj.key;
            });
            if (idx >= 0) return selectedObjects;else return [obj];
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'isValid',
        value: function isValid(expense) {
            if (expense.optional && expense.value == 0) return true;

            if (this.isInRange(expense)) return true;

            if (expense.explanation.length > 3) return true;
        }
    }, {
        key: 'isInRange',
        value: function isInRange(expense) {

            if (expense.name == 'Other') return false;
            return !this.isOverRange(expense) && !this.isUnderRange(expense);
        }
    }, {
        key: 'isOverRange',
        value: function isOverRange(expense) {
            return expense.value > expense.expectedValue * 1.3 + 50;
        }
    }, {
        key: 'isUnderRange',
        value: function isUnderRange(expense) {
            var result = expense.value < expense.expectedValue * .8 - 50;
            return result;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1094)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(2481),
  /* scopeId */
  "data-v-22c77b56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(2599),
  /* scopeId */
  "data-v-720dac24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(2504),
  /* scopeId */
  "data-v-37e0ad70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1047)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(2434),
  /* scopeId */
  "data-v-066e5573",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1254)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(2643),
  /* scopeId */
  "data-v-af1c9662",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1239)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(2627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1269)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(2658),
  /* scopeId */
  "data-v-cf4a0f7c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1176)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(2564),
  /* scopeId */
  "data-v-5b7c8e33",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(2499),
  /* scopeId */
  "data-v-307b07ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1122)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(2510),
  /* scopeId */
  "data-v-3b250d18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1170)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(2558),
  /* scopeId */
  "data-v-57cf6efc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(2590),
  /* scopeId */
  "data-v-6b901ed9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1054)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(2441),
  /* scopeId */
  "data-v-093a6fe1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1263)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(2652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1180)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(2568),
  /* scopeId */
  "data-v-5ceda94e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1046)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(2433),
  /* scopeId */
  "data-v-05a1b5a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(2532),
  /* scopeId */
  "data-v-46ab3a43",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(2571),
  /* scopeId */
  "data-v-5d970db8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(2593),
  /* scopeId */
  "data-v-6dfdb72e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1119)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(2507),
  /* scopeId */
  "data-v-38e41c22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1270)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(2659),
  /* scopeId */
  "data-v-cf61d1e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1243)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(2631),
  /* scopeId */
  "data-v-98b28b60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1252)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(2641),
  /* scopeId */
  "data-v-ae95bbaa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1162)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(2550),
  /* scopeId */
  "data-v-5359c51a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1050)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(2437),
  /* scopeId */
  "data-v-06dfce55",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(2500),
  /* scopeId */
  "data-v-31f555f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1067)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(2454),
  /* scopeId */
  "data-v-112d41ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */,
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(2674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Welcome__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Join__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Templates__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Templates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Templates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Transaction__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Transaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Transaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Maintenance__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Maintenance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Maintenance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_SupplierChecklist_SupplierDocuments__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_SupplierChecklist_SupplierDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_SupplierChecklist_SupplierDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LenderDocuments__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LenderDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_LenderDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SupplierChecklist_SupplierChecklist__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SupplierChecklist_SupplierChecklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_SupplierChecklist_SupplierChecklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_SupplierChecklist_DocumentChecklist__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_SupplierChecklist_DocumentChecklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_SupplierChecklist_DocumentChecklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_SupplierChecklist_ClientChecklist__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_SupplierChecklist_ClientChecklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_SupplierChecklist_ClientChecklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SupplierChecklist_ChecklistTemplates__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SupplierChecklist_ChecklistTemplates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_SupplierChecklist_ChecklistTemplates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Preferences__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Preferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Preferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Settings__ = __webpack_require__(2276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Dashboards__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Dashboards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Dashboards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_LayoutPage__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_LayoutPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_LayoutPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__screens_GridScreen__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__screens_GridScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__screens_GridScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__screens_BillingOld__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__screens_BillingOld___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__screens_BillingOld__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__flow_Workflow__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__flow_Workflow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__flow_Workflow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Billing_Billing__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Billing_Billing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_Billing_Billing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Billing_OneInvoice__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_Billing_OneInvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_Billing_OneInvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__system_SystemEditor__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__system_SystemEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__system_SystemEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_LayoutPage2__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_LayoutPage2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_LayoutPage2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_DownloadPage__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_DownloadPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_DownloadPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_LayoutPage3__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_LayoutPage3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_LayoutPage3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_LivingExpenses_LivingExpenses__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_LivingExpenses_LivingExpenses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_LivingExpenses_LivingExpenses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ItemList__ = __webpack_require__(2265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_ItemList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_ItemList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Components__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Charts_ChartRotator__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_Charts_ChartRotator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_Charts_ChartRotator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Charts_ChartSelector__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Charts_ChartSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_Charts_ChartSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Print__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Console__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Console___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Console__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_PrivacyPolicy__ = __webpack_require__(2275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_PrivacyPolicy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_MailLog__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_MailLog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_MailLog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__forms_Sample__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__forms_Sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__forms_Sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__dc_Maintenance__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__dc_Maintenance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__dc_Maintenance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__dc_Preferences__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__dc_Preferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__dc_Preferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__dc_Checklist__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__dc_Checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__dc_Checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__dc_Policies__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__dc_Policies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__dc_Policies__);














































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/welcome',
    name: 'Welcome',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Welcome___default.a
  }, {
    path: '/join',
    name: 'Join',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Join___default.a
  }, {
    path: '/layout',
    name: 'LayoutPage',
    component: __WEBPACK_IMPORTED_MODULE_17__components_LayoutPage___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/layout2',
    name: 'LayoutPage2',
    component: __WEBPACK_IMPORTED_MODULE_24__components_LayoutPage2___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/download',
    name: 'DownloadPage',
    component: __WEBPACK_IMPORTED_MODULE_25__components_DownloadPage___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/layout3',
    name: 'LayoutPage3',
    component: __WEBPACK_IMPORTED_MODULE_26__components_LayoutPage3___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/print',
    name: 'Print',
    component: __WEBPACK_IMPORTED_MODULE_32__components_Print___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/supplier-documents',
    name: 'SupplierDocuments',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_SupplierChecklist_SupplierDocuments___default.a
  }, {
    path: '/lender-documents',
    name: 'LenderDocuments',
    component: __WEBPACK_IMPORTED_MODULE_9__components_LenderDocuments___default.a
  }, {
    path: '/:tenant/supplier-checklist/:transaction?',
    name: 'SupplierChecklist',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_SupplierChecklist_SupplierChecklist___default.a,
    props: function props(route) {
      return {
        tenantKey: route.params.tenant,
        transactionKey: route.params.transaction
      };
    }
  }, {
    path: '/:tenant/document-checklist/:checklist?',
    name: 'DocumentChecklist',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_SupplierChecklist_DocumentChecklist___default.a,
    props: function props(route) {
      return {
        tenantKey: route.params.tenant,
        checklistKey: route.params.checklist,
        transactionKey: route.query.t
      };
    }
  }, {
    path: '/:tenant/checklist-templates/:checklist?',
    name: 'ChecklistTemplates',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_SupplierChecklist_ChecklistTemplates___default.a,
    props: function props(route) {
      return {
        tenantKey: route.params.tenant,
        checklistKey: route.params.checklist
      };
    }
  }, {
    path: '/client-checklist/:checklist?',
    name: 'ClientChecklist',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_SupplierChecklist_ClientChecklist___default.a,
    props: function props(route) {
      return {
        checklistKey: route.params.checklist
      };
    }
  }, {
    path: '/console',
    name: 'Console',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Console___default.a
  }, {
    path: '/preferences',
    name: 'Preferences',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Preferences___default.a,
    props: function props(route) {
      return {
        tenantKey: route.query.t,
        uid: route.query.u
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Settings___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: __WEBPACK_IMPORTED_MODULE_34__components_PrivacyPolicy___default.a,
    meta: {
      auth: false
    }
  }, {
    path: '/:tenant/transaction/:transaction',
    name: 'Transaction',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Transaction___default.a,
    props: function props(route) {
      return {
        tenantKey: route.params.tenant,
        transactionKeyProp: route.params.transaction
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/maintenance/',
    name: 'Maintenance',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Maintenance___default.a,
    props: function props(route) {
      return {
        item: route.query.item,
        action: route.query.action,
        transactionKey: route.query.transaction
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/templates/:template?',
    name: 'Templates',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Templates___default.a,
    props: function props(route) {
      return {
        selectedKey: route.params.template
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/dashboards/:dashboard?',
    name: 'Dashboards',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Dashboards___default.a,
    props: function props(route) {
      return {
        dashKey: route.params.dashboard
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/living',
    name: 'LivingExpenses',
    component: __WEBPACK_IMPORTED_MODULE_27__pages_LivingExpenses_LivingExpenses___default.a
  }, {
    path: '/item-list/:page',
    name: 'ItemList',
    component: __WEBPACK_IMPORTED_MODULE_28__components_ItemList___default.a
  }, {
    path: '/:tenant/charts/rotate',
    name: 'ChartRotator',
    component: __WEBPACK_IMPORTED_MODULE_30__pages_Charts_ChartRotator___default.a,
    props: function props(route) {
      return {
        tenantKey: route.params.tenant
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/:tenant/charts/select',
    name: 'ChartSelector',
    component: __WEBPACK_IMPORTED_MODULE_31__pages_Charts_ChartSelector___default.a,
    props: function props(route) {
      return {
        tenantKey: route.params.tenant
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/grid',
    name: 'GridScreen',
    component: __WEBPACK_IMPORTED_MODULE_18__screens_GridScreen___default.a,
    props: function props(route) {
      return {
        pageNumber: route.query.p
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/system',
    name: 'SystemEditor',
    component: __WEBPACK_IMPORTED_MODULE_23__system_SystemEditor___default.a,
    props: function props(route) {
      return {
        collectionId: route.query.c,
        teamId: route.query.t
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/mail-log',
    name: 'MailLog',
    component: __WEBPACK_IMPORTED_MODULE_35__components_MailLog___default.a,
    props: function props(route) {
      return {
        logId: route.query.l,
        email: route.query.e
      };
    },
    meta: {
      auth: true
    }
  }, {
    path: '/billingold',
    name: 'BillingOld',
    component: __WEBPACK_IMPORTED_MODULE_19__screens_BillingOld___default.a,
    meta: {
      auth: true
    },
    props: function props(route) {
      return {
        admin: route.query.admin
      };
    }
  }, {
    path: '/billing',
    name: 'Billing',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_Billing_Billing___default.a,
    meta: {
      auth: true
    },
    props: function props(route) {
      return {
        admin: route.query.admin
      };
    }
  }, {
    path: '/workflow/:flow',
    name: 'Workflow',
    component: __WEBPACK_IMPORTED_MODULE_20__flow_Workflow___default.a,
    meta: {
      auth: true
    },
    props: function props(route) {
      return {
        flowId: route.params.flow
      };
    }
  }, {
    path: '/invoice/:month/:invoice',
    name: 'OneInvoice',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_Billing_OneInvoice___default.a,
    meta: {
      auth: false
    },
    props: function props(route) {
      return {
        invoiceKey: route.params.invoice,
        month: route.params.month
      };
    }
  }, {
    path: '/components',
    name: 'Components',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Components___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/dc/maintenance',
    name: 'DcMaintenance',
    component: __WEBPACK_IMPORTED_MODULE_39__dc_Maintenance___default.a,
    meta: {
      auth: true
    },
    props: function props(route) {
      return {
        i: route.query.i
      };
    }
  }, {
    path: '/dc/preferences',
    name: 'DcPreferences',
    component: __WEBPACK_IMPORTED_MODULE_40__dc_Preferences___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/dc/policies',
    name: 'Policies',
    component: __WEBPACK_IMPORTED_MODULE_42__dc_Policies___default.a
  }, {
    path: '/dc/checklist',
    name: 'Checklist',
    component: __WEBPACK_IMPORTED_MODULE_41__dc_Checklist___default.a
  }, {
    path: '/forms/Sample',
    name: 'Sample',
    component: __WEBPACK_IMPORTED_MODULE_38__forms_Sample___default.a,
    meta: {
      auth: true
    }
  }, {
    path: '/',
    redirect: '/home'
  }]

});

router.beforeEach(function (to, from, next) {

  var requiresAuth = to.matched.some(function (record) {
    return record.meta.auth;
  });

  if (requiresAuth) {
    __WEBPACK_IMPORTED_MODULE_36_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
      console.log('Router waited for auth');
      if (!user) {
        debugger;
        return;
      } else next();
    });
  } else {
    console.log('Router is skipping auth');
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(2523),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1101)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(2489),
  /* scopeId */
  "data-v-2a59e42a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1175)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(2563),
  /* scopeId */
  "data-v-59de637e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1045)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(2432),
  /* scopeId */
  "data-v-05419379",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1234)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(2622),
  /* scopeId */
  "data-v-7f38dfab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);



var supportedModifiers = ['altKey', 'metaKey', 'ctrlKey', 'shiftKey'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    keyEvent: {
      type: String,
      default: 'keyup'
    },

    keyCode: {
      type: Number,
      default: null
    },
    modifiers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preventDefault: {
      type: Boolean
    },

    multipleKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      keyListeners: []
    };
  },
  mounted: function mounted() {
    this.setupListeners();
  },
  destroyed: function destroyed() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.keyListeners), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;
        var keyEvent = _ref.keyEvent,
            listener = _ref.listener;

        window.removeEventListener(keyEvent, listener);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  methods: {
    setupListeners: function setupListeners() {
      var expectedEvent = {
        keyEvent: this.keyEvent,

        keyCode: this.keyCode,
        preventDefault: this.preventDefault,
        modifiers: this.modifiers,

        multipleKeys: this.multipleKeys
      };
      this.addEventListener(expectedEvent);
    },
    addEventListener: function addEventListener(expectedEvent) {
      var listener = this.eventHandler(expectedEvent);
      window.addEventListener(expectedEvent.keyEvent, listener);
      this.keyListeners.push({ expectedEvent: expectedEvent, listener: listener });
    },
    eventHandler: function eventHandler(expectedEvent) {
      var _this = this;

      return function (event) {
        var emitResponse = function emitResponse(emitEvent, message) {
          _this.$emit(emitEvent, {
            event: event,
            expectedEvent: expectedEvent,
            message: message
          });
        };

        emitResponse('any', 'Any key was pressed.');

        var inMultipleKeysMode = expectedEvent.multipleKeys.length > 0;

        var inAnyKeyMode = !expectedEvent.keyCode && !inMultipleKeysMode;
        if (inAnyKeyMode) {
          emitResponse('success', 'Any key was pressed.');
          return;
        }

        var expectedInputs = [expectedEvent];
        if (inMultipleKeysMode) {
          expectedInputs = expectedEvent.multipleKeys;
        }

        var _loop = function _loop(expectedInput) {
          var correctKeyPressed = expectedInput.keyCode === event.keyCode;
          if (!correctKeyPressed) return 'continue';

          var hasModifiers = expectedInput.modifiers.length > 0;

          if (hasModifiers) {
            var modifiersPressed = supportedModifiers.every(function (x) {
              return event[x] == (expectedInput.modifiers.indexOf(x) !== -1);
            });
            if (!modifiersPressed) return 'continue';
          }

          if (expectedEvent.preventDefault) {
            event.preventDefault();
          }
          emitResponse('success', 'Correct key(s) pressed.');
          return {
            v: void 0
          };
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(expectedInputs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var expectedInput = _step2.value;

            var _ret = _loop(expectedInput);

            switch (_ret) {
              case 'continue':
                continue;

              default:
                if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        emitResponse('wrong', 'Wrong key(s) pressed.');
      };
    }
  },
  render: function render() {
    return null;
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_AppHelpers__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_ChatWindow__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_ChatWindow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_ChatWindow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_EmailIndicator__ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_EmailIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_EmailIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ConfirmDialog__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ConfirmDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_ConfirmDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_YouTubeDialog__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_YouTubeDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_YouTubeDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_FormDialog__ = __webpack_require__(2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_FormDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_FormDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_PageHelpers__ = __webpack_require__(72);




















var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'app',

    data: function data() {
        return {
            loginStatus: "Unknown",
            loginEnabled: true
        };
    },


    components: {
        ChatWindow: __WEBPACK_IMPORTED_MODULE_10__ui_elements_ChatWindow___default.a,
        ConfirmDialog: __WEBPACK_IMPORTED_MODULE_12__ui_elements_ConfirmDialog___default.a,
        YouTubeDialog: __WEBPACK_IMPORTED_MODULE_13__ui_elements_YouTubeDialog___default.a,
        EmailIndicator: __WEBPACK_IMPORTED_MODULE_11__ui_elements_EmailIndicator___default.a,
        FormDialog: __WEBPACK_IMPORTED_MODULE_14__ui_elements_FormDialog___default.a
    },

    methods: {
        signIn: function signIn() {
            console.log('signing in');

            this.loginEnabled = false;

            this.$store.commit('loginStatus', "Signing In");

            var provider = new __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth.GoogleAuthProvider();
            provider.addScope('email');
            provider.addScope('profile');

            provider.setCustomParameters({
                prompt: 'select_account'
            });

            __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().signInWithPopup(provider);
        },
        clearAlert: function clearAlert() {
            __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__["a" /* default */].clearAlert();
        },
        usersOfficesToArray: function usersOfficesToArray(user) {
            var offices = [];
            for (var officeKey in user.offices) {
                var office = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user.offices[officeKey]);
                office.meta = {
                    key: officeKey,
                    userKey: user.uid
                };
                offices.push(office);
            }
            return offices;
        }
    },

    computed: {
        isChatting: function isChatting() {
            return __WEBPACK_IMPORTED_MODULE_15__helpers_PageHelpers__["a" /* default */].getPageData('isChatting');
        },
        officeName: function officeName() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].officeName();
        },
        userName: function userName() {
            if (this.$store.getters.user) return __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].fullName(this.$store.getters.user);else return 'Not Signed In';
        },
        userPicture: function userPicture() {
            if (this.$store.getters.user && this.$store.getters.user.image) return this.$store.getters.user.image;else return '';
        },
        loginDialogVisible: function loginDialogVisible() {
            return this.loginStatus != 'Signed In' && this.$route.name != 'LivingExpenses' && this.$route.name != 'ClientChecklist' && this.$route.name != 'PrivacyPolicy' && this.$route.name != 'OneInvoice' && this.$route.name != 'Policies';
        },
        showLoginButton: function showLoginButton() {
            return this.loginStatus == 'Signed Out';
        },
        showSigningIn: function showSigningIn() {
            return this.loginStatus == 'Signing In';
        },
        alert: function alert() {
            return this.$store.getters.alert;
        },
        alertMessage: function alertMessage() {
            return this.$store.getters.alert.message;
        },
        officName: function officName() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].preferredOffice().name;
        }
    },

    created: function created() {

        this.loginStatus = this.$store.getters.loginStatus;

        var vm = this;
        __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.auth().onAuthStateChanged(function (googleUser) {
            console.log('Google user is ', googleUser);
            if (googleUser) {
                vm.$eventBus.$emit('signed-in');

                vm.$store.commit('loginStatus', "Signed In");

                vm.loginStatus = "Signed In";

                db.ref('users').child(googleUser.uid).once('value', function (snap) {

                    var user = snap.val();

                    if (user && user.office) {

                        vm.$store.commit('setUser', {
                            firstName: user.firstName || null,
                            lastName: user.lastName || null,
                            uid: user.uid || null,
                            image: user.image || null,
                            office: user.office || null,
                            email: user.email || null,
                            mobile: user.mobile || null
                        });

                        vm.$store.commit('setOffices', vm.usersOfficesToArray(user));
                        __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].initialiseTenant(user.office.key, true);
                        vm.$store.commit('setTenantDefault', user.office);

                        if (vm.$route.name == 'Welcome') {
                            console.log('Already signed in');
                            vm.$router.push('/home');
                        }
                    } else {
                        var userContact = __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].contactFromUser(googleUser);
                        vm.$store.commit('setUser', userContact);
                        vm.$router.push('/join');
                    }
                });
            } else {
                vm.loginStatus = "Signed Out";
                vm.$store.commit('loginStatus', "Signed Out");
                vm.$store.commit('setUser', {});
            }
        });

        Number.prototype.between = function (a, b) {
            var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var min = Math.min.apply(Math, [a, b]),
                max = Math.max.apply(Math, [a, b]);
            return inclusive ? this >= min && this <= max : this > min && this < max;
        };
        String.prototype.append = function (str) {
            var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

            var newString = this;
            if (newString && str) newString += delimiter;
            if (str) newString += str;

            return newString;
        };

        String.prototype.contains = function (str) {
            if (!this) return false;
            if (!str) return true;

            var outerString = this.toLowerCase();
            var innerString = str.toLowerCase();
            return outerString.indexOf(innerString) > -1;
        };

        String.prototype.wrap = function (prefix, suffix) {
            if (!this) return '';
            return (prefix || '') + this + (suffix || '');
        };

        Date.prototype.formatBackwards = function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(this, __WEBPACK_IMPORTED_MODULE_9__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS);
        };
    },
    mounted: function mounted() {
        this.$root.$youTube = this.$refs.youtube.open;
        this.$root.$confirm = this.$refs.confirm.open;
        this.$root.$monitorMail = this.$refs.emailIndicator.show;
        this.$root.$dialog = this.$refs.formDialog.open;
    },


    watch: {
        'loginDialogVisible': function loginDialogVisible(newVal) {
            if (newVal) this.loginEnabled = true;
        }
    },

    beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_OrderHelpers__ = __webpack_require__(29);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        element: Object,
        settings: Object
    },

    computed: {
        options: function options() {
            return (this.element.options || String('')).split(',').map(function (s) {
                return s.trim();
            });
        },
        elementOuterStyle: function elementOuterStyle() {
            return {
                'width': this.settings.narrow ? '100%' : this.element.width + '%'
            };
        },
        elementStyle: function elementStyle() {
            var style = {
                'border-style': 'dashed',
                'border-width': '2px',
                'border-color': this.settings.editing ? '#ddd' : 'transparent',
                'padding': '3px',
                'border-radius': '3px'
            };

            var borderColour = 'transparent';
            if (this.settings.editing) {

                if (this.settings.elementEditing == this.element) borderColour = '#1976d2';else borderColour = '#ddd';
            }
            style['border-color'] = borderColour;

            return style;
        },
        elementClass: function elementClass() {
            var classString = "element-inner";
            return classString;
        },
        elementOuterClass: function elementOuterClass() {
            var classString = "element-outer";
            if (this.element.height == 'S') classString += ' height-small';
            return classString;
        },
        disabled: function disabled() {
            return this.settings.editing || this.element.disabled;
        },
        hideDetails: function hideDetails() {
            return this.element.height != 'L';
        },
        singleLine: function singleLine() {
            return this.element.height == 'S';
        },
        htmlValue: function htmlValue() {
            if (this.element.value) return this.element.value;
            if (this.element.defaultValue) return this.element.defaultValue;
            return '[No Value]';
        }
    },

    methods: {
        elementClicked: function elementClicked(element) {
            this.$emit('click', this.element);
        }
    },

    created: function created() {}
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar__);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ColourBar: __WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar___default.a
    },

    props: {
        element: Object
    },

    computed: {
        heightOptions: function heightOptions() {
            return [{ text: 'Small', value: 'S' }, { text: 'Normal', value: null }, { text: 'Large', value: 'L' }];
        },
        typeOptions: function typeOptions() {
            return ['Text', 'Section', 'Column', 'Checkbox', 'List', 'Html', 'Group'];
        },
        isTypeDisabled: function isTypeDisabled() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_ArrayHelpers__["a" /* default */].textInArray(this.element.type, ['Section', 'Column']);
        },
        widthLabel: function widthLabel() {
            return 'Width (' + (this.element.width || '00') + '%)';
        }
    },

    methods: {
        buttonClicked: function buttonClicked(eventString) {
            var payload = this.element;
            this.$emit('button-click', eventString, payload);
        },
        isVisible: function isVisible(field) {
            var t = this.element.type;
            var isLayout = t == 'Column' || t == 'Section';

            if (field == 'title') return t != 'Html';
            if (field == 'name') return t != 'Column';
            if (field == 'options') return t == 'List';
            if (field == 'width') return t != 'Section';
            if (field == 'height') return !isLayout && t != "Html";
            if (field == 'table') return t == 'Section';
            if (field == 'height') return !isLayout;
            if (field == 'save-section') return t == 'Section';
            if (field == 'add-column') return t == 'Section';
            if (field == 'clone-element') return !isLayout;
            if (field == 'default-value-textarea') return t == 'Html';
            if (field == 'background-colour') return isLayout;
            return true;
        },


        debouncedElementChanged: __WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__["a" /* default */].debounce(function (val) {
            __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__["a" /* default */].showAlert('Element Changed');
            console.log('Element Changed', val);
        }, 3000)
    },

    created: function created() {
        console.log('EditPanel > created');
    },


    watch: {
        element: {
            handler: function handler(val, oldVal) {
                this.debouncedElementChanged(val);
            },
            deep: true
        }
    }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default.a
    },

    props: {
        settings: Object,
        element: Object
    },

    computed: {
        property1: function property1() {}
    },

    methods: {
        initialiseDialog: function initialiseDialog() {}
    },

    created: function created() {}
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_UploadWrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_UploadWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_UploadWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__ = __webpack_require__(52);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            uploading: false
        };
    },


    components: {
        UploadWrapper: __WEBPACK_IMPORTED_MODULE_2__ui_elements_UploadWrapper___default.a
    },

    props: {
        field: Object,
        record: Object
    },

    computed: {},

    methods: {
        doNothing: function doNothing() {
            var _this = this;

            this.$set(this.field, 'disabled', true);
            setTimeout(function () {
                _this.$set(_this.field, 'disabled', false);
            }, 1000);
        },
        uploadFiles: function uploadFiles(files) {
            var _this2 = this;

            this.uploading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__["a" /* default */].filesToFirebase(files, 'fieldUploads').then(function (fileGroup) {
                var newArrayValue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.record[_this2.field.name] || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(fileGroup));
                _this2.$set(_this2.record, _this2.field.name, newArrayValue);
                _this2.uploading = false;
            });
        },
        fileNameFromStoragePath: function fileNameFromStoragePath(path) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__["a" /* default */].fileNameFromStoragePath(path);
        },
        deleteFileFromGroup: function deleteFileFromGroup(file) {

            __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__["a" /* default */].deleteFirebaseFile(file.url);
            var idx = this.record[this.field.name].findIndex(function (o) {
                return o.url == file.url;
            });
            this.record[this.field.name].splice(idx, 1);
        }
    },

    created: function created() {}
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_DateTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileField__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FileField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            editing: false
        };
    },


    components: {
        FileField: __WEBPACK_IMPORTED_MODULE_3__FileField___default.a,
        DateTime: __WEBPACK_IMPORTED_MODULE_0__ui_elements_DateTime___default.a
    },

    props: {
        field: {
            default: function _default() {
                return {};
            },
            type: Object
        },
        record: Object,
        settings: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        options: function options() {
            if (!this.field.options) return [];
            if (Array.isArray(this.field.options)) return this.field.options;

            return (this.field.options || String('')).split(',').map(function (s) {
                return s.trim();
            });
        },


        value: {
            get: function get() {
                return this.record[this.field.name];
            },
            set: function set(newVal) {
                this.$set(this.record, this.field.name, newVal);
            }
        },

        fieldOuterStyle: function fieldOuterStyle() {
            return {
                'width': (this.field.width || '100') + '%'
            };
        },
        fieldStyle: function fieldStyle() {

            var style = {
                'border-style': 'dashed',
                'border-width': '2px',
                'border-color': this.settings && this.settings.editing ? '#ddd' : 'transparent',
                'padding': '3px',
                'border-radius': '3px'
            };
            return style;
        },
        fieldClass: function fieldClass() {
            var classString = "field-inner";
            if (this.field.compact) classString += ' compact';
            return classString;
        },
        fieldOuterClass: function fieldOuterClass() {
            var classString = "field-outer";
            if (this.field.height == 'S') classString += ' height-small';
            return classString;
        },
        disabled: function disabled() {
            return this.settings.editing || this.field.disabled;
        },
        hideDetails: function hideDetails() {
            return this.field.height != 'L';
        },
        singleLine: function singleLine() {
            return this.field.height == 'S';
        },
        htmlValue: function htmlValue() {
            if (this.record[this.field.name]) return this.record[this.field.name];
            if (this.field.defaultValue) return this.field.defaultValue;
            return '[No Value]';
        },
        visible: function visible() {
            var filter = this.field.visibleFilter;
            if (filter == null) return true;

            if (this.field.type == 'Menu') return false;

            console.log('running visible on', this.field);

            var mergeFields = __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__["a" /* default */].findMergeFields(filter);

            filter = __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__["a" /* default */].mergeRecord(filter, mergeFields, this.record);
            console.log('expression testing on', filter);

            try {
                return eval(filter);
            } catch (err) {
                console.log('Error in eval: ', err, filter);
            }
        }
    },

    methods: {
        startEditing: function startEditing() {
            this.editing = true;
        },
        finishEditing: function finishEditing() {
            this.editing = false;
        },
        isGroupVisible: function isGroupVisible(field, record) {
            return record[field.name] && record[field.name].length || !field.disabled;
        },
        createAndPush: function createAndPush() {
            if (!this.record[this.field.name]) this.$set(this.record, this.field.name, []);

            this.record[this.field.name].push({});
        },
        fieldClicked: function fieldClicked(field) {
            this.$emit('click', this.field);
        },
        changed: function changed(newVal, oldVal) {
            var changes = {
                value: newVal,
                oldValue: oldVal || null,
                field: this.field,
                name: this.field.name
            };
            this.$emit('change', changes);
        },
        blurred: function blurred() {
            if (this.field.clickToEdit) this.editing = false;
        },
        updateEmbeddedInformation: function updateEmbeddedInformation() {
            if (this.field.type == 'Embed') {
                var vm = this;
                if (!this.value) {
                    vm.$refs.embedded.innerHTML = '';
                    return;
                }

                fetch(this.value).then(function (res) {
                    return res.text();
                }).then(function (data) {
                    data = data || '';
                    vm.$refs.embedded.innerHTML = data;
                });
            }
        }
    },

    watch: {
        'value': function value(newVal, oldVal) {
            this.$emit('input', newVal);
            if (this.field.type != 'Text') this.changed(newVal, oldVal);
            this.updateEmbeddedInformation();
        },
        immediate: true
    },

    mounted: function mounted() {
        this.updateEmbeddedInformation();
    },
    created: function created() {
        if (this.field.clickToEdit && !this.value) this.editing = true;
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_ElementDialog__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_ElementDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__builder_ElementDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__builder_EditPanel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__builder_EditPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__builder_EditPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__builder_ControlElement__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__builder_ControlElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__builder_ControlElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            componentWidth: null,
            settings: {
                editing: false,
                narrow: false
            },
            elementDialog: {
                settings: {
                    visible: false,
                    title: 'Section Details'
                }
            },

            elementEditing: {}

        };
    },


    components: {
        ElementDialog: __WEBPACK_IMPORTED_MODULE_2__builder_ElementDialog___default.a,
        EditPanel: __WEBPACK_IMPORTED_MODULE_3__builder_EditPanel___default.a,
        ControlElement: __WEBPACK_IMPORTED_MODULE_4__builder_ControlElement___default.a,
        draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a
    },

    props: {
        section: Object
    },

    computed: {
        pageSettings: function pageSettings() {
            var settings = {
                narrow: this.narrow,
                editing: this.settings.editing,
                elementEditing: this.elementEditing
            };
            return settings;
        },
        narrow: function narrow() {
            return this.componentWidth < 400;
        },
        sectionOuter: function sectionOuter() {
            return {
                'border-style': this.settings.editing ? 'dashed' : 'solid',
                'border-width': '2px',
                'border-color': this.settings.editing ? '#ddd' : 'transparent',
                'border-radius': '5px',
                'padding': '3px',
                'background-color': this.section.background || ''
            };
        },
        sectionContentStyle: function sectionContentStyle() {
            var style = {};
            style.display = this.narrow ? 'block' : 'flex';
            return style;
        },
        sectionClass: function sectionClass() {
            return 'section' + (!this.settings.editing ? ' elevation-1' : '');
        },
        sectionHeading: function sectionHeading() {
            return "margin:5px;padding:6px 10px;color:white;background-color: #aaa;font-weight:600;border-radius:5px;text-transform: uppercase;";
        },
        page: function page() {
            return this.$route.params.page;
        }
    },

    methods: {
        columnOuterStyle: function columnOuterStyle(column) {
            return {
                'background-color': column.background || '',
                'border-radius': '5px',
                'width': column.width && !this.narrow ? column.width + '%' : ''
            };
        },
        showElementDialog: function showElementDialog() {
            this.elementDialog.settings.visible = true;
        },
        editSection: function editSection() {
            this.elementEditing = this.section;
        },
        editColumn: function editColumn(colIndex) {
            this.elementEditing = this.section.columns[colIndex];
        },
        elementClicked: function elementClicked(element) {
            this.elementEditing = element;
        },
        editPanelButtonClick: function editPanelButtonClick(eventString, payload) {
            if (eventString == 'add-column') {
                console.log('Adding column...');
                var columnNumber = this.section.columns.length + 1;
                this.section.columns.push({
                    key: '2342342',
                    title: 'Column ' + columnNumber,
                    name: 'column_' + columnNumber
                });
            }
            if (eventString == 'save-section') {
                this.saveSection(payload);
            }
            if (eventString == 'clone-element') {
                this.cloneElement(payload);
            }
        },
        saveSection: function saveSection(section) {
            console.log('Saving section...');

            section.page = this.page;

            var ref = __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getTenantRef().child('sections');
            __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].removeUndefinedProperties(section);
            __WEBPACK_IMPORTED_MODULE_1__data_FireData__["a" /* default */].saveItem(section, ref);
        },
        cloneElement: function cloneElement(element) {
            console.log('Cloning element...', element);
        },
        afterDrag: function afterDrag() {},
        prepareElement: function prepareElement(element, colIndex, elIndex) {
            element.colIndex = colIndex;
            element.elIndex = elIndex;
        },
        windowResized: function windowResized() {
            console.log('setting to ' + this.$el.offsetWidth);
            this.componentWidth = this.$el.offsetWidth;
        },


        debouncedWindowResized: __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].debounce(function (event, vm) {
            vm.windowResized();
        }, 500)

    },
    mounted: function mounted() {
        this.windowResized();
    },
    created: function created() {
        window.addEventListener('resize', this.debouncedWindowResized.bind(null, event, this));
    },
    destroyed: function destroyed() {
        document.removeEventListener("resize", this.debouncedWindowResized);
    }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        item: Object
    },

    computed: {
        property1: function property1() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ContactAutocomplete__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ContactAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_ContactAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_DynamicControl__ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_DynamicControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_DynamicControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Components',
    data: function data() {
        return {
            selectedContacts: [],
            contacts: [{ key: 1, firstName: 'Matt', lastName: 'Ireland', email: 'matt@ireland.mx', mobile: '0413999951', image: 'https://placeimg.com/40/40/people/45' }, { key: 2, firstName: 'Linda', lastName: 'Ireland', email: 'linda@ireland.mx', mobile: '0414012714', image: 'https://placeimg.com/40/40/people/46' }, { key: 3, firstName: 'Peter', lastName: 'Solomon', email: 'pete.solomon@mortgagechoice.com.au', mobile: '0413999953', image: 'https://placeimg.com/40/40/people/47' }],

            dateAndTime: '2013-02-27 10:30pm',
            specialValue: 'Hello',
            specialField: {
                name: 'MyField',
                type: 'tf'
            }

        };
    },

    components: {
        ContactAutocomplete: __WEBPACK_IMPORTED_MODULE_1__ui_elements_ContactAutocomplete___default.a,
        DateTime: __WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime___default.a,
        DynamicControl: __WEBPACK_IMPORTED_MODULE_3__ui_elements_DynamicControl___default.a,
        SectionLayout: __WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout___default.a,
        ElementLayout: __WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout___default.a,
        LayoutReadOnly: __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly___default.a
    },
    computed: {},
    methods: {}
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Template',
    components: { ScreenLayout: __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default.a },
    data: function data() {
        return {};
    },

    computed: {},
    methods: {}
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_Dashboard__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_Dashboard__);









/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'Dashboards',

    data: function data() {
        return {
            editMode: false,
            dashes: [],
            dash: {
                name: null,
                section: null,
                field: null
            }
        };
    },


    props: {
        dashKey: String
    },

    components: {
        Dashboard: __WEBPACK_IMPORTED_MODULE_6__ui_elements_Dashboard___default.a
    },

    computed: {
        dashRef: function dashRef() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('dashboards');
        },
        pageTitle: function pageTitle() {
            return "Dashboards" + (this.dash && this.dash.name ? ' - ' + this.dash.name : '');
        }
    },
    methods: {
        saveDash: function saveDash(dash) {
            __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(dash, this.dashRef);
        },
        selectDash: function selectDash(dash) {
            this.$router.push('/dashboards/' + dash.key);
        },
        loadDash: function loadDash() {
            var _this = this;

            var dash = this.dashes.find(function (o) {
                return o.key == _this.dashKey;
            });

            if (dash) this.dash = dash;
        }
    },

    watch: {
        dashKey: function dashKey(newVal, oldVal) {
            this.loadDash(newVal);
        }
    },
    created: function created() {
        var _this2 = this;

        this.dashRef.on('value', function (snap) {
            _this2.dashes = __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
            _this2.loadDash();
        });
    }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer2__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_ElementControl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_ElementControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__screens_ElementControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ElementMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ElementMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__screens_ElementMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ScrollHelpers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_AutomaticScroll__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_AutomaticScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_AutomaticScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_json_to_csv__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_json_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_NiceData__ = __webpack_require__(15);


















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            contacts: []
        };
    },


    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_10__screens_ScreenLayout___default.a,
        PageLayout: __WEBPACK_IMPORTED_MODULE_11__screens_PageLayout___default.a,
        LayoutContainer2: __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer2___default.a,
        SectionLayout: __WEBPACK_IMPORTED_MODULE_3__screens_SectionLayout___default.a,
        ElementLayout: __WEBPACK_IMPORTED_MODULE_5__screens_ElementLayout___default.a,
        LayoutReadOnly: __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutReadOnly___default.a,
        ElementMenu: __WEBPACK_IMPORTED_MODULE_7__screens_ElementMenu___default.a,
        ElementControl: __WEBPACK_IMPORTED_MODULE_4__screens_ElementControl___default.a,
        AutomaticScroll: __WEBPACK_IMPORTED_MODULE_12__ui_elements_AutomaticScroll___default.a,
        VueJsonToCsv: __WEBPACK_IMPORTED_MODULE_13_vue_json_to_csv___default.a
    },

    props: {},

    computed: {
        officeName: function officeName() {
            return __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].officeName();
        }
    },

    methods: {
        scrolled: function scrolled(key) {
            this.activeMenuKey = key;
        },
        elementMenuClicked: function elementMenuClicked(item, section) {
            this.activeMenuKey = section ? section.key : item.key;
            this.activeElement = item;
        }
    },

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var ref;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            ref = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contacts');
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_14__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref);

                        case 3:
                            _this.contacts = _context.sent;

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    mounted: function mounted() {}
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ContactSelector__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ContactSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_ContactSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_ContactSearch__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_ContactSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_ContactSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_AddClients__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_AddClients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_AddClients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_CommunicationBar__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_CommunicationBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ui_elements_CommunicationBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_TasksByLender__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_TasksByLender___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ui_elements_TasksByLender__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_ReassignTasksDialog__ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_ReassignTasksDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_ReassignTasksDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_KanbanView__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_KanbanView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ui_elements_KanbanView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_elements_TaskWarnings__ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_elements_TaskWarnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ui_elements_TaskWarnings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactEditor__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_AppHelpers__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_GenericListDialog__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_GenericListDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ui_elements_GenericListDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_elements_MaintenanceDialog__ = __webpack_require__(2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_elements_MaintenanceDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ui_elements_MaintenanceDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers_TenantHelpers__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ui_elements_Announcements__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ui_elements_Announcements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__ui_elements_Announcements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__ui_elements_NoRecordsPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__ui_elements_EmailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_elements_LabelMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_elements_LabelMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__ui_elements_LabelMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_elements_OfficeChooser__ = __webpack_require__(2402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_elements_OfficeChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__ui_elements_OfficeChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__helpers_PageHelpers__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__helpers_TransactionHelpers__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__helpers_CollectionHelpers__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__helpers_AlgoliaHelpers__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ui_elements_AlgoliaContacts__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__ui_elements_AlgoliaContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__ui_elements_AlgoliaContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_keypress__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_keypress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_vue_keypress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ui_elements_ChargeDialog__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ui_elements_ChargeDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__ui_elements_ChargeDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__helpers_CloudHelpers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ui_elements_LookupDataDialog__ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ui_elements_LookupDataDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__ui_elements_LookupDataDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__data_MilestoneData__ = __webpack_require__(716);


























































var db = __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.database();

var contactsRef;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    components: {
        ReassignTasksDialog: __WEBPACK_IMPORTED_MODULE_17__ui_elements_ReassignTasksDialog___default.a,
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout___default.a,
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton___default.a,
        ContactSelector: __WEBPACK_IMPORTED_MODULE_12__ui_elements_ContactSelector___default.a,
        AddClients: __WEBPACK_IMPORTED_MODULE_14__ui_elements_AddClients___default.a,
        CommunicationBar: __WEBPACK_IMPORTED_MODULE_15__ui_elements_CommunicationBar___default.a,
        Flag: __WEBPACK_IMPORTED_MODULE_20__ui_elements_Flag___default.a,
        ContactEditor: __WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactEditor___default.a,
        ContactSearch: __WEBPACK_IMPORTED_MODULE_13__ui_elements_ContactSearch___default.a,
        TasksByLender: __WEBPACK_IMPORTED_MODULE_16__ui_elements_TasksByLender___default.a,
        KanbanView: __WEBPACK_IMPORTED_MODULE_18__ui_elements_KanbanView___default.a,
        TaskWarnings: __WEBPACK_IMPORTED_MODULE_19__ui_elements_TaskWarnings___default.a,
        GenericListDialog: __WEBPACK_IMPORTED_MODULE_29__ui_elements_GenericListDialog___default.a,
        MaintenanceDialog: __WEBPACK_IMPORTED_MODULE_30__ui_elements_MaintenanceDialog___default.a,
        Announcements: __WEBPACK_IMPORTED_MODULE_34__ui_elements_Announcements___default.a,
        NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_35__ui_elements_NoRecordsPlaceholder___default.a,
        EmailDialog: __WEBPACK_IMPORTED_MODULE_36__ui_elements_EmailDialog___default.a,
        LabelMenu: __WEBPACK_IMPORTED_MODULE_37__ui_elements_LabelMenu___default.a,
        OfficeChooser: __WEBPACK_IMPORTED_MODULE_38__ui_elements_OfficeChooser___default.a,
        AlgoliaContacts: __WEBPACK_IMPORTED_MODULE_45__ui_elements_AlgoliaContacts___default.a,
        KeyPress: __WEBPACK_IMPORTED_MODULE_46_vue_keypress___default.a,
        ChargeDialog: __WEBPACK_IMPORTED_MODULE_47__ui_elements_ChargeDialog___default.a,
        LookupDataDialog: __WEBPACK_IMPORTED_MODULE_51__ui_elements_LookupDataDialog___default.a
    },

    data: function data() {
        return {

            milestones: [],
            reassignTasksDialog: {
                settings: {
                    title: 'Reassign Tasks',
                    visible: false,
                    closeOnly: true
                }
            },
            chargeDialog: {
                settings: {
                    visible: false
                },
                charge: {
                    amount: 0,
                    date: null,
                    from: null,
                    to: null,
                    clients: null,
                    description: null
                }
            },
            lookupDataDialog: {
                settings: {
                    closeOnly: true,
                    visible: false
                }
            },
            renameTransactionDialog: {
                transaction: {},
                visible: false
            },
            importantOnly: false,
            transactionTemplates: [],
            taskListeners: [],
            tasksHeading: 'My Tasks',
            localTasks: {},
            tasksByLenderSettings: {
                showInitials: false,
                condensed: false
            },
            loadLimit: 100,
            addMenuVisible: false,
            menuVisible: false,
            selectedUser: {},
            users: [],
            loading: false,
            contacts1: [],
            showingSearch: false,
            search: '',

            actionDialog: {
                visible: false,
                transactions: [],
                showingSMS: false,
                smsMessage: '',
                smsPrefix: null,
                smsSuffix: null,
                model: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    mobile: ''

                }
            },
            transactionDialog: {
                visible: false,
                withPartner: true,
                contact: {
                    firstName: '',
                    lastName: ''

                },
                model: {
                    description: '',
                    masterKey: null
                }
            },
            contactSelector: {
                visible: false,
                onok: this.linkSpouse,
                data: {},
                title: 'Select a Contact'
            },

            contactEditor: {
                contact: { meta: {} },
                settings: {
                    visible: false
                }
            },

            genericListDialog: {
                settings: {
                    visible: false,
                    title: 'Activity History'
                },
                items: []
            },

            maintenanceDialog: {
                settings: {
                    visible: false,
                    title: 'Maintenance'
                },
                item: {}
            },
            emailDialog: {

                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: '',
                    attachments: []
                },
                settings: {
                    visible: false,
                    sent: false
                },
                returnObject: null
            },

            addClientsVisible: false,

            dueTasks: true,
            searchDuration: 'Today'
        };
    },


    watch: {},

    computed: {
        masterKey: function masterKey() {
            return __WEBPACK_IMPORTED_MODULE_50__helpers_LookupData__["a" /* default */].getMasterKey();
        },
        debugInfinite: function debugInfinite() {
            console.log('debugging infinite');
            return false;
        },


        isChatting: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_40__helpers_PageHelpers__["a" /* default */].getPageData('isChatting');
            },
            set: function set(newVal) {
                __WEBPACK_IMPORTED_MODULE_40__helpers_PageHelpers__["a" /* default */].setPageData('isChatting', newVal);
            }
        },
        kanbanViewStages: function kanbanViewStages() {
            return __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__["a" /* default */].nextFiveWorkingDays().map(function (o) {
                return { text: o.day, value: o.date };
            });
            return [{ value: 'm', text: 'Monday' }, { value: 't', text: 'Tuesday' }, { value: 'w', text: 'Wednesday' }, { value: 'th', text: 'Thursday' }, { value: 'f', text: 'Friday' }];
        },
        defaultTransactionTemplateKey: function defaultTransactionTemplateKey() {
            if (this.transactionTemplates.length < 1) return null;
            var template = this.transactionTemplates.find(function (o) {
                return o.meta.key;
            });
            if (template) return template.meta.key;
            return this.transactionTemplates[0];
        },
        filteredLocalTasks: function filteredLocalTasks() {
            var _this = this;

            var tasks = [];
            for (var officeKey in this.localTasks) {
                tasks = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(tasks), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.localTasks[officeKey]));
            }

            if (this.search) {
                var searchedTasks = tasks.filter(function (o) {
                    if (!o || !o.clients) return false;
                    return o.clients.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
                });
                if (searchedTasks.length) return searchedTasks;
            }

            if (this.searchDuration == 'Today') tasks = tasks.filter(function (o) {
                return o.due <= __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__["a" /* default */].todayString();
            });

            if (this.importantOnly) tasks = tasks.filter(function (o) {
                return o.important;
            });

            return tasks;
        },
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        },
        offices: function offices() {
            return this.$store.getters.offices;
        },
        officesActive: function officesActive() {
            return this.$store.getters.officesActive;
        },
        currentOffice: function currentOffice() {
            var _this2 = this;

            return this.offices.find(function (o) {
                return o.meta.key == _this2.tenantKey;
            });
        },
        hasMultipleOffices: function hasMultipleOffices() {
            return this.offices.length > 1;
        },
        officesWithUsers: function officesWithUsers() {
            var _this3 = this;

            var offices = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getOfficesWithRefs();
            offices.forEach(function (office) {
                _this3.$set(office, 'users', []);
                office.ref.child('contacts').orderByChild('user').equalTo(true).once('value', function (snap) {
                    var userList = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].snapshotToArray(snap);
                    _this3.$set(office, 'users', userList);
                });
            });
            return offices;
        },
        contacts: function contacts() {
            return this.$store.getters.contacts;
        },
        loadingContacts: function loadingContacts() {
            return this.$store.getters.status('searchContacts') == 'Loading' || this.$store.getters.status('recentContacts') == 'Loading';
        },
        showAssignedUser: function showAssignedUser() {
            return !this.selectedUser || this.user.uid && this.selectedUser.uid != this.user.uid;
        },
        selectedUserName: function selectedUserName() {
            if (this.selectedUser) return this.selectedUser.firstName + ' ' + this.selectedUser.lastName;else return 'Everyone';
        },
        userImage: function userImage() {
            return this.$store.getters.user.image || '/static/images/loader-basic.gif';
        },
        user: function user() {
            return this.$store.getters.user;
        },
        contactDialogImageVisible: function contactDialogImageVisible() {
            if (this.contactDialog.model.image && this.contactDialog.model.image.indexOf('transparent') < 0) return true;else return false;
        },
        showLoader: function showLoader() {
            return this.loading && this.$store.getters.loginStatus == "Signed In";
        },
        loadingMessage: function loadingMessage() {
            return this.$store.getters.loadingMessage;
        },
        tenantKey: function tenantKey() {
            return this.$store.getters.tenantKey;
        },
        isInsight: function isInsight() {
            var user = this.$store.getters.user;
            return __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].isInsightUser(user);
        },
        overdueFilteredTasks: function overdueFilteredTasks() {
            return this.filteredLocalTasks.filter(function (o) {
                return o.due < __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__["a" /* default */].todayString();
            });
        },
        vtwo: function vtwo() {
            return window.location.hostname.indexOf('vtwo') > -1;
        }
    },
    methods: {
        imagePath: function imagePath(transaction) {
            if (transaction.lender) return '/static/images/lenders/' + transaction.lender + '.jpg';else return 'https://placeimg.com/40/40/people/1';
        },
        viewEmailLogs: function viewEmailLogs(email) {
            this.$router.push('/mail-log?e=' + email);
        },
        bringForward: function bringForward() {
            this.overdueFilteredTasks.forEach(function (task) {
                var changes = {
                    due: __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__["a" /* default */].todayString(),
                    meta: task.meta
                };
                __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].saveItem(changes);
            });
        },
        showCharge: function showCharge(userObj) {
            var user = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, userObj);

            if (!user.user) {
                __WEBPACK_IMPORTED_MODULE_39__helpers_AlertHelpers__["a" /* default */].showAlert('Can only add charges for users, not clients');
                return;
            }

            var key = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].safelyGetKey(user);
            user.uid = key;
            user.key = key;
            delete user.meta;
            this.chargeDialog.charge.date = __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__["a" /* default */].todayString();
            this.chargeDialog.charge.from = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getUser();
            this.chargeDialog.description = '';
            this.chargeDialog.clients = '';
            this.chargeDialog.charge.to = user;
            this.chargeDialog.amount = 0;
            this.chargeDialog.settings.visible = true;
        },
        editPreferences: function editPreferences(user) {
            var key = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].safelyGetKey(user);
            this.$router.push('/preferences?t=' + user.tenantKey + '&u=' + key);
        },
        setSearchFocus: function setSearchFocus() {
            if (this.$refs.algoliaSearch) this.$refs.algoliaSearch.focus();else this.$refs.contactSearch.focus();
        },
        isCurrentOffice: function isCurrentOffice(officeKey) {
            return officeKey == __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantKey();
        },
        emailOfficeInvite: function emailOfficeInvite() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var officeKey, invite;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                officeKey = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantKey();
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_33__helpers_TenantHelpers__["a" /* default */].fetchInvite(officeKey);

                            case 3:
                                invite = _context.sent;


                                _this4.emailDialog.email.to = [];
                                _this4.emailDialog.settings.group = 'System';
                                _this4.emailDialog.settings.template = 'Invite New User';
                                _this4.emailDialog.returnObject = null;
                                _this4.emailDialog.settings.customFields = {
                                    'office': invite.name,
                                    'invite_code': officeKey,
                                    'pin': invite.write
                                };
                                _this4.emailDialog.settings.visible = true;

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        kanbanMoved: function kanbanMoved(changes) {
            var task = this.filteredLocalTasks.find(function (t) {
                return t.meta.key == changes.id;
            });
            var newTask = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, task);
            newTask.due = changes.to;
            __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].saveItem(newTask);
            __WEBPACK_IMPORTED_MODULE_39__helpers_AlertHelpers__["a" /* default */].showAlert('Moved from ' + changes.fromText + ' to ' + changes.toText);
        },
        contactSearchChanged: function contactSearchChanged(search) {
            console.log('search for ....' + search);
            this.search = search || '';
        },
        clearSearch: function clearSearch() {
            this.$refs.contactSearch.clearSearch();
        },
        logItemClicked: function logItemClicked(item) {
            if (item.type == 'email') {
                this.emailDialog.email = item.email;
                this.emailDialog.settings.sent = true;
                this.emailDialog.settings.visible = true;
            }
        },
        clearListeners: function clearListeners() {
            var _this5 = this;

            this.officesActive.forEach(function (office) {
                _this5.taskListeners.forEach(function (taskListener) {
                    var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(office.meta.key).child('tasks');
                    ref.off('value', taskListener);
                });
            });
            this.taskListeners = [];
        },
        showOfficeTasks: function showOfficeTasks(office) {
            var _this6 = this;

            this.clearListeners();
            this.localTasks = {};
            var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(office.meta.key).child('tasks');
            this.taskListeners[0] = ref.on('value', function (snap) {
                _this6.$set(_this6.localTasks, office.meta.key, __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].arrayFromSnapshot(snap));
            });
            this.tasksHeading = office.name || 'Tasks for Office';
            this.tasksByLenderSettings.showInitials = true;
        },
        showUserTasks: function showUserTasks(office, user) {
            var _this7 = this;

            this.clearListeners();
            this.localTasks = {};
            var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(office.meta.key).child('tasks');
            this.taskListeners[0] = ref.orderByChild('assigned/uid').equalTo(user.key).on('value', function (snap) {
                _this7.$set(_this7.localTasks, office.meta.key, __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].arrayFromSnapshot(snap));
            });
            this.tasksHeading = __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].fullName(user) || 'Tasks for User';
            this.tasksByLenderSettings.showInitials = false;
        },
        showMyTasks: function showMyTasks() {
            var _this8 = this;

            this.clearListeners();

            var index = -1;
            var uid = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getUserId();
            var refs = [];
            this.localTasks = {};

            this.officesActive.forEach(function (office) {
                index += 1;
                refs[index] = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(office.meta.key).child('tasks').orderByChild('assigned/uid').equalTo(uid);
                _this8.taskListeners[_this8.taskListeners.length] = refs[index].on('value', function (snap) {
                    var tasks = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
                    _this8.$set(_this8.localTasks, office.meta.key, tasks);
                });
            });
            this.tasksHeading = 'My Tasks';
            this.tasksByLenderSettings.showInitials = false;
        },
        goToDashboards: function goToDashboards() {
            this.$router.push('/dashboards');
        },
        showActivityHistory: function showActivityHistory() {
            var _this9 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantRef().child('log').orderByChild('userKey').equalTo(__WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getUserId()).limitToLast(200);
            var items = void 0;
            __WEBPACK_IMPORTED_MODULE_31__data_FireData__["a" /* default */].fetchItems(ref).then(function (result) {
                result = result.map(function (item) {
                    var details = void 0;
                    var title = void 0;
                    var icon = void 0;
                    if (item.type == 'element') {
                        title = item.transactionClients;
                        details = item.elementTitle + ' changed to ' + (item.value || 'Empty');
                        icon = 'tune';
                    } else if (item.type == 'transaction viewed') {
                        title = item.transactionClients;
                        details = 'File Viewed';
                        icon = 'visibility';
                    } else if (item.type == 'email' || item.type == 'send email') {
                        title = item.transactionClients;
                        details = item.result && item.result != 'OK' ? 'Failed email' : 'Sent email';
                        icon = item.result && item.result != 'OK' ? 'error_outline' : 'email';
                    } else {
                        title = item.title;
                        details = item.details;
                    }

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                        meta: {
                            listTitle: title,
                            listDetails: details + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                            listIcon: icon,
                            listHover: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.email, null, 4)
                        }
                    }, item);
                });
                _this9.genericListDialog.items = result.reverse();
                _this9.genericListDialog.settings.closeOnly = true;
                _this9.genericListDialog.settings.visible = true;
            });
        },
        doNothing: function doNothing() {
            console.log('doing nothing');
        },
        initials: function initials(contact) {
            var initials = __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].initials(contact);
            return initials;

            if (initials) return '(' + initials + ')';else return '';
        },
        deleteTask: function deleteTask(task) {
            console.log('home > deleteTask', task);
        },
        isMobile: function isMobile() {
            return __WEBPACK_IMPORTED_MODULE_25__helpers_Utilities__["a" /* default */].isMobile();
        },
        showSMS: function showSMS() {
            if (!__WEBPACK_IMPORTED_MODULE_25__helpers_Utilities__["a" /* default */].isMobile()) {
                this.actionDialog.showingSMS = !this.actionDialog.showingSMS;

                if (!this.actionDialog.showingSMS) {
                    this.actionDialog.smsMessage = '';
                    return;
                }

                var vm = this;
                if (!this.actionDialog.smsPrefix) {
                    __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getSettings('sms').then(function (settings) {
                        vm.actionDialog.smsPrefix = settings.prefix || 'Update';
                        vm.actionDialog.smsSuffix = settings.suffix || '*** This is a system mobile. Please dont reply ***';
                    });
                }

                this.$nextTick(function () {
                    vm.$refs.smsText.focus();
                });
            }
        },
        sendSMSMessage: function sendSMSMessage() {
            console.log('home > sendSMS');
            var mobile = this.actionDialog.model.mobile;
            var message = this.actionDialog.smsPrefix + ': ' + this.actionDialog.smsMessage + '\n' + this.actionDialog.smsSuffix;
            __WEBPACK_IMPORTED_MODULE_25__helpers_Utilities__["a" /* default */].sendSMS(message, mobile);
            this.actionDialog.smsMessage = '';
            this.actionDialog.showingSMS = false;
        },
        stopLoading: function stopLoading() {
            this.$store.commit('stopLoading');
        },
        selectUser: function selectUser(user) {
            this.selectedUser = user;
        },
        taskClicked: function taskClicked(task) {
            if (task.code == "document-checklist" || task.code == 'checklist') this.goToChecklist(task.meta.tenantKey, task.transactionKey);else this.goToTransactionForTask(task);
        },
        goToTransactionForTask: function goToTransactionForTask(task) {
            var tenantKey = task.meta.tenantKey || '999';
            this.goToTransaction(tenantKey, task.transactionKey, task.tabKey);
        },
        goToChecklist: function goToChecklist(tenantKey, transactionKey) {
            this.$router.push('/' + tenantKey + '/document-checklist/' + transactionKey);
        },
        goToTransaction: function goToTransaction(tenantKey, transactionKey, tabKey) {
            var path = '/' + tenantKey + '/transaction/' + transactionKey + (tabKey ? '?tab=' + tabKey : '');
            this.$router.push(path);
        },


        signOut: function signOut() {
            console.log('signing out');
            __WEBPACK_IMPORTED_MODULE_8_firebase_app___default.a.auth().signOut();
        },
        addClients: function addClients() {
            this.addClientsVisible = true;
        },
        savedClients: function savedClients(result) {
            this.addClientsVisible = false;

            console.log('todo: savedClients mode', result);

            if (result.mode == 'Checklist') this.goToChecklist(result.tenantKey, result.transactionKey);
            if (result.mode == 'Transaction') this.goToTransaction(result.tenantKey, result.transactionKey);
        },
        getTenantsRef: function getTenantsRef() {
            return db.ref('tenants/' + this.$store.getters.tenantKey);
        },
        getContactsRef: function getContactsRef() {
            return this.getTenantsRef().child('contacts');
        },
        contactClicked: function contactClicked(contact) {
            __WEBPACK_IMPORTED_MODULE_33__helpers_TenantHelpers__["a" /* default */].setTenant(contact.meta.tenantKey);
            this.showActions(contact);
        },
        showActionsForAlgoliaContact: function showActionsForAlgoliaContact(algoliaContact) {
            var _this10 = this;

            var ref = this.getContactsRef().child(algoliaContact.objectID);
            __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (contact) {
                _this10.showActions(contact);
            });
        },
        showActions: function showActions(contact) {

            this.actionDialog.model = contact;

            if (contact.meta) this.loadTransactionsForContact(contact);else this.loadTransactions(contact.key);
            this.actionDialog.showingSMS = false;
            this.actionDialog.visible = true;
        },
        goToLatestTransaction: function goToLatestTransaction(contact) {
            var _this11 = this;

            var key = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].safelyGetKey(contact);
            var tenantKey = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].safelyGetTenant(contact);
            __WEBPACK_IMPORTED_MODULE_33__helpers_TenantHelpers__["a" /* default */].setTenant(tenantKey);

            var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contactTransactions').child(key);
            __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (transactions) {
                var lastTransaction = __WEBPACK_IMPORTED_MODULE_43__helpers_CollectionHelpers__["a" /* default */].getMostRecentItem(transactions);
                if (lastTransaction) {
                    _this11.goToTransaction(__WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantKey(), lastTransaction.meta.key);
                } else __WEBPACK_IMPORTED_MODULE_39__helpers_AlertHelpers__["a" /* default */].showAlert('No transactions for ' + contact.firstName);
            });
        },
        removeUserStatus: function removeUserStatus(contact) {
            var _this12 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var key;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this12.$root.$confirm('Confirm', 'This will remove contact as a user. Are you sure?', { color: 'red' });

                            case 2:
                                _context2.t0 = _context2.sent;

                                if (!(_context2.t0 == false)) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 5:
                                key = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].safelyGetKey(contact);

                                _this12.getContactsRef().child(key).update({ user: null });
                                __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('users').child(key).remove();

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this12);
            }))();
        },
        switchToPartner: function switchToPartner(key) {
            var vm = this;
            this.getContactsRef().child(key).once('value', function (snap) {
                var contact = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].objectFromSnapshot(snap);
                vm.showActions(contact);
            });
        },
        editContact: function editContact(model) {

            if (model) {
                this.contactEditor.contact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, model);
                this.contactEditor.contact.groups = model.groups || null;
            } else {
                this.contactEditor.contact = {
                    meta: {
                        tenantKey: __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].preferredOffice().meta.key
                    },
                    firstName: '',
                    preferredName: '',
                    lastName: '',
                    mobile: '',
                    email: '',
                    gender: '',
                    image: '/static/transparent.png',
                    groups: null
                };
            }
            if (this.actionDialog.visible) this.actionDialogClose();

            this.contactEditor.settings.visible = true;
        },
        contactDialogClose: function contactDialogClose() {
            this.contactDialog.visible = false;
        },
        contactDialogCancel: function contactDialogCancel() {
            this.contactDialogClose();
        },
        actionDialogClose: function actionDialogClose() {
            this.actionDialog.visible = false;
            var vm = this;
            setTimeout(function () {
                vm.actionDialog.transactions = [];
            }, 300);
        },
        actionDialogCancel: function actionDialogCancel() {
            this.actionDialogClose();
        },
        addTransactionForContact: function addTransactionForContact(contact) {
            var _this13 = this;

            this.transactionDialog.contact = contact;
            this.transactionDialog.visible = true;
            this.$nextTick(function () {
                _this13.$refs.transactionName.focus();
            });
            this.actionDialog.visible = false;
        },
        transactionDialogClose: function transactionDialogClose() {
            this.transactionDialog.model.description = '';
            this.transactionDialog.visible = false;
        },
        transactionDialogCancel: function transactionDialogCancel() {
            this.transactionDialogClose();
        },
        transactionDialogSave: function transactionDialogSave() {

            console.log('home > transactionDialogSave');

            var ref = void 0;

            var tRef = db.ref('tenants').child(this.$store.getters.tenantKey);

            var vm = this;
            var contact = vm.transactionDialog.contact;

            vm.transactionDialog.model.clients = this.jointNames(contact);
            vm.transactionDialog.model.created = __WEBPACK_IMPORTED_MODULE_27__helpers_DateHelpers__["a" /* default */].todayString();

            tRef.child('transactions').push().then(function (snap) {
                tRef.child('transactions').child(snap.key).child('details').update(vm.transactionDialog.model);

                console.log('Made new transaction', snap.key);

                var contactKey = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].safelyGetKey(contact);
                var newContact = __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(contact);

                var element = {
                    type: 'Contact',
                    role: 'Client',
                    name: 'client',
                    title: 'Client',
                    value: __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].fullName(contact),
                    contact: newContact,
                    transactionKey: snap.key,
                    tabKey: 'settings',
                    contactKey: contactKey
                };
                tRef.child('transactions').child(snap.key).child('elements').child(contact.meta.key).update(element);

                ref = tRef.child('contactTransactions').child(contact.meta.key).child(snap.key);

                ref.update(vm.transactionDialog.model);

                if (contact.partner && vm.transactionDialog.withPartner) {

                    var partnerElement = {
                        type: 'Contact',
                        role: 'Client',
                        name: 'client',
                        title: 'Client',
                        value: __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].fullName(contact.partner),
                        contact: contact.partner,
                        transactionKey: snap.key,
                        tabKey: 'settings',
                        contactKey: contact.partner.key
                    };

                    tRef.child('transactions').child(snap.key).child('elements').child(contact.partner.key).update(partnerElement);

                    tRef.child('contactTransactions/' + contact.partner.key + '/' + snap.key).update(vm.transactionDialog.model);
                }

                vm.transactionDialogClose();

                vm.openTransaction({
                    meta: {
                        key: snap.key,
                        tenantKey: contact.meta.tenantKey
                    }
                });
            });
        },
        jointNames: function jointNames(contact) {

            if (contact.partner) {
                if (contact.partner.lastName == contact.lastName) return contact.firstName + ' and ' + contact.partner.firstName + ' ' + contact.lastName;else return contact.firstName + ' ' + contact.lastName + ' and ' + contact.partner.firstName + ' ' + contact.partner.lastName;
            } else return contact.firstName + ' ' + contact.lastName;
        },
        selectSpouse: function selectSpouse(primaryContact) {
            this.actionDialog.visible = false;
            this.contactSelector.visible = true;
            this.contactSelector.data = {
                primaryContact: primaryContact
            };
            this.contactSelector.title = "Connect " + primaryContact.firstName + " to...";
        },
        linkSpouse: function linkSpouse(contact, data) {

            this.contactSelector.visible = false;

            var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(data.primaryContact.meta.tenantKey).child('contacts').child(data.primaryContact.meta.key);
            ref.update({
                partner: this.makeSpouse(contact)
            });

            ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(contact.meta.tenantKey).child('contacts').child(contact.meta.key);

            ref.update({
                partner: this.makeSpouse(data.primaryContact)
            });
        },
        makeSpouse: function makeSpouse(contact) {
            return {
                firstName: contact.firstName,
                lastName: contact.lastName,
                key: contact.meta.key
            };
        },
        removeSpouse: function removeSpouse(contact) {
            var ref = this.getContactsRef().child(contact.partner.key);

            ref.update({
                partner: null
            });

            ref = this.getContactsRef().child(contact.meta.key);
            ref.update({
                partner: null
            });

            this.actionDialog.model.partner = null;
        },
        loadTransactions: function loadTransactions(contactKey) {
            var vm = this;
            var ref = this.getTenantsRef().child('contactTransactions').child(contactKey);
            ref.once('value', function (snap) {
                vm.actionDialog.transactions = __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap, true);
            });
        },
        loadTransactionsForContact: function loadTransactionsForContact(contact) {
            var _this14 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(contact.meta.tenantKey).child('contactTransactions').child(contact.meta.key);

            ref.once('value', function (snap) {
                _this14.actionDialog.transactions = __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].arrayFromSnapshot(snap).reverse();
                _this14.actionDialog.transactions.forEach(function (transaction) {
                    _this14.attachLender(transaction);
                });
            });
        },
        attachLender: function attachLender(transaction) {
            var _this15 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var ref, el;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTransactionRef(transaction.meta.key).child('elements');
                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].fetchItemByName(ref, 'lender');

                            case 3:
                                el = _context3.sent;

                                if (el && el.value) _this15.$set(transaction, 'lender', el.value);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this15);
            }))();
        },
        openChecklist: function openChecklist(transaction) {
            var key = transaction.meta.key;
            var tenantKey = transaction.meta.tenantKey;

            this.actionDialogClose();
            this.$router.push({ path: '/' + tenantKey + '/document-checklist/' + key });
        },
        openTransaction: function openTransaction(transaction) {
            var _this16 = this;

            var key = transaction.meta.key;
            var tenantKey = transaction.meta.tenantKey;

            if (!key || !tenantKey) {
                debugger;
            }

            this.actionDialogClose();
            setTimeout(function () {
                _this16.$router.push({ path: '/' + tenantKey + '/transaction/' + key });
            }, 100);
        },
        checkGender: function checkGender() {
            __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].setInitialGender(this.contactDialog.model);
        },
        openFirebase: function openFirebase(key) {
            var path = __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__["a" /* default */].firebaseConsolePath() + "/tenants/";
            path += this.$store.getters.tenantKey + "/contacts/" + key;
            window.open(path, '_blank');
        },
        viewTaskData: function viewTaskData(key) {
            var path = __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__["a" /* default */].firebaseConsolePath() + "/tenants/";
            path += this.$store.getters.tenantKey + "/tasks/" + key;
            window.open(path, '_blank');
        },
        viewContactTransactionData: function viewContactTransactionData(key) {
            var path = __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__["a" /* default */].firebaseConsolePath() + "/tenants/";
            path += this.$store.getters.tenantKey + "/contactTransactions/" + key;
            window.open(path, '_blank');
        },
        viewUserData: function viewUserData(key) {
            var path = __WEBPACK_IMPORTED_MODULE_22__helpers_FirebaseHelpers__["a" /* default */].firebaseConsolePath() + "/users/";
            path += key;
            window.open(path, '_blank');
        },
        showContactMaintenance: function showContactMaintenance(contact) {
            this.$router.push('/maintenance/?item=' + contact.meta.key + '&action=tc');
        },
        toggleOffice: function toggleOffice(office, forceTrue) {
            var newActive = forceTrue || !office.active;

            this.$store.commit('setOfficeActive', { officeNumber: office.meta.key, value: newActive });
            __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getUserRef().child('offices').child(office.meta.key).child('active').set(newActive);

            if (!newActive && office.meta.key == __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantKey()) {
                if (this.officesActive.length) {
                    this.switchToOffice(this.officesActive[0]);
                }
            }
        },
        switchToOffice: function switchToOffice(office) {
            this.toggleOffice(office, true);
            __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].initialiseTenant(office.meta.key);
        },
        reindexContacts: function reindexContacts() {
            var contactsRef = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contacts');
            __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].fetchItemsFromFirebase(contactsRef).then(function (contacts) {
                __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].saveListToAlgolia(contacts);
            });
        },
        test: function test() {
            var _this17 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var gender, mail, ref2, ref1, db, ref;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_48__helpers_CloudHelpers__["a" /* default */].getGender('John');

                            case 2:
                                gender = _context4.sent;

                                console.log('John is a ' + gender);

                                return _context4.abrupt('return');

                            case 26:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this17);
            }))();
        },
        firstLoad: function firstLoad() {
            var _this18 = this;

            __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].fetchUser().then(function (user) {
                _this18.showMyTasks();
                _this18.selectedUser = user;

                __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].getUsers().then(function (users) {
                    _this18.users = users;
                });

                var ref = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getTenantRef(_this18.tenantKey).child('transactionTemplates');
                return __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (templates) {

                    _this18.transactionTemplates = templates;

                    var defaultTransactionTemplate = _this18.transactionTemplates.find(function (template) {
                        return template.isDefault || template.description == 'Home Loan';
                    });
                    if (defaultTransactionTemplate && defaultTransactionTemplate.meta) _this18.transactionDialog.model.masterKey = defaultTransactionTemplate.meta.key;
                });
            });
        },
        renameTransaction: function renameTransaction(transaction) {
            var _this19 = this;

            this.renameTransactionDialog.transaction = transaction;
            this.renameTransactionDialog.visible = true;
            setTimeout(function () {
                _this19.$refs.oldTransactionName.focus();
            }, 500);
        },
        saveRename: function saveRename(event) {
            var val = event.target.value;
            if (!val) return;
            var transaction = this.renameTransactionDialog.transaction;
            var key = transaction.meta.key;
            transaction.description = val;
            __WEBPACK_IMPORTED_MODULE_41__helpers_TransactionHelpers__["a" /* default */].renameTransaction(key, val);
            this.renameTransactionDialog.visible = false;
        },
        deleteTransaction: function deleteTransaction(transaction) {
            var _this20 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var _transaction$meta, path, key, contactTransactionRef;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this20.$root.$confirm('Delete Transaction', 'Delete this transaction and all associated tasks, files and comments?', { color: 'red' });

                            case 2:
                                _context5.t0 = _context5.sent;

                                if (!(_context5.t0 == true)) {
                                    _context5.next = 9;
                                    break;
                                }

                                _transaction$meta = transaction.meta, path = _transaction$meta.path, key = _transaction$meta.key;

                                __WEBPACK_IMPORTED_MODULE_42__helpers_ArrayHelpers__["a" /* default */].deleteItem(transaction, _this20.actionDialog.transactions);
                                __WEBPACK_IMPORTED_MODULE_41__helpers_TransactionHelpers__["a" /* default */].deleteTransaction(key);

                                contactTransactionRef = __WEBPACK_IMPORTED_MODULE_26__helpers_DataHelpers__["a" /* default */].getRootRef().child(path + '/' + key);

                                contactTransactionRef.remove();

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this20);
            }))();
        },
        loadMilestones: function loadMilestones() {
            var _this21 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_52__data_MilestoneData__["a" /* default */].fetchOpenMilestones();

                            case 2:
                                _this21.milestones = _context6.sent;

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this21);
            }))();
        }
    },

    created: function created() {

        this.firstLoad();
    }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_Section__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_Section___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__builder_Section__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_EditPanel__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_EditPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__builder_EditPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ItemList',
    components: {
        Section: __WEBPACK_IMPORTED_MODULE_1__builder_Section___default.a,
        EditPanel: __WEBPACK_IMPORTED_MODULE_2__builder_EditPanel___default.a
    },
    data: function data() {
        return {
            sections: []
        };
    },

    computed: {
        page: function page() {
            return this.$route.params.page;
        }
    },
    methods: {},

    created: function created() {
        var _this = this;

        var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef().child('sections').orderByChild('page').equalTo(this.page);
        ref.once('value', function (snap) {
            _this.sections = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
        });
    }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DateHelpers__ = __webpack_require__(11);








var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Join',
    data: function data() {
        return {
            officeName: '',
            step: 1,
            inviteCode: '',
            pin: '',
            snackbar: '',
            snackbarShow: false,
            user: {
                firstName: null,
                lastName: null,
                email: null,
                mobile: null
            }
        };
    },

    computed: {
        googleUser: function googleUser() {
            return __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().currentUser || {};
        }
    },
    methods: {
        signOut: function signOut() {
            __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signOut();
        },
        updateOfficeName: function updateOfficeName(newValue) {
            var _this = this;

            console.log('updating');
            if (!newValue) {
                this.officeName = '';
                return;
            }
            var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getRootRef().child('invites').child(newValue);

            ref.once('value', function (snap) {
                var invite = snap.val();
                if (invite) _this.officeName = invite.name;else _this.officeName = '';
            });
        },
        joinOffice: function joinOffice() {
            var vm = this;
            var uid = this.$store.getters.uid;
            var user = this.$store.getters.user;

            var ref = db.ref('invites/' + this.inviteCode);

            ref.child('write').once('value', function (snap) {

                if (snap.val() == vm.pin) {
                    console.log('success for writing');
                    user.office = {
                        key: vm.inviteCode
                    };
                    user.tenantKey = vm.inviteCode;
                    var usersRef = db.ref('users').child(uid);
                    usersRef.update(user);
                    usersRef.child('offices').child(vm.inviteCode).update({
                        read: true,
                        write: true,
                        active: true,
                        name: vm.officeName
                    });
                    window.location.href = '/join?step=2&inviteCode=' + vm.inviteCode;
                } else {
                    vm.snackbar = 'Failed to join. Please check credentials';
                    vm.snackbarShow = true;
                }
            }, function (error) {
                console.log(error);
            });
            console.log('got here');
        },
        createProfile: function createProfile() {
            var uid = this.$store.getters.uid;
            var contactsRef = db.ref('tenants').child(this.inviteCode).child('contacts');
            var user = this.user;
            user.created = __WEBPACK_IMPORTED_MODULE_4__helpers_DateHelpers__["a" /* default */].todayString();
            user.openedAt = __WEBPACK_IMPORTED_MODULE_4__helpers_DateHelpers__["a" /* default */].nowString();
            user.user = true;
            delete user.uid;
            contactsRef.child(uid).update(user);
            this.step = 3;
        }
    },

    created: function created() {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].fetchUser(500, true).then(function (user) {
            vm.user = user;
        });
        this.inviteCode = this.$route.query.inviteCode || '';
        if (this.$route.query.step == 2) this.step = 2;
    }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer___default.a
    },

    props: {
        item: Object
    },

    computed: {
        property1: function property1() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer2__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_ElementControl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_ElementControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__screens_ElementControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutReadOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ElementMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ElementMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__screens_ElementMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_ScrollHelpers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_AutomaticScroll__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_AutomaticScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_AutomaticScroll__);













/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {

            autoScrolling: false,

            activeMenuKey: '111',

            activeElement: null,

            settingsElement: {
                title: 'Settings',
                type: 'Group',

                elements: [{
                    title: 'Templates',
                    percent: 100,
                    type: 'Group',
                    hideTitle: true,
                    flat: true,
                    elements: [{
                        key: '111',
                        type: 'Group',
                        title: 'Email Templates',
                        complete: true,
                        elements: [{
                            key: '32422',
                            title: 'Signature',
                            type: 'Text'
                        }]

                    }, {
                        key: '222',
                        title: 'SMS Templates',
                        type: 'Group',
                        complete: false
                    }]
                }, {
                    title: 'Communication',
                    percent: 35,
                    type: 'Group',
                    hideTitle: true,
                    flat: true,
                    elements: [{
                        key: '333',
                        type: 'Group',
                        title: 'Email Preferences',
                        complete: false,
                        elements: [{
                            key: 83838,
                            type: 'Text',
                            title: 'CC on emails'
                        }, {
                            key: 83839,
                            type: 'Text',
                            title: 'BCC on emails'
                        }, {
                            key: 83840,
                            type: 'Html',
                            title: 'Email Signature'
                        }]
                    }, {
                        key: '335',
                        type: 'Group',
                        title: 'SMS Preferences',
                        complete: false,
                        elements: [{
                            key: 83838,
                            type: 'Text',
                            title: 'SMS Prefix'
                        }, {
                            key: 83839,
                            type: 'Text',
                            title: 'SMS Suffix'
                        }]
                    }, {
                        key: '383',
                        type: 'Group',
                        title: 'Phone Preferences',
                        complete: false,
                        elements: [{
                            key: 83838,
                            type: 'Text',
                            title: 'CC on emails'
                        }, {
                            key: 83839,
                            type: 'Text',
                            title: 'BCC on emails'
                        }]
                    }, {
                        key: '385',
                        type: 'Group',
                        title: 'Other Communication Preferences',
                        complete: false,
                        elements: [{
                            key: 83838,
                            type: 'Text',
                            title: 'SMS Prefix'
                        }, {
                            key: 83839,
                            type: 'Text',
                            title: 'SMS Suffix'
                        }]
                    }]
                }, {
                    title: 'Layout',
                    percent: 0,
                    type: 'Group',
                    elements: [{
                        key: '555',
                        type: 'Text',
                        title: 'This item',
                        complete: false
                    }, {
                        key: '666',
                        type: 'Text',
                        title: 'That item',
                        complete: false
                    }]
                }, {
                    title: 'Maintenance',
                    percent: 0,
                    flat: true,
                    hideTitle: true,
                    type: 'Group',
                    elements: [{
                        key: '273',
                        title: 'Copy Element Attribute',
                        percent: 0,
                        type: 'Group',
                        record: {
                            element_name: 'Franky'
                        },
                        elements: [{
                            key: '555',
                            name: 'element_name',
                            type: 'Text',
                            title: 'Element Name',
                            complete: false
                        }, {
                            key: '666',
                            type: 'Text',
                            name: 'attribute_name',
                            title: 'Attribute to Change',
                            complete: false
                        }, {
                            key: '668',
                            type: 'Options',
                            name: 'source',
                            title: 'Value Source',
                            options: [{ value: 'master', text: 'Get from master file' }, { value: 'manual', text: 'Enter a value manually' }]
                        }, {
                            key: '671',
                            type: 'Text',
                            name: 'attribute_value',
                            title: 'New Value',
                            visible: '[source] == "manual"'
                        }, {
                            key: '689',
                            type: 'Button',
                            name: 'run_copy_element_attribute',
                            title: 'Run Now',
                            complete: false
                        }]
                    }]
                }]
            }

        };
    },


    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_7__screens_ScreenLayout___default.a,
        PageLayout: __WEBPACK_IMPORTED_MODULE_8__screens_PageLayout___default.a,
        LayoutContainer2: __WEBPACK_IMPORTED_MODULE_0__ui_elements_LayoutContainer2___default.a,
        SectionLayout: __WEBPACK_IMPORTED_MODULE_1__screens_SectionLayout___default.a,
        ElementLayout: __WEBPACK_IMPORTED_MODULE_3__screens_ElementLayout___default.a,
        LayoutReadOnly: __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutReadOnly___default.a,
        ElementMenu: __WEBPACK_IMPORTED_MODULE_5__screens_ElementMenu___default.a,
        ElementControl: __WEBPACK_IMPORTED_MODULE_2__screens_ElementControl___default.a,
        AutomaticScroll: __WEBPACK_IMPORTED_MODULE_9__ui_elements_AutomaticScroll___default.a
    },

    props: {},

    computed: {},

    methods: {
        scrolled: function scrolled(key) {
            this.activeMenuKey = key;
        },
        elementMenuClicked: function elementMenuClicked(item, section) {
            this.activeMenuKey = section ? section.key : item.key;
            this.activeElement = item;
        }
    },

    mounted: function mounted() {}
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_HomeLoan__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_HomeLoan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_HomeLoan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_YesNo__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_YesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_YesNo__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            yesorno1: null,
            yesorno2: null,
            homeLoan: {
                groups: [{
                    title: 'Refinance and Cashout',
                    loans: [{
                        amount: 300000,
                        lmiType: 'Capitalised',
                        lmi: 1400,
                        rate: 3.89,
                        fixed: 2,
                        io: 1,
                        description: '2y IO, 2y Fixed, Pricing, Rate Saver 3y disc.',
                        investment: false
                    }, {
                        amount: 101000,
                        rate: null,
                        fixed: 0,
                        io: 0,
                        investment: false
                    }],
                    properties: [{
                        value: 504000
                    }, {
                        value: 255000
                    }]

                }, {
                    title: 'Purchase Home',
                    loans: [{
                        amount: 600000
                    }],
                    properties: [{
                        value: 810000,
                        address: '45 Lime Lilly Rd, Happervalley Q 4559',
                        existing: true,
                        investment: true
                    }]

                }]
            }
        };
    },


    components: {
        HomeLoan: __WEBPACK_IMPORTED_MODULE_0__ui_elements_HomeLoan___default.a, YesNo: __WEBPACK_IMPORTED_MODULE_1__ui_elements_YesNo___default.a
    },

    props: {},

    computed: {},

    methods: {},

    mounted: function mounted() {}
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_OrderHelpers__ = __webpack_require__(29);














var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database();
var lendersRef = db.ref('app/lenders');
var categoriesRef = db.ref('app/documents/categories');
var requirementsRef = db.ref('app/documents/requirements');
var requestsRef = db.ref('app/documents/requests/General');
var generalRequestsRef = db.ref('app/documents/requests/General');

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LenderDocuments',
    components: {
        DeleteButton: __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default.a
    },
    data: function data() {
        return {
            dialogTab: '0',
            lender: 'General',
            newCheckItem: '',
            documents: [],

            documentDialog: {
                settings: {
                    key: null,
                    visible: false,
                    title: 'Document Details'
                },
                document: this.createDocument()

            },
            optionDialog: {
                settings: {
                    index: null,
                    visible: false,
                    title: 'Option Details'
                },
                documentKey: null,
                option: this.createOption()
            },
            requirementDialog: {
                visible: false,
                tab: 'main-tab',
                model: {
                    name: '',
                    description: '',
                    download: '',
                    importance: 0,
                    instructions: '',
                    checklist: [],
                    notRequired: false,
                    expiryDays: null
                }
            }
        };
    },


    firebase: {
        lenders: lendersRef,
        categories: categoriesRef,
        requirements: requirementsRef,
        requests: requestsRef,
        generalRequests: generalRequestsRef
    },
    computed: {
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        }
    },
    methods: {
        getPreferredOption: function getPreferredOption(document) {

            if (!document || document.preferredIndex == null || !document.options || document.options.length <= document.preferredIndex) return this.createOption();

            return document.options[document.preferredIndex] || this.createOption();
        },
        extractOrMakeKey: function extractOrMakeKey(obj) {
            var returnVal = void 0;
            if (obj.key) {
                returnVal = obj.key;
                delete obj.key;
            } else returnVal = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getKey();
        },
        saveDocumentDialog: function saveDocumentDialog() {
            var document = this.documentDialog.document;
            saveDocument(document);
        },
        saveDocument: function saveDocument(document) {
            console.log('saving', document);
            var ref = db.ref('app/documents/lenders').child(this.lender);
            __WEBPACK_IMPORTED_MODULE_8__data_FireData__["a" /* default */].saveItem(document, ref);
        },
        saveOptionDialog: function saveOptionDialog() {
            var _this = this;

            console.log('saving option');

            var document = this.documents.find(function (o) {
                return o.key == _this.optionDialog.documentKey;
            });

            if (!document.options) document.options = [];

            if (this.optionDialog.optionIndex > -1) document.options[this.optionDialog.optionIndex] = this.optionDialog.option;else document.options.push(this.optionDialog.option);
            this.saveDocument(document);
        },
        setDefaultName: function setDefaultName() {
            var doc = this.documentDialog.document;
            if (!doc.name) doc.name = __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__["a" /* default */].toSnakeCase(doc.title);
        },
        setLender: function setLender(name) {
            this.lender = name;
            var requestsRef = db.ref('app/documents/requests').child(name);
            this.$bindAsArray('requests', requestsRef);
        },
        showDocumentDialog: function showDocumentDialog(document) {
            var _this2 = this;

            document = document || this.createDocument();
            this.documentDialog.document = document;
            this.documentDialog.settings.visible = true;
            this.$nextTick(function () {

                _this2.$refs.documentTitle.focus();
            });
        },
        showOptionDialog: function showOptionDialog(documentKey, optionIndex, option) {
            var _this3 = this;

            option = option || this.createOption();
            this.optionDialog.option = option;
            this.optionDialog.documentKey = documentKey;
            this.optionDialog.optionIndex = optionIndex;
            this.optionDialog.settings.visible = true;
            this.$nextTick(function () {
                _this3.$refs.optionTitle.focus();
            });
        },
        createDocument: function createDocument() {
            return {
                title: null,
                name: null,
                order: __WEBPACK_IMPORTED_MODULE_10__helpers_OrderHelpers__["a" /* default */].orderKey(),
                options: []
            };
        },
        createOption: function createOption() {
            return {
                title: null,
                name: null,
                order: __WEBPACK_IMPORTED_MODULE_10__helpers_OrderHelpers__["a" /* default */].orderKey()
            };
        },
        setPreferredIndex: function setPreferredIndex(document, index) {
            document.preferredIndex = index;
            this.saveDocument(document);
        },
        showRequirementDialog: function showRequirementDialog(model, requirement) {
            if (model) {
                if (typeof model.notRequired === "undefined") model.notRequired = false;
                this.requirementDialog.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
            } else {
                this.requirementDialog.model.requirementName = requirement.name;
                this.requirementDialog.model.requirementKey = requirement['.key'];
            }

            this.requirementDialog.visible = true;
        },
        requirementDialogClose: function requirementDialogClose() {
            this.requirementDialog.visible = false;
            this.requirementDialog.model = { name: '',
                description: '',
                importance: 0,
                download: '',
                instructions: '',
                checklist: [],
                category: {},
                notRequired: false,
                expiryDays: null };
            this.requirementDialog.tab = 'main-tab';
        },
        requirementDialogCancel: function requirementDialogCancel() {
            this.requirementDialogClose();
        },
        requirementDialogSave: function requirementDialogSave() {
            var ref = db.ref('app/documents/requests').child(this.lender);
            var model = this.requirementDialog.model;
            this.pushOrUpdateRef(model, ref);
            this.requirementDialogClose();
        },
        deleteRequirement: function deleteRequirement(key) {
            db.ref('app/documents/requests').child(this.lender).child(key).remove();

            this.requirementDialogClose();
        },
        requirementsForCategory: function requirementsForCategory(category) {
            return this.requirements.filter(function (req) {
                return req.category.name == category;
            });
        },
        requestsForRequirement: function requestsForRequirement(type) {
            var requests = this.requests.filter(function (req) {
                return req.requirementKey == type;
            });
            requests = requests.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return requests;
        },
        generalRequestsForRequirement: function generalRequestsForRequirement(type) {
            var requests = this.generalRequests.filter(function (req) {
                return req.requirementKey == type;
            });
            requests = requests.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return requests;
        },
        pushOrUpdateRef: function pushOrUpdateRef(model, ref) {
            var key = model['.key'];
            if (key) {
                ref = ref.child(key);
                delete model['.key'];

                ref.update(model);
            } else {
                ref.push(model);
            }
        },
        addCheckItem: function addCheckItem() {
            if (!this.requirementDialog.model.checklist) this.requirementDialog.model.checklist = [];

            this.requirementDialog.model.checklist.push({
                text: this.newCheckItem
            });
            this.newCheckItem = '';
        },
        copyToLender: function copyToLender(request) {
            var ref = db.ref('app/documents/requests/' + this.lender);
            ref.push(__WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(request));
        }
    },
    created: function created() {
        var _this4 = this;

        var generalRef = db.ref('app/documents/lenders/General');
        generalRef.on('value', function (snap) {
            _this4.documents = __WEBPACK_IMPORTED_MODULE_8__data_FireData__["a" /* default */].snapshotToArray(snap);
        });
    }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_RouterHelpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_EmailDialog__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MailLog',
    components: { ScreenLayout: __WEBPACK_IMPORTED_MODULE_3__screens_ScreenLayout___default.a, EmailDialog: __WEBPACK_IMPORTED_MODULE_12__ui_elements_EmailDialog___default.a },
    props: {
        logId: String,
        email: String
    },
    data: function data() {
        return {
            limit: 100,
            logs: [],
            loading: 'loading',
            advanced: false,
            showingAll: false,
            emailDialog: {

                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: '',
                    attachments: []
                },
                settings: {
                    visible: false,
                    sent: false
                }

            }
        };
    },

    computed: {
        allParams: function allParams() {
            return this.showingAll + this.email + this.limit;
        },
        selectedLog: function selectedLog() {
            var _this = this;

            return this.logs.find(function (o) {
                return o._id == _this.logId;
            }) || { email: {}, statuses: {}, activities: [], info: {} };
        },
        user: function user() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getUser();
        },
        isAdministrator: function isAdministrator() {
            return this.user.email == "matt.ireland.home@gmail.com";
        },
        bounceReason: function bounceReason() {

            return this.selectedLog.events.bounce.reason;
        },
        selectedLogRecipientName: function selectedLogRecipientName() {
            return this.summariseTo(this.selectedLog.email.to);
        }
    },
    methods: {
        resend: function resend() {
            this.emailDialog.email = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.selectedLog.email);
            this.emailDialog.settings.sent = true;
            this.emailDialog.settings.visible = true;
        },
        openConsole: function openConsole() {
            __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].openConsole(this.selectedLog._path + '/' + this.selectedLog._id);
        },
        sentActivity: function sentActivity(log) {
            if (!log || !log.activities) return null;
            return log.activities.find(function (o) {
                return o.event == 'sent';
            });
        },
        queuedActivity: function queuedActivity(log) {
            if (!log || !log.activities) return false;
            return log.activities.find(function (o) {
                return o.event == 'queued';
            });
        },
        logHasProblems: function logHasProblems(log) {
            if (!log || !log.activities) return false;

            var badEvent = log.activities.find(function (o) {
                return o.event == 'bounce' || o.event == 'dropped';
            });
            return Boolean(badEvent);
        },
        logAllSuccessful: function logAllSuccessful(log) {
            if (!log || !log.activities) return false;

            var opened = Boolean(log.activities.find(function (o) {
                return o.event == 'open';
            }));
            if (opened && !this.logHasProblems(log)) return true;else return false;
        },
        isLogSelected: function isLogSelected(log) {
            return log == this.selectedLog;
        },
        attachmentsToHtml: function attachmentsToHtml(attachments) {
            var str = '';
            attachments.forEach(function (attachment) {
                str += '\n            <style>\n                .attachment-button:hover {\n                    background-color: #eee;\n                }\n            </style>\n            <a href="' + attachment.path + '" target="_blank" style="text-decoration:none;">\n            <div style="margin:0 3px 3px 0px;padding:3px 10px;border:solid 1px #ccc;border-radius:14px;display:inline-block;" class="attachment-button">\n                ' + attachment.filename + '\n            </div>\n            </a>\n            ';
            });
            return str;
        },
        load: function load() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var mailRef, ref, logId;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this2.loading = 'loading';
                                console.log('loading logs...');
                                mailRef = __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getCollectionDocumentRefFromPath('teams/global/collections/mail/data');
                                ref = mailRef;

                                if (!_this2.showingAll) ref = ref.where('createdBy', '==', _this2.user.uid);
                                if (_this2.email) {
                                    ref = ref.where('info.accepted', 'array-contains', _this2.email);
                                }
                                ref = ref.orderBy('createdAt', 'desc').limit(_this2.limit);
                                _context.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].streamCollection(ref, _this2.logs);

                            case 9:
                                if (!_this2.logId) {
                                    logId = _this2.logs[0]._id;

                                    __WEBPACK_IMPORTED_MODULE_7__helpers_RouterHelpers__["a" /* default */].setQueryParameter(_this2, 'l', logId);
                                }
                                _this2.loading = 'loaded';
                                _this2.advanced = false;

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        selectLog: function selectLog(logId) {
            __WEBPACK_IMPORTED_MODULE_7__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'l', logId);
            this.advanced = false;
        },
        setEmail: function setEmail(email) {
            __WEBPACK_IMPORTED_MODULE_7__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'e', email);
        },
        listTo: function listTo(arrayOfContacts) {
            if (!arrayOfContacts || !Array.isArray(arrayOfContacts)) return '';
            return arrayOfContacts.map(function (o) {
                return o.hasOwnProperty('email') ? o.email : o;
            }).join('; ');
        },
        summariseTo: function summariseTo(arrayOfContacts) {
            if (!arrayOfContacts || !Array.isArray(arrayOfContacts)) return '';

            return arrayOfContacts.map(function (o) {
                var email = (o.hasOwnProperty('email') ? o.email : o).split('@')[0].trim();
                if (email) return email;
            }).join(', ');
        },
        showAll: function showAll() {
            if (!this.isAdministrator) return;
            this.showingAll = true;
        },
        getActivitiesForEmail: function getActivitiesForEmail(email) {
            if (!this.selectedLog.activities) return [];
            return this.selectedLog.activities.filter(function (o) {
                return o.email == email;
            });
        },
        testMail: function testMail(provider) {
            var _this3 = this;

            var mail = {
                provider: provider,
                fromName: 'Taco Testing',
                from: 'no-reply@insightprocessing.com.au',
                to: [this.user.email],
                cc: ['email-log-test@insightprocessing.com.au'],
                subject: 'Taco Test Email',
                body: '<b>Test Message</b> from Taco with attachment',
                attachments: [{
                    filename: "Email Worked.jpg",
                    path: "https://i.imgur.com/UwMBztL.jpg"
                }]
            };
            var logId = __WEBPACK_IMPORTED_MODULE_9__helpers_EmailHelpers__["a" /* default */].queueEmail(mail);
            __WEBPACK_IMPORTED_MODULE_10__helpers_AlertHelpers__["a" /* default */].showAlert('Sent Test...Loading in Mail Monitor');
            setTimeout(function () {
                _this3.selectLog(logId);
            }, 3000);
        }
    },

    created: function created() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].fetchUser();

                        case 2:
                            _this4.load();

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this4);
        }))();
    },
    mounted: function mounted() {
        console.log(this.$root);
    },


    watch: {
        allParams: {
            immediate: false,
            handler: function handler() {
                this.load();
            }
        }
    }

});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_NiceData__ = __webpack_require__(15);












/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tenantList: [],
            program: null,
            itemKey: null,
            newOfficeNumber: null,
            newOfficeName: null,
            newOfficePin: null,
            output: '',
            user: null,
            sourceTenant: null,
            destinationTenant: null,
            simulateWrites: true,
            simulateDeletes: true,
            move: false
        };
    },

    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser___default.a
    },

    props: {
        item: String,
        action: String,
        transactionKey: String
    },

    computed: {
        singleItem: function singleItem() {
            return this.program == 'tc' || this.program == 'tot' || this.program == 'ttg' || this.program == 'te' || this.program == 'tme' || false;
        },
        programItems: function programItems() {
            return [{ text: "Transfer Contact", value: 'tc' }, { text: "Transfer Contacts for User", value: 'tcu' }, { text: "Transfer All Contacts", value: 'tac' }, { text: "Transfer Tasks for User", value: 'ttu' }, { text: "Transfer All Templates", value: 'tat' }, { text: "Transfer One Template", value: 'tot' }, { text: "Transfer Template to Global", value: 'ttg' }, { text: "Transfer Lookups", value: 'tl' }, { text: "Transfer All Groups", value: 'tag' }, { text: "Transfer Element", value: 'te' }, { text: "Delete Element", value: 'de' }, { text: "Transfer Multiple Elements", value: 'tme' }, { text: "Create an Office", value: 'cno' }];
        },
        tenants: function tenants() {
            return this.$store.getters.officesActive;
        },
        sourceTenantRef: function sourceTenantRef() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.sourceTenant);
        },
        destinationTenantRef: function destinationTenantRef() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant);
        }
    },

    methods: {
        initialiseDialog: function initialiseDialog() {
            var _this = this;

            this.program = this.action;
            this.itemKey = this.item;
            this.sourceTenant = this.$store.getters.tenantKey;
            this.output = '';
            __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].fetchUser().then(function (user) {
                var officesRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getUserRef().child('offices');
                __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].fetchItemsFromFirebase(officesRef).then(function (offices) {
                    _this.tenantList = offices;
                });
            });
        },
        log: function log(msg) {
            this.output += msg + '\n';
        },
        run: function run() {
            this.output = '';
            if (this.program == 'tc') this.transferContact();
            if (this.program == 'tat') this.transferAllTemplates();
            if (this.program == 'tcu') this.transferContactsForUser();
            if (this.program == 'tac') this.transferAllContacts();
            if (this.program == 'ttu') this.transferTasksForUser();
            if (this.program == 'tl') this.transferLookups();
            if (this.program == 'tag') this.transferAllGroups();
            if (this.program == 'tot') this.transferOneTemplate();
            if (this.program == 'ttg') this.transferTemplateToGlobal();
            if (this.program == 'te') this.transferElement();
            if (this.program == 'de') this.deleteElement();
            if (this.program == 'tme') this.transferElement();
            if (this.program == 'cno') this.createNewOffice();
        },
        transferElement: function transferElement() {
            var _this2 = this;

            var itemArr = this.itemKey.split(',');
            this.destinationTenant.forEach(function (destinationTenant) {

                itemArr.forEach(function (itemKey) {

                    var sourceTemplateRef = _this2.sourceTenantRef.child('transactions').child(_this2.transactionKey).child('elements').child(itemKey);
                    var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(destinationTenant.meta.key).child('transactions').child(_this2.transactionKey).child('elements');

                    _this2.copyFirebaseData(sourceTemplateRef, destTemplateRef, _this2.move, true).then(function (result) {
                        _this2.log('Transferred element from ' + sourceTemplateRef.toString() + ' to ' + destTemplateRef.toString());
                    });
                });
            });
        },
        deleteElement: function deleteElement() {
            var _this3 = this;

            var itemArr = this.itemKey.split(',');

            this.destinationTenant.forEach(function (destinationTenant) {
                itemArr.forEach(function (itemKey) {
                    var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(destinationTenant.meta.key).child('transactions').child(_this3.transactionKey).child('elements').child(itemKey);
                    ref.remove();
                    _this3.log('Removed element from ' + destinationTenant.meta.key);
                });
            });


            itemArr.forEach(function (itemKey) {
                _this3.sourceTenantRef.child('transactions').child(_this3.transactionKey).child('elements').child(itemKey).remove();
                _this3.log('Removed element from source');
            });
        },
        transferContact: function transferContact() {
            var _this4 = this;

            var newTenant = this.destinationTenant[0].meta.key;
            this.log('Moving to tenant ' + newTenant + ' ...');
            this.copyContactToTenant(this.itemKey, newTenant);
            __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].fetchItemSingle(this.sourceTenantRef.child('contacts').child(this.itemKey)).then(function (contact) {

                if (contact.partner) _this4.copyContactToTenant(contact.partner.key, newTenant);
            });
        },
        transferOneTemplate: function transferOneTemplate() {
            var _this5 = this;

            this.destinationTenant.forEach(function (destinationTenant) {

                var sourceTemplateRef = _this5.sourceTenantRef.child('templates').child(_this5.itemKey);
                var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(destinationTenant.meta.key).child('templates');

                _this5.copyFirebaseData(sourceTemplateRef, destTemplateRef, _this5.move, true).then(function (result) {
                    _this5.log('Transferred template to ' + destTemplateRef.toString());
                });
            });
        },
        transferTemplateToGlobal: function transferTemplateToGlobal() {
            var _this6 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('templates').child(this.itemKey);
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/templates');

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this6.log('Transferred to global');
            });
        },
        transferAllTemplates: function transferAllTemplates() {
            var _this7 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('templates');
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant[0].meta.key);

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this7.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.object).length.toString() + ' templates ');
            });

            sourceTemplateRef = this.sourceTenantRef.child('transactionTemplates');
            destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant[0].meta.key);

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result2) {

                _this7.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result2.object).length.toString() + ' Transaction templates ');
            });
        },
        transferLookups: function transferLookups() {
            var _this8 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('lookup');
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant[0].meta.key);

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this8.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.object).length.toString() + ' lookup items');
            });
        },
        transferAllGroups: function transferAllGroups() {
            var _this9 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('groups');
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant[0].meta.key);

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this9.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.object).length.toString() + ' groups');
            });
        },
        transferContactsForUser: function transferContactsForUser() {
            var _this10 = this;

            var listContactsRef = this.sourceTenantRef.child('contacts').orderByChild('owner/key').equalTo(this.user.key);
            console.log('ref is ' + listContactsRef.toString());
            listContactsRef.once('value', function (snap) {
                snap.forEach(function (itemSnap) {
                    var contactKey = itemSnap.key;
                    var contact = itemSnap.val();
                    _this10.log('Transferring contact: ' + __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].fullName(contact) + ' - ' + contactKey);
                    _this10.copyContactToTenant(contactKey, _this10.destinationTenant[0].meta.key);
                });
            });
        },
        transferAllContacts: function transferAllContacts() {
            var _this11 = this;

            var sourceRef = this.sourceTenantRef.child('contacts');
            console.log('ref is ' + sourceRef.toString());
            sourceRef.once('value', function (snap) {
                snap.forEach(function (itemSnap) {
                    var contactKey = itemSnap.key;
                    var contact = itemSnap.val();
                    _this11.log('Transferring contact: ' + __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].fullName(contact) + ' - ' + contactKey);
                    _this11.copyContactToTenant(contactKey, _this11.destinationTenant[0].meta.key);
                });
            });
        },
        transferTasksForUser: function transferTasksForUser() {
            var _this12 = this;

            var sourceRef = this.sourceTenantRef.child('tasks');
            var listTasksRef = sourceRef.orderByChild('assigned/uid').equalTo(this.user.key);
            var destRef = this.destinationTenantRef.child('tasks');
            console.log('ref is ' + listTasksRef.toString());

            listTasksRef.once('value', function (snap) {
                console.log(snap.val());
                snap.forEach(function (itemSnap) {

                    var taskKey = itemSnap.key;
                    var task = itemSnap.val();
                    _this12.log('Transferring task: ' + task.title + ' - ' + taskKey);
                    _this12.copyFirebaseData(sourceRef.child(taskKey), destRef, _this12.move, true).then(function (result) {
                        _this12.log('Done...');
                    });
                });
            });
        },
        copyContactToTenant: function copyContactToTenant(contactKey, tenant) {
            var _this13 = this;

            var sourceContactRef = this.sourceTenantRef.child('contacts').child(contactKey);
            var destContactRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(tenant).child('contacts');

            this.copyFirebaseData(sourceContactRef, destContactRef, this.move, true).then(function (result) {
                console.log(result);
                _this13.log('Copied contact: ' + result.object.firstName);

                var sourceContactTransactionsRef = _this13.sourceTenantRef.child('contactTransactions').child(contactKey);
                var destContactTransactionsRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(tenant).child('contactTransactions');

                _this13.copyFirebaseData(sourceContactTransactionsRef, destContactTransactionsRef, _this13.move, true).then(function (tcResult) {
                    console.log('TC Result', tcResult);
                    var transactionArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tcResult.object);
                    _this13.log('Copied ' + transactionArray.length + ' contact-transactions');
                    transactionArray.forEach(function (transactionKey) {
                        var sourceTransactionRef = _this13.sourceTenantRef.child('transactions').child(transactionKey);
                        var destTransactionRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(tenant).child('transactions');

                        _this13.copyFirebaseData(sourceTransactionRef, destTransactionRef, _this13.move, true).then(function (tResult) {
                            _this13.log('Copied transaction: ' + tResult.object.details.description);
                        });
                    });
                }, function (err) {
                    _this13.log(err.result + ' in contactTransactions');
                });
            });
        },
        createNewOffice: function createNewOffice() {
            this.log('Creating new office...');

            var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('invites').child(this.newOfficeNumber);
            ref.update({
                name: this.newOfficeName,
                read: this.newOfficePin,
                write: this.newOfficePin
            });
            this.log('Invites Done.');

            ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('users').child(__WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getUserId()).child('offices').child(this.newOfficeNumber);
            ref.update({
                name: this.newOfficeName,
                read: true,
                write: true
            });
            this.log('Current user Granted Permission.');
        },
        copyFirebaseData: function copyFirebaseData(fromRef, toRef) {
            var _this14 = this;

            var move = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var keepSameKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                console.log('Preparing copyFirebaseData from: ' + fromRef.toString() + ' to ' + toRef.toString());
                var result = {};
                fromRef.once('value', function (snap) {
                    var obj = snap.val();

                    if (!obj) {
                        result.result = 'Data not found';
                        reject(result);
                    }
                    var newKey = keepSameKey ? snap.key : __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getKey();

                    if (!_this14.simulateWrites) toRef.child(newKey).set(obj);else _this14.log('Simulating write only...');

                    if (move) {
                        _this14.deleteFirebaseData(fromRef);
                    }

                    result.sourceRef = fromRef.toString();
                    result.destinationRef = toRef.toString();
                    result.object = obj;
                    result.sourceKey = snap.key;
                    result.destinationKey = newKey;
                    resolve(result);
                });
            });
        },
        deleteFirebaseData: function deleteFirebaseData(fromRef) {
            this.log('Deleting ' + fromRef.toString());
            if (this.simulateDeletes) {
                this.log('Simulating delete only');
                return;
            }
            fromRef.remove();
        }
    },

    created: function created() {
        this.initialiseDialog();
    }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_YesNo__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_YesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_YesNo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_HtmlEditor__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_HtmlEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_HtmlEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_ContactSelector__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_ContactSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_ContactSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_TeamHelpers__ = __webpack_require__(50);
















var db = __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Preferences',
    components: {
        'ContactSelector': __WEBPACK_IMPORTED_MODULE_10__ui_elements_ContactSelector___default.a,
        'YesNo': __WEBPACK_IMPORTED_MODULE_8__ui_elements_YesNo___default.a,
        HtmlEditor: __WEBPACK_IMPORTED_MODULE_9__ui_elements_HtmlEditor___default.a

    },
    props: {
        tenantKey: String,
        uid: String
    },
    data: function data() {
        return {
            teamSettings: {},
            ans1: null,
            ans2: null,
            email: {
                signature: null,
                cc: null,
                bcc: null,
                billing: null
            },
            tab: 0,
            sms: {
                prefix: null,
                suffix: null
            },
            billing: {
                email: null,
                entity: null,
                directDebitRef: null
            },

            drawer: null,
            mini: true,

            contactSelector: {
                visible: false,
                data: {}
            }

        };
    },

    computed: {
        preferencesRef: function preferencesRef() {
            if (this.tenantKey && this.uid) return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('users').child(this.uid).child('offices').child(this.tenantKey).child('preferences');else return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getPreferencesRef();
        },
        loadingMessage: function loadingMessage() {
            return this.$store.getters.loadingMessage;
        }
    },
    watch: {},
    methods: {
        debugMyRecord: function debugMyRecord() {
            var uid = this.uid;
            __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].viewInConsole('users/' + uid);
        },
        sendTestEmail: function sendTestEmail() {
            __WEBPACK_IMPORTED_MODULE_5__helpers_EmailHelpers__["a" /* default */].sendTest();
            console.log('sent');
        },
        selectTemplateContact: function selectTemplateContact() {
            console.log('preferences > selectTemplateContact');
        },
        save: function save() {

            console.log('Preferences ref is ', this.preferencesRef);
            this.preferencesRef.child('email').update(this.email);
            this.preferencesRef.child('sms').update(this.sms);
            this.preferencesRef.child('billing').update(this.billing);
            __WEBPACK_IMPORTED_MODULE_11__helpers_TeamHelpers__["a" /* default */].saveTeamSettings(this.teamSettings);
            this.$router.push('/home');
        },
        load: function load() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var vm;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = _this;


                                _this.preferencesRef.child('email').once('value', function (snap) {
                                    if (snap.val()) {
                                        vm.email.signature = snap.val().signature || null;
                                        vm.email.cc = snap.val().cc || null;
                                        vm.email.bcc = snap.val().bcc || null;
                                        vm.email.billing = snap.val().billing || null;
                                        vm.email.broker = snap.val().broker || null;
                                        vm.email.copyMe = snap.val().copyMe || null;
                                    }
                                });
                                _this.preferencesRef.child('sms').once('value', function (snap) {
                                    if (snap.val()) {
                                        vm.sms.prefix = snap.val().prefix || null;
                                        vm.sms.suffix = snap.val().suffix || null;
                                    }
                                });
                                _this.preferencesRef.child('billing').once('value', function (snap) {
                                    if (snap.val()) {
                                        vm.billing.email = snap.val().email || null;
                                        vm.billing.entity = snap.val().entity || null;
                                        vm.billing.directDebitRef = snap.val().directDebitRef || null;
                                    }
                                });

                                _context.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_11__helpers_TeamHelpers__["a" /* default */].fetchTeamSettings();

                            case 6:
                                _this.teamSettings = _context.sent;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].fetchUser().then(function () {
            _this2.load();
        });
    }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers_js__ = __webpack_require__(24);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Template',
    data: function data() {
        return {};
    },

    computed: {},
    methods: {}
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Template',
    components: { ScreenLayout: __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default.a },
    data: function data() {
        return {};
    },

    computed: {},
    methods: {}
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Template',
    data: function data() {
        return {
            page: {
                panel: {
                    name: 'master_panel',
                    hasColumns: true
                },
                panels: [{
                    panel: {
                        name: 'left_column',
                        scroll: true,
                        placeholderText: true
                    }
                }, {
                    panel: {
                        name: 'right_column'
                    },
                    panels: [{
                        panel: {
                            name: 'upper_row',
                            hasColumns: true
                        },

                        panels: [{
                            panel: {
                                name: 'upper_left',
                                placeholderText: true
                            }
                        }, {
                            panel: {
                                name: 'upper_right',
                                placeholderText: true
                            }
                        }]
                    }, {
                        panel: {
                            name: 'lower_row',
                            placeholderText: true
                        }
                    }]

                }]
            }

        };
    },

    components: {},
    computed: {},
    methods: {}
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuefire__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_HtmlEditor__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_HtmlEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_HtmlEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ckeditor_ckeditor5_build_classic__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ckeditor_ckeditor5_build_classic__);





















var db = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Templates',
    data: function data() {
        return {
            editor: __WEBPACK_IMPORTED_MODULE_12__ckeditor_ckeditor5_build_classic___default.a,
            editorConfig: {
                image: {
                    upload: {
                        panel: {
                            items: ['insertImageViaUrl']
                        }
                    }
                }

            },
            search: '',
            editing: false,
            viewHtmlBox: false,
            template: {
                name: null,
                group: null,
                subject: null,
                body: '',
                personal: null
            }
        };
    },


    components: {
        DeleteButton: __WEBPACK_IMPORTED_MODULE_9__ui_elements_DeleteButton___default.a,
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer___default.a,
        HtmlEditor: __WEBPACK_IMPORTED_MODULE_11__ui_elements_HtmlEditor___default.a
    },

    props: {
        selectedKey: String
    },

    computed: {
        templates: function templates() {
            return this.$store.getters.templates;
        },
        tenantKey: function tenantKey() {
            return this.$store.getters.tenantKey;
        },
        officeName: function officeName() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].officeName();
        },
        visibleTemplates: function visibleTemplates() {
            if (!this.search) return this.templates;

            var search = this.search.toLowerCase();

            return this.templates.filter(function (o) {
                return o.name && o.name.contains(search) || o.group && o.group.contains(search);
            });
        }
    },

    watch: {
        template: {
            handler: function handler(newVal, oldVal) {
                console.log('template changed', oldVal.body, newVal.body);
                this.editing = true;
            },
            deep: true
        },
        selectedKey: {
            handler: function handler(newVal) {
                console.log('selectedKey changed...');
                this.loadTemplate(newVal);
            },
            immediate: false
        }
    },

    methods: {
        updateBody: function updateBody(html) {
            this.template.body = html;
        },
        loadTemplate: function loadTemplate(key) {
            var _this = this;

            var matchingTemplate = this.templates.find(function (o) {
                return o.key == key;
            });
            if (!matchingTemplate) {
                console.log('cant find matching template...');

                return;
            }

            this.template = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, matchingTemplate);
            setTimeout(function () {
                _this.editing = false;
            }, 10);
        },
        selectTemplate: function selectTemplate(template) {
            this.$router.push('/templates/' + template.key);
        },
        saveTemplate: function saveTemplate() {
            console.log('Saving template');
            this.$store.dispatch('saveTemplate', this.template);
            this.editing = false;
        },
        cancelEditing: function cancelEditing() {
            this.resetTemplate();
        },
        copyTemplate: function copyTemplate() {
            console.log('Copying template');
            var template = __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(this.template);
            template.name += ' (copy)';
            template.key = __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].getKey();
            this.$store.dispatch('saveTemplate', template);
            this.selectTemplate(template);
        },
        deleteTemplate: function deleteTemplate() {
            var _this2 = this;

            console.log('Deleting template');
            this.$store.dispatch('deleteTemplate', this.template);

            var sourceTemplate = this.templates[0];
            this.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sourceTemplate));
            setTimeout(function () {
                _this2.editing = false;
                console.log('editing set false');
            }, 300);
        },
        resetTemplate: function resetTemplate() {
            var _this3 = this;

            var sourceTemplate = this.templates.find(function (o) {
                return o.key == _this3.template.key;
            });
            this.template = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sourceTemplate));
            setTimeout(function () {
                _this3.editing = false;
                console.log('editing set false');
            }, 300);
        },
        goToTemplateMaintenance: function goToTemplateMaintenance() {
            this.$router.push('/maintenance/?action=tot&item=' + this.selectedKey);
        },
        viewHtml: function viewHtml() {
            this.viewHtmlBox = true;
        }
    },
    created: function created() {
        var _this4 = this;

        console.log('templates > created');
        this.$store.dispatch('loadTemplates').then(function () {
            _this4.loadTemplate(_this4.selectedKey);
        });
    },
    mounted: function mounted() {
        this.$refs.search.focus();
    }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_TimeTracker__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_TimeTracker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_TimeTracker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_FileDialog__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_FileDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_FileDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_TransactionComments_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_TransactionComments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_TransactionComments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_TransactionTasks_vue__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_TransactionTasks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_TransactionTasks_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_ElementItem_vue__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_ElementItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_ElementItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ui_elements_EmailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_SmsDialog__ = __webpack_require__(2408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_SmsDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ui_elements_SmsDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_ElementDialog_vue__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_ElementDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_ElementDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_ElementScheduler_vue__ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_ElementScheduler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ui_elements_ElementScheduler_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_elements_FilterEditor_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_elements_FilterEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ui_elements_FilterEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_LookupDialog_vue__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_LookupDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ui_elements_LookupDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_FilterHelpers__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__data_NiceData_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_UploadFirebase__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_UploadFirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ui_elements_UploadFirebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers_NumberHelpers_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers_ListHelpers_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ui_elements_TransactionContact__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ui_elements_TransactionContact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__ui_elements_TransactionContact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ui_elements_TransactionMail__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ui_elements_TransactionMail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__ui_elements_TransactionMail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ui_elements_ContactSelector__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ui_elements_ContactSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__ui_elements_ContactSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_elements_TransactionContacts__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_elements_TransactionContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__ui_elements_TransactionContacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_elements_TransactionFiles__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_elements_TransactionFiles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__ui_elements_TransactionFiles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__helpers_LoanHelpers__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ui_elements_UploadElement_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ui_elements_UploadElement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__ui_elements_UploadElement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ui_elements_OutstandingsDiagram_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ui_elements_OutstandingsDiagram_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__ui_elements_OutstandingsDiagram_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__data_ContactData__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__helpers_TransactionHelpers__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__helpers_MilestoneHelpers__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__helpers_LogHelpers__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ui_elements_TaskDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ui_elements_TaskDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__ui_elements_TaskDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ui_elements_GenericListDialog__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ui_elements_GenericListDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__ui_elements_GenericListDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ui_elements_ToolbarSearch__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ui_elements_ToolbarSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__ui_elements_ToolbarSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ui_elements_SimultaneousTransactions__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ui_elements_SimultaneousTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__ui_elements_SimultaneousTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__helpers_PageHelpers__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__helpers_AppHelpers__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__helpers_LoanSecurityHelpers__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__data_Firestore__ = __webpack_require__(27);







































































/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Transaction',
    props: {
        tenantKey: String
    },
    provide: function provide() {
        return {
            loadMailFunction: this.loadMail
        };
    },
    data: function data() {
        return {
            mailLog: [],
            mailLogLoaded: false,
            columnSplits: '65/35',
            localTasks: [],
            lastHelpChange: null,
            generalUpload: {
                complete: true,
                message: ''
            },
            selectedElements: [],
            contactsVisible: false,
            importantVisible: false,
            emailsVisible: false,
            filesVisible: false,
            clipboard: {
                items: [],
                action: null
            },
            elementDialog: {
                settings: {
                    visible: false
                },
                model: {}
            },
            lookupDialog: {
                settings: {
                    title: null,
                    visible: false
                },
                element: {}
            },
            filterEditorDialog: {
                settings: {
                    visible: false,
                    title: 'Add a Filter'
                },
                model: {
                    name: 'test'
                },
                elements: []
            },
            transactionContactDialog: {
                settings: { visible: false },
                element: null
            },
            smsDialog: {
                settings: {
                    visible: false
                },
                message: null,
                recipients: null,
                returnObject: {}
            },

            emailDialog: {

                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: '',
                    attachments: []
                },
                settings: {
                    visible: false,
                    sent: false
                },
                returnObject: null
            },
            contactSelector: {
                visible: false,
                data: {
                    role: null
                }
            },
            fileDialog: {
                settings: {
                    visible: false,
                    closeOnly: true,
                    title: 'All Files'
                }
            },

            genericListDialog: {
                settings: {
                    visible: false,
                    title: 'Element History'
                },
                items: [],
                clickHandler: function clickHandler() {}
            },
            snackbarVisible: false,
            snackbarText: '',
            taskDialog: {
                settings: {
                    visible: false,
                    title: 'Task Details'
                },
                model: {
                    key: null,
                    title: null,
                    due: null,
                    assigned: {}
                }
            }
        };
    },

    components: {
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_7__ui_elements_LayoutContainer___default.a,
        'draggable': __WEBPACK_IMPORTED_MODULE_26_vuedraggable___default.a,
        TransactionComments: __WEBPACK_IMPORTED_MODULE_12__ui_elements_TransactionComments_vue___default.a,
        TransactionTasks: __WEBPACK_IMPORTED_MODULE_13__ui_elements_TransactionTasks_vue___default.a,
        ElementItem: __WEBPACK_IMPORTED_MODULE_14__ui_elements_ElementItem_vue___default.a,
        FilterEditor: __WEBPACK_IMPORTED_MODULE_19__ui_elements_FilterEditor_vue___default.a,
        ElementDialog: __WEBPACK_IMPORTED_MODULE_17__ui_elements_ElementDialog_vue___default.a,

        EmailDialog: __WEBPACK_IMPORTED_MODULE_15__ui_elements_EmailDialog___default.a,
        SmsDialog: __WEBPACK_IMPORTED_MODULE_16__ui_elements_SmsDialog___default.a,
        ContactSelector: __WEBPACK_IMPORTED_MODULE_36__ui_elements_ContactSelector___default.a,
        TransactionContact: __WEBPACK_IMPORTED_MODULE_34__ui_elements_TransactionContact___default.a,
        TransactionMail: __WEBPACK_IMPORTED_MODULE_35__ui_elements_TransactionMail___default.a,
        TransactionContacts: __WEBPACK_IMPORTED_MODULE_37__ui_elements_TransactionContacts___default.a,
        WorkflowFiles: __WEBPACK_IMPORTED_MODULE_38__ui_elements_TransactionFiles___default.a,
        UploadFirebase: __WEBPACK_IMPORTED_MODULE_28__ui_elements_UploadFirebase___default.a,
        LookupDialog: __WEBPACK_IMPORTED_MODULE_20__ui_elements_LookupDialog_vue___default.a,
        OutstandingsDiagram: __WEBPACK_IMPORTED_MODULE_47__ui_elements_OutstandingsDiagram_vue___default.a,
        FileDialog: __WEBPACK_IMPORTED_MODULE_11__ui_elements_FileDialog___default.a,
        ElementScheduler: __WEBPACK_IMPORTED_MODULE_18__ui_elements_ElementScheduler_vue___default.a,
        TaskDialog: __WEBPACK_IMPORTED_MODULE_53__ui_elements_TaskDialog___default.a,
        GenericListDialog: __WEBPACK_IMPORTED_MODULE_54__ui_elements_GenericListDialog___default.a,
        SimultaneousTransactions: __WEBPACK_IMPORTED_MODULE_56__ui_elements_SimultaneousTransactions___default.a,
        ToolbarSearch: __WEBPACK_IMPORTED_MODULE_55__ui_elements_ToolbarSearch___default.a,
        TimeTracker: __WEBPACK_IMPORTED_MODULE_10__ui_elements_TimeTracker___default.a
    },
    computed: {
        isTransactionActive: function isTransactionActive() {
            var isSubmitted = __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].getValueFromName('submitted');
            var isSettled = __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].getValueFromName('settlement_confirmed');
            var isDeclined = __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].getValueFromName('withdrawn_declined');
            return Boolean(isSubmitted && !(isSettled || isDeclined));
        },
        isAdministrator: function isAdministrator() {
            return __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].isAdministrator();
        },
        timeTrackerPayload: function timeTrackerPayload() {
            return {
                insight: __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].isInsightUser(),
                officeKey: __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantKey()
            };
        },
        searchText: function searchText() {
            return __WEBPACK_IMPORTED_MODULE_57__helpers_PageHelpers__["a" /* default */].getPageData('search');
        },
        uploadingCount: function uploadingCount() {
            return this.$store.getters.uploadingCount;
        },


        alertVisible: {
            get: function get() {
                return this.$store.getters.alert.message;
            },
            set: function set(newValue) {
                if (!newValue) this.$store.dispatch('clearAlert');
            }
        },
        alertMessage: function alertMessage() {
            return this.$store.getters.alert.message;
        },
        tabs: function tabs() {
            return this.$store.getters.elements.filter(function (o) {
                return o.type && o.type == 'Tab';
            }).sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortAscending);
        },
        isLoading: function isLoading() {
            return this.elements.length == 0;
        },
        isMaster: function isMaster() {
            return this.transaction.isTemplate;
        },
        tabElements: function tabElements() {
            var _this = this;

            if (this.searchText) {
                if (this.searchText.toLowerCase() == 'links') {
                    return this.elements.filter(function (o) {
                        return o.type != 'File' && o.value && typeof o.value == 'string' && o.value.indexOf('http') == 0;
                    });
                }
                return this.elements.filter(function (o) {
                    return (o.title || '').toLowerCase().indexOf(_this.searchText) > -1;
                });
            }

            if (!this.selectedTab) return [];

            return this.elements.filter(function (o) {
                return o.tabKey && o.tabKey == _this.tabKey;
            }).sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortAscending);
        },
        elements: function elements() {
            return __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].getElements();
        },
        importantElements: function importantElements() {
            return this.elements.filter(function (o) {
                return o.important;
            }).sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortByTitle);
        },
        transactionKey: function transactionKey() {
            return this.$route.params.transaction || "";
        },
        tabKey: function tabKey() {
            return this.$route.query.tab || (this.selectedTab ? this.selectedTab.key : '');
        },
        transaction: function transaction() {
            var transaction = this.$store.getters.transaction;

            if (!transaction.masterKey) {
                console.error('Still need fallback masterkey (transaction.vue)');
                transaction.masterKey = '-LG-kkb1y_ZwFJ9GYSZj';
            }

            return transaction;
        },
        elementRef: function elementRef() {
            return __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('elements');
        },
        selectedTab: function selectedTab() {
            return this.$store.getters.selectedTab;
        },
        selectedSection: function selectedSection() {
            return this.$store.getters.selectedSection;
        },
        masterElements: function masterElements() {
            return this.$store.getters.masters[this.transaction.masterKey];
        },
        contactElements: function contactElements() {
            return this.elements.filter(function (o) {
                return o.contact;
            });
        },
        contactElementsUnique: function contactElementsUnique() {
            return __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].contactElementsUnique(this.elements);
        },
        clients: function clients() {
            return this.contactElements.filter(function (o) {
                return o.role == 'Client';
            }).map(function (o) {
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, o.contact, { key: o.contactKey, role: 'Client' });
            });
        },
        fileElements: function fileElements() {
            return this.elements.filter(function (o) {
                return o.type == 'File' && (o.value || o.loading);
            }).sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortByTimestampDescending);
        },
        roles: function roles() {
            var roles = this.$store.getters.groups.filter(function (o) {
                return o.role == true;
            }).map(function (o) {
                return o.name;
            });
            if (this.isMaster) return roles.filter(function (o) {
                return o != 'Broker';
            });else return roles;
        },
        pageSearchText: function pageSearchText() {
            return __WEBPACK_IMPORTED_MODULE_57__helpers_PageHelpers__["a" /* default */].getPageData('search');
        },

        debugMode: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_58__helpers_AppHelpers__["a" /* default */].getApplicationData('debugMode');
            },
            set: function set(newValue) {
                __WEBPACK_IMPORTED_MODULE_58__helpers_AppHelpers__["a" /* default */].setApplicationData('debugMode', newValue);
            }
        },
        officeName: function officeName() {
            return __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].officeName();
        }
    },

    methods: {
        mailLogClick: function mailLogClick() {
            this.emailsVisible = !this.emailsVisible;
            if (this.emailsVisible && !this.mailLogLoaded) this.loadMail();
        },
        loadMail: function loadMail() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
                var refs, result;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                refs = _this2.getClientEmailRefs();
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_62__data_Firestore__["a" /* default */].fetchMulti(refs);

                            case 3:
                                result = _context.sent;


                                _this2.mailLog = result.sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortByCreatedAtDescending);

                                _this2.mailLogLoaded = true;

                                return _context.abrupt('return', _this2.mailLog);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        getClientEmailRefs: function getClientEmailRefs() {
            var mailRef = __WEBPACK_IMPORTED_MODULE_62__data_Firestore__["a" /* default */].getCollectionDocumentRefFromPath('teams/global/collections/mail/data');

            var refs = [];
            this.clients.forEach(function (client) {
                if (client.email) {
                    var emailObj = { email: client.email };
                    refs.push(mailRef.where('email.to', 'array-contains', emailObj).limit(200));
                }
            });
            return refs;
        },
        viewMilestone: function viewMilestone() {
            var path = 'tenants/' + this.tenantKey + '/milestones/' + this.transactionKey;
            __WEBPACK_IMPORTED_MODULE_27__helpers_FirebaseHelpers__["a" /* default */].viewInConsole(path);
        },
        addToComments: function addToComments(element) {
            var section = this.getElementSection(element, this.elements);
            var comment = {
                text: element.value + ' (from ' + element.title + ')',
                sectionKey: section ? section.key : null,
                tabKey: element.tabKey || null
            };

            this.$store.dispatch('saveTransactionComment', comment);
        },
        sendElementToNewWindow: function sendElementToNewWindow(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].openWindowWithHtml(element.title, element.value);
        },
        getElementBackground: function getElementBackground(element) {
            if (!this.isMaster) return 'auto';
            var isFiltered = element && element.filter && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(element.filter).length > 0;

            var isTasked = element && element.tasks && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(element.tasks).length > 0;

            if (isFiltered && isTasked) return '#fff2cc';

            if (isTasked) return '#ffccf6';

            if (isFiltered) return '#FBEFF2';

            return 'auto';
        },
        copyToClipboard: function copyToClipboard(element) {
            var text = element.value;
            __WEBPACK_IMPORTED_MODULE_61_clipboard_js___default.a.copy({ 'text': text });

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Copied to clipboard');
        },
        searchWithinTransaction: function searchWithinTransaction(searchText) {
            __WEBPACK_IMPORTED_MODULE_57__helpers_PageHelpers__["a" /* default */].setPageData('search', searchText);
        },
        ratingClicked: function ratingClicked(element) {
            var _this3 = this;

            setTimeout(function () {
                _this3.saveElement(element);
            }, 1000);
        },
        showElementHistory: function showElementHistory(element) {
            var _this4 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef().child('log').orderByChild('transactionKey').equalTo(this.transactionKey).limitToLast(500);
            var items = void 0;
            __WEBPACK_IMPORTED_MODULE_25__data_NiceData_js__["a" /* default */].fetchItemsFromFirebase(ref).then(function (result) {
                result = result.filter(function (o) {
                    return o.elementKey == element.key;
                }).reverse().map(function (item) {
                    if (item.type == 'email') {
                        item = __WEBPACK_IMPORTED_MODULE_52__helpers_LogHelpers__["a" /* default */].createListItem(item);
                    } else if (item.type == 'element') {
                        item.meta = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, item.meta, {
                            listKey: item.meta.key,
                            listTitle: 'Changed to ' + (item.value || 'Empty'),
                            listDetails: item.stamp.firstName + ' ' + item.stamp.lastName + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                            listIcon: 'tune'
                        });
                    } else debugger;
                    return item;
                });

                _this4.genericListDialog.items = result;
                _this4.genericListDialog.settings.closeOnly = true;
                _this4.genericListDialog.settings.visible = true;
                _this4.genericListDialog.clickHandler = _this4.historyClicked;
            });
        },
        showTransactionHistory: function showTransactionHistory() {
            var _this5 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef().child('log').orderByChild('transactionKey').equalTo(this.transactionKey).limitToLast(200);
            var items = void 0;
            __WEBPACK_IMPORTED_MODULE_25__data_NiceData_js__["a" /* default */].fetchItemsFromFirebase(ref).then(function (result) {
                result = result.reverse().map(function (item) {
                    if (item.type == 'email') {
                        item = __WEBPACK_IMPORTED_MODULE_52__helpers_LogHelpers__["a" /* default */].createListItem(item);
                    } else if (item.type == 'element') {
                        item.meta = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, item.meta, {
                            listKey: item.meta.key,
                            listTitle: 'Changed "' + item.elementTitle + '" to ' + (item.value || 'empty'),
                            listDetails: item.stamp.firstName + ' ' + item.stamp.lastName + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                            listIcon: 'tune'

                        });
                    } else if (item.type == 'transaction viewed') {
                        item.meta = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, item.meta, {
                            listKey: item.meta.key,
                            listTitle: 'Viewed by ' + __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].fullName(item.stamp) || 'Empty',
                            listDetails: item.stamp.firstName + ' ' + item.stamp.lastName + ' on ' + item.stamp.date + ' at ' + item.stamp.time,
                            listIcon: 'visibility'
                        });
                    } else debugger;
                    return item;
                });

                _this5.genericListDialog.items = result;
                _this5.genericListDialog.settings.closeOnly = true;
                _this5.genericListDialog.settings.visible = true;
                _this5.genericListDialog.clickHandler = _this5.historyClicked;
            });
        },
        historyClicked: function historyClicked(item) {
            console.log('history clicked', item);
            if (item.type == 'email') {
                this.emailDialog.email = item.email;
                this.emailDialog.settings.sent = true;
                this.emailDialog.settings.visible = true;
            }
        },
        emailBothClients: function emailBothClients() {
            console.log('emailing both clients');
            this.emailDialog.email.to = this.clients;
            this.emailDialog.settings.group = 'General';
            this.emailDialog.settings.template = 'Blank';
            this.emailDialog.settings.title = 'Email Client';
            this.emailDialog.settings.visible = true;
        },
        clipboardBothClients: function clipboardBothClients() {
            var clientDetailsArr = [];
            this.clients.forEach(function (client) {
                clientDetailsArr.push(__WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].contactDetailsToText(client));
            });
            var str = __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].combineClientsNames(this.clients) + ':' + clientDetailsArr.join(', ');

            __WEBPACK_IMPORTED_MODULE_61_clipboard_js___default.a.copy({ 'text': str });

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Copied to clipboard');
        },
        showTaskDialog: function showTaskDialog(element) {

            var dateStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_date_fns__["e" /* addDays */])(new Date(), 1).formatBackwards();

            this.taskDialog.model.due = dateStr;
            this.taskDialog.model.title = element.scheduleText || element.title;
            this.taskDialog.model.assigned = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getUser();
            this.taskDialog.settings.visible = true;
            this.taskDialog.settings.triggerElement = element;
        },
        showFileDialog: function showFileDialog() {
            this.$store.commit('uploadingCount', 0);
            this.fileDialog.element = this.element;
            this.fileDialog.settings.visible = true;
        },
        deleteTransaction: function deleteTransaction() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this6.$root.$confirm('Delete', 'Are you sure you want to delete this transaction?', { color: 'red' });

                            case 2:
                                _context2.t0 = _context2.sent;

                                if (!(_context2.t0 == true)) {
                                    _context2.next = 6;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_50__helpers_TransactionHelpers__["a" /* default */].deleteTransaction(_this6.transactionKey);
                                _this6.$router.push({ path: '/home' });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            }))();
        },
        refreshContact: function refreshContact(element) {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_49__data_ContactData__["a" /* default */].fetchContactSingle(element.contactKey).then(function (contact) {
                var simpleContact = __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].simplifyContact(contact);
                element.contact = simpleContact;
                element.value = __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].fullName(simpleContact);
                _this7.saveElement(element);
            });

            if (element.role == 'Client' || element.role == 'Guarantor') __WEBPACK_IMPORTED_MODULE_49__data_ContactData__["a" /* default */].contactTransactionAdd(element.contactKey, this.transactionKey);

            if (element.role == 'Client') this.refreshTransactionClients();
        },
        formatElement: function formatElement(element) {
            return __WEBPACK_IMPORTED_MODULE_40__helpers_MergeHelpers__["a" /* default */].formatElement(element, this.elements);
        },
        testFunction: function testFunction() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var structure, summary;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_60__helpers_LoanSecurityHelpers__["a" /* default */].fetchLoanStructure(_this8.transactionKey);

                            case 2:
                                structure = _context3.sent;
                                summary = __WEBPACK_IMPORTED_MODULE_60__helpers_LoanSecurityHelpers__["a" /* default */].loanSummary(structure);

                                console.log(summary);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this8);
            }))();
        },
        elementsToRecipients: function elementsToRecipients(role) {
            return this.contactElements.filter(function (o) {
                return o.role == role;
            }).map(function (o) {
                return {
                    email: o.contact.email || null,
                    firstName: o.contact.firstName,
                    preferredName: o.contact.preferredName || null,
                    lastName: o.contact.lastName || null,
                    fullName: __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].fullName(o.contact),
                    mobile: o.contact.mobile,
                    role: o.role,
                    image: o.contact.image,
                    key: o.contactKey
                };
            });
        },
        completeElement: function completeElement(element) {
            element.complete = true;
            this.saveElement(element);
        },
        merge: function merge(str) {
            return __WEBPACK_IMPORTED_MODULE_40__helpers_MergeHelpers__["a" /* default */].merge(str, this.elements);
        },
        fileMenu: function fileMenu(action, element) {
            if (action == 'delete') this.deleteElement(element);else if (action == 'email') this.emailFiles([element]);
        },
        emailFiles: function emailFiles(fileElements) {
            this.emailDialog.to = this.clients;
            this.emailDialog.role = 'Client';
            this.emailDialog.group = 'General';
            this.emailDialog.name = 'Blank';
            this.emailDialog.title = 'Email Client';
            this.emailDialog.attachments = fileElements;
            this.emailDialog.data = {
                elements: this.elements
            };
            this.emailDialog.visible = true;
        },
        reseedOrder: function reseedOrder() {
            var _this9 = this;

            var order = 0;
            this.tabElements.forEach(function (element) {
                order += 1000;
                var elementChanges = {
                    key: element.key,
                    order: order
                };
                _this9.saveElement(elementChanges);
            });
            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Elements reseeded. Refresh to take effect');
        },
        uploadStart: function uploadStart(upload) {

            upload.tabKey = 'settings';
            upload.transactionKey = this.transactionKey;
            upload.type = 'File';
            upload.title = upload.name;
            this.saveElement(upload);
        },
        uploadFinish: function uploadFinish(upload) {
            upload.value = upload.url;
            this.saveElement(upload);
        },
        uploadFinishAll: function uploadFinishAll(payload) {
            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Finished uploading ' + payload.files);
        },
        setSpecialTab: function setSpecialTab(name) {
            this.selectTab({
                key: name,
                title: __WEBPACK_IMPORTED_MODULE_45__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(name),
                name: name,
                type: 'Tab'
            });
        },
        displayLookup: function displayLookup(element) {
            this.lookupDialog.element = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, element);
            this.lookupDialog.settings.title = element.title;
            this.lookupDialog.settings.path = this.merge(element.lookup).replace(/\//g, ' > ');
            this.lookupDialog.settings.visible = true;
        },
        saveLookupFromDialog: function saveLookupFromDialog(element) {

            this.saveElement(element);
            var path = this.merge(element.lookup);

            this.saveLookup(path, element.value, element.global);
            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Saved for later');
        },
        saveLookup: function saveLookup(path, value, global) {

            var ref = (global ? __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getRootRef().child('app') : __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef()).child('lookup');

            var lookupPath = __WEBPACK_IMPORTED_MODULE_40__helpers_MergeHelpers__["a" /* default */].merge(path, this.elements);

            var re = new RegExp(/\[.*?\]/);
            var found = re.test(lookupPath);

            if (found) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Didnt save lookup. Cant resolve path');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('saveLookup', lookupPath, value);
            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert("Remembering for next time");

            this.lookup(ref, lookupPath).then(function (foundObj) {
                var key = foundObj.key || __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getKey();
                ref.child(key).update({ path: lookupPath, 'value': value });
            });
        },
        lookup: function lookup(ref, path) {

            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                ref.orderByChild('path').equalTo(path).once('value', function (snap) {
                    var obj = __WEBPACK_IMPORTED_MODULE_27__helpers_FirebaseHelpers__["a" /* default */].snapshotToObject(snap);

                    if (obj) resolve(obj);else resolve('{value:null}');
                });
            });
        },
        actionElement: function actionElement(action, element) {

            if (action == 'email') this.sendElementEmail(element);else if (action == 'sms') this.sendElementSMS(element);else if (action == 'jump-from') this.jumpFromElement(element);else if (action == 'jump-to') this.jumpToElement(element);else if (action == 'contact') this.selectContactFromElement(element);else if (action == 'contact-view') this.viewContact(element);else if (action == 'contact-remove') this.removeContactFromTransaction(element);else if (action == 'make-task') this.makeTaskFromElement(element);else if (action == 'import-outstandings') {
                var outstandings = element.items;
                var triggerElement = element.element;
                this.importOutstandings(outstandings, triggerElement);
            } else if (action == 'display-lookup') this.displayLookup(element);else if (action == 'email-files') this.emailFiles(element);else if (action == 'choose-user') this.chooseUser(element);else console.log('transaction > actionElement (unknown action)', action, element);
        },
        jumpFromElement: function jumpFromElement(element) {
            var targetElement = this.elements.find(function (o) {
                return o.name == element.target;
            });
            if (!targetElement) {
                __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Target element not found');
                return;
            }
            this.jumpToElement(targetElement);
        },
        jumpToElement: function jumpToElement(element) {
            var targetTab = this.tabs.find(function (o) {
                return o.key == element.tabKey;
            });
            this.selectTab(targetTab, element.name);
        },
        importOutstandings: function importOutstandings(outstandings, triggerElement) {
            var _this10 = this;

            var elements = outstandings.map(function (item) {
                var element = _this10.createElement();
                element.type = 'Outstanding';
                element.title = 'Outstanding';
                element.text = item;
                element.status = 'Waiting for Client';
                return element;
            });
            console.log('importOutstandings', elements, triggerElement);
            this.injectElements(elements, this.tabElements, triggerElement, true);
        },
        viewContact: function viewContact(element) {

            var contact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ key: element.contactKey }, element.contact);
            this.transactionContactDialog.model = contact;
            this.transactionContactDialog.element = element;

            this.transactionContactDialog.settings.visible = true;
        },
        addContact: function addContact(role) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('addContact');
            this.contactSelector.data.role = role || '';
            this.contactSelector.data.element = {
                tabKey: 'settings',
                transactionKey: this.transactionKey,
                type: 'Contact'
            };
            this.contactSelector.visible = true;
        },
        selectContactFromElement: function selectContactFromElement(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('selectContactFromElement');
            this.contactSelector.data.role = element.role || '';
            this.contactSelector.data.element = element;
            this.contactSelector.title = 'Include a ' + element.role || 'Contact';

            this.contactSelector.visible = true;
        },
        removeContactFromTransaction: function removeContactFromTransaction(contactElement) {
            this.deleteElement(contactElement);

            contactElement.value = null;
            this.importAffectedElements(contactElement);
        },
        chooseUser: function chooseUser(payload) {
            var contactElement = __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].replaceContact(this.transactionKey, payload.user, payload.role, this.elements);
            this.importAffectedElements(contactElement);
        },
        linkContactFromElement: function linkContactFromElement(contact, data) {
            this.linkContact(contact, data.role);
            this.contactSelector.visible = false;
        },
        linkContact: function linkContact(contact, role) {
            var newElement = __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].linkContact(this.transaction.key, contact, role);
            this.importAffectedElements(newElement);

            debugger;
            if (newElement.role == 'Client') {
                var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contactTransactions').child(newElement.contactKey).child(this.transactionKey);
                ref.set({
                    clients: this.transaction.clients,
                    description: this.transaction.description,
                    created: __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].todayString()
                });
            }
        },
        unlinkContact: function unlinkContact(contact) {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var contactKey, element, transactionKey, contactTransactionRef;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                contactKey = contact.meta.key;

                                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('unlinkContact', contact);
                                element = _this11.elements.find(function (o) {
                                    return o.contactKey == contactKey;
                                });

                                if (!(element.role == 'Client')) {
                                    _context4.next = 12;
                                    break;
                                }

                                if (!(_this11.clients.length < 2)) {
                                    _context4.next = 8;
                                    break;
                                }

                                _context4.next = 7;
                                return _this11.$root.$confirm('Cannot Delete', 'This is the only remaining client', { color: 'red' });

                            case 7:
                                return _context4.abrupt('return');

                            case 8:
                                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Also removing link in client menu...');
                                transactionKey = _this11.transactionKey;
                                contactTransactionRef = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contactTransactions').child(contactKey).child(transactionKey);

                                contactTransactionRef.remove();

                            case 12:

                                _this11.deleteElement(element);

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this11);
            }))();
        },
        sendTemplateEmail: function sendTemplateEmail(role, group, template) {
            this.emailDialog.email.to = this.elementsToRecipients(role).filter(function (o) {
                return o.email;
            });
            this.emailDialog.settings.group = group;
            this.emailDialog.settings.template = template;
            this.emailDialog.settings.customFields = [{ 'transaction_link': 'http://www.microsoft.com' }];
            this.emailDialog.settings.visible = true;
        },
        sendElementEmail: function sendElementEmail(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('sendElementEmail');
            var to = this.elementsToRecipients(element.role).filter(function (o) {
                return o.email;
            });

            if (!to.length && element.role && !this.isMaster) {
                var msg = 'Nobody with an email was found for role: \'' + element.role + '\'';
                __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert(msg);
            }

            if (element.toField) {
                var toElement = this.elements.find(function (o) {
                    return o.name == element.toField;
                });
                if (toElement && toElement.value) {
                    var toArray = toElement.value.split('|');
                    var email = toArray[0];
                    var firstName = toArray.length > 1 ? toArray[1] : '';
                    var toContact = {
                        email: email,
                        firstName: firstName,
                        key: __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getKey()
                    };
                    to = [];
                    to.push(toContact);
                } else {
                    __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Value not found for ' + element.toField);
                }
            }

            this.emailDialog.email.to = to || null;
            this.emailDialog.settings.group = element.emailGroup;
            this.emailDialog.settings.template = element.emailName;
            this.emailDialog.attachments = [];
            this.emailDialog.returnObject = element;
            this.emailDialog.settings.visible = true;
        },
        sendElementSMS: function sendElementSMS(element) {
            console.log('sendElementSMS');
            this.smsDialog.recipients = this.elementsToRecipients(element.role).filter(function (o) {
                return o.mobile;
            });
            this.smsDialog.message = element.message;
            this.smsDialog.settings.title = 'Send SMS';
            this.smsDialog.returnObject = element;
            this.smsDialog.settings.visible = true;
        },
        sentEmail: function sentEmail(data) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('transaction > sentEmail');
            this.emailDialog.visible = false;

            if (!data) return;

            var element = data.element;
            if (element) {
                element.complete = true;
                this.saveElement(element);
            }
        },
        sentSMSMessage: function sentSMSMessage(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('transaction > sentSMSMessage');
            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('SMS Sent');

            if (!element) return;

            element.complete = true;
            this.saveElement(element);
        },
        sentEmailMessage: function sentEmailMessage(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('transaction > sentEmailMessage');

            if (!element) return;

            element.complete = true;
            this.saveElement(element);
        },
        addFilter: function addFilter() {
            this.filterEditorDialog.settings.visible = true;
        },
        elementMaintenance: function elementMaintenance() {
            var selectedElementsString = this.selectedElements.map(function (o) {
                return o.key;
            }).join(',');
            window.open('/maintenance/?action=tme&transaction=' + this.transactionKey + '&item=' + selectedElementsString);
        },
        tabMaintenance: function tabMaintenance(tab) {
            window.open('/maintenance/?action=tme&transaction=' + this.transactionKey + '&item=' + tab.key);
        },
        saveFilter: function saveFilter(filter) {
            var _this12 = this;

            var filterArray = [];
            filterArray.push(filter);
            var filterObject = __WEBPACK_IMPORTED_MODULE_21__helpers_FilterHelpers__["a" /* default */].filterArrayToObject(filterArray);

            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('saveFilter');
            this.selectedElements.forEach(function (element) {

                var newElement = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, element);
                newElement.filter = newElement.filter || {};

                newElement.filter = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(newElement.filter, filterObject);
                _this12.$store.dispatch('saveElement', newElement);
            });

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Filter added to ' + this.selectedElements.length + ' elements');
        },
        deleteFilter: function deleteFilter(filter) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('deleteFilter');
        },
        initialImport: function initialImport() {
            var _this13 = this;

            if (this.isMaster) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Initial import skipped. In master template.');
                return;
            }

            if (this.elements.length > 5) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Initial import skipped. Elements exist.');
                return;
            }

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Importing workflow');

            setTimeout(function () {
                var noFilterMasterElements = _this13.masterElements.filter(function (o) {
                    return !o.filter;
                });
                noFilterMasterElements.forEach(function (element) {
                    _this13.import(element);
                });
            }, 1000);
        },
        importTab: function importTab(tab) {
            var _this14 = this;

            if (this.isMaster) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Initial import skipped. In master template.');
                return;
            }

            var tabMasterElements = this.masterElements.filter(function (o) {
                return o.tabKey == tab.key;
            });
            tabMasterElements.forEach(function (element) {
                if (_this14.shouldElementBeVisible(element)) _this14.import(element);
            });

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Elements refreshed for tab');
        },
        refreshTabs: function refreshTabs() {
            var _this15 = this;

            if (this.isMaster) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Refresh skipped. In master template.');
                return;
            }

            var tabMasterElements = this.masterElements.filter(function (o) {
                return o.type == 'Tab';
            });
            tabMasterElements.forEach(function (element) {
                if (_this15.shouldElementBeVisible(element)) _this15.import(element);
            });

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Tabs refreshed');
        },
        storeElementValue: function storeElementValue(element) {

            this.stampMilestoneElement(element);
            this.$store.dispatch('updateElementValue', element);
            this.importAffectedElements(element);
            this.createAutomaticTasks(element);
            this.saveMilestone(element);
            this.processSpecialTypes(element);
            this.showSchedulersForElement(element);
            this.syncTransactionField(element);
            this.logElementChange(element);
        },
        stampMilestoneElement: function stampMilestoneElement(element) {
            if (element.milestone) element.stamp = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getStamp();
        },
        syncTransactionField: function syncTransactionField(element) {

            if (!element.transactionField) return;
            var val = element.value;
            if (typeof val == 'undefined') val = '';
            var obj = {};
            obj[element.transactionField] = val;

            if (element.transactionField == 'description') {
                __WEBPACK_IMPORTED_MODULE_50__helpers_TransactionHelpers__["a" /* default */].renameTransaction(this.transactionKey, val);
            } else {
                var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('details');
                ref.update(obj);
            }
        },
        logElementChange: function logElementChange(element) {
            if (this.isMaster || element.type == 'Diagram Summary' || !element.title) return;

            var logItem = __WEBPACK_IMPORTED_MODULE_52__helpers_LogHelpers__["a" /* default */].createLogItem();
            logItem.type = 'element';
            logItem.elementKey = element.key;
            logItem.elementTitle = element.title || element.name || 'No name';
            logItem.value = element.value || '';
            this.logTransactionAction(logItem);
        },
        logTransactionView: function logTransactionView() {
            var logItem = __WEBPACK_IMPORTED_MODULE_52__helpers_LogHelpers__["a" /* default */].createLogItem();
            logItem.type = 'transaction viewed';
            this.logTransactionAction(logItem);
        },
        logTransactionAction: function logTransactionAction(logItem) {
            logItem.userKey = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getUserId();
            logItem.tenantKey = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantKey();
            logItem.transactionKey = this.transactionKey;
            logItem.transactionClients = this.transaction.clients;
            __WEBPACK_IMPORTED_MODULE_52__helpers_LogHelpers__["a" /* default */].log(logItem);
        },
        showSchedulersForElement: function showSchedulersForElement(element) {
            var _this16 = this;

            if (!element.value && !element.complete) return;
            if (!element || !element.name) return;
            var affectedElements = this.elements.filter(function (o) {
                return o.scheduleTrigger == element.name;
            });

            affectedElements.forEach(function (element) {
                _this16.$set(element, 'scheduleVisible', true);
                setTimeout(function () {
                    _this16.$set(element, 'scheduleVisible', false);
                }, 20000);
            });
        },
        processSpecialTypes: function processSpecialTypes(element) {
            if (element.widget == 'Loan Diagram') {
                var summary = void 0;
                if (element.version == 2) summary = element.summary;else summary = __WEBPACK_IMPORTED_MODULE_60__helpers_LoanSecurityHelpers__["a" /* default */].loanSummary(element.diagram);
                for (var prop in summary) {
                    var item = summary[prop];

                    var newEl = {
                        key: item.id,
                        name: item.name,
                        tenantKey: element.tenantKey,
                        title: item.title || null,
                        transactionKey: element.transactionKey,
                        type: 'Diagram Summary',
                        value: item.value || null,
                        dashboards: item.dashboards || null
                    };

                    this.storeElementValue(newEl);
                }
            }
        },
        setElementByName: function setElementByName(name, value) {
            var element = this.elements.find(function (o) {
                return o.name == name;
            });
            if (!element) {
                console.log('setElementByName > not found ', name);
                return;
            }

            element.value = value;
            this.storeElementValue(element);
        },
        saveActiveStatusToMilestone: function saveActiveStatusToMilestone() {
            var msRef = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef().child('milestones').child(this.transactionKey);
            msRef.update({ 'active': this.isTransactionActive });
            console.log('*** temporarily saving active status on closing ***');
        },
        saveMilestone: function saveMilestone(element) {
            var _this17 = this;

            if (!(element.milestone || element.dashboards) || this.isMaster) return;

            var msRef = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef().child('milestones').child(this.transactionKey);
            __WEBPACK_IMPORTED_MODULE_25__data_NiceData_js__["a" /* default */].fetchValue(msRef.child('updated')).then(function (updated) {
                __WEBPACK_IMPORTED_MODULE_51__helpers_MilestoneHelpers__["a" /* default */].transferClientsFromTransaction(_this17.transactionKey);
                __WEBPACK_IMPORTED_MODULE_51__helpers_MilestoneHelpers__["a" /* default */].transferBrokerAndProcessor(_this17.transactionKey);

                var msObj = {};
                msObj['updated'] = __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].todayString();
                msObj['active'] = _this17.isTransactionActive;
                msObj[element.name] = element.value;
                msObj[element.name + '_date'] = __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].todayString();
                msObj[element.name + '_type'] = element.type;
                msRef.update(msObj);
                console.log('Saving milestone data', msObj);
            });

            if (!element.milestone || this.isMaster) return;

            var section = this.getElementSection(element, this.tabElements);
            if (!section) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('saveMilestone - Section not found for element', element);
                return;
            }

            section.status = element.title + ': ' + element.value;

            if (element.type == "Checkbox") if (element.value) section.status = element.title;else section.status = null;

            if (element.type == "Options") section.status = element.value || null;

            this.saveElement(section);

            if (!section.status) return;

            var comment = {
                text: section.status,
                sectionKey: section.key,
                tabKey: this.selectedTab.key || null,
                milestone: true
            };
            this.$store.dispatch('saveTransactionComment', comment);

            setTimeout(function () {
                _this17.saveSummary(section, element);
            }, 1000);
        },
        saveSummary: function saveSummary(section, element) {
            var sectionName = section.name;
            var transactionKey = this.transactionKey;
            var transactionClients = this.transaction.clients;
            if (!transactionKey || !sectionName) {
                console.error('saveSummary > No section name or transaction');
                return;
            }

            var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTransactionSummaryRef().child(section.name).child(this.transactionKey);
            var obj = {
                'status': section.status,
                'clients': transactionClients,
                'stamp': __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getStamp(),
                'active': this.isTransactionActive
            };
            ref.update(obj);
        },
        importAffectedElements: function importAffectedElements(element) {
            var _this18 = this;

            var affectedElements = this.getAffectedElements(element, this.masterElements);

            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Affected elements', affectedElements);

            affectedElements.forEach(function (targetElement) {
                if (_this18.shouldElementBeVisible(targetElement)) _this18.import(targetElement);else _this18.deport(targetElement);
            });
        },
        import: function _import(element) {
            var _this19 = this;

            if (this.isMaster) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Import - Simulation Only in Master File', element.name);
                return;
            }
            var newElement = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, element);

            if (newElement.type == 'Contact') if (newElement.title == 'Client') return;else {
                delete newElement['value'];

                delete newElement['checklist'];
                delete newElement['percent'];
            }

            if (newElement.type == 'File') return;

            if (newElement.transactionField) newElement.value = this.getTransactionField(newElement.transactionField);

            newElement.stamp = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getStamp();
            newElement.transactionKey = this.transactionKey;

            if (element.type == 'Lookup') {
                var ref = (element.global ? __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getRootRef().child('app') : __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantRef()).child('lookup');

                var lookupPath = __WEBPACK_IMPORTED_MODULE_40__helpers_MergeHelpers__["a" /* default */].merge(element.lookup, this.elements);
                this.lookup(ref, lookupPath).then(function (obj) {

                    newElement.value = obj.value || null;
                    _this19.$store.dispatch('saveElement', newElement);
                });
            } else {
                    this.$store.dispatch('saveElement', newElement);
                }
        },
        getTransactionField: function getTransactionField(field) {
            return this.transaction[field] || null;
        },
        deport: function deport(element) {
            if (this.isMaster) {
                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Deport - Simulation Only in Master File', element.name);
                return;
            }
            this.deleteElement(element);
        },
        shouldElementBeVisible: function shouldElementBeVisible(element) {
            var _this20 = this;

            console.log('shouldElementBeVisible...');

            var _loop = function _loop(triggerElementName) {
                if (element.filter.hasOwnProperty(triggerElementName)) {
                    var localElement = _this20.elements.find(function (o) {
                        return o.name == triggerElementName;
                    });
                    var localElementValue = localElement ? localElement.value : '';
                    __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('* ' + element.title + ' * : Testing ', triggerElementName + ' from filter, and got a value of ' + localElementValue);

                    var match = false;

                    var filterObj = element.filter[triggerElementName].visible;

                    var operator = filterObj.operator;
                    filterObj.values.forEach(function (filterValue) {
                        if (_this20.broadMatch(filterValue, localElementValue)) {
                            match = true;
                        }
                    });
                    var wantMatch = operator == 'e';

                    if (match != wantMatch) return {
                            v: false
                        };
                }
            };

            for (var triggerElementName in element.filter) {
                var _ret = _loop(triggerElementName);

                if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
            }
            return true;
        },
        broadMatch: function broadMatch(filterVal, currentVal) {
            if (!currentVal) currentVal = '';

            if (filterVal == currentVal) return true;

            if (filterVal == 'Yes' && currentVal == true) return true;

            if (filterVal == 'No' && currentVal == false) return true;

            if (filterVal == 'Blank' && currentVal == '') return true;

            if (filterVal == 'Non Blank' && currentVal != '') return true;

            return false;
        },
        getAffectedElements: function getAffectedElements(element, elements) {
            return this.masterElements.filter(function (o) {
                return o.filter && o.filter[element.name];
            });
        },
        buttonElementClicked: function buttonElementClicked(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('button clicked', element);
            var elementList = [];
            var startIndex = this.tabElements.findIndex(function (o) {
                return o.key == element.key;
            });
            var offset = 1;
            var targetElement = element;

            if (element.buttonElements == 'Section') {
                var sectionElements = this.getElementsInSection(element, this.tabElements);
                var startingElement = sectionElements[sectionElements.length - 1];
                this.injectElements(sectionElements, this.tabElements, startingElement, true);
                return;
            }

            if (element.buttonElements == 'Previous') {
                offset = -1;
                targetElement = this.tabElements[startIndex - 1];
            }

            for (var n = 1; n <= element.buttonElementCount; n++) {
                var newElement = this.tabElements[startIndex + offset * n];
                elementList.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newElement));
            }
            elementList = elementList.sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortAscending);
            this.injectElements(elementList, this.tabElements, targetElement, true);
        },
        moveToClipboard: function moveToClipboard(action) {
            this.clipboard.action = action;
            this.clipboard.items = this.selectedElements.sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortAscending);
            this.selectedElements = [];
        },
        moveTabToClipboard: function moveTabToClipboard(tab) {
            this.clipboard.action = 'Tab';
            this.clipboard.items = [tab];
        },
        pasteFromClipboard: function pasteFromClipboard(baseElement) {
            this.injectElements(this.clipboard.items, this.tabElements, baseElement, this.clipboard.action == 'Copy');
            this.clearClipboard();
        },
        pasteTabFromClipboard: function pasteTabFromClipboard(baseElement) {
            this.injectElements(this.clipboard.items, this.tabs, baseElement, false);
            this.clearClipboard();
        },
        cloneSelectedElements: function cloneSelectedElements() {
            var startingElement = this.selectedElements[this.selectedElements.length - 1];
            this.injectElements(this.selectedElements, this.tabElements, startingElement, true);
            this.selectedElements = [];
        },
        injectElements: function injectElements(fromArray, toArray, afterItem, makeCopy) {
            var firstOrder = parseInt(afterItem.order || 0);
            var lastOrder = __WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].orderKey();
            var nextElement = __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].arrayNextObject(afterItem, toArray);

            if (nextElement) {
                lastOrder = parseInt(nextElement.order);
            }

            var sourceArray = fromArray.sort(__WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].sortAscending);

            var orderIncrement = parseInt((lastOrder - firstOrder) / (sourceArray.length + 1));

            for (var n = 1; n <= sourceArray.length; n++) {

                var fromItem = sourceArray[n - 1];

                var blankItem = {};
                if (makeCopy) {
                    blankItem = __WEBPACK_IMPORTED_MODULE_32__helpers_ListHelpers_js__["a" /* default */].prepareSave({});
                    blankItem.name = __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].uniqueName(fromItem.name || fromItem.title, sourceArray.map(function (o) {
                        return o.name;
                    }));

                    blankItem.targetName = __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].uniqueName(fromItem.targetName, sourceArray.map(function (o) {
                        return o.targetName;
                    }));
                    blankItem.value = null;
                }

                var newElement = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fromItem, blankItem);
                var newOrder = firstOrder + n * orderIncrement;
                newElement.order = newOrder;

                newElement.tabKey = this.tabKey;
                if (newElement.type == 'Tab') newElement.tabKey = null;

                this.$store.dispatch('saveElement', newElement);
            }
        },
        clearClipboard: function clearClipboard() {
            this.clipboard = { items: [], action: null };
        },
        addTab: function addTab() {

            var tab = {
                type: 'Tab',
                order: __WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].orderKey()
            };
            this.editTab(tab);
        },
        editTab: function editTab(tab) {
            this.elementDialog.model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tab);
            this.elementDialog.settings.visible = true;
        },
        scheduleClicked: function scheduleClicked(element) {
            if (element.scheduleDays == -2) return;
            if (element.scheduleDays == -1) {
                this.showTaskDialog(element);
                return;
            }
            this.makeTaskFromElement(element);
        },
        makeTaskFromElement: function makeTaskFromElement(element) {
            var scheduleFor = void 0;

            if (element.type == 'Date') scheduleFor = element.value;else if (element.type == 'Scheduler') scheduleFor = __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].businessDaysFromNow(element.days).formatBackwards();else if (element.scheduleDays) scheduleFor = __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].businessDaysFromNow(element.scheduleDays).formatBackwards();else scheduleFor = __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].businessDaysFromNow(1).formatBackwards();

            var section = this.getElementSection(element, this.tabElements);

            this.$store.dispatch('saveTask', {
                title: element.scheduleText || element.title,
                tabKey: element.tabKey,
                sectionKey: section ? section.key : null,
                sectionTitle: section ? section.title : null,
                due: scheduleFor,
                lender: __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].getValueFromName('lender')
            });
        },
        createAutomaticTasks: function createAutomaticTasks(element) {
            var _this21 = this;

            if (!element.tasks || !element.tasks.length || !element.value) return;

            element.tasks.forEach(function (automaticTask) {

                var section = _this21.getElementSection(element, _this21.tabElements);
                var task = {
                    due: __WEBPACK_IMPORTED_MODULE_24__helpers_DateHelpers__["a" /* default */].businessDaysFromNow(automaticTask.days).formatBackwards(),
                    lender: __WEBPACK_IMPORTED_MODULE_33__helpers_ElementHelpers_js__["a" /* default */].getValueFromName('lender'),
                    sectionTitle: section ? section.title : null,
                    sectionKey: section ? section.key : null,
                    tabKey: element.tabKey,
                    title: automaticTask.title,
                    hint: 'This automatic task was created by completing the \'' + element.title + '\' element'
                };

                var assignee = _this21.contactElements.find(function (o) {
                    return o.role == (automaticTask.role || 'NO-ROLE');
                });
                if (assignee) {
                    task.assigned = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, assignee.contact, { uid: assignee.contactKey });
                }
                _this21.saveTask(task);
            });
            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert(element.tasks.length + ' task/s created');
        },
        saveTask: function saveTask(task, settings) {
            this.$store.dispatch('saveTask', task);
        },
        addAfterElement: function addAfterElement(element) {
            var newOrder = __WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].orderKey();
            var nextElement = __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].arrayNextObject(element, this.tabElements);
            var thisOrder = element.order || 0;

            if (nextElement) {
                var nextOrder = nextElement.order;
                newOrder = parseInt((thisOrder + nextOrder) / 2);
            }
            this.editElement({
                order: newOrder,
                tabKey: element.tabKey,
                width: 100
            });
        },
        editElement: function editElement(element) {
            var el = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, element);
            this.elementDialog.model = el;
            this.elementDialog.settings.visible = true;
        },
        createElement: function createElement() {
            return {
                transactionKey: this.transactionKey,
                key: __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getKey(),
                order: __WEBPACK_IMPORTED_MODULE_31__helpers_OrderHelpers_js__["a" /* default */].orderKey(),
                tabKey: this.tabKey || 'settings',
                width: 100
            };
        },
        saveElement: function saveElement(element) {

            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('saveElement', element);
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].removeUndefinedProperties(element);
            this.$store.dispatch('saveElement', element);
        },
        selectTab: function selectTab(tab, sectionName) {
            var _this22 = this;

            if (!tab) {
                this.setSpecialTab('home');
                return;
            }

            if (this.selectedTab && this.selectedTab.key == 'home') this.importantVisible = false;
            if (tab.key == 'home') this.importantVisible = true;

            this.$store.dispatch('selectTab', tab);
            setTimeout(function () {

                var destination = {
                    path: '/' + _this22.tenantKey + '/transaction/' + _this22.transactionKey
                };

                if (tab) destination.query = {
                    tab: tab.key || tab
                };

                if (sectionName) {
                    destination.query.section = sectionName;
                }

                setTimeout(function () {
                    _this22.scrollToElement(sectionName);
                }, sectionName ? 500 : 0);

                _this22.$router.replace(destination);

                _this22.$store.dispatch('selectSection', null);

                if (_this22.selectedTab && _this22.tabElements.length < 1) {
                    var element = _this22.createElement();
                    element.type = 'Section';
                    element.title = tab.title;
                    _this22.saveElement(element);
                }
            }, 10);
        },
        scrollToElement: function scrollToElement(section) {
            var parentElement = document.getElementById('col1');

            var topPos = 0;
            if (section) {
                var sectionElement = this.$refs[section];
                topPos = sectionElement[0].offsetTop;
                console.log('section jump', sectionElement);
            }

            parentElement.scrollTop = topPos - 135;
        },
        elementClicked: function elementClicked(element) {
            this.selectedElements = [];
            var path = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTransactionRef().toString() + ('/elements/' + element.key);

            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('elementClicked', element, path);

            var section = this.getElementSection(element, this.tabElements);

            if (element.type == 'Section' && section == this.selectedSection) section = null;
            this.$store.dispatch('selectSection', section);
        },
        elementDoubleClicked: function elementDoubleClicked(element) {
            if (element.type == 'Section' || element.type == 'Outstanding') {
                this.editElement(element);
            }
        },
        getElementSection: function getElementSection(element, elements) {
            var idx = elements.findIndex(function (o) {
                return o.key == element.key;
            });
            while (idx >= 0) {
                var testingElement = elements[idx];
                if (testingElement.type == 'Section') {
                    return testingElement;
                }
                idx--;
            }
            return null;
        },
        getElementsInSection: function getElementsInSection(element, elements) {
            var section = this.getElementSection(element, elements);
            var idx = elements.findIndex(function (o) {
                return o.key == section.key;
            });
            var result = [section];
            for (var n = idx + 1; n < elements.length; n++) {
                var _element = elements[n];
                if (_element.type != 'Section') result.push(_element);else break;
            }
            return result;
        },
        makeImportant: function makeImportant(element) {
            element.important = true;
            this.saveElement(element);
        },
        removeImportant: function removeImportant(element) {
            element.important = false;
            this.saveElement(element);
        },
        toggleNotApplicable: function toggleNotApplicable(element) {
            element.na = !element.na;
            this.saveElement(element);
            if (element.type == 'Section') this.setNotApplicableSection(element);
        },
        setNotApplicableSection: function setNotApplicableSection(sectionElement) {
            var _this23 = this;

            var sectionElements = this.getElementsInSection(sectionElement, this.tabElements);
            sectionElements.forEach(function (sec) {
                sec.na = sectionElement.na;
                _this23.saveElement(sec);
            });
        },
        deleteElements: function deleteElements(elements) {
            var _this24 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this24.$root.$confirm('Delete', 'Delete these elements?', { color: 'red' });

                            case 2:
                                _context5.t0 = _context5.sent;

                                if (!(_context5.t0 == true)) {
                                    _context5.next = 5;
                                    break;
                                }

                                elements.forEach(function (element) {
                                    _this24.deleteElement(element);
                                });

                            case 5:

                                _this24.selectedElements = [];

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this24);
            }))();
        },
        deleteElement: function deleteElement(element) {
            this.$store.dispatch('deleteElement', element);
        },
        selectSingle: function selectSingle(element) {
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('transaction > selectSingle');
            __WEBPACK_IMPORTED_MODULE_32__helpers_ListHelpers_js__["a" /* default */].selectSingle(element, this.elements);

            if (element.type == 'Section') this.$store.dispatch('selectSection', element);
        },
        selectMulti: function selectMulti(element) {
            if (element.type == 'Section') {
                var sectionElements = this.getElementsInSection(element, this.tabElements);
                this.selectedElements = sectionElements;
                return;
            }

            var idx = this.selectedElements.findIndex(function (o) {
                return o.key == element.key;
            });
            if (idx > -1) this.selectedElements.splice(idx, 1);else this.selectedElements.push(element);
        },
        isElementSelected: function isElementSelected(element) {
            return this.selectedElements.findIndex(function (o) {
                return o.key == element.key;
            }) >= 0;
        },
        selectRange: function selectRange(element) {
            __WEBPACK_IMPORTED_MODULE_32__helpers_ListHelpers_js__["a" /* default */].selectRange(element, this.elements);
        },
        getElementStyle: function getElementStyle(element) {
            if (element.width == 10) return 'width:10%';else if (element.width == 90) return 'width:90%';else if (this.$vuetify.breakpoint.xsOnly) return "width:100%";else return "width:" + element.width + "%";
        },
        menuContainerStyle: function menuContainerStyle(element) {
            if (element.type == 'Lookup' && element.help) return 'padding-top:20px;vertical-align:top';
            if (element.type == 'Button') return 'padding-bottom:12px;vertical-align:bottom;';else if (element.type == 'Outstanding') return 'padding-top:12px;vertical-align:top;';else if (element.type == 'Checklist') return 'padding-top:4px;vertical-align:top;';else return 'padding-top:22px;vertical-align:top;';
        },
        add: function add(prevElement) {
            var idx = this.elements.indexOf(prevElement);
            this.elements.splice(idx + 1, 0, this.makeRandomElement());
        },
        del: function del(element) {
            var idx = this.elements.indexOf(element);
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('deleting...', idx);
            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('deleting', idx);
            this.elements.splice(idx, 1);
        },
        inc: function inc(element) {
            element.counter++;
        },
        reorderStep: function reorderStep() {},
        deleteAll: function deleteAll() {
            var _this25 = this;

            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var elementCache;
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!_this25.isMaster) {
                                    _context6.next = 3;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('Cant delete all in master');
                                return _context6.abrupt('return');

                            case 3:
                                _context6.next = 5;
                                return _this25.$root.$confirm('Delete', 'Delete everything from this file completely?', { color: 'red' });

                            case 5:
                                _context6.t0 = _context6.sent;

                                if (!(_context6.t0 == true)) {
                                    _context6.next = 9;
                                    break;
                                }

                                elementCache = _this25.elements.map(function (o) {
                                    return { 'key': o.key };
                                });


                                elementCache.forEach(function (element) {
                                    _this25.deleteElement(element);
                                });

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this25);
            }))();
        },
        makeRandomElement: function makeRandomElement() {
            var el = {
                key: __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getKey(),
                title: 'Item number ' + __WEBPACK_IMPORTED_MODULE_30__helpers_NumberHelpers_js__["a" /* default */].randomInt(999).toString(),
                showHint: __WEBPACK_IMPORTED_MODULE_30__helpers_NumberHelpers_js__["a" /* default */].randomInt(100) < 10,
                important: __WEBPACK_IMPORTED_MODULE_30__helpers_NumberHelpers_js__["a" /* default */].randomInt(100) < 10,
                width: __WEBPACK_IMPORTED_MODULE_59__helpers_ArrayHelpers__["a" /* default */].randomFromArray([50, 30, 10]),
                counter: 0,
                type: __WEBPACK_IMPORTED_MODULE_59__helpers_ArrayHelpers__["a" /* default */].randomFromArray(['Text', 'List', 'Switch', 'Checkbox', 'Section', 'Date', 'Currency'])
            };
            if (el.type == 'Section') el.width = 100;
            if (el.type == 'List') el.options = 'Item A, Item B, Item C';
            if (el.type == 'Status') el.options = 'Item A|red, Item B|green, Item C|orange';
            return el;
        },
        maintenance: function maintenance() {
            var _this26 = this;

            var oldContacts = this.elements.filter(function (o) {
                return o.type == 'Contact' && o.tabKey;
            });

            if (!oldContacts.length) {
                console.log('Skipping maintenance');
                return;
            }

            oldContacts.forEach(function (el) {

                var uploadEl = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, el);
                uploadEl.contact = null;
                uploadEl.contactKey = null;
                uploadEl.value = null;
                uploadEl.key = null;
                uploadEl['.key'] = null;
                uploadEl.title = 'Choose ' + uploadEl.title;
                uploadEl.name = __WEBPACK_IMPORTED_MODULE_45__helpers_StringHelpers__["a" /* default */].toSnakeCase(uploadEl.name) + '_selector';
                uploadEl.type = "Contact Selector";
                _this26.saveElement(uploadEl);

                if (el.contact) {
                    el.width = null;
                    el.tabKey = null;
                    el.order = null;
                    el.compact = null;
                    _this26.saveElement(el);
                } else _this26.deleteElement(el);
            });

            __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Performing contact maintenance');
        },
        checkForActions: function checkForActions() {
            var action = this.$route.query.a;
            if (action == 'email') this.openWithEmail();
        },
        openWithEmail: function openWithEmail() {
            var _this27 = this;

            var role = this.$route.query.r;
            var group = this.$route.query.g;
            var template = this.$route.query.t;
            if (!role || !group || !template) {
                __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Missing information to show Email');
                return;
            }

            __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].fetchUser().then(function (user) {

                _this27.sendTemplateEmail(role, group, template);
            });
        },
        test: function test() {},
        initialise: function initialise() {
            var _this28 = this;

            __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('transaction > Initialise');

            __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].initialiseTenant(this.tenantKey);

            this.$store.dispatch('loadTransaction', this.transactionKey).then(function (transaction) {
                var arr = transaction.clients.split(' ');
                document.title = arr[arr.length - 1];

                __WEBPACK_IMPORTED_MODULE_29__helpers_Utilities__["a" /* default */].log('transaction > initialise - Calling load transaction', transaction);

                _this28.$store.dispatch('loadAllElements').then(function (elementsResult) {
                    _this28.$store.dispatch('loadMaster').then(function (result) {
                        _this28.initialImport();
                    });

                    _this28.selectTab(_this28.tabs.find(function (o) {
                        return o.key == _this28.$route.query.tab;
                    }));

                    _this28.$store.dispatch('fetchAllGroups');

                    _this28.refreshTransactionClients();

                    _this28.checkForActions();

                    _this28.maintenance();

                    _this28.logTransactionView();

                    _this28.logOpenedAt();
                });
            }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert(err);
                _this28.transaction.clients = err;
                _this28.loading = false;
            });
        },
        logOpenedAt: function logOpenedAt() {
            var _this29 = this;

            this.clients.forEach(function (client) {

                __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].updateOpenedDate(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, client, {
                    tenantKey: _this29.tenantKey
                }));
            });
        },
        refreshTransactionClients: function refreshTransactionClients() {
            var _this30 = this;

            setTimeout(function () {
                var newClients = __WEBPACK_IMPORTED_MODULE_39__helpers_ContactHelpers__["a" /* default */].combineClientsNames(_this30.clients);
                if (!newClients) {
                    if (_this30.isMaster) __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('You are in the master template for your office. Please take care in here');else __WEBPACK_IMPORTED_MODULE_22__helpers_AlertHelpers__["a" /* default */].showAlert('Clients dont exist in this file. Please add them manually');
                    return;
                }
                if (newClients == _this30.transaction.clients) return;

                var newTransaction = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, _this30.transaction);
                newTransaction.clients = newClients;
                _this30.$store.commit('setTransaction', newTransaction);

                var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('details').child('clients');
                ref.set(newClients);
            }, 1000);
        },
        makeTemplate: function makeTemplate() {
            __WEBPACK_IMPORTED_MODULE_50__helpers_TransactionHelpers__["a" /* default */].makeTemplate(this.transactionKey).then(function (result) {

                window.location.reload();
            });
        },
        removeTemplate: function removeTemplate() {
            __WEBPACK_IMPORTED_MODULE_50__helpers_TransactionHelpers__["a" /* default */].removeTemplate(this.transactionKey).then(function (result) {

                window.location.reload();
            });
        }
    },

    created: function created() {
        var _this31 = this;

        this.initialise();

        setTimeout(function () {
            _this31.saveActiveStatusToMilestone();
        }, 3000);
    },
    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {
        document.title = 'Taco';
        __WEBPACK_IMPORTED_MODULE_57__helpers_PageHelpers__["a" /* default */].clearPageData();
    },


    watch: {
        'debugMode': {
            handler: function handler(newVal) {
                console.log('debug mode set to ' + newVal);
            }

        }
    }

});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(21);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Welcome',
    data: function data() {
        return {
            assignedTo: ''
        };
    },

    computed: {
        signInEnabled: function signInEnabled() {
            var enabled = localStorage.getItem("loginStatus") == "Signed Out";
            return enabled;
        }
    },
    methods: {
        signIn: function signIn() {
            console.log('signing in');

            localStorage.setItem("loginStatus", "Signing In");

            var provider = new __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.GoogleAuthProvider();
            provider.addScope('email');
            provider.addScope('profile');

            __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signInWithPopup(provider);
        }

    }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Db__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_Db1__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_lists_ListList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_lists_ListList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__forms_lists_ListList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_RouterHelpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_FormControl__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__forms_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_activity_Activities__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_activity_Activities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__forms_activity_Activities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChecklistSchemas__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ChecklistRules__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_ExpansionPanel__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_ExpansionPanel__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Checklist',

    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout___default.a, ConfirmIcon: __WEBPACK_IMPORTED_MODULE_4__ui_elements_ConfirmIcon___default.a, ListList: __WEBPACK_IMPORTED_MODULE_5__forms_lists_ListList___default.a, FormControl: __WEBPACK_IMPORTED_MODULE_7__forms_FormControl___default.a, Activities: __WEBPACK_IMPORTED_MODULE_8__forms_activity_Activities___default.a, ExpansionPanel: __WEBPACK_IMPORTED_MODULE_11__ui_elements_ExpansionPanel___default.a
    },
    data: function data() {
        return {
            requests: [],
            policiesDoc: null,

            item: {},
            proofsDoc: null,
            testItem: {
                first_name: 'Matty',
                last_name: 'Ireland'
            },

            formContext: { hello: 'World' },

            someComments: [{ 'description': 'This is my little comment. Please disregard for now until I expand on it' }, { 'description': 'Sure, I will ignore, but I cannot wait until this is working properly!!' }],
            scenarioSchema: null

        };
    },

    computed: {
        items: function items() {
            if (!this.proofsDoc) return [];
            if (!this.proofsDoc.list) this.proofsDoc.list = [];
            return this.proofsDoc.list;
        },
        lists: function lists() {
            return [{
                name: 'Proofs',
                schema: this.proofSchema,
                path: 'apps/dc/lists/proofs'
            }];
        },
        currentList: function currentList() {
            return this.lists[1];
        },
        allPolicies: function allPolicies() {
            return this.getAllPolicies(this.policiesDoc);
        }
    },
    methods: {
        getPolicyForField: function getPolicyForField(fieldName) {
            if (!fieldName) return null;
            return this.allPolicies.find(function (o) {
                return o.checklistField == fieldName;
            });
        },
        getAllPolicies: function getAllPolicies(doc) {
            if (!doc) return [];

            var policies = [];
            doc.categories.forEach(function (cat) {
                if (cat.policies) {
                    cat.policies.forEach(function (pol) {
                        policies.push(pol);
                    });
                }
            });
            return policies;
        },
        formChanged: function formChanged(changes) {

            __WEBPACK_IMPORTED_MODULE_10__ChecklistRules__["a" /* default */].addPolicy(changes);

            if (changes.type == 'Row Added' || changes.type == 'Row Changed' || changes.type == 'Field Changed' && changes.value) {
                console.log('Should add something here ++++');
                this.injectRequest(changes);
            } else {
                this.deleteRequest(changes);
                console.log('Should remove something here ----');
            }
            console.log(changes);
        },
        injectRequest: function injectRequest(changes) {
            var policy = this.getPolicyByName(changes.policy);

            var request = this.getNewOrExistingRequest(changes);
            request.name = changes.rowName || policy.name;
            request.policy = policy;
        },
        getExistingRequest: function getExistingRequest(changes) {
            var request = this.requests.find(function (o) {
                return (o.rowId == changes.rowId || !changes.rowId) && (o.field == changes.field || !changes.field);
            });
            return request;
        },
        makeNewRequest: function makeNewRequest(changes) {

            var request = {};
            request._id = this.changesToRequestId(changes);
            var obj = this.splitRequestId(request._id);
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(request, obj);

            request.name = '';
            this.requests.push(request);
            return request;
        },
        changesToRequestId: function changesToRequestId(changes) {
            return (changes.collection || 'global') + '/' + (changes.rowId || 'main') + '/' + (changes.field || 'none');
        },
        splitRequestId: function splitRequestId(requestId) {
            var arr = requestId.split('/');
            var obj = {
                collection: arr[0],
                rowId: arr[1],
                field: arr[2]
            };
        },
        getNewOrExistingRequest: function getNewOrExistingRequest(changes) {
            return this.getExistingRequest(changes) || this.makeNewRequest(changes);
        },
        deleteRequest: function deleteRequest(changes) {
            var id = this.changesToRequestId(changes);
            var idx = this.requests.findIndex(function (o) {
                return o._id == id;
            });
            if (!idx) {
                console.log('Cannot delete from list. Changes:', changes);
            }
            this.requests.splice(idx, 1);
        },
        getPolicyByName: function getPolicyByName(name) {

            var policy = this.allPolicies.find(function (o) {
                return o.name == name;
            });
            if (!policy) console.error('getPolicyByName fails to find policy for:', name);
            return policy;
        },
        policyAsText: function policyAsText(policy) {
            if (!policy) return '';
            return policy.default.options[0].requirements.map(function (o) {
                return o.description;
            }).join(' and ');
        },
        removeRequest: function removeRequest(id) {
            var idx = this.requests.findIndex(function (o) {
                return o._id == id;
            });
            if (idx > -1) this.requests.splice(idx, 1);
        },
        select: function select(item) {
            this.item = item || this.items[0];
            __WEBPACK_IMPORTED_MODULE_6__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'i', item._id);
        },
        add: function add() {
            var newItem = {
                _id: __WEBPACK_IMPORTED_MODULE_3__data_Db1__["a" /* default */].newId(),
                title: 'New Item'
            };
            this.items.unshift(newItem);
            this.select(newItem);
            this.$refs.itemForm.focusFirst();
        },
        save: function save() {},
        deleteCurrent: function deleteCurrent() {
            var _this = this;

            var idx = this.items.findIndex(function (p) {
                return p == _this.item;
            });
            this.items.splice(idx, 1);
            this.select();
            this.save();
        }
    },

    created: function created() {
        var _this2 = this;

        this.scenarioSchema = __WEBPACK_IMPORTED_MODULE_9__ChecklistSchemas__["a" /* default */].getScenarioSchema();

        __WEBPACK_IMPORTED_MODULE_3__data_Db1__["a" /* default */].fetchDocumentByCode('apps/dc/lists', 'policies').then(function (doc) {
            _this2.policiesDoc = doc;
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.save();
    }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Db__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Db1__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_RouterHelpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_FormControl__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__forms_FormControl__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Maintenance',
    props: {
        i: String },
    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default.a, ConfirmIcon: __WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon___default.a, ListList: __WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList___default.a, FormControl: __WEBPACK_IMPORTED_MODULE_6__forms_FormControl___default.a
    },
    data: function data() {
        return {
            item: null,
            proofsDoc: null,

            proofSchema: {
                fields: [{
                    type: 'text',
                    name: 'title',
                    label: 'Title',
                    validation: 'required'
                }, {
                    type: 'text',
                    name: 'keywords',
                    label: 'Other Search Keywords'
                }, {
                    type: 'file',
                    name: 'sample',
                    label: 'Sample Version',
                    multiple: true,
                    path: 'apps/dc/lists/items'
                }, {
                    type: 'group',
                    name: 'checks',
                    label: 'Document Checks',
                    columns: false,
                    fields: [{
                        type: 'text',
                        name: 'title',
                        label: 'Title',
                        placeholder: ' ',
                        hint: 'What to check...',
                        validation: 'required'
                    }, {
                        type: 'text',
                        name: 'description',
                        label: 'Description',
                        hint: 'How to check it...',
                        validation: 'required'
                    }]
                }] },

            claimSchema: [{
                type: 'text',
                name: 'title',
                label: 'Title',
                validation: 'required'
            }, {
                type: 'text',
                name: 'name',
                label: 'Name',
                placeholder: 'claim_name',
                validation: 'fieldname|required'
            }, {
                type: 'text',
                name: 'keywords',
                label: 'Other Search Keywords'
            }]

        };
    },

    computed: {
        items: function items() {
            if (!this.proofsDoc) return [];
            if (!this.proofsDoc.list) this.proofsDoc.list = [];
            return this.proofsDoc.list;
        },
        lists: function lists() {
            return [{
                name: 'Claims',
                schema: this.claimSchema,
                path: 'apps/dc/lists/claims'
            }, {
                name: 'Proofs',
                schema: this.proofSchema,
                path: 'apps/dc/lists/proofs'
            }];
        },
        currentList: function currentList() {
            return this.lists[1];
        }
    },
    methods: {
        select: function select(item) {
            this.item = item || this.items[0];
            __WEBPACK_IMPORTED_MODULE_5__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'i', item._id);
        },
        add: function add() {
            var newItem = {
                _id: __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].newId(),
                title: 'New Item'
            };
            this.items.unshift(newItem);
            this.select(newItem);
            this.$refs.itemForm.focusFirst();
        },
        save: function save() {
            __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].saveDocument(this.proofsDoc);
        },
        deleteCurrent: function deleteCurrent() {
            var _this = this;

            var idx = this.items.findIndex(function (p) {
                return p == _this.item;
            });
            this.items.splice(idx, 1);
            this.select();
            this.save();
        }
    },

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].fetchDocumentByCode('apps/dc/lists', 'proofs').then(function (doc) {
            _this2.proofsDoc = doc;
            _this2.item = _this2.items.find(function (o) {
                return o._id == _this2.i;
            }) || _this2.items[0];
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.save();
    }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_Db__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_Db1__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_lists_ListList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__forms_lists_ListList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__forms_lists_ListList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_RouterHelpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_FormControl__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__forms_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__forms_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_EditableText__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_EditableText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_EditableText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_Permissions__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_Permissions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__forms_Permissions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_Security__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_AlertHelpers__ = __webpack_require__(12);






















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Policies',
    props: {
        i: String },
    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_4__screens_ScreenLayout___default.a, ConfirmIcon: __WEBPACK_IMPORTED_MODULE_7__ui_elements_ConfirmIcon___default.a, ListList: __WEBPACK_IMPORTED_MODULE_8__forms_lists_ListList___default.a, FormControl: __WEBPACK_IMPORTED_MODULE_10__forms_FormControl___default.a, EditableText: __WEBPACK_IMPORTED_MODULE_11__ui_elements_EditableText___default.a, Permissions: __WEBPACK_IMPORTED_MODULE_15__forms_Permissions___default.a
    },
    data: function data() {
        return {
            showingGuide: false,
            search: null,
            lender: null,
            editing: false,
            selectedRequirement: null,
            selectedPolicy: null,
            policiesDoc: null,
            proofsDoc: null,
            lendersDoc: null,
            lenderStipulationsDoc: null,

            newLenderSchema: {
                width: 360,
                fields: [{
                    name: 'name',
                    type: 'Text',
                    label: 'Lender Name'
                }]
            },

            item: null,

            lenderSchema: {
                readOnly: true,
                fields: [{
                    visible: '[editing]',
                    type: 'Section Heading',
                    label: '[name]'
                }, {
                    visible: '[editing]',
                    name: 'name',
                    type: 'Text',
                    label: 'Lender Name'
                }, {
                    name: 'checklist',
                    type: 'File',
                    multiple: true,
                    label: 'Lender Issued Checklist'
                }]
            },

            lenderSchemaRO: {
                readOnly: true,
                fields: [{
                    name: 'checklist',
                    type: 'File',
                    multiple: true,
                    label: 'Lender Issued Checklist'
                }]
            },

            stipulationSchema: {
                readOnly: true,
                fields: [{
                    name: 'notRequired',
                    type: 'Checkbox',
                    label: 'Evidence Not Required'
                }, {
                    name: 'notSupported',
                    type: 'Checkbox',
                    label: 'Policy Not Supported'
                }]
            },

            policySchema: {
                readOnly: true,
                fields: [{
                    type: 'Section Heading',
                    label: '[name]'
                }, {
                    name: 'keywords',
                    type: 'Text',
                    label: 'Keywords for Searching'
                }, {
                    name: 'checklistField',
                    type: 'Text',
                    label: 'Checklist Field'
                }]
            },

            requirementSchema: {
                readOnly: true,
                fields: [{
                    name: 'description',
                    type: 'Text',
                    label: 'Description'
                }, {
                    name: 'checks',
                    type: 'Group',
                    label: 'Checks',
                    fields: [{
                        name: 'description',
                        type: 'Text',
                        label: 'What to Check'
                    }, {
                        name: 'officeUseOnly',
                        type: 'Checkbox',
                        label: 'Office Use Only'
                    }]
                }, {
                    name: 'details',
                    type: 'Html',
                    label: 'Details'
                }, {
                    name: 'sample',
                    type: 'File',
                    label: 'Sample'
                }, {
                    name: 'template',
                    type: 'File',
                    multiple: true,
                    label: 'Template'
                }, {
                    name: 'expiryDays',
                    type: 'Number',
                    label: 'Days to Expiry'
                }, {
                    name: 'officeUseOnly',
                    type: 'Checkbox',
                    label: 'Office Use Only'
                }]
            }

        };
    },

    computed: {
        pageTitle: function pageTitle() {
            return (this.lender ? this.lender.name + ' ' : '') + ' Evidence Requirements';
        },
        categories: function categories() {
            if (!this.policiesDoc) return [];
            return this.policiesDoc.categories;
        },
        lenders: function lenders() {
            if (!this.lendersDoc) return [];
            if (!this.lendersDoc.list) this.lendersDoc.list = [];
            return this.lendersDoc.list;
        },
        proofs: function proofs() {
            if (!this.proofsDoc) return [];
            if (!this.proofsDoc.list) this.proofsDoc.list = [];
            return this.proofsDoc.list;
        },
        proofsSelect: function proofsSelect() {
            return this.proofs.map(function (o) {
                return {
                    value: o._id,
                    text: o.title
                };
            });
        },
        lenderName: function lenderName() {
            if (this.lender) return this.lender.name;
            return null;
        },
        allPolicies: function allPolicies() {
            return this.getAllPolicies(this.policiesDoc);
        }
    },
    methods: {
        getAllPolicies: function getAllPolicies(doc) {
            if (!doc) return [];

            var policies = [];
            doc.categories.forEach(function (cat) {
                if (cat.policies) {
                    cat.policies.forEach(function (pol) {
                        policies.push(pol);
                    });
                }
            });
            return policies;
        },
        canWrite: function canWrite(doc) {
            return __WEBPACK_IMPORTED_MODULE_16__data_Security__["a" /* default */].canWrite(doc);
        },
        filterPolicies: function filterPolicies(policies) {
            var _this = this;

            if (this.search) return policies.filter(function (o) {
                return o.name && o.name.toLowerCase().indexOf(_this.search.toLowerCase()) > -1 || o.keywords && o.keywords.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
            });else return policies;
        },
        savePolicy: function savePolicy(policy) {
            console.log('savePolicy');
            var newStipulation = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(policy._stipulation));
            delete newStipulation._default;
            if (policy._stipulation._default) {
                delete newStipulation._id;
                policy.default = newStipulation;
                this.savePolicies();
            } else {
                this.updateCollection(newStipulation, this.lenderStipulationsDoc.stipulations);
                this.saveLenderStipulations();
            }
        },
        updateCollection: function updateCollection(obj, arr) {
            var idx = arr.findIndex(function (o) {
                return o._id == obj._id;
            });
            if (idx >= 0) {
                this.$set(arr, idx, obj);
                return true;
            } else return false;
        },
        makePreferredRequirement: function makePreferredRequirement(option, policy) {
            var idx = policy._stipulation.options.findIndex(function (o) {
                return o == option;
            });
            __WEBPACK_IMPORTED_MODULE_12__helpers_ArrayHelpers__["a" /* default */].moveItem(policy._stipulation.options, idx, 0);
        },
        addPolicy: function addPolicy(category) {
            if (!category.policies) this.$set(category, 'policies', []);

            var stipulation = {
                options: [{
                    requirements: [{ description: 'New requirement...' }]
                }]
            };
            category.policies.push({
                'name': 'New policy...',
                '_id': __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].newId(),
                'default': __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, stipulation),
                '_stipulation': __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, stipulation, { _default: true })
            });
        },
        addRequirement: function addRequirement(option) {
            option.requirements.push({ description: 'Requirement ' + (option.requirements.length + 1) + '...' });
        },
        addOption: function addOption(policy) {
            policy._stipulation.options.push({
                requirements: [{ description: 'Requirement 1...' }]
            });
        },
        deleteRequirement: function deleteRequirement(requirement, option, policy) {
            var idx = option.requirements.findIndex(function (o) {
                return o == requirement;
            });
            if (idx) {
                option.requirements.splice(idx, 1);
                this.savePolicy(policy);
            }
        },
        deleteOption: function deleteOption(policy, optionIndex) {
            policy._stipulation.options.splice(optionIndex, 1);
            this.savePolicy(policy);
        },
        deletePolicy: function deletePolicy(policy, category) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var idx;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$root.$confirm('Delete', 'Are you sure you want to delete this policy and associated requirements?', { color: 'red' });

                            case 2:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 6;
                                    break;
                                }

                                idx = category.policies.findIndex(function (o) {
                                    return o == policy;
                                });

                                if (idx) category.policies.splice(idx, 1);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        saveAll: function saveAll() {
            this.savePolicies();
            this.saveLenders();
        },
        savePolicies: function savePolicies() {
            var doc = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.policiesDoc));
            var policies = this.getAllPolicies(doc);
            policies.forEach(function (policy) {
                delete policy._stipulation;
            });
            __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].saveDocument(doc);
        },
        saveLenders: function saveLenders() {
            this.lendersDoc.list = this.lendersDoc.list.sort(__WEBPACK_IMPORTED_MODULE_17__helpers_OrderHelpers__["a" /* default */].sortByName);
            __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].saveDocument(this.lendersDoc);
        },
        updateLender: function updateLender(lender) {
            __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__["a" /* default */].copyProperties(lender, this.lender);
            this.saveLenders();
        },
        updateRequirement: function updateRequirement(requirement) {
            __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__["a" /* default */].copyProperties(requirement, this.selectedRequirement);
            this.savePolicy(this.selectedPolicy);
        },
        updatePolicy: function updatePolicy(policy) {
            __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__["a" /* default */].copyProperties(policy, this.selectedPolicy);
            this.savePolicy(this.selectedPolicy);
        },
        updateStipulation: function updateStipulation(stipulation) {
            __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__["a" /* default */].copyProperties(stipulation, this.selectedPolicy._stipulation);
            this.savePolicy(this.selectedPolicy);
        },
        markupSchema: function markupSchema(schema) {},
        downloadBackups: function downloadBackups() {
            __WEBPACK_IMPORTED_MODULE_14__helpers_FileHelpers__["a" /* default */].downloadObject(this.policiesDoc, 'Policies');
        },
        addLender: function addLender() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var newLender, lender;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                newLender = {
                                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].newId(),
                                    name: null
                                };
                                _context2.next = 3;
                                return _this3.$root.$dialog(newLender, _this3.newLenderSchema);

                            case 3:
                                lender = _context2.sent;

                                if (lender) _this3.lenders.unshift(lender);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        resetPolicy: function resetPolicy() {
            this.lenderStipulationsDoc = null;
            this.selectedPolicy = null;
            this.selectedRequirement = null;
        },
        lenderChanged: function lenderChanged() {
            var _this4 = this;

            this.allPolicies.forEach(function (policy) {
                _this4.setStipulation(policy);
            });

            if (!this.lender) {
                __WEBPACK_IMPORTED_MODULE_9__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'l', null);
                return;
            }

            __WEBPACK_IMPORTED_MODULE_9__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'l', this.lender._id);

            __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].fetchDocument('apps/dc/stipulations', this.lender._id).then(function (doc) {
                _this4.lenderStipulationsDoc = doc || {
                    _id: _this4.lender._id,
                    _path: 'apps/dc/stipulations',
                    lender: _this4.lender.name,
                    stipulations: []
                };

                _this4.lenderStipulationsDoc.stipulations.forEach(function (stipulation) {
                    var idx = _this4.allPolicies.findIndex(function (p) {
                        return p._id == stipulation._id;
                    });
                    if (idx >= 0) {
                        _this4.setStipulation(_this4.allPolicies[idx], stipulation);
                    }
                });
            }).catch(function (err) {
                console.log('lenderChanged', err);
            });

            this.selectedRequirement = null;
        },
        makeLenderRequirements: function makeLenderRequirements(policy) {
            var lenderPolicy = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(policy.default));
            lenderPolicy._id = policy._id;

            this.setStipulation(policy, lenderPolicy);

            this.lenderStipulationsDoc.stipulations.push(lenderPolicy);
        },
        saveLenderStipulations: function saveLenderStipulations() {
            __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].saveDocument(this.lenderStipulationsDoc);
        },
        revertToGeneric: function revertToGeneric(policy) {
            console.log('reverting');
            this.setStipulation(policy);
            var idx = this.lenderStipulationsDoc.stipulations.findIndex(function (o) {
                return o._id == policy._id;
            });
            if (idx > -1) {
                this.lenderStipulationsDoc.stipulations.splice(idx, 1);
                this.saveLenderStipulations();
            }
            this.savePolicy(policy);
        },
        setStipulation: function setStipulation(policy, stipulation) {
            var newStipulation = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(stipulation || policy.default));
            newStipulation._default = !Boolean(stipulation);
            this.$set(policy, '_stipulation', newStipulation);
        },
        addSpecialChecks: function addSpecialChecks(type) {
            if (!this.selectedRequirement.checks) this.$set(this.selectedRequirement, 'checks', []);
            if (type == 'statements') {
                this.selectedRequirement.checks.push({ description: 'Name is shown to identify statements' });
                this.selectedRequirement.checks.push({ description: 'Entire duration shown with no gaps' });
                this.selectedRequirement.checks.push({ description: 'May include transaction listings, but must contain 1 real proper statement' });
                this.selectedRequirement.checks.push({ description: 'No overdue/overlimit/negative balances' });
                this.selectedRequirement.checks.push({ description: 'No defaults, penalties or arrears in transactions' });
                this.savePolicy(this.selectedPolicy);
            }
        },
        isRequirementHilighted: function isRequirementHilighted(requirement) {

            if (!this.editing) return requirement == this.selectedRequirement;
        },
        startCreation: function startCreation() {
            var documents = [];
            var categoryOrder = 0;
            this.policiesDoc.categories.forEach(function (category) {
                categoryOrder += 1;
                category.policies.forEach(function (policy) {
                    policy.default.options.forEach(function (option) {
                        option.requirements.forEach(function (requirement) {
                            var req = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, requirement);
                            req.category = category.name;
                            req.order = categoryOrder;
                            req.for = policy.name;
                            documents.push(req);
                        });
                    });
                });
            });
            console.log(documents);
            var documentsDoc = {
                _id: __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].newId(),
                _path: '/apps/dc/lists',
                code: 'documents',
                documents: documents,
                permissions: {
                    editors: [__WEBPACK_IMPORTED_MODULE_16__data_Security__["a" /* default */].getMyId()]
                }
            };
            debugger;
            __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].saveDocument(documentsDoc);
        }
    },

    created: function created() {
        var _this5 = this;

        this.markupSchema(this.policySchema);

        __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].fetchDocumentByCode('apps/dc/lists', 'policies').then(function (doc) {
            _this5.policiesDoc = doc;

            _this5.allPolicies.forEach(function (policy) {
                _this5.setStipulation(policy);
            });
        });

        __WEBPACK_IMPORTED_MODULE_6__data_Db1__["a" /* default */].fetchDocumentByCode('apps/dc/lists', 'lenders').then(function (doc) {
            _this5.lendersDoc = doc;
            var lenderId = _this5.$route.query.l;
            if (lenderId) {

                var idx = _this5.lenders.findIndex(function (o) {
                    return o._id == lenderId;
                });
                if (idx > -1) _this5.$set(_this5, 'lender', _this5.lenders[idx]);
            }
        });
    },


    watch: {
        'lender': {
            handler: function handler(newVal) {
                console.log('detected lender change');
                this.lenderChanged();
            }
        },

        'editing': {
            handler: function handler(newVal) {
                this.requirementSchema.readOnly = !newVal;
                this.policySchema.readOnly = !newVal;
                this.lenderSchema.readOnly = !newVal;
                this.stipulationSchema.readOnly = !newVal;
            }
        }
    },

    beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Db__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Db1__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_RouterHelpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_FormControl__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forms_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__forms_FormControl__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DcPreferences',
    props: {
        i: String },
    components: { ScreenLayout: __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default.a, ConfirmIcon: __WEBPACK_IMPORTED_MODULE_3__ui_elements_ConfirmIcon___default.a, ListList: __WEBPACK_IMPORTED_MODULE_4__forms_lists_ListList___default.a, FormControl: __WEBPACK_IMPORTED_MODULE_6__forms_FormControl___default.a },
    data: function data() {
        return {

            profile: null,

            profileSchema: {

                fields: [{
                    name: 'name',
                    type: 'text',
                    label: 'Full Name',
                    validation: ''
                }, {
                    name: 'use_fact_find',
                    type: 'radio',
                    label: 'Client Fact Find',
                    items: [{ value: 'No', text: "Don't send one" }, { value: 'Yes', text: "Send my own" }]
                }, {
                    name: 'fact_find',
                    type: 'file',
                    multiple: false,
                    label: 'Client Fact Find',
                    visible: '"[use_fact_find]" == "Yes"'
                }, {
                    name: 'use_bank_statements',
                    type: 'radio',
                    label: 'Bankstatements.com.au',
                    items: [{ value: 'No', text: "I don't use them" }, { value: 'Yes', text: "I have an account" }]
                }, {
                    name: 'bank_statements',
                    type: 'link',
                    label: 'Bankstatements Link',
                    visible: '"[use_bank_statements]" == "Yes"'
                }]
            }

        };
    },

    computed: {},
    methods: {
        cgc: function cgc(newVal) {
            console.log('prefs got new val of ', newVal);
        },
        save: function save() {
            __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].saveDocument(this.profile);
        },
        makeProfile: function makeProfile() {
            this.profile = {
                _id: __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].me().uid,
                _path: '/apps/dc/preferences'
            };
        },
        controlChanged: function controlChanged(newVal) {
            console.log('new value passed right up is ', newVal);
        }
    },

    created: function created() {
        var _this = this;

        console.log(__WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].me().uid);

        __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].fetchDocument('apps/dc/preferences', __WEBPACK_IMPORTED_MODULE_2__data_Db1__["a" /* default */].me().uid).then(function (doc) {
            _this.profile = doc;
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.save();
    }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Step__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ObjectArrayHelpers__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FlowHelpers__ = __webpack_require__(283);
















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            flow: {
                steps: []
            },
            allFlows: []
        };
    },


    inject: ['$page'],

    components: {
        Step: __WEBPACK_IMPORTED_MODULE_6__Step___default.a, draggable: __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default.a
    },

    props: {
        level: {
            type: Number,
            default: 0
        },
        id: String
    },

    computed: {
        selectedSteps: function selectedSteps() {
            return this.flow.steps.filter(function (o) {
                return o._selected;
            });
        },
        chosenSteps: function chosenSteps() {
            var steps = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.selectedSteps));
            if (this.flow.focused) steps.push(this.flow.focused);
            return steps;
        }
    },

    methods: {
        getFlowFromCache: function getFlowFromCache(id) {
            return this.$page.allFlows.find(function (o) {
                return o._id == id;
            });
        },
        getSummary: function getSummary() {},
        toggleStepValue: function toggleStepValue(step, key) {
            this.$set(step, key, !Boolean(step[key]));
        },
        moved: function moved(event) {
            console.log('Moved to ', event.to);
        },
        focusFirst: function focusFirst() {
            var firstItem = this.flow.steps[0];
            if (firstItem) __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].focusById('step' + firstItem._id);
        },
        selectStep: function selectStep(step) {
            this.$set(step, '_selected', true);
        },
        toggleSelection: function toggleSelection(step) {
            __WEBPACK_IMPORTED_MODULE_8__helpers_ObjectArrayHelpers__["a" /* default */].toggleSelection(step);
        },
        addStep: function addStep(previousStep) {

            var vm = this;
            var newStep = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, previousStep);

            newStep._parent = this.flow;
            newStep.value = null;
            delete newStep.title;
            delete newStep.type;
            __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].removeMeta(newStep);
            newStep._id = __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].getId();
            var idx = this.flow.steps.findIndex(function (o) {
                return o._id == previousStep._id;
            });
            this.flow.steps.splice(idx + 1, 0, newStep);

            __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].focusById('step' + newStep._id);

            this.selectStep(newStep);
        },
        editStep: function editStep(step) {
            this.$page.designing = true;
            this.selectStep(step);
        },
        incrementDueDate: function incrementDueDate() {
            var _this = this;

            var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            this.$page.getSelectedSteps().forEach(function (step) {
                if (!step.due) _this.$set(step, 'due', new Date());
                _this.$set(step, 'due', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_date_fns__["e" /* addDays */])(step.due, days));
                if (!step.assigned) _this.$set(step, 'assigned', __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getUser());
            });
        },
        removeStep: function removeStep(step) {
            var idx = this.flow.steps.findIndex(function (o) {
                return o._id == step._id;
            });
            this.flow.steps.splice(idx, 1);
        },
        focusNextStep: function focusNextStep(step) {
            var nextStep = __WEBPACK_IMPORTED_MODULE_8__helpers_ObjectArrayHelpers__["a" /* default */].getNextItem(this.flow.steps, step);
            if (!nextStep) nextStep = this.flow.steps[0];
            __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].focusById('step' + nextStep._id);
        },
        focusPreviousStep: function focusPreviousStep(step) {
            var previousStep = __WEBPACK_IMPORTED_MODULE_8__helpers_ObjectArrayHelpers__["a" /* default */].getPreviousItem(this.flow.steps, step);
            if (!previousStep) previousStep = this.flow.steps[this.flow.steps.length - 1];
            __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].focusById('step' + previousStep._id);
        },
        keyPressed: function keyPressed(event, step) {
            if ((event.ctrlKey || event.metaKey) && event.key == "ArrowDown") {
                this.addStep(step);
                return;
            }

            if ((event.ctrlKey || event.metaKey) && event.code == 'KeyI') {
                var newImportance = void 0;
                var MAX_IMPORTANCE = 3;
                if (!step.important) newImportance = 1;else if (step.important == MAX_IMPORTANCE) newImportance = 0;else newImportance = step.important + 1;

                this.$set(step, 'important', newImportance);

                event.preventDefault();
                return;
            }

            if (event.key == 'ArrowDown') {
                this.focusNextStep(step);
                return;
            }

            if (event.key == 'ArrowUp') {
                this.focusPreviousStep(step);
                return;
            }

            if (event.key == 'ArrowRight') {
                this.incrementDueDate();
                return;
            }
            if (event.key == 'ArrowLeft') {
                this.incrementDueDate(-1);
                return;
            }

            if (event.keyCode == 32) {
                this.toggleSelection(step);
                return;
            }

            if (event.key == 'Escape') {
                step.$page.designing = false;
                return;
            }

            if (event.key == "Enter" && __WEBPACK_IMPORTED_MODULE_8__helpers_ObjectArrayHelpers__["a" /* default */].isLastItem(this.flow.steps, step)) {
                if (step.title) this.addStep(step);else {
                    this.removeStep(step);
                    this.flow.designing = false;
                }
                return;
            }

            if (event.key == 'Shift') return;

            if (event.key >= 'a' && event.key <= 'z') this.$page.showActivity(event.key);
            console.log('opendi', event.key);
        }
    },

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var flow;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            flow = void 0;

                            flow = _this2.getFlowFromCache(_this2.id);

                            if (!flow) {
                                _context.next = 6;
                                break;
                            }

                            _this2.flow = flow;
                            _context.next = 10;
                            break;

                        case 6:
                            _context.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_12__FlowHelpers__["a" /* default */].fetchFlow(_this2.id);

                        case 8:
                            _this2.flow = _context.sent;

                            _this2.$page.allFlows.push(_this2.flow);

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_SpeechBubble__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_SpeechBubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_SpeechBubble__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    inject: ['$page'],

    components: {
        SpeechBubble: __WEBPACK_IMPORTED_MODULE_0__ui_SpeechBubble___default.a
    },

    props: {
        activities: Array
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ObjectArrayHelpers__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_DueIndicator__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_DueIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_DueIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepSelector__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__StepSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_ContactHelpers__ = __webpack_require__(9);
















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            designing: false,
            readOnly: false
        };
    },


    inject: ['$page'],

    components: {
        DueIndicator: __WEBPACK_IMPORTED_MODULE_4__ui_DueIndicator___default.a, StepSelector: __WEBPACK_IMPORTED_MODULE_6__StepSelector___default.a
    },

    props: {
        step: Object,
        level: Number
    },

    computed: {
        flowStepStyle: function flowStepStyle() {
            var style = {};
            if (this.step.important) {
                style['background-size'] = 'contain';
                style['background-position'] = '45px 0px';
                style['background-image'] = 'url(/static/images/hilight' + this.step.important + '.png)';
            }
            return style;
        }
    },

    methods: {
        stepIconClicked: function stepIconClicked(step) {
            this.quickLoader();
            this.toggle(step, 'complete');
            this.$delete(step, 'percent');
        },
        quickLoader: function quickLoader() {
            var _this = this;

            var milliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 900;

            this.toggle(this.step, '_loading');
            setTimeout(function () {
                _this.$delete(_this.step, '_loading');
            }, milliseconds);
        },
        iconClicked: function iconClicked(step) {
            if (step.expanded) {
                this.$children.forEach(function (childWorkflow) {
                    console.log(childWorkflow);
                });
            } else this.quickLoader(1200);
            this.toggle(step, 'expanded');
        },
        toggle: function toggle(step, field) {
            console.log('setting step to ' + !step.field);
            this.$set(step, field, !step[field]);
        },
        toggleComplete: function toggleComplete(step) {
            this.toggle(step, 'complete');
        },
        isActive: function isActive(step) {
            return this.$page.activeStep && step._id == this.$page.activeStep._id;
        },
        stepFocus: function stepFocus(step) {
            this.$page.activeStep = step;
        },
        stepBlur: function stepBlur(step) {
            this.$emit('blur');
        },
        getIconName: function getIconName(step) {

            if (step.type == 'task') return 'check_circle';
            if (step.type.startsWith('file')) return 'cloud_upload';
            return '';
        },
        getIconColour: function getIconColour(step) {
            if (step.complete) return 'blue';

            return 'rgba(0,0,0,0.1)';
        },
        getStepDOMElement: function getStepDOMElement(step) {
            return document.getElementById('step' + step._id);
        },
        randomPercentage: function randomPercentage() {
            var percent = __WEBPACK_IMPORTED_MODULE_5__helpers_NumberHelpers__["a" /* default */].randomIntRange(1, 99);
            if (percent < 30) return 0;
            if (percent > 70) return 100;
            return percent;
        },
        clicked: function clicked(event, step) {
            console.log('clicked', step);

            if (event.ctrlKey || event.metaKey) {
                __WEBPACK_IMPORTED_MODULE_0__helpers_ObjectArrayHelpers__["a" /* default */].toggleSelection(step);
                return;
            }

            if (event.shiftKey) {
                var allSteps = this.$page.getAllVisibleSteps();

                __WEBPACK_IMPORTED_MODULE_0__helpers_ObjectArrayHelpers__["a" /* default */].selectRange(allSteps, step);
                return;
            }

            this.$page.unselectAll();
            this.selectStep(step);
        },
        selectStep: function selectStep(step) {
            this.$set(step, '_selected', true);
        },
        hasLines: function hasLines(step) {
            return step.type == 'task';
        },
        showScheduler: function showScheduler() {
            if (this.step.due) return true;
            if (this.step.showScheduler === false) return false;
            if (this.step.showScheduler === true) return true;
            if (this.step.type == 'task') return true;
            return false;
        },


        debouncedDueChanged: __WEBPACK_IMPORTED_MODULE_8__helpers_Utilities__["a" /* default */].debounce(function (changes, vm) {
            vm.trackChanges(changes);
        }, 1500),

        trackChanges: function trackChanges(changes) {
            console.log('tracking changes', changes);
            this.$page.activities.push(changes);
        }
    },

    created: function created() {},


    watch: {
        'step.value': {
            handler: function handler(newVal, oldVal) {
                var changes = {
                    stepId: this.step._id,
                    type: 'Change Data',
                    description: 'Changed field \'' + this.step.title + '\' from \'' + oldVal + '\' to \'' + newVal + '\''
                };
                this.trackChanges(changes);
            }
        },
        'step.assigned': {
            handler: function handler(newVal, oldVal) {
                if (newVal == oldVal) return;
                var changes = {
                    stepId: this.step._id,
                    type: 'Schedule',
                    description: 'Assigned \'' + this.step.title + '\' to \'' + __WEBPACK_IMPORTED_MODULE_9__helpers_ContactHelpers__["a" /* default */].fullName(newVal) + '\'.'
                };
                if (oldVal) changes.description += ' Previously \'' + __WEBPACK_IMPORTED_MODULE_9__helpers_ContactHelpers__["a" /* default */].fullName(oldVal) + '\'';
                this.trackChanges(changes);
            }
        },
        'step.due': {
            handler: function handler(newVal, oldVal) {
                if (oldVal == newVal) return;

                var changes = {
                    stepId: this.step._id,
                    type: 'Schedule'
                };
                if (newVal) changes.description = 'Scheduled \'\' for \'' + __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToAu(newVal) + '\'.';else changes.description = 'Removed due date for ' + this.step.title + '.';

                if (oldVal) {
                    changes.description += ' Previously \'' + __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToAu(oldVal) + '\'';
                }
                this.debouncedDueChanged(changes, this);
            }
        }
    }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controls_FileUpload__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controls_FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__controls_FileUpload__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        FileUpload: __WEBPACK_IMPORTED_MODULE_1__controls_FileUpload___default.a
    },

    props: {
        step: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        updateValue: function updateValue(val) {

            this.step.value = val;
        }
    },

    created: function created() {}
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flow__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_StepDesigner__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_StepDesigner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_StepDesigner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_ToolbarSearch__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_ToolbarSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_ToolbarSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FlowHelpers__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FlowActivity__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FlowActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__FlowActivity__);
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Workflow',
    components: { ScreenLayout: __WEBPACK_IMPORTED_MODULE_1__screens_ScreenLayout___default.a, Flow: __WEBPACK_IMPORTED_MODULE_2__Flow___default.a, ToolbarSearch: __WEBPACK_IMPORTED_MODULE_7__ui_elements_ToolbarSearch___default.a, StepDesigner: __WEBPACK_IMPORTED_MODULE_3__ui_StepDesigner___default.a, FlowActivity: __WEBPACK_IMPORTED_MODULE_12__FlowActivity___default.a },
    props: {
        flowId: String
    },
    data: function data() {
        return {
            page: {

                newComment: null,
                activeStep: null,
                allFlows: [],

                activities: [],

                showActivity: function showActivity(desc) {
                    this.newComment = desc;
                    __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].focusById('activityDescription');
                },

                getAllVisibleSteps: function getAllVisibleSteps() {
                    return this.getAllSteps(null, null, { visible: true });
                },
                getAllSteps: function getAllSteps(workflowId, allSteps) {
                    var _this = this;

                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                    if (!allSteps) allSteps = [];
                    var workflow = void 0;

                    if (workflowId) workflow = this.allFlows.find(function (o) {
                        return o._id == workflowId;
                    });else workflow = this.allFlows.find(function (o) {
                        return o.name == 'root';
                    });

                    workflow.steps.forEach(function (step) {
                        allSteps.push(step);
                        if (step.children) {
                            step.children.forEach(function (childId) {
                                if (!options.visible || step.expanded) _this.getAllSteps(childId, allSteps, options);
                            });
                        }
                    });
                    return allSteps;
                },
                getSelectedSteps: function getSelectedSteps() {
                    var allSelected = [];
                    this.allFlows.forEach(function (flow) {
                        var selectedSteps = flow.steps.filter(function (o) {
                            return o._selected;
                        });
                        allSelected = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(allSelected), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(selectedSteps));
                    });
                    return allSelected;
                },
                unselectAll: function unselectAll() {
                    this.getSelectedSteps().forEach(function (step) {
                        __WEBPACK_IMPORTED_MODULE_8_vue__["default"].delete(step, '_selected');
                    });
                },
                saveAll: function saveAll() {
                    this.allFlows.forEach(function (flow) {
                        __WEBPACK_IMPORTED_MODULE_11__FlowHelpers__["a" /* default */].saveFlow(flow);
                    });
                    __WEBPACK_IMPORTED_MODULE_10__helpers_AlertHelpers__["a" /* default */].showAlert('Saved Everything');
                }
            },
            sampleFlows: [],
            flow: {}
        };
    },

    provide: function provide() {
        return {
            '$page': this.page
        };
    },
    computed: {
        makingActivity: {
            get: function get() {
                return Boolean(this.page.newComment);
            },
            set: function set(newVal) {
                if (!newVal) this.page.newComment = null;
            }
        }
    },

    methods: {
        search: function search() {
            console.log('searching...');
        },
        mockFlows: function mockFlows() {

            return [{
                _id: 'BiI1r9ST77HjOeOIlbQ4',
                name: 'root',
                title: 'Home Loan Demo',
                steps: [{
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Lead',
                    name: 'lead',
                    type: 'task',
                    value: null,
                    complete: true
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Loan',
                    name: 'loan',
                    type: 'task',
                    value: null,
                    complete: true
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Pricing and Valuation',
                    description: 'Pricing Ordered, Pricing Back, Valuation Ordered',
                    name: 'pricing_valuation',
                    type: 'task',
                    value: null,
                    children: ['YflNLuJ7Kby867fLuYjT'],
                    due: new __WEBPACK_IMPORTED_MODULE_4_date_fns__["e" /* addDays */](new Date(), 3),
                    assigned: __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getUser(),
                    percent: 50
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Submission',
                    name: 'submission',
                    type: 'task',
                    value: null,
                    percent: 30
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Conditional',
                    name: 'conditional',
                    type: 'task',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Formal',
                    name: 'formal',
                    type: 'task',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Settled',
                    name: 'settled',
                    type: 'task',
                    value: null
                }]
            }, {
                _id: 'YflNLuJ7Kby867fLuYjT',
                name: 'pricing',
                steps: [{
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Pricing Ordered',
                    name: 'pricing_ordered',
                    type: 'task',
                    value: null,
                    complete: true
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Pricing Back',
                    name: 'pricing_back',
                    type: 'task',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Valuation Ordered',
                    name: 'val_ordered',
                    type: 'task',
                    value: null,
                    complete: true,
                    children: ['0bccrQE8PRwLMoTq1bUx'],
                    description: '$400,000, Trentons Valuation Services',
                    important: 3
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Valuation Back',
                    name: 'val_back',
                    type: 'task',
                    value: null,
                    due: new Date()
                }]
            }, {
                _id: '0bccrQE8PRwLMoTq1bUx',
                name: 'val_details',
                steps: [{
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Val Estimate',
                    name: 'val_estimate',
                    type: 'text',
                    value: '$400,000',
                    important: 1
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Valuer Details',
                    name: 'valuer',
                    type: 'text',
                    value: 'Trentons Valuation Services'
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Full Valuation',
                    name: 'full_val',
                    type: 'true-false/switch',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Contract of Sale',
                    name: 'cos',
                    type: 'file/upload',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Sent COS',
                    name: 'sent_cos',
                    type: 'true-false/checkbox',
                    value: null,
                    important: 2

                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Sent Lender Info',
                    name: 'sent_lender_info',
                    type: 'true-false/checkbox',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Checked purchase amount',
                    name: 'purchase_amt',
                    type: 'true-false/checkbox',
                    value: null
                }, {
                    _id: __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId(),
                    title: 'Due Back',
                    name: 'due_back',
                    type: 'text',
                    value: '14 October'
                }]
            }];
        }
    }

});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        step: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        contact: Object,
        emptyTooltip: {
            type: String,
            default: 'No Contact'
        },
        size: {
            type: Number,
            default: 50
        }
    },

    computed: {
        pictureUrl: function pictureUrl() {
            try {
                return this.contact.image;
            } catch (e) {
                return null;
            }
        },
        backgroundUrlString: function backgroundUrlString() {
            if (this.pictureUrl && this.pictureUrl.indexOf('random') < 0) return 'url(\'' + this.pictureUrl + '\')';else return 'none';
        },
        initials: function initials() {
            if (!this.pictureUrl || this.pictureUrl.indexOf('random') > -1) return __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].initials(this.contact);
        },
        fullName: function fullName() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].fullName(this.contact) || this.emptyTooltip;
        },
        imageStyle: function imageStyle() {
            return {
                'background-image': this.backgroundUrlString,
                'width': this.size + 'px',
                'height': this.size + 'px',
                'max-width': this.size + 'px',
                'max-height': this.size + 'px',
                'min-width': this.size + 'px',
                'min-height': this.size + 'px',
                'line-height': this.size + 'px',
                'font-size': 6 + this.size / 5 + 'px',
                'font-weight': this.size < 40 ? 600 : 400,
                'background-color': this.initialsToColour(this.initials)
            };
        }
    },

    methods: {
        initialsToColour: function initialsToColour(initials) {
            if (!initials || initials.length != 2) return '#b0bec5';

            var alphabet = "abcdefghijklmnopqrstuvwxyz";
            var colours = ['#e57373', '#f06292', '#ba68c8', '#9575cd', '#7986cb', '#039be5', '#ff5722'];
            var pos1 = alphabet.indexOf(initials[0].toLowerCase());
            var pos2 = alphabet.indexOf(initials[1].toLowerCase());
            var colourPos = (pos1 + pos2) % 7;
            return colours[colourPos];
        }
    },

    created: function created() {}
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactImage__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContactImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContactImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            calendarVisible: false,
            contacts: [{
                _id: __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].getId(),
                firstName: 'Linda',
                lastName: 'Ireland',
                image: __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__["a" /* default */].getSampleImage('female')
            }, {
                _id: __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].getId(),
                firstName: 'Peta',
                lastName: 'Short',
                image: __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__["a" /* default */].getSampleImage('female')
            }, {
                _id: __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].getId(),
                firstName: 'Bill',
                lastName: 'Jaemeison'
            }, {
                _id: __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].getId(),
                firstName: 'James',
                lastName: 'Squire',
                image: __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__["a" /* default */].getSampleImage('male')
            }, {
                _id: __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].getId(),
                firstName: 'Harriet',
                lastName: 'Constantino',
                image: __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__["a" /* default */].getSampleImage('female')
            }, {
                _id: __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].getId(),
                firstName: 'Jonothon',
                lastName: 'Draper'
            }]
        };
    },


    components: {
        ContactImage: __WEBPACK_IMPORTED_MODULE_3__ContactImage___default.a
    },

    props: {
        task: Object
    },

    computed: {
        backwardsDate: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].dateToBackwards(this.task.due);
            },
            set: function set(val) {
                this.$set(this.task, 'due', __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].backwardsToDate(val));
                if (!this.task.assigned) this.$set(this.task, 'assigned', __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getUser());
            }
        },

        dueDays: function dueDays() {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["I" /* differenceInBusinessDays */])(this.task.due, new Date());
        },
        dueOpacity: function dueOpacity() {
            if (this.dueDays < 2) return .9;
            if (this.dueDays < 4) return .6;
            return .4;
        },
        dueColour: function dueColour() {
            if (this.dueDays == 0) return '#2E9AFE';
            if (this.dueDays < 0) return '#FE2E64';
            return '#848484';
        }
    },

    methods: {
        fromNow: function fromNow(dt) {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].fromNow(dt);
        },
        clearSchedule: function clearSchedule() {
            this.$delete(this.task, 'due');
            this.$delete(this.task, 'assigned');
            this.calendarVisible = false;
        }
    },

    created: function created() {}
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactImage__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContactImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ContactImage__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ContactImage: __WEBPACK_IMPORTED_MODULE_1__ContactImage___default.a
    },

    props: {
        activity: Object
    },

    computed: {
        isCurrentUser: function isCurrentUser() {
            return false;
        },
        currentUser: function currentUser() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getUser();
        }
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            usedInTemplates: false,
            stepTypes: ['file', 'file/upload', 'task', 'text', 'true-false', 'true-false/switch', 'true-false/checkbox'],
            importanceLevels: [{ value: 0, text: 'Normal' }, { value: 1, text: 'Hilight' }, { value: 2, text: 'Important' }, { value: 3, text: 'Urgent' }]
        };
    },


    inject: ['$page'],

    components: {},

    props: {
        item: Object
    },

    computed: {
        step: function step() {
            return this.$page.activeStep || null;
        }
    },

    methods: {
        getBackgroundStyle: function getBackgroundStyle(value) {
            var style = {
                'background-image': 'url(/static/images/hilight' + value + '.png)'
            };
            if (value == 3) {
                style['padding-left'] = '25px';
                style['padding-top'] = '7px';
                style['height'] = '30px';
                style['background-size'] = 'contain';
            }
            return style;
        }
    },

    created: function created() {},


    watch: {
        'usedInTemplates': {
            handler: function handler(newVal) {
                if (!newVal) this.step.name = '';else this.step.name = __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__["a" /* default */].toSnakeCase(this.step.title);
            }
        }
    }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        schema: Array,
        value: Object,
        horizontal: Boolean,
        context: Object
    },

    computed: {},

    methods: {
        sectionStyle: function sectionStyle(field) {
            var style = {};
            if (this.horizontal) {
                style.minWidth = '130px';
                if (field.width) {
                    style['flex-basis'] = field.width;
                    style['flex-grow'] = 1;
                } else {
                    style['flex-grow'] = 5;
                    style['flex-shrink'] = 5;
                }
            }
            return style;
        },
        emitChanges: function emitChanges(newVal, fieldName) {
            var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value);
            this.$set(obj, fieldName, newVal);
            this.$emit('change', obj);
        }
    },
    watch: {},
    created: function created() {}
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controls_GroupControl__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controls_GroupControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__controls_GroupControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controls_SectionControl__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controls_SectionControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__controls_SectionControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controls_TextControl__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controls_TextControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__controls_TextControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controls_PaymentControl__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controls_PaymentControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__controls_PaymentControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controls_NumberControl__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__controls_NumberControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__controls_NumberControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controls_LinkControl__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__controls_LinkControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__controls_LinkControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controls_SwitchControl__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controls_SwitchControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__controls_SwitchControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controls_CheckboxControl__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controls_CheckboxControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__controls_CheckboxControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controls_FileControl__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controls_FileControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__controls_FileControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__controls_RadioControl__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__controls_RadioControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__controls_RadioControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controls_SectionHeadingControl__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controls_SectionHeadingControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__controls_SectionHeadingControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controls_HtmlControl__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controls_HtmlControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__controls_HtmlControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__controls_YesNoControl__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__controls_YesNoControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__controls_YesNoControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__viewers_FileView__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__viewers_FileView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__viewers_FileView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_MergeHelpers__ = __webpack_require__(33);






















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        TextControl: __WEBPACK_IMPORTED_MODULE_3__controls_TextControl___default.a, NumberControl: __WEBPACK_IMPORTED_MODULE_5__controls_NumberControl___default.a, GroupControl: __WEBPACK_IMPORTED_MODULE_1__controls_GroupControl___default.a, SectionControl: __WEBPACK_IMPORTED_MODULE_2__controls_SectionControl___default.a, SwitchControl: __WEBPACK_IMPORTED_MODULE_7__controls_SwitchControl___default.a, CheckboxControl: __WEBPACK_IMPORTED_MODULE_8__controls_CheckboxControl___default.a,
        FileControl: __WEBPACK_IMPORTED_MODULE_9__controls_FileControl___default.a, LinkControl: __WEBPACK_IMPORTED_MODULE_6__controls_LinkControl___default.a, RadioControl: __WEBPACK_IMPORTED_MODULE_10__controls_RadioControl___default.a, PaymentControl: __WEBPACK_IMPORTED_MODULE_4__controls_PaymentControl___default.a,
        FileView: __WEBPACK_IMPORTED_MODULE_15__viewers_FileView___default.a, SectionHeadingControl: __WEBPACK_IMPORTED_MODULE_11__controls_SectionHeadingControl___default.a, HtmlControl: __WEBPACK_IMPORTED_MODULE_12__controls_HtmlControl___default.a, CurrencyControl: __WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl___default.a, YesNoControl: __WEBPACK_IMPORTED_MODULE_14__controls_YesNoControl___default.a
    },

    props: {
        schema: Object,
        value: [Boolean, Array, String, Number, Object],
        context: Object,
        record: Object
    },

    computed: {
        controlName: function controlName() {
            return this.schema.type.replace(' ', '') + 'Control';
        },
        viewerName: function viewerName() {
            return this.schema.type.replace(' ', '') + 'View';
        },
        isVisible: function isVisible() {

            var visible = this.schema.visible;

            if (typeof visible == 'undefined') return true;
            if (typeof visible == 'boolean') return visible;

            var expression = this.merge(visible, this.record);
            console.log('Expression is ', expression);
            var result = void 0;
            try {
                result = eval(expression);
            } catch (e) {
                result = false;
            }

            console.log('checking vis for ', this.schema.label, 'returns....', result);

            return result;
        },
        mergedSchema: function mergedSchema() {
            var newSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.schema);
            newSchema.label = this.merge(newSchema.label, this.record);
            return newSchema;
        }
    },

    methods: {
        evalInFormOrRecord: function evalInFormOrRecord(expression) {
            var ctx = void 0;
            if (expression.indexOf('record.') > -1) {
                expression = expression.replace('record.', 'this.');
                ctx = this.record;
            } else if (expression.indexOf('form.') > -1) {

                expression = expression.replace('form.', 'this.');
                ctx = this.globalForm.formValue;
            }

            return this.evalInContext(expression, ctx);
        },
        evalInContext: function evalInContext(js, context) {
            return function () {
                return eval(js);
            }.call(context);
        },
        merge: function merge(str, context) {

            if (!str || str.indexOf('[') < 0) return str;

            var mergeItems = this.findMergeFields(str);

            mergeItems.forEach(function (mergeItem) {
                var value = context[mergeItem.name];
                if (typeof value !== 'undefined') str = str.replace(mergeItem.text, value);
            });

            console.log('Merge returns ', str);
            return str;
        },
        findMergeFields: function findMergeFields(searchString) {

            var matches = [];
            var match = void 0;

            do {
                match = String(searchString).match(/\[(.*?)\]/i);
                if (!match) break;

                var innerMatch = match[1];
                var outerMatch = match[0];

                var innerArr = innerMatch.split('|');
                var matchObj = {
                    name: innerArr[0].trim(),
                    text: outerMatch,
                    operations: []
                };
                for (var n = 1; n < innerArr.length; n++) {
                    var operationArr = innerArr[n].split(':');
                    matchObj.operations.push({
                        operator: operationArr[0].trim(),
                        value: (operationArr.length > 1 ? operationArr[1] : '').trim()
                    });
                }

                matches.push(matchObj);
                searchString = searchString.replace(outerMatch, '');
            } while (match);

            return matches;
        }
    },

    created: function created() {},


    watch: {
        'globalForm': {
            handler: function handler(newVal) {
                'Global form changed to ', newVal;
            },
            deep: true
        }

    }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blocks_GroupControl__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blocks_GroupControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__blocks_GroupControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks_SectionControl__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks_SectionControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__blocks_SectionControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_SwitchHeadingControl__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks_SwitchHeadingControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__blocks_SwitchHeadingControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_TextControl__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blocks_TextControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__blocks_TextControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_CheckboxControl__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__blocks_CheckboxControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__blocks_CheckboxControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_CurrencyControl__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blocks_CurrencyControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__blocks_CurrencyControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_FileControl__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blocks_FileControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__blocks_FileControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_HtmlControl__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blocks_HtmlControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__blocks_HtmlControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blocks_LinkControl__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__blocks_LinkControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__blocks_LinkControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__blocks_NumberControl__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__blocks_NumberControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__blocks_NumberControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__blocks_PaymentControl__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__blocks_PaymentControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__blocks_PaymentControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__blocks_RadioControl__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__blocks_RadioControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__blocks_RadioControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__blocks_SectionHeadingControl__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__blocks_SectionHeadingControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__blocks_SectionHeadingControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__blocks_SwitchControl__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__blocks_SwitchControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__blocks_SwitchControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__blocks_YesNoControl__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__blocks_YesNoControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__blocks_YesNoControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__blocks_DropdownLabelControl__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__blocks_DropdownLabelControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__blocks_DropdownLabelControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Merger__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__viewers_FileView__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__viewers_FileView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__viewers_FileView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_MergeHelpers__ = __webpack_require__(33);



























/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        TextControl: __WEBPACK_IMPORTED_MODULE_4__blocks_TextControl___default.a, NumberControl: __WEBPACK_IMPORTED_MODULE_10__blocks_NumberControl___default.a, GroupControl: __WEBPACK_IMPORTED_MODULE_1__blocks_GroupControl___default.a, SectionControl: __WEBPACK_IMPORTED_MODULE_2__blocks_SectionControl___default.a, SwitchHeadingControl: __WEBPACK_IMPORTED_MODULE_3__blocks_SwitchHeadingControl___default.a, SwitchControl: __WEBPACK_IMPORTED_MODULE_14__blocks_SwitchControl___default.a, CheckboxControl: __WEBPACK_IMPORTED_MODULE_5__blocks_CheckboxControl___default.a,
        FileControl: __WEBPACK_IMPORTED_MODULE_7__blocks_FileControl___default.a, LinkControl: __WEBPACK_IMPORTED_MODULE_9__blocks_LinkControl___default.a, RadioControl: __WEBPACK_IMPORTED_MODULE_12__blocks_RadioControl___default.a, PaymentControl: __WEBPACK_IMPORTED_MODULE_11__blocks_PaymentControl___default.a,
        FileView: __WEBPACK_IMPORTED_MODULE_19__viewers_FileView___default.a, SectionHeadingControl: __WEBPACK_IMPORTED_MODULE_13__blocks_SectionHeadingControl___default.a, HtmlControl: __WEBPACK_IMPORTED_MODULE_8__blocks_HtmlControl___default.a, CurrencyControl: __WEBPACK_IMPORTED_MODULE_6__blocks_CurrencyControl___default.a, YesNoControl: __WEBPACK_IMPORTED_MODULE_15__blocks_YesNoControl___default.a, DropdownLabelControl: __WEBPACK_IMPORTED_MODULE_16__blocks_DropdownLabelControl___default.a
    },

    props: {
        schema: [Object],
        value: [Boolean, Array, String, Number, Object],
        context: Object,
        horizontal: Boolean
    },

    computed: {
        shouldRenderFields: function shouldRenderFields() {
            var theType = this.schema.type;
            var excludes = ['Group', 'Section', 'group', 'section'];
            return !excludes.includes(theType) || !theType;
        },
        childFields: function childFields() {
            return this.schema.fields || [];
        },
        controlName: function controlName() {
            if (!this.schema.type) return "";

            return (this.schema.type || '').replace(' ', '') + 'Control';
        },
        viewerName: function viewerName() {
            return this.schema.type.replace(' ', '') + 'View';
        },
        isVisible: function isVisible() {

            var visible = this.schema.visible;

            if (typeof visible == 'undefined') return true;
            if (typeof visible == 'boolean') return visible;

            var result = __WEBPACK_IMPORTED_MODULE_18__Merger__["a" /* default */].processExpressions(visible, this.value);

            return result;
        },
        mergedSchema: function mergedSchema() {
            var newSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.schema);
            newSchema.label = __WEBPACK_IMPORTED_MODULE_18__Merger__["a" /* default */].processExpressions(newSchema.label, this.value);
            return newSchema;
        }
    },

    methods: {
        clearInvisibleField: function clearInvisibleField() {
            this.value[this.schema.name] = null;
        },
        formBlockClicked: function formBlockClicked(e) {},
        blockStyle: function blockStyle(field) {
            var style = {};
            if (this.horizontal) {
                style.minWidth = '130px';
                if (field.width) {
                    style['flex-basis'] = field.width;
                    style['flex-grow'] = 1;
                } else {
                    style['flex-grow'] = 5;
                    style['flex-shrink'] = 5;
                }
            }
            return style;
        },
        change: function change(newVal) {

            if (newVal && newVal.changed) {
                this.$emit('change', newVal);
                return;
            }

            var oldVal = this.value[this.schema.name];

            this.$set(this.value, this.schema.name, newVal);
            var changes = {
                type: 'Field Changed',
                changed: true,
                field: this.schema.name,
                old: oldVal,
                value: newVal,
                row: this.value
            };
            this.$emit('change', changes);
        },
        focusFirst: function focusFirst() {
            var _this = this;

            setTimeout(function () {
                if (__WEBPACK_IMPORTED_MODULE_17__helpers_Utilities__["a" /* default */].isMobile()) return;
                var el = _this.$el.querySelector("input");
                if (el) {
                    el.focus();
                    el.select();
                }
            }, 200);
        },
        focus: function focus(e, eventContext) {
            this.$set(this.context, 'focusedField', this.schema.name);
        }
    },

    created: function created() {
        if (!this.value.hasOwnProperty(this.schema.name)) this.$set(this.value, this.schema.name, null);
    },


    watch: {
        'isVisible': {
            handler: function handler(newVal) {
                if (!newVal) {
                    this.clearInvisibleField();
                }
            }
        }

    }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        schema: Object,
        value: Object,
        context: Object
    },

    computed: {
        formClass: function formClass() {
            return {
                xray: this.schema.debug
            };
        },
        childContext: function childContext() {
            var ctx = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.context || {}));
            ctx.form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.value));
            return ctx;
        },
        schemaFields: function schemaFields() {
            var _this = this;

            var fields = this.schema.fields;
            fields.forEach(function (field) {
                field._root = _this.schema;
            });
            return fields;
        }
    },

    methods: {
        focusFirst: function focusFirst() {
            var _this2 = this;

            setTimeout(function () {
                var inputs = _this2.$el.getElementsByTagName('input');
                inputs[0].focus();
                inputs[0].select();
            }, 300);
        },
        emitChanges: function emitChanges(newVal) {
            this.$emit('input', newVal);
            this.$emit('change', newVal);
            console.log('Form emitted input and change', newVal);
        }
    },
    watch: {},
    created: function created() {}
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_Security__ = __webpack_require__(138);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        document: Object,
        label: String
    },

    computed: {
        myId: function myId() {
            return __WEBPACK_IMPORTED_MODULE_0__data_Security__["a" /* default */].getMyId();
        },
        editors: function editors() {
            if (!this.document || !this.document.permissions || !this.document.permissions.editors) return [];else return this.document.permissions.editors;
        },
        canWrite: function canWrite() {
            return __WEBPACK_IMPORTED_MODULE_0__data_Security__["a" /* default */].canWrite(this.document);
        },
        publicOrPrivate: function publicOrPrivate() {
            return this.value && this.value.public ? 'Public' : 'Private';
        }
    },

    methods: {
        initialisePermissions: function initialisePermissions() {
            this.$set(this.document, 'permissions', { editors: [this.myId] });
            this.$emit('change');
        }
    },

    created: function created() {}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormControl__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormControl__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sample',
    props: {},
    components: { ScreenLayout: __WEBPACK_IMPORTED_MODULE_0__screens_ScreenLayout___default.a, FormControl: __WEBPACK_IMPORTED_MODULE_1__FormControl___default.a },
    data: function data() {
        return {

            profile: null,

            sampleSchema: {
                name: 'mealOptions',
                fields: [{
                    name: 'meal_name',
                    type: 'Text',
                    label: 'Meal Name'
                }, {
                    name: 'meal_time',
                    type: 'Text',
                    label: 'Meal Start Time'
                }, {
                    name: 'menu',
                    type: 'Group',
                    label: 'Menu Items',
                    fields: [{
                        name: 'dish_name',
                        type: 'Text',
                        label: 'Dish'
                    }, {
                        name: 'menu_listing',
                        type: 'File',
                        label: 'Menu in PDF',
                        path: 'temp/sampleApp'
                    }, {
                        name: 'dish_ingredients',
                        type: 'Group',
                        label: 'Ingredients',
                        fields: [{
                            name: 'ingredient_name',
                            type: 'Text',
                            label: 'Ingredient'
                        }, {
                            name: 'ingredient_availability',
                            type: 'Switch',
                            label: 'Available'
                        }, {
                            name: 'coming_soon',
                            type: 'Checkbox',
                            label: 'Coming Soon'
                        }]
                    }]
                }]
            },

            sampleRecord: {
                meal_name: 'Breakfast',
                meal_time: 'from 7am',
                menu: [{
                    dish_name: 'Baked Beans',
                    dish_ingredients: [{
                        ingredient_name: 'Beans',
                        ingredient_availability: true,
                        coming_soon: true
                    }, {
                        ingredient_name: 'Sauce',
                        ingredient_availability: false
                    }]
                }, {
                    dish_name: 'Cereal'
                }]
            }
        };
    },

    computed: {},
    methods: {
        formChanged: function formChanged(newVal) {
            console.log('form changed', this.sampleRecord);
        }
    },

    created: function created() {},
    beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flow_ui_SpeechBubble__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flow_ui_SpeechBubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flow_ui_SpeechBubble__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Security__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            newCommentText: ''
        };
    },


    components: {
        SpeechBubble: __WEBPACK_IMPORTED_MODULE_0__flow_ui_SpeechBubble___default.a, ScrollDownDiv: __WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv___default.a
    },

    props: {
        activities: Array
    },

    computed: {},

    methods: {
        saveComment: function saveComment() {
            if (!this.newCommentText) return;

            var activity = { description: this.newCommentText, uid: __WEBPACK_IMPORTED_MODULE_1__data_Security__["a" /* default */].getMyId() };
            this.activities.push(activity);

            this.newCommentText = '';
        }
    },

    created: function created() {}
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {
        textValue: function textValue() {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__["a" /* default */].formatNumber(this.value[this.schema.name]);
        }
    },

    methods: {
        change: function change(newVal) {
            newVal = this.convertToRawNumber(newVal);
            this.$emit('change', newVal);
        },
        convertToRawNumber: function convertToRawNumber(val) {
            if (val == '') return '';

            val = val.toLowerCase();

            var multiplier = 1;

            if (val.indexOf('m') > -1) multiplier = 1000000;else if (val.indexOf('k') > -1) multiplier = 1000;

            val = __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__["a" /* default */].numbersFromString(val);

            if (!val) val = 0;

            val = val * multiplier;

            return val;
        }
    },

    created: function created() {},


    watch: {}

});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_LabelMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_LabelMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_LabelMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        LabelMenu: __WEBPACK_IMPORTED_MODULE_0__ui_elements_LabelMenu___default.a
    },

    props: {
        value: Object,
        schema: Object
    },

    computed: {
        hideDetails: function hideDetails() {
            if (this.schema.compact) return true;else return false;
        }
    },

    methods: {
        change: function change(newVal) {
            this.value[this.schema.name] = newVal;
        }
    },

    created: function created() {}
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__ = __webpack_require__(6);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            url: null,
            linking: false,
            uploading: []
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon___default.a,
        UploadWrapper: __WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper___default.a,
        DocumentView: __WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView___default.a,
        BaseInput: __WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput___default.a
    },

    props: {
        value: Object,
        schema: Object
    },

    computed: {
        targetValue: function targetValue() {
            if (!this.value[this.schema.name]) this.$set(this.value, this.schema.name, []);
            return this.value[this.schema.name];
        },
        isUploading: function isUploading() {
            return this.uploading.length > 0;
        },
        uploaderVisible: function uploaderVisible() {
            if (this.isUploading) return false;
            if (this.schema.multiple) return true;
            return !this.targetValue || !this.targetValue.length;
        }
    },

    methods: {
        uploadFiles: function uploadFiles(files) {
            console.log('upload....');
            __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__["a" /* default */].storeFiles(files, this.schema.path, this.uploadStart, this.uploadStatus, this.uploadFinish);
        },
        uploadStart: function uploadStart(files) {
            console.log('uploadStart', files);
            this.uploading = files;
        },
        uploadStatus: function uploadStatus(files) {
            console.log(files);
        },
        uploadFinish: function uploadFinish(files) {
            console.log('Finished uploading', files);
            this.addFiles(this.uploading);
            this.uploading = [];
        },
        addFiles: function addFiles(arr) {
            var newVal = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.targetValue || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arr));
            this.$emit('input', newVal);
            this.$emit('change', newVal);
        },
        deleteFile: function deleteFile(file) {
            var files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.targetValue));
            var idx = files.findIndex(function (o) {
                return o == file;
            });
            files.splice(idx, 1);
            this.$emit('input', files);
            this.$emit('change', files);
        },
        fileIcon: function fileIcon(type) {
            if (!type) return 'mdi-file-document';
            if (type == 'application/pdf') {
                return 'mdi-file-pdf-box';
            } else if (type.startsWith('image')) return 'image';else return 'mdi-file-document';
        },
        link: function link() {
            if (this.linking) {
                if (this.url) this.addFiles([{ 'name': this.url, 'url': this.url }]);
                this.hideLinking();
            } else {
                this.linking = true;
                __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].focus(this, 'url');
            }
        },
        hideLinking: function hideLinking() {
            this.url = null;
            this.linking = false;
        }
    },

    created: function created() {}
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_Db1__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Merger__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_NumberHelpers__ = __webpack_require__(24);













/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapsed: false
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_5__ui_elements_ConfirmIcon___default.a, draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a
    },

    props: {
        schema: Object,
        value: {
            type: Object
        },
        context: Object
    },

    computed: {
        targetValue: function targetValue() {
            if (!this.value[this.schema.name]) this.$set(this.value, this.schema.name, []);
            return this.value[this.schema.name];
        },
        summary: function summary() {
            var _this = this;

            if (!this.schema.summary) return '';

            return this.targetValue.map(function (o) {
                return __WEBPACK_IMPORTED_MODULE_8__Merger__["a" /* default */].processExpressions(_this.schema.summary, o);
            }).filter(function (o) {
                return o !== false;
            }).join(', ');
        },
        columnStyle: function columnStyle() {
            var style = {};
            if (this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px';
            }
            return style;
        },
        modifiedSchema: function modifiedSchema() {
            var schema = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.schema);
            delete schema.type;
            delete schema.visible;
            schema.compact = true;
            return schema;
        },
        schemaFields: function schemaFields() {
            var _this2 = this;

            this.schema.fields.forEach(function (field) {
                field._root = _this2.schema._root;
            });
            return this.schema.fields;
        },
        readOnly: function readOnly() {
            return false;
        },
        groupTitle: function groupTitle() {
            if (this.schema.hideButtons) return this.schema.label;
            var len = this.itemCount;
            if (len == 0) return 'No ' + this.schema.label;else if (len == 1) return '1 ' + this.schema.label.replace(/ies$/, 'y').replace(/s$/, '');else return len + ' ' + this.schema.label;
        },
        itemCount: function itemCount() {
            return this.targetValue.length;
        }
    },

    methods: {
        emitChanges: function emitChanges(e, rowIndex) {
            var target = this.targetValue[rowIndex];
            this.$set(target, 'has_edits', true);
            this.calculateTotals(e);
            var changes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, e);
            changes.collection = this.schema.name;
            changes.rowId = e.row._id;
            changes.rowIndex = rowIndex;
            changes.changed = true;
            changes.type = 'Row Changed';
            this.$emit('change', changes);
        },
        calculateTotals: function calculateTotals(e) {
            var schema = this.getFieldSchema(e.field);

            if (schema.type == 'Currency' || schema.type == 'Payment') {
                var total = this.getFieldTotal(schema.name);
                this.$set(this.value, this.schema.name + '_total_' + schema.name, total);
            }
        },
        getFieldTotal: function getFieldTotal(name) {
            var _this3 = this;

            var total = 0;
            this.targetValue.forEach(function (row) {
                var val = _this3.convertToMonthly(row[name]);
                if (val) total += val;
            });
            return total;
        },
        convertToMonthly: function convertToMonthly(amt) {
            if (!amt) return 0;
            if (__WEBPACK_IMPORTED_MODULE_9__helpers_NumberHelpers__["a" /* default */].isNumeric(amt)) return amt;
            var numericAmount = Math.round(parseInt(__WEBPACK_IMPORTED_MODULE_9__helpers_NumberHelpers__["a" /* default */].numbersFromString(amt)));
            if (amt.indexOf('pw') > -1) return numericAmount * 52 / 12;
            if (amt.indexOf('pa') > -1) return numericAmount / 12;
            if (amt.indexOf('pf') > -1) return numericAmount * 26 / 12;
            return numericAmount;
        },
        getFieldSchema: function getFieldSchema(name) {
            var schema = this.schema.fields.find(function (o) {
                return o.name == name;
            });
            return schema;
        },
        add: function add() {
            var _this4 = this;

            var schema = this.schema;
            var newRecord = { _id: __WEBPACK_IMPORTED_MODULE_4__data_Db1__["a" /* default */].newId() };
            schema.fields.forEach(function (field) {
                if (field.default) newRecord[field.name] = field.default.replace('[n]', _this4.itemCount + 1);
            });

            this.targetValue.push(newRecord);

            this.$emit('change', {
                type: 'Row Added',
                collection: this.schema.name,
                row: newRecord,
                rowId: newRecord._id,
                rowIndex: this.itemCount,
                changed: true
            });

            setTimeout(function () {
                var inputs = _this4.$el.getElementsByTagName('input');
                inputs[0].focus();
                inputs[0].select();
            }, 300);
        },
        subtract: function subtract() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var row, idx;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                row = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this5.targetValue[_this5.itemCount - 1]);
                                idx = _this5.itemCount - 1;

                                if (!row.has_edits) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 5;
                                return _this5.$root.$confirm(_this5.descriptiveField(row) || 'Delete', 'Delete this item?', { color: 'red' });

                            case 5:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 8;
                                    break;
                                }

                                _this5.deleteItem(idx);

                            case 8:
                                _context.next = 11;
                                break;

                            case 10:
                                _this5.deleteItem(idx);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        deleteItem: function deleteItem(idx) {
            var row = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.targetValue[idx]);
            this.targetValue.splice(idx, 1);
            if (!this.itemCount) this.collapsed = false;
            this.emitRemoved(row);
        },
        emitRemoved: function emitRemoved(row) {
            this.$emit('change', {
                type: 'Row Removed',
                collection: this.schema.name,
                rowId: row._id,
                row: row,
                changed: true
            });
        },
        toggleCollapse: function toggleCollapse() {
            if (this.itemCount) this.collapsed = !this.collapsed;else this.collapsed = false;
        },
        draggableInput: function draggableInput(newVal) {
            this.$emit('change', newVal);
        },
        descriptiveField: function descriptiveField(row) {
            if (!row) return '';
            return row.title || row.description || row.text || row.name;
        }
    },

    watch: {
        'itemCount': {

            handler: function handler(newVal) {

                var countFieldName = this.schema.name + '_count';
                var oldValue = this.value[countFieldName];
                if (oldValue == newVal) return;

                this.$set(this.value, countFieldName, newVal);
                this.$emit('change', {
                    type: 'Field Changed',
                    name: countFieldName,
                    old: oldValue,
                    value: newVal,
                    changed: true
                });
            }
        }
    },

    created: function created() {}
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            holdValue: null,
            editor: __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default.a,
            editorConfig: {
                removePlugins: ['Heading', 'UndoUI']
            }
        };
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {
        editorValue: {
            get: function get() {
                return this.value[this.schema.name] || '';
            },
            set: function set(newVal) {
                this.holdValue = newVal;
            }
        }

    },

    methods: {
        checkForNumber: function checkForNumber(e) {
            console.log(e);
            if (!NumberHelpers.isNumeric(e.key) && !this.isNavigationKey(e.key)) {
                e.preventDefault();
            }
        },
        isNavigationKey: function isNavigationKey(key) {
            return Boolean(['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'].indexOf(key) > -1);
        },
        blur: function blur(e) {
            this.$emit('change', this.holdValue);
        }
    },

    created: function created() {}
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {
        checkForNumber: function checkForNumber(e) {
            console.log(e);
            if (!__WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__["a" /* default */].isNumeric(e.key) && !this.isNavigationKey(e.key)) {
                e.preventDefault();
            }
        },
        isNavigationKey: function isNavigationKey(key) {
            return Boolean(['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'].indexOf(key) > -1);
        }
    },

    created: function created() {}
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            amount: null,
            frequencyIndex: 0,
            frequencies: [{ abbreviation: 'pm', name: 'monthly' }, { abbreviation: 'pw', name: 'weekly' }, { abbreviation: 'pf', name: 'fortnightly' }, { abbreviation: 'pa', name: 'annually' }]
        };
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {
        targetValue: function targetValue() {
            return this.value[this.schema.name];
        },

        abbreviation: {
            get: function get() {

                if (!this.targetValue) return this.schema.defaultFrequency || 'pm';else return this.targetValue.split(' ')[1];
            },
            set: function set(newVal) {
                if (!this.targetValue) return this.schema.defaultFrequency || 'pm';else return newVal;
            }
        }
    },

    methods: {
        toggleFrequency: function toggleFrequency() {
            var _this = this;

            var idx = this.frequencies.findIndex(function (f) {
                return f.abbreviation == _this.abbreviation;
            });

            idx = idx == 3 ? 0 : idx + 1;
            this.emitChanges(this.frequencies[idx].abbreviation);
        },
        emitAmountChange: function emitAmountChange() {
            this.emitChanges(this.abbreviation);
        },
        emitChanges: function emitChanges(abbreviation) {
            this.$emit('change', this.amount + ' ' + abbreviation);
        }
    },

    created: function created() {},


    watch: {
        targetValue: {
            immediate: true,
            handler: function handler(newVal) {
                console.log('watcher got: ', newVal);
                this.amount = newVal ? newVal.split(' ')[0] : 0;
            }
        }
    }

});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Merger__ = __webpack_require__(184);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapsed: false
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon___default.a, draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
    },

    props: {
        schema: Object,
        value: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        context: Object
    },

    computed: {
        modifiedSchema: function modifiedSchema() {
            var schema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.schema);
            schema.type = '';
            return schema;
        },
        columnStyle: function columnStyle() {
            var style = {};
            if (this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px';
            }
            return style;
        },
        schemaFields: function schemaFields() {
            var _this = this;

            this.schema.fields.forEach(function (field) {
                field._root = _this.schema._root;
            });
            return this.schema.fields;
        },
        readOnly: function readOnly() {
            return Boolean(this.schema._root.readOnly);
        },
        itemCount: function itemCount() {
            if (this.value) return this.value.length;else return 0;
        },
        summary: function summary() {
            if (!this.schema.summary) return '';

            if (this.schema.summary && this.schema.summary == '[$true_labels]') return __WEBPACK_IMPORTED_MODULE_4__Merger__["a" /* default */].trueLabels(this.schema.fields, this.value);else return __WEBPACK_IMPORTED_MODULE_4__Merger__["a" /* default */].processExpressions(this.schema.summary, this.value);
        }
    },

    methods: {
        calculatePaymentTotals: function calculatePaymentTotals() {
            var _this2 = this;

            var currencyTotal = 0;
            this.schema.fields.forEach(function (field) {
                if (field.type == 'Currency' || field.inputType == 'Currency') {
                    var v1 = _this2.value[field.name];
                    currencyTotal += v1 || 0;
                }
            });

            this.$set(this.value, this.schema.name + '_total_currency', currencyTotal);
        },
        emitChanges: function emitChanges(newVal) {
            console.log('Section emitting changes', newVal);
            this.calculatePaymentTotals();
            this.$emit('change', newVal);
        },
        toggleCollapse: function toggleCollapse() {
            this.collapsed = !this.collapsed;
        }
    },

    created: function created() {}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon___default.a, draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
    },

    props: {
        schema: Object,
        value: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        context: Object
    },

    computed: {
        modifiedSchema: function modifiedSchema() {
            var schema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.schema);
            schema.type = this.schema.inputType;
            schema.visible = true;
            schema.label = this.schema.inputLabel || '';
            schema.compact = true;
            return schema;
        },
        checkboxName: function checkboxName() {
            return this.schema.name + '_exists';
        },


        checkboxValue: {
            get: function get() {
                return this.value[this.checkboxName] || false;
            },
            set: function set(newVal) {
                this.$set(this.value, this.checkboxName, newVal);
            }
        }

    },

    methods: {
        emitCheckboxChange: function emitCheckboxChange(newVal) {
            console.log('Section checkbox changes for switchheading', newVal);
            this.$emit('change', {
                type: 'Field Changed',
                field: this.schema.name + '_exists',
                value: newVal,
                changed: true
            });
        },
        emitInputChange: function emitInputChange(newVal) {
            console.log('Section input changes for switchheading', newVal);
            this.$emit('change', {
                type: 'Field Changed',
                field: this.schema.name,
                value: newVal,
                changed: true
            });
        }
    },

    created: function created() {},


    watch: {
        'checkboxValue': {
            handler: function handler(newVal) {
                var _this = this;

                if (newVal) {
                    setTimeout(function () {
                        _this.$refs.theInput.focusFirst();
                    }, 100);
                } else {
                    this.value[this.schema.name] = null;
                }
                this.emitCheckboxChange(newVal);
            }
        }
    }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Object,
        schema: Object
    },

    computed: {
        hideDetails: function hideDetails() {
            if (this.schema.compact) return true;else return false;
        }
    },

    methods: {
        change: function change(newVal) {
            this.value[this.schema.name] = newVal;
        }
    },

    created: function created() {}
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        YesNo: __WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo___default.a
    },

    props: {
        value: Object,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Boolean,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {},


    watch: {}

});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__ = __webpack_require__(6);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            url: null,
            linking: false,
            uploading: []
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_2__ui_elements_ConfirmIcon___default.a,
        UploadWrapper: __WEBPACK_IMPORTED_MODULE_1__ui_elements_UploadWrapper___default.a,
        DocumentView: __WEBPACK_IMPORTED_MODULE_4__ui_elements_DocumentView___default.a,
        BaseInput: __WEBPACK_IMPORTED_MODULE_5__forms_inputs_BaseInput___default.a
    },

    props: {
        value: Array,
        schema: Object
    },

    computed: {
        isUploading: function isUploading() {
            return this.uploading.length > 0;
        },
        uploaderVisible: function uploaderVisible() {
            if (this.isUploading) return false;
            if (this.schema.multiple) return true;
            return !this.value || !this.value.length;
        }
    },

    methods: {
        uploadFiles: function uploadFiles(files) {
            console.log('upload....');
            __WEBPACK_IMPORTED_MODULE_3__helpers_FileHelpers__["a" /* default */].storeFiles(files, this.schema.path, this.uploadStart, this.uploadStatus, this.uploadFinish);
        },
        uploadStart: function uploadStart(files) {
            console.log('uploadStart', files);
            this.uploading = files;
        },
        uploadStatus: function uploadStatus(files) {
            console.log(files);
        },
        uploadFinish: function uploadFinish(files) {
            console.log('Finished uploading', files);
            this.addFiles(this.uploading);
            this.uploading = [];
        },
        addFiles: function addFiles(arr) {
            var newVal = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arr));
            this.$emit('input', newVal);
            this.$emit('change', newVal);
        },
        deleteFile: function deleteFile(file) {
            var files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value));
            var idx = files.findIndex(function (o) {
                return o == file;
            });
            files.splice(idx, 1);
            this.$emit('input', files);
            this.$emit('change', files);
        },
        fileIcon: function fileIcon(type) {
            if (!type) return 'mdi-file-document';
            if (type == 'application/pdf') {
                return 'mdi-file-pdf-box';
            } else if (type.startsWith('image')) return 'image';else return 'mdi-file-document';
        },
        link: function link() {
            if (this.linking) {
                if (this.url) this.addFiles([{ 'name': this.url, 'url': this.url }]);
                this.hideLinking();
            } else {
                this.linking = true;
                __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].focus(this, 'url');
            }
        },
        hideLinking: function hideLinking() {
            this.url = null;
            this.linking = false;
        }
    },

    created: function created() {}
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapsed: false
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon___default.a, draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
    },

    props: {
        schema: Object,
        value: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },

    computed: {
        columnStyle: function columnStyle() {
            var style = {};
            if (this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px';
            }
            return style;
        },
        schemaFields: function schemaFields() {
            var _this = this;

            this.schema.fields.forEach(function (field) {
                field._root = _this.schema._root;
            });
            return this.schema.fields;
        },
        readOnly: function readOnly() {
            return Boolean(this.schema._root.readOnly);
        },
        groupTitle: function groupTitle() {
            var len = this.value ? this.value.length : 0;
            if (len == 0) return 'No ' + this.schema.label;else if (len == 1) return '1 ' + this.schema.label.replace(/ies$/, 'y').replace(/s$/, '');else return len + ' ' + this.schema.label;
        },
        itemCount: function itemCount() {
            if (this.value) return this.value.length;else return 0;
        }
    },

    methods: {
        emitChanges: function emitChanges(newVal, recordIndex) {
            this.value.splice(recordIndex, 1, newVal);
            this.$emit('change', this.value);
        },
        add: function add() {
            var _this2 = this;

            var schema = this.schema;
            var newRecord = {};
            schema.fields.forEach(function (field) {
                if (field.default) newRecord[field.name] = field.default + ' ' + (_this2.value.length + 1);
            });

            this.value.push(newRecord);

            setTimeout(function () {
                var inputs = _this2.$el.getElementsByTagName('input');
                inputs[0].focus();
                inputs[0].select();
            }, 300);
        },
        subtract: function subtract() {
            this.value.splice(this.value.length - 1, 1);
        },
        deleteItem: function deleteItem(idx) {
            this.value.splice(idx, 1);
            if (!this.itemCount) this.collapsed = false;
        },
        toggleCollapse: function toggleCollapse() {
            if (this.itemCount) this.collapsed = !this.collapsed;else this.collapsed = false;
        },
        draggableInput: function draggableInput(newVal) {
            this.$emit('change', newVal);
        }
    },

    created: function created() {}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            holdValue: null,
            editor: __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default.a,
            editorConfig: {
                removePlugins: ['Heading', 'UndoUI']
            }
        };
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {
        editorValue: {
            get: function get() {
                return this.value || '';
            },
            set: function set(newVal) {
                this.holdValue = newVal;
            }
        }

    },

    methods: {
        checkForNumber: function checkForNumber(e) {
            console.log(e);
            if (!NumberHelpers.isNumeric(e.key) && !this.isNavigationKey(e.key)) {
                e.preventDefault();
            }
        },
        isNavigationKey: function isNavigationKey(key) {
            return Boolean(['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'].indexOf(key) > -1);
        },
        blur: function blur(e) {
            this.$emit('change', this.holdValue);
        }
    },

    created: function created() {}
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {
        checkForNumber: function checkForNumber(e) {
            console.log(e);
            if (!__WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__["a" /* default */].isNumeric(e.key) && !this.isNavigationKey(e.key)) {
                e.preventDefault();
            }
        },
        isNavigationKey: function isNavigationKey(key) {
            return Boolean(['Tab', 'ArrowRight', 'ArrowLeft', 'Backspace'].indexOf(key) > -1);
        }
    },

    created: function created() {}
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            amount: null,
            frequencyIndex: 0,
            frequencies: [{ abbreviation: 'pm', name: 'monthly' }, { abbreviation: 'pw', name: 'weekly' }, { abbreviation: 'pf', name: 'fortnightly' }, { abbreviation: 'pa', name: 'annually' }]
        };
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {
        abbreviation: {
            get: function get() {

                if (!this.value) return this.schema.defaultAbbreviation || 'pm';else return this.value.split(' ')[1];
            },
            set: function set(newVal) {
                if (!this.value) return this.schema.defaultFrequency || 'pm';else return newVal;
            }
        }
    },

    methods: {
        toggleFrequency: function toggleFrequency() {
            var _this = this;

            var idx = this.frequencies.findIndex(function (f) {
                return f.abbreviation == _this.abbreviation;
            });

            idx = idx == 3 ? 0 : idx + 1;
            this.emitChanges(this.frequencies[idx].abbreviation);
        },
        emitAmountChange: function emitAmountChange() {
            this.emitChanges(this.abbreviation);
        },
        emitChanges: function emitChanges(abbreviation) {
            this.$emit('change', this.amount + ' ' + abbreviation);
        }
    },

    created: function created() {},


    watch: {
        value: {
            immediate: true,
            handler: function handler(newVal) {
                console.log('watcher got: ', newVal);
                this.amount = newVal ? newVal.split(' ')[0] : 0;
            }
        }
    }

});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapsed: false
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_0__ui_elements_ConfirmIcon___default.a, draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
    },

    props: {
        schema: Object,
        value: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        columnStyle: function columnStyle() {
            var style = {};
            if (this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px';
            }
            return style;
        },
        schemaFields: function schemaFields() {
            var _this = this;

            this.schema.fields.forEach(function (field) {
                field._root = _this.schema._root;
            });
            return this.schema.fields;
        },
        readOnly: function readOnly() {
            return Boolean(this.schema._root.readOnly);
        },
        itemCount: function itemCount() {
            if (this.value) return this.value.length;else return 0;
        }
    },

    methods: {
        emitChanges: function emitChanges(newVal) {
            console.log('Section emitting changes', newVal);
            this.$emit('change', newVal);
        },
        toggleCollapse: function toggleCollapse() {
            this.collapsed = !this.collapsed;
        }
    },

    created: function created() {}
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: Boolean,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        YesNo: __WEBPACK_IMPORTED_MODULE_0__ui_elements_YesNo___default.a
    },

    props: {
        value: String,
        schema: Object
    },

    computed: {},

    methods: {},

    created: function created() {}
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        label: String,
        hint: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_EditableText__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_EditableText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_EditableText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            search: null
        };
    },


    components: {
        EditableText: __WEBPACK_IMPORTED_MODULE_2__ui_elements_EditableText___default.a
    },

    props: {
        items: Array,
        value: {
            type: Object,
            default: function _default() {
                return this.items[0];
            }
        },
        displayField: {
            type: String,
            default: 'title'
        }
    },

    computed: {
        selectedIndex: {
            get: function get() {
                var _this = this;

                if (!this.selectedItem) return null;
                return this.items.findIndex(function (o) {
                    return o._id == _this.selectedItem._id;
                });
            },
            set: function set(newVal) {
                this.select(this.items[newVal]);
            }
        },

        itemsList: function itemsList() {
            var _this2 = this;

            if (!this.search) {
                return this.items;
            }
            return this.items.filter(function (item) {
                return _this2.objectContains(item, _this2.search);
            });
        }
    },

    methods: {
        isSelected: function isSelected(item) {
            if (!item || !this.value) return false;
            return this.value._id == item._id;
        },
        select: function select(item) {
            this.$emit('input', item);
            this.$emit('click', item);
        },
        objectContains: function objectContains(obj, search) {
            var result = false;
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(obj).forEach(function (entry) {
                var _entry = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(entry, 2),
                    key = _entry[0],
                    val = _entry[1];

                if (key != '_id' && val && val.contains && val.contains(search)) result = true;
            });
            return result;
        },
        focusSearch: function focusSearch() {
            __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].focus(this, 'search');
        }
    },

    created: function created() {}
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FileView',

    data: function data() {
        return {
            selectedFile: null
        };
    },


    components: {},

    props: {
        value: Array,
        schema: Object
    },

    computed: {
        hasImage: function hasImage() {
            if (!this.selectedFile) return false;

            return this.selectedFile.type.contains('image') || this.selectedFile.url.contains('.jpg') || this.selectedFile.url.contains('.png') || this.selectedFile.url.contains('.gif');
        }
    },

    methods: {},

    created: function created() {},


    watch: {
        'value': {
            handler: function handler(newVal) {
                if (newVal && newVal.length) this.selectedFile = this.value[0];else this.selectedFile = null;
            },
            immediate: true,
            deep: true
        }
    }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_LayoutContainer2__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_LayoutContainer2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_LayoutContainer2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_LayoutReadOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_StatusLine__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_StatusLine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_StatusLine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_ElementMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_ElementMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__screens_ElementMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_ScrollHelpers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_json_to_csv__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_json_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_DateRangeList__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_DateRangeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ui_elements_DateRangeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__screens_ScreenData__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__screens_ScreenTable__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__screens_ScreenTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__screens_ScreenTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers_TemplateHelpers__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_elements_SplitButton__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_elements_SplitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ui_elements_SplitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__helpers_TagStatusHelpers__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ui_elements_ChargeDialog__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ui_elements_ChargeDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__ui_elements_ChargeDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Invoice__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__Invoice__);














































var PageSection = function () {
    function PageSection(section) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PageSection);

        this.section = section;
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(PageSection, [{
        key: 'fieldByName',
        value: function fieldByName(name) {
            return this.section.fields.find(function (o) {
                return o.name == name;
            }) || null;
        }
    }]);

    return PageSection;
}();

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            user: {},
            invoices: [],
            charges: [],
            month: __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].yearMonth(),
            showingSummary: false,
            mine: false,
            chargeDialog: {
                settings: {
                    visible: false
                },
                charge: {
                    amount: 0,
                    date: null,
                    from: null,
                    to: null,
                    clients: null,
                    description: null
                }
            }
        };
    },

    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_15__screens_ScreenLayout___default.a,
        StatusLine: __WEBPACK_IMPORTED_MODULE_12__ui_elements_StatusLine___default.a,
        NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder___default.a,
        ChargeDialog: __WEBPACK_IMPORTED_MODULE_39__ui_elements_ChargeDialog___default.a,
        Invoice: __WEBPACK_IMPORTED_MODULE_40__Invoice___default.a
    },

    props: {},

    computed: {
        currentUser: function currentUser() {
            return __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getUser();
        },
        isAdministrator: function isAdministrator() {
            return __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].isAdministrator();
        },
        invoicesBySender: function invoicesBySender() {
            var _this = this;

            var result = {};

            this.invoices.forEach(function (invoice) {
                if (!result[invoice.from.key]) {
                    result[invoice.from.key] = {
                        invoices: [],
                        from: invoice.from,
                        consultantTotal: 0
                    };
                }
                if (invoice.charges && invoice.charges.length) {
                    var total = invoice.charges.reduce(function (a, b) {
                        return a + (b.amount || 0);
                    }, 0);
                    _this.$set(invoice, 'total', total);
                } else {
                    _this.$set(invoice, 'total', 0);
                }

                result[invoice.from.key].consultantTotal = result[invoice.from.key].consultantTotal + invoice.total;
                result[invoice.from.key].invoices.push(invoice);
            });
            return result;
        },
        monthFormatted: function monthFormatted() {
            var dt = __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].backwardsToDate(this.month + '-01');
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["a" /* format */])(dt, 'MMM yyyy');
        },
        billingStages: function billingStages() {
            return __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].stages;
        },
        billingStagesVisible: function billingStagesVisible() {
            return this.billingStages.filter(function (o) {
                return o.visible;
            });
        },
        invoicesNeedingValidation: function invoicesNeedingValidation() {
            return __WEBPACK_IMPORTED_MODULE_36__helpers_TagStatusHelpers__["a" /* default */].itemsWithoutTag(this.invoices, 'valid');
        },
        invoicesReadyToSend: function invoicesReadyToSend() {
            var _this2 = this;

            var invoices = [];
            this.invoices.forEach(function (invoice) {
                if (_this2.invoiceHasTag(invoice, 'valid') && !_this2.invoiceHasTag(invoice, 'sent')) invoices.push(invoice);
            });
            return invoices;
        },
        invoicesPaid: function invoicesPaid() {
            return this.invoices.filter(function (o) {
                return o.tags.paid;
            });
        },
        insightInvoices: function insightInvoices() {
            return this.invoices.filter(function (o) {
                return o.from.email == 'billing@insightprocessing.com.au';
            });
        },
        insightInvoicesSent: function insightInvoicesSent() {
            var _this3 = this;

            var invoices = [];
            this.insightInvoices.forEach(function (invoice) {
                if (_this3.invoiceHasTag(invoice, 'sent')) invoices.push(invoice);
            });
            return invoices;
        },
        insightInvoicesPaid: function insightInvoicesPaid() {
            var _this4 = this;

            var invoices = [];
            this.insightInvoices.forEach(function (invoice) {
                if (_this4.invoiceHasTag(invoice, 'paid')) invoices.push(invoice);
            });
            return invoices;
        },
        insightInvoicesAllSent: function insightInvoicesAllSent() {
            return this.insightInvoices.length == this.insightInvoicesSent.length && this.insightInvoices.length > 0;
        },
        processorsReadyToMake: function processorsReadyToMake() {
            var processors = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.invoicesBySender);
            for (var prop in processors) {
                var processor = processors[prop];
                if (!this.senderNeedsInvoicing(processor)) delete processors[prop];
            }
            return processors;
        },
        processorsReadyToMakeLength: function processorsReadyToMakeLength() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.processorsReadyToMake).length;
        },
        grandTotal: function grandTotal() {
            var total = 0;
            for (var prop in this.invoicesBySender) {
                total += this.invoicesBySender[prop].consultantTotal || 0;
            }
            return total;
        },
        viewingPreviousMonth: function viewingPreviousMonth() {
            var currentMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["a" /* format */])(new Date(), 'yyyy-MM');
            return Boolean(this.month < currentMonth);
        },
        viewingCurrentMonth: function viewingCurrentMonth() {
            var currentMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["a" /* format */])(new Date(), 'yyyy-MM');
            return Boolean(this.month == currentMonth);
        }
    },

    methods: {
        isProcessor: function isProcessor(contact) {
            return Boolean(this.getProcessorForContact(contact).email);
        },
        openInvoice: function openInvoice(invoice) {
            this.$router.push('/invoice/' + this.month + '/' + invoice.meta.key);
        },
        loadInvoices: function loadInvoices() {
            var _this5 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/billing/' + this.month + '/invoices');

            if (this.mine) ref = ref.orderByChild('to/key').equalTo(this.$store.getters.user.uid);else if (!this.isAdministrator) {
                ref = ref.orderByChild('from/key').equalTo(this.$store.getters.user.uid);
            }
            console.log('fetching...', ref);
            __WEBPACK_IMPORTED_MODULE_34__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (invoices) {
                _this5.$set(_this5, 'invoices', invoices);
                _this5.invoices.forEach(function (invoice) {
                    _this5.$set(invoice, 'charges', []);

                    var chargeRef = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/billing/' + _this5.month + '/charges').orderByChild('invoice').equalTo(invoice.meta.key);
                    __WEBPACK_IMPORTED_MODULE_34__data_NiceData__["a" /* default */].fetchItemsFromFirebase(chargeRef).then(function (charges) {
                        _this5.$set(invoice, 'charges', charges.sort(__WEBPACK_IMPORTED_MODULE_38__helpers_OrderHelpers__["a" /* default */].sortByDate));
                    });
                });
            });
        },
        previewInvoice: function previewInvoice(invoice) {
            if (!invoice.from.abn) {
                this.populateEntities(invoice);
            }
            this.$set(invoice.meta, 'preview', true);
        },
        debugInvoice: function debugInvoice(invoice) {
            __WEBPACK_IMPORTED_MODULE_37__helpers_FirebaseHelpers__["a" /* default */].viewInConsole(invoice.meta.path + '/' + invoice.meta.key);
        },
        debugCharge: function debugCharge(charge) {
            __WEBPACK_IMPORTED_MODULE_37__helpers_FirebaseHelpers__["a" /* default */].viewInConsole(charge.meta.path + '/' + charge.meta.key);
        },
        populateEntities: function populateEntities(invoice) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var processorDetails, billingPreferences, newInvoice;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                processorDetails = _this6.getProcessorForContact(invoice.from);


                                _this6.$set(invoice.from, 'abn', processorDetails.abn || '');
                                _this6.$set(invoice.from, 'address', processorDetails.address || '');
                                _this6.$set(invoice.from, 'account', processorDetails.account || '');
                                _this6.$set(invoice.from, 'entity', processorDetails.entity || '');
                                _this6.$set(invoice.from, 'mobile', processorDetails.mobile || invoice.from.mobile || '');

                                _context.next = 8;
                                return __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getPreferencesGroup(invoice.to.tenantKey, invoice.to.uid, 'billing');

                            case 8:
                                billingPreferences = _context.sent;


                                _this6.$set(invoice.to, 'entity', billingPreferences.entity || '');
                                _this6.$set(invoice.to, 'email', billingPreferences.email || invoice.to.email);
                                _this6.$set(invoice.to, 'directDebitRef', billingPreferences.directDebitRef || invoice.to.directDebitRef || '');

                                newInvoice = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, invoice);

                                newInvoice.charges = [];
                                delete newInvoice['total'];

                                __WEBPACK_IMPORTED_MODULE_34__data_NiceData__["a" /* default */].saveItem(newInvoice);

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this6);
            }))();
        },
        incrementMonth: function incrementMonth() {
            var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var dt = __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].backwardsToDate(this.month + '-01');
            var nextMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["m" /* addMonths */])(dt, number);
            this.month = __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].yearMonth(nextMonth);
        },
        isLastMonth: function isLastMonth(month) {
            var previousMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["a" /* format */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["m" /* addMonths */])(new Date(), -1), 'MM');
            var activeMonth = month.split('-')[1];
            return previousMonth == activeMonth;
        },
        decrementMonth: function decrementMonth() {
            this.incrementMonth(-1);
        },
        getInvoiceId: function getInvoiceId(invoice) {
            var payer = invoice.to;
            var initials = __WEBPACK_IMPORTED_MODULE_32__helpers_ContactHelpers__["a" /* default */].initials(payer) + payer.lastName[payer.lastName.length - 1].toUpperCase();

            var recipient = invoice.from;
            var recipientInitials = __WEBPACK_IMPORTED_MODULE_32__helpers_ContactHelpers__["a" /* default */].initials(recipient);

            return initials + recipientInitials + '-' + invoice.month.split('-')[1];
        },
        invoiceHasTag: function invoiceHasTag(invoice, tagName) {
            return __WEBPACK_IMPORTED_MODULE_36__helpers_TagStatusHelpers__["a" /* default */].tagExists(invoice.tags, tagName);
        },
        invoiceAddTag: function invoiceAddTag(invoice, tagName) {
            if (!invoice.tags) this.$set(invoice, 'tags', {});
            __WEBPACK_IMPORTED_MODULE_36__helpers_TagStatusHelpers__["a" /* default */].addTag(invoice.tags, tagName);
        },
        reminderText: function reminderText(invoice) {
            if (this.invoiceHasTag(invoice, 'reminder sent')) return 'Remind Again';else return 'Send Reminder';
        },
        getTemplate: function getTemplate(name) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_25__helpers_TemplateHelpers__["a" /* default */].fetchTemplate('global', name).then(function (template) {
                    if (!template) __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Template not found:' + name);
                    resolve(template);
                });
            });
        },
        resetInvoice: function resetInvoice(invoice) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this7.$root.$confirm('Reset', 'Are you sure you want to reset the status on this invoice?', { color: 'red' });

                            case 2:
                                _context2.t0 = _context2.sent;

                                if (!(_context2.t0 == true)) {
                                    _context2.next = 6;
                                    break;
                                }

                                invoice.tags = {
                                    created: true,
                                    'created-date': new Date()
                                };
                                __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this7);
            }))();
        },
        senderNeedsInvoicing: function senderNeedsInvoicing(sender) {
            var _this8 = this;

            var needs = false;
            sender.invoices.forEach(function (invoice) {
                if (_this8.isInvoiceReadyToMake(invoice)) needs = true;
            });
            return needs;
        },
        isInvoiceReadyToMake: function isInvoiceReadyToMake(invoice) {
            var valid = this.invoiceHasTag(invoice, 'valid');
            var unmade = !this.invoiceHasTag(invoice, 'insight invoice made');
            var isClientInvoice = !this.isProcessor(invoice.to);
            var result = valid && unmade && isClientInvoice;

            return result;
        },
        isInvoiceReadyToSend: function isInvoiceReadyToSend(invoice) {
            return this.invoiceHasTag(invoice, 'valid') && !this.invoiceHasTag(invoice, 'sent');
        },
        requestValidation: function requestValidation(invoice) {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var template;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this9.getTemplate('Request Invoice Validation');

                            case 2:
                                template = _context3.sent;

                                _this9.emailInvoice(template, invoice.html, invoice.from.firstName, invoice.from.email, null, invoice);
                                _this9.invoiceAddTag(invoice, 'validation requested');
                                __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this9);
            }))();
        },
        validate: function validate(invoice) {
            this.invoiceAddTag(invoice, 'valid');
            if (!invoice.tags.validation_requested) this.invoiceAddTag(invoice, 'validation requested');
            __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);
            __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Validated. Thank you');
        },
        makeInvoice: function makeInvoice(sender) {
            var _this10 = this;

            sender.invoices.forEach(function (invoice) {
                var customer = __WEBPACK_IMPORTED_MODULE_32__helpers_ContactHelpers__["a" /* default */].fullName(invoice.to);
                var customerRevenue = invoice.total;
                var userParams = __WEBPACK_IMPORTED_MODULE_24__helpers_LookupData__["a" /* default */].processors().find(function (o) {
                    return o.email == invoice.from.email;
                }) || { rate: .15, email: 'unknown', firstName: 'Unknown' };
                var amount = userParams.rate * customerRevenue;

                var to = invoice.from;
                var firstDay = __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].backwardsToDate(_this10.month + '-01');
                var lastDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["u" /* lastDayOfMonth */])(firstDay);
                var date = __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].dateToBackwards(lastDay);
                var from = {
                    key: 'insight-processing',
                    uid: 'insight-processing',
                    firstName: 'Insight',
                    lastName: 'Processing',
                    email: 'billing@insightprocessing.com.au',
                    image: 'https://i.imgur.com/BekZJi7.png'
                };
                var charge = {
                    to: to, from: from, date: date, amount: amount,
                    description: 'Insight Comms on ' + __WEBPACK_IMPORTED_MODULE_22__helpers_StringHelpers__["a" /* default */].formatCurrency(customerRevenue),
                    clients: customer,
                    internal: true
                };

                if (_this10.isProcessor(invoice.to)) {
                    charge.amount = 0;
                    charge.description = 'Internal - no charge';
                }

                __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveCharge(charge);
                _this10.invoiceAddTag(invoice, 'insight invoice made');
                __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);
            });
            __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Invoice created for ' + sender.firstName);
        },
        sendInvoice: function sendInvoice(invoice) {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var template, cc;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this11.getTemplate('Send Invoice');

                            case 2:
                                template = _context4.sent;
                                cc = invoice.from.email;

                                if (cc == 'billing@insightprocessing.com.au') cc = 'accounting@insightprocessing.com.au';

                                _this11.emailInvoice(template, invoice.html, invoice.to.firstName, invoice.to.email, cc, invoice);
                                _this11.invoiceAddTag(invoice, 'sent');
                                __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this11);
            }))();
        },
        skipSendInvoice: function skipSendInvoice(invoice) {
            this.invoiceAddTag(invoice, 'sent');
            __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);
        },
        emailMe: function emailMe(invoice) {
            var _this12 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var template;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this12.getTemplate('Send Invoice');

                            case 2:
                                template = _context5.sent;

                                _this12.emailInvoice(template, invoice.html, _this12.currentUser.firstName, _this12.currentUser.email, null, invoice);

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this12);
            }))();
        },
        sendReminder: function sendReminder(invoice) {
            var _this13 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var template;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(!invoice.from.abn || !invoice.from.account)) {
                                    _context6.next = 3;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Email Failed. Missing abn or account');
                                return _context6.abrupt('return');

                            case 3:
                                _context6.next = 5;
                                return _this13.getTemplate('Send Invoice Reminder');

                            case 5:
                                template = _context6.sent;

                                _this13.emailInvoice(template, invoice.html, invoice.to.firstName, invoice.to.email, invoice.from.email, invoice);
                                _this13.invoiceAddTag(invoice, 'reminder sent');
                                __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this13);
            }))();
        },
        markPaid: function markPaid(invoice) {
            this.invoiceAddTag(invoice, 'paid');
            __WEBPACK_IMPORTED_MODULE_35__helpers_BillingHelpers__["a" /* default */].saveInvoiceTags(invoice);
        },
        makeInvoiceMultiple: function makeInvoiceMultiple() {
            var _this14 = this;

            this.processorsReadyToMake.forEach(function (processor) {
                _this14.makeInvoice(processor);
            });
            this.loadInvoices();
            __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Made invoices');
        },
        makeInvoiceSingle: function makeInvoiceSingle(sender) {
            this.makeInvoice(sender);
            this.loadInvoices();
            __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Made invoices');
        },
        requestValidationMultiple: function requestValidationMultiple() {
            var _this15 = this;

            this.invoicesNeedingValidation.forEach(function (invoice) {
                _this15.requestValidation(invoice);
            });
        },
        sendInvoiceMultiple: function sendInvoiceMultiple() {
            var _this16 = this;

            this.invoicesReadyToSend.forEach(function (invoice) {
                _this16.sendInvoice(invoice);
            });
        },
        deleteCharge: function deleteCharge(charge) {
            var _this17 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var amountString;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                amountString = __WEBPACK_IMPORTED_MODULE_22__helpers_StringHelpers__["a" /* default */].formatCurrency(charge.amount);

                                if (!_this17.mine) {
                                    _context7.next = 4;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('You cannot delete your own charges, you sneaky thing');
                                return _context7.abrupt('return');

                            case 4:
                                _context7.next = 6;
                                return _this17.$root.$confirm('Delete', 'Are you sure you want to delete this charge for ' + charge.client + ' amounting to ' + amountString + ' from the invoice?', { color: 'red' });

                            case 6:
                                _context7.t0 = _context7.sent;

                                if (!(_context7.t0 == true)) {
                                    _context7.next = 12;
                                    break;
                                }

                                console.log('deleting charge', charge.meta.key);
                                __WEBPACK_IMPORTED_MODULE_34__data_NiceData__["a" /* default */].deleteItem(charge);
                                charge.amount = 0;
                                charge.clients = '*** Deleted ***';

                            case 12:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this17);
            }))();
        },
        deleteInvoice: function deleteInvoice(invoice) {
            var _this18 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return _this18.$root.$confirm('Delete', 'Are you sure you want to delete this invoice?', { color: 'red' });

                            case 2:
                                _context8.t0 = _context8.sent;

                                if (!(_context8.t0 == true)) {
                                    _context8.next = 7;
                                    break;
                                }

                                console.log('deleting invoice', invoice);
                                __WEBPACK_IMPORTED_MODULE_34__data_NiceData__["a" /* default */].deleteItem(invoice);
                                _this18.loadInvoices();

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this18);
            }))();
        },
        getProcessorForContact: function getProcessorForContact(contact) {
            var processors = __WEBPACK_IMPORTED_MODULE_24__helpers_LookupData__["a" /* default */].processors();
            var processor = processors.find(function (p) {
                return p.uid == contact.uid || p.email == contact.email;
            });
            if (processor) return processor;else return {};
        },
        emailAllInvoicesToBookkeeper: function emailAllInvoicesToBookkeeper() {
            var _this19 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var template, invoiceSummary, to, cc;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return _this19.getTemplate('Send Invoices to Bookkeeper');

                            case 2:
                                template = _context9.sent;
                                invoiceSummary = "";


                                _this19.insightInvoicesSent.forEach(function (invoice) {
                                    invoiceSummary += invoice.html + "<hr/>";
                                });
                                to = 'accounting@insightprocessing.com.au';
                                cc = 'billing@insightprocessing.com.au';


                                _this19.emailInvoice(template, invoiceSummary, 'Emma', to, cc, invoice);

                            case 8:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this19);
            }))();
        },
        getBillingEmail: function getBillingEmail(email) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_32__helpers_ContactHelpers__["a" /* default */].fetchContactByEmail(email).then(function (contact) {

                    var uid = contact.meta.key;
                    var tenantKey = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getTenantKey();
                    var ref = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getRootRef().child('users/' + uid + '/offices/' + tenantKey + '/preferences/email/billing');
                    __WEBPACK_IMPORTED_MODULE_34__data_NiceData__["a" /* default */].fetchValue(ref).then(function (billingEmail) {

                        if (!billingEmail) billingEmail = email;
                        resolve(billingEmail);
                    });
                }).catch(function (err) {
                    console.log('getBillingEmail threw an error so just used normal email address', err);
                    resolve(email);
                });
            });
        },
        emailInvoice: function emailInvoice(template, invoiceHtml, greeting, to, cc, invoice) {

            if (!invoiceHtml) {
                var el = document.getElementById('invoice' + invoice.meta.key);
                if (el && el.innerHTML) invoiceHtml = el.innerHTML;else {
                    __WEBPACK_IMPORTED_MODULE_27__helpers_AlertHelpers__["a" /* default */].showAlert('Cant get invoice info. Not sent.');
                    return;
                }
            }

            console.log('*** sending invoice ***', to, cc);

            var customFields = {
                greeting: greeting,
                sender: this.$store.getters.user.firstName,
                invoice: invoiceHtml
            };

            if (invoice) customFields.pdf = __WEBPACK_IMPORTED_MODULE_29__helpers_EmailHelpers__["a" /* default */].emailButton('invoice/' + this.month + '/' + invoice.meta.key, 'Get PDF Version');

            var body = __WEBPACK_IMPORTED_MODULE_28__helpers_MergeHelpers__["a" /* default */].simpleMerge(template.body, customFields);

            var email = {};
            email.to = [{ email: to }];
            email.cc = [{ email: cc }];
            email.subject = template.subject || '';
            email.body = body;

            email.from = 'no-reply@insightprocessing.com.au';

            email.bcc = [{ email: __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getUserEmail() }];

            var logId = __WEBPACK_IMPORTED_MODULE_29__helpers_EmailHelpers__["a" /* default */].queueEmail(email);
            this.$root.$monitorMail(logId);
        },
        showCharge: function showCharge(invoice) {
            var user = invoice.to;

            this.chargeDialog.charge.date = this.viewingCurrentMonth ? __WEBPACK_IMPORTED_MODULE_33__helpers_DateHelpers__["a" /* default */].todayString() : this.month + '-01';

            this.chargeDialog.charge.from = __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].getUser();
            this.chargeDialog.description = '';
            this.chargeDialog.clients = '';
            this.chargeDialog.charge.to = user;
            this.chargeDialog.amount = 0;
            this.chargeDialog.settings.visible = true;
        }
    },

    watch: {
        'month': {
            immediate: false,
            handler: function handler(newVal) {
                this.loadInvoices();
            }
        }
    },

    created: function created() {
        var _this20 = this;

        __WEBPACK_IMPORTED_MODULE_23__helpers_DataHelpers__["a" /* default */].fetchUser().then(function (user) {
            _this20.user = user;
            _this20.loadInvoices();
        });
    }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        invoice: Object
    },

    computed: {
        nth: function nth() {
            if (__WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].isInsightUser(this.invoice.to)) return '28th';

            return '21st';
        },
        invoiceHTML: function invoiceHTML() {
            return this.$refs.invoice.outerHTML;
        },
        invoiceDate: function invoiceDate() {
            var dateString = this.invoice.month + '-01';
            var startOfMonth = new Date(dateString);
            var startOfNextMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["m" /* addMonths */])(startOfMonth, 1);
            return __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].dateToAu(startOfNextMonth);
        }
    },

    methods: {
        formatStamp: function formatStamp(stamp) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].formatStamp(stamp);
        },
        getInvoiceId: function getInvoiceId(invoice) {

            if (!invoice.meta) return '';

            var payer = invoice.to;
            var initials = __WEBPACK_IMPORTED_MODULE_1__helpers_ContactHelpers__["a" /* default */].initials(payer) + payer.lastName[payer.lastName.length - 1].toUpperCase();

            var recipient = invoice.from;
            var recipientInitials = __WEBPACK_IMPORTED_MODULE_1__helpers_ContactHelpers__["a" /* default */].initials(recipient);

            var _invoice$month$split = invoice.month.split('-'),
                _invoice$month$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_invoice$month$split, 2),
                year = _invoice$month$split2[0],
                month = _invoice$month$split2[1];

            var singleDigitYear = year - 2020;

            return initials + recipientInitials + '-' + month + singleDigitYear;
        },
        isAdministrator: function isAdministrator() {
            var userEmail = this.user.email;
            return userEmail == 'matt.ireland.home@gmail.com';
        },
        deleteCharge: function deleteCharge(charge) {
            this.$emit('delete-charge', charge);
        },
        debugCharge: function debugCharge(charge) {
            __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].viewInConsole(charge.meta.path + '/' + charge.meta.key);
        }
    },

    mounted: function mounted() {
        var _this = this;

        Object.defineProperty(this.invoice, 'html', {
            get: function get() {
                return _this.invoiceHTML;
            }
        });
    }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Invoice__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Invoice__);














/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'OneInvoice',
    data: function data() {
        return {
            invoice: { charges: [], from: {}, to: {} }
        };
    },


    components: {
        Invoice: __WEBPACK_IMPORTED_MODULE_7__Invoice___default.a
    },

    props: {
        invoiceKey: String,
        month: String
    },

    computed: {
        thisPage: function thisPage() {
            return encodeURI(window.location);
        }
    },

    watch: {},

    methods: {},

    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var ref, invoice, chargeRef, charges, total;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/billing').child(_this.month).child('invoices').child(_this.invoiceKey);
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].fetchItemSingle(ref);

                        case 3:
                            invoice = _context.sent;
                            chargeRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/billing/' + _this.month + '/charges').orderByChild('invoice').equalTo(_this.invoiceKey);
                            _context.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].fetchItemsFromFirebase(chargeRef);

                        case 7:
                            charges = _context.sent;

                            _this.$set(invoice, 'charges', charges);

                            if (invoice.charges && invoice.charges.length) {
                                total = invoice.charges.reduce(function (a, b) {
                                    return a + (b.amount || 0);
                                }, 0);

                                _this.$set(invoice, 'total', total);
                            } else {
                                _this.$set(invoice, 'total', 0);
                            }

                            _this.invoice = invoice;

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    mounted: function mounted() {}
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns_esm_fp__ = __webpack_require__(170);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChartControl',
    props: {
        definition: Object,
        record: Object
    },
    components: { ImageGroup: __WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup___default.a },
    data: function data() {
        return {
            transactions: []
        };
    },

    computed: {
        controlClass: function controlClass() {
            var value = this.record[this.definition.name];
            return {
                'green darken-1': value === true,
                'white--text': this.definition.type == 'pd'

            };
        },
        dateInWords: function dateInWords() {
            var value = this.record[this.definition.name + '_date'];
            if (!value) return '';
            var dateValue = __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].backwardsToDate(value);
            return __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].fromNow(dateValue);
        },
        clientNames: function clientNames() {
            var clientsObj = this.record['clients'];
            var clients = __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var names = __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].combineClientsNames(clients);
            return names;
        },
        clientImages: function clientImages() {
            var clientsObj = this.record['clients'];
            var clients = __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var images = clients.map(function (o) {
                return o.image;
            });
            return images;
        }
    },
    methods: {},
    created: function created() {}
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressChart__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProgressChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UpcomingChart__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UpcomingChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UpcomingChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProgressRotator',
    components: { ProgressChart: __WEBPACK_IMPORTED_MODULE_0__ProgressChart___default.a, UpcomingChart: __WEBPACK_IMPORTED_MODULE_1__UpcomingChart___default.a },
    props: {
        tenantKey: String
    },
    data: function data() {
        return {
            seconds: 30,
            charts: [{
                name: 'Todays Finance and Settlements',
                type: 'UpcomingChart',
                dates: [{
                    name: 'finance_date',
                    title: 'Finance Date',
                    color: '#FF80AB'
                }, {
                    name: 'settlement_date',
                    title: 'Settlement Date',
                    color: '#9575CD'
                }]
            }, {
                name: 'Lead Tracking',
                triggerStart: 'lead_taken',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'lead_taken',
                    title: 'Taken',
                    type: 'pd'
                }, {
                    name: 'qualified',
                    title: 'Qualified',
                    type: 'pd'
                }, {
                    name: 'converted_to_appointment',
                    title: 'Converted',
                    type: 'pd'
                }]
            }, {
                name: 'Pricing',
                triggerStart: 'pricing_ordered',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'pricing_ordered',
                    title: 'Ordered',
                    type: 'pd'
                }, {
                    name: 'pricing_complete',
                    title: 'Complete',
                    type: 'pd'
                }]
            }, {
                name: 'Valuations',
                triggerStart: 'val_ordered',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'val_ordered',
                    title: 'Ordered',
                    type: 'pd'
                }, {
                    name: 'val_back',
                    title: 'Back',
                    type: 'pd'
                }]
            }, {
                name: 'Major Milestones',
                triggerStart: 'submitted',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'submitted',
                    title: 'Submitted',
                    type: 'pd'
                }, {
                    name: 'conditional_approval',
                    title: 'Conditional',
                    type: 'pd'
                }, {
                    name: 'approved',
                    title: 'Approved',
                    type: 'pd'
                }, {
                    name: 'settlement_confirmed',
                    title: 'Settled',
                    type: 'pd'
                }]
            }]
        };
    },

    computed: {},
    methods: {
        setSpeed: function setSpeed(seconds) {
            this.seconds = seconds;
            __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__["a" /* default */].showAlert('Speed set to ' + seconds + ' seconds');
        }
    }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressChart__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ProgressChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VolumeChart__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VolumeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VolumeChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RangeChart__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RangeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RangeChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UpcomingChart__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UpcomingChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UpcomingChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__screens_ScreenLayout__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProgressRotator',
    components: { ProgressChart: __WEBPACK_IMPORTED_MODULE_0__ProgressChart___default.a, VolumeChart: __WEBPACK_IMPORTED_MODULE_1__VolumeChart___default.a, RangeChart: __WEBPACK_IMPORTED_MODULE_2__RangeChart___default.a, UpcomingChart: __WEBPACK_IMPORTED_MODULE_3__UpcomingChart___default.a, ScreenLayout: __WEBPACK_IMPORTED_MODULE_5__screens_ScreenLayout___default.a },
    props: {
        tenantKey: String
    },
    data: function data() {
        return {
            seconds: 30,
            activeChart: {},
            charts: [{
                name: 'Todays Finance and Settlements',
                type: 'UpcomingChart',
                dates: [{
                    name: 'finance_date',
                    title: 'Finance Date',
                    color: '#FF80AB'
                }, {
                    name: 'settlement_date',
                    title: 'Settlement Date',
                    color: '#9575CD'
                }]
            }, {
                name: 'Monthly Overview',
                type: 'VolumeChart'
            }, {
                name: 'Monthly Reports',
                type: 'RangeChart'
            }, {
                name: 'Lead Tracking',
                triggerStart: 'lead_taken',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'lead_taken',
                    title: 'Taken',
                    type: 'pd'
                }, {
                    name: 'qualified',
                    title: 'Qualified',
                    type: 'pd'
                }, {
                    name: 'converted_to_appointment',
                    title: 'Converted',
                    type: 'pd'
                }]
            }, {
                name: 'Pricing',
                triggerStart: 'pricing_ordered',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'pricing_ordered',
                    title: 'Ordered',
                    type: 'pd'
                }, {
                    name: 'pricing_complete',
                    title: 'Complete',
                    type: 'pd'
                }]
            }, {
                name: 'Valuations',
                triggerStart: 'val_ordered',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'val_ordered',
                    title: 'Ordered',
                    type: 'pd'
                }, {
                    name: 'val_back',
                    title: 'Back',
                    type: 'pd'
                }]
            }, {
                name: 'Major Milestones',
                triggerStart: 'submitted',
                type: 'ProgressChart',
                columns: [{
                    name: 'clients',
                    title: '',
                    type: 'pc'
                }, {
                    name: 'submitted',
                    title: 'Submitted',
                    type: 'pd'
                }, {
                    name: 'conditional_approval',
                    title: 'Conditional',
                    type: 'pd'
                }, {
                    name: 'approved',
                    title: 'Approved',
                    type: 'pd'
                }, {
                    name: 'settlement_confirmed',
                    title: 'Settled',
                    type: 'pd'
                }]
            }]
        };
    },

    computed: {},
    methods: {
        isChartActive: function isChartActive(chart) {
            if (!this.activeChart || !chart) return false;

            return chart.name == this.activeChart.name;
        }
    },
    created: function created() {
        this.activeChart = this.charts[0];
    }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_reverse__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartControl__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ChartControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ChartControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_esm_fp__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProgressChart',
    props: {
        tenantKey: String,
        chart: Object
    },
    components: {
        ChartControl: __WEBPACK_IMPORTED_MODULE_3__ChartControl___default.a
    },

    data: function data() {
        return {
            transactions: []
        };
    },

    computed: {},
    methods: {
        loadChartData: function loadChartData() {
            var _this = this;

            var threeMonthsAgo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns_esm_fp__["a" /* subMonths */])(3, new Date());
            var threeMonthsAgoStr = __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].dateToBackwards(threeMonthsAgo);
            var ref = __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getTenantRef(this.tenantKey).child('milestones');
            console.log('trigger start is', this.chart.triggerStart);
            if (this.chart.triggerStart) ref = ref.orderByChild(this.chart.triggerStart + '_date').startAt(threeMonthsAgoStr).limitToLast(100);
            ref.on('value', function (snap) {
                var transactions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_reverse___default()(__WEBPACK_IMPORTED_MODULE_2__data_NiceData__["a" /* default */].arrayFromSnapshot(snap));

                _this.transactions = transactions;
            });
        },
        transactionLink: function transactionLink(transactionKey) {
            return '/' + this.tenantKey + '/transaction/' + transactionKey;
        }
    },
    created: function created() {
        this.loadChartData();
    },

    watch: {
        chart: {
            immediate: true,
            handler: function handler(newVal) {
                this.loadChartData();
            }
        }
    }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_TeamHelpers__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChartControl__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChartControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ChartControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DateRange__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DateRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_LabelMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_LabelMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_LabelMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_date_fns__ = __webpack_require__(17);


















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'RangeChart',
    props: {
        tenantKey: String,
        chart: Object
    },
    components: {
        ImageGroup: __WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup___default.a, NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder___default.a, DateRange: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DateRange___default.a, LabelMenu: __WEBPACK_IMPORTED_MODULE_12__ui_elements_LabelMenu___default.a
    },

    data: function data() {
        return {
            search: '',
            dateFilter: 'active',

            dateRange: {
                start: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_date_fns__["z" /* startOfMonth */])(new Date()),
                end: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_date_fns__["A" /* endOfMonth */])(new Date())
            },
            transactions: {},
            loans: [],
            settledThisMonth: [],
            daysThisMonth: 30,
            dayOfMonth: 1

        };
    },


    asyncComputed: {
        officeName: {
            get: function get() {
                var _this = this;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__helpers_TeamHelpers__["a" /* default */].officeNumberToName(_this.tenantKey));

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }))();
            },

            default: ''
        }
    },

    computed: {
        filteredLoans: function filteredLoans() {
            if (this.search) {
                var s = this.search.toLowerCase();
                return this.loans.filter(function (o) {
                    return (o.broker ? o.broker.firstName.toLowerCase() : '').indexOf(s) > -1 || (o.broker ? o.broker.lastName.toLowerCase() : '').indexOf(s) > -1 || (o.lender ? o.lender.toLowerCase() : '').indexOf(s) > -1;
                });
            } else {
                return this.loans;
            }
        },
        googleChartOptions: function googleChartOptions() {
            return {
                legend: 'labeled',
                colors: this.chartColours,
                height: 200,
                width: 400
            };
        },
        lenderSpread: function lenderSpread() {
            var spread = {};
            this.filteredLoans.forEach(function (loan) {
                var lender = loan.lender;
                spread[lender] = (spread[lender] || 0) + 1;
            });
            var chartData = [];
            for (var key in spread) {
                var rowArray = [key, spread[key]];
                chartData.push(rowArray);
            }
            chartData.sort(function (a, b) {
                return b[1] - a[1];
            });

            while (chartData.length > 6) {
                chartData.pop();
            }

            chartData.unshift(['Lender', 'Count']);
            return chartData;
        },
        chartColours: function chartColours() {
            var colours = [];
            for (var i = 1; i < this.lenderSpread.length; i++) {
                var lender = this.lenderSpread[i][0];
                var colour = this.getLenderColour(lender);
                colours.push(colour);
            }
            return colours;
        },
        filteredLoanCount: function filteredLoanCount() {
            return this.filteredLoans.length;
        },
        startingDate: function startingDate() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__["a" /* default */].dateToBackwards(this.dateRange.start);
        },
        endingDate: function endingDate() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__["a" /* default */].dateToBackwards(this.dateRange.end);
        },
        totalAmount: function totalAmount() {
            return this.totalNewMoney(this.filteredLoans);
        },
        triggers: function triggers() {
            return {
                filter: this.dateFilter,
                range: this.dateRange
            };
        }
    },
    methods: {
        getLenderColour: function getLenderColour(lender) {
            var colours = [{ lender: 'CBA', colour: '#ffcc00' }, { lender: 'ANZ', colour: '#007dba' }, { lender: 'Westpac', colour: '#990000' }, { lender: 'NAB', colour: '#c20000' }, { lender: 'Macquarie', colour: '#000000' }, { lender: 'Bankwest', colour: '#ff911e' }, { lender: 'CUA', colour: '#00a0b9' }, { lender: 'Me Bank', colour: '#000000' }, { lender: 'St George', colour: '#78be20' }, { lender: 'Gateway', colour: '#002B54' }, { lender: 'HSBC', colour: '#db0011' }, { lender: 'Mortgage Choice Home Loans', colour: '#007491' }, { lender: 'Suncorp', colour: '#478081' }, { lender: 'Aussie Select', colour: '#6610f2' }];
            var obj = colours.find(function (o) {
                return o.lender == lender;
            });
            return obj ? obj.colour : '#999999';
        },
        fullName: function fullName(contact) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].fullName(contact);
        },
        formatMillions: function formatMillions(amt) {
            return '$' + Math.round(amt / 10000) / 100 + 'm';
        },
        transactionLink: function transactionLink(transactionKey) {
            return '/' + this.tenantKey + '/transaction/' + transactionKey;
        },
        clientImages: function clientImages(clientsObj) {
            var clients = __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var images = clients.map(function (o) {
                return o.image;
            });
            return images;
        },
        clientNames: function clientNames(clientsObj) {
            var clients = __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var names = __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].combineClientsNames(clients);
            return names;
        },
        totalNewMoney: function totalNewMoney(arr) {
            if (!arr || arr.length == 0) return 0;
            return arr.reduce(function (a, b) {
                return a + (b.total_new_money || 0);
            }, 0);
        },
        fetchRecords: function fetchRecords() {
            var _this2 = this;

            var milestoneRef = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef(this.tenantKey).child('milestones');
            var loansRef = void 0;
            if (this.dateFilter == 'active') loansRef = milestoneRef.orderByChild('active').equalTo(true);else loansRef = milestoneRef.orderByChild(this.dateFilter).startAt(this.startingDate).endAt(this.endingDate).limitToLast(500);

            __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].fetchItemsFromFirebase(loansRef).then(function (items) {
                _this2.loans = items;
            });
        }
    },

    created: function created() {},


    watch: {
        'dateRange': {
            handler: function handler() {
                this.fetchRecords();
            },
            deep: true
        },
        'dateFilter': {
            handler: function handler() {
                this.fetchRecords();
            },
            immediate: true
        }
    }

});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChartControl__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ChartControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ChartControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_ImageGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_ImageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_ImageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_NoRecordsPlaceholder__);












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'UpcomingChart',
    props: {
        tenantKey: String,
        chart: Object
    },
    components: {
        ImageGroup: __WEBPACK_IMPORTED_MODULE_7__ui_elements_ImageGroup___default.a, NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_8__ui_elements_NoRecordsPlaceholder___default.a
    },

    data: function data() {
        return {
            transactions: {}
        };
    },

    computed: {
        combinedTransactions: function combinedTransactions() {
            var combinedTransactions = [];
            for (var prop in this.transactions) {
                console.log('prop:' + prop);
                combinedTransactions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(combinedTransactions), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.transactions[prop]));
            }
            return combinedTransactions || 'hello   ';
        },
        todaysTransactions: function todaysTransactions() {
            return this.combinedTransactions.filter(function (o) {
                return o.date == __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].todayString();
            });
        },
        tomorrowsTransactions: function tomorrowsTransactions() {
            return this.combinedTransactions.filter(function (o) {
                return o.date == __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].tomorrowString();
            });
        }
    },
    methods: {
        transactionLink: function transactionLink(transactionKey) {
            return '/' + this.tenantKey + '/transaction/' + transactionKey;
        },
        clientImages: function clientImages(clientsObj) {
            var clients = __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var images = clients.map(function (o) {
                return o.image;
            });
            return images;
        },
        clientNames: function clientNames(clientsObj) {
            var clients = __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var names = __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__["a" /* default */].combineClientsNames(clients);
            return names;
        }
    },
    created: function created() {
        var _this = this;

        var n = 0;
        this.chart.dates.forEach(function (dateField) {
            var ref = __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].getTenantRef(_this.tenantKey).child('milestones').orderByChild(dateField.name).startAt(__WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].yesterdayString()).endAt(__WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].tomorrowString());
            ref.on('value', function (snap) {
                var item = __WEBPACK_IMPORTED_MODULE_4__data_NiceData__["a" /* default */].arrayFromSnapshot(snap).map(function (o) {

                    return {
                        clients: o.clients,
                        date: o[dateField.name],
                        title: dateField.title,
                        color: dateField.color
                    };
                });
                _this.$set(_this.transactions, dateField.name, item);
            });
            n++;
        });
    }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_TeamHelpers__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChartControl__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChartControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ChartControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_date_fns__ = __webpack_require__(17);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VolumeChart',
    props: {
        tenantKey: String,
        chart: Object
    },
    components: {
        ImageGroup: __WEBPACK_IMPORTED_MODULE_9__ui_elements_ImageGroup___default.a, NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_10__ui_elements_NoRecordsPlaceholder___default.a, DialogBox: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default.a
    },

    data: function data() {
        return {
            transactions: {},
            submittedThisMonth: [],
            settledThisMonth: [],
            submittedLastMonth: [],
            settledLastMonth: [],
            targetSubmissions: 5000000,
            targetSettlements: 4000000,
            daysThisMonth: 30,
            dayOfMonth: 1,
            dialog: {
                settings: {
                    visible: false,
                    closeOnly: true
                }
            }
        };
    },


    asyncComputed: {
        officeName: {
            get: function get() {
                var _this = this;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_5__helpers_TeamHelpers__["a" /* default */].officeNumberToName(_this.tenantKey));

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }))();
            },

            default: ''
        }
    },

    computed: {
        targetSubmissionsMillions: function targetSubmissionsMillions() {
            return '$' + Math.round(this.targetSubmissions / 100000) / 10 + 'm';
        },
        targetSettlementsMillions: function targetSettlementsMillions() {
            return '$' + Math.round(this.targetSettlements / 100000) / 10 + 'm';
        },
        amountSubmittedThis: function amountSubmittedThis() {
            return this.totalNewMoney(this.submittedThisMonth);
        },
        amountSubmittedLast: function amountSubmittedLast() {
            return this.totalNewMoney(this.submittedLastMonth);
        },
        amountSettledThis: function amountSettledThis() {
            return this.totalNewMoney(this.settledThisMonth);
        },
        amountSettledLast: function amountSettledLast() {
            return this.totalNewMoney(this.settledLastMonth);
        }
    },
    methods: {
        formatMillions: function formatMillions(amt) {
            return '$' + Math.round(amt / 10000) / 100 + 'm';
        },
        saveSettings: function saveSettings() {
            __WEBPACK_IMPORTED_MODULE_5__helpers_TeamHelpers__["a" /* default */].saveTeamSettings({
                targetSubmissions: this.targetSubmissions,
                targetSettlements: this.targetSettlements
            });
        },
        transactionLink: function transactionLink(transactionKey) {
            return '/' + this.tenantKey + '/transaction/' + transactionKey;
        },
        clientImages: function clientImages(clientsObj) {
            var clients = __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var images = clients.map(function (o) {
                return o.image;
            });
            return images;
        },
        clientNames: function clientNames(clientsObj) {
            var clients = __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].objectToObjectArray(clientsObj);
            var names = __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].combineClientsNames(clients);
            return names;
        },
        totalNewMoney: function totalNewMoney(arr) {
            if (!arr || arr.length == 0) return 0;
            return arr.reduce(function (a, b) {
                return a + (b.total_new_money || 0);
            }, 0);
        },
        loadSettings: function loadSettings() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var settings;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_5__helpers_TeamHelpers__["a" /* default */].fetchTeamSettings();

                            case 2:
                                settings = _context2.sent;

                                _this2.targetSubmissions = settings.targetSubmissions || _this2.targetSubmissions;
                                _this2.targetSettlements = settings.targetSettlements || _this2.targetSettlements;

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    created: function created() {
        var _this3 = this;

        var today = new Date();
        var oneMonthAgo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["v" /* subMonths */])(today, 1);
        var startOfThisMonth = __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["z" /* startOfMonth */])(today));
        var endOfThisMonth = __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["A" /* endOfMonth */])(today));
        var startOfLastMonth = __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["z" /* startOfMonth */])(oneMonthAgo));
        var endOfLastMonth = __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["A" /* endOfMonth */])(oneMonthAgo));

        this.daysThisMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["F" /* getDaysInMonth */])(today);
        this.dayOfMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_date_fns__["B" /* getDate */])(new Date());

        var milestoneRef = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef(this.tenantKey).child('milestones');


        var submittedThisRef = milestoneRef.orderByChild('submitted_date').startAt(startOfThisMonth).endAt(endOfThisMonth);
        var settledThisRef = milestoneRef.orderByChild('settlement_confirmed_date').startAt(startOfThisMonth).endAt(endOfThisMonth);
        var submittedLastRef = milestoneRef.orderByChild('submitted_date').startAt(startOfLastMonth).endAt(endOfLastMonth);
        var settledLastRef = milestoneRef.orderByChild('settlement_confirmed_date').startAt(startOfThisMonth).endAt(endOfLastMonth);

        __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].fetchItemsFromFirebase(submittedThisRef).then(function (items) {
            _this3.submittedThisMonth = items;
        });
        __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].fetchItemsFromFirebase(submittedLastRef).then(function (items) {
            _this3.submittedLastMonth = items;
        });
        __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].fetchItemsFromFirebase(settledThisRef).then(function (items) {
            _this3.settledThisMonth = items;
        });
        __WEBPACK_IMPORTED_MODULE_6__data_NiceData__["a" /* default */].fetchItemsFromFirebase(settledLastRef).then(function (items) {
            _this3.settledLastMonth = items;
        });

        this.loadSettings();
    }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LivingExpenseHelpers__ = __webpack_require__(289);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            breakdownDialog: {
                settings: {
                    visible: false,
                    description: 'Breakdown',
                    title: "Breakdown"
                },
                breakdown: []
            }
        };
    },


    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default.a
    },

    props: {
        expense: Object
    },

    computed: {
        displayExpense: function displayExpense() {
            if (this.expense.value == null) return '';else if (this.expense.value == 0) return 'Nil';else return __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__["a" /* default */].formatCurrency(this.expense.value);
        },
        hasValue: function hasValue() {
            return this.expense.value > 0;
        },
        isInRange: function isInRange() {
            return __WEBPACK_IMPORTED_MODULE_6__LivingExpenseHelpers__["a" /* default */].isInRange(this.expense);
        },
        overRange: function overRange() {
            return __WEBPACK_IMPORTED_MODULE_6__LivingExpenseHelpers__["a" /* default */].isOverRange(this.expense);
        },
        underRange: function underRange() {
            return __WEBPACK_IMPORTED_MODULE_6__LivingExpenseHelpers__["a" /* default */].isUnderRange(this.expense);
        },
        rangeError: function rangeError() {
            return !this.isInRange && this.expense.explanation.length < 3 && this.hasValue;
        },
        endOfSlider: function endOfSlider() {
            return this.sliderValue == this.expected.min && this.sliderValue > 0 || this.sliderValue == this.expected.max;
        },
        higherOrLower: function higherOrLower() {
            if (this.overRange) return 'higher';
            if (this.underRange) return 'lower';
            return 'better';
        },
        breakdownTotal: function breakdownTotal() {
            var total = 0;
            this.expense.breakdown.forEach(function (item) {
                total += parseInt(item.value) || 0;
            });
            return total;
        }
    },

    methods: {
        saveBreakdown: function saveBreakdown() {
            if (this.breakdownTotal) {
                if (this.breakdownTotal > this.expense.max) this.expense.max = this.breakdownTotal;
                this.expense.value = this.breakdownTotal;
            }
        },
        showDetails: function showDetails() {
            this.breakdownDialog.settings.title = this.expense.name;
            this.breakdownDialog.settings.visible = true;
        },
        nearestTen: function nearestTen(num) {
            return parseInt(num / 10) * 10;
        },
        sliderFinished: function sliderFinished() {
            var _this = this;

            setTimeout(function () {
                if (_this.expense.value == _this.expense.max) _this.expense.max = _this.nearestTen(_this.expense.max * 1.5);
            }, 1000);
        }
    },

    created: function created() {},


    watch: {}
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LivingExpense__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LivingExpense___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LivingExpense__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LivingExpenseHelpers__ = __webpack_require__(289);













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'LivingExpenses',
    data: function data() {
        return {
            linkCopied: false,
            sendCopy: false,
            submitted: false,
            mode: 'normal',
            step: 1,
            stepVisible: false,
            params: {
                name: '',
                email: '',
                consultant: '',
                adults: 2,
                children: 0,
                daycare: false,
                private: false,
                cars: 2,
                investments: 0,
                income: 'Average Income',
                explanation: ''
            },
            expenses: {

                a_groceries: {
                    name: 'Groceries',
                    value: 0,
                    explanation: '',
                    hint: "Food, household supplies",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Food',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Household Supplies',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                b_clothing: {
                    name: 'Clothing and Personal',
                    value: 0,
                    explanation: '',
                    hint: "Clothes, accessories, cosmetics etc",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Clothing',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Accessories',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Cosmetics',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },
                c_transport: {
                    name: 'Transport',
                    value: 0,
                    explanation: '',
                    hint: "Includes fuel, servicing, public transport, rego, parking, tolls (but not leases/loans)",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Fuel',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Servicing',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Public Transport',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Registration',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Parking',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Tolls',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                d_communication: {
                    name: 'Telephone, Internet, Pay TV',
                    value: 0,
                    explanation: '',
                    hint: "Phone, internet, TV Subscriptions",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Phones',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Internet',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'TV Subscriptions',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                e_entertainment: {
                    name: 'Recreation and Entertainment',
                    value: 0,
                    explanation: '',
                    hint: "Movies, gym, dining, alcohol, tobacco, holdays",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Holidays',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Tobacco/Alcohol',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Movies/Dining Out',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Gym',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                f_childcare: {
                    name: 'Childcare',
                    value: 0,
                    explanation: '',
                    hint: "Child care for young children",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    optional: true,
                    breakdown: [{
                        name: 'Daycare (after rebates)',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Nannies/Sitters',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                g_petcare: {
                    name: 'Pet Care',
                    value: 0,
                    explanation: '',
                    hint: "Food and care for pets",
                    expectedValue: 0,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'Pet Food',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Vetinary',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                h_medical: {
                    name: 'Medical and Health',
                    value: 0,
                    explanation: '',
                    hint: "Doctor, dentist, physio, prescriptions",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Doctor',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Dentist',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Physio/Chiro',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Prescriptions',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                i_health_insurance: {
                    name: 'Health Insurance',
                    value: 0,
                    explanation: '',
                    hint: "Health insurance premiums",
                    expectedValue: 100,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'Health Premium',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                j_general_insurance: {
                    name: 'General Basic Insurance',
                    value: 0,
                    explanation: '',
                    hint: "Cars and other assets",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    optional: false,
                    breakdown: [{
                        name: 'Car Insurance',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other Insurance',
                        value: 0,
                        frequency: 'm'
                    }]
                },
                k_risk_insurance: {
                    name: 'Sickness, Accident, Life Insurance',
                    value: 0,
                    explanation: '',
                    hint: "Risk, Trauma, Life",
                    expectedValue: 101,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'Life',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Risk',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Trauma',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                l_public_education: {
                    name: 'Public School',
                    value: 0,
                    explanation: '',
                    hint: "Courses, school fees, books",
                    expectedValue: 101,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'School Fees',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Books/Stationary',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Courses',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },
                m_private_education: {
                    name: 'Private School',
                    value: 0,
                    explanation: '',
                    hint: "Courses, school fees, books",
                    expectedValue: 101,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'School Fees',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Books/Stationary',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Courses',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                n_higher_education: {
                    name: 'Higher Education',
                    value: 0,
                    explanation: '',
                    hint: "Tafe, Uni, Personal Development",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    optional: true,
                    breakdown: [{
                        name: 'University/College',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'TAFE',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Courses',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },

                o_home_costs: {
                    name: 'Home Rates and Utilities',
                    value: 0,
                    explanation: '',
                    hint: "Council rates, electricity, gas (INCLUDES PURCHASE PROPERTY)",
                    expectedValue: 101,
                    max: 300,
                    na: false,
                    breakdown: [{
                        name: 'Council Rates',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Electricity',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Gas',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Water',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },
                p_investment: {
                    name: 'Investment Property',
                    value: 0,
                    explanation: '',
                    hint: "Council rates, strata, repairs",
                    expectedValue: 101,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'Council Rates',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Body Corp Fees',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Repairs',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },
                q_secondary_property: {
                    name: 'Secondary Residence Running Costs',
                    value: 0,
                    explanation: '',
                    hint: "Council rates, strata, repairs",
                    expectedValue: 101,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'Council Rates',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Body Corp Fees',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Repairs',
                        value: 0,
                        frequency: 'm'
                    }, {
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                },
                r_other: {
                    name: 'Other',
                    value: 0,
                    explanation: '',
                    hint: "Anything else",
                    expectedValue: 0,
                    max: 300,
                    optional: true,
                    na: false,
                    breakdown: [{
                        name: 'Other',
                        value: 0,
                        frequency: 'm'
                    }]
                }
            }
        };
    },

    components: {
        LivingExpense: __WEBPACK_IMPORTED_MODULE_1__LivingExpense___default.a
    },
    computed: {
        expectedTotal: function expectedTotal() {

            var PER_ADULT = 1450;
            var PER_CHILD = 500;

            var total = this.params.adults * PER_ADULT + this.params.children * PER_CHILD;
            if (this.params.income == 'Low Income') total = total * 0.93;
            if (this.params.income == 'High Income') total = total * 1.2;
            return total;
        },
        path: function path() {
            if (!this.key) return '';

            return __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].rootPath() + 'living?k=' + this.key;
        },


        alertVisible: {
            get: function get() {
                return this.$store.getters.alert.message;
            },
            set: function set(newValue) {
                if (!newValue) this.$store.dispatch('clearAlert');
            }
        },
        alertMessage: function alertMessage() {
            return this.$store.getters.alert.message;
        },
        totalRangeError: function totalRangeError() {
            return !this.totalWithinRange && this.params.explanation.length < 3;
        },
        totalWithinRange: function totalWithinRange() {
            var diff = Math.abs(this.expectedTotal - this.total);
            return diff / this.expectedTotal < 0.1;
        },
        totalHigherOrLower: function totalHigherOrLower() {
            if (this.total > this.expectedTotal) return 'higher';else return 'lower';
        },
        houseHoldSummary: function houseHoldSummary() {
            return this.params.adults + ' adults, ' + this.params.children + ' children, ' + (this.params.private ? 'Private School, ' : '') + (this.params.daycare ? 'Daycare, ' : '') + this.params.cars + ' cars, ' + this.params.investments + ' investments';
        },
        stepOneValidation: function stepOneValidation() {
            var validationErrors = [];
            if (this.params.name.length < 5) validationErrors.push('Require valid name');
            if (this.params.consultant.length < 5) validationErrors.push('Require valid consultant');
            if (!__WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].isEmail(this.params.email)) validationErrors.push('Require valid email');
            return __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].sentenceJoin(validationErrors);
        },
        stepTwoValidation: function stepTwoValidation() {
            var validationErrors = [];
            for (var property in this.expenses) {
                if (!this.isValid(this.expenses[property])) validationErrors.push(this.expenses[property].name);
            }
            if (validationErrors.length) return 'Require ' + __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].sentenceJoin(validationErrors);else return '';
        },
        adultItems: function adultItems() {
            return [{ text: '1 Adult', value: 1 }, { text: '2 Adults', value: 2 }];
        },
        childrenItems: function childrenItems() {
            return [{ text: 'No Children', value: 0 }, { text: '1 Child', value: 1 }, { text: '2 Children', value: 2 }, { text: '3 Children', value: 3 }, { text: '4 or more!', value: 4 }];
        },
        carItems: function carItems() {
            return [{ text: 'No Cars', value: 0 }, { text: '1 Cars', value: 1 }, { text: '2+ Cars', value: 2 }];
        },
        investmentItems: function investmentItems() {
            return [{ text: 'No Investments', value: 0 }, { text: '1 Investment Property', value: 1 }, { text: '2+ Investment Properties', value: 2 }];
        },
        total: function total() {
            var total = 0;
            for (var property in this.expenses) {
                var value = this.expenses[property].value || 0;
                total += parseInt(value);
            }
            return total;
        },
        stepTwoSubtitle: function stepTwoSubtitle() {
            if (this.total < 300 && this.step == 2) return "Do not include rent or debts. They are assessed separately";

            return "Please select a number for each expense category";
        },
        clientLinkVisible: function clientLinkVisible() {
            var validEmail = __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].isEmail(this.params.consultant);
            return validEmail && this.mode == 'normal' && !this.linkCopied;
        }
    },
    methods: {
        isValid: function isValid(expense) {
            return __WEBPACK_IMPORTED_MODULE_9__LivingExpenseHelpers__["a" /* default */].isValid(expense);
        },
        setExpectations: function setExpectations() {
            console.log('setting expectations');

            var e = this.expenses;

            var scaling = 1;
            if (this.params.income == 'High Income') scaling = 1.2;
            if (this.params.income == 'Low Income') scaling = 0.8;

            e.a_groceries.expectedValue = (200 + this.params.adults * 300 + this.params.children * 180) * scaling;
            e.b_clothing.expectedValue = (this.params.adults * 100 + this.params.children * 40) * scaling;
            e.c_transport.expectedValue = 300 * scaling;
            e.d_communication.expectedValue = (this.params.adults * 100 + this.params.children * 20) * scaling;
            e.e_entertainment.expectedValue = (this.params.adults * 250 + this.params.children * 100) * scaling;
            e.f_childcare.expectedValue = 200;
            e.g_petcare.expectedValue = 100;
            e.h_medical.expectedValue = (this.params.adults * 50 + this.params.children * 30) * scaling;
            e.i_health_insurance.expectedValue = (this.params.adults * 150 + this.params.children * 80) * scaling;
            e.j_general_insurance.expectedValue = 100;
            e.j_general_insurance.optional = true;
            e.k_risk_insurance.expectedValue = 100;
            e.l_public_education.expectedValue = this.params.children * 80;
            e.m_private_education.expectedValue = this.params.children * 400;
            e.n_higher_education.expectedValue = 100;
            e.o_home_costs.expectedValue = 220 + this.params.adults * 50;
            e.p_investment.expectedValue = 200;
            e.p_investment.optional = true;
            e.q_secondary_property.expectedValue = 300;


            for (var prop in e) {
                e[prop].max = this.nearestTen(e[prop].expectedValue * 2) || 100;
            }
        },
        nameChanged: function nameChanged() {
            if (this.params.name == 'demo') {
                this.params.name = 'Jenkin Hanmington';
                this.params.consultant = 'matt.ireland.home@gmail.com';
                this.params.email = 'matt.ireland.home@gmail.com';
            }
        },
        getClientLink: function getClientLink() {
            var linkPath = __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].rootPath() + 'living/?r=' + this.params.consultant;
            __WEBPACK_IMPORTED_MODULE_8_clipboard_js___default.a.copy({ 'text': linkPath });
            this.linkCopied = true;
            __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Link copied to clipboard');
        },
        showExample: function showExample() {
            for (var prop in this.expenses) {
                this.expenses[prop].value = this.expenses[prop].expectedValue;
            }
        },
        nearestTen: function nearestTen(num) {
            return parseInt(num / 10) * 10;
        },
        stepTwoClicked: function stepTwoClicked() {
            if (!this.stepOneValidation) {
                this.step = 2;
            }
        },
        stepThreeClicked: function stepThreeClicked() {
            if (!this.stepTwoValidation) {
                this.step = 3;
            }
        },
        sendSubmission: function sendSubmission() {
            var _this = this;

            this.save();
            var subject = 'Living Expenses - ' + this.params.name;
            var linkBack = '<a href="' + this.path + '">' + subject + '</a>';

            var expenses = this.$refs.expenses.innerHTML;

            var email = __WEBPACK_IMPORTED_MODULE_2__helpers_EmailHelpers__["a" /* default */].createEmail();
            email.service = 'living_expenses';
            email.to = this.params.consultant;
            email.cc = this.params.email || null;
            email.from = 'expense.estimation@gmail.com';
            email.fromName = 'Living Expense Tool';
            email.subject = 'Living Expenses - ' + this.params.name;
            email.body = "You've been sent a living expenses simulation. <br/><br/>" + "You can revisit this simulation using this link: " + linkBack + "<br/><br/>" + expenses;
            __WEBPACK_IMPORTED_MODULE_2__helpers_EmailHelpers__["a" /* default */].sendEmailJS(email).then(function (response) {
                if (response.text == 'OK') {
                    _this.submitted = true;
                    __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Email sent successfully');
                } else __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Email Failed: ' + response.text);
            });
        },
        adultsChanged: function adultsChanged() {
            this.params.cars = this.params.adults;
        },
        save: function save() {
            if (!this.key) this.key = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getKey();
            var record = {
                key: this.key,
                params: this.params,
                expenses: this.expenses
            };

            var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/livingExpenses');
            __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(record, ref);
        },
        load: function load() {
            var _this2 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/livingExpenses').child(this.key);
            __WEBPACK_IMPORTED_MODULE_5__data_FireData__["a" /* default */].fetchItemSingle(ref).then(function (record) {
                console.log(record);
                _this2.expenses = record.expenses;
                _this2.params = record.params;
            });
        }
    },
    watch: {
        step: function step(newVal, oldVal) {
            if (newVal == 2 && oldVal == 1) this.setExpectations();
        },

        total: function total(newVal) {
            this.submitted = false;
        }

    },
    created: function created() {
        var replyAddress = this.$route.query.r || null;
        if (replyAddress) {
            this.params.consultant = replyAddress;
            this.mode = 'invitation';
        }

        this.key = this.$route.query.k || null;
        if (this.key) {
            this.load();
        }
    }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_AdvancedDialog__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_AdvancedDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_AdvancedDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_SortDialog__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_SortDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_SortDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChecklistDocument__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChecklistDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ChecklistDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_PageHelpers__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChecklistHelpers__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_FirebaseHelpers__ = __webpack_require__(14);


















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {

            categories: [],
            policies: [],
            options: [],
            documents: [],

            categoriesString: null,

            sortDialog: {
                settings: {
                    visible: false,
                    title: 'Sort Items',
                    closeOnly: true
                },
                dataRef: null,
                items: null
            },

            categoryFields: [{ name: 'name', title: 'Name', type: 'Text' }],
            optionFields: [{ name: 'name', title: 'Name', type: 'Text' }],

            documentFields: [{ name: 'name', title: 'Name', type: 'Text' }, { name: 'messageToClient', title: 'Message to Client', type: 'Text', clearable: true, visibleFilter: this.mode != 'Template' }, { name: 'received', title: 'Received', type: 'Switch', visibleFilter: this.mode != 'Template' }, { name: 'checks', title: 'Things to Check', type: 'Group', disabled: this.mode == 'Client', fields: [{ name: 'check', title: 'Check', type: 'Text', rows: 2, width: 70, clickToEdit: true }, { name: 'complete', title: 'Complete', type: 'Checkbox', width: 10, visibleFilter: this.mode != 'Template', compact: true }] }, { name: 'attachment', title: 'Attach File', type: 'File', color: 'primary' }, { name: 'links', title: 'Associated Links', type: 'Group', fields: [{ name: 'url', title: 'Link URL', type: 'Text' }, { name: 'display', title: 'Display Text', type: 'Text' }] }, { name: 'date', title: 'Document Date', type: 'Date', visibleFilter: this.mode != 'Template' }, { name: 'information', title: 'More Information', type: 'Embed', disabled: this.mode != 'Template' }],
            openDocumentFields: [{ name: 'name', title: 'Name', type: 'Html', disabled: true }, { name: 'checks', title: 'Things to Check', type: 'Group', disabled: true, fields: [{ name: 'check', title: 'Please Check', type: 'Html', width: 70 }, { name: 'complete', title: 'Confirmed', type: 'Checkbox', width: 10, compact: true }] }, { name: 'attachment', title: 'Attach File', type: 'File', color: 'primary' }, { name: 'date', title: 'Document Date', type: 'Date' }, { name: 'information', title: 'More Information', type: 'Embed', disabled: true }],

            editDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: []
            }
        };
    },


    components: {
        AdvancedDialog: __WEBPACK_IMPORTED_MODULE_6__ui_elements_AdvancedDialog___default.a,
        SortDialog: __WEBPACK_IMPORTED_MODULE_7__ui_elements_SortDialog___default.a,
        ChecklistDocument: __WEBPACK_IMPORTED_MODULE_8__ChecklistDocument___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default.a
    },

    props: {
        transactionKey: String,
        checklistKey: String,
        mode: {
            type: String,
            default: 'Client'
        },
        pageSettings: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        summary: function summary() {
            return {
                documents: this.documents.length,
                received: this.documents.filter(function (o) {
                    return o.received;
                }).length,
                outstanding: this.documents.filter(function (o) {
                    return !o.received && !o.attachment;
                }).length
            };
        },
        policyFields: function policyFields() {
            return [{ name: 'debugPolicyMenu', title: 'Debug Policy', type: 'Menu' }, { name: 'name', title: 'Name', type: 'Text' }];
        },
        clientOrEmail: function clientOrEmail() {
            return this.mode == 'Client' || this.mode == 'Email';
        },
        imagePath: function imagePath() {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].imagePath();
        },
        checklistRef: function checklistRef() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/data').child(this.checklistKey);
            if (this.transactionKey) return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('documentChecklist');else return null;
        },
        categoriesRef: function categoriesRef() {
            return this.checklistRef.child('categories');
        },
        policiesRef: function policiesRef() {
            return this.checklistRef.child('policies');
        },
        optionsRef: function optionsRef() {
            return this.checklistRef.child('options');
        },
        documentsRef: function documentsRef() {
            return this.checklistRef.child('documents');
        },
        policiesString: function policiesString() {
            return this.categories.map(function (o) {
                return o.name;
            }).join(',');
        }
    },

    methods: {
        editDialogMenu: function editDialogMenu(_ref) {
            var menu = _ref.menu,
                record = _ref.record;

            console.log('edit dialog menu', menu, record);
            if (menu.name == 'debugPolicyMenu') {
                var policyKey = record.meta.key;
                var checklistKey = this.checklistKey;
                var path = 'app/documentChecklist/data/' + checklistKey + '/policies/' + policyKey;
                __WEBPACK_IMPORTED_MODULE_14__helpers_FirebaseHelpers__["a" /* default */].viewInConsole(path);
            }
        },
        indicatorColour: function indicatorColour(document) {
            if (document.received) return "green";
            if (!document.received && this.pageSettings.flagOutstandings) return "red";
            return "grey";
        },
        switchReceived: function switchReceived(document) {
            __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].saveItem(document);
        },
        loadCategories: function loadCategories() {
            var _this = this;

            var vm = this;
            this.categoriesRef.orderByChild('order').on('value', function (snap) {
                _this.categories = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
                _this.categoriesString = _this.categories.map(function (o) {
                    return o.name;
                }).join(',');
            });
        },
        loadPolicies: function loadPolicies() {
            var _this2 = this;

            this.policiesRef.orderByChild('order').on('value', function (snap) {
                _this2.policies = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
                _this2.$store.commit('setSelectedKeys', { code: 'checklist-policies', keys: _this2.policies.map(function (o) {
                        return o.name;
                    }) });
            });
        },
        loadOptions: function loadOptions() {
            var _this3 = this;

            this.optionsRef.orderByChild('order').on('value', function (snap) {
                _this3.options = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
            });
        },
        loadDocuments: function loadDocuments() {
            var _this4 = this;

            this.documentsRef.orderByChild('order').on('value', function (snap) {
                _this4.documents = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
            });
        },
        addCategory: function addCategory() {
            var category = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].makeItem(this.categoriesRef);
            category.meta.savePosition = "top";
            this.editCategory(category);
        },
        addPolicy: function addPolicy(categoryName) {
            var policy = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].makeItem(this.policiesRef);
            policy.category = categoryName;
            policy.meta.savePosition = "top";
            this.editPolicy(policy);
        },
        addOption: function addOption(policyKey) {
            var option = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].makeItem(this.optionsRef);
            option.policyKey = policyKey;
            option.meta.savePosition = "top";
            this.editOption(option);
        },
        addDocument: function addDocument(optionKey) {
            var document = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].makeItem(this.documentsRef);
            document.optionKey = optionKey;
            document.meta.savePosition = "top";
            this.editDocument(document);
        },
        addDifferentDocument: function addDifferentDocument(document) {
            this.editDialog.fields = this.differentDocumentFields;
            this.editDialog.settings.mode = 'different';
            this.editDialog.settings.title = 'Different Document';
            this.editDialog.settings.deleteButton = false;
            this.editDialog.settings.visible = true;
        },
        editCategory: function editCategory(category) {
            this.editDialog.fields = this.categoryFields;
            this.editDialog.record = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, category);
            this.editDialog.settings.visible = true;
        },
        editPolicy: function editPolicy(policy) {
            this.editDialog.fields = this.policyFields;
            this.editDialog.record = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, policy);
            this.editDialog.settings.title = 'Policy Details';
            this.editDialog.settings.visible = true;
        },
        editOption: function editOption(option) {
            this.editDialog.fields = this.optionFields;
            this.editDialog.record = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, option);
            this.editDialog.settings.title = 'Option - ' + (option.name || 'Create a New One');
            this.editDialog.settings.visible = true;
        },
        editDocument: function editDocument(document) {
            this.editDialog.fields = this.mode == 'Client' ? this.openDocumentFields : this.documentFields;
            this.editDialog.record = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, document);

            this.editDialog.settings.title = 'Document';
            this.editDialog.settings.deleteButton = this.mode != 'Client';
            this.editDialog.settings.visible = true;
        },
        policiesForCategory: function policiesForCategory(category) {
            return (this.policies || []).filter(function (o) {
                return o.category == category.name;
            });
        },
        optionsForPolicy: function optionsForPolicy(policy) {
            return (this.options || []).filter(function (o) {
                return o.policyKey == policy.meta.key;
            }).sort(__WEBPACK_IMPORTED_MODULE_9__helpers_OrderHelpers__["a" /* default */].sortByOrder);
        },
        firstOptionForPolicy: function firstOptionForPolicy(policy) {
            if (this.optionsForPolicy(policy) && this.optionsForPolicy(policy).length) {
                return this.optionsForPolicy(policy)[0];
            } else return { meta: {} };
        },
        remainingOptionsForPolicy: function remainingOptionsForPolicy(policy) {
            if (this.optionsForPolicy(policy) && this.optionsForPolicy(policy).length > 1) {
                var arr = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.optionsForPolicy(policy)));
                arr.shift();
                return arr;
            } else return [];
        },
        documentsForOption: function documentsForOption(option) {
            return (this.documents || []).filter(function (o) {
                return o.optionKey == option.meta.key;
            });
        },
        saveRecord: function saveRecord(item) {
            if (item.optionKey && this.mode != 'Template') {
                __WEBPACK_IMPORTED_MODULE_13__ChecklistHelpers__["a" /* default */].fetchPolicyForDocument(item).then(function (policy) {
                    policy.modified = true;

                    __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].saveItem(policy);
                });
            }

            __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].saveItem(item);
            this.$emit('change', item);
            this.updateSummary;
        },
        deleteRecord: function deleteRecord(item) {
            __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].deleteItem(item);
            this.editDialog.settings.visible = false;
        },
        deleteDocument: function deleteDocument(document) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this5.$root.$confirm('Delete', 'Delete this document?', { color: 'red' });

                            case 2:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 5;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].deleteItem(document);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        deleteOption: function deleteOption(option) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this6.$root.$confirm('Delete', 'Delete this option?', { color: 'red' });

                            case 2:
                                _context2.t0 = _context2.sent;

                                if (!(_context2.t0 == true)) {
                                    _context2.next = 5;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].deleteItem(option);

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            }))();
        },
        deletePolicy: function deletePolicy(policy) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this7.$root.$confirm('Delete', 'Delete this policy?', { color: 'red' });

                            case 2:
                                _context3.t0 = _context3.sent;

                                if (!(_context3.t0 == true)) {
                                    _context3.next = 5;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_13__ChecklistHelpers__["a" /* default */].deletePolicyCascade(policy);

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this7);
            }))();
        },
        deleteCategory: function deleteCategory(category) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return _this8.$root.$confirm('Delete', 'Delete this category?', { color: 'red' });

                            case 2:
                                _context4.t0 = _context4.sent;

                                if (!(_context4.t0 == true)) {
                                    _context4.next = 5;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].deleteItem(category);

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this8);
            }))();
        },
        optionLinkClicked: function optionLinkClicked(option) {
            var order = 0 - __WEBPACK_IMPORTED_MODULE_9__helpers_OrderHelpers__["a" /* default */].orderKey();
            option.order = order;
            __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].saveItem(option);
        },
        sortCategories: function sortCategories() {
            this.sortDialog.items = null;
            this.sortDialog.dataRef = this.categoriesRef;
            this.sortDialog.settings.visible = true;
        },
        sortPoliciesForCategory: function sortPoliciesForCategory(category) {
            this.sortDialog.items = this.policiesForCategory(category);
            this.sortDialog.dataRef = this.policiesRef;
            this.sortDialog.settings.visible = true;
        },
        sortOptionsForPolicy: function sortOptionsForPolicy(policy) {
            this.sortDialog.items = this.optionsForPolicy(policy);
            this.sortDialog.dataRef = this.optionsRef;
            this.sortDialog.settings.visible = true;
        },
        sortDocumentsForOption: function sortDocumentsForOption(option) {
            this.sortDialog.items = this.documentsForOption(option);
            this.sortDialog.dataRef = this.documentsRef;
            this.sortDialog.settings.visible = true;
        },
        initialise: function initialise() {
            this.loadCategories();
            this.loadPolicies();
            this.loadOptions();
            this.loadDocuments();
        },
        updateSummary: function updateSummary() {}
    },

    watch: {
        'checklistKey': {
            handler: function handler(newVal, oldVal) {
                this.initialise();
            },
            immediate: true
        },
        'summary': {
            handler: function handler(newVal, oldVal) {
                __WEBPACK_IMPORTED_MODULE_12__helpers_PageHelpers__["a" /* default */].setPageData('summary', newVal);
            },
            immediate: true
        }
    },

    created: function created() {}
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(17);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        Flag: __WEBPACK_IMPORTED_MODULE_0__ui_elements_Flag___default.a
    },

    props: {
        document: Object,
        pageSettings: Object
    },

    computed: {
        documentStyling: function documentStyling() {
            var result = { path: __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__["a" /* default */].imagePath(), status: '', textColour: '#888' };

            if (this.document.received) {
                result.path += 'document-success.png';
                result.status = '(received thank you)';
                result.textColour = 'rgba(3, 123, 48, 0.8)';
                result.path = "https://drive.google.com/uc?id=1CFIhEmyal3qYKJsuoi0mKb2tFsqYv0sl";
            } else if (this.document.attachment) {
                result.path += 'document-timer.png';
                result.status = '(pending checks)';
                result.textColour = 'rgba(0, 133, 255, 0.9)';
                result.path = "https://drive.google.com/uc?id=1fSMiMY82uR9xlryMLHAS87TzOf1aF1nD";
            } else if (this.pageSettings.flagOutstandings) {
                result.path += 'document-error.png';
                result.status = '(outstanding)';
                result.textColour = 'rgba(255, 63, 0, 0.9)';
                result.path = "https://drive.google.com/uc?id=1T7KKzNjF7JvHT9T1xgDQsptsucQeQElK";
            } else result.path += 'document.png';

            return result;
        },
        freshness: function freshness() {

            if (!this.document.date) {
                return {};
            }
            var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["G" /* differenceInDays */])(new Date(), __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToDate(this.document.date));

            var freshness = {
                textColour: '#bbb',
                text: days + ' days ago'
            };

            if (days < 0) freshness.text = 'Invalid Date';
            if (days < 1) {
                freshness.text = 'Today';
            } else if (days < 2) {
                freshness.text = 'Yesterday';
            } else if (days < 14) {} else if (days < 21) {
                freshness.textColour = 'orange';
            } else if (days > 21) {
                freshness.textColour = 'red';
            }
            return freshness;
        }
    },

    methods: {
        openDocument: function openDocument() {
            this.$emit('open', this.document);
        },
        checkStyle: function checkStyle(check) {
            return {
                'text-decoration': check.complete ? 'line-through' : 'none',
                'color': '#999'
            };
        }
    },

    created: function created() {}
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            officeDocumentObject: null
        };
    },


    components: {},

    props: {
        documents: Array
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        initialise: function initialise() {
            var _this = this;

            var ref = __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getTenantRef().child('documentChecklist').child('General');
            __WEBPACK_IMPORTED_MODULE_2__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (obj) {
                delete obj.meta;
                _this.officeDocumentObject = obj;
            });
        },
        camelToNormal: function camelToNormal(str) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].camelToNormal(str);
        },
        markAsReceived: function markAsReceived(document) {
            var newDocument = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, document);
            newDocument.received = true;
            this.$emit('change', newDocument);
        },
        documentClicked: function documentClicked(document) {
            this.$emit('click', document);
        }
    },

    created: function created() {
        this.initialise();
    }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_Flag__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            search: ''
        };
    },


    components: {
        Flag: __WEBPACK_IMPORTED_MODULE_3__ui_elements_Flag___default.a
    },

    props: {
        menu: Object
    },

    computed: {
        selectedPolicies: function selectedPolicies() {
            return this.$store.getters.getSelectedKeys('checklist-policies');
        }
    },

    methods: {
        matchesSearch: function matchesSearch(policyName) {
            var s = this.search.toLowerCase();
            if (!s) return true;
            var n = policyName.toLowerCase();
            return n.indexOf(s) > -1;
        },
        titleClicked: function titleClicked(titleObj) {
            this.$emit('click', titleObj);
        },
        isSelected: function isSelected(policyName) {
            return Boolean(this.selectedPolicies.find(function (p) {
                return p == policyName;
            }));
        },
        addDocument: function addDocument(category) {
            this.$emit('add', category);
        }
    },

    created: function created() {}
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChecklistDetails__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChecklistDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ChecklistDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChecklistHelpers__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_AdvancedList__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_AdvancedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_AdvancedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_AdvancedPanel__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_AdvancedPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_AdvancedPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_AdvancedDialog__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_AdvancedDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_AdvancedDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_NoRecordsPlaceholder__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChecklistTemplates',
    props: {
        tenantKey: String,
        transactionKey: String,
        checklistKey: String
    },

    components: {
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_3__ui_elements_LayoutContainer___default.a,
        ChecklistDetails: __WEBPACK_IMPORTED_MODULE_8__ChecklistDetails___default.a,
        AdvancedList: __WEBPACK_IMPORTED_MODULE_10__ui_elements_AdvancedList___default.a,
        AdvancedPanel: __WEBPACK_IMPORTED_MODULE_11__ui_elements_AdvancedPanel___default.a,
        AdvancedDialog: __WEBPACK_IMPORTED_MODULE_12__ui_elements_AdvancedDialog___default.a,
        NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_13__ui_elements_NoRecordsPlaceholder___default.a
    },
    data: function data() {
        return {
            templates: [],
            templateDetails: {},


            checklistTable: {
                ref: null,
                fields: [{ name: 'name', type: 'Text' }, { name: 'templates', type: 'List' }, { name: 'template', type: 'Switch' }, { name: 'global', type: 'Switch' }, { name: 'stamp', type: 'Text', default: '[stamp]' }, { name: 'tenantKey', type: 'Text', default: '[tenantKey]' }]
            },

            templateDetailsPanel: {
                fields: [{ name: 'name', title: 'Template Name', type: 'Text' }, { name: 'advanced', title: 'Show Advanced Options', type: 'Switch', width: 70 }, { name: 'done', title: 'Done', type: 'Button', width: 30 }, { name: 'template', title: 'Template', type: 'Switch', visibleFilter: '[advanced] = true', disabled: true }, { name: 'global', title: 'Global', type: 'Switch', visibleFilter: '[template] = true && [advanced] = true' }, { name: 'makeCopy', title: 'Make a Copy', type: 'Button', visibleFilter: '[advanced] = true', width: 50 }, { name: 'deleteTemplate', title: 'Delete Template', type: 'Button', color: 'error', visibleFilter: '[advanced] = true', width: 50 }],
                settings: {}
            },

            addDocumentDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: []
            },

            addDocumentFields: [{ name: 'name', title: 'Name', type: 'Text', focus: true }, { name: 'checks', title: 'Things to Check', type: 'Group', fields: [{ name: 'check', title: 'Please Check', type: 'Text', width: 70 }] }]

        };
    },


    computed: {
        topRef: function topRef() {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist');
        },
        listRef: function listRef() {
            return this.topRef.child('list');
        },
        listItemRef: function listItemRef() {
            return this.listRef.child(this.checklistKey);
        },
        dataRef: function dataRef() {
            return this.topRef.child('data').child(this.checklistKey);
        },
        pageTitle: function pageTitle() {
            return this.templateDetails.name || 'Document Checklist Templates';
        }
    },
    methods: {
        goToTemplate: function goToTemplate(key) {
            this.$router.push('/' + this.tenantKey + '/checklist-templates/' + key);
        },
        selectTemplate: function selectTemplate(template) {
            this.goToTemplate(template.meta.key);
        },
        templateDetailsButton: function templateDetailsButton(buttonName, record) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var newKey, newDetails;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (buttonName == 'makeCopy') {
                                    newKey = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getKey();

                                    __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('categories'), _this.topRef.child('data').child(newKey).child('categories'));
                                    __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('policies'), _this.topRef.child('data').child(newKey).child('policies'));
                                    __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('options'), _this.topRef.child('data').child(newKey).child('options'));
                                    __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('documents'), _this.topRef.child('data').child(newKey).child('documents'));

                                    newDetails = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.templateDetails);

                                    newDetails.name += ' (copy)';
                                    newDetails.tenantKey = _this.tenantKey;
                                    newDetails.global = false;
                                    newDetails.advanced = null;

                                    newDetails.meta.key = newKey;
                                    __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].saveItem(newDetails);
                                    _this.goToTemplate(newKey);
                                }

                                if (!(buttonName == 'deleteTemplate')) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 4;
                                return _this.$root.$confirm('Delete', 'Delete this entire template?', { color: 'red' });

                            case 4:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 9;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_9__ChecklistHelpers__["a" /* default */].deleteChecklist(record.meta.key);
                                _this.loadTemplates();
                                _this.$router.push('/' + _this.tenantKey + '/checklist-templates');

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        templateDetailsFieldChanged: function templateDetailsFieldChanged(changes) {},
        categoryClicked: function categoryClicked(category) {
            var categoryName = category.name;
        },
        addDocumentForCategory: function addDocumentForCategory(categoryName) {
            console.log('addDocumentForCategory', categoryName);
            this.addDocumentDialog.fields = this.addDocumentFields;
            this.addDocumentDialog.record = {};
            this.addDocumentDialog.settings.visible = true;
        },
        saveDocumentForCategory: function saveDocumentForCategory(document) {
            console.log('saveDocumentForCategory', document);
        },
        loadDetails: function loadDetails() {
            var _this2 = this;

            this.checklistTable.ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list');
            var ref = this.checklistTable.ref.child(this.checklistKey);

            __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (item) {
                if (item) _this2.templateDetails = item;else {
                    _this2.templateDetails = __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].makeRecord(_this2.checklistTable);
                    _this2.templateDetails.meta.key = _this2.checklistKey;
                    __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].saveItem(_this2.templateDetails);
                }
            });
        },
        loadTemplates: function loadTemplates() {
            var _this3 = this;

            var templatesRef = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list').orderByChild('template').equalTo(true);
            templatesRef.on('value', function (snap) {
                _this3.templates = __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].arrayFromSnapshot(snap).filter(function (o) {
                    return o.global == true || o.tenantKey == _this3.tenantKey && o.template;
                });
            });
        },
        loadTemplateData: function loadTemplateData() {
            this.loadDetails();
        }
    },

    watch: {
        'checklistKey': {
            handler: function handler(newVal, oldVal) {
                if (newVal) this.loadTemplateData();
            },
            immediate: true
        }

    },

    created: function created() {

        __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].initialiseTenant(this.tenantKey);
        this.loadTemplates();
    }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_TemplateHelpers__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ChecklistDetails__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ChecklistDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ChecklistDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChecklistHelpers__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_AdvancedList__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_AdvancedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ui_elements_AdvancedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_AdvancedPanel__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_AdvancedPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ui_elements_AdvancedPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_AdvancedDialog__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_AdvancedDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_AdvancedDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ui_elements_NoRecordsPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_Utilities__ = __webpack_require__(6);























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ClientChecklist',
    props: {
        checklistKey: String
    },

    components: {
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer___default.a,
        ChecklistDetails: __WEBPACK_IMPORTED_MODULE_11__ChecklistDetails___default.a,
        AdvancedList: __WEBPACK_IMPORTED_MODULE_15__ui_elements_AdvancedList___default.a,
        AdvancedPanel: __WEBPACK_IMPORTED_MODULE_16__ui_elements_AdvancedPanel___default.a,
        AdvancedDialog: __WEBPACK_IMPORTED_MODULE_17__ui_elements_AdvancedDialog___default.a,
        NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_18__ui_elements_NoRecordsPlaceholder___default.a
    },
    data: function data() {
        return {
            transactionDetails: {},
            checklistDetails: {},


            checklistTable: {
                ref: null,
                fields: [{ name: 'name', type: 'Text' }, { name: 'templates', type: 'List' }, { name: 'template', type: 'Switch' }, { name: 'global', type: 'Switch' }, { name: 'stamp', type: 'Text', default: '[stamp]' }, { name: 'tenantKey', type: 'Text', default: '[tenantKey]' }]
            },

            checklistDetailsPanel: {
                fields: [{ name: 'name', title: 'Template Name', type: 'Text' }, { name: 'advanced', title: 'Show Advanced Options', type: 'Switch', width: 70 }, { name: 'done', title: 'Done', type: 'Button', width: 30 }, { name: 'template', title: 'Template', type: 'Switch', visibleFilter: '[advanced] = true', disabled: true }, { name: 'global', title: 'Global', type: 'Switch', visibleFilter: '[template] = true && [advanced] = true' }, { name: 'makeCopy', title: 'Make a Copy', type: 'Button', visibleFilter: '[advanced] = true', width: 50 }, { name: 'deleteTemplate', title: 'Delete Template', type: 'Button', color: 'error', visibleFilter: '[advanced] = true', width: 50 }],
                settings: {}
            },

            addDocumentDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: []
            },

            addDocumentFields: [{ name: 'name', title: 'Name', type: 'Text', focus: true }, { name: 'checks', title: 'Things to Check', type: 'Group', fields: [{ name: 'check', title: 'Please Check', type: 'Text', width: 70 }] }]

        };
    },


    computed: {
        topRef: function topRef() {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist');
        },
        listRef: function listRef() {
            return this.topRef.child('list');
        },
        listItemRef: function listItemRef() {
            return this.listRef.child(this.checklistKey);
        },
        dataRef: function dataRef() {
            return this.topRef.child('data').child(this.checklistKey);
        },
        pageTitle: function pageTitle() {
            return this.transactionDetails.clients || 'Document Checklist';
        },
        pageSettings: function pageSettings() {
            return {
                flagOutstandings: this.checklistDetails.flagOutstandings
            };
        },
        tenantKey: function tenantKey() {
            return this.checklistDetails.tenantKey || null;
        },
        hasTransaction: function hasTransaction() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.transactionDetails).length > 0;
        }
    },
    methods: {
        notifyChangesMenuClicked: function notifyChangesMenuClicked() {
            this.sendEmailOfChanges();
        },
        selectTemplate: function selectTemplate(template) {
            this.goToTemplate(template.meta.key);
        },
        checklistDetailsButton: function checklistDetailsButton(buttonName, record) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var newKey, newDetails;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (buttonName == 'makeCopy') {
                                    newKey = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getKey();

                                    __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('categories'), _this.topRef.child('data').child(newKey).child('categories'));
                                    __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('policies'), _this.topRef.child('data').child(newKey).child('policies'));
                                    __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('options'), _this.topRef.child('data').child(newKey).child('options'));
                                    __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].copyItems(_this.dataRef.child('documents'), _this.topRef.child('data').child(newKey).child('documents'));

                                    newDetails = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.checklistDetails);

                                    newDetails.name += ' (copy)';
                                    newDetails.advanced = null;

                                    newDetails.meta.key = newKey;
                                    __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].saveItem(newDetails);
                                    _this.goToTemplate(newKey);
                                }

                                if (!(buttonName == 'deleteTemplate')) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 4;
                                return _this.$root.$confirm('Delete', 'Delete this template?', { color: 'red' });

                            case 4:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 9;
                                    break;
                                }

                                __WEBPACK_IMPORTED_MODULE_12__ChecklistHelpers__["a" /* default */].deleteChecklist(record.meta.key);
                                _this.loadTemplates();
                                _this.$router.push('/' + _this.tenantKey + '/checklist-templates');

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checklistDetailsFieldChanged: function checklistDetailsFieldChanged(changes) {},
        categoryClicked: function categoryClicked(category) {
            var categoryName = category.name;
        },
        addDocumentForCategory: function addDocumentForCategory(categoryName) {
            console.log('addDocumentForCategory', categoryName);
            this.addDocumentDialog.fields = this.addDocumentFields;
            this.addDocumentDialog.record = {};
            this.addDocumentDialog.settings.visible = true;
        },
        saveDocumentForCategory: function saveDocumentForCategory(document) {
            console.log('saveDocumentForCategory', document);
            this.sendEmailOfChanges();
        },
        documentChanged: function documentChanged(document) {
            this.sendEmailOfChanges();
        },
        sendEmailOfChanges: function sendEmailOfChanges() {
            var _this2 = this;

            console.log('Sending email of changes');

            __WEBPACK_IMPORTED_MODULE_19__helpers_Utilities__["a" /* default */].checkIfThisWasDone('checklist-notification-' + this.checklistKey).then(function (done) {
                if (done) {
                    console.log('skipping...already sent');
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_12__ChecklistHelpers__["a" /* default */].fetchChecklistTask(_this2.tenantKey, _this2.checklistKey).then(function (task) {

                    if (!task || !task.assigned || !task.assigned.email) {
                        console.log('Cant send email, nobody assigned');
                        return;
                    }
                    var recipient = task.assigned.email;
                    var greeting = task.assigned.firstName;

                    __WEBPACK_IMPORTED_MODULE_6__helpers_TemplateHelpers__["a" /* default */].fetchTemplate('global', 'Notify Checklist Updated').then(function (template) {

                        console.log('Template is ', template);

                        if (!template) {
                            __WEBPACK_IMPORTED_MODULE_9__helpers_AlertHelpers__["a" /* default */].showAlert('Template not found: Notify Checklist Updated');
                            return;
                        }

                        var linkToTaco = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].linkToTaco(_this2.checklistDetails.tenantKey + '/document-checklist/' + _this2.checklistKey, 'Go there now');

                        var customFields = {
                            greeting: greeting,
                            sender: _this2.$store.getters.user.firstName,
                            clients: _this2.transactionDetails.clients,
                            transaction_link: linkToTaco
                        };

                        var body = __WEBPACK_IMPORTED_MODULE_13__helpers_MergeHelpers__["a" /* default */].simpleMerge(template.body, customFields);

                        var email = {};
                        email.from = 'no-reply@insightprocessing.com.au';
                        email.fromName = 'Taco System Alert';
                        email.to = recipient;
                        email.subject = template.subject || '';
                        email.body = body;
                        __WEBPACK_IMPORTED_MODULE_14__helpers_EmailHelpers__["a" /* default */].sendEmail(email);
                        console.log('Email Sent');
                    });
                });
            });
        },
        loadDetails: function loadDetails() {
            var _this3 = this;

            this.checklistTable.ref = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list');
            var ref = this.checklistTable.ref.child(this.checklistKey);

            __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (item) {
                if (!item) {
                    __WEBPACK_IMPORTED_MODULE_9__helpers_AlertHelpers__["a" /* default */].showAlert('Checklist not found');
                    return;
                }
                _this3.checklistDetails = item;

                var transactionRef = __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(_this3.tenantKey).child('transactions').child(_this3.checklistKey).child('details');

                __WEBPACK_IMPORTED_MODULE_10__data_NiceData__["a" /* default */].fetchItemSingle(transactionRef).then(function (transactionDetails) {
                    if (transactionDetails) _this3.transactionDetails = transactionDetails;
                });
            });
        }
    },

    beforeDestroy: function beforeDestroy() {},


    watch: {
        'checklistKey': {
            handler: function handler(newVal, oldVal) {
                if (newVal) this.loadDetails();
            },
            immediate: true
        }
    },

    created: function created() {
        document.title = 'Document Checklist';
    }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_Scheduler__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_Scheduler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ui_elements_Scheduler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_TransactionComments__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_TransactionComments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_TransactionComments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ui_elements_EmailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ChecklistMenu__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ChecklistMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ChecklistMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ChecklistItems__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ChecklistItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__ChecklistItems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ChecklistDetails__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ChecklistDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ChecklistDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_elements_AdvancedList__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_elements_AdvancedList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ui_elements_AdvancedList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_elements_AdvancedPanel__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_elements_AdvancedPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ui_elements_AdvancedPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_elements_AdvancedDialog__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_elements_AdvancedDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ui_elements_AdvancedDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_ContactCard__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_ContactCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ui_elements_ContactCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_elements_LinkNewTab__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ui_elements_LinkNewTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ui_elements_LinkNewTab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers_PageHelpers__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ChecklistHelpers__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_jszip__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_file_saver__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_date_fns_fp__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__helpers_DateHelpers__ = __webpack_require__(11);
















































/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DocumentChecklist',
    props: {
        tenantKey: String,
        transactionKey: String,
        checklistKey: String
    },

    components: {
        LayoutContainer: __WEBPACK_IMPORTED_MODULE_4__ui_elements_LayoutContainer___default.a,

        Scheduler: __WEBPACK_IMPORTED_MODULE_15__ui_elements_Scheduler___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_16__ui_elements_UserChooser___default.a,
        EmailDialog: __WEBPACK_IMPORTED_MODULE_20__ui_elements_EmailDialog___default.a,
        TransactionComments: __WEBPACK_IMPORTED_MODULE_17__ui_elements_TransactionComments___default.a,
        ChecklistMenu: __WEBPACK_IMPORTED_MODULE_21__ChecklistMenu___default.a,
        ChecklistItems: __WEBPACK_IMPORTED_MODULE_23__ChecklistItems___default.a,
        ChecklistDetails: __WEBPACK_IMPORTED_MODULE_24__ChecklistDetails___default.a,
        AdvancedList: __WEBPACK_IMPORTED_MODULE_25__ui_elements_AdvancedList___default.a,
        AdvancedPanel: __WEBPACK_IMPORTED_MODULE_26__ui_elements_AdvancedPanel___default.a,
        AdvancedDialog: __WEBPACK_IMPORTED_MODULE_27__ui_elements_AdvancedDialog___default.a,
        ContactCard: __WEBPACK_IMPORTED_MODULE_29__ui_elements_ContactCard___default.a,
        LinkNewTab: __WEBPACK_IMPORTED_MODULE_30__ui_elements_LinkNewTab___default.a,
        NoRecordsPlaceholder: __WEBPACK_IMPORTED_MODULE_31__ui_elements_NoRecordsPlaceholder___default.a
    },
    data: function data() {
        return {
            detailsVisible: false,
            leftColumnTabs: null,

            menu: { categories: {} },

            checklistDetails: {},
            checklistDetailsMode: 'Consultant',

            dialogTab: 0,
            followUpTask: {
                code: 'document-checklist',
                title: 'Follow up document checklist',
                due: null,
                assigned: null,
                transactionKey: this.transactionKey
            },

            transactionFields: [],

            search: '',
            selectedItems: [],
            activeItem: '',
            lender: 'General',
            newCheckItem: '',
            liveTransaction: {
                details: {}
            },

            dialogVisible: false,
            dialogDateMenu: false,
            documentKey: '',

            documentName: '',
            documentDescription: '',
            documentDownload: '',
            documentImportance: 0,
            documentInstructions: '',
            documentReceived: false,
            documentChecked: false,
            documentChecklist: [],
            documentDate: null,
            documentExpiryDays: null,
            documentFlag: '',
            documentNote: '',

            emailDialog: {
                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: ''
                },
                settings: {
                    visible: false,
                    customFields: {
                        checklist: null
                    }
                },
                returnObject: null
            },

            newActivity: null,

            checklistTable: {
                ref: null,
                fields: [{ name: 'name', type: 'Text' }, { name: 'templates', type: 'List' }, { name: 'template', type: 'Switch' }, { name: 'global', type: 'Switch' }, { name: 'stamp', type: 'Text', default: '[stamp]' }, { name: 'tenantKey', type: 'Text', default: '[tenantKey]' }]
            },

            checklistDetailsPanel: {
                fields: [{ name: 'templates', title: 'Templates', type: 'List', multiple: true, returnObject: true, options: [] }, { name: 'flagOutstandings', title: 'Flag Outstanding Docs', type: 'Switch' }],
                settings: {}
            },

            addDocumentDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: []
            },

            addDocumentFields: [{ name: 'name', title: 'Name', type: 'Text', focus: true }, { name: 'checks', title: 'Things to Check', type: 'Group', fields: [{ name: 'check', title: 'Please Check', type: 'Text', width: 70 }] }]

        };
    },

    watch: {
        selectedItems: function selectedItems() {
            this.updateProgress();
        }
    },
    computed: {
        checklistSummary: function checklistSummary() {
            return __WEBPACK_IMPORTED_MODULE_32__helpers_PageHelpers__["a" /* default */].getPageData('summary') || {};
        },
        clientUrl: function clientUrl() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].rootPath() + 'client-checklist/' + this.checklistKey;
        },
        clientLink: function clientLink() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].linkToTaco('client-checklist/' + this.checklistKey, 'Go to Checklist');
        },
        pageSettings: function pageSettings() {
            return {
                flagOutstandings: this.checklistDetails.flagOutstandings
            };
        },
        pageTitle: function pageTitle() {
            if (this.clients) return __WEBPACK_IMPORTED_MODULE_10__helpers_ContactHelpers__["a" /* default */].combineClientsNames(this.clients);

            return 'Document Checklist';
        },
        topRef: function topRef() {
            return __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist');
        },
        listRef: function listRef() {
            return this.topRef.child('list').child(this.checklistKey);
        },
        dataRef: function dataRef() {
            return this.topRef.child('data').child(this.checklistKey);
        },
        clients: function clients() {
            if (this.liveTransaction.clients && this.liveTransaction.clients.length) return this.liveTransaction.clients;

            if (this.checklistDetails.name) return __WEBPACK_IMPORTED_MODULE_10__helpers_ContactHelpers__["a" /* default */].namesToContacts(this.checklistDetails.name);

            return [];
        },
        recipients: function recipients() {
            return this.clients.filter(function (o) {
                return o.email;
            }).map(function (o) {
                var recipient = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, o);
                recipient.role = 'Client';
                recipient.fullName = __WEBPACK_IMPORTED_MODULE_10__helpers_ContactHelpers__["a" /* default */].fullName(recipient);
                recipient.fullNameAndEmail = __WEBPACK_IMPORTED_MODULE_10__helpers_ContactHelpers__["a" /* default */].fullName(recipient) + '(' + recipient.email + ')';
                return recipient;
            });
        },
        checklistRef: function checklistRef() {
            if (this.transactionKey) return __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getTenantRef().child('transactions').child(this.transactionKey).child('checklist');else return null;
        },


        documentDateString: function documentDateString() {
            if (this.documentDate) {
                console.log('calcing date');
                return format(DateHelpers.backwardsToDate(this.documentDate), DateFormats.AUSTRALIAN);
            } else return '';
        },

        selectedPolicies: function selectedPolicies() {
            return this.$store.getters.getSelectedKeys('checklist-policies');
        },
        isMobile: function isMobile() {
            return __WEBPACK_IMPORTED_MODULE_18__helpers_Utilities__["a" /* default */].isMobile();
        }
    },
    methods: {
        downloadAllFiles: function downloadAllFiles() {
            var _this = this;

            var ref = this.dataRef.child('documents');
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (documents) {
                var attachments = [];
                var documentsWithAttachments = documents.filter(function (d) {
                    return d.attachment;
                });

                var allPromises = [];
                documentsWithAttachments.forEach(function (document) {
                    var p = __WEBPACK_IMPORTED_MODULE_34__ChecklistHelpers__["a" /* default */].fetchPolicyForDocument(document).then(function (policy) {
                        document.category = policy.category;
                    });
                    allPromises.push(p);
                });
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(allPromises).then(function (result) {
                    documentsWithAttachments.forEach(function (document) {
                        document.attachment.forEach(function (file) {
                            attachments.push({
                                url: file.url,
                                category: document.category
                            });
                        });
                    });
                    console.log(attachments);
                    _this.saveToZip('checklist_documents.zip', attachments);
                });
            });
        },
        saveToZip: function saveToZip(filename, attachments) {

            __WEBPACK_IMPORTED_MODULE_14__helpers_AlertHelpers__["a" /* default */].showAlert('Downloading...See below');
            var zip = new __WEBPACK_IMPORTED_MODULE_36_jszip___default.a();

            attachments.forEach(function (attachment) {
                var blobPromise = fetch(attachment.url).then(function (r) {
                    if (r.status === 200) return r.blob();
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(r.statusText));
                });
                var folder = zip.folder(attachment.category);
                var name = __WEBPACK_IMPORTED_MODULE_35__helpers_FileHelpers__["a" /* default */].fileNameFromStoragePath(attachment.url);
                folder.file(name, blobPromise);
            });

            zip.generateAsync({ type: "blob" }).then(function (blob) {
                __WEBPACK_IMPORTED_MODULE_37_file_saver___default()(blob, filename);
            }).catch(function (e) {
                return console.log(e);
            });
        },
        isSelected: function isSelected(policyName) {
            return Boolean(this.selectedPolicies.find(function (p) {
                return p == policyName;
            }));
        },
        checklistDetailsFieldChanged: function checklistDetailsFieldChanged(changes) {
            if (changes.name == 'templates') this.loadMenu();
        },
        categoryClicked: function categoryClicked(category) {},
        addDocumentForCategory: function addDocumentForCategory(category) {
            console.log('addDocumentForCategory', category);
            this.addDocumentDialog.fields = this.addDocumentFields;
            this.addDocumentDialog.record = {
                categoryName: category.name,
                categoryOrder: category.order,
                categoryKey: category.meta.key
            };
            this.addDocumentDialog.settings.title = 'Add ' + category.name + ' document';
            this.addDocumentDialog.settings.visible = true;
        },
        saveDocumentForCategory: function saveDocumentForCategory(documentDetails) {
            var _this2 = this;

            console.log('saveDocumentForCategory', documentDetails);

            var ref = this.dataRef.child('categories');
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemByName(ref, documentDetails.categoryName).then(function (category) {
                if (!category) {
                    category = {
                        meta: {
                            key: documentDetails.categoryKey,
                            path: __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].firebaseRefToPath(_this2.dataRef + '/categories')
                        },
                        name: documentDetails.categoryName,
                        order: documentDetails.categoryOrder
                    };
                }
                __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(category);
            });

            var policy = {
                meta: {
                    key: __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].firebaseRefToPath(this.dataRef + '/policies')
                },
                name: documentDetails.name,
                category: documentDetails.categoryName
            };
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(policy);

            var option = {
                meta: {
                    key: __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].firebaseRefToPath(this.dataRef + '/options')
                },
                name: documentDetails.name,
                policyKey: policy.meta.key,
                preferred: true
            };
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(option);

            var document = {
                meta: {
                    key: __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].firebaseRefToPath(this.dataRef + '/documents')
                },
                name: documentDetails.name,
                optionKey: option.meta.key,
                checks: documentDetails.checks || null
            };
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(document);
        },
        checklistMenuClicked: function checklistMenuClicked(policy) {
            var _this3 = this;

            var ref = this.dataRef.child('policies');
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemByName(ref, policy.name).then(function (localPolicy) {
                if (localPolicy) {
                    if (!localPolicy.modified) __WEBPACK_IMPORTED_MODULE_34__ChecklistHelpers__["a" /* default */].deletePolicyCascade(localPolicy);else {
                        _this3.$root.$confirm('Delete', 'Are you sure you want to delete this policy?', { color: 'red' }).then(function (res) {
                            if (res) __WEBPACK_IMPORTED_MODULE_34__ChecklistHelpers__["a" /* default */].deletePolicyCascade(localPolicy);
                        });
                    }
                    return;
                }
                _this3.importPolicy(policy);
            });
        },
        importPolicy: function importPolicy(policy) {
            this.detailsVisible = false;

            var checklistTopPath = __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].firebaseRefToPath(this.dataRef);
            var templateKey = policy.meta.path.split('/')[3];
            var templateTopRef = this.topRef.child('data').child(templateKey);

            console.log('**** policy path is ', policy.meta.path);

            var newPolicy = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(policy));
            newPolicy.meta.path = checklistTopPath + '/policies';

            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(newPolicy);

            var categorySourceRef = templateTopRef.child('categories').orderByChild('name').equalTo(policy.category);
            var existingCategoryRef = this.dataRef.child('categories').orderByChild('name').equalTo(policy.category);
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(existingCategoryRef).then(function (categories) {
                if (categories.length < 1) {
                    __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(categorySourceRef).then(function (categories) {
                        if (categories.length < 1) {
                            console.error('no categories');
                            debugger;
                        } else {
                            var newCategory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, categories[0]);
                            newCategory.meta.path = checklistTopPath + '/categories';
                            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(newCategory);
                        }
                    });
                } else {
                    var newCategory = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, categories[0]);
                    newCategory.meta.path = checklistTopPath + '/categories';
                    __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(newCategory);
                }
            });

            var optionSourceRef = templateTopRef.child('options').orderByChild('policyKey').equalTo(policy.meta.key);
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(optionSourceRef).then(function (options) {
                options.forEach(function (option) {
                    var newOption = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, option);
                    newOption.meta.path = checklistTopPath + '/options';
                    __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(newOption);

                    var documentSourceRef = templateTopRef.child('documents').orderByChild('optionKey').equalTo(option.meta.key);
                    __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(documentSourceRef).then(function (documents) {
                        documents.forEach(function (document) {
                            var newDocument = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, document);
                            newDocument.meta.path = checklistTopPath + '/documents';
                            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(newDocument);
                        });
                    });
                });
            });
        },
        goToTransaction: function goToTransaction() {
            this.$router.push('/' + this.tenantKey + '/transaction/' + this.checklistKey);
        },
        goToTemplates: function goToTemplates() {
            this.$router.push('/' + this.tenantKey + '/checklist-templates');
        },
        goToOldChecklist: function goToOldChecklist() {
            this.$router.push('/' + this.tenantKey + '/supplier-checklist/' + this.checklistKey);
        },
        stamp: function stamp(activity) {
            var stampString = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].formatStamp(activity.stamp);
            return stampString;
        },
        showEmail: function showEmail() {
            __WEBPACK_IMPORTED_MODULE_18__helpers_Utilities__["a" /* default */].log('showEmail');

            this.emailDialog.email.to = this.recipients;
            this.emailDialog.settings.group = 'Checklist';
            this.emailDialog.settings.template = 'Followup';
            this.emailDialog.returnObject = null;

            var html = this.$refs.checklistHidden.$refs.checklist.innerHTML;
            this.emailDialog.settings.customFields.checklist = html;
            this.emailDialog.settings.customFields.client_link = this.clientLink;

            this.emailDialog.settings.visible = true;
        },
        documentExpired: function documentExpired(doc) {

            if (!doc.expiryDays) doc.expiryDays = 30;

            var expiryDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39_date_fns_fp__["c" /* addDays */])(DateHelpers.backwardsToDate(doc.documentDate), doc.expiryDays);

            var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_39_date_fns_fp__["c" /* addDays */])(new Date(), expiryDate);

            if (days < 7) {
                if (days > 0) return 'Expires ' + days + 'd';else if (days == 0) return 'Expired Today';else return 'Expired ' + Math.abs(days) + 'd ago';
            } else return '';
        },
        getTransactionRef: function getTransactionRef() {
            return this.getTenantRef().child('transactions/' + this.checklistKey);
        },
        copyToClipboard: function copyToClipboard() {

            var html = this.$refs.checklist.innerHTML;

            __WEBPACK_IMPORTED_MODULE_8_clipboard_js___default.a.copy({ 'text/html': html });

            __WEBPACK_IMPORTED_MODULE_14__helpers_AlertHelpers__["a" /* default */].showAlert('Copied to clipboard');
        },
        saveFollowupTask: function saveFollowupTask() {
            console.log('saveFollowupTask', this.followUpTask);
            this.$store.dispatch('saveTask', this.followUpTask);
        },
        setSpecialTab: function setSpecialTab(name) {
            var tab = {
                key: name,
                title: __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(name),
                name: name,
                type: 'Tab'
            };
            this.$store.commit('setSelectedTab', tab);
        },
        loadDetails: function loadDetails() {
            var _this4 = this;

            var vm = this;
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                vm.ref = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list');

                var ref = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list').child(_this4.checklistKey);
                __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (item) {
                    if (item) _this4.checklistDetails = item;else {
                        _this4.checklistTable.ref = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list');
                        _this4.checklistDetails = __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].makeRecord(_this4.checklistTable);
                        _this4.checklistDetails.meta.key = _this4.checklistKey;
                        __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].saveItem(_this4.checklistDetails);
                    }
                    resolve(item);
                });
            });
        },
        loadMenu: function loadMenu() {
            var _this5 = this;

            if (!this.checklistDetails || !this.checklistDetails.templates) return;
            this.menu = {};

            var templates = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.checklistDetails.templates)).sort(__WEBPACK_IMPORTED_MODULE_28__helpers_OrderHelpers__["a" /* default */].sortByOrder);
            templates.reverse();
            templates.forEach(function (template) {

                var ref = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/data/' + template.value);
                __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref.child('categories')).then(function (categories) {

                    categories.forEach(function (category) {
                        _this5.$set(_this5.menu, 'categories', _this5.menu.categories || {});
                        _this5.$set(_this5.menu.categories, category.name, _this5.menu[category.name] || { policies: {}, category: category });
                    });
                    __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref.child('policies')).then(function (policies) {
                        policies.forEach(function (policy) {
                            policy.templateName = template.text;
                            if (_this5.menu.categories[policy.category]) _this5.$set(_this5.menu.categories[policy.category].policies, policy.name, policy);
                        });
                    });
                });
            });
        },
        loadTemplateOptions: function loadTemplateOptions() {
            var _this6 = this;

            var templatesRef = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getRootRef().child('app/documentChecklist/list').orderByChild('template').equalTo(true);
            __WEBPACK_IMPORTED_MODULE_22__data_NiceData__["a" /* default */].fetchItemsFromFirebase(templatesRef).then(function (templates) {
                var templateOptions = templates.filter(function (o) {
                    return o.tenantKey == _this6.tenantKey || o.global;
                }).map(function (o) {
                    return { value: o.meta.key, text: o.name, order: o.order };
                });
                __WEBPACK_IMPORTED_MODULE_33__helpers_ArrayHelpers__["a" /* default */].findByName(_this6.checklistDetailsPanel.fields, 'templates').options = templateOptions;
            });
        },
        logOpenedDate: function logOpenedDate() {
            this.clients.forEach(function (client) {
                __WEBPACK_IMPORTED_MODULE_10__helpers_ContactHelpers__["a" /* default */].updateOpenedDate(client);
            });
        }
    },
    created: function created() {
        var _this7 = this;

        __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].initialiseTenant(this.tenantKey);
        if (!this.checklistKey) {
            var key = __WEBPACK_IMPORTED_MODULE_13__helpers_DataHelpers__["a" /* default */].getKey();
            this.$router.push('/' + this.tenantKey + '/document-checklist/' + key);
        }

        this.loadDetails().then(function (checklist) {
            _this7.loadMenu();
        });

        this.loadTemplateOptions();

        console.log('document-checklist > created');
        var vm = this;

        this.liveTransaction = {
            details: {},
            clients: []
        };

        this.setSpecialTab('checklist');

        this.$store.dispatch('loadTransaction', this.checklistKey).then(function (transaction) {
            if (!transaction) {
                __WEBPACK_IMPORTED_MODULE_14__helpers_AlertHelpers__["a" /* default */].showAlert('Checklist is not linked to a transaction');
                return;
            }

            __WEBPACK_IMPORTED_MODULE_18__helpers_Utilities__["a" /* default */].log('Workflow > initialise - Calling load transaction', transaction);
            vm.liveTransaction.details = transaction;

            _this7.$store.dispatch('fetchElementsByType', 'Contact').then(function (contactElements) {

                console.log('celements', contactElements);
                var contacts = __WEBPACK_IMPORTED_MODULE_11__helpers_ElementHelpers__["a" /* default */].contactElementsForRole('Client', contactElements).map(function (o) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                        key: o.contactKey,
                        tenantKey: o.tenantKey
                    }, o.contact);
                });

                if (contacts && contacts.length) _this7.liveTransaction.clients = contacts;

                _this7.logOpenedDate();
            });

            __WEBPACK_IMPORTED_MODULE_34__ChecklistHelpers__["a" /* default */].fetchChecklistTask(_this7.tenantKey, _this7.checklistKey).then(function (task) {
                _this7.followUpTask = task;
            });


            setTimeout(function () {

                if (!vm.clients.length) __WEBPACK_IMPORTED_MODULE_14__helpers_AlertHelpers__["a" /* default */].showAlert("Old file: Please go into transaction, then add clients as contacts manually");
            }, 4000);
        }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_18__helpers_Utilities__["a" /* default */].log('Created > Error in loadTransaction ', err);
            debugger;
            __WEBPACK_IMPORTED_MODULE_14__helpers_AlertHelpers__["a" /* default */].showAlert('Error loading transaction');
        });
    }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_TransactionComments__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_TransactionComments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_TransactionComments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_EmailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SupplierDocumentDialog__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SupplierDocumentDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__SupplierDocumentDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns__ = __webpack_require__(17);























var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database();
var lendersRef = db.ref('app/lenders');
var categoriesRef = db.ref('app/documents/categories');
var requirementsRef = db.ref('app/documents/requirements');
var requestsRef = db.ref('app/documents/requests/General');
var generalRequestsRef = db.ref('app/documents/requests/General');



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SupplierChecklist',
    props: {
        tenantKey: String,
        transactionKey: String
    },

    components: {
        SupplierDocumentDialog: __WEBPACK_IMPORTED_MODULE_18__SupplierDocumentDialog___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_5__ui_elements_DeleteButton___default.a,
        Scheduler: __WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser___default.a,
        EmailDialog: __WEBPACK_IMPORTED_MODULE_17__ui_elements_EmailDialog___default.a,
        TransactionComments: __WEBPACK_IMPORTED_MODULE_14__ui_elements_TransactionComments___default.a
    },
    data: function data() {
        return {
            supplierDocumentDialog: {
                settings: {
                    visible: false
                },
                document: {}
            },
            dialogTab: 0,
            followUpTask: {
                code: 'document-checklist',
                title: 'Follow up document checklist',
                due: null,
                assigned: null,
                transactionKey: this.transactionKey
            },
            transactionFields: [],

            snackbar: '',
            snackbarshow: false,
            search: '',
            selectedItems: [],
            activeItem: '',
            lender: 'General',
            newCheckItem: '',
            liveTransaction: {
                details: {}
            },

            dialogVisible: false,
            dialogDateMenu: false,
            documentKey: '',

            documentName: '',
            documentDescription: '',
            documentDownload: '',
            documentImportance: 0,
            documentInstructions: '',
            documentReceived: false,
            documentChecked: false,
            documentChecklist: [],
            documentDate: null,
            documentExpiryDays: null,
            documentFlag: '',
            documentNote: '',

            emailDialog: {
                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: ''
                },
                settings: {
                    visible: false,
                    customFields: {
                        checklist: null
                    }
                },
                returnObject: null
            },

            newActivity: null

        };
    },


    firebase: {
        lenders: lendersRef,
        categories: categoriesRef,
        requirements: requirementsRef,
        requests: requestsRef,
        generalRequests: generalRequestsRef
    },
    watch: {
        selectedItems: function selectedItems() {
            this.updateProgress();
        }
    },
    computed: {
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        },
        clients: function clients() {
            if (this.liveTransaction.clients.length) return this.liveTransaction.clients;else return [];
        },
        recipients: function recipients() {
            return this.clients.filter(function (o) {
                return o.email;
            }).map(function (o) {
                var recipient = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, o);
                recipient.role = 'Client';
                recipient.fullName = __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__["a" /* default */].fullName(recipient);
                return recipient;
            });
        },
        client1: function client1() {
            if (this.clients.length) return this.clients[0].firstName.toUpperCase();else return 'CLIENT 1';
        },
        client2: function client2() {
            if (this.clients.length > 1) return this.clients[1].firstName.toUpperCase();else return 'CLIENT 2';
        },
        selectedItemsSorted: function selectedItemsSorted() {
            var result = this.selectedItems.filter(function (o) {
                return o.type == 'd';
            });
            result = result.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return result;
        },
        selectedCommentsSorted: function selectedCommentsSorted() {
            var result = this.selectedItems.filter(function (o) {
                return o.type == 'c';
            });

            result = result.sort(function (a, b) {
                return (a['.key'] < b['.key']) - (a['.key'] > b['.key']);
            });
            return result;
        },
        activityRef: function activityRef() {
            return this.getTransactionRef().child('activities').orderByChild('type').equalTo('d');
        },


        documentDateString: function documentDateString() {
            if (this.documentDate) {
                console.log('calcing date');

                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_date_fns__["a" /* format */])(DateHelpers.backwardsToDate(this.documentDate), __WEBPACK_IMPORTED_MODULE_19__helpers_DateHelpers__["b" /* dateFormats */].AUSTRALIAN);
            } else return '';
        },
        couple: function couple() {
            return this.clients.length > 1;
        },
        flagOptions: function flagOptions() {
            var arr = [];

            arr.push({ text: 'LATER', value: 'LATER' });

            if (this.liveTransaction.clients.length > 1) {
                var firstName = this.liveTransaction.clients[0].firstName;
                arr.push({ text: firstName, value: firstName });
                firstName = this.liveTransaction.clients[1].firstName;
                arr.push({ text: firstName, value: firstName });
                arr.push({ text: 'BOTH', value: 'BOTH' });
            }

            return arr;
        }
    },
    methods: {
        goToTransaction: function goToTransaction() {
            this.$router.push('/' + this.tenantKey + '/transaction/' + this.transactionKey);
        },
        stamp: function stamp(activity) {
            var stampString = __WEBPACK_IMPORTED_MODULE_10__helpers_DataHelpers__["a" /* default */].formatStamp(activity.stamp);
            return stampString;
        },
        showEmail: function showEmail() {
            __WEBPACK_IMPORTED_MODULE_15__helpers_Utilities__["a" /* default */].log('showEmail');
            this.emailDialog.email.to = this.recipients;
            this.emailDialog.settings.group = 'Checklist';
            this.emailDialog.settings.template = 'Followup';
            this.emailDialog.returnObject = null;
            this.emailDialog.settings.customFields.checklist = this.$refs.checklist.innerHTML;

            this.emailDialog.settings.visible = true;
        },
        updateProgress: function updateProgress() {

            return;
        },
        emailsFromClients: function emailsFromClients(clients) {
            if (!clients || clients.length == 0) return '';
            if (clients.length == 1) return clients[0].email || '';

            return (clients[0].email || '') + (clients[0].email && clients[1].email ? ',' : '') + (clients[1].email || '');
        },
        documentExpired: function documentExpired(doc) {

            if (!doc.expiryDays) doc.expiryDays = 30;

            var expiryDate = addDays(DateHelpers.backwardsToDate(doc.documentDate), doc.expiryDays);

            var days = addDays(new Date(), expiryDate);

            if (days < 7) {
                if (days > 0) return 'Expires ' + days + 'd';else if (days == 0) return 'Expired Today';else return 'Expired ' + Math.abs(days) + 'd ago';
            } else return '';
        },
        getActivityRef: function getActivityRef() {
            return this.getTransactionRef().child('activities');
        },
        getTenantRef: function getTenantRef() {
            return db.ref('tenants').child(this.$store.getters.tenantKey);
        },
        getTransactionRef: function getTransactionRef() {
            return this.getTenantRef().child('transactions/' + this.transactionKey);
        },
        listItemClicked: function listItemClicked(item) {
            this.showDialog(item);
        },
        itemClicked: function itemClicked(item) {
            if (!this.collectionContainsKey(this.selectedItems, item['.key'])) {

                var singleItem = this.getSingleItemForLender(this.lender, item['.key']);

                if (!singleItem) singleItem = this.getSingleItemForLender('General', item['.key']);
                if (singleItem) {

                    singleItem.importance = item.category.importance + item.importance;

                    this.insertToList(singleItem);
                }
            } else {
                if (this.transactionKey) {
                    this.getActivityRef().child(item['.key']).remove();
                }

                this.selectedItems = this.selectedItems.filter(function (e) {
                    return e['.key'] != item['.key'];
                });
            }

            this.quickHilight(item);
            this.search = "";
        },
        insertToList: function insertToList(item) {

            this.selectedItems.push(item);

            item.type = 'd';

            if (this.transactionKey) {
                var ref = this.getActivityRef();
                ref.child(item['.key']).update(__WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(item));
            }
        },
        getSingleItemForLender: function getSingleItemForLender(lender, key) {
            var ref = db.ref('app/documents/requests/').child(lender).orderByChild('requirementKey').equalTo(key);

            var singleItem = void 0;
            ref.on('value', function (snap) {
                var results = __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                if (!results.length) return null;
                results.sort(function (a, b) {
                    return b.importance - a.importance;
                });

                singleItem = results[0];
                singleItem['.key'] = key;
            });
            return singleItem;
        },
        collectionContainsKey: function collectionContainsKey(col, key) {
            return col.filter(function (e) {
                return e['.key'] == key;
            }).length > 0;
        },
        setLender: function setLender(name) {
            this.lender = name;
            var requestsRef = db.ref('app/documents/requests').child(name);
            this.$bindAsArray('requests', requestsRef);
        },
        showDialog: function showDialog(model, category) {
            if (model) {
                this.documentKey = model['.key'];
                this.documentName = model.name || null;
                this.documentDescription = model.description || null;
                this.documentDownload = model.download || null;
                this.documentImportance = model.importance || null;
                this.documentInstructions = model.instructions || null;
                this.documentReceived = model.received || null;
                this.documentChecked = model.checked || null;
                this.documentChecklist = model.checklist || null;
                this.documentRequirementName = model.requirementName || null;
                this.documentDate = model.documentDate || null;
                this.documentExpiryDays = model.expiryDays || null;
                this.documentFlag = model.flag || null, this.documentNote = model.note || null;
            } else {
                    this.documentImportance = category.importance;
                    this.documentRequirementName = category.name;
                }

            this.dialogVisible = true;
        },
        showSupplierDocumentDialog: function showSupplierDocumentDialog(document) {
            this.supplierDocumentDialog.document = document;
            this.supplierDocumentDialog.settings.visible = true;
        },
        dialogClose: function dialogClose() {
            this.dialogVisible = false;
            var vm = this;
            setTimeout(function () {

                vm.documentKey = '', vm.documentName = '', vm.documentDescription = '', vm.documentImportance = 0, vm.documentDownload = '', vm.documentInstructions = '', vm.documentChecklist = [], vm.documentReceived = false, vm.documentChecked = false, vm.documentRequirementName = '', vm.documentDate = null, vm.documentExpiryDays = null, vm.documentFlag = '', vm.documentNote = '', vm.dialogTab = '0';
            }, 300);
        },
        dialogCancel: function dialogCancel() {
            this.dialogClose();
        },
        dialogSave: function dialogSave() {
            this.addOrUpdateItem();
            this.dialogClose();
        },
        deleteRequirement: function deleteRequirement(key) {
            this.selectedItems = this.selectedItems.filter(function (o) {
                return o['.key'] != key;
            });

            this.dialogClose();

            this.getActivityRef().child(key).remove();
        },
        requirementsForCategory: function requirementsForCategory(category) {
            var result = this.requirements.filter(function (req) {
                return req.category.name == category;
            });
            if (this.search) {
                var regex = new RegExp(this.search, 'i');
                result = result.filter(function (req) {
                    return req.name.match(regex);
                });
            }
            result = result.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return result;
        },
        requestsForRequirement: function requestsForRequirement(type) {
            var requests = this.requests.filter(function (req) {
                return req.requirementKey == type;
            });
            requests = requests.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return requests;
        },
        generalRequestsForRequirement: function generalRequestsForRequirement(type) {
            var requests = this.generalRequests.filter(function (req) {
                return req.requirementKey == type;
            });
            requests = requests.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return requests;
        },
        addOrUpdateItem: function addOrUpdateItem() {

            var model = {
                name: this.documentName,
                description: this.documentDescription,
                download: this.documentDownload,
                importance: this.documentImportance,
                instructions: this.documentInstructions,
                received: this.documentReceived || null,
                checked: this.documentChecked || null,
                checklist: this.documentChecklist || null,
                documentDate: this.documentDate || null,
                expiryDays: this.documentExpiryDays || null,
                requirementName: this.documentRequirementName,
                flag: this.documentFlag,
                note: this.documentNote,

                type: 'd'
            };

            if (this.documentKey) {
                var newArr = [];
                newArr.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, model, { '.key': this.documentKey }));
                this.selectedItems = this.selectedItems.map(function (obj) {
                    return newArr.find(function (o) {
                        return o['.key'] === obj['.key'];
                    }) || obj;
                });
                this.quickHilight({ '.key': this.documentKey });

                if (this.transactionKey) this.getActivityRef().child(this.documentKey).update(model);
            } else {
                var key = db.ref().push().key;

                this.selectedItems.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, model, { '.key': key }));
                this.quickHilight({ '.key': key });

                if (this.transactionKey) this.getActivityRef().child(key).set(model);
            }
        },
        addCheckItem: function addCheckItem() {
            if (!this.documentChecklist) this.documentChecklist = [];

            this.documentChecklist.push({
                text: this.newCheckItem
            });
            this.newCheckItem = '';
        },
        copyToClipboard: function copyToClipboard() {

            var html = this.$refs.checklist.innerHTML;

            __WEBPACK_IMPORTED_MODULE_4_clipboard_js___default.a.copy({ 'text/html': html });
            this.snackbar = 'Copied to Clipboard';

            this.snackbarshow = true;
        },
        quickHilight: function quickHilight(item) {
            var vm = this;
            vm.activeItem = item['.key'];
            clearTimeout(window.timer);
            window.timer = setTimeout(function () {
                vm.activeItem = '';
            }, 1000);
        },
        saveFollowupTask: function saveFollowupTask() {
            console.log('saveFollowupTask', this.followUpTask);
            this.$store.dispatch('saveTask', this.followUpTask);
        },
        setSpecialTab: function setSpecialTab(name) {
            var tab = {
                key: name,
                title: __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(name),
                name: name,
                type: 'Tab'
            };
            this.$store.commit('setSelectedTab', tab);
        }
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_10__helpers_DataHelpers__["a" /* default */].initialiseTenant(this.tenantKey);

        console.log('supplier-checklist > created');
        var vm = this;

        this.liveTransaction = {
            details: {},
            people: [],
            clients: []
        };

        if (!this.transactionKey) return;

        var fupRef = __WEBPACK_IMPORTED_MODULE_10__helpers_DataHelpers__["a" /* default */].getTenantRef().child('tasks').orderByChild('transactionKey').equalTo(this.transactionKey);
        __WEBPACK_IMPORTED_MODULE_16__data_FireData__["a" /* default */].fetchItems(fupRef).then(function (tasks) {
            var fupTask = tasks.find(function (o) {
                return o.code == 'document-checklist';
            });
            if (fupTask) _this.followUpTask = fupTask;
        });

        this.setSpecialTab('checklist');

        this.$store.dispatch('loadTransaction', this.transactionKey).then(function (transaction) {

            __WEBPACK_IMPORTED_MODULE_15__helpers_Utilities__["a" /* default */].log('Workflow > initialise - Calling load transaction', transaction);

            _this.$store.dispatch('fetchElementsByType', 'Contact').then(function (contactElements) {

                console.log('celements', contactElements);
                var contacts = __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__["a" /* default */].contactElementsForRole('Client', contactElements).map(function (o) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                        key: o.contactKey
                    }, o.contact);
                });

                if (contacts && contacts.length) _this.liveTransaction.clients = contacts;
            });

            vm.liveTransaction.details = transaction;

            setTimeout(function () {

                if (!vm.clients.length) __WEBPACK_IMPORTED_MODULE_11__helpers_AlertHelpers__["a" /* default */].showAlert("Old file: Please go into transaction, then add clients as contacts manually");
            }, 4000);
        }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_15__helpers_Utilities__["a" /* default */].log('Created > Error in loadTransaction ', err);
            _this.snackbar = err;
            _this.snackbarshow = true;
        });

        vm.getActivityRef().on('value', function (activitySnap) {
            vm.selectedItems = __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(activitySnap);
        });
    }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_DeleteButton__);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            form: {
                saveAsTemplate: false,
                advanced: false
            }

        };
    },


    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default.a, DeleteButton: __WEBPACK_IMPORTED_MODULE_6__ui_elements_DeleteButton___default.a
    },

    props: {
        settings: Object,
        document: Object
    },

    computed: {
        templatePath: function templatePath() {
            return {
                category: __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].toCamelCase(this.document.category),
                title: __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].toCamelCase(this.document.title)
            };
        },
        lenders: function lenders() {
            return ['General'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__helpers_LookupData__["a" /* default */].lenders().map(function (lender) {
                return lender.name;
            })));
        },
        tenantKey: function tenantKey() {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getTenantKey();
        }
    },

    methods: {
        saveDocument: function saveDocument() {
            if (this.form.saveAsTemplate) this.saveTemplate();
            this.$emit('save', this.document);
        },
        saveTemplate: function saveTemplate() {
            var ref = __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getRootRef();

            ref = ref.child('tenants').child(this.tenantKey).child('documentChecklist');
            ref = ref.child(this.document.lender).child(this.templatePath.category).child(this.templatePath.title);
            var newDocument = __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(this.document);
            ref.update(newDocument);
        },
        deleteButtonClicked: function deleteButtonClicked() {},
        initialise: function initialise() {
            this.form.saveAsTemplate = false;
            this.form.advanced = false;
        }
    },

    created: function created() {}
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);









var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database();
var lendersRef = db.ref('app/lenders');
var categoriesRef = db.ref('app/documents/categories');
var requirementsRef = db.ref('app/documents/requirements');
var requestsRef = db.ref('app/documents/requests/General');
var generalRequestsRef = db.ref('app/documents/requests/General');

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SupplierDocuments',
    components: {
        'DeleteButton': __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default.a
    },
    data: function data() {
        return {
            dialogTab: 0,
            lender: 'General',
            newCheckItem: '',
            documentDialog: {
                visible: false,
                key: '',
                model: {
                    name: '',
                    importance: 0,
                    category: {}
                }
            },
            requirementDialog: {
                visible: false,
                tab: 'main-tab',
                model: {
                    name: '',
                    description: '',
                    download: '',
                    importance: 0,
                    instructions: '',
                    checklist: [],
                    notRequired: false,
                    expiryDays: null
                }
            }
        };
    },


    firebase: {
        lenders: lendersRef,
        categories: categoriesRef,
        requirements: requirementsRef,
        requests: requestsRef,
        generalRequests: generalRequestsRef
    },
    computed: {
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        }
    },
    methods: {
        setLender: function setLender(name) {
            this.lender = name;
            var requestsRef = db.ref('app/documents/requests').child(name);
            this.$bindAsArray('requests', requestsRef);
        },
        documentDialogClose: function documentDialogClose() {
            this.documentDialog.visible = false;
            this.documentDialog.model = { name: '', category: '', importance: 0 };
        },
        documentDialogCancel: function documentDialogCancel() {
            this.documentDialogClose();
        },
        documentDialogSave: function documentDialogSave() {
            var ref = db.ref('app/documents/requirements');
            var model = this.documentDialog.model;

            var catref = db.ref('app/documents/categories').orderByChild('name').equalTo(model.category.name);

            catref.on('child_added', function (snap) {
                model.category = snap.val();
            });

            this.pushOrUpdateRef(model, ref);
            this.documentDialogClose();
        },
        showDocumentDialog: function showDocumentDialog(model, category) {
            if (model) this.documentDialog.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));else this.documentDialog.model.category = category;

            this.documentDialog.visible = true;
        },
        showRequirementDialog: function showRequirementDialog(model, requirement) {
            if (model) {
                if (typeof model.notRequired === "undefined") model.notRequired = false;
                this.requirementDialog.model = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model));
            } else {
                this.requirementDialog.model.requirementName = requirement.name;
                this.requirementDialog.model.requirementKey = requirement['.key'];
            }

            this.requirementDialog.visible = true;
        },
        requirementDialogClose: function requirementDialogClose() {
            this.requirementDialog.visible = false;
            this.requirementDialog.model = { name: '',
                description: '',
                importance: 0,
                download: '',
                instructions: '',
                checklist: [],
                category: {},
                notRequired: false,
                expiryDays: null };
            this.requirementDialog.tab = 'main-tab';
        },
        requirementDialogCancel: function requirementDialogCancel() {
            this.requirementDialogClose();
        },
        requirementDialogSave: function requirementDialogSave() {
            var ref = db.ref('app/documents/requests').child(this.lender);
            var model = this.requirementDialog.model;
            this.pushOrUpdateRef(model, ref);
            this.requirementDialogClose();
        },
        deleteRequirement: function deleteRequirement(key) {
            db.ref('app/documents/requests').child(this.lender).child(key).remove();

            this.requirementDialogClose();
        },
        requirementsForCategory: function requirementsForCategory(category) {
            return this.requirements.filter(function (req) {
                return req.category.name == category;
            });
        },
        requestsForRequirement: function requestsForRequirement(type) {
            var requests = this.requests.filter(function (req) {
                return req.requirementKey == type;
            });
            requests = requests.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return requests;
        },
        generalRequestsForRequirement: function generalRequestsForRequirement(type) {
            var requests = this.generalRequests.filter(function (req) {
                return req.requirementKey == type;
            });
            requests = requests.sort(function (a, b) {
                return b.importance - a.importance;
            });
            return requests;
        },
        pushOrUpdateRef: function pushOrUpdateRef(model, ref) {
            var key = model['.key'];
            if (key) {
                ref = ref.child(key);
                delete model['.key'];

                ref.update(model);
            } else {
                ref.push(model);
            }
        },
        addCheckItem: function addCheckItem() {
            if (!this.requirementDialog.model.checklist) this.requirementDialog.model.checklist = [];

            this.requirementDialog.model.checklist.push({
                text: this.newCheckItem
            });
            this.newCheckItem = '';
        },
        copyToLender: function copyToLender(request) {
            var ref = db.ref('app/documents/requests/' + this.lender);
            ref.push(__WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(request));
        }
    }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_LayoutContainer2__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_LayoutContainer2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_LayoutContainer2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_LayoutReadOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ElementMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ElementMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__screens_ElementMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_ScrollHelpers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_json_to_csv__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_json_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_DateRangeList__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_DateRangeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_DateRangeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ScreenData__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ScreenTable__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ScreenTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ScreenTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_TemplateHelpers__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_SplitButton__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_SplitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ui_elements_SplitButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__data_NiceData__ = __webpack_require__(15);





































var PageSection = function () {
    function PageSection(section) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, PageSection);

        this.section = section;
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(PageSection, [{
        key: 'fieldByName',
        value: function fieldByName(name) {
            return this.section.fields.find(function (o) {
                return o.name == name;
            }) || null;
        }
    }]);

    return PageSection;
}();

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedInvoiceKeys: [],
            tables: {},
            billingTable: {},
            pageLoaded: false,
            page2: null,
            dateRange: {
                start: null,
                end: null,
                text: null
            },
            currentUserOnly: true,
            category: 'Client Invoices',

            leftPageSection: {
                title: 'Parameters',
                flat: true,
                hideTitle: true,
                hideIcons: true,
                hideIndicators: true,
                fields: [{
                    name: 'date_range',
                    type: 'DateRange',
                    control: 'DateRange',
                    key: '111',
                    title: 'Date Range',
                    complete: true,
                    value: null
                }]
            },

            page: { sections: [], collections: [] }

        };
    },

    components: {
        SectionLayout: __WEBPACK_IMPORTED_MODULE_9__screens_SectionLayout___default.a,
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_14__screens_ScreenLayout___default.a,
        ScreenTable: __WEBPACK_IMPORTED_MODULE_19__ScreenTable___default.a,
        DateRangeList: __WEBPACK_IMPORTED_MODULE_17__ui_elements_DateRangeList___default.a,
        VueJsonToCsv: __WEBPACK_IMPORTED_MODULE_16_vue_json_to_csv___default.a,
        SplitButton: __WEBPACK_IMPORTED_MODULE_29__ui_elements_SplitButton___default.a
    },

    props: {
        admin: String
    },

    computed: {
        filters: function filters() {
            return {
                u: this.currentUserOnly,
                c: this.category,
                d: this.dateRange
            };
        },
        nextTwentieth: function nextTwentieth() {
            var today = new Date();
            var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["B" /* getDate */])(today);
            var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["C" /* getMonth */])(today) + (day > 15 ? 1 : 0);
            var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["c" /* getYear */])(today);
            return year + '-' + month + '-20';
        },
        billingTableGrouped: function billingTableGrouped() {
            var _this = this;

            var obj = {};
            if (!this.billingTable.records) return obj;

            var currentUserEmail = __WEBPACK_IMPORTED_MODULE_22__helpers_DataHelpers__["a" /* default */].getUserEmail();
            this.billingTable.records.forEach(function (billingRecord) {
                var allowForUser = !_this.currentUserOnly || currentUserEmail == billingRecord.recipient.email;

                var allowForCategory = true;
                if (_this.category == 'Processor Invoices') allowForCategory = billingRecord.recipient.email == 'billing@insightprocessing.com.au';else if (_this.category == 'Client Invoices') allowForCategory = billingRecord.recipient.email != 'billing@insightprocessing.com.au';

                var payerExists = Boolean(billingRecord.payer) && Boolean(billingRecord.payer.email);

                if (payerExists && allowForUser && allowForCategory) {
                    var invoiceKey = billingRecord.payer.email + '-' + billingRecord.recipient.email;
                    if (!obj[invoiceKey]) {
                        obj[invoiceKey] = [];
                    }
                    obj[invoiceKey].push(billingRecord);
                } else {}
            });
            return obj;
        },
        selectedInvoices: function selectedInvoices() {
            var _this2 = this;

            var result = {};
            this.selectedInvoiceKeys.forEach(function (key) {
                if (!_this2.billingTableGrouped[key]) debugger;
                result[key] = _this2.billingTableGrouped[key].slice();
            });
            return result;
        },
        mergedSection: function mergedSection() {
            try {
                return this.mergeSection(this.page.sections[0], this.page.collections[1].data);
            } catch (e) {
                return null;
            }
        },
        dates: function dates() {
            return this.dateRange;
        },
        moreButtonVisible: function moreButtonVisible() {
            if (!this.page.collections || !this.page.collections.length || !this.page.collections[1].data || !this.page.collections[1].data.records) return false;
            return this.page.collections[1].data.records.length >= this.page.collections[1].limit;
        },
        areInvoicesSelected: function areInvoicesSelected() {
            return this.selectedInvoiceKeys.length > 0;
        },
        areAllInvoicesSelected: function areAllInvoicesSelected() {
            return this.selectedInvoiceKeys.length == __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.billingTableGrouped).length;
        }
    },

    methods: {
        getInvoiceId: function getInvoiceId(invoice) {
            var firstInvoice = invoice[0];
            var payer = firstInvoice.payer;
            var initials = __WEBPACK_IMPORTED_MODULE_30__helpers_ContactHelpers__["a" /* default */].initials(payer) + payer.lastName[payer.lastName.length - 1].toUpperCase();

            var recipient = firstInvoice.recipient;
            var recipientInitials = __WEBPACK_IMPORTED_MODULE_30__helpers_ContactHelpers__["a" /* default */].initials(recipient);

            var backwardsDate = firstInvoice.charge_date;
            var dateObj = __WEBPACK_IMPORTED_MODULE_31__helpers_DateHelpers__["a" /* default */].backwardsToDate(backwardsDate);
            var monthYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_date_fns__["a" /* format */])(dateObj, 'MMyy');
            return initials + recipientInitials + '-' + monthYear;
        },
        markInvoices: function markInvoices(menu) {
            var _this3 = this;

            var _loop = function _loop(invoiceKey) {
                var status = menu.text == 'Outstanding' ? null : menu.text;

                console.log('Marking as ' + status + ' for ' + invoiceKey);
                var invoice = _this3.selectedInvoices[invoiceKey];
                invoice.forEach(function (charge) {
                    __WEBPACK_IMPORTED_MODULE_18__ScreenData__["a" /* default */].saveFieldValue('insight', 'billing', charge.key, 'status', status);
                });
            };

            for (var invoiceKey in this.selectedInvoices) {
                _loop(invoiceKey);
            }
        },
        makeInsightBills: function makeInsightBills() {
            var _this4 = this;

            var _loop2 = function _loop2(invoiceKey) {
                var dt = __WEBPACK_IMPORTED_MODULE_31__helpers_DateHelpers__["a" /* default */].todayString();
                var invoice = _this4.selectedInvoices[invoiceKey];
                var total = _this4.invoiceTotal(invoice);
                var processor = invoice[0].recipient;
                var broker = invoice[0].payer;
                var brokerParams = __WEBPACK_IMPORTED_MODULE_23__helpers_LookupData__["a" /* default */].processors().find(function (o) {
                    return o.email == processor.email;
                }) || { rate: .25, email: 'unknown', firstName: 'Unknown' };
                var itemAmount = brokerParams.rate * total;
                var percentString = __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].formatPercent(brokerParams.rate);
                var totalString = __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].formatCurrency(total);
                var note = 'Comms on ' + percentString + ' of ' + totalString;
                var recipient = {
                    firstName: 'Insight',
                    lastName: 'Processing',
                    email: 'billing@insightprocessing.com.au'
                };

                if (processor.email == 'billing@insightprocessing.com.au') {
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert("Can't generate from an existing Insight Invoice");
                    return 'continue';
                }

                var page = {
                    rowKey: __WEBPACK_IMPORTED_MODULE_22__helpers_DataHelpers__["a" /* default */].getKey(),
                    table: 'billing',
                    scope: 'insight',
                    elements: [{ fieldPos: 'i1', name: 'charge_date', value: dt }, { fieldPos: 'f1', name: 'amount', value: itemAmount }, { fieldPos: 'f2', name: 'note', value: note }, { fieldPos: 'i2', name: 'recipient', value: recipient }, { fieldPos: 'i3', name: 'payer', value: processor }, { fieldPos: 'i4', name: 'clients', value: __WEBPACK_IMPORTED_MODULE_30__helpers_ContactHelpers__["a" /* default */].fullName(broker) }]
                };
                __WEBPACK_IMPORTED_MODULE_18__ScreenData__["a" /* default */].savePageValues(page);
                __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert('Insight Invoices Created');
            };

            for (var invoiceKey in this.selectedInvoices) {
                var _ret2 = _loop2(invoiceKey);

                if (_ret2 === 'continue') continue;
            }
        },
        pluralise: function pluralise(prefix, count, singularVersion, pluralVersion) {
            var result = prefix + ' ';
            if (count < 1) result += 'no';else result += count;
            if (count == 1) result += ' ' + singularVersion;else result += ' ' + pluralVersion;
            return result;
        },
        selectAllInvoices: function selectAllInvoices() {
            this.selectedInvoiceKeys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.billingTableGrouped);
        },
        clearSelectedInvoices: function clearSelectedInvoices() {
            this.selectedInvoiceKeys = [];
        },
        mergeSection: function mergeSection(section, table) {
            var _this5 = this;

            if (!(section && section.fields && table && table.fields)) return {};

            var toSection = {};
            toSection.fields = [];
            section.fields.forEach(function (field) {

                var tableField = table.fields.find(function (o) {
                    return o.name == field.name;
                });
                var mergedField = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, tableField, field);
                _this5.setDefaultProperties(mergedField);

                toSection.fields.push(mergedField);
            });

            toSection.records = [];

            table.records.forEach(function (record) {
                var toRecord = {};
                toSection.fields.forEach(function (field) {
                    var value = record[field.name];
                    toRecord[field.name] = __WEBPACK_IMPORTED_MODULE_18__ScreenData__["a" /* default */].formatForDisplay(value, field.type);
                });
                toSection.records.push(toRecord);
            });

            return toSection;
        },
        toggleInvoiceSelection: function toggleInvoiceSelection(invoiceKey) {
            __WEBPACK_IMPORTED_MODULE_25__helpers_ArrayHelpers__["a" /* default */].toggleInArray(this.selectedInvoiceKeys, invoiceKey);
        },
        isInvoiceSelected: function isInvoiceSelected(email) {
            return this.selectedInvoiceKeys.indexOf(email) > -1;
        },
        invoiceTotal: function invoiceTotal(invoice) {
            return invoice.reduce(function (a, b) {
                return a + (b.amount || 0);
            }, 0);
        },
        getProcessorDetails: function getProcessorDetails(email, field) {
            var processors = __WEBPACK_IMPORTED_MODULE_23__helpers_LookupData__["a" /* default */].processors();
            var processor = processors.find(function (p) {
                return p.email == email;
            });
            if (processor) return processor[field];else return '';
        },
        setDefaultProperties: function setDefaultProperties(field) {
            field.title = field.title || __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].snakeToNormal(field.name);
            field.align = field.align || (['Currency', 'Number'].includes(field.type) ? 'right' : null);
        },
        emailSelectedInvoices: function emailSelectedInvoices(menu) {
            var _this6 = this;

            if (menu && menu.text == 'To Bookkeeper') {
                this.emailAllInvoicesToBookkeeper();
                return;
            }

            var templateName = menu && menu.text == 'Send Reminder' ? 'Send Invoice Reminder' : 'Send Invoice';
            __WEBPACK_IMPORTED_MODULE_24__helpers_TemplateHelpers__["a" /* default */].fetchTemplate('global', templateName).then(function (template) {
                console.log('Template is ', template);

                if (!template) {
                    __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert('Template not found: Notify Checklist Updated');
                    return;
                }
                var selectedInvoices = _this6.selectedInvoices;

                var _loop3 = function _loop3(invoiceKey) {
                    var invoiceText = _this6.$refs['invoice-' + invoiceKey][0].outerHTML;
                    var payerEmail = selectedInvoices[invoiceKey][0].payer.email;
                    _this6.getBillingEmail(payerEmail).then(function (billingEmail) {

                        var recipentEmail = selectedInvoices[invoiceKey][0].recipient.email;
                        var greeting = selectedInvoices[invoiceKey][0].payer.firstName;
                        var to = void 0,
                            cc = void 0;
                        if (!menu || menu.text == 'To Both' || menu.text == 'Send Reminder') {
                            to = billingEmail;
                            cc = recipentEmail;
                        } else if (menu.text == 'To Client') {
                            to = billingEmail;
                            cc = null;
                        } else if (menu.text == 'To Processor') {
                            to = recipentEmail;
                            cc = null;
                            greeting = selectedInvoices[invoiceKey][0].recipient.firstName;
                        }
                        _this6.emailInvoice(template, invoiceText, greeting, to, cc);
                    });
                };

                for (var invoiceKey in selectedInvoices) {
                    _loop3(invoiceKey);
                }
            });
        },
        emailAllInvoicesToBookkeeper: function emailAllInvoicesToBookkeeper() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_24__helpers_TemplateHelpers__["a" /* default */].fetchTemplate('global', 'Send Invoice').then(function (template) {
                console.log('Template is ', template);
                var emailText = '';
                for (var invoiceKey in _this7.selectedInvoices) {
                    var _invoiceText = _this7.$refs['invoice-' + invoiceKey][0].outerHTML;
                    emailText += _invoiceText + '<br/><br/>';
                }
                var to = 'accounting@insightprocessing.com.au';
                var cc = 'billing@insightprocessing.com.au';

                _this7.emailInvoice(template, emailText, 'Emma', to, cc);
            });
        },
        getBillingEmail: function getBillingEmail(email) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_30__helpers_ContactHelpers__["a" /* default */].fetchContactByEmail(email).then(function (contact) {

                    var uid = contact.meta.key;
                    var tenantKey = __WEBPACK_IMPORTED_MODULE_22__helpers_DataHelpers__["a" /* default */].getTenantKey();
                    var ref = __WEBPACK_IMPORTED_MODULE_22__helpers_DataHelpers__["a" /* default */].getRootRef().child('users/' + uid + '/offices/' + tenantKey + '/preferences/email/billing');
                    __WEBPACK_IMPORTED_MODULE_32__data_NiceData__["a" /* default */].fetchValue(ref).then(function (billingEmail) {

                        if (!billingEmail) billingEmail = email;
                        resolve(billingEmail);
                    });
                }).catch(function (err) {
                    console.log('getBillingEmail threw an error so just used normal email address', err);
                    resolve(email);
                });
            });
        },
        emailInvoice: function emailInvoice(template, invoiceHtml, greeting, to, cc) {

            console.log('*** sending invoice ***', to, cc);

            var customFields = {
                greeting: greeting,
                sender: this.$store.getters.user.firstName,
                invoice: invoiceHtml
            };

            var body = __WEBPACK_IMPORTED_MODULE_27__helpers_MergeHelpers__["a" /* default */].simpleMerge(template.body, customFields);

            var email = {};
            email.to = to;
            email.cc = cc;
            email.subject = template.subject || '';
            email.body = body;

            email.bcc = __WEBPACK_IMPORTED_MODULE_22__helpers_DataHelpers__["a" /* default */].getUserEmail();

            __WEBPACK_IMPORTED_MODULE_28__helpers_EmailHelpers__["a" /* default */].sendEmail(email).then(function (msg) {
                if (msg != 'OK') __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert('Email Failed - ' + msg);else __WEBPACK_IMPORTED_MODULE_26__helpers_AlertHelpers__["a" /* default */].showAlert('Invoice Sent to ' + greeting);
            });
        },
        deleteCharge: function deleteCharge(charge) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var amountString;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                amountString = __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].formatCurrency(charge.amount);
                                _context.next = 3;
                                return _this8.$root.$confirm('Delete', 'Are you sure you want to delete this charge for ' + charge.client + ' amounting to ' + amountString + ' from the invoice?', { color: 'red' });

                            case 3:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 7;
                                    break;
                                }

                                console.log('deleting charge', charge.key);
                                __WEBPACK_IMPORTED_MODULE_18__ScreenData__["a" /* default */].deleteRecord('insight', 'billing', charge.key);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this8);
            }))();
        },
        loadData: function loadData() {
            var _this9 = this;

            var collection = {};
            console.log('running load data');
            collection.scope = 'insight';
            collection.table = 'billing';
            collection.orderBy = 'charge_date';
            collection.startAt = this.dateRange.start;
            collection.endAt = this.dateRange.end;
            this.$set(collection, 'data', {});
            __WEBPACK_IMPORTED_MODULE_18__ScreenData__["a" /* default */].injectTable(this.billingTable, collection).then(function (result) {
                console.log(result, _this9.billingTable);
            });
        }
    },

    watch: {
        'filters': {
            deep: true,
            handler: function handler(newVal) {
                this.clearSelectedInvoices();
            }
        }
    },

    mounted: function mounted() {
        console.log('***REFS****', this.$refs);
    },
    created: function created() {
        this.loadData();
    }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controls_GroupControl__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controls_GroupControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__controls_GroupControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_SortableList__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_SortableList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_SortableList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controls_TextControl__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controls_TextControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__controls_TextControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controls_NumberControl__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controls_NumberControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__controls_NumberControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controls_SwitchControl__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controls_SwitchControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__controls_SwitchControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__controls_CheckboxControl__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__controls_CheckboxControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__controls_CheckboxControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controls_DateControl__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controls_DateControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__controls_DateControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controls_SelectUserControl__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controls_SelectUserControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__controls_SelectUserControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__controls_DateRangeControl__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__controls_DateRangeControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__controls_DateRangeControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__controls_ButtonControl__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__controls_ButtonControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__controls_ButtonControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__controls_OptionsControl__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__controls_OptionsControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__controls_OptionsControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__controls_DropdownControl__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__controls_DropdownControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__controls_DropdownControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__controls_HtmlControl__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__controls_HtmlControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__controls_HtmlControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__controls_ImageControl__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__controls_ImageControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__controls_ImageControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__controls_UploadControl__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__controls_UploadControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__controls_UploadControl__);

























/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            previousValue: null
        };
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_2__screens_ElementLayout___default.a,
        TextControl: __WEBPACK_IMPORTED_MODULE_7__controls_TextControl___default.a,
        HtmlControl: __WEBPACK_IMPORTED_MODULE_18__controls_HtmlControl___default.a,
        NumberControl: __WEBPACK_IMPORTED_MODULE_8__controls_NumberControl___default.a,
        DateControl: __WEBPACK_IMPORTED_MODULE_11__controls_DateControl___default.a,
        SwitchControl: __WEBPACK_IMPORTED_MODULE_9__controls_SwitchControl___default.a,
        CheckboxControl: __WEBPACK_IMPORTED_MODULE_10__controls_CheckboxControl___default.a,
        UploadControl: __WEBPACK_IMPORTED_MODULE_20__controls_UploadControl___default.a,
        SelectUserControl: __WEBPACK_IMPORTED_MODULE_12__controls_SelectUserControl___default.a,
        CurrencyControl: __WEBPACK_IMPORTED_MODULE_13__controls_CurrencyControl___default.a,
        DateRangeControl: __WEBPACK_IMPORTED_MODULE_14__controls_DateRangeControl___default.a,
        GroupControl: __WEBPACK_IMPORTED_MODULE_3__controls_GroupControl___default.a,
        SectionLayout: __WEBPACK_IMPORTED_MODULE_4__screens_SectionLayout___default.a,
        ButtonControl: __WEBPACK_IMPORTED_MODULE_15__controls_ButtonControl___default.a,
        OptionsControl: __WEBPACK_IMPORTED_MODULE_16__controls_OptionsControl___default.a,
        DropdownControl: __WEBPACK_IMPORTED_MODULE_17__controls_DropdownControl___default.a,
        draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a,
        SortableList: __WEBPACK_IMPORTED_MODULE_6__ui_elements_SortableList___default.a,
        ImageControl: __WEBPACK_IMPORTED_MODULE_19__controls_ImageControl___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        componentName: function componentName() {
            if (!this.element) return null;
            var controlName = this.element.control || this.element.type;
            if (!controlName) debugger;
            return controlName.replace(' ', '') + 'Control';
        },
        childElements: function childElements() {
            var _this = this;

            return this.element.elements.map(function (o) {
                var el = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, o);
                el.record = el.record || _this.element.record;
                return el;
            });
        }
    },

    methods: {
        valueChanged: function valueChanged(changeObj) {
            var changes = { value: this.element.value, previousValue: this.previousValue };
            console.log('** Value Changed **', changes);
            this.storePreviousValue();
        },
        storePreviousValue: function storePreviousValue() {
            this.previousValue = this.element.value;
        }
    },

    created: function created() {
        this.storePreviousValue();
    },
    mounted: function mounted() {},


    watch: {
        'element.value': {
            handler: function handler(newVal, oldVal) {
                console.log('Changed from ' + oldVal + ' to ' + newVal);
            }
        }
    }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        root: Object,
        activeKey: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        nodeClicked: function nodeClicked(element, section) {
            if (!section) this.$set(element, 'expanded', !element.expanded);
            this.$emit('click', element, section);
        },
        isActive: function isActive(menu) {
            return this.activeKey && menu.key == this.activeKey;
        }
    },

    created: function created() {}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_OneOrMoreList__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_OneOrMoreList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_OneOrMoreList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer2__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_LayoutReadOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__screens_ElementMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ScrollHelpers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_DateRangeList__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_DateRangeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ui_elements_DateRangeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_ToolbarSearch__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_ToolbarSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ui_elements_ToolbarSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_TagsView__ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_TagsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_TagsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ScreenData__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ScreenTable__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ScreenTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ScreenTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_FakeHelpers__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_elements_contacts_ContactRow__ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_elements_contacts_ContactRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ui_elements_contacts_ContactRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_elements_ImageGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_elements_ImageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ui_elements_ImageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_elements_GroupDropdown__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_elements_GroupDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ui_elements_GroupDropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_ContactImages__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_ContactImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ui_elements_ContactImages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_DataLoader__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ui_elements_DataLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ui_elements_DataLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__helpers_TagHelpers__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__helpers_TeamHelpers__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__helpers_CollectionHelpers__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__data_Collection__ = __webpack_require__(715);












































/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            user: {},
            joinSets: 'intersection',
            lock: '',

            addingRelationship: false,
            newRelationship: {
                text: 'Friend',
                relatedText: 'Friend'
            },

            colours: ['#FE2E2E', '#FE9A2E', '#31B404', '#0080FF', '#AC58FA', '#FE2E9A', '#848484'],

            sampleGroups: [{ _id: 'clients', name: 'Clients', colour: '#31B404', members: 983 }, { _id: 'firstHomeBuyers', name: 'First Home Buyers', members: 14 }, { _id: 'investors', name: 'Investors', colour: '#FE2E9A', members: 87 }, { _id: 'marketing4', name: 'Marketing 4', colour: '#31B404', members: 44 }, { _id: 'builders', name: 'Builders', members: 13, colour: '#AC58FA' }, { _id: 'agents', name: 'Agents', colour: '#0080FF', members: 20 }],

            contacts: [],
            groups: [],
            lockedContacts: [],

            singleRelationships: [],
            coupleRelationships: [],
            contactSearch: '',
            sortField: 'firstName'

        };
    },

    components: {
        DeleteButton: __WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton___default.a,
        ColourBar: __WEBPACK_IMPORTED_MODULE_4__ui_elements_ColourBar___default.a,
        OneOrMoreList: __WEBPACK_IMPORTED_MODULE_5__ui_elements_OneOrMoreList___default.a,
        SectionLayout: __WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout___default.a,
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout___default.a,
        ScreenTable: __WEBPACK_IMPORTED_MODULE_19__ScreenTable___default.a,
        DateRangeList: __WEBPACK_IMPORTED_MODULE_15__ui_elements_DateRangeList___default.a,
        VueJsonToCsv: __WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv___default.a,
        ContactRow: __WEBPACK_IMPORTED_MODULE_25__ui_elements_contacts_ContactRow___default.a,
        ImageGroup: __WEBPACK_IMPORTED_MODULE_26__ui_elements_ImageGroup___default.a,
        TagsView: __WEBPACK_IMPORTED_MODULE_17__ui_elements_TagsView___default.a,
        GroupDropdown: __WEBPACK_IMPORTED_MODULE_27__ui_elements_GroupDropdown___default.a,
        ContactImages: __WEBPACK_IMPORTED_MODULE_28__ui_elements_ContactImages___default.a,
        ToolbarSearch: __WEBPACK_IMPORTED_MODULE_16__ui_elements_ToolbarSearch___default.a,
        DataLoader: __WEBPACK_IMPORTED_MODULE_29__ui_elements_DataLoader___default.a
    },

    props: {},

    computed: {
        downloadableContacts: function downloadableContacts() {
            return this.selectedContacts.map(function (c) {
                var newItem = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, c);
                newItem.id = newItem._id;
                delete newItem.createdAt;
                delete newItem.updatedAt;
                delete newItem.createdBy;
                delete newItem.updatedBy;
                if (newItem.tags) {
                    newItem.tags = __WEBPACK_IMPORTED_MODULE_31__helpers_TagHelpers__["a" /* default */].tagsToString(newItem.tags);
                }
                newItem = __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].removeMeta(newItem);
                return newItem;
            });
        },
        alternateSortField: function alternateSortField() {
            return this.sortField == 'firstName' ? 'lastName' : 'firstName';
        },
        offices: function offices() {
            return this.$store.getters.offices;
        },
        selectedGroups: function selectedGroups() {
            return this.groups.filter(function (o) {
                return o._selected;
            });
        },
        groupsFilter: function groupsFilter() {
            var filters = [];
            this.selectedGroups.forEach(function (group) {
                filters.push({
                    field: 'tags.' + group._id,
                    operator: '==',
                    value: true
                });
            });
            return filters;
        },
        relationshipsFilter: function relationshipsFilter() {
            return [{ field: 'primaryId', operator: '==', value: this.selectedContact._id }];
        },
        selectedNames: function selectedNames() {
            return __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].sentenceJoin(this.selectedContacts.map(function (o) {
                return o.firstName;
            }));
        },
        selectedImages: function selectedImages() {
            return this.selectedContacts.map(function (o) {
                return o.image;
            });
        },
        selectedContact: function selectedContact() {
            return this.selectedContacts[0];
        },
        selectedContacts: function selectedContacts() {
            return this.contacts.filter(function (o) {
                return o._selected;
            });
        },
        relationshipNames: function relationshipNames() {
            return __WEBPACK_IMPORTED_MODULE_30__helpers_LookupData__["a" /* default */].relationships().filter(function (o) {
                return o.text != 'Partner';
            });
        },
        contactsCouldBePartners: function contactsCouldBePartners() {
            var c1 = this.selectedContacts[0];
            var c2 = this.selectedContacts[1];
            if (!c1 || !c2) return false;
            if (this.differentTeams) return false;
            return !c1.hasPartner && !c2.hasPartner;
        },
        contactsArePartners: function contactsArePartners() {
            return Boolean(this.coupleRelationships.find(function (r) {
                return r.relatedRelationship == 'Partner';
            }));
        },
        differentTeams: function differentTeams() {
            if (this.selectedContacts.length < 2) return false;
            var different = false;
            var team = __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getItemTeam(this.selectedContacts[0]);
            this.selectedContacts.forEach(function (contact) {

                if (__WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getItemTeam(contact) != team) different = true;
            });
            return different;
        }
    },

    methods: {
        downloadableLabels: function downloadableLabels(collection) {
            var item = collection[0];
            var labels = {};
            for (var prop in item) {
                labels[prop] = { title: __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].camelToNormal(prop) };
            }
            return labels;
        },
        downloadComplete: function downloadComplete() {
            __WEBPACK_IMPORTED_MODULE_32__helpers_AlertHelpers__["a" /* default */].showAlert(this.selectedContacts.length + ' rows downloaded. See below');
        },
        avatarClicked: function avatarClicked(item) {
            __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].consoleLogPath(item);
        },
        search: function search(term) {
            this.contactSearch = term;
            console.log('search for ' + term);
        },
        contactsLoading: function contactsLoading() {
            var _this = this;

            if (this.lock) {
                this.lockedContacts = [];
                this.selectedContacts.forEach(function (selectedContact) {
                    _this.lockedContacts.push(selectedContact);
                });
            }
        },
        contactsLoaded: function contactsLoaded(contacts) {
            var _this2 = this;

            this.contacts = contacts;

            if (this.lock) {
                this.lockedContacts.forEach(function (lockedContact) {
                    __WEBPACK_IMPORTED_MODULE_36__helpers_CollectionHelpers__["a" /* default */].insertOrMoveToTop(lockedContact, _this2.contacts);
                });
            }
        },
        groupsLoaded: function groupsLoaded(groups) {
            this.groups = groups;
        },
        getItemTeamName: function getItemTeamName(contact) {
            return __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].camelToNormal(__WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getItemTeam(contact));
        },
        createInitialTeams: function createInitialTeams() {
            var userKey = __WEBPACK_IMPORTED_MODULE_35__helpers_DataHelpers__["a" /* default */].getUserId();
            this.offices.forEach(function (office) {
                console.log(office);
                var team = {
                    _id: __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].toCamelCase(office.name),
                    _new: true,
                    active: false,
                    legacyNumber: office.meta.key,
                    _path: 'users/' + userKey + '/teams'
                };
                __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(team);
                var role = {
                    _id: __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].toCamelCase(office.name),
                    _new: true,
                    read: true,
                    write: true,
                    _path: 'users/' + userKey + '/roles'
                };
                __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(role);
            });
        },
        initSearchFields: function initSearchFields() {
            debugger;
            this.contacts.forEach(function (contact) {
                contact.search1 = contact.firstName.toLowerCase();
                contact.search2 = contact.lastName.toLowerCase();
                contact.relationships = __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].deleteToken();
                __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(contact);
            });
        },
        resetContactSelection: function resetContactSelection(force) {
            this.$refs.searchBox.clear();
            if (force) this.lock = '';
            if (!this.lock) this.$refs.contactsList.unselectAll();
        },
        contactSelectionChanged: function contactSelectionChanged() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this3.loadCoupleRelationships();

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        loadCoupleRelationships: function loadCoupleRelationships() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var c1, c2;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this4.selectedContacts.length !== 2)) {
                                    _context2.next = 3;
                                    break;
                                }

                                _this4.coupleRelationships = [];
                                return _context2.abrupt('return');

                            case 3:
                                c1 = _this4.selectedContacts[0];
                                c2 = _this4.selectedContacts[1];

                                if (!(__WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getItemTeam(c1) !== __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getItemTeam(c1))) {
                                    _context2.next = 8;
                                    break;
                                }

                                _this4.coupleRelationships = [];
                                return _context2.abrupt('return');

                            case 8:
                                _context2.next = 10;
                                return __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].fetchCoupleRelationships(c1, c2);

                            case 10:
                                _this4.coupleRelationships = _context2.sent;

                                console.log('couple relates = ', _this4.coupleRelationships);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        addToGroup: function addToGroup(group) {
            var result = __WEBPACK_IMPORTED_MODULE_31__helpers_TagHelpers__["a" /* default */].addTagToItems(group, this.selectedContacts);
            this.saveSelectedContacts();
            __WEBPACK_IMPORTED_MODULE_32__helpers_AlertHelpers__["a" /* default */].showAlert(result.message);
        },
        saveSelectedContacts: function saveSelectedContacts() {
            this.selectedContacts.forEach(function (contact) {
                __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(contact, { merge: false });
            });
        },
        removeFromGroup: function removeFromGroup(group) {
            var result = __WEBPACK_IMPORTED_MODULE_31__helpers_TagHelpers__["a" /* default */].removeTagFromItems(group, this.selectedContacts);
            this.saveSelectedContacts();
            __WEBPACK_IMPORTED_MODULE_32__helpers_AlertHelpers__["a" /* default */].showAlert(result.message);
        },
        addToNewGroup: function addToNewGroup(name) {
            var newGroup = this.addGroup(name, { silent: true });
            this.addToGroup(newGroup);
        },
        makePartners: function makePartners() {
            this.lock = false;
            __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].makePartners(this.selectedContacts[0], this.selectedContacts[1], this.coupleRelationships);
        },
        separatePartners: function separatePartners() {
            __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].separatePartners(this.selectedContacts[0], this.selectedContacts[1], this.coupleRelationships);
        },
        contactPartnerId: function contactPartnerId(contact) {
            return __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].contactPartnerId(contact);
        },
        addGroup: function addGroup() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.uniqueGroupName();
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var newGroup = {
                _id: __WEBPACK_IMPORTED_MODULE_21__helpers_StringHelpers__["a" /* default */].toCamelCase(newGroup),
                colour: __WEBPACK_IMPORTED_MODULE_22__helpers_ArrayHelpers__["a" /* default */].randomFromArray(this.colours),
                name: name
            };
            this.groups.unshift(newGroup);
            if (!options.silent) this.$refs.groups.expand(newGroup);
            return newGroup;
        },
        getGroupColour: function getGroupColour(name) {
            var groups = this.groups;
            var group = groups.find(function (g) {
                return g._id == name;
            });
            if (group) return group.colour;else return null;
        },
        swatchStyle: function swatchStyle(item) {
            return 'background-color:' + item.colour;
        },
        groupExpanded: function groupExpanded(item) {
            console.log('expanding with focus');
            __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].trackChanges(item);
            var select = Boolean(item.name == this.uniqueGroupName());
            __WEBPACK_IMPORTED_MODULE_20__helpers_Utilities__["a" /* default */].focus(this, 'name', select);
        },
        groupContracted: function groupContracted(item) {
            console.log('Contracting', item);
            var changes = __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getChanges(item, item._originalValues);
            if (changes.hasChanges) __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(item);
        },
        uniqueGroupName: function uniqueGroupName() {
            var name = void 0;
            for (var n = 1; n < 99; n++) {
                name = 'Group ' + n.toString();
                if (this.groups.findIndex(function (o) {
                    return o.name == name;
                }) < 0) break;
            }
            return name;
        },
        saveRelationship: function saveRelationship() {
            this.lock = false;
            __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].relateContacts(this.selectedContacts[0], this.newRelationship.text, this.selectedContacts[1], this.newRelationship.relatedText, this.coupleRelationships);
            this.addingRelationship = false;
        },
        addRelationshipToIndividual: function addRelationshipToIndividual() {
            this.lock = "Adding Relationship. Choose another person.";
            document.getElementsByClassName('right-column')[0].scrollTop = 0;
        },
        setLockMessage: function setLockMessage() {
            if (!this.lock || this.lock.indexOf('Adding Relationship') < 0) return;

            if (this.selectedContacts.length == 1) this.lock = 'Adding Relationship. Select another...';else if (this.selectedContacts.length == 2) this.lock = 'Adding Relationship. Click below...';else this.lock = 'Adding Relationship. Choose 2 contacts...';
        },
        goToRelated: function goToRelated(relationship) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var id, team, collection, ref, contact, edRef, edItems;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].consoleLogPath(relationship);

                                id = relationship.relatedId;
                                team = __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].getItemTeam(relationship);
                                collection = 'contacts';
                                _context3.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].ref({ team: team, collection: collection, id: id });

                            case 6:
                                ref = _context3.sent;
                                _context3.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].fetch(ref);

                            case 9:
                                contact = _context3.sent;
                                _context3.next = 12;
                                return __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].ref({ team: team, collection: collection }).where('firstName', '==', 'Edward');

                            case 12:
                                edRef = _context3.sent;
                                _context3.next = 15;
                                return __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].fetch(edRef);

                            case 15:
                                edItems = _context3.sent;


                                _this5.$refs.contactsData.addItem(contact);
                                _this5.$refs.screenLayout.$refs.middleColumn.scrollTop = 0;
                                _this5.$refs.contactsList.selectOne(contact);

                                console.log(contact);

                            case 20:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },
        hydrateRelationships: function hydrateRelationships(contact) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var relationships;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (contact) {
                                    _context4.next = 2;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 2:
                                _context4.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].fetchRelationships(contact);

                            case 4:
                                relationships = _context4.sent;


                                _this6.selectedRelationships = relationships;

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6);
            }))();
        },
        sendEmail: function sendEmail(contact) {
            __WEBPACK_IMPORTED_MODULE_32__helpers_AlertHelpers__["a" /* default */].showAlert('Email to be sent here to ' + __WEBPACK_IMPORTED_MODULE_23__helpers_ContactHelpers__["a" /* default */].fullName(contact));
        },
        removeRelationship: function removeRelationship(relationship) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return _this7.$root.$confirm('Delete Relationship', 'Remove association between ' + relationship.primaryFirstName + ' and ' + relationship.relatedFirstName + '?', { color: 'red' });

                            case 2:
                                _context5.t0 = _context5.sent;

                                if (!(_context5.t0 == true)) {
                                    _context5.next = 4;
                                    break;
                                }

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7);
            }))();
        },
        makeContacts: function makeContacts() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var contacts, teamName, relationships;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                contacts = __WEBPACK_IMPORTED_MODULE_24__helpers_FakeHelpers__["a" /* default */].fakeContacts(100);
                                teamName = _this8.user.primaryTeam;


                                __WEBPACK_IMPORTED_MODULE_24__helpers_FakeHelpers__["a" /* default */].fakeGroups(contacts);
                                relationships = __WEBPACK_IMPORTED_MODULE_24__helpers_FakeHelpers__["a" /* default */].fakeRelationships(contacts);

                                contacts.forEach(function (contact) {

                                    contact._team = teamName;
                                    contact._collection = 'contacts';
                                    __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(contact);
                                });
                                relationships.forEach(function (relationship) {

                                    relationship._team = teamName;
                                    relationship._collection = 'relationships';
                                    __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(relationship);
                                });

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8);
            }))();
        },
        makeGroups: function makeGroups() {
            var _this9 = this;

            debugger;
            this.sampleGroups.forEach(function (group) {
                group._team = _this9.user.primaryTeam;
                group._collection = 'groups';
                __WEBPACK_IMPORTED_MODULE_33__data_Firestore__["a" /* default */].saveItem(group);
            });
        }
    },

    mounted: function mounted() {},


    watch: {
        'selectedGroups': {
            handler: function handler(newVal) {
                if (!this.lock) this.$refs.contactsList.unselectAll();
            },
            deep: true
        },
        'selectedContact': {
            handler: function handler(newVal) {
                this.hydrateRelationships(newVal);
                this.setLockMessage();
            }
        }
    },

    created: function created() {
        var _this10 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
            var uid;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:

                            console.log('User is ' + __WEBPACK_IMPORTED_MODULE_35__helpers_DataHelpers__["a" /* default */].getUserId());

                            _context7.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_34__helpers_TeamHelpers__["a" /* default */].fetchUserId(_this10);

                        case 3:
                            uid = _context7.sent;


                            __WEBPACK_IMPORTED_MODULE_34__helpers_TeamHelpers__["a" /* default */].streamUser(_this10.user);

                        case 5:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this10);
        }))();
    }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScreenHelpers__ = __webpack_require__(111);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        SectionLayout: __WEBPACK_IMPORTED_MODULE_1__SectionLayout___default.a
    },

    props: {
        page: Object
    },

    computed: {
        valid: function valid() {
            return __WEBPACK_IMPORTED_MODULE_2__ScreenHelpers__["a" /* default */].isPageValid(this.page);
        }
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ScrollHelpers__ = __webpack_require__(63);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            leftColumnActive: false,
            rightColumnActive: false
        };
    },


    components: {},

    props: {
        leftVisible: {
            default: true,
            type: Boolean
        },
        leftWider: {
            default: false,
            type: Boolean
        },
        rightVisible: {
            default: true,
            type: Boolean
        },
        title: {
            default: 'Taco',
            type: String
        },
        uniformColour: {
            type: Boolean
        }

    },

    computed: {
        leftButtonVisible: function leftButtonVisible() {
            return this.leftVisible && !this.leftColumnActive;
        },
        rightButtonVisible: function rightButtonVisible() {
            return this.rightVisible && !this.rightColumnActive;
        }
    },

    methods: {
        overlayClicked: function overlayClicked() {
            this.leftColumnActive = false;
            this.rightColumnActive = false;
        },
        expandLeft: function expandLeft() {
            this.leftColumnActive = !this.leftColumnActive;
            this.rightColumnActive = false;
        },
        expandRight: function expandRight() {
            this.rightColumnActive = !this.rightColumnActive;
            this.leftColumnActive = false;
        }
    }

});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScreenData__ = __webpack_require__(88);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },

    components: {},

    props: {
        table: Object
    },

    computed: {
        xxx: function xxx() {
            return null;
        }
    },

    methods: {
        formatForDisplay: function formatForDisplay(value, type) {
            return __WEBPACK_IMPORTED_MODULE_0__ScreenData__["a" /* default */].formatForDisplay(value, type);
        },
        cellClass: function cellClass(field) {
            return {
                'text-xs-right': field.align == 'right'
            };
        }
    },

    mounted: function mounted() {}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScreenHelpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScreenTable__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScreenTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ScreenTable__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_1__ElementLayout___default.a,

        ScreenTable: __WEBPACK_IMPORTED_MODULE_3__ScreenTable___default.a
    },

    props: {
        section: Object,
        parent: Object
    },

    computed: {
        fieldsNotApplicable: function fieldsNotApplicable() {
            if (!this.section || !this.section.elements) return false;

            return this.section.elements.filter(function (o) {
                return o.na;
            });
        },
        valid: function valid() {
            return __WEBPACK_IMPORTED_MODULE_2__ScreenHelpers__["a" /* default */].isSectionValid(this.section);
        }
    },

    methods: {
        sectionClicked: function sectionClicked() {}
    },

    created: function created() {}
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_CodeHelpers__ = __webpack_require__(719);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a,
        CurrencyBox: __WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        run_copy_element_attribute: function run_copy_element_attribute() {
            console.log('copying attribute...');
        },
        run: function run() {
            var buttonName = this.element.name;
            __WEBPACK_IMPORTED_MODULE_2__helpers_CodeHelpers__["a" /* default */][buttonName]();
        }
    }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {},

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue);
            this.originalValue = newVal;
        }
    }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a,
        CurrencyBox: __WEBPACK_IMPORTED_MODULE_1__ui_elements_CurrencyBox___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_DateTime__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a,
        DateTime: __WEBPACK_IMPORTED_MODULE_1__ui_elements_DateTime___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DateRangeList__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DateRangeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_DateRangeList__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a,
        DateRangeList: __WEBPACK_IMPORTED_MODULE_1__ui_elements_DateRangeList___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    }
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_ScreenHelpers__ = __webpack_require__(111);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        options: function options() {
            return __WEBPACK_IMPORTED_MODULE_1__screens_ScreenHelpers__["a" /* default */].parseOptions(this.element.options);
        }
    },

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue);
            this.originalValue = newVal;
        }
    }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementControl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ElementControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScreenHelpers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScreenTable__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScreenTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ScreenTable__);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_1__ElementLayout___default.a,
        ElementControl: __WEBPACK_IMPORTED_MODULE_2__ElementControl___default.a,
        ScreenTable: __WEBPACK_IMPORTED_MODULE_4__ScreenTable___default.a
    },

    props: {
        element: Object
    },

    computed: {
        fieldsNotApplicable: function fieldsNotApplicable() {
            return this.element.elements.filter(function (o) {
                return o.na;
            });
        },
        valid: function valid() {
            return __WEBPACK_IMPORTED_MODULE_3__ScreenHelpers__["a" /* default */].isSectionValid(this.element);
        }
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            editor: __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default.a,
            editorConfig: {
                removePlugins: ['Heading', 'UndoUI']
            }
        };
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {},

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', { value: newVal, previousValue: this.originalValue });
            this.originalValue = newVal;
        },
        updateValue: function updateValue(newValue) {
            this.element.value = newValue;
        }
    },

    created: function created() {}
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_SplitButton__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_SplitButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_SplitButton__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            imageObject: {},
            uploading: false,
            uploaded: false,
            dirty: false
        };
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a,
        SplitButton: __WEBPACK_IMPORTED_MODULE_7__ui_elements_SplitButton___default.a
    },

    props: {
        element: Object,
        parent: Object,
        width: {
            type: Number,
            default: 50
        },
        height: {
            type: Number,
            default: 50
        }
    },

    computed: {
        storagePath: function storagePath() {
            return 'teams/' + __WEBPACK_IMPORTED_MODULE_2__data_Firestore__["a" /* default */].shortPath(this.element._path) + '/' + this.element.rowId;
        },
        displayImage: function displayImage() {
            if (this.element.value && this.element.value.indexOf('randomuser') < 0 && this.element.value.indexOf('transparent') < 0) {
                return this.element.value;
            }

            return '';
        },
        placeholder: function placeholder() {
            if (this.width < 60) return '[?]';
            return 'Choose...';
        },
        label: function label() {
            if (this.uploading) return 'Uploading...';
            if (this.uploaded) return 'Zoom and Move to Center';
            return this.element.title;
        }
    },

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', { value: newVal, previousValue: this.originalValue });
            this.originalValue = newVal;
        },
        fileSizeExceeded: function fileSizeExceeded() {
            this.dirty = false;
            __WEBPACK_IMPORTED_MODULE_6__helpers_AlertHelpers__["a" /* default */].showAlert('File is too big');
        },
        imageChanged: function imageChanged() {
            var _this = this;

            this.dirty = true;
            this.uploaded = false;
            setTimeout(function () {
                _this.upload();
            }, 500);
        },
        imageRemoved: function imageRemoved() {
            console.log('image removed');
            this.element.value = '';
        },
        upload: function upload() {
            var _this2 = this;

            if (this.uploading) {
                console.log('Not uploading...upload in progress');
                return;
            }

            if (!this.dirty) {
                console.log('Upload cancelled by system');
                return;
            }

            this.dirty = false;

            this.uploading = true;
            this.imageObject.generateBlob(function (blob) {
                var fileName = _this2.imageObject;
                __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.storage().ref(_this2.storagePath + '/' + _this2.element.name + '.jpg').put(blob).then(function (fileData) {
                    fileData.ref.getDownloadURL().then(function (url) {
                        console.log('Finished uploading', url);
                        _this2.element.value = url;
                        _this2.uploading = false;
                        _this2.uploaded = true;
                        if (_this2.dirty) _this2.upload();
                    });
                });
            }, 'image/jpeg', 0.5);
        }
    },

    created: function created() {},


    watch: {}
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object,
        decimals: Number
    },

    computed: {},

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue);
            this.originalValue = newVal;
        },
        increment: function increment(amount) {
            var existingAmount = parseInt(this.element.value);
            this.element.value = existingAmount + amount;
        }
    }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screens_ScreenHelpers__ = __webpack_require__(111);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        options: function options() {
            return __WEBPACK_IMPORTED_MODULE_1__screens_ScreenHelpers__["a" /* default */].parseOptions(this.element.options);
        }
    },

    methods: {
        log: function log() {
            console.log('menu clicked');
        }
    }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_UserChooser__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_1__ui_elements_UserChooser___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {},

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue);
            this.originalValue = newVal;
        }
    }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ElementLayout__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_0__ElementLayout___default.a
    },

    props: {
        element: Object,
        parent: Object
    },

    computed: {},

    methods: {
        fieldChanged: function fieldChanged(newVal) {
            this.$emit('change', { value: newVal, previousValue: this.originalValue });
            this.originalValue = newVal;
        }
    },

    created: function created() {}
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_UploadWrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_UploadWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_UploadWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_SortableList__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_SortableList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_SortableList__);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            uploading: false
        };
    },

    components: {
        ElementLayout: __WEBPACK_IMPORTED_MODULE_3__ElementLayout___default.a,
        UploadWrapper: __WEBPACK_IMPORTED_MODULE_4__ui_elements_UploadWrapper___default.a,
        SortableList: __WEBPACK_IMPORTED_MODULE_8__ui_elements_SortableList___default.a
    },

    props: {
        element: Object,
        parent: Object
    },
    computed: {
        storagePath: function storagePath() {
            return 'teams/' + __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].shortPath(this.element._path) + '/' + this.element._id;
        },
        files: function files() {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].objectDeepGet(this, 'element/data/files');
        }
    },
    methods: {
        doNothing: function doNothing() {
            var _this = this;

            this.$set(this.element, 'disabled', true);
            setTimeout(function () {
                _this.$set(_this.element, 'disabled', false);
            }, 1000);
        },
        uploadFiles: function uploadFiles(files) {
            var _this2 = this;

            this.uploading = true;
            __WEBPACK_IMPORTED_MODULE_5__helpers_FileHelpers__["a" /* default */].filesToFirebase(files, this.storagePath).then(function (fileGroup) {
                var newArrayValue = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].objectDeepGet(_this2, 'element/data/files') || []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fileGroup));
                __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].objectDeepSet(_this2, 'element/data/files', newArrayValue);

                _this2.uploading = false;
                _this2.updateFileCount();
            });
        },
        updateFileCount: function updateFileCount() {
            var files = __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].objectDeepGet(this, 'element/data/files') || [];
            __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].objectDeepSet(this, 'element/value', files.length + ' files');
        },
        fileNameFromStoragePath: function fileNameFromStoragePath(path) {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_FileHelpers__["a" /* default */].fileNameFromStoragePath(path);
        },
        deleteSelectedFiles: function deleteSelectedFiles(files) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var res;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.$confirm('Are you sure you want to delete all selected files?');

                            case 2:
                                res = _context.sent;

                                if (res) files.forEach(function (file) {
                                    _this3.deleteFileFromGroup(file);
                                });

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        deleteFileFromGroup: function deleteFileFromGroup(file) {
            __WEBPACK_IMPORTED_MODULE_5__helpers_FileHelpers__["a" /* default */].deleteFirebaseFile(file.url);

            var files = __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].objectDeepGet(this, 'element/data/files');
            var idx = files.findIndex(function (o) {
                return o.url == file.url;
            });
            files.splice(idx, 1);
            this.updateFileCount();
        },
        elementChanged: function elementChanged(newVal) {
            this.$emit('change', { value: newVal, data: this.element.data, previousValue: this.originalValue });
            this.originalValue = newVal;
        }
    },
    created: function created() {}
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ContactHelpers__ = __webpack_require__(9);


















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        action: Object
    },
    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        isFormValid: function isFormValid() {
            return true;
        },
        actionTypes: function actionTypes() {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__["a" /* default */].actionTypes;
        }
    },
    methods: {
        save: function save() {
            this.$emit('save', this.action);
            this.settings.visible = false;
        },
        showingDialog: function showingDialog() {},
        hidingDialog: function hidingDialog() {
            setTimeout(function () {}, 300);
        },
        deleteButtonClicked: function deleteButtonClicked() {
            this.$emit('delete', this.action);
            this.settings.visible = false;
        },
        setIdentifier: function setIdentifier() {
            if (!this.action.identifier && this.action.name) this.$set(this.action, 'identifier', __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__["a" /* default */].toCamelCase(this.action.name));
        }
    },

    created: function created() {
        this.settings.height = '350px';
    }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ContactHelpers__ = __webpack_require__(9);
















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        team: Object
    },
    components: {
        'DialogBox': __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        isFormValid: function isFormValid() {
            return true;
        }
    },
    methods: {
        save: function save() {
            this.$emit('save', this.team);
            this.settings.visible = false;
        },
        showingDialog: function showingDialog() {},
        hidingDialog: function hidingDialog() {
            setTimeout(function () {}, 300);
        }
    },

    created: function created() {
        this.settings.height = '350px';
    }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ContactHelpers__ = __webpack_require__(9);
















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        collection: Object
    },
    components: {
        'DialogBox': __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        isFormValid: function isFormValid() {
            return true;
        }
    },
    methods: {
        save: function save() {
            this.$emit('save', this.collection);
            this.settings.visible = false;
        },
        showingDialog: function showingDialog() {},
        hidingDialog: function hidingDialog() {
            setTimeout(function () {}, 300);
        }
    },

    created: function created() {
        this.settings.height = '350px';
    }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ElementControl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ElementControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__screens_ElementControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ContactHelpers__ = __webpack_require__(9);






















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        row: Object,
        fields: Array
    },
    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_15__ui_elements_DialogBox___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_14__ui_elements_DeleteButton___default.a,
        ElementControl: __WEBPACK_IMPORTED_MODULE_12__screens_ElementControl___default.a
    },
    data: function data() {
        return {
            page: {
                type: 'Group'
            }
        };
    },

    computed: {
        pageDefinition: function pageDefinition() {
            var _this = this;

            var elements = [];
            this.fields.forEach(function (field) {
                var element = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, field);
                delete element._id;
                element.rowId = _this.row._id;
                element.fieldId = field._id;
                element.value = _this.row[element.identifier];
                element.data = _this.row[element.identifier + 'Data'];
                element.name = element.identifier;
                element.title = field.name;

                elements.push(element);
            });
            return {
                title: null,
                type: 'Group',
                flat: true,
                hideIcons: true,
                hideTitle: true,
                elements: elements
            };
        }
    },
    methods: {
        debugRecord: function debugRecord() {
            var path = this.row._path + '/' + this.row._id;
            __WEBPACK_IMPORTED_MODULE_13__data_Firestore__["a" /* default */].openConsole(path);
        },
        newRowValues: function newRowValues(previousRow, elements) {
            var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, previousRow);
            newRow._key = newRow._key || __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].getKey();
            elements.forEach(function (element) {
                if (typeof element.value !== 'undefined') newRow[element.name] = element.value;
                if (typeof element.data !== 'undefined') newRow[element.name + 'Data'] = element.data;
            });
            return newRow;
        },
        save: function save() {
            var newRow = this.newRowValues(this.row, this.page.elements);
            this.$emit('save', newRow);
            this.settings.visible = false;
        },
        showingDialog: function showingDialog() {
            this.page = this.pageDefinition;
        },
        hidingDialog: function hidingDialog() {
            var _this2 = this;

            setTimeout(function () {
                _this2.page = { type: 'Group' };
            }, 300);
        },
        deleteButtonClicked: function deleteButtonClicked() {
            this.$emit('delete', this.row);
            this.settings.visible = false;
        }
    },

    created: function created() {
        this.settings.height = '350px';
    }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ContactHelpers__ = __webpack_require__(9);


















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        field: Object
    },
    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        isFormValid: function isFormValid() {
            return true;
        },
        fieldTypes: function fieldTypes() {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__["a" /* default */].fieldTypes;
        },
        controlTypes: function controlTypes() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__["a" /* default */].controlTypes.filter(function (o) {
                return o.field == _this.field.type;
            });
        }
    },
    methods: {
        save: function save() {
            this.$emit('save', this.field);
            this.settings.visible = false;
        },
        showingDialog: function showingDialog() {
            if (this.field.name && !this.field.identifier) this.setIdentifier();
        },
        hidingDialog: function hidingDialog() {
            setTimeout(function () {}, 300);
        },
        deleteButtonClicked: function deleteButtonClicked() {
            this.$emit('delete', this.field);
            this.settings.visible = false;
        },
        setIdentifier: function setIdentifier() {
            if (!this.field.identifier && this.field.name) this.$set(this.field, 'identifier', __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__["a" /* default */].toCamelCase(this.field.name));
        }
    },

    created: function created() {
        this.settings.height = '350px';
    }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_async_computed__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer2__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_LayoutContainer2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__screens_SectionLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_ElementLayout__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_ElementLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__screens_ElementLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_LayoutReadOnly__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_LayoutReadOnly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_LayoutReadOnly__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_ElementMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__screens_ElementMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ScrollHelpers__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_json_to_csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TeamDialog__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TeamDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__TeamDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CollectionDialog__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CollectionDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__CollectionDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FieldDialog__ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FieldDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__FieldDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ActionDialog__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ActionDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ActionDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DataDialog__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DataDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__DataDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_DateRangeList__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_DateRangeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ui_elements_DateRangeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_Merger__ = __webpack_require__(2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_Merger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ui_elements_Merger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__screens_ScreenData__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__screens_ScreenTable__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__screens_ScreenTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__screens_ScreenTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BulkUpdateDialog__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BulkUpdateDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__BulkUpdateDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers_TemplateHelpers__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__helpers_RouterHelpers__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__data_Data4__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__data_Firestore__ = __webpack_require__(27);













































var PageSection = function () {
    function PageSection(section) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageSection);

        this.section = section;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PageSection, [{
        key: 'fieldByName',
        value: function fieldByName(name) {
            return this.section.fields.find(function (o) {
                return o.name == name;
            }) || null;
        }
    }]);

    return PageSection;
}();

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _ref;

        return _ref = {

            searchText: '',
            db: {},

            teams: [],
            collections: []

        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'teams', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tables', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'teamDialog', {
            settings: {
                visible: false,
                title: 'New Team'
            },
            team: {}
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'collectionDialog', {
            settings: {
                visible: false,
                title: 'New Collection'
            },
            collection: {}
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'bulkUpdateDialog', {
            settings: {
                visible: false,
                title: 'Bulk Update'
            },
            collection: {}
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fieldDialog', {
            settings: {
                visible: false,
                title: null
            },
            field: {}
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'actionDialog', {
            settings: {
                visible: false,
                title: null
            },
            action: {
                operation: ['Create', 'Update']
            }
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dataDialog', {
            settings: {
                visible: false,
                title: null
            },
            row: {},
            fields: []
        }), _ref;
    },


    components: {
        ScreenLayout: __WEBPACK_IMPORTED_MODULE_12__screens_ScreenLayout___default.a,
        TeamDialog: __WEBPACK_IMPORTED_MODULE_15__TeamDialog___default.a,
        CollectionDialog: __WEBPACK_IMPORTED_MODULE_16__CollectionDialog___default.a,
        FieldDialog: __WEBPACK_IMPORTED_MODULE_17__FieldDialog___default.a,
        ActionDialog: __WEBPACK_IMPORTED_MODULE_18__ActionDialog___default.a,
        DataDialog: __WEBPACK_IMPORTED_MODULE_19__DataDialog___default.a,
        BulkUpdateDialog: __WEBPACK_IMPORTED_MODULE_24__BulkUpdateDialog___default.a,
        Flag: __WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag___default.a,
        Merger: __WEBPACK_IMPORTED_MODULE_21__ui_elements_Merger___default.a
    },

    props: {
        teamId: String,
        collectionId: String
    },

    computed: {
        collection: function collection() {
            return this.$store.getters.getCollection(this.teamSlug, this.collectionSlug);
        },
        pageTitle: function pageTitle() {
            return (this.activeTeam.name || '') + (this.activeTeam.name && this.activeCollection.name ? ' - ' : '') + (this.activeCollection.name || '') || 'Taco';
        },
        activeCollection: function activeCollection() {
            var _this = this;

            return this.collections.find(function (o) {
                return o._id == _this.collectionId;
            }) || {};
        },
        activeTeam: function activeTeam() {
            var _this2 = this;

            return this.teams.find(function (o) {
                return o._id == _this2.teamId;
            }) || {};
        },
        teamSlug: function teamSlug() {
            return __WEBPACK_IMPORTED_MODULE_26__helpers_StringHelpers__["a" /* default */].toCamelCase(this.activeTeam.name) || 'nullTeam';
        },
        collectionSlug: function collectionSlug() {
            return __WEBPACK_IMPORTED_MODULE_26__helpers_StringHelpers__["a" /* default */].toCamelCase(this.activeCollection.name) || 'nullCollection';
        },
        teamsItems: function teamsItems() {
            return this.teams.map(function (o) {
                return { text: o.name, value: o._id };
            });
        },
        collectionsListRef: function collectionsListRef() {
            var ref = __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].getTeamRef(this.teamSlug).collection('collections');
            ref.storePath = true;
            return ref;
        },
        collectionRef: function collectionRef() {
            return __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].getCollectionDocumentRef(this.teamSlug, this.collectionSlug);
        },
        fieldsRef: function fieldsRef() {
            var ref = this.collectionRef.collection('fields');
            ref.storePath = true;
            return ref;
        },
        dataRef: function dataRef() {
            return this.collectionRef.collection('data');
        }
    },

    methods: {
        loadTeams: function loadTeams() {
            var ref = __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].getFirestore().collection('teams');
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].streamCollection(ref, this.teams);
        },
        loadCollections: function loadCollections() {
            if (this.teamSlug == 'nullteam') return;
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].streamCollection(this.collectionsListRef, this.collections);
        },
        loadCollection: function loadCollection() {

            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].streamToStore(this.teamSlug, this.collectionSlug);
        },
        selectCollection: function selectCollection(collection) {
            __WEBPACK_IMPORTED_MODULE_32__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 'c', collection._id);
        },
        selectTeam: function selectTeam(teamId) {

            if (teamId == 'add') {
                this.showTeamDetails(null);
                return;
            }

            __WEBPACK_IMPORTED_MODULE_32__helpers_RouterHelpers__["a" /* default */].setQueryParameter(this, 't', teamId);
        },
        showTeamDetails: function showTeamDetails(team) {
            this.teamDialog.team = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, team);
            this.teamDialog.settings.title = this.teamDialog.team.name || 'Add a Team';
            this.teamDialog.settings.visible = true;
        },
        saveTeam: function saveTeam(team) {
            console.log('saving', team);
            team._path = 'teams';
            team._id = team._id || team.name;
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].saveItem(team);
        },
        showCollectionDetails: function showCollectionDetails(collection) {
            this.collectionDialog.collection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collection);
            this.collectionDialog.settings.title = this.collectionDialog.collection.name || 'Add a Collection';

            this.collectionDialog.settings.visible = true;
        },
        saveCollection: function saveCollection(collection) {
            console.log('saving', collection);
            collection._path = collection._path || 'teams/' + this.teamSlug + '/collections';
            collection._id = collection._id || collection.name;
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].saveItem(collection);
        },
        showFieldDetails: function showFieldDetails(field) {
            this.fieldDialog.settings.title = field ? 'Modify Field' : 'New Field';
            this.fieldDialog.field = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, field);
            this.fieldDialog.field._path = this.fieldDialog.field._path || 'teams/' + this.teamSlug + '/collections/' + this.collectionSlug + '/fields';
            this.fieldDialog.settings.visible = true;
        },
        saveField: function saveField(field) {
            console.log('saving', field);
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].saveItem(field);
        },
        deleteField: function deleteField(field) {
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].deleteItem(field);
        },
        showActionDetails: function showActionDetails(action) {
            this.actionDialog.settings.title = action ? 'Modify Action' : 'New Action';
            this.actionDialog.action = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, action);
            this.actionDialog.action._path = this.actionDialog.action._path || 'teams/' + this.teamSlug + '/collections/' + this.collectionSlug + '/actions';
            this.actionDialog.settings.visible = true;
        },
        saveAction: function saveAction(action) {
            console.log('saving', action);
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].saveItem(action);
        },
        deleteAction: function deleteAction(action) {
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].deleteItem(action);
        },
        showDataDetails: function showDataDetails(row, fields) {
            this.dataDialog.settings.title = row ? 'Modify Record' : 'New Record';
            this.dataDialog.row = __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].cloneForEdit(row);
            this.dataDialog.row._path = this.dataDialog.row._path || 'teams/' + this.teamSlug + '/collections/' + this.collectionSlug + '/data';
            this.dataDialog.fields = fields;
            this.dataDialog.settings.visible = true;
        },
        saveData: function saveData(record) {
            console.log('Saving Data...', record);
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].saveAndAction(record);
        },
        deleteData: function deleteData(row) {
            console.log('dltng');
            __WEBPACK_IMPORTED_MODULE_39__data_Firestore__["a" /* default */].deleteItem(row);
        },
        showBulkUpdate: function showBulkUpdate() {}
    },

    watch: {
        activeTeam: {
            handler: function handler(val, oldVal) {
                this.loadCollections();
            }
        },
        activeCollection: {
            handler: function handler(val, oldVal) {
                this.loadCollection();
            }
        }
    },

    created: function created() {
        this.loadTeams();
        this.loadCollections();
        __WEBPACK_IMPORTED_MODULE_27__helpers_DataHelpers__["a" /* default */].fetchUser().then(function (user) {
            console.log('logged in as id', __WEBPACK_IMPORTED_MODULE_27__helpers_DataHelpers__["a" /* default */].getUserId());
        });
    }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ContactHelpers__ = __webpack_require__(9);
















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        team: Object
    },
    components: {
        'DialogBox': __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        isFormValid: function isFormValid() {
            return true;
        }
    },
    methods: {
        save: function save() {
            this.$emit('save', this.team);
            this.settings.visible = false;
        },
        showingDialog: function showingDialog() {},
        hidingDialog: function hidingDialog() {
            setTimeout(function () {}, 300);
        }
    },

    created: function created() {
        this.settings.height = '350px';
    }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_UserHelpers__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_CloudHelpers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_UniqueContactEnforcer__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_UniqueContactEnforcer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_UniqueContactEnforcer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailBox__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_LookupData__ = __webpack_require__(30);






















var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        visible: Boolean,
        data: Object
    },
    components: {
        UniqueContactEnforcer: __WEBPACK_IMPORTED_MODULE_13__ui_elements_UniqueContactEnforcer___default.a, EmailBox: __WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailBox___default.a
    },
    data: function data() {
        return {

            primaryEmailValidationErrors: '',
            secondaryEmailValidationErrors: '',

            namesRules: [function (v) {
                return v.length > 2 || 'Valid names required';
            }, function (v) {
                return v.indexOf(' ') > -1 && v.indexOf(' ') < v.length - 1 || 'Include both names';
            }],
            emailValidationRules: [function (v) {
                return !v || __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].isEmail(v) || 'Enter a valid email format';
            }],
            requiredRules: [function (v) {
                return v && v.length > 2 || 'This field is required';
            }],

            valid: true,

            dialogVisible: this.visible,

            fullNames: '',
            fullNamesHint: 'eg. John and June Citizen',

            primaryFirstName: '',
            primaryLastName: '',
            primaryGender: '',
            primaryImage: '',
            secondaryFirstName: '',
            secondaryLastName: '',
            secondaryGender: '',
            secondaryImage: '',

            validNames: false,

            primaryMobile: '',
            primaryEmail: '',

            secondaryMobile: '',
            secondaryEmail: '',

            transactionName: '',
            masterKey: __WEBPACK_IMPORTED_MODULE_18__helpers_LookupData__["a" /* default */].getMasterKey(),

            transactionTemplates: [],

            tenantKey: __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getTenantKey()

        };
    },

    computed: {
        defaultTransactionTemplateKey: function defaultTransactionTemplateKey() {
            if (this.transactionTemplates.length < 1) return null;
            var template = this.transactionTemplates.find(function (o) {
                return o.meta.key;
            });
            if (template) return template.meta.key;
            return this.transactionTemplates[0];
        },
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '545px';
        },
        title: function title() {
            if (this.marriedCouple) return 'Add Married Couple';else if (this.couple) return 'Add Couple';else return 'Add Client';
        },
        primaryMobileLabel: function primaryMobileLabel() {
            if (this.primaryFirstName) return this.primaryFirstName + "'s Mobile";else return 'Primary Mobile';
        },
        primaryEmailLabel: function primaryEmailLabel() {
            if (this.primaryFirstName) return this.primaryFirstName + "'s Email";else return 'Primary Email';
        },
        secondaryMobileLabel: function secondaryMobileLabel() {
            if (this.secondaryFirstName) return this.secondaryFirstName + "'s Mobile";else return 'Secondary Mobile';
        },
        secondaryEmailLabel: function secondaryEmailLabel() {
            if (this.secondaryFirstName) return this.secondaryFirstName + "'s Email";else return 'Secondary Email';
        },
        individual: function individual() {
            return this.secondaryFirstName.length === 0;
        },
        couple: function couple() {
            return this.secondaryFirstName.length > 1;
        },
        marriedCouple: function marriedCouple() {
            return this.couple && this.secondaryLastName == this.primaryLastName && this.primaryLastName.length > 0;
        },
        officesList: function officesList() {
            return this.$store.getters.officesActive;
        },
        primaryContactName: function primaryContactName() {
            return {
                firstName: this.primaryFirstName,
                lastName: this.primaryLastName
            };
        },
        secondaryContactName: function secondaryContactName() {
            return {
                firstName: this.secondaryFirstName,
                lastName: this.secondaryLastName
            };
        }
    },
    methods: {
        checkForDemo: function checkForDemo() {
            if (this.fullNames != 'demo') return;

            this.fullNames = 'Michael and Jessica Hampton';
            this.primaryMobile = '0413999951';
            this.primaryEmail = 'matt@ireland.mx';
            this.secondaryMobile = '0414012714';
            this.secondaryEmail = 'linda.a.ireland@gmail.com';
            this.transactionName = 'Purchase owner occ home';
        },
        getTenantsRef: function getTenantsRef() {
            return db.ref('tenants/' + this.tenantKey);
        },
        calculateNames: function calculateNames() {
            console.log('calcing names');
            this.checkForDemo();

            var fullNames = this.fullNames;
            fullNames = fullNames.replace(' & ', ';').replace(/ and /gi, ';');
            var namesArr = fullNames.split(';');

            this.validNames = true;

            var singleNameArr = namesArr[0].split(' ');
            this.primaryFirstName = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(singleNameArr[0]);

            if (singleNameArr.length > 1) this.primaryLastName = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(singleNameArr[1]);else this.primaryLastName = '';

            if (namesArr.length > 1) {
                singleNameArr = namesArr[1].split(' ');
                this.secondaryFirstName = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(singleNameArr[0]);

                if (singleNameArr.length > 1) this.secondaryLastName = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].capitalizeFirstLetter(singleNameArr[1]);else this.secondaryLastName = '';
            } else {
                this.secondaryFirstName = '';
                this.secondaryLastName = '';
            }

            if (this.primaryLastName == 'An' || this.primaryLastName == 'And' || this.primaryLastName.length < 2) this.primaryLastName = '';

            if (this.primaryLastName && this.secondaryFirstName && !this.secondaryLastName) this.secondaryLastName = this.primaryLastName;

            if (this.secondaryLastName && !this.primaryLastName) this.primaryLastName = this.secondaryLastName;

            if (this.primaryFirstName.length < 2 || this.primaryLastName < 2) this.validNames = false;

            if (this.secondaryFirstName) if (this.secondaryFirstName.length < 2 || this.secondaryLastName.length < 2) this.validNames = false;
        },
        cleanNames: function cleanNames() {

            var fullNames = void 0;
            if (this.marriedCouple) fullNames = this.primaryFirstName + ' and ' + this.secondaryFirstName + ' ' + this.primaryLastName;else if (this.couple) fullNames = this.primaryFirstName + ' ' + this.primaryLastName + ' and ' + this.secondaryFirstName + ' ' + this.secondaryLastName;else fullNames = this.primaryFirstName + ' ' + this.primaryLastName;

            this.fullNames = fullNames;

            var vm = this;

            __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].getGender(this.primaryFirstName).then(function (gender) {
                vm.primaryGender = gender;
                vm.primaryImage = __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].getSampleImage(gender);
            });
            __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].getGender(this.secondaryFirstName).then(function (gender) {
                vm.secondaryGender = gender;
                vm.secondaryImage = __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].getSampleImage(gender);
            });
            this.$refs.enforcer1.check();
            this.$refs.enforcer2.check();
        },
        clickedSave: function clickedSave(mode) {

            var secondaryEmailComponent = this.$refs.secondaryEmail;
            var secondaryEmailValidationResult = secondaryEmailComponent ? secondaryEmailComponent.validate() : true;

            if (!this.$refs.form.validate() || !this.$refs.primaryEmail.validate() || !secondaryEmailValidationResult) return;

            var vm = this;
            var secondaryClient = void 0;
            var tenantRef = this.getTenantsRef();
            var couple = this.secondaryFirstName.length > 1;
            var created = __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelpers__["a" /* default */].todayString();
            var openedAt = __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelpers__["a" /* default */].nowString();

            var primaryKey = db.ref().push().key;
            var secondaryKey = db.ref().push().key;
            var transactionKey = db.ref().push().key;

            var me = this.$store.getters.user;
            var owner = {

                key: me.uid || __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getUserId(),
                firstName: me.firstName || '',
                lastName: me.lastName || ''
            };

            var primaryClient = {
                firstName: this.primaryFirstName,
                lastName: this.primaryLastName,
                mobile: this.primaryMobile,
                email: this.primaryEmail,
                created: created,
                gender: this.primaryGender,
                image: this.primaryImage,
                owner: owner,
                groups: { Client: true },
                openedAt: __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelpers__["a" /* default */].nowString()
            };

            __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].formatMobileForContact(primaryClient);

            if (couple) {
                secondaryClient = {
                    firstName: this.secondaryFirstName,
                    lastName: this.secondaryLastName,
                    mobile: this.secondaryMobile,
                    email: this.secondaryEmail,
                    partner: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, primaryClient, { key: primaryKey }),
                    created: created,
                    gender: this.secondaryGender,
                    image: this.secondaryImage,
                    owner: owner,
                    groups: { Client: true },
                    openedAt: __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelpers__["a" /* default */].nowString()

                };

                __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].formatMobileForContact(secondaryClient);

                primaryClient.partner = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, secondaryClient, { key: secondaryKey });
            }

            tenantRef.child('contacts').child(primaryKey).set(primaryClient);
            __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].saveToAlgolia(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, primaryClient, { key: primaryKey, tenantKey: this.tenantKey }));

            if (couple) {
                tenantRef.child('contacts').child(secondaryKey).set(secondaryClient);
                __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].saveToAlgolia(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, secondaryClient, { key: secondaryKey, tenantKey: this.tenantKey }));
            }

            var transaction = {
                description: this.transactionName,
                created: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_date_fns__["a" /* format */])(new Date(), __WEBPACK_IMPORTED_MODULE_12__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS),
                clients: this.fullNames,
                masterKey: this.masterKey
            };

            tenantRef.child('transactions').child(transactionKey).child('details').set(transaction);

            tenantRef.child('contactTransactions').child(primaryKey).child(transactionKey).set(transaction);
            delete primaryClient.partner;

            tenantRef.child('transactions').child(transactionKey).child('people').child(primaryKey).set(primaryClient);

            tenantRef.child('transactions').child(transactionKey).child('elements').child(primaryKey).set({
                type: 'Contact',
                name: 'client',
                tabKey: 'settings',
                transactionKey: transactionKey,
                role: 'Client',
                contactKey: primaryKey,
                contact: primaryClient,
                value: __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].fullName(primaryClient)
            });

            if (this.couple) {
                tenantRef.child('contactTransactions').child(secondaryKey).child(transactionKey).set(transaction);
                delete secondaryClient.partner;

                tenantRef.child('transactions').child(transactionKey).child('elements').child(secondaryKey).set({
                    type: 'Contact',
                    name: 'client',
                    tabKey: 'settings',
                    transactionKey: transactionKey,
                    role: 'Client',
                    contactKey: secondaryKey,
                    contact: secondaryClient,
                    value: __WEBPACK_IMPORTED_MODULE_6__helpers_ContactHelpers__["a" /* default */].fullName(secondaryClient)
                });
            }

            var result = {
                mode: mode,
                transactionKey: transactionKey,
                tenantKey: this.tenantKey
            };

            this.$emit('save', result);
        },
        clickedCancel: function clickedCancel() {
            this.$emit('cancel');
        },
        initialiseDialog: function initialiseDialog() {
            var _this = this;

            if (this.$refs.form) this.$refs.form.resetValidation();
            this.primaryEmailValidationErrors = '';
            this.secondaryEmailValidationErrors = '';
            this.fullNames = '';
            this.primaryFirstName = '';
            this.primaryLastName = '';
            this.primaryGender = '';
            this.primaryImage = '';

            this.secondaryFirstName = '';
            this.secondaryLastName = '';
            this.secondaryGender = '';
            this.secondaryImage = '';
            this.primaryMobile = '';
            this.primaryEmail = '';
            this.secondaryMobile = '';
            this.secondaryEmail = '';
            this.transactionName = '';
            var preferredOffice = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].preferredOffice();
            this.tenantKey = preferredOffice.meta.key;

            var ref = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getTenantRef(this.tenantKey).child('transactionTemplates');
            return __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (templates) {
                _this.transactionTemplates = templates;
                var defaultTransactionTemplate = _this.transactionTemplates.find(function (template) {
                    return template.isDefault;
                });
                if (defaultTransactionTemplate && defaultTransactionTemplate.meta) _this.masterKey = defaultTransactionTemplate.meta.key;
            });
        }
    },
    watch: {
        'visible': function visible(newVal) {
            this.dialogVisible = newVal;
            if (newVal) {
                this.initialiseDialog();
                __WEBPACK_IMPORTED_MODULE_16__helpers_Utilities__["a" /* default */].focus(this, 'fullNames');
            }
        }
    }

});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_InterfaceField__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builder_InterfaceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__builder_InterfaceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox___default.a, InterfaceField: __WEBPACK_IMPORTED_MODULE_2__builder_InterfaceField___default.a, DeleteButton: __WEBPACK_IMPORTED_MODULE_3__ui_elements_DeleteButton___default.a
    },

    props: {
        settings: Object,
        fields: Array,
        record: Object
    },

    computed: {
        menus: function menus() {
            return this.fields.filter(function (o) {
                return o.type == 'Menu';
            });
        }
    },

    methods: {
        saveRecord: function saveRecord() {
            this.$emit('save', this.record);
        },
        deleteButtonClicked: function deleteButtonClicked() {
            this.$emit('delete', this.record);
        },
        menuClicked: function menuClicked(menu) {
            var record = this.record;
            this.$emit('menu', { menu: menu, record: record });
        },
        show: function show() {}
    },

    created: function created() {}
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_AdvancedDialog__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_AdvancedDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_AdvancedDialog__);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            localItems: [],
            fields: [{ name: 'name', title: 'Name', type: 'Text' }, { name: 'type', title: 'Type', type: 'List', options: 'Document, Group' }],
            editDialog: {
                record: {},
                settings: {
                    visible: false
                }
            }
        };
    },


    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
        AdvancedDialog: __WEBPACK_IMPORTED_MODULE_5__ui_elements_AdvancedDialog___default.a
    },

    props: {
        dataRef: Object,
        items: Array
    },

    computed: {},

    methods: {
        afterDrag: function afterDrag(e) {
            console.log('dragged', e);
            var newItem = this.localItems[e.newIndex];
            newItem.order = __WEBPACK_IMPORTED_MODULE_4__helpers_OrderHelpers__["a" /* default */].getAverageOrder(e);
            __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].saveItem(newItem);
        },
        editItem: function editItem(item) {
            this.editDialog.record = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
            this.editDialog.settings.visible = true;
        },
        addItem: function addItem() {
            var item = {
                meta: {
                    key: __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: this.dataRef.toString().split('/').splice(3).join('/'),
                    savePosition: 'top'
                }
            };
            this.editItem(item);
        },
        saveRecord: function saveRecord(record) {
            __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].saveItem(record);
        },
        deleteRecord: function deleteRecord(record) {
            __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].deleteItem(record);
            this.editDialog.settings.visible = false;
        },
        itemClicked: function itemClicked(item) {
            this.$emit('click', item);
        }
    },

    watch: {
        'items': {
            handler: function handler(newVal, oldVal) {

                if (newVal && newVal.length) this.localItems = newVal;
            },
            immediate: true
        }
    },

    created: function created() {}
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_NiceData__ = __webpack_require__(15);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        InterfaceField: __WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField___default.a
    },

    props: {
        settings: Object,
        fields: Array,
        record: Object,
        recordRef: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        fieldChanged: function fieldChanged(changes) {
            console.log('AdvancedPanel > fieldChanged > changes ', changes);
            __WEBPACK_IMPORTED_MODULE_2__data_NiceData__["a" /* default */].saveField(this.recordRef.child(changes.name), changes.value);
            this.$emit('field-change', changes);
        },
        fieldInput: function fieldInput(newVal) {
            console.log('input', newVal);
        },
        buttonClicked: function buttonClicked(field) {
            this.$emit('button', field.name, this.record);
        }
    },

    created: function created() {}
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlgoliaHelpers__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            contacts: [],
            search: '',
            contact: {}
        };
    },


    components: {},

    props: {
        item: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        select: function select(newVal) {
            this.$emit('select', newVal);
            this.search = "";
        },
        jump: function jump(newVal) {
            this.$emit('jump', newVal);
            this.search = "";
        },
        runSearch: function runSearch() {
            var _this = this;

            var index = __WEBPACK_IMPORTED_MODULE_2__helpers_AlgoliaHelpers__["a" /* default */].getContactIndex(__WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getTenantKey());
            index.search(this.search, { hitsPerPage: 15 }).then(function (result) {
                console.log(result);
                _this.contacts = result.hits.map(function (c) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, {
                        fullName: c.firstName + ' ' + c.lastName,
                        fullNameHighlighted: c._highlightResult.firstName.value + ' ' + c._highlightResult.lastName.value
                    });
                });
            });
        },
        bestContact: function bestContact(contact) {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__["a" /* default */].bestNumber(contact);
        },
        focus: function focus() {
            this.$refs.contactSearch.focus();
        }
    },

    created: function created() {},


    watch: {
        'search': {
            handler: function handler(newVal) {
                if (newVal) this.runSearch();else this.contacts = [];
            }
        }
    }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField__);


var ANNOUNCEMENT_NUMBER = 9;
var BUTTON_TEXT = "Love It";




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            visible: false
        };
    },


    components: {
        InterfaceField: __WEBPACK_IMPORTED_MODULE_1__builder_InterfaceField___default.a
    },

    props: {
        item: Object
    },

    computed: {
        buttonText: function buttonText() {
            return BUTTON_TEXT;
        },
        announcementField: function announcementField() {
            return { name: 'announcement', type: 'Embed', disabled: true };
        },
        announcementRecord: function announcementRecord() {
            return {
                announcement: 'https://docs.google.com/document/d/e/2PACX-1vTnYt3aI8BKbFsTx5lQK4xyLxCnqURErNDJnHnX813xS9Y1FFO6H1wrJQUYjMN4SMTlEixljMC_xk69/pub?embedded=true'
            };
        }
    },

    methods: {
        dismiss: function dismiss() {
            localStorage.setItem('announcementNumber', ANNOUNCEMENT_NUMBER);
            this.visible = false;
        }
    },

    created: function created() {
        var announcementNumber = localStorage.getItem('announcementNumber') || 0;
        if (announcementNumber < ANNOUNCEMENT_NUMBER) this.visible = true;
    }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ScrollHelpers__ = __webpack_require__(63);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            scrollingProgramatically: false

        };
    },


    components: {},

    props: {
        scrollingElementId: String,
        sectionElementClass: String,
        activeSectionKey: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        goToSection: function goToSection(key) {
            var _this = this;

            var scrollingElement = document.getElementById(this.scrollingElementId);
            var el = scrollingElement.querySelector('.' + this.sectionElementClass + '[data-key="' + key + '"]');
            this.scrollingProgramatically = true;
            scrollingElement.scrollTop = el ? el.offsetTop - 100 : 0;
            setTimeout(function () {
                _this.scrollingProgramatically = false;
            }, 1000);
        }
    },

    watch: {
        'activeSectionKey': {
            handler: function handler(newVal) {
                this.goToSection(newVal);
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        var scrollingElement = document.getElementById(this.scrollingElementId);

        __WEBPACK_IMPORTED_MODULE_1__helpers_ScrollHelpers__["a" /* default */].scrollStop(scrollingElement, function () {
            if (_this2.scrollingProgramatically) return;

            var firstEl = __WEBPACK_IMPORTED_MODULE_1__helpers_ScrollHelpers__["a" /* default */].getFirstVisibleElement(scrollingElement, _this2.sectionElementClass);
            _this2.$emit('change', firstEl.dataset.key);
        });
    }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_TagStatusHelpers__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_BillingHelpers__ = __webpack_require__(284);















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        charge: Object
    },
    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_1__ui_elements_DialogBox___default.a,
        DateTime: __WEBPACK_IMPORTED_MODULE_2__ui_elements_DateTime___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_4__ui_elements_UserChooser___default.a,
        CurrencyBox: __WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox___default.a
    },
    data: function data() {
        return {
            charges: [{ text: 'Settlement (normal)', amount: 290 }, { text: 'Settlement (construct)', amount: 390 }, { text: 'Increase', amount: 110 }, { text: 'Admin Support', amount: 50 }, { text: 'Submission (normal)', amount: 200 }, { text: 'Submission (data)', amount: 120 }, { text: 'Submission (lodgement)', amount: 80 }, { text: 'Processing to Approval', amount: 175 }, { text: 'Approval to Settlement', amount: 160 }, { text: 'Complex Submission Loading (1)', amount: 75 }, { text: 'Complex Submission Loading (2)', amount: 160 }, { text: 'Urgent Submission', amount: 60 }, { text: 'Cloned Submission', amount: 100 }, { text: 'Withdrawn (short)', amount: 50 }, { text: 'Withdrawn (long)', amount: 75 }]

        };
    },

    computed: {
        chargeDescriptions: function chargeDescriptions() {
            return this.charges.map(function (o) {
                return {
                    text: o.text + ' ' + __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].formatCurrency(o.amount),
                    value: o.text
                };
            });
        },
        transaction: function transaction() {
            return this.$store.getters.transaction;
        },
        validationErrors: function validationErrors() {
            try {

                var errors = '';
                if (!this.charge.description || this.charge.description.length < 5) {
                    errors += 'Enter a proper description. ';
                }
                if (!this.charge.clients || this.charge.clients.length < 5) {
                    errors += 'Enter clients details. ';
                }
                if (!this.charge.date) {
                    errors += 'Enter a date. ';
                }
                if (!this.charge.amount) {
                    errors += 'Choose a valid charge amount. ';
                }
                if (!this.charge.from.user && !this.charge.from.uid) {
                    errors += 'The charge is not from a valid user. ';
                }
                return errors;
            } catch (e) {
                console.log('errors building charge validation string', e);
            }
        }
    },
    methods: {
        setBrokerName: function setBrokerName() {
            this.$set(this.charge, 'brokerName', __WEBPACK_IMPORTED_MODULE_9__helpers_ContactHelpers__["a" /* default */].fullName(this.charge.to));
        },
        updatePrice: function updatePrice(newVal) {
            if (!newVal) return;

            var chargeType = this.charges.find(function (o) {
                return o.text == newVal;
            });
            if (chargeType) this.charge.amount = chargeType.amount;else this.charge.amount = this.charges[0].amount;
        },
        save: function save() {
            __WEBPACK_IMPORTED_MODULE_11__helpers_BillingHelpers__["a" /* default */].saveCharge(this.charge);
            var fromFullName = __WEBPACK_IMPORTED_MODULE_9__helpers_ContactHelpers__["a" /* default */].fullName(this.charge.from);
            var auDate = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].backwardsToAu(this.charge.date);

            var summary = 'Charged ' + __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].formatCurrency(this.charge.amount) + ' from ' + fromFullName + ' on ' + auDate;
            this.charge.description = '';
            this.charge.amount = 0;
            this.charge.clients = '';
            __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__["a" /* default */].showAlert(summary);
            this.$emit('saved', summary);
        },
        dialogShown: function dialogShown() {
            console.log('setting broker name....');
            this.setBrokerName();
        }
    },

    created: function created() {}
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_LabelMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_LabelMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_LabelMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_Firestore__ = __webpack_require__(27);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            newMessage: '',
            mode: 'idle',
            messages: [],
            office: '1',
            messageLimit: 10
        };
    },


    components: {
        LabelMenu: __WEBPACK_IMPORTED_MODULE_1__ui_elements_LabelMenu___default.a,
        ScrollDownDiv: __WEBPACK_IMPORTED_MODULE_2__ui_elements_ScrollDownDiv___default.a
    },

    props: {
        item: Object
    },

    computed: {
        currentUserImage: function currentUserImage() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getUser().image;
        },
        menuItems: function menuItems() {
            return this.offices.map(function (o) {
                return {
                    text: o.name,
                    value: o.meta.key
                };
            });
        },
        offices: function offices() {
            return this.$store.getters.officesActive;
        },
        chatPath: function chatPath() {
            var teamName = __WEBPACK_IMPORTED_MODULE_4__helpers_LookupData__["a" /* default */].officeTeams()[this.office];
            var teamSlug = __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].toCamelCase(teamName);
            return '/teams/' + teamSlug + '/collections/chats/data';
        }
    },

    methods: {
        isMyMessage: function isMyMessage(message) {
            return message.user.uid == __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getUser().uid;
        },
        chatsAdded: function chatsAdded() {
            if (this.mode == 'idle') this.mode = 'alert';
        },
        loadMessages: function loadMessages() {
            console.log('loading messages');
            var ref = __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].getCollectionDocumentRefFromPath(this.chatPath).orderBy('createdAt', "desc").limit(this.messageLimit);
            return __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].streamCollection(ref, this.messages, { reverse: true });
        },
        saveMessage: function saveMessage() {
            if (!this.newMessage) return;
            console.log(this.newMessage);


            __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].saveItem({
                text: this.newMessage,
                user: __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getUser(),
                _path: this.chatPath
            }).then(function () {});

            this.newMessage = '';
        },
        buttonClicked: function buttonClicked() {
            this.changeMode();
            if (this.mode == 'open') this.$refs.messageText.focus();
        },
        changeMode: function changeMode() {
            if (this.mode == 'open') this.mode = 'idle';else this.mode = 'open';
            console.log('mode changed to ', this.mode);
        }
    },

    created: function created() {
        var _this = this;

        setTimeout(function () {

            var office = _this.$store.getters.tenant.key;

            _this.office = office;

            _this.loadMessages();
        }, 500);
    },


    watch: {
        'messageLimit': {
            immediate: false,
            handler: function handler() {

                this.loadMessages();
            }
        },
        'office': {
            immediate: false,
            handler: function handler() {

                this.loadMessages();
            }
        }
    }

});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        items: Array
    },

    computed: {},

    methods: {
        bestName: function bestName(item) {
            return item.text || item.label || item.title || item.name || '[item]';
        },
        color: function color(item) {
            if (item._selected) return 'blue lighten-2';
            return 'grey lighten-1';
        },
        textColor: function textColor(item) {
            return 'white';
        },
        toggleSelection: function toggleSelection(item) {
            this.$set(item, '_selected', !item._selected);
        }
    },

    created: function created() {}
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        label: String,
        colours: Array,
        value: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        colourItemStyle: function colourItemStyle(colour) {
            return {
                'background-color': colour || 'white',
                'border': colour == this.value ? 'solid 4px #A9D0F5' : 'solid 3px white'
            };
        }
    },

    created: function created() {}
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__ = __webpack_require__(11);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        element: Object
    },

    components: {
        Flag: __WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag___default.a
    },

    computed: {
        elements: function elements() {
            return this.$store.getters.elements;
        },
        tabs: function tabs() {
            return this.elements.filter(function (o) {
                return o.type && o.type == 'Tab';
            }).sort(__WEBPACK_IMPORTED_MODULE_0__helpers_OrderHelpers__["a" /* default */].sortAscending);
        },
        dateElements: function dateElements() {
            return this.elements.filter(function (o) {
                return o.type == 'Date';
            });
        },
        nextTenDays: function nextTenDays() {
            var returnDates = [];
            for (var i = 0; i < 10; i++) {
                var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["e" /* addDays */])(new Date(), i);

                var dateStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(date, __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS);

                var day = {
                    date: dateStr,
                    day: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(date, 'EEE')
                };
                returnDates.push(day);
            }
            return returnDates;
        },
        upcomingDates: function upcomingDates() {
            var _this = this;

            var nextSevenDays = this.nextTenDays;
            nextSevenDays.forEach(function (day) {
                day.weekday = day.day.toUpperCase();
                day.shortDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(__WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].backwardsToDate(day.date), 'd/M');
                var events = _this.dateElements.filter(function (o) {
                    return o.value == day.date;
                });
                day.events = events;
                var tasks = _this.tasks.filter(function (o) {
                    return o.due == day.date;
                });
                day.tasks = tasks;
            });
            return nextSevenDays;
        },
        tasks: function tasks() {
            var _this2 = this;

            return this.$store.getters.tasks.filter(function (o) {
                return o.transactionKey == _this2.element.transactionKey;
            });
        }
    },

    methods: {
        milestonesForTab: function milestonesForTab(tabKey) {
            return this.milestones.filter(function (o) {
                return o.tabKey == tabKey;
            });
        },
        complete: function complete(element) {
            element.value = true;
            this.$emit('save', element);
        },
        notApplicable: function notApplicable(element) {
            element.na = true;
            this.$emit('save', element);
        }
    }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_TeamHelpers__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_EmailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_GroupSelector__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_GroupSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_GroupSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flow_ui_ContactImage__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flow_ui_ContactImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__flow_ui_ContactImage__);













/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            blankAvatars: false,
            smsGroup: 'General SMS',
            smsName: 'General',

            showingSMS: false,
            smsMessage: null,
            smsPrefix: null,
            smsSuffix: null,

            expandedView: this.expanded,

            emailDialog: {
                settings: {
                    visible: false,
                    group: '',
                    template: ''
                },
                email: {
                    to: [],
                    cc: [],
                    bcc: [],
                    subject: '',
                    body: '',
                    attachments: []
                }
            }
        };
    },


    computed: {
        templates: function templates() {
            var _this = this;

            return this.$store.getters.templates.filter(function (o) {
                return o.group == _this.smsGroup;
            });
        },
        isMobile: function isMobile() {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].isMobile();
        }
    },

    props: {
        contact: Object,
        expanded: Boolean
    },

    components: {
        'EmailDialog': __WEBPACK_IMPORTED_MODULE_1__ui_elements_EmailDialog___default.a,
        'GroupSelector': __WEBPACK_IMPORTED_MODULE_8__ui_elements_GroupSelector___default.a,
        ContactImage: __WEBPACK_IMPORTED_MODULE_9__flow_ui_ContactImage___default.a
    },

    methods: {
        getContactImage: function getContactImage(contact) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].getContactImage(contact, this.blankAvatars);
        },
        objectToArray: function objectToArray(obj) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].objectToArray(obj);
        },
        updateGroups: function updateGroups(groups) {
            console.log('CommunicationBar > updateGroups', groups, this.contact);
            var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contacts').child(this.contact.key).child('groups');
            ref.update(groups);
        },
        fullName: function fullName(contact) {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].fullName(contact);
        },
        showSMS: function showSMS() {

            if (this.isMobile) return;

            this.showingSMS = !this.showingSMS;

            if (!this.showingSMS) {
                this.smsMessage = '';
                return;
            }

            this.initialiseSMSTemplates();

            var vm = this;
            if (!this.smsPrefix) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getSettings('sms').then(function (settings) {
                    vm.smsPrefix = settings.prefix || 'Update';
                    vm.smsSuffix = settings.suffix || '*** This is a system mobile. Please dont reply ***';
                });
            }

            setTimeout(function () {
                vm.$refs.smsText.focus();
            }, 500);
        },
        toFaxAddress: function toFaxAddress(faxNumber) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].toFaxAddress(faxNumber);
        },
        sendSMSMessage: function sendSMSMessage() {
            console.log('CommunicationBar > sendSMS');
            var mobile = this.contact.mobile;
            var message = this.smsMessage;
            if (this.smsPrefix) message = '(' + this.smsPrefix + ') ' + message;
            if (this.smsSuffix) message = message + ' (' + this.smsSuffix + ')';
            __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].sendSMS(message, mobile);
            this.smsMessage = '';
            this.showingSMS = false;
        },
        showEmail: function showEmail(options) {
            console.log('CommunicationBar > showEmail');

            var recipient = __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].simplifyContact(this.contact);
            recipient.key = this.contact.meta.key;
            recipient.role = this.contact.meta.role || null;

            if (options && options.fax == true) recipient = __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].createFaxContact(recipient);

            this.emailDialog.email.to = [recipient];
            this.emailDialog.settings.group = 'General';
            this.emailDialog.settings.template = 'Blank';
            this.emailDialog.returnObject = null;
            this.emailDialog.settings.visible = true;
        },
        initialiseSMSTemplates: function initialiseSMSTemplates() {
            var _this2 = this;

            console.log('CommunicationBar > initialise');

            this.$store.dispatch('loadTemplates').then(function () {
                var template = _this2.templates.find(function (o) {
                    return o.name == (_this2.smsName || 'General SMS');
                });
                if (template) _this2.selectSMSTemplate(template);else console.log('Template not found:', _this2.smsName);
            });
        },
        selectSMSTemplate: function selectSMSTemplate(template) {
            console.log('CommunicationBar > selectSMSTemplate', template);
            this.smsMessage = template.subject.replace('[greeting]', __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].greetingFromContacts([this.contact]));
            if (this.$refs.smsText) this.$refs.smsText.focus();
        }
    },
    created: function created() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_0__helpers_TeamHelpers__["a" /* default */].fetchTeamSettings().then(function (settings) {
            _this3.blankAvatars = settings.blankAvatars;
        });
    },


    watch: {
        contact: function contact(newVal) {
            this.showingSMS = false;
        }
    }

});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 290,
        zIndex: 200
      }
    };
  },
  methods: {
    open: function open(title, message, options) {
      var _this = this;

      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.options, options);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    agree: function agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        item: Object,
        small: Boolean,
        corner: Boolean
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        value: Array,
        items: Array,
        label: String
    },

    components: {},

    computed: {
        itemsFormatted: function itemsFormatted() {
            return this.formatForCombo(this.items);
        },


        selectedItemsFormatted: {
            get: function get() {
                return this.formatForCombo(this.value);
            },
            set: function set(passedValue) {

                var cleanedContacts = this.cleanContacts(passedValue);

                this.$emit('input', cleanedContacts);
                this.$emit('change', cleanedContacts);
            }
        }
    },

    methods: {
        getImage: function getImage(item) {
            return item.image || '/static/images/user.png';
        },
        getHintText: function getHintText(item) {
            return (item.role ? item.role + ': ' : '') + item.email;
        },
        cleanContacts: function cleanContacts(items) {
            var newItems = [];
            items.forEach(function (item) {
                if (!__WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].isObject(item)) {
                    if (__WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].isEmail(item)) {
                        var newItem = {
                            key: __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getKey(),
                            email: item
                        };
                        newItems.push(newItem);
                    }
                } else {
                    newItems.push(item);
                }
            });
            return newItems;
        },
        formatForCombo: function formatForCombo(items) {
            if (!items) return [];
            return items.map(function (contact) {
                var newContact = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, contact);
                if (!contact || !contact.key) {
                    console.error('no contact key in formatforcombo');
                    return;
                }
                newContact.text = newContact.fullName || __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__["a" /* default */].fullName(newContact) || newContact.email;

                newContact.value = newContact.key.toString();
                return newContact;
            });
        },
        remove: function remove(item) {
            var selectedItems = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.selectedItemsFormatted));
            var index = selectedItems.findIndex(function (o) {
                return o.value == item.value;
            });
            if (index >= 0) {
                selectedItems.splice(index, 1);
                this.selectedItemsFormatted = selectedItems;
            }
        }
    }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        contact: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_CloudHelpers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageEditor__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ImageEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_UniqueContactEnforcer__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_UniqueContactEnforcer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_UniqueContactEnforcer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_EmailBox__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_EmailBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_EmailBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_DateTime__);













/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            valid: true,
            imageObj: {},
            advanced: false,
            imageObject: {},
            groupsArray: [],
            requiredRules: [function (v) {
                return v && v.length > 1 || 'Required';
            }],
            emailRules: [function (v) {
                return !v || __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].isEmail(v) || 'Enter a valid email';
            }],
            mobileRules: [function (v) {
                return !v || __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].isMobileNumber(v) || 'Enter a valid mobile';
            }],
            emailValidationError: '',
            ignoreEmailValidationErrors: false
        };
    },


    props: {
        contact: Object
    },

    components: {
        ImageEditor: __WEBPACK_IMPORTED_MODULE_4__ImageEditor___default.a, UniqueContactEnforcer: __WEBPACK_IMPORTED_MODULE_5__ui_elements_UniqueContactEnforcer___default.a, EmailBox: __WEBPACK_IMPORTED_MODULE_8__ui_elements_EmailBox___default.a, DateTime: __WEBPACK_IMPORTED_MODULE_9__ui_elements_DateTime___default.a
    },

    asyncComputed: {
        users: function users() {
            if (!this.tenantKey) return [];

            return __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].fetchUsersForOffice(this.tenantKey).then(function (users) {

                return users.map(function (o) {
                    var user = {
                        key: o.meta.key,
                        firstName: o.firstName,
                        lastName: o.lastName,
                        meta: { fullName: __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].fullName(o) }
                    };
                    return user;
                });
            });
        }
    },

    computed: {
        officesList: function officesList() {
            return this.$store.getters.officesActive;
        },
        availableGroups: function availableGroups() {
            return this.$store.getters.groups.map(function (o) {
                return o.name;
            });
        },
        selectedGroups: function selectedGroups() {
            if (this.contact && this.contact.groups) return __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].objectToArray(this.contact.groups);else return null;
        },
        tenantKey: function tenantKey() {
            return this.$store.getters.tenantKey;
        }
    },

    methods: {
        validate: function validate() {
            return this.$refs.form.validate() && this.$refs.email.validate();
        },
        checkGenderAndDuplicates: function checkGenderAndDuplicates() {
            this.checkGender();
            this.checkDuplicates();
        },
        checkDuplicates: function checkDuplicates() {
            this.$refs.enforcer.check();
        },
        fullName: function fullName(contact) {
            var c = __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].fullName(contact);
            return c;
        },
        setInitialFocus: function setInitialFocus() {
            var _this = this;

            this.$refs.form.resetValidation();
            this.emailValidationError = '';
            setTimeout(function () {
                _this.$refs.firstName.focus();
            }, 1000);
        },
        updateGroups: function updateGroups(e) {
            console.log('ContactDetails > updateGroups', e);
            this.contact.groups = __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].arrayToObject(e);
        },
        checkGender: function checkGender() {
            if (!this.contact.gender) __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].setInitialGender(this.contact);
        },
        checkImage: function checkImage() {
            if (this.contact.image.indexOf('random') > -1) {
                this.contact.image = __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].getGenderImage(this.contact.gender);
            }
        },
        uploadComplete: function uploadComplete() {
            console.log('upload complete');
        },
        collapse: function collapse() {
            console.log('collapsing advanced section....');
            this.advanced = false;
        }
    },

    watch: {
        'contact.meta.key': function contactMetaKey(newVal) {
            this.collapse();
        }
    },

    created: function created() {
        this.$store.dispatch('fetchAllGroups');
    }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ContactDetails__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ContactDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_ContactDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);









/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'DeleteButton': __WEBPACK_IMPORTED_MODULE_2__ui_elements_DeleteButton___default.a,
        'ContactDetails': __WEBPACK_IMPORTED_MODULE_3__ui_elements_ContactDetails___default.a
    },
    props: {
        contactItem: Object,
        settings: Object
    },
    data: function data() {
        return {
            officeDisabled: false,
            contact: {
                meta: {},
                firstName: null,
                preferredName: null,
                middleName: null,
                lastName: null,
                address: null,
                mobile: null,
                email: null,
                dob: null,
                image: null,
                owner: null,
                notes: null,
                groups: null
            }
        };
    },


    computed: {
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        }
    },

    watch: {
        'settings.visible': function settingsVisible(newVal) {
            if (newVal) {
                this.initialiseDialog();
            } else {
                this.resetForm();
            }
        }
    },

    methods: {
        initialiseDialog: function initialiseDialog() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__["a" /* default */].copyProperties(this.contactItem, this.contact);

            setTimeout(function () {
                _this.$refs.contactDetails.setInitialFocus();
                if (_this.contact.meta && _this.contact.meta.key) _this.officeDisabled = true;
            }, 300);
        },
        fullName: function fullName(contact) {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].fullName(contact);
        },
        saveContact: function saveContact() {
            console.log('ContactEditor > saveContact');
            if (!this.$refs.contactDetails.validate()) {
                console.log('cant continue...invalid');
                return;
            }

            if (!this.contact.meta) debugger;

            if (this.contact.user) this.saveProfilePic(this.contact);

            __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].saveContact(this.contact);
            this.settings.visible = false;
            this.$emit('saved', this.contact);
        },
        saveProfilePic: function saveProfilePic(contact) {
            var image = contact.image;
            var uid = contact.meta.key;
            var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('users').child(uid).child('image');

            ref.set(image);
        },
        cancelEdit: function cancelEdit() {
            console.log('ContactEditor > cancelEdit');
            this.settings.visible = false;
        },
        resetForm: function resetForm() {
            var _this2 = this;

            setTimeout(function () {
                console.log('ContactEditor > resetForm');
                _this2.settings.tab = 'details-tab';
                _this2.contact.owner = null;
                _this2.contact.firstName = null;
                _this2.contact.preferredName = null;
                _this2.contact.address = null;
                _this2.contact.middleName = null;
                _this2.contact.lastName = null;
                _this2.contact.business = null;
                _this2.contact.phone = null;
                _this2.contact.fax = null;
                _this2.contact.email = null;
                _this2.contact.mobile = null;
                _this2.contact.partner = null;
                _this2.contact.notes = null;
                _this2.contact.image = null;
                _this2.contact.dob = null;
                _this2.contact.groups = {};
                _this2.contact.meta = {};
                _this2.$refs.contactDetails.collapse();
            }, 300);
        },
        deleteContact: function deleteContact() {
            console.log('ContactEditor > deleteContact');
            __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].deleteContact(this.contact);
            this.settings.visible = false;
            this.$emit('deleted', this.contact);
        },
        resetContactImage: function resetContactImage() {
            this.contact.image = __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].getGenderImage(this.contact.gender);
        }
    }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_ImageFader__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_ImageFader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_ImageFader__);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ImageGroup: __WEBPACK_IMPORTED_MODULE_5__ui_elements_ImageGroup___default.a,
        ImageFader: __WEBPACK_IMPORTED_MODULE_6__ui_elements_ImageFader___default.a
    },

    props: {
        contacts: Array,
        partners: Boolean
    },

    computed: {
        limitedContacts: function limitedContacts() {
            return this.contacts.slice(0, 14);
        },
        selectedNames: function selectedNames() {
            var arr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.limitedContacts.map(function (o) {
                return o.firstName;
            })));
            if (this.contacts.length > 14) arr.push('more...');
            return __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__["a" /* default */].sentenceJoin(arr);
        },
        imageOne: function imageOne() {
            if (this.contacts.length < 1) return '';

            return this.contacts[0].image;
        },
        imageTwo: function imageTwo() {
            if (this.contacts.length < 1) return '';
            if (this.contacts.length < 2) return this.contacts[0].image;

            return this.contacts[1].image;
        },
        imageThree: function imageThree() {
            if (this.contacts.length < 1) return '';
            if (this.contacts.length < 2) return this.contacts[0].image;
            if (this.contacts.length < 3) return this.contacts[1].image;

            return this.contacts[2].image;
        },
        contactStyle: function contactStyle() {
            var c = this.contacts.length;
            var diameter = 50;
            if (c < 2) diameter = 100;else if (c < 3) diameter = 80;

            var result = {};

            result['width'] = diameter.toString() + 'px';
            result['height'] = diameter.toString() + 'px';
            return result;
        },
        contactOneStyle: function contactOneStyle() {
            var c = this.contacts.length;
            var left = 77;
            if (c > 2) left = 10;
            if (c == 2) left = this.partners ? 50 : 20;

            var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.contactStyle);
            result['left'] = left.toString() + 'px';
            result['opacity'] = [1, 2, 3].includes(c) ? 1 : 0;

            if (this.partners) result['transform'] = 'rotate(20deg)';

            return result;
        },
        contactTwoStyle: function contactTwoStyle() {
            var c = this.contacts.length;
            var left = 50;
            if (c < 2) left = 77;else if (c < 3) left = this.partners ? 120 : 150;

            var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.contactStyle);
            result['left'] = left.toString() + 'px';
            result['opacity'] = [2, 3].includes(c) ? 1 : 0;

            if (this.partners) result['transform'] = 'rotate(-20deg)';

            return result;
        },
        contactThreeStyle: function contactThreeStyle() {
            var c = this.contacts.length;
            var left = 85;
            if (c < 3) left = 300;

            var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.contactStyle);
            result['left'] = left.toString() + 'px';
            result['opacity'] = c == 3 ? 1 : 0;

            return result;
        }
    },

    methods: {
        contactLabel: function contactLabel(contact) {
            if (!contact) return '';
            return __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__["a" /* default */].fullName(contact);
        }
    },

    created: function created() {}
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_GroupSelector__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_GroupSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_GroupSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ListJumpButton__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ListJumpButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_ListJumpButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flow_ui_ContactImage__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flow_ui_ContactImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__flow_ui_ContactImage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_TeamHelpers__ = __webpack_require__(50);




















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        visible: Boolean,
        role: String,
        global: Boolean
    },
    components: {
        Flag: __WEBPACK_IMPORTED_MODULE_10__ui_elements_Flag___default.a,
        GroupSelector: __WEBPACK_IMPORTED_MODULE_11__ui_elements_GroupSelector___default.a,
        ListJumpButton: __WEBPACK_IMPORTED_MODULE_12__ui_elements_ListJumpButton___default.a,
        ContactImage: __WEBPACK_IMPORTED_MODULE_13__flow_ui_ContactImage___default.a
    },
    data: function data() {
        return {
            blankAvatars: false,
            loading: false,
            listeners: {},
            search: '',
            contactsByOffice: {},
            showingGroups: false,
            dialogVisible: false,
            group: {
                name: null,
                role: false
            },
            groups: []
        };
    },

    computed: {
        tenantKey: function tenantKey() {
            return __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getTenantKey();
        },
        contacts: function contacts() {

            var searchParameters = __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__["a" /* default */].searchAnalysis(this.search);

            var contacts = [];
            for (var officeCode in this.contactsByOffice) {
                contacts = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(contacts), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.contactsByOffice[officeCode]));
            }

            if (this.search.length < 3 || searchParameters.type == 'mobile') return contacts;

            var names = __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__["a" /* default */].searchNames(this.search);

            return contacts.filter(function (o) {
                if (!o.firstName || !o.lastName) return true;

                if (o.firstName.startsWith(names.primaryName) && o.lastName.startsWith(names.secondaryName)) return true;

                if (o.lastName.startsWith(names.primaryName) && o.firstName.startsWith(names.secondaryName)) return true;

                return false;
            }).slice(0, 20);
        },
        noResults: function noResults() {
            return this.contacts.length < 1;
        },
        searchMode: function searchMode() {
            return this.search.length > 0;
        }
    },
    methods: {
        getContactImage: function getContactImage(contact) {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__["a" /* default */].getContactImage(contact, this.blankAvatars);
        },
        officeNameFromKey: function officeNameFromKey(key) {
            return __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].officeNameFromKey(key);
        },
        groupSelected: function groupSelected(group) {
            console.log('ContactSearch > groupSelected', group);
        },
        initials: function initials(contact) {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__["a" /* default */].initials(contact) || 'No Owner';
        },
        clearSearch: function clearSearch() {
            this.search = '';
            if (!__WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].isMobile()) this.$refs.search.focus();
        },
        contactClicked: function contactClicked(contact) {
            this.$emit('click', contact, this.data);
        },
        focus: function focus() {
            this.$refs.search.focus();
        },
        jump: function jump(contact) {
            this.$emit('jump', contact, this.data);
        },
        clickedCancel: function clickedCancel() {
            this.$emit('cancel');
        },


        debouncedRunSearch: __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].debounce(function (searchText) {
            this.runSearch(searchText);
        }, 700),

        runSearch: function runSearch(searchText) {
            var _this = this;

            var searchParameters = __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__["a" /* default */].searchAnalysis(searchText);

            if (searchParameters.type == 'waiting') return;

            if (['names', 'recent', 'mobile'].includes(searchParameters.type)) this.getContacts(searchParameters);

            setTimeout(function () {
                _this.$emit('search', searchText);
            });
        },
        getContacts: function getContacts(searchParameters) {
            var _this2 = this;

            this.clearListeners();

            var index = -1;
            var firstNameRefs = [];
            var lastNameRefs = [];
            this.loading = true;

            var offices = [];
            if (!this.global) {
                console.log('Gettting contacts for office: ' + this.tenantKey);
                offices.push({ meta: {
                        key: this.tenantKey
                    } });
            }

            if (this.global) offices = this.$store.getters.officesActive;

            if (searchParameters.type != 'names') this.contactsByOffice = {};

            offices.forEach(function (office) {

                index += 1;
                firstNameRefs[index] = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(office.meta.key).child('contacts');

                if (searchParameters.type == 'names') firstNameRefs[index] = firstNameRefs[index].orderByChild('firstName').startAt(searchParameters.primaryName).endAt(searchParameters.primaryName + '\uF8FF');
                if (searchParameters.type == 'recent') firstNameRefs[index] = firstNameRefs[index].orderByChild('openedAt');
                if (searchParameters.type == 'mobile') firstNameRefs[index] = firstNameRefs[index].orderByChild('mobileSearch').equalTo(searchParameters.search);

                firstNameRefs[index] = firstNameRefs[index].limitToLast(10);

                if (!_this2.listeners[office.meta.key]) _this2.listeners[office.meta.key] = [];
                var listenersForOffice = _this2.listeners[office.meta.key];

                listenersForOffice[listenersForOffice.length] = firstNameRefs[index].on('value', function (snap) {
                    var contacts = __WEBPACK_IMPORTED_MODULE_14__data_NiceData__["a" /* default */].arrayFromSnapshot(snap).sort(__WEBPACK_IMPORTED_MODULE_15__helpers_OrderHelpers__["a" /* default */].sortByOpenedAtDescending);
                    _this2.$set(_this2.contactsByOffice, office.meta.key, contacts);
                    _this2.loading = false;
                });

                if (searchParameters.type == 'names') {

                    lastNameRefs[index] = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(office.meta.key).child('contacts');

                    lastNameRefs[index] = lastNameRefs[index].orderByChild('lastName').startAt(searchParameters.primaryName).endAt(searchParameters.primaryName + '\uF8FF');
                    lastNameRefs[index] = lastNameRefs[index].limitToLast(10);

                    if (!_this2.listeners[office.meta.key]) _this2.listeners[office.meta.key] = [];
                    var listenersForOffice2 = _this2.listeners[office.meta.key];
                    listenersForOffice2[listenersForOffice2.length] = lastNameRefs[index].on('value', function (snap) {
                        var contacts = __WEBPACK_IMPORTED_MODULE_14__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);

                        _this2.$set(_this2.contactsByOffice, office.meta.key + 'a', contacts);
                    });
                }
            });
        },
        clearListeners: function clearListeners() {
            var _this3 = this;

            var _loop = function _loop(officeKey) {
                _this3.listeners[officeKey].forEach(function (listener) {
                    __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(officeKey).child('contacts').off('value', listener);
                });
            };

            for (var officeKey in this.listeners) {
                _loop(officeKey);
            }
            this.listeners = {};
        }
    },

    watch: {

        'search': function search(newVal) {
            this.debouncedRunSearch(newVal);
        },
        'visible': function visible(newVal) {
            var _this4 = this;

            if (newVal) {
                __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
                    _this4.$refs.search.focus();
                });
            }
        },
        'tenantKey': {
            handler: function handler(newVal) {
                this.runSearch();
            }
        }

    },

    created: function created() {
        var _this5 = this;

        __WEBPACK_IMPORTED_MODULE_16__helpers_TeamHelpers__["a" /* default */].fetchTeamSettings().then(function (settings) {
            _this5.blankAvatars = settings.blankAvatars;
        });

        __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].fetchUser().then(function () {
            _this5.runSearch();
        });
    },
    mounted: function mounted() {
        console.log('listeners', this.$listeners);
    }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactSearch__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ContactSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactDetails__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ContactDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__ = __webpack_require__(3);













var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        visible: Boolean,
        data: Object,
        title: String
    },
    components: {
        'ContactSearch': __WEBPACK_IMPORTED_MODULE_6__ContactSearch___default.a,
        'ContactDetails': __WEBPACK_IMPORTED_MODULE_7__ContactDetails___default.a
    },
    data: function data() {
        return {
            dialogVisible: this.visible,
            adding: false,
            contact: null
        };
    },


    computed: {
        tenantKey: function tenantKey() {
            return this.$store.getters.tenantKey;
        },
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        },
        contactDialogImageVisible: function contactDialogImageVisible() {
            if (this.contact.image && this.contact.image.indexOf('transparent') < 0) return true;else return false;
        },
        contactImage: function contactImage() {
            if (this.contact.image) return this.contact.image;else return '/static/images/transparent.png';
        }
    },
    methods: {
        toggleAdding: function toggleAdding() {
            this.adding = !this.adding;
            if (this.adding) {
                this.contact.meta = {
                    tenantKey: this.tenantKey
                };
            }
        },
        saveAndSelect: function saveAndSelect() {
            var _this = this;

            if (!this.$refs.contactDetails.validate()) return;

            var vm = this;
            var ref = __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].getTenantRef(this.tenantKey).child('contacts');

            ref.push(this.contact).then(function (snap) {
                vm.contact.meta = {};
                vm.contact.meta.key = snap.key;
                vm.contact.meta.tenantKey = _this.tenantKey;
                vm.select(vm.contact);
            });
        },
        select: function select(contact) {
            this.$emit('select', contact, this.data);
        },
        clickedCancel: function clickedCancel() {
            this.$emit('cancel');
        },
        initialiseDialog: function initialiseDialog() {
            this.adding = false;

            this.contact = {
                image: '/static/images/transparent.png'
            };
        },
        checkGender: function checkGender() {
            __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].setInitialGender(this.contact);
        },
        showAllContacts: function showAllContacts() {
            this.data.role = null;
        }
    },
    watch: {
        visible: function visible(newVal) {
            this.dialogVisible = newVal;
            if (newVal) this.initialiseDialog();
        }

    },
    created: function created() {
        this.initialiseDialog();
    }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_NumberHelpers__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        label: String,
        value: [String, Number],
        hideDetails: Boolean,
        singleLine: Boolean,
        compact: Boolean
    },

    computed: {
        longFormat: function longFormat() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__["a" /* default */].formatCurrencyWithCents(this.value);
        },
        shortFormat: function shortFormat() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__["a" /* default */].formatFloat(this.value);
        }
    },

    methods: {
        inputted: function inputted(val) {
            this.$emit('input', val);
        },
        changed: function changed(val) {
            val = this.convertToRawNumber(val);

            this.$emit('input', val);
            this.$emit('change');
        },
        convertToRawNumber: function convertToRawNumber(val) {
            if (val == '') return '';

            val = val.toLowerCase();

            var multiplier = 1;

            if (val.indexOf('m') > -1) multiplier = 1000000;else if (val.indexOf('k') > -1) multiplier = 1000;

            val = __WEBPACK_IMPORTED_MODULE_1__helpers_NumberHelpers__["a" /* default */].numbersFromString(val);

            if (!val) val = 0;

            val = val * multiplier;

            return val;
        }
    }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_FirebaseHelpers_js__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            items: [],

            chartOptions: {

                title: '',
                pieHole: 0.4,
                'chartArea': { 'width': '100%', 'height': '80%' },
                'legend': { 'position': 'right' },
                backgroundColor: { fill: 'transparent' }
            },

            chartEvents: {
                'select': function select(e) {
                    var chartObj = _this.$refs.chart.chartObject;
                    var selection = chartObj.getSelection();
                    if (!selection || !selection.length) return;

                    var row = selection[0].row;
                    console.log(_this.chartData[row + 1][0]);
                }
            }

        };
    },


    components: {},

    props: {
        dash: Object
    },

    computed: {
        groupedItems: function groupedItems() {
            if (!this.dash.field) return {};
            var field = this.dash.field;

            var groupedItems = {};
            this.items.forEach(function (item) {
                var name = item[field];
                if (!groupedItems[name]) groupedItems[name] = { count: 0, data: [] };
                groupedItems[name].count += 1;
                groupedItems[name].data.push(item);
            });
            return groupedItems;
        },
        chartData: function chartData() {
            var data = [['Type', 'Leads']];

            for (var group in this.groupedItems) {
                var row = [];
                row.push(group);
                var count = this.groupedItems[group].count;
                row.push(count);
                data.push(row);
            }
            return data;
        }
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {},


    watch: {
        dash: {
            immediate: true,

            handler: function handler(newVal) {
                var _this2 = this;

                if (!this.dash.section) return;
                var ref = __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers_js__["a" /* default */].getTransactionSummaryRef().child(this.dash.section);

                ref.on('value', function (snap) {

                    _this2.items = __WEBPACK_IMPORTED_MODULE_1__helpers_FirebaseHelpers_js__["a" /* default */].snapshotToArray(snap);
                });
            }
        }
    }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ObjectViewer__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_ObjectViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_ObjectViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_TeamHelpers__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_CollectionHelpers__ = __webpack_require__(140);














/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: {},
            status: '',
            itemLimit: this.limit || 100,
            teamNames: [],
            items: []
        };
    },


    components: {
        ObjectViewer: __WEBPACK_IMPORTED_MODULE_3__ui_elements_ObjectViewer___default.a
    },

    props: {
        collection: String,
        conditions: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        limit: Number,
        sortField: String,
        search: String
    },

    computed: {
        moreItemsAvailable: function moreItemsAvailable() {
            return this.items.length >= this.itemLimit;
        }
    },

    methods: {
        addItem: function addItem(item) {
            __WEBPACK_IMPORTED_MODULE_10__helpers_CollectionHelpers__["a" /* default */].insertOrMoveToTop(item, this.items);
        },
        loadData: function loadData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var refs, mergedItems, sortField;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('DataLoader > loadData');
                                _this.status = 'loading';
                                _this.$emit('loading');
                                refs = [];

                                _this.teamNames.forEach(function (team) {

                                    var ref = __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].getFirestore().collection('teams/' + team + '/collections/' + _this.collection + '/data');

                                    if (_this.search) {
                                        for (var i = 1; i < 4; i++) {
                                            var field = 'search' + i;
                                            var refSearch = ref.where(field, '>=', _this.search).where(field, '<', _this.search + '\uF8FF').limit(30);
                                            refs.push(refSearch);
                                        }
                                    } else {
                                        _this.conditions.forEach(function (condition) {
                                            ref = ref.where(condition.field, condition.operator, condition.value);
                                        });
                                        ref = ref.limit(_this.itemLimit);
                                        refs.push(ref);
                                    }
                                });
                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_5__data_Firestore__["a" /* default */].fetchMulti(refs);

                            case 7:
                                mergedItems = _context.sent;
                                sortField = _this.sortField;

                                if (sortField) mergedItems = mergedItems.sort(function (a, b) {
                                    return __WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__["a" /* default */].sortByField(a, b, sortField);
                                });

                                _this.items = mergedItems.map(function (item) {
                                    var enhancedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { _sourceArray: mergedItems });
                                    return enhancedItem;
                                });
                                _this.$emit('loaded', _this.items);
                                _this.status = 'loaded';

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    watch: {
        'sortField': {
            handler: function handler(newVal) {
                console.log('sortField watcher');
                this.items = this.items.sort(function (a, b) {
                    return __WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__["a" /* default */].sortByField(a, b, newVal);
                });
            }
        },
        'itemLimit': {
            handler: function handler(newVal) {
                console.log('itemLimit watcher');
                this.loadData();
            }
        },
        'search': {
            handler: function handler(newVal) {
                console.log('search watcher');
                this.loadData();
            }
        },
        'conditions': {
            handler: function handler(newVal) {
                console.log('conditions watcher');

                this.loadData();
            },
            deep: true
        }
    },

    created: function created() {
        var _this2 = this;

        console.groupCollapsed('DataLoader');
        __WEBPACK_IMPORTED_MODULE_7__helpers_TeamHelpers__["a" /* default */].fetchActiveTeams().then(function (teams) {
            _this2.teamNames = teams.map(function (team) {
                return team._id;
            });
            console.log('Teams:', _this2.teamNames);
            _this2.loadData();
            console.groupEnd();
        });
    }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            sourceText: this.value,
            editing: false
        };
    },


    props: {
        label: String,
        value: String,
        hideDetails: Boolean,
        short: Boolean,
        baseDate: {
            default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(new Date(), __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS),
            type: String
        }
    },

    computed: {
        displayDate: function displayDate() {
            if (!this.value) return '';
            var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(this.backwardsToDate(this.value), this.displayFormat);

            return date;
        },
        displayFormat: function displayFormat() {
            if (this.short) return 'd/M/yy';else return 'EEEE d MMM yyyy';
        }
    },

    methods: {
        backwardsToDate: function backwardsToDate(dateStr) {
            return __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToDate(dateStr);
        },
        dueString: function dueString(date) {
            if (!date) return '';
            return __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__["a" /* default */].dueString(this.backwardsToDate(date));
        },
        editDate: function editDate() {
            var _this = this;

            this.editing = true;
            setTimeout(function () {
                var textbox = _this.$refs.textbox;

                textbox.focus();
            }, 300);
        },
        changed: function changed(val) {
            console.log('changed', val);
            if (val) val = this.formatDate(val);else val = null;
            console.log('converted', val);

            this.$emit('input', val);
            this.$emit('change');

            return true;
        },
        blurred: function blurred() {},
        focused: function focused() {},
        formatDate: function formatDate(val) {
            var startingDate = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToDate(this.baseDate) || new Date();
            var timeFrameObj = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].findTimeframeInString(val, startingDate);
            return __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(timeFrameObj.date);
        }
    }

});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dates: [],
            start: null,
            end: null,
            dialogVisible: false
        };
    },


    components: {},

    props: {
        label: {
            type: String,
            default: 'Date Range'
        },
        value: {
            type: Object,
            default: function _default() {
                return {
                    start: null,
                    end: null
                };
            }
        }
    },

    computed: {
        dialogTitle: function dialogTitle() {
            if (this.value.start && this.value.end) return 'From ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(this.value.start, 'dd/MM/yy') + ' to ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(this.value.end, 'dd/MM/yy');else if (this.value.start && !this.value.end) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(this.value.start, 'dd/MM/yy') + '. Select another...';else return 'Select 2 dates...';
        },
        commonRanges: function commonRanges() {
            var thisYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["c" /* getYear */])(new Date());
            var ranges = [];
            var today = new Date();

            var lastQuarterStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["w" /* startOfQuarter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["x" /* subQuarters */])(today, 1));
            var lastQuarterEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["y" /* lastDayOfQuarter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["x" /* subQuarters */])(today, 1));
            var thisQuarterStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["w" /* startOfQuarter */])(today);
            var thisQuarterEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["y" /* lastDayOfQuarter */])(today);

            var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["z" /* startOfMonth */])(today);
            var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["A" /* endOfMonth */])(today);
            var text = 'This Month';
            ranges.push({ text: text, start: start, end: end });

            var aMonthAgo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["v" /* subMonths */])(today, 1);
            start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["z" /* startOfMonth */])(aMonthAgo);
            end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["A" /* endOfMonth */])(aMonthAgo);
            text = 'Last Month';
            ranges.push({ text: text, start: start, end: end });

            ranges.push({
                text: 'This Quarter',
                start: thisQuarterStartDate,
                end: thisQuarterEndDate
            });

            ranges.push({
                text: 'Last Quarter',
                start: lastQuarterStartDate,
                end: lastQuarterEndDate
            });

            for (var i = 2; i < 12; i++) {
                var dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["v" /* subMonths */])(new Date(), i);
                var _start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["z" /* startOfMonth */])(dt);
                var _end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["A" /* endOfMonth */])(dt);
                var _text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["a" /* format */])(dt, 'MMMM');
                var range = {
                    text: _text, start: _start, end: _end
                };
                ranges.push(range);
            }

            start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["v" /* subMonths */])(today, 3);
            end = today;
            text = 'Past 3 Months';
            ranges.push({ text: text, start: start, end: end });

            start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["v" /* subMonths */])(today, 6);
            end = today;
            text = 'Past 6 Months';
            ranges.push({ text: text, start: start, end: end });

            start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["D" /* subYears */])(today, 1);
            end = today;
            text = 'Past Year';
            ranges.push({ text: text, start: start, end: end });

            return ranges;
        },


        pickerDates: {
            get: function get() {
                var range = [];
                if (this.value.start) {
                    range.push(__WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].dateToBackwards(this.value.start));
                    if (this.value.end) range.push(__WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].dateToBackwards(this.value.end));
                }
                return range;
            },
            set: function set(val) {

                if (!val || !val.length) {
                    this.value.start == null;
                    this.value.end == null;
                    return;
                }
                var sortedRange = val.sort();
                if (sortedRange.length == 1) {
                    this.value.start = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].backwardsToDate(sortedRange[0]);
                    this.value.end = null;
                    return;
                }
                this.value.start = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].backwardsToDate(sortedRange[0]);
                this.value.end = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].backwardsToDate(sortedRange[1]);
            }
        },
        rangeText: {
            get: function get() {
                var _this = this;

                if (!this.value.start) return '';

                if (this.value.start && !this.value.end) {
                    var dtString = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].dateToAu(this.value.start);
                    return dtString + ' - ' + dtString;
                }

                var foundRange = this.commonRanges.find(function (o) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["E" /* isSameDay */])(_this.value.start, o.start) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["E" /* isSameDay */])(_this.value.end, o.end);
                });
                if (foundRange) return foundRange.text;

                if (this.value.start && this.value.end) {
                    var startString = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].dateToAu(this.value.start);
                    var endString = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].dateToAu(this.value.end);
                    return startString + ' - ' + endString;
                }
            },
            set: function set(val) {
                console.log('setting range text ', val);
                if (!val) {
                    this.value.start = null;
                    this.value.end = null;
                    return;
                }

                var foundRange = this.commonRanges.find(function (o) {
                    return o.text == val;
                });
                if (foundRange) {
                    this.value.start = foundRange.start;
                    this.value.end = foundRange.end;
                    return;
                }

                var arr = val.split(' - ');
                if (arr && arr.length == 2) {
                    this.value.start = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].toDate(arr[0]);
                    this.value.end = __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__["a" /* default */].toDate(arr[1]);
                }
            }
        },

        ranges: function ranges() {
            return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.commonRanges), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__helpers_LookupData__["a" /* default */].months)).sort();
        }
    },

    methods: {
        showCalendar: function showCalendar() {
            console.log('calendar!!');
            this.dialogVisible = true;
        },
        closeIfApplicable: function closeIfApplicable() {
            if (this.value.end) this.dialogVisible = false;
        }
    },

    created: function created() {}
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__ = __webpack_require__(11);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            ranges: []
        };
    },


    components: {},

    props: {
        value: Object,
        label: String,
        default: String },

    computed: {
        hint: function hint() {
            if (!this.value) return 'Select a range...';
            if (!this.value.start && !this.value.end) return 'Showing all records';
            return 'From ' + __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToAu(this.value.start) + ' to ' + __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToAu(this.value.end);
        }
    },

    methods: {
        selectionChanged: function selectionChanged(value) {
            this.emitChanges(value);
        },
        emitChanges: function emitChanges(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        }
    },

    mounted: function mounted() {},
    created: function created() {
        var _this = this;

        var today = new Date();
        var oneMonthAgo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["v" /* subMonths */])(today, 1);

        var lastQuarterStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["w" /* startOfQuarter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["x" /* subQuarters */])(today, 1));
        var lastQuarterEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["y" /* lastDayOfQuarter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["x" /* subQuarters */])(today, 1));
        var thisQuarterStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["w" /* startOfQuarter */])(today);
        var thisQuarterEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["y" /* lastDayOfQuarter */])(today);

        this.ranges.push({
            text: 'All',
            start: null,
            end: null
        });
        this.ranges.push({
            text: 'This month',
            start: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["z" /* startOfMonth */])(today)),
            end: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["A" /* endOfMonth */])(today))
        });
        this.ranges.push({
            text: 'Last month',
            start: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["z" /* startOfMonth */])(oneMonthAgo)),
            end: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["A" /* endOfMonth */])(oneMonthAgo))
        });
        this.ranges.push({
            text: 'Last Quarter',
            start: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["z" /* startOfMonth */])(lastQuarterStartDate)),
            end: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["A" /* endOfMonth */])(lastQuarterEndDate))
        });
        this.ranges.push({
            text: 'This Quarter',
            start: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["z" /* startOfMonth */])(thisQuarterStartDate)),
            end: __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["A" /* endOfMonth */])(thisQuarterEndDate))
        });

        if (!this.value || !this.value.start && !this.value.end) {
            var range = this.ranges[0];
            if (this.default) range = this.ranges.find(function (o) {
                return o.text == _this.default;
            }) || range;
            this.emitChanges(range);
        }
    }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            storageFormat: __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS,
            displayFormat: __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["b" /* dateFormats */].AUSTRALIAN,
            menuVisible: false
        };
    },


    components: {},

    props: {
        value: String,
        label: String,
        dateOnly: {
            default: false,
            type: Boolean
        },
        past: Boolean,
        short: Boolean
    },

    computed: {
        datePart: function datePart() {
            if (!this.value) return '';
            return this.value.split(' ')[0].trim();
        },
        datePartAu: function datePartAu() {
            if (!this.datePart) return '';
            return __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].convertDate(this.datePart, this.storageFormat, this.displayFormat);
        },
        timePart: function timePart() {
            if (!this.value || this.value.length < 2) return '';

            var arr = this.value.split(' ');
            if (arr.length < 2) return '';

            return arr[1].trim();
        },


        textValue: {
            get: function get() {
                if (!this.datePartAu) return '';

                return this.datePartAu + (this.timePart ? ' @ ' : '') + this.timePart;
            },
            set: function set(textValue) {}
        },

        calendarValue: {
            get: function get() {
                return this.datePart;
            },
            set: function set(newValue) {
                this.setDate(newValue);
            }
        },

        availableTimes: function availableTimes() {
            return ['7:00 am', '7:30 am', '8:00 am', '8:30 am', '9:00 am', '9:30 am', '10:00 am', '10:30 am', '11:00 am', '11:30 am', '12:00 pm', '12:30 pm', '1:00 pm', '1:30 pm', '2:00 pm', '2:30 pm', '3:00 pm', '3:30 pm', '4:00 pm', '4:30 pm', '5:00 pm', '5:30 pm', '6:00 pm', '6:30 pm', '7:00 pm'];
        }
    },

    methods: {
        emitChanges: function emitChanges(newValue) {
            this.$emit('input', newValue);
            this.$emit('change', newValue);
        },
        clearDate: function clearDate() {
            this.emitChanges(null);
            this.menuVisible = false;
        },
        setDays: function setDays(n) {
            var dateObj = new Date();
            var newDate = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].smartDaysFromNow(n);
            this.setDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(newDate, this.storageFormat));
        },
        setTextValue: function setTextValue(textValue) {
            if (!textValue) {
                this.emitChanges(null);
                return;
            }

            var dateStr = void 0;
            var timeStr = void 0;

            var arr = textValue.split('@');

            dateStr = arr[0].trim();

            if (arr.length > 1) {
                timeStr = arr[1].trim();
            }

            var finalDate = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].findTimeframeInString(dateStr).date;

            if (!finalDate) finalDate = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].toDate(dateStr);
            if (!finalDate) {
                console.error('invalid date');
                return;
            }

            var finalFormat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(finalDate, this.storageFormat);

            var newValue = finalFormat + (timeStr ? ' ' + timeStr : '');
            this.emitChanges(newValue);
        },
        setDate: function setDate(newDate) {
            var newValue = void 0;
            if (!this.value) newValue = newDate;else newValue = this.value.replace(this.datePart, newDate);

            this.emitChanges(newValue);
            if (this.dateOnly) this.menuVisible = false;
        },
        setTime: function setTime(timeString) {
            timeString = timeString.toLowerCase().replace(' ', '');
            var date = this.datePart;
            if (!date) date = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].todayString();

            var newValue = date + ' ' + timeString;
            this.emitChanges(newValue);
            this.menuVisible = false;
        },
        calendarClicked: function calendarClicked() {
            this.menuVisible = !this.menuVisible;
        },
        getTimeHalfHourly: function getTimeHalfHourly(n) {
            return this.availableTimes[n - 1];
        },
        isSelected: function isSelected(n) {
            var time = this.getTimeHalfHourly(n).replace(' ', '');
            return time == this.timePart;
        },
        isTime: function isTime(timeString) {
            if (!timeString) return false;

            timeString = timeString.toLowerCase().trim();
            var arr = timeString.split(':');
            if (arr.length != 2) return false;

            var hrs = parseInt(arr[0]);
            var mins = parseInt(arr[1]);
            if (hrs == 0 || hrs > 12) return false;
            if (mins > 59) return false;

            return true;
        },
        windowResized: function windowResized() {
            var componentWidth = this.$el.offsetWidth;
            if (componentWidth > 310 && !this.short) this.displayFormat = 'eeee do MMMM';else this.displayFormat = 'dd/MM/yy';
        },


        debouncedWindowResized: __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].debounce(function (event, vm) {
            vm.windowResized();
        }, 1000)

    },
    mounted: function mounted() {
        this.windowResized();
    },
    created: function created() {
        window.addEventListener('resize', this.debouncedWindowResized.bind(null, event, this));
    },
    destroyed: function destroyed() {
        window.removeEventListener('resize', this.debouncedWindowResized);
    }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfirming: false
    };
  },


  props: {
    disabled: Boolean
  },

  methods: {
    confirmDelete: function confirmDelete() {
      console.log('confirming...');
      this.isConfirming = true;
      var vm = this;
      setTimeout(function () {
        vm.isConfirming = false;
      }, 4000);
    },
    raiseDeleteEvent: function raiseDeleteEvent() {
      this.isConfirming = false;
      this.$emit('delete');
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        settings: Object,


        saveOnEnter: Boolean,
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {},

    data: function data() {
        return {};
    },


    computed: {
        dialogVisible: function dialogVisible() {
            return this.settings.visible;
        },
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.xsOnly) return '100%';else {
                if (this.settings.height) return;
                this.settings.height;
                return '500px';
            }
        },
        bodyStyle: function bodyStyle() {
            return {
                'max-height': this.$vuetify.breakpoint.xsOnly ? '100%' : '400px'
            };
        }
    },

    methods: {
        save: function save() {
            this.$emit('save');
            this.settings.visible = false;
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.settings.visible = false;
        },
        close: function close() {
            this.$emit('close');
            this.settings.visible = false;
        },
        enterPressed: function enterPressed() {
            if (this.saveOnEnter) this.save();
        },
        focusFirstElement: function focusFirstElement() {
            var _this = this;

            setTimeout(function () {
                if (__WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__["a" /* default */].isMobile()) return;
                var el = _this.$refs.dialogDOM.$el.querySelector("input");
                if (el) el.focus();
            }, 500);
        }
    },

    watch: {
        'settings.visible': {
            handler: function handler(visible) {
                if (visible) {
                    this.focusFirstElement();
                    this.$emit('show');
                } else this.$emit('hide');
            },
            immediate: true
        }
    }

});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dialogVisible: false,
            zoom: false
        };
    },


    components: {},

    props: {
        url: String,
        type: {
            type: String,
            default: ''
        }
    },

    computed: {
        hasImage: function hasImage() {
            return this.type.contains('image') || this.url.contains('.jpg') || this.url.contains('.png') || this.url.contains('.gif');
        },
        hasPdf: function hasPdf() {
            return (this.type.contains('pdf') || this.url.contains('.pdf')) && !this.hasImage;
        }
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DynamicControlHelpers__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_CollectionHelpers__ = __webpack_require__(140);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        field: Object,
        value: String
    },

    computed: {
        componentName: function componentName() {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_CollectionHelpers__["a" /* default */].lookupValue(this.controlTypes, 'value', this.field.type, 'control');
        },
        controlTypes: function controlTypes() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_DynamicControlHelpers__["a" /* default */].dynamicControlTypes();
        }
    },

    methods: {
        emitInput: function emitInput(newValue) {
            this.$emit('input', newValue);
        }
    },

    created: function created() {}
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            backupText: null,
            focused: false
        };
    },


    components: {},

    props: {
        value: [String, Number],
        width: {
            type: String,
            default: '30px'
        },
        dark: Boolean,
        plain: Boolean,
        readOnly: Boolean,
        inline: Boolean
    },

    computed: {
        inputStyle: function inputStyle() {
            return {
                width: this.width
            };
        }
    },

    methods: {
        gotFocus: function gotFocus(e) {
            console.log('got focus');
            this.focused = true;
            this.backupText = e.target.innerText;
            this.selectAll();
        },
        removeFocus: function removeFocus(e) {
            this.focused = false;
            this.backupText = null;
            e.target.blur();
        },
        cancel: function cancel(e) {
            e.target.innerText = this.backupText;
            this.removeFocus(e);
        },
        changed: function changed(e) {
            e.preventDefault();
            var newText = e.target.innerText.trim();
            this.$emit('input', newText);
            if (e.target.innerText != this.backupText) {
                this.$emit('change', { value: e.target.innerText, oldValue: this.backupText });
            }
            this.removeFocus(e);
        },
        focus: function focus() {
            var _this = this;

            setTimeout(function () {
                _this.$refs.editRegion.focus();
            }, 100);
        },
        selectAll: function selectAll() {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(this.$refs.editRegion);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    },

    mounted: function mounted() {

        if (this.value && this.value.toString().indexOf('...') > 0 && !this.readOnly) {
            this.focus();
            this.selectAll();
        }
    },
    created: function created() {}
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        icon: String,
        text: String,
        element: Object,
        complete: Boolean

    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        buttonClicked: function buttonClicked() {
            this.$emit('click');
        }
    }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_FilterEditor__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_FilterEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_FilterEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_FilterHelpers__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_CurrencyBox__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        data: Object,
        model: Object
    },
    components: {
        DeleteButton: __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default.a,
        FilterEditor: __WEBPACK_IMPORTED_MODULE_10__ui_elements_FilterEditor___default.a,
        CurrencyBox: __WEBPACK_IMPORTED_MODULE_13__ui_elements_CurrencyBox___default.a
    },
    data: function data() {
        return {
            tab: 'Details',
            nameRules: [function (v) {
                return !!v || 'Name is required';
            }, function (v) {
                return v && v.length >= 3 || 'Name must be greater than 3 characters';
            }],
            typeHasValue: false,
            nameHasValue: false,

            filterEditorDialog: {
                settings: {
                    visible: false,
                    title: 'Add a Filter'
                },
                filter: null,
                elements: []
            },
            filterArray: [],
            editingTask: {}
        };
    },

    computed: {
        valid: function valid() {
            return this.model.type && this.model.name && this.model.title;
        },
        elements: function elements() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__["a" /* default */].getElements();
        },
        dateElements: function dateElements() {
            return this.elements.filter(function (o) {
                return o.type == 'Date';
            });
        },
        elementNames: function elementNames() {
            return this.elements.filter(function (o) {
                return o.name;
            }).sort(__WEBPACK_IMPORTED_MODULE_6__helpers_OrderHelpers__["a" /* default */].sortByName).map(function (o) {
                return o.name;
            });
        },
        dateElementNames: function dateElementNames() {
            return this.dateElements.filter(function (o) {
                return o.name;
            }).sort(__WEBPACK_IMPORTED_MODULE_6__helpers_OrderHelpers__["a" /* default */].sortByName).map(function (o) {
                return o.name;
            });
        },
        operators: function operators() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_LookupData__["a" /* default */].operators();
        },
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        },
        dialogTitle: function dialogTitle() {
            if (this.model.type) return this.model.type + ' Details';else return 'Element Details';
        },
        isContainer: function isContainer() {
            if (!this.model.type) return false;

            return this.model.type.startsWith('Heading') || this.model.type == 'Tab';
        },
        contactDialogImageVisible: function contactDialogImageVisible() {
            if (this.contact.image && this.contact.image.indexOf('transparent') < 0) return true;else return false;
        },
        contactImage: function contactImage() {
            if (this.contact.image) return this.contact.image;else return '/static/images/transparent.png';
        },
        buttonActionOptions: function buttonActionOptions() {
            return ['Clone', 'Delete'];
        },
        buttonElementsOptions: function buttonElementsOptions() {
            return ['Previous', 'Next', 'Section'];
        },
        widgetOptions: function widgetOptions() {
            return ['Import Outstandings', 'Outstandings Diagram', 'Element Summary', 'Loan Diagram', 'Transaction Summary', 'Coming Up'];
        },
        statusOptions: function statusOptions() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_LookupData__["a" /* default */].outstandingStatuses();
        },
        buttonIconOptions: function buttonIconOptions() {
            return ['add', 'delete', 'edit'];
        },
        typeOptions: function typeOptions() {
            return ['Section', 'Text', 'Date', 'DateTime', 'Currency', 'Percent', 'List', 'Options', 'Switch', 'Checkbox', 'Checkbox List', 'Checklist', 'Slider', 'Button', 'Status', 'Tab', 'Comment', 'Field Summary', 'Email', 'Scheduler', 'SMS', 'Contact Selector', 'User Chooser', 'File Upload', 'Lookup', 'Html', 'Rating', 'Charge', 'Heading', 'Outstanding', 'Jump', 'Contact', 'Widget', 'Divider', "Exporter", "LoanAttributes"];
        },
        roles: function roles() {
            return this.$store.getters.groups.filter(function (o) {
                return o.role == true;
            }).map(function (o) {
                return o.name;
            });
        },
        childNames: function childNames() {
            var children = __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__["a" /* default */].getChildren(this.model, this.elements);
            return children.map(function (o) {
                return o.name;
            });
        },
        backgroundOptions: function backgroundOptions() {
            return ['Grey'];
        }
    },
    methods: {
        addAutomaticTask: function addAutomaticTask() {
            this.model.tasks = this.model.tasks || [];
            this.model.tasks.push({
                title: 'Follow Up',
                days: 2
            });
            this.editingTask = this.model.tasks[this.model.tasks.length - 1];
        },
        deleteAutomaticTask: function deleteAutomaticTask(task) {
            var idx = this.model.tasks.findIndex(function (t) {
                return t == task;
            });
            this.model.tasks.splice(idx, 1);
            this.editingTask = null;
        },
        clearValue: function clearValue() {
            this.model.value = null;
            if (this.model.contact) delete this.model.contact;
        },
        save: function save() {

            this.model.filter = __WEBPACK_IMPORTED_MODULE_11__helpers_FilterHelpers__["a" /* default */].filterArrayToObject(this.filterArray);

            if (!this.model.width) this.model.width = null;

            if (this.model.type == 'Contact') {
                this.model.name = __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__["a" /* default */].toSnakeCase(this.model.role);
                this.model.title = this.model.role;
            }

            this.$emit('save', this.model);
            this.settings.visible = false;
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.settings.visible = false;
        },
        deleteElement: function deleteElement() {
            this.$emit('delete', this.model);
            this.settings.visible = false;
        },
        setDefaultName: function setDefaultName() {
            var _this = this;

            if (this.model.name) return;
            this.makeElementName(this.model).then(function (name) {
                __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this.model, 'name', name);
            });
        },
        makeElementName: function makeElementName(element) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                if (!element.title) {
                    resolve('');
                    return;
                }
                var name = element.title.replace(/\s|-/g, '_').toLowerCase();

                if (['Section', 'Heading', 'Checklist'].indexOf(element.type) >= 0) {
                    name = name + '_' + element.type.toLowerCase();
                }

                var baseName = _this2.getBaseElementName(name);
                _this2.getSimilarElements(baseName).then(function (similarElements) {
                    var n = 1;
                    while (similarElements.find(function (o) {
                        return o.name == name;
                    })) {
                        n++;
                        name = baseName + '_' + n;
                    }
                    resolve(name);
                });
            });
        },
        getSimilarElements: function getSimilarElements(baseName) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('elements').orderByChild('name').startAt(baseName);
                ref.once('value', function (snap) {
                    var arr = __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                    resolve(arr);
                });
            });
        },
        getBaseElementName: function getBaseElementName(name) {
            if (!name) return null;

            var nameArray = name.split('_');
            if (nameArray.length == 1) return name;

            var lastSegment = nameArray[nameArray.length - 1];
            if (!__WEBPACK_IMPORTED_MODULE_7__helpers_NumberHelpers__["a" /* default */].isNumeric(lastSegment)) return name;

            nameArray.splice(nameArray.length - 1, 1);
            return nameArray.join('_');
        },
        deleteFilter: function deleteFilter(filter) {
            __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].log('DeleteFilter');
            var index = this.filterArray.find(function (o) {
                return o.type == filter.type && o.name == filter.name;
            });
            if (index) this.filterArray.splice(index, 1);
        },
        isVisible: function isVisible(name) {
            var visibleTypes = {};
            visibleTypes.Value = ['Comment', 'Charge'];

            if (visibleTypes[name].indexOf(this.model.type) > -1) return true;

            return false;
        },
        addFilter: function addFilter() {
            __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].log('addFilter');
            this.filterEditorDialog.settings.visible = true;
        },
        editFilter: function editFilter(filter) {
            __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].log('editFilter');
            this.filterEditorDialog.filter = filter;
            this.filterEditorDialog.settings.visible = true;
        },
        saveFilter: function saveFilter(filter) {
            var existingFilter = this.filterArray.find(function (o) {
                return o.type == filter.type && o.name == filter.name;
            });
            if (existingFilter) {
                existingFilter.operator = filter.operator;
                existingFilter.values = filter.values;
            } else {
                this.filterArray.push(filter);
            }
        },
        goToElementMaintenance: function goToElementMaintenance() {
            this.$router.push('/maintenance/?action=te&item=' + this.model.key + '&transaction=' + this.model.transactionKey);
        },
        initialiseDialog: function initialiseDialog() {
            __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].log('initialiseDialog');

            this.$store.dispatch('fetchAllGroups');

            this.$refs.focus.focus();
            this.typeHasValue = this.model.type;
            this.nameHasValue = this.model.type;
            this.filterArray = __WEBPACK_IMPORTED_MODULE_11__helpers_FilterHelpers__["a" /* default */].filterObjectToArray(this.model.filter);
            this.editingTask = null;
        }
    },

    watch: {
        'settings.visible': function settingsVisible(newVal) {
            var _this3 = this;

            if (newVal) {
                setTimeout(function () {
                    _this3.initialiseDialog();
                }, 300);
            } else {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_Utilities__["a" /* default */].clearProperties(_this3.model);

                    _this3.tab = 'Details';
                }, 300);
            }
        }
    },

    mounted: function mounted() {},
    beforeDestroy: function beforeDestroy() {
        console.log('destroying');
    }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DateBox__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DateBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_DateBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_DateTime__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_DateTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_checklist__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_checklist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_checklist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_StatusBox__ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_StatusBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_StatusBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_ImportItems__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_ImportItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_ImportItems__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ElementSummary__ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_ElementSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_ElementSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_ElementButton__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_ElementButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_ElementButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_elements_UploadFirebase__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_elements_UploadFirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ui_elements_UploadFirebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_UploadElement__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_elements_UploadElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ui_elements_UploadElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_LoanDiagram__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_LoanDiagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ui_elements_LoanDiagram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_elements_HomeLoan__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_elements_HomeLoan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ui_elements_HomeLoan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_elements_OutstandingsDiagram__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_elements_OutstandingsDiagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__ui_elements_OutstandingsDiagram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_elements_TransactionSummary__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ui_elements_TransactionSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__ui_elements_TransactionSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_elements_ComingUp__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ui_elements_ComingUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__ui_elements_ComingUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_TaskDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_TaskDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ui_elements_TaskDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__screens_PageLayout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__screens_PageLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__screens_PageLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__screens_ElementControl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__screens_ElementControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__screens_ElementControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__screens_ScreenData__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_elements_ExporterDialog__ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ui_elements_ExporterDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__ui_elements_ExporterDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_elements_ChargeDialog__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ui_elements_ChargeDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__ui_elements_ChargeDialog__);




var _computed;






































/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dateMenuVisible: false,
            taskDialog: {
                settings: {
                    visible: false,
                    title: 'Task Details'
                },
                model: {
                    key: null,
                    title: null,
                    due: null,
                    assigned: {}
                }
            },
            exporterDialog: {
                settings: {
                    visible: false,
                    title: 'Export History'
                }
            },
            chargeDialogData: {
                charge: {
                    date: __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].todayString(),
                    to: null,
                    description: '',
                    amount: 0,
                    from: null,
                    clients: ''
                },
                settings: {
                    visible: false,
                    title: 'Charge Details'
                }
            },

            chargeDialog: {
                settings: {
                    visible: false,
                    title: 'Charge Details'
                },
                initialValues: {
                    key: null,
                    client: null,
                    recipient: null,
                    amount: null
                },
                page: {
                    title: 'Charge Details',
                    hideTitle: true,
                    hideIcons: true,
                    flat: true,
                    table: 'billing',
                    type: 'Group',
                    elements: [{
                        name: 'charge_date',
                        fieldPos: 'i1',
                        title: 'Charge Date',
                        type: 'Date',
                        control: 'Date',
                        default: '[today]',
                        value: null,
                        required: true
                    }, {
                        name: 'amount',
                        fieldPos: 'f1',
                        title: 'Amount',
                        type: 'Number',
                        control: 'Currency',
                        value: null,
                        required: true
                    }, {
                        name: 'note',
                        fieldPos: 'f2',
                        title: 'Note',
                        type: 'Text',
                        control: 'Text',
                        value: null
                    }, {
                        name: 'recipient',
                        fieldPos: 'i2',
                        title: 'Processor',
                        type: 'Contact',
                        control: 'SelectUser',
                        value: null,
                        default: '[user]',
                        required: true

                    }, {
                        name: 'payer',
                        fieldPos: 'i3',
                        title: 'Broker',
                        type: 'Contact',
                        control: 'SelectUser',
                        value: null,
                        default: null,
                        required: true
                    }, {
                        name: 'clients',
                        fieldPos: 'i4',
                        title: 'Clients',
                        type: 'Hidden',
                        control: 'Text',
                        hidden: true,
                        value: null
                    }]
                }
            }

        };
    },


    props: {
        element: Object,
        hideHints: Boolean
    },

    components: {
        Flag: __WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag___default.a,
        DateBox: __WEBPACK_IMPORTED_MODULE_5__ui_elements_DateBox___default.a,
        DateTime: __WEBPACK_IMPORTED_MODULE_6__ui_elements_DateTime___default.a,
        CurrencyBox: __WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox___default.a,
        ImportItems: __WEBPACK_IMPORTED_MODULE_11__ui_elements_ImportItems___default.a,
        ElementSummary: __WEBPACK_IMPORTED_MODULE_12__ui_elements_ElementSummary___default.a,
        ElementButton: __WEBPACK_IMPORTED_MODULE_13__ui_elements_ElementButton___default.a,
        StatusBox: __WEBPACK_IMPORTED_MODULE_9__ui_elements_StatusBox___default.a,
        Checklist: __WEBPACK_IMPORTED_MODULE_8__ui_elements_checklist___default.a,
        UploadFirebase: __WEBPACK_IMPORTED_MODULE_19__ui_elements_UploadFirebase___default.a,
        UploadElement: __WEBPACK_IMPORTED_MODULE_20__ui_elements_UploadElement___default.a,
        LoanDiagram: __WEBPACK_IMPORTED_MODULE_21__ui_elements_LoanDiagram___default.a,
        HomeLoan: __WEBPACK_IMPORTED_MODULE_22__ui_elements_HomeLoan___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_24__ui_elements_UserChooser___default.a,
        TransactionSummary: __WEBPACK_IMPORTED_MODULE_25__ui_elements_TransactionSummary___default.a,
        ComingUp: __WEBPACK_IMPORTED_MODULE_26__ui_elements_ComingUp___default.a,
        OutstandingsDiagram: __WEBPACK_IMPORTED_MODULE_23__ui_elements_OutstandingsDiagram___default.a,
        TaskDialog: __WEBPACK_IMPORTED_MODULE_28__ui_elements_TaskDialog___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_27__ui_elements_DialogBox___default.a,
        PageLayout: __WEBPACK_IMPORTED_MODULE_31__screens_PageLayout___default.a,
        ElementControl: __WEBPACK_IMPORTED_MODULE_32__screens_ElementControl___default.a,
        ExporterDialog: __WEBPACK_IMPORTED_MODULE_37__ui_elements_ExporterDialog___default.a,
        ChargeDialog: __WEBPACK_IMPORTED_MODULE_38__ui_elements_ChargeDialog___default.a
    },

    computed: (_computed = {
        chargeDialogDisabled: function chargeDialogDisabled() {
            return this.$refs.chargePage ? !this.$refs.chargePage.valid : true;
        },
        selectedSectionKey: function selectedSectionKey() {
            var selectedSection = this.$store.getters.selectedSection;
            if (!selectedSection) return null;
            return selectedSection.key;
        },
        selectedTabKey: function selectedTabKey() {
            var selectedTab = this.$store.getters.selectedTab;
            if (!selectedTab) return null;
            return selectedTab.key;
        },
        elements: function elements() {
            return this.$store.getters.elements;
        },
        user: function user() {
            return this.$store.getters.user;
        },
        statusOptions: function statusOptions() {
            return __WEBPACK_IMPORTED_MODULE_18__helpers_LookupData__["a" /* default */].outstandingStatuses();
        },
        transaction: function transaction() {
            return this.$store.getters.transaction;
        },

        userChooserUser: {
            get: function get() {
                var contactElements = __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].contactElementsForRole(this.element.role, this.elements);
                if (contactElements.length == 0) return null;
                var contactElement = contactElements[0];
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, contactElement.contact, { key: contactElement.contactKey });
            },
            set: function set(newVal) {
                if (newVal) {
                    this.chooseUser(newVal);
                } else {
                    console.log('to unlink here');
                }
            }
        },
        checkboxListValue: {
            get: function get() {
                if (!this.element.value || !Array.isArray(this.element.value)) return [];else return this.element.value;
            },
            set: function set(newVal) {
                this.element.value = newVal;
            }
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, 'elements', function elements() {
        return this.$store.getters.elements;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_computed, 'outstandingItems', function outstandingItems() {
        return this.elements.filter(function (o) {
            return o.type == 'Outstanding';
        });
    }), _computed),

    methods: {
        bulkChangeOutstandings: function bulkChangeOutstandings(fromStatus, toStatus) {
            var _this = this;

            this.outstandingItems.forEach(function (item) {
                if (item.status.startsWith(fromStatus)) {
                    _this.$set(item, 'status', toStatus);
                    _this.saveElement(item);
                }
            });
        },
        loanAttributes: function loanAttributes() {
            return __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].loanAttributes(this.element, this.elements);
        },
        exportHistory: function exportHistory(element) {
            this.exporterDialog.settings.element = element;
            this.exporterDialog.settings.visible = true;
        },
        exportSave: function exportSave(settings) {
            var newElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, settings.element);
            newElement.complete = true;
            this.saveElement(newElement);
        },
        datePickerChanged: function datePickerChanged() {
            this.saveElement(this.element);
        },
        toggleSectionComplete: function toggleSectionComplete() {
            var section = {
                key: this.element.key,
                complete: !Boolean(this.element.complete)
            };
            this.saveElement(section);
        },
        showTaskDialog: function showTaskDialog(element) {

            var dateStr = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].smartDaysFromNow(element.days).formatBackwards();


            this.taskDialog.model.assigned = this.user;

            if (element.role) {
                var elements = __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].contactElementsForRole(element.role, this.elements);
                if (elements && elements.length) {
                    this.taskDialog.model.assigned = elements[0].contact;
                    this.taskDialog.model.assigned.uid = elements[0].contactKey;
                } else __WEBPACK_IMPORTED_MODULE_30__helpers_AlertHelpers__["a" /* default */].showAlert('Nobody is assigned to role: ' + element.role);
            }

            this.taskDialog.model.due = dateStr;
            this.taskDialog.model.title = element.taskText || element.title;
            this.taskDialog.settings.visible = true;
            this.taskDialog.settings.triggerElement = element;
        },
        saveTask: function saveTask(task, settings) {
            task.sectionKey = this.selectedSectionKey;
            task.tabKey = this.selectedTabKey;

            task.lender = __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].getValueFromName('lender');

            this.$store.dispatch('saveTask', task);
            if (settings.triggerElement) this.completeElement(settings.triggerElement);
        },
        showChargeDialog: function showChargeDialog(element) {
            var broker = __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].singleContactForRole('Broker', this.elements);
            this.chargeDialogData.charge.from = __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].singleContactForRole('Processor', this.elements) || this.user;
            this.chargeDialogData.charge.date = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].todayString();
            this.chargeDialogData.charge.description = '';
            this.chargeDialogData.charge.clients = '';
            this.chargeDialogData.charge.amount = 0;

            this.chargeDialogData.charge.to = broker;
            this.chargeDialogData.charge.clients = this.transaction.clients;
            this.chargeDialogData.settings.visible = true;

            return;

            this.setDefaultValues(this.chargeDialog.page);
            this.chargeDialog.settings.visible = true;
            this.chargeDialog.settings.triggerElement = element;
        },
        setDefaultValues: function setDefaultValues(page) {
            var _this2 = this;

            page.rowKey = __WEBPACK_IMPORTED_MODULE_33__helpers_DataHelpers__["a" /* default */].getKey();
            page.elements.forEach(function (field) {
                if (field.default == '[today]') field.value = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].todayString();
                if (field.default == '[user]') field.value = __WEBPACK_IMPORTED_MODULE_33__helpers_DataHelpers__["a" /* default */].getUser();
                if (field.title == 'Amount') field.value = _this2.element.amount;
                if (field.title == 'Broker') field.value = __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].getPropertySafely(__WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].singleContactElementForRole('Broker', _this2.elements), "contact");
                if (field.title == 'Clients') field.value = _this2.transaction.clients;
            });
        },
        chargeSaved: function chargeSaved(summary) {
            this.element.value = (this.element.value ? this.element.value + ' and ' : '') + summary;
            this.element.complete = true;
            this.saveValue(this.element);
        },
        makeTaskFromDate: function makeTaskFromDate() {
            this.$emit('action', 'make-task', this.element);
            this.dateMenuVisible = false;
        },
        getValueFromName: function getValueFromName(name) {
            return __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].getValueFromName(name);
        },
        jumpFromElement: function jumpFromElement(element) {
            this.$emit('action', 'jump-from', element);
        },
        jumpToElement: function jumpToElement(element) {
            this.$emit('action', 'jump-to', element);
        },
        fullName: function fullName(contact) {
            return __WEBPACK_IMPORTED_MODULE_16__helpers_ContactHelpers__["a" /* default */].fullName(contact);
        },
        clearInput: function clearInput(element) {
            console.log('Clearing input');
            element.value = null;
        },
        isTargetComplete: function isTargetComplete(element) {
            var targetElement = this.elements.find(function (o) {
                return o.name == element.target;
            });
            return targetElement && targetElement.complete;
        },
        uploadElementMenu: function uploadElementMenu(action, elements) {
            this.$emit('action', 'email-files', elements);
        },
        chooseUser: function chooseUser(user) {
            var payload = {
                user: user,
                role: this.element.role
            };
            this.$emit('action', 'choose-user', payload);
        },
        updateElementProperty: function updateElementProperty(element, property, option) {
            element[property] = option;
            this.saveElement(element);
        },
        importItems: function importItems(items) {
            var payload = {
                items: items,
                element: this.element
            };
            this.$emit('action', 'import-outstandings', payload);
        },
        saveState: function saveState(state) {
            var newElement = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.element, state);
            this.saveElement(newElement);
        },
        saveChecklist: function saveChecklist(result) {
            __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].log('saving checklist...', result);
            var element = result.element;
            element.checklist = result.checklist;
            element.percent = result.percent;
            this.saveElement(element);
        },
        saveLoanDiagram: function saveLoanDiagram(result) {
            __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].log('saving loan diagram...', result);
            var element = result.element;
            element.diagram = result.diagram;
            element.value = result.value;
            this.saveElement(element);
        },
        saveLoanDiagram2: function saveLoanDiagram2(result) {
            this.element.value = result.html;
            this.element.summary = result.summary;
            this.saveElement(this.element);
        },
        loanDiagramChanged: function loanDiagramChanged(diagram) {
            this.$set(this.element, 'diagram2', diagram);
        },
        contactElementsForRole: function contactElementsForRole(role) {
            return __WEBPACK_IMPORTED_MODULE_17__helpers_ElementHelpers__["a" /* default */].contactElementsForRole(role, this.elements);
        },
        merge: function merge(path) {
            return __WEBPACK_IMPORTED_MODULE_15__helpers_MergeHelpers__["a" /* default */].merge(path, this.elements);
        },
        splitOptions: function splitOptions(element) {
            if (element && element.options) return element.options.split(',').map(function (item) {
                return item.trim();
            });else return ['[No Options]'];
        },
        hideHint: function hideHint(element) {
            return !element.showHint || this.hideHints;
        },
        saveValue: function saveValue(element) {
            var _this3 = this;

            this.$nextTick(function () {
                setTimeout(function () {
                    if (!element.value) element.value = null;


                    var partialElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, element);

                    _this3.$emit('change', partialElement);

                    if (element.type == 'Lookup') {
                        _this3.$emit('save-lookup', element.lookup, element.value, element.global);
                    }
                }, 100);
            });
        },
        saveElement: function saveElement(element) {
            this.$emit('change', element);
        },
        uploadStart: function uploadStart(upload, triggerElement) {

            __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].log('uploadStart', upload);
            upload.tabKey = 'settings';
            upload.transactionKey = this.transaction.key;
            upload.type = 'File';
            upload.title = upload.name;
            this.saveElement(upload);
        },
        uploadFinish: function uploadFinish(upload, triggerElement) {
            __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].log('uploadFinish', upload);
            upload.value = upload.url;
            upload.triggerElementKey = triggerElement.key;
            upload.name = triggerElement && triggerElement.targetName ? triggerElement.targetName : upload.name;
            this.saveElement(upload);
        },
        uploadStartAll: function uploadStartAll(triggerElement) {
            __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].log('uploadStartAll');

            triggerElement.loading = true;
            this.saveElement(triggerElement);
        },
        uploadFinishAll: function uploadFinishAll(triggerElement) {
            __WEBPACK_IMPORTED_MODULE_14__helpers_Utilities__["a" /* default */].log('uploadFinishAll');

            triggerElement.complete = true;
            triggerElement.loading = false;
            this.saveElement(triggerElement);
        },
        uploadedFiles: function uploadedFiles(element) {
            return this.elements.filter(function (o) {
                return o.name == element.targetName;
            });
        },
        completeElement: function completeElement(element) {
            var updates = {
                key: element.key,
                complete: true
            };
            this.saveElement(updates);
        },
        toggleChecklist: function toggleChecklist(element) {
            element.collapsed = !element.collapsed;
            this.saveElement(element);
        },
        fileFromId: function fileFromId(fileKey) {
            var element = this.elements.find(function (o) {
                return o.key == fileKey;
            });
            if (!element) return {};
            return element;
        }
    }

});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__ = __webpack_require__(5);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            menuItems: [{ days: 1, description: '1 day' }, { days: 2, description: '2 days' }, { days: 3, description: '3 days' }, { days: 4, description: '4 days' }, { days: 7, description: '1 week' }, { days: 14, description: '2 weeks' }, { days: 21, description: '3 weeks' }, { days: 30, description: '1 month' }, { days: 60, description: '2 months' }, { days: 90, description: '3 months' }]

        };
    },


    components: {},

    props: {
        element: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        scheduleDays: function scheduleDays(days) {
            this.$store.commit('saveElement', { key: this.element.key, scheduleVisible: false });
            console.log('scheduling for days: ', days);
            var returnElement = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.element);
            returnElement.scheduleDays = days;
            this.$emit('schedule', returnElement);
        }
    }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ElementHelpers__ = __webpack_require__(38);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            comment: '',
            search: ''
        };
    },


    props: {},

    computed: {
        elements: function elements() {
            var _this = this;

            var elementsList = __WEBPACK_IMPORTED_MODULE_4__helpers_ElementHelpers__["a" /* default */].getElements().map(function (o) {
                var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, o);
                obj.order = obj.title || obj.name || 'aaa';
                return obj;
            }).sort(__WEBPACK_IMPORTED_MODULE_2__helpers_OrderHelpers__["a" /* default */].sortAscending);

            if (this.search) {

                elementsList = elementsList.filter(function (o) {
                    return o.name && o.name.toLowerCase().indexOf(_this.search.toLowerCase()) > -1 || o.title && o.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
                });
            }

            return elementsList;
        }
    },

    methods: {
        log: function log(element) {
            console.log(element);
            var path = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTransactionRef().toString() + ('/elements/' + element.key);
            console.log('Path:', path);
        }
    }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_CloudHelpers__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            status: 'Empty',
            confirmation: '',
            emailRules: [function (v) {
                return !v || __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__["a" /* default */].isEmail(v) || 'Enter a valid email';
            }]
        };
    },


    props: {
        value: String,
        label: {
            type: String,
            default: 'Email'
        },
        hideDetails: [Boolean, String],
        icon: String
    },

    computed: {
        valid: function valid() {
            return this.status == '' || this.status == 'Empty' || this.value == this.confirmation;
        },
        confirmationIcon: function confirmationIcon() {
            if (this.icon) return 'arrow_right';else return '';
        },
        confirmationVisible: function confirmationVisible() {
            return this.status != 'Enter a valid email' && this.status != 'Checking' && this.status != '' && this.status != 'Empty' && this.status != 'Invalid email format';
        },
        emailValidationError: function emailValidationError() {

            if (this.valid) return '';

            if (this.status == 'Checking') return 'Checking...';

            if (this.status == 'Empty') {
                if (__WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__["a" /* default */].isEmail(this.value) || this.value.length == 0) return '';else return 'Enter a valid email';
            }

            return this.status + (this.status != 'Invalid email format' ? '. Please confirm below' : '');
        }
    },

    methods: {
        emailInput: function emailInput(newVal) {
            this.$emit('input', newVal);
        },
        validateEmail: function validateEmail(email) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (email) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:

                                _this.status = 'Checking';
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_3__helpers_CloudHelpers__["a" /* default */].validateEmail(email);

                            case 5:
                                _this.status = _context.sent;

                                console.log('validating email returned', _this.status);

                                if (_this.status == 'Unable to verify') __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].focus(_this, 'confirmation', true);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        validate: function validate() {
            return this.valid;
        }
    },

    watch: {
        'value': {
            handler: function handler(newVal) {
                this.status = 'Empty';
                this.confirmation = '';
            }
        }
    }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_LogHelpers__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactAutocomplete__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_elements_HtmlEditor__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_elements_HtmlEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ui_elements_HtmlEditor__);






var _computed;






















var db = __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.database();
var templatesRef = db.ref('empty');

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        ContactAutocomplete: __WEBPACK_IMPORTED_MODULE_21__ui_elements_ContactAutocomplete___default.a,
        HtmlEditor: __WEBPACK_IMPORTED_MODULE_22__ui_elements_HtmlEditor___default.a
    },

    props: {
        settings: Object,

        email: Object,

        returnObject: Object
    },

    data: function data() {
        return {
            userContact: {},

            emailBcc: null,
            mostRecentGreeting: null,
            showCC: false,
            showAttachments: false,
            automaticSubject: false,
            preferences: {
                cc: '',
                bcc: '',
                signature: '',
                broker: false
            },
            template: { key: null },
            urgent: false,

            customToolbar: [[{ 'header': [1, 2, 3, 4, 5, 6, false] }], ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }, { list: "check" }], ["link", "blockquote"], [{ 'color': [] }, { 'background': [] }], ['clean']]
        };
    },


    computed: (_computed = {
        from: function from() {
            if (this.settings.sent) {
                return {
                    email: this.email.from,
                    name: this.email.fromName,
                    special: true
                };
            }

            if (this.broker && this.preferences.broker) {
                return {
                    email: this.broker.email,
                    name: __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fullName(this.broker),
                    special: true
                };
            }

            return {
                email: this.userContact.email || this.user.email,
                name: __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fullName(this.user),
                special: this.user.email !== this.userContact.email
            };
        },
        user: function user() {
            return this.$store.getters.user;
        },
        broker: function broker() {
            var brokerEls = __WEBPACK_IMPORTED_MODULE_16__helpers_ElementHelpers__["a" /* default */].contactElementsForRole('Broker', this.elements);
            if (brokerEls.length) return brokerEls[0].contact;else return null;
        },
        brokerEmail: function brokerEmail() {
            return this.broker ? this.broker.email : '';
        },
        mailToLink: function mailToLink() {
            var recipient = 'matt@ireland.mx';
            var subject = encodeURIComponent(this.email.subject);
            var body = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].removeHtml(this.email.body));
            return 'mailto:' + recipient + '?subject=' + subject + '&body=' + body;
        },
        sendLabel: function sendLabel() {
            if (this.settings.sent) return 'Send Again';else return 'Send';
        },
        attachmentsAsLinks: function attachmentsAsLinks() {
            if (!this.email || !this.email.attachments || this.email.attachments.length == 0) return '';
            var str = '';
            this.email.attachments.forEach(function (attachment) {
                str += __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__["a" /* default */].formatFileLink(attachment);
            });
            return str + '<br>';
        },
        mergeFieldsUnresolved: function mergeFieldsUnresolved() {
            return this.email.body.match(/\[(.*?)\]/) || (this.email.subject || '').match(/\[(.*?)\]/);
        },
        recipientsWithMobiles: function recipientsWithMobiles() {

            return this.email.to.filter(function (o) {
                return o.mobile;
            });
        },
        recipientsWithFaxes: function recipientsWithFaxes() {
            if (!this.email.to) return [];
            return this.email.to.filter(function (o) {
                return o.fax;
            });
        },
        validationErrors: function validationErrors() {
            var errors = [];
            if (this.mergeFieldsUnresolved) errors.push("There are unknown [merge_fields]");
            if (!this.email.subject) errors.push("You should provide a subject");
            if ((!this.email.to || !this.email.to.length) && (!this.email.cc || !this.email.cc.length) && (!this.email.bcc || !this.email.bcc.length)) errors.push("You need to provide recipients");
            return errors.join(' + ');
        }
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'user', function user() {
        return this.$store.getters.user;
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'bodyHeight', function bodyHeight() {
        var height = 340;

        if (this.showCC) height -= 54;

        if (this.showAttachments) height -= 54;

        return height;
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'greeting', function greeting() {
        return __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].greetingFromContacts(this.email.to);
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'dialogHeight', function dialogHeight() {
        return window.innerHeight - 150;
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'elements', function elements() {
        return __WEBPACK_IMPORTED_MODULE_16__helpers_ElementHelpers__["a" /* default */].getElements();
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'fields', function fields() {
        return [{
            name: 'sender',
            value: this.user.firstName
        }].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.elements));
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'contactsWithEmail', function contactsWithEmail() {
        var contacts = [];

        this.$store.getters.transactionContacts.forEach(function (contact) {
            if (contact.email) contacts.push(contact);
            if (__WEBPACK_IMPORTED_MODULE_10__helpers_Utilities__["a" /* default */].isPhoneNumber(contact.fax)) {
                var faxContact = __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].createFaxContact(contact);
                contacts.push(faxContact);
            }
        });
        return contacts;
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'primaryContactType', function primaryContactType() {

        if (!this.email.to || this.email.to.length < 1) return 'Contact';

        if (!this.email.to[0].role) {

            console.error('primaryContactType - no role passed');
            return;
        }
        var contactType = this.email.to[0].role.toLowerCase();
        if (contactType.indexOf('lender') > -1) return 'Lender';else if (contactType.indexOf('bdm') > -1) return 'BDM';else if (contactType.indexOf('client') > -1) return 'Client';else return 'Contact';
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'files', function files() {
        return this.elements.filter(function (o) {
            return o.type == 'File';
        });
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'templates', function templates() {
        var _this = this;

        var templates = this.$store.getters.templates;
        return templates.filter(function (o) {
            return o.group == _this.settings.group;
        });
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'hasRecipientsCopied', function hasRecipientsCopied() {
        return this.email.cc && this.email.cc.length || this.email.bcc && this.email.bcc.length;
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_computed, 'dialogTitle', function dialogTitle() {
        if (this.settings.sent) return 'Sent Previously';else return 'Send Email';
    }), _computed),

    methods: {
        print: function print() {
            var el = document.querySelector('.vue-html5-editor .content');
            console.log(el.innerHTML);
            __WEBPACK_IMPORTED_MODULE_10__helpers_Utilities__["a" /* default */].printHtml(el.innerHTML);
        },
        sendClicked: function sendClicked() {
            var _this2 = this;

            var email = this.createEmail();

            if (this.email.to) email.to = this.email.to.map(function (o) {
                return _this2.determineEmail(o);
            });
            if (this.email.cc) email.cc = this.email.cc.map(function (o) {
                return _this2.determineEmail(o);
            });
            if (this.email.bcc) email.bcc = this.email.bcc.map(function (o) {
                return _this2.determineEmail(o);
            });

            email.from = this.from.email;

            email.reply = email.from;
            email.fromName = this.from.name;
            email.body = this.email.body;

            email.subject = this.email.subject;

            email.attachments = (this.email.attachments || []).map(function (attachment) {
                return {
                    path: attachment.value,
                    name: attachment.originalName || attachment.filename || attachment.name || __WEBPACK_IMPORTED_MODULE_19__helpers_FileHelpers__["a" /* default */].fileNameFromStoragePath(attachment.value)
                };
            });

            var toObjArray = email.to.map(function (s) {
                return { email: s };
            });
            var attachmentArray = email.attachments.map(function (o) {
                return {
                    filename: o.name,
                    path: o.path
                };
            });
            var emailObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, email, { provider: 'smtp2go', to: toObjArray, attachments: attachmentArray });
            var logId = __WEBPACK_IMPORTED_MODULE_20__helpers_EmailHelpers__["a" /* default */].queueEmail(emailObj);
            if (this.preferences.copyMe) {
                var copyMeObj = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, emailObj);
                copyMeObj.to = [{ email: __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getUserEmail() }];
                copyMeObj.cc = [];
                copyMeObj.bcc = [];
                copyMeObj.subject = 'TACO-SENT: ' + copyMeObj.subject;
                copyMeObj.body = "*** Copy of email sent to " + emailObj.to.map(function (o) {
                    return o.email;
                }).join(',') + " ***" + '<br/><br/>' + copyMeObj.body;

                __WEBPACK_IMPORTED_MODULE_20__helpers_EmailHelpers__["a" /* default */].queueEmail(copyMeObj);
            }

            this.$root.$monitorMail(logId);

            this.$emit('sent', this.returnObject);
            this.settings.visible = false;
            return;
        },
        determineEmail: function determineEmail(obj) {
            if (!obj) return '';
            if (typeof obj == 'string') return obj;
            if (obj.email) return obj.email;
            return '';
        },
        logEmail: function logEmail(email, result) {
            var logItem = __WEBPACK_IMPORTED_MODULE_17__helpers_LogHelpers__["a" /* default */].createLogItem();

            logItem.result = result;

            logItem.userKey = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getUserId();
            logItem.type = 'email';
            logItem.tenantKey = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getTenantKey();

            var transactionDetails = __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getTransactionDetails();
            if (transactionDetails) {
                logItem.transactionKey = transactionDetails.key;
                logItem.transactionClients = transactionDetails.clients;
            }

            if (this.returnObject) {

                logItem.elementKey = this.returnObject.key;
                logItem.elementTitle = this.returnObject.title;

                logItem.elementIndex = logItem.transactionKey + '/' + logItem.elementKey;
            }

            logItem.email = email;

            __WEBPACK_IMPORTED_MODULE_17__helpers_LogHelpers__["a" /* default */].log(logItem);
        },
        sendSMS: function sendSMS() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getSettings('sms').then(function (settings) {
                _this3.recipientsWithMobiles.forEach(function (recipient) {
                    var message = settings.prefix + ' Hi ' + recipient.firstName + ', I have just sent you an important email. Give me a call if you need to. ' + settings.suffix;
                    __WEBPACK_IMPORTED_MODULE_10__helpers_Utilities__["a" /* default */].sendSMS(message, recipient.mobile);
                });
            });
            this.urgent = false;
        },
        createEmail: function createEmail() {

            return {
                to: null,
                cc: null,
                bcc: null,
                body: ''
            };
        },
        minimise: function minimise() {
            this.settings.minimised = true;
            this.settings.visible = false;
        },
        maximise: function maximise() {
            this.settings.visible = true;
        },
        cancelClicked: function cancelClicked() {
            this.closeDialog();
        },
        closeDialog: function closeDialog() {
            this.settings.visible = false;
        },
        templatesClicked: function templatesClicked() {},
        selectTemplate: function selectTemplate(template) {
            if (!template) {
                __WEBPACK_IMPORTED_MODULE_15__helpers_AlertHelpers__["a" /* default */].showAlert('No template provided');
                return;
            }

            var newTemplate = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, template);


            this.template = newTemplate;
            this.merge();
            this.mostRecentGreeting = null;
            this.mergeGreeting();
        },
        merge: function merge() {
            console.log('emailDialog > merge');

            var options = { element: this.returnObject };

            if (this.settings.customFields) {
                options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options, this.settings.customFields);
            }

            this.email.subject = __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__["a" /* default */].merge(this.template.subject, this.fields, options);
            this.automaticSubject = !this.email.subject;
            this.setAutomaticSubject();


            var mainMergeResults = __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__["a" /* default */].mergeAndAttach(this.template.body, this.fields, options);

            var signature = this.preferences.signature;
            console.log('signature is....' + signature);

            this.email.body = mainMergeResults.text + '<br><br>' + signature;

            this.email.attachments = mainMergeResults.attachments.map(function (attachment) {

                return {
                    name: attachment.name,
                    value: attachment.path,
                    title: attachment.name,
                    fileName: attachment.fileName
                };
            }).concat(this.email.attachments);
            this.showAttachments = this.email.attachments.length > 0;
        },
        subjectChanged: function subjectChanged() {
            var _this4 = this;

            setTimeout(function () {
                if (_this4.email.subject) _this4.automaticSubject = false;else {
                    _this4.automaticSubject = true;
                    _this4.setAutomaticSubject();
                }
            }, 200);
        },
        setAutomaticSubject: function setAutomaticSubject() {
            if (!this.automaticSubject) return;
            if (this.primaryContactType == 'Client') this.email.subject = 'Loan Update';else if (this.primaryContactType == 'Lender') this.email.subject = __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__["a" /* default */].merge('[loan_reference]', this.fields);else if (this.primaryContactType == 'BDM') this.email.subject = __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__["a" /* default */].merge('[loan_reference] - [client]', this.fields);else this.email.subject = __WEBPACK_IMPORTED_MODULE_12__helpers_MergeHelpers__["a" /* default */].merge('[client]', this.fields);
        },
        mergeGreeting: function mergeGreeting() {

            if (!this.greeting) return;

            if (this.mostRecentGreeting) {
                this.email.body = this.email.body.replace(this.mostRecentGreeting, this.greeting);
            } else {
                this.email.body = this.email.body.replace('[greeting]', this.greeting);
            }

            this.mostRecentGreeting = this.greeting;
        },
        resolveContacts: function resolveContacts(contactArray) {
            if (!contactArray) return [];
            var newArray = [];

            contactArray.forEach(function (contact) {
                if (typeof contact == 'string') {
                    newArray.push({
                        email: contact,
                        key: __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getKey(),
                        fullName: contact
                    });
                } else if (!contact.key && !contact.fullName) {
                    newArray.push({
                        email: contact.email,
                        key: __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getKey(),
                        fullName: contact.email
                    });
                } else newArray.push(contact);
            });
            return newArray;
        },
        initialiseDialog: function initialiseDialog() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var prefs, preferredCCArr, preferredBCCArr;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this5.email.to = _this5.resolveContacts(_this5.email.to);
                                _this5.email.cc = _this5.resolveContacts(_this5.email.cc);
                                _this5.email.bcc = _this5.resolveContacts(_this5.email.bcc);

                                if (!_this5.settings.sent) {
                                    _context.next = 6;
                                    break;
                                }

                                _this5.email.attachments.forEach(function (attachment) {
                                    _this5.$set(attachment, 'value', attachment.path);
                                    _this5.$set(attachment, 'name', attachment.filename);
                                    _this5.$set(attachment, 'name', attachment.filename);
                                    _this5.$set(attachment, 'title', attachment.filename);
                                });
                                return _context.abrupt('return');

                            case 6:

                                if (!_this5.email.attachments) _this5.email.attachments = [];

                                if (_this5.email.attachments.length) _this5.showAttachments = true;

                                _context.next = 10;
                                return __WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getSettings('email');

                            case 10:
                                prefs = _context.sent;


                                _this5.preferences.signature = prefs.signature || '';
                                _this5.preferences.cc = prefs.cc || '';
                                _this5.preferences.bcc = prefs.bcc || '';
                                _this5.preferences.broker = prefs.broker || '';
                                _this5.preferences.copyMe = prefs.copyMe || false;

                                _context.next = 18;
                                return __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fetchContact(__WEBPACK_IMPORTED_MODULE_9__helpers_DataHelpers__["a" /* default */].getUserId());

                            case 18:
                                _context.t0 = _context.sent;

                                if (_context.t0) {
                                    _context.next = 21;
                                    break;
                                }

                                _context.t0 = {};

                            case 21:
                                _this5.userContact = _context.t0;


                                if (prefs.cc) {
                                    if (!_this5.email.cc) _this5.email.cc = [];
                                    preferredCCArr = prefs.cc.split(',');

                                    preferredCCArr.forEach(function (preferredCCEntry, index) {
                                        var contact = _this5.contactsWithEmail.find(function (o) {
                                            return o.email.toLowerCase() == preferredCCEntry.trim().toLowerCase();
                                        });
                                        if (contact) _this5.email.cc.push(contact);else _this5.email.cc.push({ email: preferredCCEntry, key: '_ccAddress' + index });
                                    });
                                }

                                if (prefs.bcc) {
                                    if (!_this5.email.bcc) _this5.email.bcc = [];
                                    preferredBCCArr = prefs.bcc.split(',');

                                    preferredBCCArr.forEach(function (preferredBCCEntry, index) {
                                        var contact = _this5.contactsWithEmail.find(function (o) {
                                            return o.email.toLowerCase() == preferredBCCEntry.trim().toLowerCase();
                                        });
                                        if (contact) _this5.email.bcc.push(contact);else _this5.email.bcc.push({ email: preferredBCCEntry, key: '_bccAddress' + index });
                                    });
                                }

                                _this5.$store.dispatch('loadTemplates').then(function () {
                                    var template = _this5.templates.find(function (o) {
                                        return o.name == _this5.settings.template;
                                    });

                                    setTimeout(function () {
                                        _this5.selectTemplate(template);
                                    }, 100);
                                });

                            case 25:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        resetDialog: function resetDialog() {
            var _this6 = this;

            setTimeout(function () {
                _this6.email.to = null;
                _this6.email.cc = null;
                _this6.email.bcc = null;
                _this6.email.body = '';
                _this6.email.attachments = [];
                _this6.settings.sent = false;
                _this6.settings.showCC = false;
                _this6.mostRecentGreeting = null;
            }, 500);
        },
        sendTestEmail: function sendTestEmail() {
            var clientId = '729201786634-ehmhjpt1vs7scb5rr60tuc5ru2cc5pvd.apps.googleusercontent.com';
            var apiKey = 'AIzaSyDpqlA9Rm67VW6jnC-ZzxYZZNyW3CekVMQ';
            var scopes = 'https://www.googleapis.com/auth/gmail.readonly ' + 'https://www.googleapis.com/auth/gmail.send';

            gapi.client.setApiKey(apiKey);

            gapi.auth.signOut();

            gapi.auth.authorize({
                client_id: clientId,
                scope: scopes
            }, function (result) {

                consule.log(result);
            });
        }
    },

    watch: {
        'settings.visible': function settingsVisible(newVal) {
            if (newVal) {
                if (!this.settings.minimised) this.initialiseDialog();else this.settings.minimised = false;
            }
            if (!newVal && !this.settings.minimised) this.resetDialog();
        },

        'email.to': function emailTo(newVal) {
            this.setAutomaticSubject();
        }
    }

});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Firestore__ = __webpack_require__(27);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            visible: false,
            log: {}
        };
    },


    components: {},

    props: {},

    computed: {
        currentStatus: function currentStatus() {
            var log = this.log;
            if (!log || !log.statuses) return '';
            var statuses = log.statuses;
            if (statuses.open) return 'Open';else if (statuses.delivered) return 'Delivered';else if (statuses.sent) return 'Sent';else if (statuses.queued) return 'Queued';else return 'Waiting...';
        },
        emailToValue: function emailToValue() {
            var log = this.log;
            if (!log || !log.email || !log.email.to) return '';
            return log.email.to[0].email;
        }
    },

    methods: {
        show: function show(logId) {
            var _this = this;

            var ref = __WEBPACK_IMPORTED_MODULE_1__data_Firestore__["a" /* default */].getCollectionDocumentRefFromPath('teams/global/collections/mail/data').doc(logId);
            __WEBPACK_IMPORTED_MODULE_1__data_Firestore__["a" /* default */].streamDocument(ref, this.log);
            this.visible = true;
            setTimeout(function () {
                _this.visible = false;
            }, 15000);
        },
        hide: function hide() {
            this.visible = false;
        },
        loadLog: function loadLog() {}
    },

    created: function created() {}
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            collapsed: false
        };
    },


    components: {
        ConfirmIcon: __WEBPACK_IMPORTED_MODULE_1__ui_elements_ConfirmIcon___default.a, draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
    },

    props: {
        schema: Object,
        value: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        context: Object
    },

    computed: {
        modifiedSchema: function modifiedSchema() {
            var schema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.schema);
            schema.type = '';
            return schema;
        },
        columnStyle: function columnStyle() {
            var style = {};
            if (this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px';
            }
            return style;
        },
        schemaFields: function schemaFields() {
            var _this = this;

            this.schema.fields.forEach(function (field) {
                field._root = _this.schema._root;
            });
            return this.schema.fields;
        },
        readOnly: function readOnly() {
            return Boolean(this.schema._root.readOnly);
        },
        itemCount: function itemCount() {
            if (this.value) return this.value.length;else return 0;
        }
    },

    methods: {
        emitChanges: function emitChanges(newVal) {
            console.log('Section emitting changes', newVal);
            this.$emit('change', newVal);
        },
        toggleCollapse: function toggleCollapse() {
            this.collapsed = !this.collapsed;
        }
    },

    created: function created() {}
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_ElementsStore__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_LoanHelpers__ = __webpack_require__(85);


















/* harmony default export */ __webpack_exports__["default"] = ({
    inject: ['loadMailFunction'],
    data: function data() {
        return {
            historyElement: {},
            transactionDetails: {},
            comments: [],
            exportPreferences: [0, 1, 2, 3],
            exportOptions: {
                TRANSACTION: 0,
                CONTACTS: 1,
                FILES: 2,
                COMMENTS: 3,
                EMAILS: 4
            },
            exportFormat: 0,
            exportFormatOptions: {
                HTML: 0,
                TEXT: 1
            },
            exportText: '',
            mailLog: []
        };
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox___default.a
    },

    props: {
        settings: Object,
        elements: Array
    },

    computed: {
        exportString: function exportString() {
            if (this.exportFormat == this.exportFormatOptions.HTML) {
                var html = this.$refs.export.innerHTML;
                return html;
            } else {
                return this.allText;
            }
        },
        headingStyle: function headingStyle() {
            return 'font-size:20px;color:#5DADE2;margin:10px 0;';
        },
        imagePath: function imagePath() {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].imagePath() + '/document-simple.svg';
        },
        importantElements: function importantElements() {
            return this.elements.filter(function (o) {
                return o.important;
            });
        },
        fileElements: function fileElements() {
            return this.elements.filter(function (o) {
                return o.type == 'File';
            });
        },
        contacts: function contacts() {
            return this.elements.filter(function (o) {
                return o.type == 'Contact';
            }).map(function (o) {
                return o.contact;
            });
        },
        importantElementsStr: function importantElementsStr() {
            var str = '';
            this.elements.forEach(function (element) {
                if (element.important) {
                    str += '<b>' + element.title + ':</b> ' + element.value + '<br/>';
                }
            });
            return str;
        },
        transactionText: function transactionText() {
            var _this = this;

            var str = '*** ' + this.transactionDetails.clients + ' ***';
            this.importantElements.forEach(function (element) {
                str = _this.addLine(str, element.title + ': ' + _this.checkForLoanDiagram(element));
            });
            return str;
        },
        contactsText: function contactsText() {
            var _this2 = this;

            var str = '*** CONTACTS ***';
            this.contacts.forEach(function (contact) {
                str = _this2.addLine(str, __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fullName(contact));
                str = _this2.addLine(str, __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].phoneNumbers(contact));
                str = _this2.addLine(str, '---');
            });
            return str;
        },
        commentsText: function commentsText() {
            var _this3 = this;

            var str = '*** COMMENTS ***';
            this.comments.forEach(function (comment) {
                str = _this3.addLine(str, comment.text);
                str = _this3.addLine(str, __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].backwardsToAu(comment.stamp.date) + ' - ' + __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fullName(comment.stamp));
                str = _this3.addLine(str, '---');
            });
            return str;
        },
        filesText: function filesText() {
            var _this4 = this;

            var str = '*** FILES ***';
            this.fileElements.forEach(function (file) {
                str = _this4.addLine(str, file.title);
                str = _this4.addLine(str, file.value);
                str = _this4.addLine(str, __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].backwardsToAu(file.stamp.date) + ' - ' + __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fullName(file.stamp));
                str = _this4.addLine(str, '---');
            });
            return str;
        },
        emailsText: function emailsText() {
            var _this5 = this;

            var str = '*** EMAILS ***';

            this.mailLog.forEach(function (mailLogItem) {
                str = _this5.addLine(str, 'From: ' + mailLogItem.email.from);
                str = _this5.addLine(str, 'To: ' + mailLogItem.email.to.map(function (recipient) {
                    return recipient.email;
                }).join(', '));
                str = _this5.addLine(str, 'Subject: ' + mailLogItem.email.subject);
                str = _this5.addLine(str, 'Body: ' + _this5.removeHtml(mailLogItem.email.body));
                str = _this5.addLine(str, '\n');
            });

            return str;
        },
        allText: function allText() {
            var str = '';
            if (this.exportPreferences.includes(this.exportOptions.TRANSACTION)) str = this.addLine(str, this.transactionText);
            if (this.exportPreferences.includes(this.exportOptions.CONTACTS)) str = this.addLine(str, this.contactsText);
            if (this.exportPreferences.includes(this.exportOptions.FILES)) str = this.addLine(str, this.filesText);
            if (this.exportPreferences.includes(this.exportOptions.COMMENTS)) str = this.addLine(str, this.commentsText);
            if (this.exportPreferences.includes(this.exportOptions.EMAILS)) str = this.addLine(str, this.emailsText);

            return str;
        }
    },

    methods: {
        removeHtml: function removeHtml(html) {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].removeHtml(html, true);
        },
        save: function save() {
            __WEBPACK_IMPORTED_MODULE_2_clipboard_js___default.a.copy({ 'text/html': this.exportString });
            __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__["a" /* default */].showAlert('Copied to clipboard');
            this.$emit('save', this.settings);
        },
        phoneNumbers: function phoneNumbers(contact) {
            return __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].phoneNumbers(contact);
        },
        loadComments: function loadComments() {
            var _this6 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('comments');
            __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (comments) {
                _this6.comments = comments.sort(__WEBPACK_IMPORTED_MODULE_8__helpers_OrderHelpers__["a" /* default */].sortByTimestampDescending);
            });
        },
        loadTransactionDetails: function loadTransactionDetails() {
            var _this7 = this;

            var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('details');
            __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (details) {
                _this7.transactionDetails = details;
            });
        },
        initialise: function initialise() {},
        addLine: function addLine(originalText, addText) {
            if (originalText && addText) originalText += '\n';
            originalText += addText;
            return originalText;
        },
        checkForLoanDiagram: function checkForLoanDiagram(element) {
            if (element.name == 'loan_diagram') {
                var diagramDetails = __WEBPACK_IMPORTED_MODULE_14__helpers_LoanHelpers__["a" /* default */].diagramDetails(element.diagram);
                var desc = __WEBPACK_IMPORTED_MODULE_14__helpers_LoanHelpers__["a" /* default */].diagramDescription(diagramDetails);
                return __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__["a" /* default */].removeHtml(desc);
            } else return element.value;
        },
        loadMail: function loadMail() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this8.loadMailFunction();

                            case 2:
                                _this8.mailLog = _context.sent;

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this8);
            }))();
        }
    },

    created: function created() {
        this.settings.saveLabel = 'Copy to Clipboard';
        this.loadComments();
        this.loadTransactionDetails();
        this.loadMail();
    },
    mounted: function mounted() {
        this.historyElement = this.$refs.export;
    }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_InputDialog__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_InputDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_InputDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_UploadWrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_UploadWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_UploadWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_SelectionHelpers__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailDialog__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_FileHelpers__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jszip__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_file_saver__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_ToolbarSearch__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ui_elements_ToolbarSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ui_elements_ToolbarSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_elements_DocumentView__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_elements_DocumentView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ui_elements_DocumentView__);


























/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            search: '',
            selectedKeys: [],
            emailDialog: {

                email: {
                    to: null,
                    cc: null,
                    bcc: null,
                    subject: null,
                    body: '',
                    attachments: []
                },
                settings: {
                    visible: false,
                    group: 'Files',
                    template: 'Send Files'
                }
            },
            inputDialog: {
                settings: {
                    visible: false,
                    description: 'New name',
                    title: "Rename File",
                    default: null
                }
            }
        };
    },

    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default.a,
        UploadWrapper: __WEBPACK_IMPORTED_MODULE_7__ui_elements_UploadWrapper___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_13__ui_elements_DeleteButton___default.a,
        EmailDialog: __WEBPACK_IMPORTED_MODULE_14__ui_elements_EmailDialog___default.a,
        InputDialog: __WEBPACK_IMPORTED_MODULE_6__ui_elements_InputDialog___default.a,
        ToolbarSearch: __WEBPACK_IMPORTED_MODULE_21__ui_elements_ToolbarSearch___default.a,
        DocumentView: __WEBPACK_IMPORTED_MODULE_22__ui_elements_DocumentView___default.a
    },

    props: {
        element: Object,
        settings: Object,
        files: Array

    },

    computed: {
        linkedKeys: function linkedKeys() {
            if (!this.element) return [];

            var newKeys = this.element.linkedFileKeys || [];

            var oldKeys = __WEBPACK_IMPORTED_MODULE_8__helpers_ElementHelpers__["a" /* default */].filesForElement(this.element, this.elements).map(function (o) {
                return o.key;
            });
            oldKeys.forEach(function (key) {
                __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelpers__["a" /* default */].pushUnique(key, newKeys);
            });

            return newKeys;
        },
        elements: function elements() {
            return this.$store.getters.elements;
        },
        linkedFiles: function linkedFiles() {
            var _this = this;

            return this.files.filter(function (file) {
                return _this.linkedKeys.indexOf(file.key) > -1;
            });
        },
        unlinkedFiles: function unlinkedFiles() {
            var _this2 = this;

            return this.files.filter(function (file) {
                return _this2.linkedKeys.indexOf(file.key) == -1;
            });
        },
        filesDisplay: function filesDisplay() {
            var _this3 = this;

            var allFiles = [];
            allFiles = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.linkedFiles), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.unlinkedFiles)).filter(function (file) {
                if (!_this3.search) return true;

                return file.fileName.toLowerCase().indexOf(_this3.search.toLowerCase()) > -1;
            });
            return allFiles;
        },
        selectedFiles: function selectedFiles() {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_SelectionHelpers__["a" /* default */].getSelectedItems(this.filesDisplay, this.selectedKeys);
        },
        selectedLinkedKeys: function selectedLinkedKeys() {
            var _this4 = this;

            return this.selectedKeys.filter(function (key) {
                return _this4.linkedKeys.indexOf(key) > -1;
            });
        },
        selectedUnlinkedKeys: function selectedUnlinkedKeys() {
            var _this5 = this;

            return this.selectedKeys.filter(function (key) {
                return _this5.linkedKeys.indexOf(key) == -1;
            });
        },
        linkButtonVisible: function linkButtonVisible() {
            return this.element && this.selectedUnlinkedKeys;
        },
        isMobile: function isMobile() {
            return __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].isMobile();
        }
    },

    methods: {
        downloadZip: function downloadZip() {
            __WEBPACK_IMPORTED_MODULE_17__helpers_AlertHelpers__["a" /* default */].showAlert('Downloading...See below');
            var zip = new __WEBPACK_IMPORTED_MODULE_18_jszip___default.a();
            var folder = zip.folder('files');
            this.selectedFiles.forEach(function (file) {

                var blobPromise = fetch(file.value).then(function (r) {
                    if (r.status === 200) return r.blob();
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(new Error(r.statusText));
                });

                var name = __WEBPACK_IMPORTED_MODULE_16__helpers_FileHelpers__["a" /* default */].fileNameFromStoragePath(file.originalName);
                folder.file(name, blobPromise);
            });

            zip.generateAsync({ type: "blob" }).then(function (blob) {
                __WEBPACK_IMPORTED_MODULE_19_file_saver___default()(blob, 'documents_download.zip');
            }).catch(function (e) {
                return console.log(e);
            });
        },
        getFileName: function getFileName(file) {
            return file.fileName || file.name.replace(/\_/g, ' ');
        },
        renameFile: function renameFile() {
            var selectedFile = this.selectedFiles[0];

            this.inputDialog.settings.default = selectedFile.fileName || selectedFile.name;
            this.inputDialog.settings.file = selectedFile;
            this.inputDialog.settings.visible = true;
        },
        copyLink: function copyLink() {
            var selectedFile = this.selectedFiles[0];
            __WEBPACK_IMPORTED_MODULE_20_clipboard_js___default.a.copy({ 'text': selectedFile.value });
            __WEBPACK_IMPORTED_MODULE_17__helpers_AlertHelpers__["a" /* default */].showAlert('Link copied to clipboard');
        },
        changeFileName: function changeFileName(newName, settings) {
            if (!newName) return;

            var newFile = {
                key: settings.file.key,
                fileName: newName
            };
            this.saveElement(newFile);
        },
        emailFiles: function emailFiles() {
            this.emailDialog.email.attachments = this.selectedFiles;
            this.emailDialog.settings.visible = true;
        },
        fileIconString: function fileIconString(file) {

            if (!file || !file.originalName) return 'library_books';

            var fileExtension = file.originalName.split('.').pop().toLowerCase();

            if (fileExtension == 'pdf') return 'mdi-file-pdf-outline';else if (fileExtension == 'doc') return 'perm_media';else if (fileExtension == 'jpg' || fileExtension == 'gif' || fileExtension == 'png') return 'mdi-image-outline';else return 'library_books';
        },
        uploadFiles: function uploadFiles(files) {
            this.$store.dispatch('uploadFiles', { files: files, 'element': this.element });
        },
        selectLinkedKeys: function selectLinkedKeys() {
            var _this6 = this;

            this.selectedKeys.splice(0, this.selectedKeys.length);
            this.linkedKeys.forEach(function (key) {
                _this6.selectedKeys.push(key);
            });
        },
        linkSelectedFiles: function linkSelectedFiles() {
            this.linkSelectedKeys();
            this.changeSelectedFileNames();
        },
        linkSelectedKeys: function linkSelectedKeys() {
            var newLinkedKeys = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.linkedKeys));
            this.selectedKeys.forEach(function (key) {
                __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelpers__["a" /* default */].pushUnique(key, newLinkedKeys);
            });
            var newElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.element);
            newElement.linkedFileKeys = newLinkedKeys;

            this.saveElement(newElement);
        },
        changeSelectedFileNames: function changeSelectedFileNames() {
            var _this7 = this;

            var targetFileName = this.element.targetName;
            if (!targetFileName) return;
            this.selectedFiles.forEach(function (file) {
                if (file.name != targetFileName) {
                    file.name = targetFileName;
                    _this7.saveElement(file);
                }
            });
        },
        unlinkSelectedFiles: function unlinkSelectedFiles() {
            var _this8 = this;

            var newLinkedKeys = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.linkedKeys));
            this.selectedKeys.forEach(function (key) {
                __WEBPACK_IMPORTED_MODULE_15__helpers_ArrayHelpers__["a" /* default */].deleteItem(key, newLinkedKeys);

                var obj = {
                    key: key,
                    triggerElementKey: null,
                    name: 'general_file'
                };
                _this8.saveElement(obj);
            });

            var newElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.element);
            newElement.linkedFileKeys = newLinkedKeys;

            this.saveElement(newElement);
        },
        unlinkAllFiles: function unlinkAllFiles() {
            var newElement = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.element);
            newElement.linkedFileKeys = [];
            this.saveElement(newElement);
        },
        deleteSelectedFiles: function deleteSelectedFiles() {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this9.$root.$confirm('Delete', 'Delete these files completely?', { color: 'red' });

                            case 2:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 7;
                                    break;
                                }

                                _this9.unlinkSelectedFiles();
                                _this9.selectedFiles.forEach(function (file) {
                                    _this9.deleteElement(file);
                                });
                                _this9.selectedKeys = [];

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this9);
            }))();
        },
        deleteElement: function deleteElement(element) {
            this.$store.dispatch('deleteElement', element);
        },
        selectSingle: function selectSingle(file) {
            console.log('Calculated file name is', __WEBPACK_IMPORTED_MODULE_16__helpers_FileHelpers__["a" /* default */].fileNameFromStoragePath(file.value));

            var path = __WEBPACK_IMPORTED_MODULE_12__helpers_DataHelpers__["a" /* default */].getTransactionRef().toString() + ('/elements/' + file.key);
            console.log('File Clicked', path);

            __WEBPACK_IMPORTED_MODULE_11__helpers_SelectionHelpers__["a" /* default */].selectSingle(file.key, this.selectedKeys);
        },
        selectMulti: function selectMulti(file) {
            console.log('ctrlclicked', file.key);
            __WEBPACK_IMPORTED_MODULE_11__helpers_SelectionHelpers__["a" /* default */].selectMulti(file.key, this.selectedKeys);
        },
        selectRange: function selectRange(file) {
            console.log('shiftclicked', file.key);
            __WEBPACK_IMPORTED_MODULE_11__helpers_SelectionHelpers__["a" /* default */].selectRange(file.key, this.selectedKeys, this.filesDisplay.map(function (o) {
                return o.key;
            }));
        },
        isSelected: function isSelected(fileKey) {
            return this.selectedKeys.indexOf(fileKey) > -1;
        },
        isLinked: function isLinked(fileKey) {
            return this.linkedKeys.indexOf(fileKey) > -1;
        },
        saveElement: function saveElement(element) {
            this.$store.dispatch('saveElement', element);
        },
        initialiseDialog: function initialiseDialog() {
            this.selectedKeys = [];
            this.search = '';
            __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].focus(this, 'search');
        }
    },

    created: function created() {
        if (this.element) this.settings.title = 'Files for ' + this.element.title;
    }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ElementHelpers__ = __webpack_require__(38);
















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        elements: Array,
        filterProp: Object
    },
    components: {
        'DialogBox': __WEBPACK_IMPORTED_MODULE_10__ui_elements_DialogBox___default.a

    },
    data: function data() {
        return {
            filter: {
                type: 'Visible',
                name: '',
                values: [],
                operator: 'Equals'
            }

        };
    },

    computed: {
        transaction: function transaction() {
            return this.$store.getters.transaction;
        },
        masterElements: function masterElements() {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_ElementHelpers__["a" /* default */].getMasters(this.transaction.masterKey);
        },
        masterNames: function masterNames() {
            return this.masterElements.map(function (o) {
                return o.name;
            }).filter(function (i) {
                return i != null;
            }).sort();
        },
        operators: function operators() {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__["a" /* default */].operators();
        },
        masterChoices: function masterChoices() {

            var name = this.filter.name;
            if (!name) return [];
            var masterElement = this.masterElements.find(function (o) {
                return o.name == name;
            });
            if (!masterElement) return [];

            if (masterElement.type == 'List') {
                var optionsString = masterElement.options || '';
                var options = optionsString.split(',').map(function (i) {
                    return i.trim();
                });
                return ['Blank', 'Non Blank'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(options));
            }

            if (masterElement.type == 'Switch' || masterElement.type == 'Checkbox') {
                return ['Yes', 'No'];
            }

            return ['Blank', 'Non Blank'];
        },
        isFormValid: function isFormValid() {
            return this.filter.name && this.filter.values.length;
        }
    },
    methods: {
        save: function save() {
            this.$emit('save', this.filter);
        },
        showDialog: function showDialog() {
            if (this.filterProp) {
                this.filter = this.filterProp;
            }
        },
        hideDialog: function hideDialog() {
            var _this = this;

            setTimeout(function () {
                _this.filter = {
                    type: 'Visible',
                    name: '',
                    values: [],
                    operator: 'Equals'
                };
            }, 300);
        }
    }

});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        value: String,
        white: Boolean,
        red: Boolean,
        purple: Boolean,
        orange: Boolean,
        transparent: Boolean,
        primary: Boolean,
        success: Boolean,
        error: Boolean,
        small: Boolean,
        darkred: Boolean
    },

    computed: {
        mainClass: function mainClass() {
            var newClass = '';
            if (!this.transparent) newClass = "flag";
            if (this.purple) newClass += " flag-purple";else if (this.orange) newClass += " flag-orange";else if (this.darkred) newClass += " flag-dark-red";else if (this.red) newClass += " flag-error";else if (this.error) newClass += " flag-error";else if (this.primary) newClass += " flag-primary";else if (this.success) newClass += " flag-success";else if (this.white) newClass += " flag-white";

            if (this.small) newClass += " flag-small";

            return newClass;
        },
        visible: function visible() {
            return true;
            if (!this.$slots.default) return false;else return !!this.$slots.default[0].text.length;
        }
    },

    methods: {}
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_FormControl__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__forms_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__forms_FormControl__);




/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    FormControl: __WEBPACK_IMPORTED_MODULE_1__forms_FormControl___default.a
  },
  data: function data() {
    return {
      value: null,
      schema: null,
      visible: false,
      resolve: null,
      reject: null
    };
  },

  computed: {
    formWidth: function formWidth() {
      if (!this.schema) return 650;

      return this.schema.width || 650;
    }
  },

  methods: {
    open: function open(value, schema) {
      var _this = this;

      this.schema = schema;
      this.value = value;
      this.visible = true;
      setTimeout(function () {
        _this.$refs.theForm.focusFirst();
      }, 400);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    cancel: function cancel() {
      this.resolve(false);
      this.visible = false;
    },
    save: function save() {
      this.resolve(this.value);
      this.visible = false;
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            layout: {
                title: 'stamp.firstName',
                subtitle: 'stamp.date'
            }
        };
    },


    props: {
        items: Array
    },

    computed: {},

    methods: {
        stringify: function stringify(obj) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
        }
    },

    watch: {}
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_GenericList__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_GenericList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_GenericList__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            value: ''
        };
    },

    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default.a,
        GenericList: __WEBPACK_IMPORTED_MODULE_1__ui_elements_GenericList___default.a
    },

    props: {
        items: Array,
        settings: Object,
        clickHandler: Function
    },

    computed: {},

    methods: {
        listItemClicked: function listItemClicked(item) {
            console.log('listItemClicked', item);
            this.clickHandler(item);
        },
        initialiseDialog: function initialiseDialog() {
            if (this.settings.default) this.value = this.settings.default;
            setTimeout(function () {}, 500);
        }
    },

    created: function created() {}
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            groupName: '',
            visible: false
        };
    },


    components: {},

    props: {
        label: {
            default: 'Select a Group',
            type: String
        },
        groups: {
            type: Array
        },
        existingOnly: {
            default: false,
            type: Boolean
        },
        buttonClass: {
            type: String
        }
    },

    computed: {
        uniqueGroupName: function uniqueGroupName() {
            var name = void 0;
            for (var n = 1; n < 99; n++) {
                name = 'Group ' + n.toString();
                if (this.groups.findIndex(function (o) {
                    return o.name == name;
                }) < 0) break;
            }
            return name;
        }
    },

    methods: {
        initialiseDropdown: function initialiseDropdown() {
            if (!this.existingOnly) {
                this.groupName = this.uniqueGroupName;
                __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__["a" /* default */].focus(this, 'group', true);
            }
        },
        select: function select(group) {
            this.$emit('select', group);
            this.visible = false;
        },
        newGroup: function newGroup() {
            this.$emit('new', this.groupName);
            this.visible = false;
        }
    },

    created: function created() {}
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__ = __webpack_require__(12);












var db = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.database();
var smsTemplatesRef = db.ref('empty');

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            visible: false,
            adding: false,
            group: {
                name: null,
                role: false,
                stamp: null
            },
            selectedGroups: {}
        };
    },


    computed: {
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        },
        groups: function groups() {
            return this.$store.getters.groups;
        }
    },

    props: {
        settings: Object,
        selected: Object
    },

    components: {
        'Flag': __WEBPACK_IMPORTED_MODULE_7__ui_elements_Flag___default.a
    },

    methods: {
        openDialog: function openDialog() {
            this.visible = true;
            this.$store.dispatch('fetchAllGroups');
            if (this.selected) this.selectedGroups = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.selected);else this.selectedGroups = {};
        },
        closeDialog: function closeDialog() {
            this.visible = false;
            this.adding = false;
            this.group.name = null;
            this.group.role = null;
            this.group.stamp = null;
        },
        saveAndSelect: function saveAndSelect() {
            this.group.stamp = __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].getStamp();
            var ref = __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].getTenantRef().child('groups');
            ref.push(this.group);
            this.select(this.group);
        },
        done: function done() {
            this.$emit('select', this.selectedGroups);
            this.closeDialog();
        },
        select: function select(group) {
            if (this.settings.multiselect) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__["a" /* default */].objectToggle(this.selectedGroups, group.name);
            } else {
                this.$emit('select', group);
                this.closeDialog();
            }
        },
        deleteGroup: function deleteGroup(group) {
            this.$store.commit('deleteGroup', group);
            var ref = __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('groups').child(group.key);
            ref.remove();
            __WEBPACK_IMPORTED_MODULE_8__helpers_AlertHelpers__["a" /* default */].showAlert('Group Deleted');
        },
        isSelected: function isSelected(item) {
            return this.selectedGroups[item.name];
        }
    },
    created: function created() {},

    watch: {}

});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LabelMenu__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_LabelMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_LabelMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_Timer__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ui_elements_Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ui_elements_Timer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_EditableText__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_EditableText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_EditableText__);





















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dragging: false,
            loanDialog: {
                loan: {
                    amount: 0,
                    years: 30
                },
                settings: {
                    visible: false,
                    title: 'Loan Details'
                }
            },
            propertyDialog: {
                property: {
                    value: 0
                },
                settings: {
                    visible: false,
                    title: 'Property Details'
                }
            },
            fixedOptions: [{ text: 'Variable', value: 0 }, { text: '1y Fixed', value: 1 }, { text: '2y Fixed', value: 2 }, { text: '3y Fixed', value: 3 }, { text: '4y Fixed', value: 4 }, { text: '5y Fixed', value: 5 }],
            rateLockOptions: [{ text: 'No lock', value: false }, { text: 'Rate Lock', value: true }],
            ioOptions: [{ text: 'P&I', value: 0 }, { text: '1y IO', value: 1 }, { text: '2y IO', value: 2 }, { text: '3y IO', value: 3 }, { text: '4y IO', value: 4 }, { text: '5y IO', value: 5 }],
            investmentPropertyOptions: [{ text: 'Owner Occ', value: false }, { text: 'Investment', value: true }],
            existingPropertyOptions: [{ text: 'New', value: false }, { text: 'Existing', value: true }],

            loanPurposeOptions: [{ text: 'OO', value: false }, { text: 'Inv', value: true }],

            lmiOptions: ['None', 'Capitalised', 'Included'],

            propertyTypes: [{ text: 'House', value: "House" }, { text: "Townhouse", value: "Townhouse" }, { text: 'Unit', value: "Unit" }, { text: 'Land', value: "Land" }, { text: 'Build', value: "Build" }]
        };
    },


    components: {
        LabelMenu: __WEBPACK_IMPORTED_MODULE_6__ui_elements_LabelMenu___default.a, DeleteButton: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DeleteButton___default.a, CurrencyBox: __WEBPACK_IMPORTED_MODULE_10__ui_elements_CurrencyBox___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_9__ui_elements_DialogBox___default.a, Timer: __WEBPACK_IMPORTED_MODULE_16__ui_elements_Timer___default.a, EditableText: __WEBPACK_IMPORTED_MODULE_17__ui_elements_EditableText___default.a
    },

    props: {
        homeLoan: Object
    },

    computed: {
        activeLoanPayment: function activeLoanPayment() {
            var payment = __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__["a" /* default */].loanPayment(this.loanDialog.loan);
            return payment;
        },
        yearsOptions: function yearsOptions() {
            var terms = [];
            for (var n = 1; n < 31; n++) {
                terms.push(n);
            }
            return terms;
        },
        allLoans: function allLoans() {
            var loans = [];
            this.homeLoan.groups.forEach(function (group) {
                loans = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(loans), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(group.loans));
            });
            return loans;
        },
        allProperties: function allProperties() {
            var properties = [];
            this.homeLoan.groups.forEach(function (group) {
                properties = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(properties), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(group.properties));
            });
            return properties;
        },
        allOOProperties: function allOOProperties() {
            return this.allProperties.filter(function (o) {
                return !o.investment;
            });
        },
        summary: function summary() {
            return [__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'New Money', format: 'Currency', value: 0, id: 'newMoney', name: 'total_new_money', dashboards: true }, 'value', this.totalNewMoney), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Mortgage Insurance', format: 'Currency', value: 0, id: 'lmi', name: 'total_lmi' }, 'value', this.sumLoansWhere('lmi', true, 'lmi')), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Interest Only', format: 'Currency', value: 0, id: 'io', name: 'total_io' }, 'value', this.sumLoansWhere('io', true)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Fixed Rate', format: 'Currency', value: 0, id: 'fixed', name: 'total_fixed' }, 'value', this.sumLoansWhere('fixed', true)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Owner Occupied', format: 'Currency', value: 0, id: 'ownerOccupied', name: 'total_owner_occupied' }, 'value', this.sumLoansWhere('investment', false)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Investment', format: 'Currency', value: 0, id: 'investment', name: 'total_investment' }, 'value', this.sumLoansWhere('investment', true)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Rate Lock', format: 'Currency', value: 0, id: 'rateLock', name: 'total_rate_lock' }, 'value', this.sumLoansWhere('rateLock', true)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Special', format: 'Currency', value: 0, id: 'special', name: 'total_special' }, 'value', this.sumLoansWhere('special', true)), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({ title: 'Pro Package', format: 'Currency', value: 0, id: 'package', name: 'total_package' }, 'value', this.sumLoansWhere('package', true)), { title: 'Purchase Address', format: 'String', value: this.purchaseAddress, id: 'purchase_address', name: 'purchase_address' }, { title: 'Existing Address', format: 'String', value: this.existingAddress, id: 'existing_address', name: 'existing_address' }];
        },
        shortSummary: function shortSummary() {
            return this.summary.filter(function (o) {
                return o.value;
            }).map(function (o) {
                return {
                    title: o.title,
                    name: o.name,
                    value: o.format == 'Currency' ? __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].formatCurrency(o.value) : o.value
                };
            });
        },
        purchaseAddress: function purchaseAddress() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].sentenceJoin(this.allProperties.filter(function (property) {
                return !property.existing;
            }).map(function (property) {
                return property.address;
            }));
        },
        existingAddress: function existingAddress() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].sentenceJoin(this.allProperties.filter(function (property) {
                return property.existing;
            }).map(function (property) {
                return property.address;
            }));
        },
        totalNewMoney: function totalNewMoney() {
            var _this = this;

            return this.allLoans.reduce(function (sum, loan) {
                return sum + _this.loanNewMoney(loan);
            }, 0);
        }
    },

    methods: {
        loanNewMoney: function loanNewMoney(loan) {
            if (loan.newMoney) return loan.newMoney;

            var amt = loan.amount;
            if (loan.lmiType == 'Capitalised' && loan.lmi > 0) amt += loan.lmi;
            return amt;
        },
        saveDiagram: function saveDiagram() {
            var result = {
                data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.homeLoan),
                html: this.getHTML(),
                summary: this.summary
            };
            this.$emit('save', result);
        },
        loanTitle: function loanTitle(loan) {
            if (!loan.lmiType || loan.lmiType == 'None') return __WEBPACK_IMPORTED_MODULE_15__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.amount);
            if (loan.lmiType == 'Included') return loan.amount + '(incl lmi ' + __WEBPACK_IMPORTED_MODULE_15__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.lmi) + ')';
            if (loan.lmiType == 'Capitalised') return __WEBPACK_IMPORTED_MODULE_15__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.amount + loan.lmi) + ' (' + __WEBPACK_IMPORTED_MODULE_15__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.amount) + ' + ' + __WEBPACK_IMPORTED_MODULE_15__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.lmi) + ')';
        },
        loanDetails: function loanDetails(loan) {
            var desc = (loan.fixed ? 'Fixed ' + loan.fixed + 'y' : 'Vbl') + ', ' + (loan.io ? 'IO ' + loan.io + 'y' : 'P&I');

            if (loan.rate) desc = '@ ' + loan.rate + '% ' + desc;

            if (loan.fixed) {
                if (loan.rateLock) desc += ', Rate Lock';else desc += ', No Lock';
            }

            if (loan.product) desc += ', ' + loan.product;

            if (loan.existing) desc += ', *Existing';
            if (loan.package) desc += ', *Package';
            if (loan.special) desc += ', *Special';

            if (loan.years && loan.years != 30) desc += ' over ' + loan.years + 'yrs';

            return desc;
        },
        propertyDetails: function propertyDetails(property) {
            var desc = (property.existing ? 'Existing' : 'New') + ' ' + (property.investment ? 'Investment ' : 'Owner Occ') + ' ';
            property.type;

            if (property.address) desc += ' @ ' + property.address;

            return desc;
        },
        copy: function copy() {
            var html = this.getHTML();
            console.log(html);
            __WEBPACK_IMPORTED_MODULE_14_clipboard_js___default.a.copy({ 'text/html': html });
            __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Copied');
        },
        getHTML: function getHTML() {
            var html = this.$refs.simple.innerHTML;
            return html;
        },
        sumLoansWhere: function sumLoansWhere(field, exists) {
            var fieldToTally = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'amount';


            var filteredLoans = void 0;
            if (exists) filteredLoans = this.allLoans.filter(function (o) {
                return o[field];
            });else filteredLoans = this.allLoans.filter(function (o) {
                return !o[field];
            });

            return filteredLoans.reduce(function (sum, val) {
                return sum + val[fieldToTally];
            }, 0);
        },
        countOO: function countOO() {},
        split: function split(loan) {
            var duplicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var group = this.getGroup(loan);
            var idx = this.getLoanIndex(loan);
            var newLoan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, loan);
            if (!duplicate) {
                newLoan.amount = this.nearestFiveThousand(loan.amount / 2);
                loan.amount = loan.amount - newLoan.amount;
            }
            group.loans.splice(idx + 1, 0, newLoan);
        },
        addLoan: function addLoan(loan) {
            var group = this.getGroup(loan);
            group.loans.push(this.blankLoan());
        },
        addProperty: function addProperty(property) {
            var group = this.getGroup(property);
            var idx = this.getPropertyIndex(property);
            var newProperty = { value: 400000 };

            if (this.allOOProperties.length > 0) newProperty.investment = true;

            if (this.allProperties.filter(function (o) {
                return o.existing == 0;
            })) newProperty.existing = true;

            group.properties.splice(idx + 1, 0, newProperty);
        },
        deleteLoan: function deleteLoan(loan) {
            var group = this.getGroup(loan);
            var idx = this.getLoanIndex(loan);
            if (group.loans.length < 2) __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Cant delete last loan');else group.loans.splice(idx, 1);
        },
        deleteProperty: function deleteProperty(property) {
            var group = this.getGroup(property);
            var idx = this.getPropertyIndex(property);
            if (group.properties.length < 2) __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Cant delete last property');else group.properties.splice(idx, 1);
        },
        deleteGroup: function deleteGroup(groupIndex) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.$root.$confirm('Delete Entire Group', 'Are you sure you want to delete group ' + (groupIndex + 1) + '? All loans and properties will be obliterated.', { color: 'red' });

                            case 2:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 5;
                                    break;
                                }

                                _this2.homeLoan.groups.splice(groupIndex, 1);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        help: function help() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this3.$root.$youTube('2RGsedl2Qr8');

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        getLVR: function getLVR(group) {
            var totalLoans = this.totalLoans(group);
            var totalProperties = this.totalProperties(group);
            return Math.round(totalLoans / totalProperties * 10000) / 100;
        },
        getGroup: function getGroup(loanOrProperty) {
            var foundGroup = null;
            this.homeLoan.groups.forEach(function (group) {

                group.loans.forEach(function (loan) {
                    if (loan == loanOrProperty) {
                        foundGroup = group;
                    }
                });
                group.properties.forEach(function (property) {
                    if (property == loanOrProperty) foundGroup = group;
                });
            });
            return foundGroup;
        },
        getNextLoan: function getNextLoan(loan) {
            var group = this.getGroup(loan);
            var idx = group.loans.findIndex(function (o) {
                return o == loan;
            });
            return group.loans[idx + 1] || null;
        },
        resized: function resized(e) {
            console.log(e);
        },
        getPixels: function getPixels(group) {
            var width = this.$el.clientWidth;
            var dollars = this.totalProperties(group);

            var pixelsPerDollar = width / dollars;

            return pixelsPerDollar * 5000;
        },
        getLoanIndex: function getLoanIndex(loan) {
            var group = this.getGroup(loan);
            return group.loans.findIndex(function (o) {
                return o == loan;
            });
        },
        getPropertyIndex: function getPropertyIndex(property) {
            var group = this.getGroup(property);
            return group.properties.findIndex(function (o) {
                return o == property;
            });
        },
        loanStyle: function loanStyle(loan, propertyGroup) {
            var percent = this.percentage(loan, propertyGroup);
            return 'flex-basis:' + Math.max(percent, 25) + '%;';
        },
        loanBarStyle: function loanBarStyle(loan) {
            var percent = 80 - this.getLoanIndex(loan) * 10;
            var col = void 0;
            if (loan.existing) col = '200, 200, 200,';else if (loan.investment) col = '89, 0, 255,';else col = '25,156,227,';

            var colString = 'rgba(' + col + percent + '%';
            return { 'background-color': colString };
        },
        propertyStyle: function propertyStyle(property, propertyGroup) {
            var percent = this.percentage(property, propertyGroup);
            var style = 'flex-basis:' + percent + '%;' + this.propertyColour(property, propertyGroup);
            return style;
        },
        propertyColour: function propertyColour(property, propertyGroup) {
            var backgroundPercent = 90 - this.getPropertyIndex(property) * 10;
            var colour = 'background-color:rgba(255, 136, 0,' + backgroundPercent + '%);';
            if (property.investment) colour = 'background-color:rgba(255, 81, 0,' + backgroundPercent + '%);';
            return colour;
        },
        percentage: function percentage(loanOrProperty, propertyGroup) {
            return Math.round((loanOrProperty.amount || loanOrProperty.value) / this.totalProperties(propertyGroup) * 100);
        },
        totalLoans: function totalLoans(propertyGroup) {
            return propertyGroup.loans.reduce(function (acc, val) {
                return acc += val.amount;
            }, 0);
        },
        totalProperties: function totalProperties(propertyGroup) {
            return propertyGroup.properties.reduce(function (acc, val) {
                return acc += val.value;
            }, 0);
        },
        groupTitle: function groupTitle(groupIndex) {
            return this.homeLoan.groups[groupIndex].title || 'Group ' + (groupIndex + 1).toString();
        },
        checkLockStatus: function checkLockStatus() {
            if (this.homeLoan.locked) {
                __WEBPACK_IMPORTED_MODULE_7__helpers_AlertHelpers__["a" /* default */].showAlert('Diagram is locked. Cant change');
                return fale;
            }
            return true;
        },
        startLoanDrag: function startLoanDrag(e, loan) {

            if (!this.checkLockStatus()) return;

            console.log('start drag', e);

            var nextLoan = this.getNextLoan(loan);
            if (nextLoan) {
                this.$set(nextLoan, '_dragAmount', nextLoan.amount);
                this.$set(this.homeLoan, '_nextEntity', nextLoan);
            }

            this.$set(loan, '_element', e.currentTarget);
            this.$set(loan, '_dragStart', e.screenX);
            this.$set(loan, '_dragAmount', this.nearestFiveThousand(loan.amount));
            this.$set(this.homeLoan, '_dragEntity', loan);
        },
        startPropertyDrag: function startPropertyDrag(e, property) {

            if (!this.checkLockStatus()) return;

            console.log('start prop drag', e);

            this.$set(property, '_element', e.currentTarget);
            this.$set(property, '_dragStart', e.screenX);
            this.$set(property, '_dragAmount', this.nearestFiveThousand(property.value));
            this.$set(this.homeLoan, '_dragEntity', property);
            e.currentTarget.classList.add('dragging');
        },
        drag: function drag(e) {
            var entity = this.homeLoan._dragEntity;
            if (entity) {

                var totalMouseMovement = e.screenX - entity._dragStart;

                if (Math.abs(totalMouseMovement) > 20) this.dragging = true;
                if (!this.dragging) return;

                console.log('total movement', totalMouseMovement);
                console.log('xposition:', e.screenX);

                var group = this.getGroup(entity);

                var pixels = this.getPixels(group);

                var amountChange = parseInt(totalMouseMovement / pixels) * 5000;

                if (entity.amount) {
                    var nextEntity = this.homeLoan._nextEntity;
                    var nextAmount = void 0;
                    var newAmount = entity._dragAmount + amountChange;
                    if (newAmount < 10000) return;
                    if (nextEntity) {
                        if (entity._dragMode == 'splitter') {
                            nextAmount = nextEntity._dragAmount - amountChange;
                            if (nextAmount < 10000) return;
                            nextEntity.amount = nextAmount;
                        }
                    }
                    entity.amount = newAmount;

                    this.snapLoan(entity);
                }

                if (entity.value) {
                    var newValue = entity._dragAmount + amountChange;
                    if (newValue >= 10000) entity.value = newValue;
                }
            }
        },
        endDrag: function endDrag(e) {
            var entity = this.homeLoan._dragEntity;
            if (entity) {

                console.log('stop drag');
                var nextEntity = this.homeLoan._nextEntity;
                if (nextEntity) {
                    this.$delete(nextEntity, '_dragAmount');
                    this.$delete(this.homeLoan, '_nextEntity');
                }

                this.$delete(entity, '_dragStart');
                this.$delete(entity, '_dragAmount');
                this.$delete(entity, '_element');
                this.$delete(entity, '_dragMode');
                this.$delete(this.homeLoan, '_dragEntity');
                this.dragging = false;
            }
        },
        nextThousand: function nextThousand(num) {
            return Math.floor((num + 1000) / 1000) * 1000;
        },
        nextFiveThousand: function nextFiveThousand(num) {

            num = this.nextThousand(num);
            while (num % 5000 > 0) {
                num = num + 1000;
            }
            return num;
        },
        nearestFiveThousand: function nearestFiveThousand(num) {
            return Math.round(num / 5000) * 5000;
        },
        snapLoan: function snapLoan(loan) {
            var commons = [60, 70, 80, 85, 90, 95];
            var group = this.getGroup(loan);
            var otherLoans = this.totalLoans(group) - loan.amount;
            var totalProperties = this.totalProperties(group);
            var currentLVR = this.getLVR(group);
            commons.forEach(function (commonLVR) {
                if (Math.abs(currentLVR - commonLVR) < 1) {
                    loan.amount = totalProperties * commonLVR / 100 - otherLoans;
                    return;
                }
            });
        },
        editLoan: function editLoan(loan) {
            this.loanDialog.loan = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, loan, { _originalLoan: loan });
            this.loanDialog.settings.visible = true;
        },
        saveLoan: function saveLoan(loan) {
            var original = loan._originalLoan;
            delete loan._originalLoan;

            delete original._originalLoan;

            __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__["a" /* default */].copyProperties(loan, original);
        },
        editProperty: function editProperty(property) {
            this.propertyDialog.property = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, property, { _originalProperty: property });
            this.propertyDialog.settings.visible = true;
        },
        saveProperty: function saveProperty(property) {
            var original = property._originalProperty;
            delete property._originalProperty;

            delete original._originalProperty;
            __WEBPACK_IMPORTED_MODULE_13__helpers_Utilities__["a" /* default */].copyProperties(property, original);
        },
        addGroup: function addGroup() {
            var group = this.blankGroup();
            this.homeLoan.groups.push(group);
        },
        blankGroup: function blankGroup() {
            var group = {
                loans: [], properties: []
            };
            group.loans.push(this.blankLoan());
            group.properties.push(this.blankProperty());
            return group;
        },
        blankLoan: function blankLoan() {
            return {
                amount: 400000,
                rate: 4,
                years: 30,
                investment: false,
                special: false,
                lmi: 0,
                lmiType: 'None'
            };
        },
        blankProperty: function blankProperty() {
            return {
                value: 500000,
                investment: false,
                existing: false,
                address: ''
            };
        }
    },

    mounted: function mounted() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            var group, homeLoan;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (_this4.homeLoan) {
                                _context3.next = 8;
                                break;
                            }

                            _context3.next = 3;
                            return _this4.$root.$confirm('New Diagram', 'No loan diagram found. Create one?', { color: 'red' });

                        case 3:
                            _context3.t0 = _context3.sent;

                            if (!(_context3.t0 == true)) {
                                _context3.next = 8;
                                break;
                            }

                            group = _this4.blankGroup();
                            homeLoan = { groups: [group] };

                            _this4.$emit('change', homeLoan);

                        case 8:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }))();
    },


    watch: {
        homeLoan: {
            handler: function handler(newVal, oldVal) {},
            deep: true
        }
    }

});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        value: String,
        height: {
            default: 300,
            type: Number
        }
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    mounted: function mounted() {
        var _this = this;

        var el = this.$refs.vueHtml5Editor.$el;
        var content = el.querySelector(".content");

        this.observer = new MutationObserver(function (mutationsList) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(mutationsList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var mutation = _step.value;

                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        _this.$emit('input', content.innerHTML);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });

        this.observer.observe(content, {
            childList: true,
            subtree: true,
            characterData: true });
    }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dialogVisible: false,
            imageObject: {},
            dirty: false,
            uploading: false
        };
    },


    props: {
        item: Object
    },

    computed: {
        displayImage: function displayImage() {
            if (this.item.image && this.item.image.indexOf('randomuser') < 0 && this.item.image.indexOf('transparent') < 0) {
                return this.item.image;
            }
            return '';
        },
        title: function title() {
            if (this.dirty) return "Click 'Keep' when ready";
            if (this.chosenFile || this.item.image) return "Select, zoom, move";
            return "Select an image";
        }
    },

    methods: {
        imageChanged: function imageChanged() {
            this.dirty = true;
        },
        initialise: function initialise() {
            this.dirty = false;
            this.uploading = false;
        },
        showDialog: function showDialog() {
            this.initialise();
            this.dialogVisible = true;
        },
        upload: function upload() {
            var _this = this;

            var contactKey = __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].safelyGetKey(this.item);
            if (!this.imageObject.hasImage()) {
                this.saveToContact('');
                return;
            }
            this.uploading = true;
            this.imageObject.generateBlob(function (blob) {
                var tenantKey = _this.$store.getters.tenantKey;

                __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.storage().ref('tenants/' + tenantKey + '/avatars/' + contactKey).put(blob).then(function (fileData) {
                    fileData.ref.getDownloadURL().then(function (url) {
                        console.log('Finished uploading', url);
                        _this.saveToContact(url);
                    });
                });
            }, 'image/jpeg', 0.5);
        },
        saveToContact: function saveToContact(url) {
            this.item.image = url;
            this.uploading = false;
            this.dialogVisible = false;
        }
    }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            imageNumber: 1,
            src1: '',
            src2: ''
        };
    },


    components: {},

    props: {
        src: String,
        size: {
            type: Number,
            default: 50
        }
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    watch: {
        'src': {
            handler: function handler(newVal) {
                if (this.imageNumber == 1) {
                    this.src2 = newVal;
                    this.imageNumber = 2;
                } else {
                    this.src1 = newVal;
                    this.imageNumber = 1;
                }
            },
            immediate: true
        }
    },

    created: function created() {}
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        images: Array,
        size: {
            type: Number,
            default: 50
        }
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            text: '',
            isCompact: false
        };
    },


    props: {
        compact: Boolean
    },

    computed: {
        items: function items() {
            var cleanText = this.text.replace(/\n/g, '|');

            if (this.text.match(/\n\n/)) cleanText = this.text.replace(/\n\n/g, '|');

            cleanText = cleanText.replace('||', '|');
            var items = cleanText.split('|').filter(function (item) {
                return item;
            });
            return items;
        }
    },

    methods: {
        makeCompact: function makeCompact(value) {
            this.isCompact = value;
            this.saveState();
        },
        demoData: function demoData() {
            this.text = this.$faker().lorem.lines(4);
        },
        quickText: function quickText(code) {
            if (code == 'val') this.text += '\nSubject to valuation.';
            if (code == 'cos') this.text += '\nFully signed contract of sale.';
            if (code == 'pay') this.text += '\nUpdated most recent payslips.';
            if (code == 'lmi') this.text += '\nSubject to lenders mortgage insurance.';
        },
        saveItems: function saveItems() {
            this.$emit('importItems', this.items);
            this.text = '';
            this.isCompact = true;
            this.saveState;
        },
        saveState: function saveState() {
            var state = { compact: this.isCompact };
            this.$emit('saveState', state);
        }
    },

    created: function created() {
        this.isCompact = this.compact;
    }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            value: ''
        };
    },

    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default.a
    },

    props: {
        settings: Object
    },

    computed: {},

    methods: {
        save: function save() {
            this.$emit('save', this.value, this.settings);
        },
        initialiseDialog: function initialiseDialog() {
            var _this = this;

            if (this.settings.default) this.value = this.settings.default;
            setTimeout(function () {
                _this.$refs.focus.focus();
            }, 500);
        }
    },

    watch: {
        'settings.visible': function settingsVisible(visible) {
            if (visible) {
                this.initialiseDialog();
            }
        }
    },

    created: function created() {}
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_TenantHelpers__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_TransactionHelpers__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_Utilities__ = __webpack_require__(6);

















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        items: Array,
        stages: Array,
        fieldPath: String
    },
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
    },

    computed: {},

    methods: {
        afterDrag: function afterDrag(e) {

            var changes = {
                id: e.item.dataset.id,
                to: e.item.parentNode.dataset.stage,
                toText: e.item.parentNode.dataset.stageText,
                from: e.from.dataset.stage,
                fromText: e.from.dataset.stageText
            };
            this.$emit('move', changes);
        },
        itemClicked: function itemClicked(item) {
            this.$emit('click', item);
        },
        getItemId: function getItemId(item) {
            return item._id || item._key || item.key || (item.meta ? item.meta.key : null);
        },
        getItemsForRegion: function getItemsForRegion(region) {
            var _this = this;

            var matches = [];
            this.items.forEach(function (item) {
                var fieldValue = __WEBPACK_IMPORTED_MODULE_12__helpers_Utilities__["a" /* default */].objectDeepGet(item, _this.fieldPath);
                if (fieldValue == region) matches.push(item);
            });
            return matches;
        }
    }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            menuVisible: false
        };
    },


    components: {},

    props: {
        prefix: String,
        underline: String,
        value: [String, Boolean, Number],
        disabled: Boolean,
        menus: Array,
        labelClass: {
            type: String,
            default: 'label-menu-default'
        }
    },

    computed: {
        buttonText: function buttonText() {
            var _this = this;

            var currentMenu = this.menus.find(function (o) {
                return o.value == _this.value;
            });
            if (currentMenu) return currentMenu.text || currentMenu.value;
        },
        labelClassValue: function labelClassValue() {
            return this.labelClass + (this.disabled ? ' disabled' : '');
        }
    },

    methods: {
        menuClicked: function menuClicked(menu) {
            var newVal = menu.value;
            if (typeof newVal == 'undefined') newVal = menu.text;
            this.$emit('input', newVal);
            this.$emit('change', newVal);
        }
    },

    created: function created() {
        if (!this.value) this.menuClicked(this.menus[0]);
    }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_Store__ = __webpack_require__(31);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        columns: {
            default: '50/50',
            type: String
        },
        width: {
            default: 1280,
            type: Number
        }
    },

    computed: {
        columnList: function columnList() {
            var columnList = this.columns.split(/\//).map(function (width) {
                var w = width;

                if (window.innerWidth < 600) w = '100%';

                if (w.indexOf('px') < 0) w = w + '%';

                return {
                    width: w
                };
            });
            return columnList;
        },
        contentStyle: function contentStyle() {
            return {
                'max-width': this.width + 'px'
            };
        },
        isMichelle: function isMichelle() {
            var user = __WEBPACK_IMPORTED_MODULE_1__store_Store__["a" /* default */].getters.user;
            return user.firstName == 'Michelle' && user.lastName == 'Solomon';
        }
    },

    methods: {
        scrollLeftColumn: function scrollLeftColumn(position) {}
    },

    created: function created() {}
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_Store__ = __webpack_require__(31);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            items: [{ title: 'Home', icon: 'dashboard' }, { title: 'About', icon: 'question_answer' }],
            right: null
        };
    },


    components: {},

    props: {
        columns: {
            default: '50/50',
            type: String
        },
        width: {
            default: 1280,
            type: Number
        }
    },

    computed: {
        columnList: function columnList() {
            var columnList = this.columns.split(/\//).map(function (width) {
                var w = width;

                if (window.innerWidth < 600) w = '100%';

                if (w.indexOf('px') < 0) w = w + '%';

                return {
                    width: w
                };
            });
            return columnList;
        },
        contentStyle: function contentStyle() {
            return {
                'max-width': this.width + 'px'
            };
        },
        isMichelle: function isMichelle() {
            var user = __WEBPACK_IMPORTED_MODULE_1__store_Store__["a" /* default */].getters.user;
            return user.firstName == 'Michelle' && user.lastName == 'Solomon';
        }
    },

    methods: {
        scrollLeftColumn: function scrollLeftColumn(position) {}
    },

    created: function created() {}
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_PageHelpers__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_PanelDialog__ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_PanelDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_PanelDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            panelDialog: {
                settings: {
                    visible: false
                },
                field: {}
            }

        };
    },


    components: {
        PanelDialog: __WEBPACK_IMPORTED_MODULE_2__ui_elements_PanelDialog___default.a,
        Draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a
    },

    props: {
        tree: Object
    },

    computed: {
        panel: function panel() {
            return this.tree.panel;
        },
        parentName: function parentName() {
            if (this.panel && this.panel.parent) return this.panel.parent.name;else return 'top';
        },
        isSelected: function isSelected() {
            if (!this.selectedPanel) return false;

            return this.panel.name == this.selectedPanel.name;
        },
        placeholderText: function placeholderText() {
            if (this.panel.placeholderText) return Array(500).fill(this.panel.name).join(' ');
        },
        panelStyle: function panelStyle() {
            var style = {
                'min-width': '100px',

                padding: '0px',
                'display': 'flex',

                'flex-grow': '1',

                'flex-direction': this.panel.hasColumns ? 'row' : 'column',
                'overflow-y': 'scroll',
                'position': 'relative'

            };
            if (this.panel.width) style.flexBasis = this.panel.width + '%';

            return style;
        },
        selectedPanel: function selectedPanel() {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_PageHelpers__["a" /* default */].getPageData('selected-panel');
        }
    },

    methods: {
        saveField: function saveField() {},
        showDialog: function showDialog() {
            debugger;
            this.panelDialog.field = this.panel;
            this.panelDialog.settings.visible = true;
        },
        navigateUp: function navigateUp() {
            __WEBPACK_IMPORTED_MODULE_1__helpers_PageHelpers__["a" /* default */].setPageData('selected-panel', this.tree.parent);
        },
        getChildTree: function getChildTree(panel) {
            panel.parent = this.tree;
            panel.rootPanel = this.tree.rootPanel;
            return panel;
        },
        selectPanel: function selectPanel(panel) {

            document.getSelection().removeAllRanges();

            __WEBPACK_IMPORTED_MODULE_1__helpers_PageHelpers__["a" /* default */].setPageData('selected-panel', panel);
        },
        afterDrag: function afterDrag() {}
    },

    created: function created() {
        if (!this.tree.parent) this.tree.rootPanel = this.panel;
    }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        label: String,
        value: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        link: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showingTip: false
        };
    },


    components: {},

    props: {
        tooltip: String
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        clicked: function clicked() {
            var _this = this;

            this.showingTip = false;
            setTimeout(function () {
                _this.$emit('click');
            }, 200);
        }
    },

    created: function created() {}
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LoanHelpers__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_AlertHelpers__ = __webpack_require__(12);
















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedAttribute: {},
            lastChange: null,

            wordWrap: false,
            diagramData: [{
                loans: [{ amount: 400000, fixed: 0, io: 0 }],
                properties: [{ value: 500000, type: 'House' }]
            }],

            loanDialog: {
                loan: {
                    amount: 0,
                    years: 30
                },
                settings: {
                    visible: false,
                    title: 'Loan Details'
                }

            },
            propertyDialog: {
                model: {
                    amount: 0
                },
                settings: {
                    visible: false,
                    title: 'Property Details'
                }
            }

        };
    },


    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_4__ui_elements_DeleteButton___default.a,
        CurrencyBox: __WEBPACK_IMPORTED_MODULE_3__ui_elements_CurrencyBox___default.a
    },

    props: {
        diagram: Array,
        passBack: Object
    },

    computed: {
        activeLoanPayment: function activeLoanPayment() {
            var payment = __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__["a" /* default */].loanPayment(this.loanDialog.loan);
            return payment;
        },
        summary: function summary() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__["a" /* default */].loanSummary(this.groups);
        },
        descriptionObject: function descriptionObject() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__["a" /* default */].diagramDescription(this.groups);
        },
        descriptionWithSummaryObject: function descriptionWithSummaryObject() {
            var summaryDescription = __WEBPACK_IMPORTED_MODULE_8__helpers_LoanSecurityHelpers__["a" /* default */].loanSummaryDescription(this.groups);
            return {
                text: this.descriptionObject.text + '\n\n' + summaryDescription.text,
                html: this.descriptionObject.html + '<br/><br/>' + summaryDescription.html
            };
        },
        allLoans: function allLoans() {
            var loans = [];
            this.diagramData.forEach(function (group) {
                loans = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(loans), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(group.loans));
            });
            return loans;
        },
        allProperties: function allProperties() {
            var properties = [];
            this.diagramData.forEach(function (group) {
                properties = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(properties), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(group.properties));
            });
            return properties;
        },
        anyFixedLoans: function anyFixedLoans() {
            return Boolean(this.allLoans.find(function (o) {
                return o.fixed > 0;
            }));
        },
        anyioLoans: function anyioLoans() {
            return Boolean(this.allLoans.find(function (o) {
                return o.io > 0;
            }));
        },
        anyLMI: function anyLMI() {
            return Boolean(this.allLoans.find(function (o) {
                return o.lmiType == 'Capitalised' || o.lmiType == 'Included';
            }));
        },
        anyOwnerOccupied: function anyOwnerOccupied() {
            return Boolean(this.allProperties.find(function (o) {
                return !o.investment;
            }));
        },
        anyInvestmentProperties: function anyInvestmentProperties() {
            return Boolean(this.allProperties.find(function (o) {
                return o.investment;
            }));
        },
        groups: function groups() {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_LoanHelpers__["a" /* default */].diagramDetails(this.diagramData);
        },
        fixedOptions: function fixedOptions() {
            return [{ years: 0, display: 'Variable' }, { years: 1, display: '1 Year Fixed' }, { years: 2, display: '2 Years Fixed' }, { years: 3, display: '3 Years Fixed' }, { years: 4, display: '4 Years Fixed' }, { years: 5, display: '5 Years Fixed' }];
        },
        propertyTypes: function propertyTypes() {
            return ["House", "Townhouse", "Unit", "Land", "Build"];
        },
        ioOptions: function ioOptions() {
            return [{ years: 0, display: 'Principal and Interest' }, { years: 1, display: '1 Year IO' }, { years: 2, display: '2 Years IO' }, { years: 3, display: '3 Years IO' }, { years: 4, display: '4 Years IO' }, { years: 5, display: '5 Years IO' }];
        },
        lmiOptions: function lmiOptions() {
            return ['None', 'Capitalised', 'Included'];
        },
        yearsOptions: function yearsOptions() {
            var terms = [];
            for (var n = 1; n < 31; n++) {
                terms.push(n);
            }
            return terms;
        }
    },

    methods: {
        isPositiveAmount: function isPositiveAmount(val) {
            var result = val && __WEBPACK_IMPORTED_MODULE_5__helpers_NumberHelpers__["a" /* default */].isNumeric(val) && val > 0;
            return result;
        },
        selectAttribute: function selectAttribute(attribute) {
            if (attribute == this.selectedAttribute) this.selectedAttribute = {};else this.selectedAttribute = attribute;
        },
        toggleWordWrap: function toggleWordWrap() {
            this.$set(this.diagramData, 'wordWrap', !this.wordWrap);
        },
        copyToClipboard: function copyToClipboard() {
            __WEBPACK_IMPORTED_MODULE_10_clipboard_js___default.a.copy({
                'text/plain': this.descriptionWithSummaryObject.text,
                'text/html': this.descriptionWithSummaryObject.html
            });
            __WEBPACK_IMPORTED_MODULE_11__helpers_AlertHelpers__["a" /* default */].showAlert('Copied to Clipboard');
        },
        loanDescription: function loanDescription(loan) {
            var descriptions = [];

            if (loan.rate) descriptions.push('@ ' + loan.rate + '%');

            if (loan.io && this.$vuetify.breakpoint.smAndUp) descriptions.push(loan.io + 'y IO');

            if (loan.fixed && this.$vuetify.breakpoint.smAndUp) {
                var fixedDescription = loan.fixed + 'y Fixed';
                if (loan.rateLock) fixedDescription += ' RATE LOCK';
                descriptions.push(fixedDescription);
            }

            if (loan.years < 30 && this.$vuetify.breakpoint.smAndUp) descriptions.push(loan.years + 'yrs');

            if (loan.existing && this.$vuetify.breakpoint.mdAndUp) descriptions.push('Existing Lending Keeping');else if (loan.product && this.$vuetify.breakpoint.mdAndUp) descriptions.push(loan.product);

            var description = descriptions.join(', ');

            if (loan.lmi) {
                var lmi = __WEBPACK_IMPORTED_MODULE_5__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.lmi);
                var amount = __WEBPACK_IMPORTED_MODULE_5__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(loan.amount);
                if (loan.lmiType == 'Included') description = '(incl ' + lmi + ' lmi)' + description;else description = '(' + amount + ' + ' + lmi + ') ' + description;
            }

            return description;
        },
        allowDeleteLoan: function allowDeleteLoan(loan) {
            if (!loan.loanIndex) return false;

            if (this.groups[loan.groupIndex].loans.length < 2) return false;

            return true;
        },
        allowDeleteProperty: function allowDeleteProperty(property) {
            if (!property.propertyIndex) return false;

            if (this.groups[property.groupIndex].properties.length < 2) return false;

            return true;
        },
        editLoan: function editLoan(loan, loanIndex, groupIndex) {
            if (!loan) loan = { amount: 400000, years: 30 };

            this.loanDialog.loan = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, loan, { loanIndex: loanIndex, groupIndex: groupIndex
            });

            this.loanDialog.settings.visible = true;
        },
        editProperty: function editProperty(property, propertyIndex, groupIndex) {
            if (!property) property = { value: 500000 };
            this.propertyDialog.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, property, { propertyIndex: propertyIndex, groupIndex: groupIndex
            });
            this.propertyDialog.settings.visible = true;
        },
        addGroup: function addGroup() {
            this.diagramData.push({
                loans: [{
                    amount: 400000
                }],
                properties: [{
                    value: 500000, type: 'House'
                }]
            });
            this.saveDiagram();
        },
        saveLoan: function saveLoan(loan) {
            console.log('saving', loan);
            var loanIndex = loan.loanIndex;
            var groupIndex = loan.groupIndex;
            delete loan['loanIndex'];
            delete loan['groupIndex'];
            delete loan['meta'];

            if (loanIndex == null) {
                this.diagramData[groupIndex].loans.push(loan);
            } else {
                var loans = this.diagramData[groupIndex].loans;
                __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(loans, loanIndex, loan);
            }
            this.saveDiagram();
        },
        saveProperty: function saveProperty(property) {
            console.log('saving', property);
            var propertyIndex = property.propertyIndex;
            var groupIndex = property.groupIndex;
            delete property['propertyIndex'];
            delete property['groupIndex'];
            delete property['meta'];
            if (propertyIndex == null) {
                this.diagramData[groupIndex].properties.push(property);
            } else {
                var properties = this.diagramData[groupIndex].properties;
                __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(properties, propertyIndex, property);
            }
            this.saveDiagram();
        },
        deleteLoan: function deleteLoan(loan) {
            this.diagramData[loan.groupIndex].loans.splice(loan.loanIndex, 1);
            this.loanDialog.settings.visible = false;
            this.saveDiagram();
        },
        deleteProperty: function deleteProperty(property) {
            this.diagramData[property.groupIndex].properties.splice(property.propertyIndex, 1);
            this.propertyDialog.settings.visible = false;
            this.saveDiagram();
        },
        removeGroup: function removeGroup(groupIndex) {
            this.diagramData.splice(groupIndex, 1);
            this.saveDiagram();
        },
        loanClass: function loanClass(loan) {
            var classes = 'diagram-bar loan';
            if (loan.existing) classes += " existing";else if (loan.investment) classes += ' investment';

            if (!this.wordWrap) classes += ' no-wrap';

            if (this.loanHasAttribute(loan, this.selectedAttribute.id)) classes += ' selected';

            return classes;
        },
        loanHasAttribute: function loanHasAttribute(loan, attributeId) {

            if (!attributeId) return false;
            if (attributeId == 'ownerOccupied') return !loan.investment;
            if (attributeId == 'variable') return !loan.fixed;
            if (attributeId == 'principalAndInterest') return !loan.io;

            return loan[attributeId];
        },
        propertyClass: function propertyClass(property) {
            return 'diagram-bar property' + (property.investment ? ' investment' : '') + ' white--text' + (this.wordWrap ? '' : ' no-wrap');
        },
        adjustLVR: function adjustLVR(percent, groupIndex) {
            console.log('adjusing lvr for group ', groupIndex);

            var group = this.groups[groupIndex];
            var loans = this.groups[groupIndex].loans;
            var maxLoanAmount = Math.max.apply(Math, loans.map(function (o) {
                return o.amount;
            }));
            var loan = loans.find(function (o) {
                return o.amount == maxLoanAmount;
            });
            var idx = loans.indexOf(loan);

            var desiredTotalLoanAmount = group.propertyTotal * percent / 100;

            var amountToSubtract = group.loanTotal - desiredTotalLoanAmount;

            loan.amount = maxLoanAmount - amountToSubtract;

            __WEBPACK_IMPORTED_MODULE_9_vue__["default"].set(this.diagramData[groupIndex].loans, idx, loan);

            this.saveDiagram();
        },
        saveDiagram: function saveDiagram() {
            console.log('saving...');
            var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.passBack);
            result.diagram = this.diagramData;
            result.value = __WEBPACK_IMPORTED_MODULE_7__helpers_LoanHelpers__["a" /* default */].diagramPicture(this.groups);
            this.$emit('save', result);
        },
        shortenAddress: function shortenAddress(address) {
            var pos = address.indexOf(',');
            if (pos) return address.substr(0, pos);

            return address;
        }
    },
    created: function created() {
        if (this.diagram) this.diagramData = this.diagram;
    }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_ElementsStore__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_LoanHelpers__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__forms_lists_ListList__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__forms_lists_ListList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__forms_lists_ListList__);

















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            lookupData: null
        };
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox___default.a,
        ListList: __WEBPACK_IMPORTED_MODULE_13__forms_lists_ListList___default.a
    },

    props: {
        settings: Object
    },

    computed: {
        items: function items() {
            if (!this.lookupData) return [];else return this.lookupData.map(function (o) {
                return { text: o.path, value: o.value };
            });
        }
    },

    methods: {
        loadLookupData: function loadLookupData() {
            var _this = this;

            var ref = __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getTenantRef().child('lookup').orderByChild('path');
            __WEBPACK_IMPORTED_MODULE_5__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (data) {
                _this.lookupData = data;
            });
        }
    },

    created: function created() {
        this.loadLookupData();
    },
    mounted: function mounted() {}
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        element: Object
    },
    components: {
        'DialogBox': __WEBPACK_IMPORTED_MODULE_0__ui_elements_DialogBox___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        transaction: function transaction() {
            return this.$store.getters.transaction;
        },
        isFormValid: function isFormValid() {
            return true;
        }
    },
    methods: {
        htmlChanged: function htmlChanged(str) {
            this.element.value = str;
        },
        save: function save() {
            this.$emit('save', this.element);
        }
    }

});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_NiceData__ = __webpack_require__(15);












/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            program: null,
            contactKey: null,
            templateKey: null,
            output: '',
            user: null,
            sourceTenant: null,
            destinationTenant: null,
            simulateWrites: true,
            simulateDeletes: true,
            move: false
        };
    },

    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_2__ui_elements_DialogBox___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_3__ui_elements_UserChooser___default.a
    },

    props: {
        initialProgram: null,
        item: Object,
        settings: Object
    },

    computed: {
        programItems: function programItems() {
            return [{ text: "Transfer Contact", value: 'tc' }, { text: "Transfer Contacts for User", value: 'tcu' }, { text: "Transfer All Contacts", value: 'tac' }, { text: "Transfer Tasks for User", value: 'ttu' }, { text: "Transfer All Templates", value: 'tat' }, { text: "Transfer One Template", value: 'tot' }, { text: "Transfer Lookups", value: 'tl' }, { text: "Transfer All Groups", value: 'tag' }];
        },
        tenants: function tenants() {
            return this.$store.getters.officesActive;
        },
        sourceTenantRef: function sourceTenantRef() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.sourceTenant);
        },
        destinationTenantRef: function destinationTenantRef() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant);
        }
    },

    methods: {
        initialiseDialog: function initialiseDialog() {
            this.settings.closeOnly = true;
            this.program = this.initialProgram;
            this.contactKey = __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].safelyGetKey(this.item);
            this.sourceTenant = this.$store.getters.tenantKey;
            this.output = '';
        },
        log: function log(msg) {
            this.output += msg + '\n';
        },
        run: function run() {
            this.output = '';
            if (this.program == 'tc') this.transferContact();
            if (this.program == 'tat') this.transferAllTemplates();
            if (this.program == 'tcu') this.transferContactsForUser();
            if (this.program == 'tac') this.transferAllContacts();
            if (this.program == 'ttu') this.transferTasksForUser();
            if (this.program == 'tl') this.transferLookups();
            if (this.program == 'tag') this.transferAllGroups();
            if (this.program == 'tot') this.transferOneTemplate();
        },
        transferContact: function transferContact() {
            var newTenant = this.destinationTenant;
            this.log('Moving to tenant ' + newTenant + ' ...');
            this.copyContactToTenant(this.contactKey, newTenant);
            if (this.item.partner) this.copyContactToTenant(this.item.partner.key, newTenant);
        },
        transferOneTemplate: function transferOneTemplate() {
            var _this = this;

            var sourceTemplateRef = this.sourceTenantRef.child('templates').child(this.templateKey);
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant.toString()).child('templates');

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this.log('Transferred template');
            });
        },
        transferAllTemplates: function transferAllTemplates() {
            var _this2 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('templates');
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant.toString());

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this2.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.object).length.toString() + ' templates ');
            });

            sourceTemplateRef = this.sourceTenantRef.child('transactionTemplates');
            destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant.toString());

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result2) {

                _this2.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result2.object).length.toString() + ' Transaction templates ');
            });
        },
        transferLookups: function transferLookups() {
            var _this3 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('lookup');
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant.toString());

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this3.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.object).length.toString() + ' lookup items');
            });
        },
        transferAllGroups: function transferAllGroups() {
            var _this4 = this;

            var sourceTemplateRef = this.sourceTenantRef.child('groups');
            var destTemplateRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(this.destinationTenant.toString());

            this.copyFirebaseData(sourceTemplateRef, destTemplateRef, this.move, true).then(function (result) {
                _this4.log('Transferred ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result.object).length.toString() + ' groups');
            });
        },
        transferContactsForUser: function transferContactsForUser() {
            var _this5 = this;

            var listContactsRef = this.sourceTenantRef.child('contacts').orderByChild('owner/key').equalTo(this.user.key);
            console.log('ref is ' + listContactsRef.toString());
            listContactsRef.once('value', function (snap) {
                snap.forEach(function (itemSnap) {
                    var contactKey = itemSnap.key;
                    var contact = itemSnap.val();
                    _this5.log('Transferring contact: ' + __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].fullName(contact) + ' - ' + contactKey);
                    _this5.copyContactToTenant(contactKey, _this5.destinationTenant);
                });
            });
        },
        transferAllContacts: function transferAllContacts() {
            var _this6 = this;

            var sourceRef = this.sourceTenantRef.child('contacts');
            console.log('ref is ' + sourceRef.toString());
            sourceRef.once('value', function (snap) {
                snap.forEach(function (itemSnap) {
                    var contactKey = itemSnap.key;
                    var contact = itemSnap.val();
                    _this6.log('Transferring contact: ' + __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].fullName(contact) + ' - ' + contactKey);
                    _this6.copyContactToTenant(contactKey, _this6.destinationTenant);
                });
            });
        },
        transferTasksForUser: function transferTasksForUser() {
            var _this7 = this;

            var sourceRef = this.sourceTenantRef.child('tasks');
            var listTasksRef = sourceRef.orderByChild('assigned/uid').equalTo(this.user.key);
            var destRef = this.destinationTenantRef.child('tasks');
            console.log('ref is ' + listTasksRef.toString());

            listTasksRef.once('value', function (snap) {
                console.log(snap.val());
                snap.forEach(function (itemSnap) {

                    var taskKey = itemSnap.key;
                    var task = itemSnap.val();
                    _this7.log('Transferring task: ' + task.title + ' - ' + taskKey);
                    _this7.copyFirebaseData(sourceRef.child(taskKey), destRef, _this7.move, true).then(function (result) {
                        _this7.log('Done...');
                    });
                });
            });
        },
        copyContactToTenant: function copyContactToTenant(contactKey, tenant) {
            var _this8 = this;

            var sourceContactRef = this.sourceTenantRef.child('contacts').child(contactKey);
            var destContactRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(tenant).child('contacts');

            this.copyFirebaseData(sourceContactRef, destContactRef, this.move, true).then(function (result) {
                console.log(result);
                _this8.log('Copied contact: ' + result.object.firstName);

                var sourceContactTransactionsRef = _this8.sourceTenantRef.child('contactTransactions').child(contactKey);
                var destContactTransactionsRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(tenant).child('contactTransactions');

                _this8.copyFirebaseData(sourceContactTransactionsRef, destContactTransactionsRef, _this8.move, true).then(function (tcResult) {
                    console.log('TC Result', tcResult);
                    var transactionArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tcResult.object);
                    _this8.log('Copied ' + transactionArray.length + ' contact-transactions');
                    transactionArray.forEach(function (transactionKey) {
                        var sourceTransactionRef = _this8.sourceTenantRef.child('transactions').child(transactionKey);
                        var destTransactionRef = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getRootRef().child('tenants').child(tenant).child('transactions');

                        _this8.copyFirebaseData(sourceTransactionRef, destTransactionRef, _this8.move, true).then(function (tResult) {
                            _this8.log('Copied transaction: ' + tResult.object.details.description);
                        });
                    });
                }, function (err) {
                    _this8.log(err.result + ' in contactTransactions');
                });
            });
        },
        copyFirebaseData: function copyFirebaseData(fromRef, toRef) {
            var _this9 = this;

            var move = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var keepSameKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;


            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                console.log('Preparing copyFirebaseData from: ' + fromRef.toString() + ' to ' + toRef.toString());
                var result = {};
                fromRef.once('value', function (snap) {
                    var obj = snap.val();

                    if (!obj) {
                        result.result = 'Data not found';
                        reject(result);
                    }
                    var newKey = keepSameKey ? snap.key : __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getKey();

                    if (!_this9.simulateWrites) toRef.child(newKey).set(obj);else _this9.log('Simulating write only...');

                    if (move) {
                        _this9.deleteFirebaseData(fromRef);
                    }

                    result.sourceRef = fromRef.toString();
                    result.destinationRef = toRef.toString();
                    result.object = obj;
                    result.sourceKey = snap.key;
                    result.destinationKey = newKey;
                    resolve(result);
                });
            });
        },
        deleteFirebaseData: function deleteFirebaseData(fromRef) {
            this.log('Deleting ' + fromRef.toString());
            if (this.simulateDeletes) {
                this.log('Simulating delete only');
                return;
            }
            fromRef.remove();
        }
    },

    created: function created() {}
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__ = __webpack_require__(11);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            value: ''
        };
    },


    components: {},

    props: {
        row: Object,
        field: Object
    },

    computed: {},

    methods: {
        calculateValue: function calculateValue() {

            var fieldId = this.field.identifier;
            var value = this.row[fieldId] || '';
            if (this.field.type == 'Currency') value = __WEBPACK_IMPORTED_MODULE_1__helpers_StringHelpers__["a" /* default */].formatCurrency(value);else if (this.field.type == 'Date') value = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToAu(value);else if (this.field.type == 'Calculated') {
                value = 'loading...';
            } else if (this.field.type == 'Image' && value) {
                value = '<img src="' + value + '" height="50" width="50" class="round white-border shadow"/>';
            }

            this.value = value;
        },
        loadTransforms: function loadTransforms() {}
    },

    created: function created() {
        this.calculateValue();
    },


    watch: {
        'row': {
            deep: true,
            handler: function handler(newVal) {
                this.calculateValue();
            }
        }
    }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            visible: false
        };
    },


    props: {
        delay: {
            type: Number,
            default: 4000
        },
        message: {
            type: String,
            default: 'No Records'
        },
        icon: String },

    components: {},

    computed: {},

    methods: {},

    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.visible = true;
        }, this.delay);
    }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        item: Object
    },

    computed: {},

    methods: {}
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_TeamHelpers__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_Firestore__ = __webpack_require__(27);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            menuVisible: false
        };
    },


    components: {},

    props: {
        buttonStyle: String,
        buttonClass: String
    },

    computed: {
        hasMultipleOffices: function hasMultipleOffices() {
            return this.offices.length > 1;
        },
        offices: function offices() {
            return this.$store.getters.offices.sort(__WEBPACK_IMPORTED_MODULE_1__helpers_OrderHelpers__["a" /* default */].sortByName);
        },
        officesActive: function officesActive() {
            return this.$store.getters.officesActive;
        },
        currentOffice: function currentOffice() {
            return this.offices.find(function (o) {
                return o.meta.key == __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getTenantKey();
            }) || {};
        },
        activeCount: function activeCount() {
            var ctr = this.officesActive.length;
            if (ctr < 2) return '';
            return ' +' + (ctr - 1).toString();
        },
        debugInfinite: function debugInfinite() {
            console.log('debugging oc infinite');
            return true;
        }
    },

    methods: {
        toggleOffice: function toggleOffice(office, forceTrue) {
            var newActive = forceTrue || !office.active;

            this.$store.commit('setOfficeActive', { officeNumber: office.meta.key, value: newActive });
            __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getUserRef().child('offices').child(office.meta.key).child('active').set(newActive);

            if (newActive) __WEBPACK_IMPORTED_MODULE_2__helpers_TeamHelpers__["a" /* default */].activateTeam(__WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].toCamelCase(office.name));else __WEBPACK_IMPORTED_MODULE_2__helpers_TeamHelpers__["a" /* default */].deactivateTeam(__WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].toCamelCase(office.name));

            if (!newActive && office.meta.key == __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getTenantKey()) {
                if (this.officesActive.length) {
                    this.switchToOffice(this.officesActive[0]);
                }
            }
        },
        switchToOffice: function switchToOffice(office) {
            var _this = this;

            setTimeout(function () {
                console.log('running switch to office');
                _this.toggleOffice(office, true, true);
                __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].initialiseTenant(office.meta.key);
                __WEBPACK_IMPORTED_MODULE_2__helpers_TeamHelpers__["a" /* default */].setPrimaryTeam(__WEBPACK_IMPORTED_MODULE_3__helpers_StringHelpers__["a" /* default */].toCamelCase(office.name));
            }, 250);
        },
        onlyOffice: function onlyOffice(office) {
            var _this2 = this;

            this.officesActive.forEach(function (office) {
                _this2.toggleOffice(office);
            });
            this.switchToOffice(office);
            this.menuVisible = false;
        },
        isCurrentOffice: function isCurrentOffice(officeKey) {
            return Boolean(officeKey == __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__["a" /* default */].getTenantKey());
        }
    },

    created: function created() {}
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ChipSelector__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_ChipSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_ChipSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_OrderHelpers__ = __webpack_require__(29);






/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        settings: Object,


        saveOnEnter: Boolean,
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        ChipSelector: __WEBPACK_IMPORTED_MODULE_1__ui_elements_ChipSelector___default.a
    },

    data: function data() {
        return {
            offices: []
        };
    },


    computed: {
        dialogVisible: function dialogVisible() {
            return this.settings.visible;
        },
        buttonText: function buttonText() {
            if (this.selectedOffices.length > 1) return 'Copy to ' + this.selectedOffices.length + ' Offices';
            if (this.selectedOffices.length == 1) return 'Copy to 1 Office';
            return 'Cancel';
        },
        selectedOffices: function selectedOffices() {
            return this.offices.filter(function (o) {
                return o._selected;
            });
        }
    },

    methods: {
        select: function select() {
            this.$emit('select', this.selectedOffices);
            this.settings.visible = false;
        },
        loadOffices: function loadOffices() {
            this.offices = this.$store.getters.offices.filter(function (o) {
                return o.meta.key != __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].getTenantKey();
            }).sort(__WEBPACK_IMPORTED_MODULE_3__helpers_OrderHelpers__["a" /* default */].sortByName);
        }
    },

    created: function created() {},


    watch: {
        'settings.visible': function settingsVisible(visible) {
            var _this = this;

            if (visible) {
                this.loadOffices();
                this.offices.forEach(function (office) {
                    _this.$set(office, '_selected', false);
                });
            }
        }
    }

});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ItemSelection__ = __webpack_require__(722);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            expandedItem: {},
            hoveredItem: {}
        };
    },

    components: {},

    props: {
        items: Array,
        width: String,
        icon: {
            type: String,
            default: 'mdi-hexagon-multiple'
        },
        hideExpander: Boolean,
        lock: Boolean
    },

    computed: {
        selectedItems: function selectedItems() {
            return this.items.filter(function (o) {
                return o._selected;
            });
        },
        selectionCount: function selectionCount() {
            return this.selectedItems.length;
        },
        itemContainerStyle: function itemContainerStyle() {
            return 'width:' + (this.width || '100%');
        }
    },

    methods: {
        addItem: function addItem() {
            this.$emit('add');
        },
        itemClicked: function itemClicked(item) {
            this.selectOne(item);
            this.$emit('click', item);
        },
        buttonClicked: function buttonClicked(item) {
            if (item == this.expandedItem) this.contract();else this.expand(item);
        },
        contract: function contract() {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.expandedItem).length) this.$emit('contracted', this.expandedItem);
            this.expandedItem = {};
        },
        expand: function expand(item) {
            this.contract();
            this.expandedItem = item;
            this.$emit('expanded', item);
        },
        itemHovered: function itemHovered(item) {
            this.hoveredItem = item;
        },
        itemNotHovered: function itemNotHovered(item) {
            this.hoveredItem = {};
        },
        selectOne: function selectOne(item) {
            if (!this.lock) this.unselectAll(this.items);
            this.$set(item, '_selected', true);
        },
        unselectAll: function unselectAll() {
            __WEBPACK_IMPORTED_MODULE_4__helpers_ItemSelection__["a" /* default */].unselectAll(this.items);
        },
        toggleSelection: function toggleSelection(item) {
            __WEBPACK_IMPORTED_MODULE_4__helpers_ItemSelection__["a" /* default */].toggleSelection(item);
        }
    },

    watch: {
        'selectionCount': {
            deep: true,
            handler: function handler(newVal, oldVal) {
                this.$emit('selection-change');
            }
        }
    },

    mounted: function mounted() {},
    created: function created() {}
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ElementHelpers__ = __webpack_require__(38);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        step: Object,
        size: String
    },

    computed: {
        outstandings: function outstandings() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_ElementHelpers__["a" /* default */].getElements().filter(function (o) {
                return o.type == 'Outstanding';
            });
        },
        waitingCount: function waitingCount() {
            return this.outstandings.filter(function (o) {
                return o.status == 'Waiting for Broker' || o.status == 'Waiting for Processor' || o.status == 'Waiting for Client';
            }).length;
        },
        sentCount: function sentCount() {
            return this.outstandings.filter(function (o) {
                return o.status == 'Sent';
            }).length;
        },
        readyCount: function readyCount() {
            return this.outstandings.filter(function (o) {
                return o.status == 'Ready to Send';
            }).length;
        },
        totalCount: function totalCount() {
            return this.outstandings.length;
        }
    },

    methods: {}
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        settings: Object,


        dialog: Object

    },

    components: {},

    data: function data() {
        return {
            expansionPanelNumber: 0,
            fieldBackup: {}
        };
    },


    computed: {
        field: function field() {
            return this.dialog.field || {};
        },
        dialogVisible: function dialogVisible() {
            return this.dialog.settings.visible;
        },
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.xsOnly) return '100%';else {
                if (this.dialog.settings.height) return;
                this.dialog.settings.height;
                return '500px';
            }
        },
        bodyStyle: function bodyStyle() {
            return {
                'max-height': this.$vuetify.breakpoint.xsOnly ? '100%' : '400px'
            };
        }
    },

    methods: {
        sliderLabel: function sliderLabel(label, percent) {
            return label + (percent ? ' (' + percent + '%)' : ' (00%)');
        },
        save: function save() {
            this.$emit('save');
            this.dialog.settings.visible = false;
        },
        cancel: function cancel() {
            this.$emit('cancel');
            this.dialog.settings.visible = false;
        },
        enterPressed: function enterPressed() {
            if (this.saveOnEnter) this.save();
        },
        show: function show() {
            this.fieldBackup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dialog.field);
        }
    },

    watch: {
        'dialog.settings.visible': function dialogSettingsVisible(visible) {
            if (visible) {
                this.show();
                this.$emit('show');
            } else this.$emit('hide');
        }
    }

});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_TemplateHelpers__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_ContactData__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__builder_Template_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__builder_Template_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__builder_Template_vue__);






























/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object
    },
    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_14__ui_elements_DialogBox___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_13__ui_elements_UserChooser___default.a
    },
    data: function data() {
        return {
            hasDestination: false,
            fromUser: this.user,
            toUser: null,
            days: 0,
            users: [],
            tasksForUser: []
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user;
        },
        tenantKey: function tenantKey() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].getTenantKey();
        },
        tasks: function tasks() {
            var _this = this;

            var tasks = [];
            this.tasksForUser.forEach(function (task) {
                var daysFromNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_date_fns__["G" /* differenceInDays */])(__WEBPACK_IMPORTED_MODULE_9__helpers_DateHelpers__["a" /* default */].toDate(task.due), new Date());
                if (daysFromNow <= _this.days) tasks.push(task);
            });
            return tasks;
        }
    },
    methods: {
        loadTasksForUser: function loadTasksForUser() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var uid, ref, tasks;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                uid = _this2.fromUser.uid;

                                _this2.tasksForUser = [];
                                ref = __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].getTenantRef().child('tasks').orderByChild('assigned/uid').equalTo(uid);
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_15__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref);

                            case 5:
                                tasks = _context.sent;

                                _this2.tasksForUser = tasks;

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        reassign: function reassign() {
            var _this3 = this;

            if (this.toUser == null) {
                __WEBPACK_IMPORTED_MODULE_16__helpers_AlertHelpers__["a" /* default */].showAlert('Select a user');
                return;
            }
            this.tasks.forEach(function (task) {
                var ref = __WEBPACK_IMPORTED_MODULE_8__helpers_DataHelpers__["a" /* default */].getTenantRef().child('tasks').child(task.meta.key);
                ref.update({ assigned: _this3.toUser });
            });
            this.loadTasksForUser();
            __WEBPACK_IMPORTED_MODULE_16__helpers_AlertHelpers__["a" /* default */].showAlert('Tasks have been reassigned');
        },
        initialiseDialog: function initialiseDialog() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_20__data_ContactData__["a" /* default */].fetchUsers().then(function (users) {
                console.log('fetching users from Reassign Dialog', users);
                _this4.users = users;
            });
        },
        reassignAll: function reassignAll() {},
        sendEmail: function sendEmail() {}
    },

    created: function created() {
        this.initialiseDialog();
    },


    watch: {
        'settings.visible': function settingsVisible(newVal) {
            if (newVal) {
                this.initialiseDialog();
            }
        }
    }

});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns__ = __webpack_require__(17);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value'],
    data: function data() {
        return {
            stepModalVisible: false,
            scheduleDate: this.value
        };
    },

    watch: {
        value: function value() {
            this.scheduleDate = this.value;
        },
        scheduleDate: function scheduleDate() {
            if (this.scheduleDate && this.scheduleDate != this.value) this.updateDate(this.scheduleDate);
        }
    },
    methods: {
        updateDate: function updateDate(dt) {
            this.$emit('input', dt);
            this.$emit('change', dt);
        },

        upcomingDays: function upcomingDays() {
            var days = [];
            for (var n = 0; n < 8; n++) {
                var dt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["e" /* addDays */])(new Date(), n);
                var initial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(dt, 'EEEE').charAt(0);
                var day = {
                    initial: initial,
                    date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["a" /* format */])(dt, __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS),
                    today: n == 0,
                    friday: initial == 'F'
                };
                if (initial != 'S') days.push(day);
            }

            days[days.length - 1].friday = false;

            return days;
        },
        sameDay: function sameDay(d1, d2) {
            var date1 = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].backwardsToDate(d1);
            var date2 = __WEBPACK_IMPORTED_MODULE_0__helpers_DateHelpers__["a" /* default */].backwardsToDate(d2);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_date_fns__["E" /* isSameDay */])(date1, date2);
        }
    }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        item: Object

    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        setupScrolling: function setupScrolling() {
            var _this = this;

            this.$refs.scroller.addEventListener('DOMNodeInserted', function (e) {
                _this.scrollToBottom(e);
            });
        },
        scrollToLastElement: function scrollToLastElement() {
            var el = this.$refs.scroller.lastChild;
            if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: 'smooth', block: 'end' });
                this.$emit('change');
            }
        },
        scrollToBottom: function scrollToBottom(e) {
            var el = this.$refs.scroller;

            if (e && e.target && e.target.className && e.target.className.indexOf('tooltip') > -1) {
                console.log('not scrolling');
                return;
            }

            el.scrollTop = el.scrollHeight;
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        setTimeout(function () {
            _this2.scrollToBottom();
            _this2.setupScrolling();
        }, 500);
    }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag__);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            transactions: []
        };
    },


    components: {
        Flag: __WEBPACK_IMPORTED_MODULE_5__ui_elements_Flag___default.a
    },

    props: {
        transactionKey: String,
        delay: {
            default: 3000,
            type: Number
        }
    },

    computed: {},

    methods: {
        getLink: function getLink(transactionKey) {
            return window.location.href.replace(this.transactionKey, transactionKey);
        },
        goToAnother: function goToAnother(transactionKey) {
            var link = this.getLink(transactionKey);
            window.location.href = link;
        },
        loadTransactions: function loadTransactions() {
            var _this = this;

            var transactions = [];
            var promises = [];

            __WEBPACK_IMPORTED_MODULE_2__helpers_ElementHelpers__["a" /* default */].fetchContactsForRole(this.transactionKey, 'Client').then(function (clients) {
                clients.forEach(function (client) {
                    var clientKey = client.key;
                    var ref = __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getTenantRef().child('contactTransactions').child(clientKey);
                    var promise = __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref);

                    console.log(ref.toString());
                    __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].fetchItemsFromFirebase(ref).then(function (res) {
                        console.log(res);
                    });
                    promises.push(promise);
                });
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (result) {
                    var uniqueTransactionsObj = {};
                    result.forEach(function (transactions) {
                        transactions.forEach(function (transaction) {
                            var transactionKey = transaction.meta.key;
                            delete transaction.meta;
                            if (transactionKey == _this.transactionKey) {
                                transaction.active = true;
                            }

                            uniqueTransactionsObj[transactionKey] = transaction;
                        });
                    });
                    _this.transactions = __WEBPACK_IMPORTED_MODULE_4__helpers_Utilities__["a" /* default */].objectToObjectArray(uniqueTransactionsObj).sort(function (a, b) {
                        return a.created > b.created;
                    });
                });
            });
        }
    },

    created: function created() {
        var _this2 = this;

        setTimeout(function () {
            _this2.loadTransactions();
        }, this.delay);
    }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ContactHelpers__ = __webpack_require__(9);

















/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        settings: Object,
        recipients: Array,
        message: String,
        returnObject: Object
    },
    components: {
        'DialogBox': __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default.a

    },
    data: function data() {
        return {
            sms: {
                recipients: [],
                message: ''
            },
            prefix: '',
            suffix: ''
        };
    },

    computed: {
        elements: function elements() {
            return this.$store.getters.elements;
        },
        fields: function fields() {
            return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.elements), [{ name: 'greeting', value: this.greeting }]);
        },
        greeting: function greeting() {
            return __WEBPACK_IMPORTED_MODULE_12__helpers_ContactHelpers__["a" /* default */].greetingFromContacts(this.sms.recipients);
        },
        contactsWithMobiles: function contactsWithMobiles() {
            return this.$store.getters.transactionContacts.filter(function (o) {
                return o.mobile;
            });
        },
        isFormValid: function isFormValid() {
            return true;
        }
    },
    methods: {
        sendSMS: function sendSMS() {
            var message = this.prefix + '...' + this.sms.message + ' (' + this.suffix + ')';
            var mobiles = this.sms.recipients.map(function (o) {
                return o.mobile || o;
            });
            console.log('mobiles', mobiles);
            mobiles.forEach(function (mobile) {
                __WEBPACK_IMPORTED_MODULE_10__helpers_Utilities__["a" /* default */].sendSMS(message, mobile);
            });

            this.$emit('sent', this.returnObject);
        },
        showingDialog: function showingDialog() {
            var _this = this;

            this.sms.recipients = this.recipients;
            this.sms.message = __WEBPACK_IMPORTED_MODULE_5__helpers_MergeHelpers__["a" /* default */].merge(this.message, this.fields);
            if (!this.suffix) {
                __WEBPACK_IMPORTED_MODULE_7__helpers_DataHelpers__["a" /* default */].getSettings('sms').then(function (settings) {
                    _this.suffix = settings.suffix;
                    _this.prefix = settings.prefix;
                });
            }
        },
        hidingDialog: function hidingDialog() {
            var _this2 = this;

            setTimeout(function () {
                _this2.sms = {
                    message: '',
                    recipients: []
                };
            }, 300);
        }
    },

    created: function created() {
        this.settings.saveLabel = 'Send';
        this.settings.height = '350px';
    }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ElementsStore__ = __webpack_require__(145);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            localItems: []
        };
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
        DialogBox: __WEBPACK_IMPORTED_MODULE_5__ui_elements_DialogBox___default.a
    },

    props: {
        dataRef: Object,
        settings: Object,
        items: Array
    },

    computed: {},

    methods: {
        afterDrag: function afterDrag(e) {
            console.log('dragged', e);
            var newItem = this.localItems[e.newIndex];
            newItem.order = __WEBPACK_IMPORTED_MODULE_4__helpers_OrderHelpers__["a" /* default */].getAverageOrder(e);
            __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].saveItem(newItem);
        },
        editItem: function editItem(item) {
            this.editDialog.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
            this.editDialog.settings.visible = true;
        },
        addItem: function addItem() {
            var item = {
                meta: {
                    key: __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].getKey(),
                    path: this.dataRef.toString().split('/').splice(3).join('/'),
                    savePosition: 'top'
                }
            };
            this.editItem(item);
        },
        saveRecord: function saveRecord(record) {
            __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].saveItem(record);
        },
        deleteRecord: function deleteRecord(record) {
            __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].deleteItem(record);
            this.editDialog.settings.visible = false;
        },
        itemClicked: function itemClicked(item) {
            this.$emit('click', item);
        },
        initialise: function initialise() {
            var _this = this;

            if (!this.dataRef && !this.items) return;else if (this.items) this.localItems = this.items;else this.dataRef.orderByChild('order').on('value', function (snap) {
                _this.localItems = __WEBPACK_IMPORTED_MODULE_3__data_NiceData__["a" /* default */].arrayFromSnapshot(snap);
            });
        }
    },

    created: function created() {}
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_ObjectViewer__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_ObjectViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_ObjectViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__system_ListHelpers__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_Firestore__ = __webpack_require__(27);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        ObjectViewer: __WEBPACK_IMPORTED_MODULE_0__ui_elements_ObjectViewer___default.a,
        draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
    },

    props: {
        items: Array,
        itemWidth: {
            type: String,
            default: '100%'
        }
    },

    computed: {
        selectedItems: function selectedItems() {
            return this.items.filter(function (o) {
                return o._selected;
            });
        },
        itemStyle: function itemStyle() {
            return 'width:' + this.itemWidth;
        }
    },

    methods: {
        afterDrag: function afterDrag(e) {
            var newOrder = __WEBPACK_IMPORTED_MODULE_2__helpers_OrderHelpers__["a" /* default */].getAverageOrder(e);
            var id = e.item.dataset.id;
            var movedItem = this.items.find(function (o) {
                return o._id == id;
            });
            var changes = {
                order: newOrder,
                _id: id,
                _path: movedItem._path,
                _collection: movedItem._collection,
                _team: movedItem._team
            };
            __WEBPACK_IMPORTED_MODULE_4__data_Firestore__["a" /* default */].saveItem(changes);
        },
        selectSingle: function selectSingle(element) {
            console.log('SortableList > selectSingle');
            __WEBPACK_IMPORTED_MODULE_3__system_ListHelpers__["a" /* default */].selectSingle(element, this.items);
        },
        selectMulti: function selectMulti(item) {
            console.log('SortableList > selectMulti');

            __WEBPACK_IMPORTED_MODULE_3__system_ListHelpers__["a" /* default */].selectMulti(item);
        },
        selectRange: function selectRange(item) {
            console.log('SortableList > selectRange');

            __WEBPACK_IMPORTED_MODULE_3__system_ListHelpers__["a" /* default */].selectRange(item, this.items);

            document.getSelection().removeAllRanges();
        },
        unselectAll: function unselectAll() {
            console.log('SortableList > deselectAll');

            __WEBPACK_IMPORTED_MODULE_3__system_ListHelpers__["a" /* default */].unselectAll(this.items);
        }
    }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            menuVisible: false

        };
    },


    components: {},

    props: {
        text: String,
        disabled: Boolean,
        menus: Array,
        menuOnly: Boolean,
        outline: Boolean,
        color: String
    },

    computed: {
        buttonText: function buttonText() {
            return this.text ? this.text.toUpperCase() : 'OK';
        },
        buttonContent: function buttonContent() {
            return this.$slots.default[0];
        }
    },

    methods: {
        bodyPartClicked: function bodyPartClicked() {
            if (this.disabled) this.menuVisible = false;
        },
        textPartClicked: function textPartClicked(e) {
            console.log(e);

            if (this.disabled) return;else if (!this.menuOnly) {
                e.stopPropagation();
                this.$emit('click', null);
            }
        },
        buttonPartClicked: function buttonPartClicked() {},
        emitClick: function emitClick(params) {
            this.$emit('click', params);
        }
    }

});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_StringHelpers__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            menuVisible: false
        };
    },


    props: {
        label: String,
        value: String,
        options: {
            type: String,
            default: 'One|red,Two|blue,Three|orange'
        }
    },

    computed: {
        colourClass: function colourClass() {
            return this.currentColour + ' lighten-2';
        },
        optionsList: function optionsList() {
            var items = [];
            var optionsArr = this.options.split(',');
            optionsArr.forEach(function (item) {
                var itemArr = item.split('|');
                var label = itemArr[0];
                var colour = itemArr[1] || 'grey';
                items.push({ label: label, colour: colour });
            });
            return items;
        },
        currentColour: function currentColour() {
            var _this = this;

            var currentItem = this.optionsList.find(function (o) {
                return o.label == _this.value;
            });
            return currentItem ? currentItem.colour : 'grey';
        }
    },

    methods: {
        textColourClass: function textColourClass(colour) {
            return colour + '--text text--lighten-2';
        },
        selectItem: function selectItem(item) {
            this.$emit('input', item.label);
        }
    }

});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_TagStatusHelpers__ = __webpack_require__(141);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {},

    props: {
        diameter: {
            type: Number,
            default: 32
        },
        value: Object,
        availableStages: Array },

    computed: {
        stageWidth: function stageWidth() {
            return parseInt(100 / this.availableStages.length);
        },
        statusStageStyle: function statusStageStyle() {
            return {

                'flex-basis': this.stageWidth + '%'
            };
        },
        stageCircleStyle: function stageCircleStyle() {
            return {
                'height': this.diameter + 'px',
                'width': this.diameter + 'px'
            };
        },
        controlStyle: function controlStyle() {
            return {
                'height': this.height + 'px'
            };
        },
        lineStyle: function lineStyle() {
            return {
                'top': this.diameter / 2 - 2 + 'px'
            };
        },
        lineStageStyle: function lineStageStyle() {
            return {
                'height': this.height - 2 + 'px',
                'width': this.height - 2 + 'px'
            };
        }
    },

    methods: {
        tagExists: function tagExists(stage) {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_TagStatusHelpers__["a" /* default */].tagExists(this.value, stage.name);
        },
        tagDate: function tagDate(stage) {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_TagStatusHelpers__["a" /* default */].tagDate(this.value, stage.name);
        },
        tagUser: function tagUser(stage) {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_TagStatusHelpers__["a" /* default */].tagUser(this.value, stage.name);
        }
    },

    created: function created() {}
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tagArray: []
        };
    },


    components: {},

    props: {
        tags: Object,
        availableTags: Array
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        remove: function remove(tag) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$root.$confirm('Remove', 'Are you sure you want to remove me from this group?', { color: 'yellow darken-2' });

                            case 2:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 6;
                                    break;
                                }

                                _this.$emit('remove', tag);
                                console.log('removing', tag);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    created: function created() {},


    watch: {
        'tags': {
            deep: true,
            immediate: true,
            handler: function handler(newVal, oldVal) {
                var _this2 = this;

                var tagArray = [];

                var _loop = function _loop(prop) {
                    var item = _this2.availableTags.find(function (t) {
                        return t._id == prop;
                    });
                    if (item) tagArray.push(item);else {
                        console.log('tagsView...not found ' + prop + ' in', _this2.availableTags.map(function (o) {
                            return o._id;
                        }).join(', '));
                    }
                };

                for (var prop in newVal) {
                    _loop(prop);
                }
                this.tagArray = tagArray;
            }
        }
    }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_TemplateHelpers__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_EmailHelpers__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_ContactData__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_date_fns__ = __webpack_require__(17);


























/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        task: Object,
        settings: Object
    },
    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_11__ui_elements_DialogBox___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_17__ui_elements_DeleteButton___default.a
    },
    data: function data() {
        return {
            sendEmailNotification: false,
            showEmailNotification: false,
            users: []
        };
    },

    computed: {
        isDisabled: function isDisabled() {
            var key = __WEBPACK_IMPORTED_MODULE_12__data_NiceData__["a" /* default */].safelyGetKey(this.task);
            return !Boolean(key);
        },
        user: function user() {
            return this.$store.getters.user;
        },
        tenantKey: function tenantKey() {
            if (this.task && this.task.tenantKey) return this.task.tenantKey;
            if (this.task && this.task.meta && this.task.meta.tenantKey) return this.task.meta.tenantKey;
            return null;
        },
        notificationRecipient: function notificationRecipient() {
            var recipient = void 0;
            if (this.task && this.task.assigned) recipient = this.task.assigned.firstName;else {
                recipient = '';
            }
            return recipient;
        }
    },
    methods: {
        pickerClicked: function pickerClicked() {
            this.saveTask();
            this.settings.visible = false;
        },
        userSelected: function userSelected(user) {
            var userId = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getUserId();

            this.showEmailNotification = Boolean(user.key != userId);
        },
        initialiseDialog: function initialiseDialog() {
            var _this = this;

            this.showEmailNotification = false;
            this.sendEmailNotification = false;
            setTimeout(function () {
                _this.$refs.focus.focus();
            }, 300);

            __WEBPACK_IMPORTED_MODULE_18__data_ContactData__["a" /* default */].fetchUsers().then(function (users) {
                console.log('fetching users from Task Dialog', users);
                _this.users = users;
            });
        },
        saveTask: function saveTask() {
            if (!this.task.assigned.uid) {
                this.task.assigned.uid = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getUserId();
            }

            this.sendEmail();
            this.$emit('save', this.task, this.settings);
        },
        deleteTask: function deleteTask(task) {
            var key = __WEBPACK_IMPORTED_MODULE_12__data_NiceData__["a" /* default */].safelyGetKey(task);
            this.settings.visible = false;
            var ref = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getTenantRef().child('tasks').child(key);
            console.log(ref.toString());
            ref.remove();
        },
        sendEmail: function sendEmail() {
            var _this2 = this;

            if (!this.sendEmailNotification) return;

            var assignedKey = this.task.assigned.key;
            var tenantKey = this.tenantKey;

            var ref = __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__["a" /* default */].getTenantRef(tenantKey).child('contacts').child(assignedKey);
            __WEBPACK_IMPORTED_MODULE_12__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (contact) {
                console.log('Contact is ', contact);

                __WEBPACK_IMPORTED_MODULE_14__helpers_TemplateHelpers__["a" /* default */].fetchTemplate(tenantKey, 'Notify Broker Task').then(function (template) {
                    console.log('Template is ', template);

                    if (!template) {
                        __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__["a" /* default */].showAlert('Template not found: Notify Broker Task');
                        return;
                    }

                    if (!_this2.task.transactionKey) {
                        __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__["a" /* default */].showAlert('Email not sent, since task was not linked to a transaction');
                    }

                    var linkToTaco = __WEBPACK_IMPORTED_MODULE_8__helpers_StringHelpers__["a" /* default */].linkToTaco(tenantKey + '/transaction/' + _this2.task.transactionKey, _this2.task.clients);

                    var customFields = {
                        greeting: __WEBPACK_IMPORTED_MODULE_16__helpers_ContactHelpers__["a" /* default */].greetingFromContacts([contact]),
                        sender: _this2.$store.getters.user.firstName,
                        clients: _this2.task.clients,
                        task_text: _this2.task.title,
                        task_due: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_date_fns__["a" /* format */])(new Date(_this2.task.due), __WEBPACK_IMPORTED_MODULE_19__helpers_DateHelpers__["b" /* dateFormats */].AUSTRALIAN),
                        transaction_link: linkToTaco
                    };

                    var body = __WEBPACK_IMPORTED_MODULE_4__helpers_MergeHelpers__["a" /* default */].simpleMerge(template.body, customFields);

                    var email = {};
                    email.to = contact.email;
                    email.subject = template.subject || '';
                    email.body = body;
                    __WEBPACK_IMPORTED_MODULE_15__helpers_EmailHelpers__["a" /* default */].sendEmail(email);

                    __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__["a" /* default */].showAlert('Email sent to ' + contact.firstName);
                });
            });
        }
    },

    created: function created() {},


    watch: {
        'settings.visible': function settingsVisible(newVal) {
            if (newVal) {
                this.initialiseDialog();
            }
        }
    }

});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__builder_InterfaceField__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__builder_InterfaceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__builder_InterfaceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__ = __webpack_require__(11);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            moreTime: false
        };
    },


    components: {
        InterfaceField: __WEBPACK_IMPORTED_MODULE_3__builder_InterfaceField___default.a
    },

    props: {
        tasks: Array
    },

    computed: {
        oldTasks: function oldTasks() {
            var thirtyDaysAgo = __WEBPACK_IMPORTED_MODULE_6__helpers_DateHelpers__["a" /* default */].dateToBackwards(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_date_fns__["H" /* subDays */])(new Date(), 30));

            return this.tasks.filter(function (o) {
                return o.due < thirtyDaysAgo;
            });
        },
        visible: function visible() {
            return !this.moreTime && this.oldTasks.length > 2;
        },
        clients: function clients() {
            return __WEBPACK_IMPORTED_MODULE_4__helpers_StringHelpers__["a" /* default */].sentenceJoin(this.oldTasks.map(function (o) {
                return o.clients;
            }));
        }
    },

    methods: {
        killOldTasks: function killOldTasks() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$root.$confirm('Delete', 'Are you sure you want to delete tasks older than 30 days?', { color: 'red' });

                            case 2:
                                _context.t0 = _context.sent;

                                if (!(_context.t0 == true)) {
                                    _context.next = 5;
                                    break;
                                }

                                _this.oldTasks.forEach(function (task) {
                                    var ref = __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__["a" /* default */].getRootRef().child(task.meta.path).child(task.meta.key);
                                    ref.remove();
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },

    created: function created() {}
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_TaskDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_elements_TaskDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ui_elements_TaskDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_TenantHelpers__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_TransactionHelpers__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_DataHelpers__ = __webpack_require__(3);


















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            taskDialog: {
                settings: {
                    visible: false,
                    title: 'Task Details'
                },
                model: {
                    key: null,
                    title: null,
                    due: null,
                    assigned: {}
                }
            }
        };
    },


    props: {
        tasks: Array,
        settings: Object
    },
    components: {
        TaskDialog: __WEBPACK_IMPORTED_MODULE_2__ui_elements_TaskDialog___default.a,
        Flag: __WEBPACK_IMPORTED_MODULE_6__ui_elements_Flag___default.a
    },

    computed: {
        lenders: function lenders() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_LookupData__["a" /* default */].lenders().map(function (o) {
                return o.name;
            });
        },
        importantTasks: function importantTasks() {
            return this.tasks.filter(function (o) {
                return o.important;
            });
        },
        transactionCount: function transactionCount() {
            var count = 0;
            for (var n in this.lenderTasks) {

                count += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.lenderTasks[n].transactions).length;
            }
            return count;
        },
        lenderTasks: function lenderTasks() {
            var result = {};
            this.tasks.sort(function (a, b) {
                a.lender = a.lender || 'Zero';
                b.lender = b.lender || 'Zero';
                if (a.lender < b.lender) return -1;
                if (a.lender > b.lender) return 1;
                return 0;
            });

            this.tasks.forEach(function (task) {
                var taskKey = __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].safelyGetKey(task);
                var lender = task.lender || 'No Lender';
                var transactionKey = task.transactionKey;
                var tenantKey = task.tenantKey;

                if (!result[lender]) result[lender] = {};

                var lenderObj = result[lender];
                lenderObj.name = lender;

                if (!lenderObj.transactions) lenderObj.transactions = {};

                if (!lenderObj.transactions[transactionKey]) {

                    lenderObj.transactions[transactionKey] = {
                        tenantKey: tenantKey,
                        key: transactionKey,
                        description: task.transactionDescription || '',
                        broker: task.transactionBroker || '',
                        clients: task.clients,
                        tasks: {}
                    };
                }

                result[lender].transactions[transactionKey].tasks[taskKey] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, task);

                lenderObj.multipleTransactions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(lenderObj.transactions).length;
            });

            return result;
        }
    },

    methods: {
        loadTransactionDetails: function loadTransactionDetails(transaction) {
            var _this = this;

            if (transaction.description) return;

            var transactionRef = __WEBPACK_IMPORTED_MODULE_14__helpers_DataHelpers__["a" /* default */].getTransactionRef(transaction.key, transaction.tenantKey);
            var ref = transactionRef.child('details');
            __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].fetchItemSingle(ref).then(function (transObj) {
                var elementRef = transactionRef.child('elements');
                __WEBPACK_IMPORTED_MODULE_8__data_NiceData__["a" /* default */].fetchItemByName(elementRef, 'broker').then(function (brokerElement) {
                    var broker = '';
                    if (brokerElement) broker = brokerElement.value;

                    var description = transObj ? transObj.description : 'Transaction not found for this task';
                    var tasks = _this.tasks.filter(function (t) {
                        return t.transactionKey == transaction.key;
                    });
                    tasks.forEach(function (task) {
                        _this.$set(task, 'transactionDescription', description);
                        _this.$set(task, 'transactionBroker', broker);
                    });
                });
            });
        },
        importantTaskColour: function importantTaskColour(task) {
            var days = this.daysTillDue(task);

            if (days < 0) return 'red darken-2';

            if (days == 0) return 'primary';

            return 'grey darken-1';
        },
        initials: function initials(user) {
            return __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__["a" /* default */].initials(user);
        },
        openAll: function openAll(lender) {
            var _this2 = this;

            var delay = 1000;
            for (var transaction in lender.transactions) {
                setTimeout(function () {

                    console.log('opening transaction', transaction);
                    _this2.transactionSpawn(transaction);
                }, delay);
                delay += 1000;
            }
        },
        transactionLink: function transactionLink(transaction) {
            var task = this.transactionFirstTask(transaction);
            var path = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].rootPath() + task.meta.tenantKey + '/transaction/' + task.transactionKey;
            return path;
        },
        taskClicked: function taskClicked(task) {
            console.log('taskClicked', task);
            __WEBPACK_IMPORTED_MODULE_9__helpers_TenantHelpers__["a" /* default */].setTenant(task.meta.tenantKey);
            this.$emit('clicked', task);
        },
        transactionClicked: function transactionClicked(transaction) {
            var firstTask = this.transactionFirstTask(transaction);

            this.taskClicked(firstTask);
        },
        transactionFirstTask: function transactionFirstTask(transaction) {
            var firstKey = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(transaction.tasks)[0];
            var firstTask = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, transaction.tasks[firstKey]);
            return firstTask;
        },
        daysTillDue: function daysTillDue(task) {
            if (!task.due) return null;

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_date_fns__["o" /* differenceInCalendarDays */])(__WEBPACK_IMPORTED_MODULE_11__helpers_DateHelpers__["a" /* default */].backwardsToDate(task.due), new Date());
        },
        openTask: function openTask(task) {
            __WEBPACK_IMPORTED_MODULE_9__helpers_TenantHelpers__["a" /* default */].setTenant(task.meta.tenantKey);
            this.taskDialog.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, task);
            this.taskDialog.settings.visible = true;
        },
        saveTask: function saveTask(task) {
            console.log('tasksByLender > saveTask');
            this.$store.dispatch('saveTask', task);
        }
    }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_Db__ = __webpack_require__(108);













/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            paused: false,
            sheets: [],
            interval: null,
            inactiveTime: 0,
            expanded: false
        };
    },


    components: {},

    props: {
        relatedId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true,
            default: 'Loading'
        },
        payload: {
            type: Object
        }
    },

    computed: {
        mySheet: function mySheet() {
            var _this = this;

            return this.sheets.find(function (o) {
                return o.userId == _this.myUserId;
            });
        },
        myTimeToday: function myTimeToday() {
            if (!this.mySheet) return null;
            return this.mySheet.days.find(function (d) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_date_fns__["E" /* isSameDay */])(d.day, new Date());
            });
        },
        myUserId: function myUserId() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getUserId();
        },
        myUserName: function myUserName() {
            return __WEBPACK_IMPORTED_MODULE_8__helpers_ContactHelpers__["a" /* default */].fullName(__WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getUser());
        },
        durationToday: function durationToday() {
            if (!this.myTimeToday) return 0;

            return __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].convertToDuration(this.myTimeToday.seconds);
        },
        durationTotal: function durationTotal() {
            if (!this.mySheet) return 0;

            return this.duration(this.mySheet.total);
        },
        allUserTotal: function allUserTotal() {
            return this.sheets.reduce(function (acc, val) {
                return acc + val.total;
            }, 0);
        }
    },

    methods: {
        duration: function duration(seconds) {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].convertToDuration(seconds);
        },
        debugMe: function debugMe() {
            console.log('My Sheet...', this.mySheet);
        },
        incrementTimer: function incrementTimer() {
            if (!this.paused) {
                this.$set(this.myTimeToday, 'seconds', this.myTimeToday.seconds + 1);
                this.$set(this.mySheet, 'total', this.mySheet.total + 1);
            }
        },
        incrementInactive: function incrementInactive() {
            this.$set(this, 'inactiveTime', this.inactiveTime + 1);
        },
        keepAlive: function keepAlive() {
            this.inactiveTime = 0;
        },
        saveTimesheet: function saveTimesheet() {
            var sheet = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.mySheet, this.payload);
            this.mySheet.title = this.title;
            this.mySheet._db.saveItem(this.mySheet, { owner: true, timestamp: true });
        }
    },

    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var db, sheets, sheet;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            console.log('Time tracker created...');

                            window.addEventListener('click', _this2.keepAlive);
                            window.addEventListener('keypress', _this2.keepAlive);

                            db = new __WEBPACK_IMPORTED_MODULE_9__data_Db__["a" /* default */]();
                            _context.next = 6;
                            return db.ref('timesheets').where('relatedId', '==', _this2.relatedId).fetch();

                        case 6:
                            sheets = _context.sent;


                            if (sheets.length) _this2.sheets = sheets;

                            if (!_this2.mySheet) {
                                sheet = {};

                                sheet._db = db;
                                sheet._id = __WEBPACK_IMPORTED_MODULE_6__data_Firestore__["a" /* default */].getId();

                                sheet.flowId = _this2.relatedId;

                                sheet.relatedId = _this2.relatedId;
                                sheet.userId = _this2.myUserId;
                                sheet.userName = _this2.myUserName;
                                sheet.total = 0;
                                sheet.days = [];
                                _this2.sheets.push(sheet);
                            }

                            if (!_this2.myTimeToday) {
                                _this2.mySheet.days.push({
                                    day: new Date(),
                                    seconds: 0
                                });
                            }

                            setInterval(_this2.incrementInactive, 1000);
                            setInterval(_this2.incrementTimer, 1000);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('click', this.keepAlive);
        window.removeEventListener('keypress', this.keepAlive);
        this.saveTimesheet();
    },


    watch: {
        'inactiveTime': {
            handler: function handler(newVal) {
                if (newVal > 60) this.paused = true;else this.paused = false;
            }
        }
    }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_AlertHelpers__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            remaining: 0,
            timerHandle: null
        };
    },


    components: {},

    props: {
        seconds: Number,
        watch: [Object, String, Number]
    },

    computed: {
        timerText: function timerText() {
            if (this.remaining) return 'Saving in ' + this.remaining + 's';else return 'Saved';
        }
    },

    methods: {
        revert: function revert() {
            __WEBPACK_IMPORTED_MODULE_1__helpers_AlertHelpers__["a" /* default */].showAlert('Cannot revert yet');
        },
        start: function start() {
            var _this = this;

            this.remaining = this.seconds;
            if (!this.timerHandle) {
                this.timerHandle = setInterval(function () {
                    _this.remaining -= 1;
                    if (_this.remaining <= 0) {
                        _this.stop();
                        _this.run();
                    }
                }, 1000);
            }
        },
        stop: function stop() {
            clearInterval(this.timerHandle);
            this.timerHandle = null;
            this.remaining = 0;
        },
        run: function run() {
            this.$emit('run', this.watch);
        }
    },

    watch: {
        'watch': {
            handler: function handler(newVal) {
                this.start();
            },
            deep: true
        }
    },

    beforeDestroy: function beforeDestroy() {
        if (this.timerHandle) this.run();
    }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            searchVisible: false,
            searchText: ''
        };
    },


    components: {},

    props: {
        item: Object,
        debounced: Boolean
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        clear: function clear() {
            this.searchText = '';
            this.runSearch();
        },


        debouncedRunSearch: __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__["a" /* default */].debounce(function () {
            if (this.debounced) this.runSearch();
        }, 700),

        enterRunSearch: function enterRunSearch() {
            if (!this.debounced) this.runSearch();
        },
        runSearch: function runSearch() {
            console.log('about to search for ', this.searchText);
            this.$emit('search', this.searchText.toLowerCase());
        },
        toggleSearchVisibility: function toggleSearchVisibility() {
            this.searchVisible = !this.searchVisible;
            if (this.searchVisible) this.$refs.search.focus();else {
                this.cancelSearch();
            }
        },
        lostFocus: function lostFocus() {
            var _this = this;

            setTimeout(function () {
                if (!_this.searchText) {
                    _this.cancelSearch();
                }
            }, 200);
        },
        cancelSearch: function cancelSearch() {
            var _this2 = this;

            this.searchVisible = false;
            setTimeout(function () {

                _this2.searchText = '';
                _this2.$refs.search.blur();
                _this2.$emit('search', '');
            }, 100);
        }
    },

    created: function created() {}
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_PageHelpers__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_TaskDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_TaskDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_TaskDialog__);

















/* harmony default export */ __webpack_exports__["default"] = ({

    components: {
        TaskDialog: __WEBPACK_IMPORTED_MODULE_12__ui_elements_TaskDialog___default.a
    },

    data: function data() {
        return {
            commentMenu: false,
            currentComment: {
                text: '' },
            members: ['Roxie Miles', 'grace.carroll', 'Mikaleigh'],
            hashtags: ['Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek'],
            taskDialog: {
                settings: {
                    visible: false,
                    title: 'Task Details'
                },
                model: {
                    key: null,
                    title: null,
                    due: null,
                    assigned: {}
                }
            }
        };
    },


    props: {
        firebaseRef: Object
    },

    computed: {
        snippets: function snippets() {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_LookupData__["a" /* default */].snippets().filter(function (o) {
                return o.category == 'Comments';
            });
        },
        searchText: function searchText() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_PageHelpers__["a" /* default */].getPageData('search');
        },
        allCommentsMode: function allCommentsMode() {
            return this.$store.getters.allCommentsMode;
        },
        comments: function comments() {
            var _this = this;

            var comments = this.$store.getters.transactionComments;

            if (this.searchText) {
                return comments.filter(function (o) {
                    return o.text.toLowerCase().indexOf(_this.searchText) > -1;
                });
            }

            if (this.allCommentsMode) {
                console.log('showing all comments');
                return comments;
            }

            if (this.selectedTab && this.selectedTab.key == 'home') comments = comments.filter(function (o) {
                return o.important;
            });else if (this.selectedTask) comments = comments.filter(function (o) {
                return o.taskKey == _this.selectedTask.key;
            });else if (this.selectedSection) comments = comments.filter(function (o) {
                return o.sectionKey == _this.selectedSection.key;
            });else if (this.selectedTab) {
                return comments.filter(function (o) {
                    return !o.tabKey || o.tabKey == _this.selectedTab.key || o.important;
                });
            }

            return comments;
        },
        selectedMentions: function selectedMentions() {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].mentions(this.currentComment.text);
        },
        selectedHashtags: function selectedHashtags() {
            return __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].hashtags(this.currentComment.text);
        },
        selectedComments: function selectedComments() {
            return this.comments.filter(function (o) {
                return o.selected;
            });
        },
        commentType: function commentType() {
            var commentType = 'General';
            if (this.selectedTask) commentType = __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].truncate(this.selectedTask.title || '', 25);else if (this.selectedSection) commentType = this.selectedSection.title;else if (this.selectedTab) commentType = this.selectedTab.title;

            if (commentType == 'Home') commentType = 'Important';
            return commentType;
        },
        placeHolder: function placeHolder() {
            if (this.searchText) {
                return "Containing '" + this.searchText + "'...";
            }
            var sectionTitle = this.commentType.toLowerCase();
            return 'Comment for ' + sectionTitle + '...';
        },
        selectedTask: function selectedTask() {
            return this.$store.getters.selectedTask;
        },
        selectedSection: function selectedSection() {
            return this.$store.getters.selectedSection;
        },
        selectedTab: function selectedTab() {
            return this.$store.getters.selectedTab;
        },
        usersWithInitials: function usersWithInitials() {
            return this.$store.getters.users.map(function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, o, {
                    initials: __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__["a" /* default */].acronym(o.name)
                });
            });
        }
    },

    methods: {
        useSnippet: function useSnippet(snippet) {
            this.currentComment.text = snippet.text + ' ';
            this.$refs.commentBox.$el.focus();
        },
        showAllComments: function showAllComments() {
            this.$store.commit('allCommentsMode', true);
        },
        makeImportant: function makeImportant(comment) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectedOrClicked(comment, this.selectedComments).forEach(function (comment) {
                var changes = { key: comment.key, important: true };
                _this2.$store.dispatch('saveTransactionComment', changes);
            });
        },
        makeTask: function makeTask(comment) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectedOrClicked(comment, this.selectedComments).forEach(function (comment) {
                var key = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getKey();
                var title = comment.text || '';

                var newTask = { key: key, title: title };
                _this3.$store.dispatch('saveTask', newTask);
            });
        },
        saveTask: function saveTask(task) {
            this.$store.dispatch('saveTask', task);
        },
        scheduleTask: function scheduleTask(comment) {
            var dateStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["e" /* addDays */])(new Date(), 1).formatBackwards();

            this.taskDialog.model.due = dateStr;
            this.taskDialog.model.title = comment.text;
            this.taskDialog.model.assigned = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getUser();
            this.taskDialog.settings.visible = true;
        },
        removeImportant: function removeImportant(comment) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectedOrClicked(comment, this.selectedComments).forEach(function (comment) {
                var changes = { key: comment.key, important: null };
                _this4.$store.dispatch('saveTransactionComment', changes);
            });
        },
        editComment: function editComment(comment) {
            this.currentComment = comment;
            this.$refs.commentBox.$el.focus();
        },
        deleteComment: function deleteComment(comment) {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectedOrClicked(comment, this.selectedComments).forEach(function (comment) {
                _this5.$store.dispatch('deleteTransactionComment', comment);
            });
        },
        selectSingle: function selectSingle(comment) {
            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectSingle(comment, this.comments);

            var path = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTransactionRef().toString() + ('/comments/' + comment.key);

            __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].log('selectSingle', comment, path);
        },
        selectMulti: function selectMulti(comment) {
            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectMulti(comment);
        },
        selectRange: function selectRange(comment) {
            __WEBPACK_IMPORTED_MODULE_7__helpers_ListHelpers__["a" /* default */].selectRange(comment, this.comments);
        },
        saveComment: function saveComment() {
            if (!this.currentComment || !this.currentComment.text || this.currentComment.text.length < 3) return;

            var continueToSave = this.preProcessComment(this.currentComment.text);

            var newComment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentComment);

            var selectedTask = this.$store.getters.selectedTask;

            __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].assignProperty(this.selectedTab, 'key', newComment, 'tabKey');
            __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].assignProperty(this.selectedSection, 'key', newComment, 'sectionKey');
            __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].assignProperty(selectedTask, 'key', newComment, 'taskKey');

            if (this.selectedTab && this.selectedTab.key == 'home') newComment.important = true;

            if (continueToSave) this.$store.dispatch('saveTransactionComment', newComment);

            __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].clearProperties(this.currentComment);
        },
        preProcessComment: function preProcessComment(text) {
            var _this6 = this;

            var initialsList = String(text).match(/@[A-Z][A-Z]\b/g) || [];
            var continueToSave = true;
            initialsList.forEach(function (initials) {
                var user = _this6.usersWithInitials.find(function (o) {
                    return '@' + o.initials == initials;
                });
                if (user) {
                    var newTask = {
                        title: text,
                        assigned: user,
                        due: __WEBPACK_IMPORTED_MODULE_10__helpers_DateHelpers__["a" /* default */].todayString()
                    };
                    _this6.$store.dispatch('saveTask', newTask);
                    continueToSave = false;
                }
            });
            return continueToSave;
        },
        loadComments: function loadComments() {
            for (var n = 1; n < 50; n++) {
                this.comments.push(this.makeRandomComment());
            }
        },
        makeRandomComment: function makeRandomComment() {
            return {
                key: __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getKey(),
                text: this.$faker().lorem.paragraph(3),
                stamp: __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getStamp()
            };
        },
        demoData: function demoData() {
            this.currentComment.text = this.$faker().lorem.paragraph(2);
        },
        lineBreaks: function lineBreaks(str) {
            try {
                return str.replace(/\n/g, '<br/>');
            } catch (err) {
                console.error('lineBreaks was passed', err);
                return '[no value]';
            }
        },
        stamp: function stamp(item) {
            var stampString = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].formatStamp(item.stamp);
            return stampString;
        }
    },

    created: function created() {
        __WEBPACK_IMPORTED_MODULE_9__helpers_Utilities__["a" /* default */].log('comments > created');
        this.$store.dispatch('loadTransactionComments');
    }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_CommunicationBar__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_CommunicationBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_CommunicationBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_ContactEditor__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_ContactEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_ContactEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_OfficeSelectionDialog__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_OfficeSelectionDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_OfficeSelectionDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_clipboard_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_clipboard_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_clipboard_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_NiceData__ = __webpack_require__(15);




















var db = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.database();

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        element: Object,
        transactionKey: String,
        settings: Object
    },
    components: {
        CommunicationBar: __WEBPACK_IMPORTED_MODULE_8__ui_elements_CommunicationBar___default.a,
        ContactEditor: __WEBPACK_IMPORTED_MODULE_9__ui_elements_ContactEditor___default.a,
        DeleteButton: __WEBPACK_IMPORTED_MODULE_10__ui_elements_DeleteButton___default.a,
        OfficeSelectionDialog: __WEBPACK_IMPORTED_MODULE_12__ui_elements_OfficeSelectionDialog___default.a
    },

    data: function data() {
        return {

            dialogVisible: this.visible,
            contactEditor: {
                contact: null,
                settings: {
                    visible: false
                }
            },
            officeSelectionDialog: {
                settings: {
                    visible: false
                }
            }
        };
    },

    computed: {
        dialogHeight: function dialogHeight() {
            if (this.$vuetify.breakpoint.smAndDown) return '100%';else return '500px';
        },
        title: function title() {
            if (this.element && this.element.contact) return __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__["a" /* default */].fullName(this.element.contact);else return 'Contact';
        },
        firstName: function firstName() {
            if (this.element && this.element.contact) return this.element.contact.firstName;else return 'Contact';
        },
        elementAsContact: function elementAsContact() {
            try {
                var newContact = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.element.contact);
                newContact.meta = {};
                newContact.meta.key = this.element.contactKey;

                newContact.meta.tenantKey = this.element.tenantKey != "1" ? this.element.tenantKey : __WEBPACK_IMPORTED_MODULE_15__data_NiceData__["a" /* default */].safelyGetTenant();

                newContact.meta.role = this.element.role;
                return newContact;
            } catch (e) {
                console.log('elementAsContact fails');
                return {};
            }
        }
    },

    methods: {
        clickedClose: function clickedClose() {
            this.settings.visible = false;
        },
        clickedEditContact: function clickedEditContact() {
            this.settings.visible = false;
            this.contactEditor.contact = this.elementAsContact;
            this.contactEditor.settings.visible = true;
        },
        unlinkContact: function unlinkContact() {
            this.settings.visible = false;
            this.$emit('unlink', this.elementAsContact);
        },
        contactSaved: function contactSaved() {
            this.refreshContact();
        },
        refreshContact: function refreshContact() {
            this.$emit('refresh', this.element);
        },
        showElementDialog: function showElementDialog() {
            this.settings.visible = false;
            this.$emit('edit-element', this.element);
        },
        showCopyToOffices: function showCopyToOffices() {
            this.officeSelectionDialog.settings.visible = true;
        },
        copyToOffices: function copyToOffices(offices) {
            if (!offices || offices.length < 1) return;
            var transactionContact = this.element;
            offices.forEach(function (office) {
                __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__["a" /* default */].copyTransactionContactToOffices(transactionContact, office.meta.key);
            });
            __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__["a" /* default */].showAlert('Contact has been exported to other office/s');
        },
        clientToClipboard: function clientToClipboard() {
            var str = __WEBPACK_IMPORTED_MODULE_7__helpers_ContactHelpers__["a" /* default */].contactDetailsToText(this.element.contact);

            __WEBPACK_IMPORTED_MODULE_14_clipboard_js___default.a.copy({ 'text': str });

            __WEBPACK_IMPORTED_MODULE_13__helpers_AlertHelpers__["a" /* default */].showAlert('Copied to clipboard');
        }
    },
    watch: {
        visible: function visible(newVal) {
            this.dialogVisible = newVal;
            if (newVal) {}
        }
    },

    created: function created() {}
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ContactHelpers_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_TeamHelpers_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flow_ui_ContactImage__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flow_ui_ContactImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flow_ui_ContactImage__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            blankAvatars: false
        };
    },


    components: {
        ContactImage: __WEBPACK_IMPORTED_MODULE_3__flow_ui_ContactImage___default.a
    },

    props: {
        contactElements: Array
    },

    computed: {},

    methods: {
        getContactImage: function getContactImage(contact) {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_ContactHelpers_js__["a" /* default */].getContactImage(contact, this.blankAvatars);
        },
        contactClicked: function contactClicked(element) {
            this.$emit('click', element);
            var path = __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers_js__["a" /* default */].getTransactionRef().toString() + ('/elements/' + element.key);
            console.log('TransactionContacts > contactClicked', path);
        },
        bestNumber: function bestNumber(contact) {
            return __WEBPACK_IMPORTED_MODULE_1__helpers_ContactHelpers_js__["a" /* default */].bestNumber(contact);
        }
    },

    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2__helpers_TeamHelpers_js__["a" /* default */].fetchTeamSettings().then(function (settings) {
            _this.blankAvatars = settings.blankAvatars;
        });
    }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        fileElements: Array
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        fileClicked: function fileClicked(file) {
            console.log('File clicked', file);
        }
    }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builder_Template_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__builder_Template_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__builder_Template_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    components: {
        Template: __WEBPACK_IMPORTED_MODULE_0__builder_Template_vue___default.a

    },

    props: {
        items: Array,
        showTo: Boolean
    },

    computed: {},

    methods: {
        textBody: function textBody(html, expanded) {
            var str = __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__["a" /* default */].removeHtml(html);
            if (!expanded) str = __WEBPACK_IMPORTED_MODULE_2__helpers_StringHelpers__["a" /* default */].truncateDots(str, 85);
            return str;
        },
        toggleExpansion: function toggleExpansion(item) {
            this.$set(item, 'expanded', !item.expanded);
        }
    },

    created: function created() {}
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_OrderHelpers__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {},

    computed: {
        elements: function elements() {
            return this.$store.getters.elements;
        },
        tabs: function tabs() {
            return this.elements.filter(function (o) {
                return o.type && o.type == 'Tab';
            }).sort(__WEBPACK_IMPORTED_MODULE_0__helpers_OrderHelpers__["a" /* default */].sortAscending);
        },
        milestones: function milestones() {
            return this.elements.filter(function (o) {
                return o.milestone && !o.na;
            }).sort(__WEBPACK_IMPORTED_MODULE_0__helpers_OrderHelpers__["a" /* default */].sortAscending);
        }
    },

    methods: {
        milestonesForTab: function milestonesForTab(tabKey) {
            return this.milestones.filter(function (o) {
                return o.tabKey == tabKey;
            });
        },
        complete: function complete(element) {
            element.value = true;
            this.$emit('save', element);
        },
        notApplicable: function notApplicable(element) {
            element.na = true;
            this.$emit('save', element);
        }
    }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_TaskDialog__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_elements_TaskDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ui_elements_TaskDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_Flag__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_elements_Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ui_elements_Flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_AlertHelpers__ = __webpack_require__(12);






















var SAFETY_TASK_TITLE = 'Please follow up';

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            newTask: null,
            taskDialog: {
                settings: {
                    visible: false,
                    title: 'Task Details'
                },
                model: {
                    key: null,
                    title: null,
                    due: null,
                    assigned: {}
                }
            }
        };
    },


    props: {},

    components: {
        DialogBox: __WEBPACK_IMPORTED_MODULE_7__ui_elements_DialogBox___default.a,
        TaskDialog: __WEBPACK_IMPORTED_MODULE_8__ui_elements_TaskDialog___default.a,
        UserChooser: __WEBPACK_IMPORTED_MODULE_10__ui_elements_UserChooser___default.a,
        Scheduler: __WEBPACK_IMPORTED_MODULE_12__ui_elements_Scheduler___default.a,
        Flag: __WEBPACK_IMPORTED_MODULE_9__ui_elements_Flag___default.a
    },

    computed: {
        tasks: function tasks() {
            var _this = this;

            return this.$store.getters.tasks.filter(function (o) {
                return o.transactionKey == _this.transactionKey;
            }).sort(function (a, b) {
                return a.due > b.due;
            });
        },
        user: function user() {
            return this.$store.getters.user;
        },
        transactionKey: function transactionKey() {
            return this.$store.getters.transaction.key;
        },
        nextBusinessDay: function nextBusinessDay() {
            __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].businessDaysFromNow(1).formatBackwards();
        },
        selectedTab: function selectedTab() {
            return this.$store.getters.selectedTab;
        },
        selectedTask: function selectedTask() {
            return this.$store.getters.selectedTask;
        }
    },

    methods: {
        increment: function increment(task, days) {

            var dueDate = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToDate(task.due);
            dueDate = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].businessDaysAdd(dueDate, days);
            task.due = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(dueDate);
            this.saveTask(task);
        },
        fullName: function fullName(contact) {
            return __WEBPACK_IMPORTED_MODULE_11__helpers_ContactHelpers__["a" /* default */].fullName(contact);
        },
        dueIndicatorClass: function dueIndicatorClass(task) {
            var days = this.daysTillDue(task);
            if (days == 0) return "primary darken-1";else if (days < 0) return "red darken-2";
        },
        daysTillDue: function daysTillDue(task) {
            if (!task.due) return null;

            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_date_fns__["G" /* differenceInDays */])(__WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToDate(task.due), new Date());
        },
        openTask: function openTask(task) {
            this.taskDialog.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, task) || {
                due: this.nextBusinessDay,
                assigned: this.$store.getters.user,
                clients: this.$store.getters.transaction.clients
            };

            this.taskDialog.settings.visible = true;
        },
        changeDueDate: function changeDueDate(task, days) {
            __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__["a" /* default */].selectedOrClicked(task, this.selectedTasks).forEach(function (selected) {
                var selectedDue = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].backwardsToDate(selected.due);
                var newDue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_date_fns__["e" /* addDays */])(selectedDue, days);
                selected.due = format(newDue, __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["b" /* dateFormats */].BACKWARDS);
            });
        },
        taskChecked: function taskChecked(task) {
            var _this2 = this;

            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_13_vue__["default"].nextTick(function () {
                    _this2.completeTask(task);
                });
            }, 700);
        },
        isTaskSelected: function isTaskSelected(task) {
            if (!this.selectedTask || !task) return false;
            if (task.key == this.selectedTask.key) return true;
            return false;
        },
        completeTask: function completeTask(task) {
            var comment = {
                text: task.title,
                sectionKey: task.sectionKey || null,
                tabKey: this.selectedTab.key || null,
                complete: true
            };
            this.$store.dispatch('saveTransactionComment', comment);
            this.deleteTask(task);
        },
        toggleImportant: function toggleImportant(task) {
            task.important = !task.important;
            this.saveTask(task);
        },
        selectSingle: function selectSingle(task) {
            console.log('selectSingle', task);
            var newTask = void 0;
            if (this.isTaskSelected(task)) newTask = null;else newTask = task;
            this.$store.dispatch('selectTask', newTask);
        },
        quickSaveTask: function quickSaveTask(taskTitle) {

            if (taskTitle.length < 3) return;

            __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].log('tasks > quickSaveTask');

            var task = {
                tabKey: this.selectedTab ? this.selectedTab.key : null,
                sectionTitle: this.selectedSection ? this.selectedSection.title : null,
                title: taskTitle,
                assigned: this.user,
                due: this.nextBusinessDay,
                clients: this.$store.getters.transaction.clients,
                lender: __WEBPACK_IMPORTED_MODULE_14__helpers_ElementHelpers__["a" /* default */].getValueFromName('lender')
            };

            var periodObj = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].findTimeframeInString(taskTitle);
            if (periodObj.found) {
                task.due = __WEBPACK_IMPORTED_MODULE_2__helpers_DateHelpers__["a" /* default */].dateToBackwards(periodObj.date);
                task.title = periodObj.remaining;
                __WEBPACK_IMPORTED_MODULE_17__helpers_AlertHelpers__["a" /* default */].showAlert('Scheduled for ' + periodObj.words);
            }

            this.$store.dispatch('saveTask', task);

            this.newTask = '';

            this.removeSafeguard();
        },
        saveTask: function saveTask(task) {
            console.log('tasks > saveTask');

            if (task.title) task.lender = __WEBPACK_IMPORTED_MODULE_14__helpers_ElementHelpers__["a" /* default */].getValueFromName('lender');

            this.$store.dispatch('saveTask', task);
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].clearProperties(task);
            }, 500);

            if (!task.title == SAFETY_TASK_TITLE) this.removeSafeguard();
        },
        removeSafeguard: function removeSafeguard() {

            var safeTask = this.tasks.find(function (o) {
                return o.title == SAFETY_TASK_TITLE;
            });
            if (safeTask && this.tasks.length > 1) this.deleteTask(safeTask, true);
        },
        deleteTask: function deleteTask(task, force) {
            this.$store.dispatch('deleteTask', task);

            if (force) return;

            if (!this.tasks.length) {
                this.saveTask({
                    title: SAFETY_TASK_TITLE
                });
            }
        },
        lineBreaks: function lineBreaks(str) {
            return str.replace(/\n/g, '<br/>');
        },
        stamp: function stamp(item) {
            var stampString = __WEBPACK_IMPORTED_MODULE_1__helpers_DataHelpers__["a" /* default */].formatStamp(item.stamp);
            return stampString;
        }
    },

    watch: {},

    created: function created() {
        this.$store.dispatch('loadTasks');
    }
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__ = __webpack_require__(9);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            duplicate: false
        };
    },


    components: {},

    props: {
        contact: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        check: function check() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var firstName, lastName, duplicate;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                console.log('Checking duplicates...');
                                firstName = _this.contact.firstName;
                                lastName = _this.contact.lastName;

                                if (!(!firstName || !lastName)) {
                                    _context.next = 6;
                                    break;
                                }

                                _this.duplicate = false;
                                return _context.abrupt('return');

                            case 6:
                                _context.next = 8;
                                return __WEBPACK_IMPORTED_MODULE_3__helpers_ContactHelpers__["a" /* default */].checkForDuplicates(firstName, lastName);

                            case 8:
                                duplicate = _context.sent;

                                if (duplicate) _this.duplicate = duplicate;else _this.duplicate = false;

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        clearIfEmpty: function clearIfEmpty(name) {
            if (!name) {
                this.duplicate = false;
            }
        }
    },

    created: function created() {},


    watch: {
        'contact.firstName': {
            handler: function handler(newVal) {
                this.clearIfEmpty(newVal);
            }
        },
        'contact.lastName': {
            handler: function handler(newVal) {
                this.clearIfEmpty(newVal);
            }
        }

    }

});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_UploadFirebase__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ui_elements_UploadFirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ui_elements_UploadFirebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_FileDialog__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_elements_FileDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ui_elements_FileDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__ = __webpack_require__(12);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            linkMode: false,
            fileDialog: {
                settings: {
                    visible: false,
                    closeOnly: true,
                    title: 'Linked Files'
                }
            }

        };
    },


    components: {
        UploadFirebase: __WEBPACK_IMPORTED_MODULE_0__ui_elements_UploadFirebase___default.a,
        FileDialog: __WEBPACK_IMPORTED_MODULE_1__ui_elements_FileDialog___default.a
    },

    props: {
        element: Object
    },

    computed: {
        linkedFileCount: function linkedFileCount() {
            if (this.element.linkedFileKeys && this.element.linkedFileKeys.length) return this.element.linkedFileKeys.length;else return 0;
        },
        buttonClass: function buttonClass() {
            if (this.linkedFileCount) return 'blue lighten-3';else return 'grey lighten-3';
        },
        iconClass: function iconClass() {
            if (this.element.complete) return 'blue darken-1';else return 'grey';
        },
        elements: function elements() {
            return this.$store.getters.elements;
        },
        files: function files() {
            return this.elements.filter(function (o) {
                return o.type == "File";
            }).reverse();
        },
        transaction: function transaction() {
            return this.$store.getters.transaction;
        },
        uploadedFiles: function uploadedFiles() {
            return __WEBPACK_IMPORTED_MODULE_3__helpers_ElementHelpers__["a" /* default */].filesForElement(this.element, this.elements);
        }
    },

    methods: {
        showDialog: function showDialog() {
            this.fileDialog.element = this.element;
            this.fileDialog.settings.visible = true;
        },
        uploadStart: function uploadStart(upload, triggerElement) {
            __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].log('uploadStart', upload);
            upload.tabKey = 'settings';
            upload.transactionKey = this.transaction.key;
            upload.type = 'File';
            upload.title = upload.name;
            this.saveElement(upload);
        },
        uploadFinish: function uploadFinish(upload, triggerElement) {

            if (!upload.url) {
                console.log('failed upload...deleting');
                this.deleteElement(upload);
            }
            console.log('uploadFinish', upload);

            upload.value = upload.url;
            upload.triggerElementKey = triggerElement.key;
            upload.name = triggerElement && triggerElement.targetName ? triggerElement.targetName : upload.name;
            this.saveElement(upload);
        },
        uploadStartAll: function uploadStartAll(triggerElement) {
            __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].log('uploadStartAll');
            triggerElement.loading = true;
            this.saveElement(triggerElement);
        },
        uploadFinishAll: function uploadFinishAll(payload) {
            __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].log('uploadFinishAll');

            var triggerElement = payload.returnObject;
            triggerElement.complete = true;
            triggerElement.loading = false;
            this.saveElement(triggerElement);
            __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__["a" /* default */].showAlert('Uploaded ' + payload.files);
        },
        saveElement: function saveElement(element) {
            this.$store.dispatch('saveElement', element);
        },
        deleteElement: function deleteElement(element) {
            this.$store.dispatch('deleteElement', element);
        },
        showError: function showError(error) {
            this.$emit('error', error);
        },
        hideLoader: function hideLoader() {
            this.element.loading = false;
            this.saveElement(this.element);
        }
    },

    created: function created() {}
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_database__ = __webpack_require__(21);











/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        path: String,
        returnObject: {
            type: Object,
            default: function _default() {
                key: null;
            }
        }
    },

    computed: {
        test: function test() {
            return null;
        }
    },

    methods: {
        upload: function upload(files) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].log('uploading...', files);

            if (!this.path) {
                this.$emit('error', 'Path not provided');
            }
            var uploadList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(files).map(function (file) {
                return {
                    file: file,
                    key: __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getKey(),
                    name: file.name,
                    loading: true,
                    url: null
                };
            });

            var counterTarget = uploadList.length;
            var counterComplete = 0;

            this.broadcastChange(counterComplete, counterTarget, uploadList);
            this.$emit('startAll', this.returnObject);

            uploadList.forEach(function (upload) {

                var file = upload.file;
                var copy = _this.copyOfUpload(upload);

                _this.$emit('start', copy);

                if (file.size > 7500000) {
                    upload.status = 'Failed';
                    counterComplete += 1;

                    __WEBPACK_IMPORTED_MODULE_4__helpers_AlertHelpers__["a" /* default */].showAlert(file.name + ' is too big (' + parseInt(file.size / 1000000) + 'mb). Max 7mb');
                    upload.loading = false;
                    _this.$emit('finish', _this.copyOfUpload(upload), _this.returnObject);
                    if (counterComplete == counterTarget) {

                        var filesUploaded = uploadList.map(function (o) {
                            return o.name;
                        }).join(', ');
                        var obj = {
                            returnObject: _this.returnObject,
                            files: filesUploaded
                        };
                    }
                } else {

                    var fileReader = new FileReader();
                    fileReader.addEventListener('load', function () {
                        var result = fileReader.result;
                        var filePath = _this.path + '/' + file.name;
                        upload.status = 'Loading';
                        __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].log('Started uploading');

                        Firebase.storage().ref(filePath).put(file).then(function (fileData) {

                            fileData.ref.getDownloadURL().then(function (url) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_Utilities__["a" /* default */].log('Finished uploading');

                                upload.loading = false;
                                upload.url = url;
                                counterComplete += 1;

                                _this.$emit('finish', _this.copyOfUpload(upload), _this.returnObject);
                                if (counterComplete == counterTarget) {
                                    var _filesUploaded = uploadList.map(function (o) {
                                        return o.name;
                                    }).join(', ');
                                    var _obj = {
                                        returnObject: _this.returnObject,
                                        files: _filesUploaded
                                    };
                                    _this.$emit('finishAll', _obj);
                                }
                            });
                        });
                    });

                    fileReader.readAsDataURL(upload.file);
                }
            });
        },
        copyOfUpload: function copyOfUpload(upload) {
            var copy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, upload);
            delete copy['file'];
            return copy;
        },
        broadcastChange: function broadcastChange(completeCount, targetCount, uploads) {
            var message = void 0,
                complete = void 0;
            if (completeCount == targetCount) {
                message = 'Upload complete';
                complete = true;
            } else {
                message = 'Uploading ' + (completeCount + 1) + ' of ' + targetCount;
                complete = false;
            }
            var result = {
                message: message,
                complete: complete,
                uploads: uploads
            };
            this.$emit('change', result);
        }
    }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_database__ = __webpack_require__(21);










/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        multiple: {
            type: Boolean,
            default: true
        }
    },

    computed: {},

    methods: {
        wrapperClicked: function wrapperClicked() {
            this.$emit('click');
        },
        emitChanges: function emitChanges(event) {
            var files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(event.target.files));
            this.$emit('select', files);
            event.target.value = null;
        }
    }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_ContactData__ = __webpack_require__(137);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['contact', 'contacts', 'value', 'role', 'label'],
    data: function data() {
        return {
            localUsers: []
        };
    },

    watch: {},
    computed: {
        users: function users() {
            var users = void 0;
            if (this.contacts) users = this.contacts;else users = this.localUsers;
            return users.sort(function (a, b) {
                return a.firstName > b.firstName;
            });
        },
        image: function image() {
            if (this.value && this.value.image) return this.value.image;else return '';
        }
    },

    methods: {
        selectUser: function selectUser(user) {
            console.log('selectUser in Userchooser', user);
            this.$emit('input', user);
            this.$emit('select', user);
        },
        fullName: function fullName(user) {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_ContactHelpers__["a" /* default */].fullName(user);
        }
    },
    created: function created() {
        var _this = this;

        if (!this.contacts) {
            __WEBPACK_IMPORTED_MODULE_1__data_ContactData__["a" /* default */].fetchContactsForRole(this.role).then(function (contacts) {
                _this.localUsers = contacts.sort(function (a, b) {
                    return a.firstName > b.firstName;
                });
            });
        }
    }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {};
    },


    props: {
        label: String,
        question: String,
        value: String,
        color: String
    },

    computed: {
        extraSmall: function extraSmall() {
            return this.$vuetify.breakpoint.name == 'xs';
        },
        slotClass: function slotClass() {

            var classObj = {
                'yes': this.value == 'Yes',
                'grey-text': !this.color || this.value == 'No',
                'white-text': this.color && this.value == 'Yes'
            };
            classObj[this.color] = Boolean(this.color) && this.value == 'Yes';
            return classObj;
        },
        buttonClass: function buttonClass() {

            var isColoured = Boolean(this.color) && this.value == 'Yes';

            var classObj = {
                'yes': this.value == 'Yes',
                'grey--text': !this.color || this.value == 'No',
                'white--text': this.color && this.value == 'Yes',
                'white': !this.isColoured,
                'no-value': !this.value
            };

            classObj[this.color] = isColoured;

            return classObj;
        }
    },

    methods: {
        buttonClicked: function buttonClicked() {
            var newValue = this.value == 'Yes' ? 'No' : 'Yes';
            this.setValue(newValue);
        },
        setValue: function setValue(newValue) {
            this.$emit('input', newValue);
        }
    }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      videoId: null,
      visible: false,
      resolve: null,
      reject: null,
      options: {
        color: 'primary',
        width: 290,
        zIndex: 200
      }
    };
  },
  methods: {
    open: function open(videoNumber) {
      this.videoId = videoNumber;
      this.visible = true;
    },
    close: function close() {
      this.visible = false;
    },
    ready: function ready(event) {
      this.player = event.target;
    },
    playing: function playing(event) {}
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_fp__ = __webpack_require__(170);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            editing: false,
            newItem: '',
            items: this.list || [],
            lastChange: null,
            columns: 2
        };
    },


    props: {
        list: Array,
        passBack: Object
    },

    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        isCapitalised: function isCapitalised(str) {
            return str === str.toUpperCase();
        },
        showAddItem: function showAddItem() {
            var _this = this;

            this.editing = true;
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
                _this.$refs.addTextbox.focus();
            });
        },
        addItem: function addItem() {
            if (!this.newItem) {
                this.editing = false;
                return;
            }

            this.items.push({
                text: this.newItem,
                status: 'O'
            });
            this.newItem = '';
            this.delayedSave();
        },
        deleteItem: function deleteItem(item) {
            var idx = this.items.indexOf(item);
            this.items.splice(idx, 1);
            this.delayedSave();
        },
        cancelEditing: function cancelEditing() {
            this.editing = false;
            this.newItem = '';
        },
        toggleItem: function toggleItem(item) {
            if (item.status == "C") item.status = 'NA';else if (item.status == 'NA') item.status = "O";else item.status = "C";

            if (this.isCapitalised(item.text)) this.cascadeStatus(item);
            this.delayedSave();
        },
        cascadeStatus: function cascadeStatus(item) {
            if (item.status == 'C') return;

            var idx = this.list.findIndex(function (o) {
                return o.text == item.text;
            });
            for (var n = idx + 1; n < this.list.length; n++) {
                if (this.isCapitalised(this.list[n].text)) break;
                this.list[n].status = item.status;
            }
        },
        delayedSave: function delayedSave() {
            var _this2 = this;

            this.lastChange = new Date();
            setTimeout(function () {
                var seconds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns_fp__["b" /* differenceInSeconds */])(_this2.lastChange, new Date());

                if (seconds >= 3) {
                    var completedItems = _this2.items.filter(function (o) {
                        return o.status != 'O';
                    });
                    var percent = parseInt(completedItems.length / (_this2.items.length || 0.1) * 100);
                    var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ checklist: _this2.items, percent: percent }, _this2.passBack);
                    _this2.$emit('save', result);
                }
            }, 3100);
        }
    }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_responsive_components__ = __webpack_require__(2673);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            contactRowSizes: {
                'row-layout': function rowLayout(el) {
                    return el.width >= 500;
                },
                'card-layout': function cardLayout(el) {
                    return el.width < 500 && el.width >= 400;
                },
                'compact-layout': function compactLayout(el) {
                    return el.width < 400;
                }
            }

        };
    },


    directives: {
        responsive: __WEBPACK_IMPORTED_MODULE_1_vue_responsive_components__["a" /* ResponsiveDirective */]
    },

    components: {},

    props: {
        contact: Object
    },

    computed: {
        attributes: function attributes() {}
    },

    methods: {
        function1: function function1() {}
    },

    created: function created() {}
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_firestore__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_OrderHelpers__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_MergeHelpers__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_CollectionsStore__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Actions__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_AlertHelpers__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_TeamHelpers__ = __webpack_require__(50);
























var _class = function () {
    function _class(path) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, _class);

        if (path.indexOf('/') > -1) this.path = path;else this.collection = path;
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'load',
        value: function load() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                    var teams, promises;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (_this.teams) {
                                        _context.next = 5;
                                        break;
                                    }

                                    _context.next = 3;
                                    return __WEBPACK_IMPORTED_MODULE_21__helpers_TeamHelpers__["a" /* default */].fetchActiveTeams();

                                case 3:
                                    teams = _context.sent;

                                    _this.teams = teams.map(function (team) {
                                        return team._id;
                                    });

                                case 5:
                                    promises = [];

                                    _this.teams.forEach(function (team) {
                                        var ref = __WEBPACK_IMPORTED_MODULE_20__data_Firestore__["a" /* default */].getFirestore().collection('teams/' + team + '/collections/' + _this.collection + '/data');
                                        _this.conditions.forEach(function (condition) {
                                            ref = ref.where(condition.field, condition.operator, condition.value);
                                        });
                                        ref = ref.limit(_this.limit);
                                        var prom = __WEBPACK_IMPORTED_MODULE_20__data_Firestore__["a" /* default */].fetchCollection(ref);
                                        promises.push(prom);
                                    });
                                    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(promises).then(function (results) {
                                        var mergedItems = [];
                                        results.forEach(function (arr) {
                                            mergedItems = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(mergedItems), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(arr)).map(function (item) {
                                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { _collection: _this });
                                            });
                                        });

                                        var sortField = _this.sortField;
                                        if (sortField) mergedItems = mergedItems.sort(function (a, b) {
                                            return __WEBPACK_IMPORTED_MODULE_12__helpers_OrderHelpers__["a" /* default */].sortByField(a, b, sortField);
                                        });
                                        console.log('there are items: ' + mergedItems.length);
                                        _this.data = mergedItems;
                                        _this.status = 'loaded';
                                        resolve(_this.data);
                                    });

                                case 8:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    }, {
        key: 'path',
        get: function get() {
            return this._path;
        },
        set: function set(value) {
            this._path = value;
        }
    }, {
        key: 'teams',
        get: function get() {
            return this._teams;
        },
        set: function set(value) {
            this._teams = value;
        }
    }, {
        key: 'collection',
        get: function get() {
            return this._collection;
        },
        set: function set(value) {
            this._collection = value;
        }
    }, {
        key: 'conditions',
        get: function get() {
            return this._conditions || [];
        },
        set: function set(value) {
            this._conditions = value;
        }
    }, {
        key: 'limit',
        get: function get() {
            return this._limit || 100;
        },
        set: function set(value) {
            this._limit = value;
        }
    }, {
        key: 'sortField',
        get: function get() {
            return this._sortField || 100;
        },
        set: function set(value) {
            this._sortField = value;
        }
    }, {
        key: 'data',
        get: function get() {
            return this._data;
        },
        set: function set(value) {
            this._data = value;
        }
    }]);

    return _class;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (_class);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);







var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'fetchOpenMilestones',
        value: function fetchOpenMilestones(contactKey) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var ref = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getTenantRef().child('milestones');
                __WEBPACK_IMPORTED_MODULE_3__FireData__["a" /* default */].fetchItems(ref).then(function (milestones) {
                    resolve(milestones);
                });
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'addPolicy',
        value: function addPolicy(changes) {
            var fld = changes.field;
            var row = changes.row;
            var col = changes.collection;
            var val = changes.value;
            var pol = void 0,
                rowName = void 0;

            if (fld == 'clients_count') pol = 'Purchase Property';

            if (col == 'existing_properties') {
                rowName = row.description;
                pol = 'Existing Property';
            }

            if (col == 'clients') {
                rowName = row.first_name + ' Income';
                if (fld == 'employment_type') {
                    if (val == 'Permanent Full Time') pol = 'Permanent Full Time';
                    if (val == 'Permanent Part Time') pol = 'Permanent Part Time';
                    if (val == 'Casual') pol = 'Casual Income';
                }
            }

            if (fld == 'purchase_property_exists') pol = 'Purchase Property';
            if (fld == 'construction_exists') pol = 'Construction';

            if (fld == 'family_payments_exists') pol = 'Family Payments';
            if (fld == 'child_support_exists') pol = 'Child Support';
            if (fld == 'government_payments_exists') pol = 'Government Pension';
            if (fld == 'investment_income_exists') pol = 'Investment Income';

            if (col == 'personal_loans') {
                rowName = row.description;
                var intention = row.personal_loan_intention;
                if (intention == 'keep') pol = 'Personal/Car Loans Keeping';else if (intention == 'refinance') pol = 'Personal/Car Loans Refinancing';else if (intention == 'close') pol = 'Personal/Car Loans Closing';
            }

            if (col == 'cards') {
                rowName = row.description;
                var _intention = row.card_intention;
                if (_intention == 'keep') pol = 'Credit Cards Keeping';else if (_intention == 'refinance') pol = 'Credit Cards Refinancing';else if (_intention == 'close') pol = 'Credit Cards Closing';
            }

            if (fld == 'mature') pol = 'Superannuation';
            if (fld == 'bad_credit') pol = 'Adverse Credit';
            if (fld == 'previous_companies') pol = 'Company Not Trading';
            if (fld == 'separating') pol = 'Separation';
            if (fld == 'paying_child_support') pol = 'Paying Child Support';
            if (fld == 'mature') pol = 'Superannuation';

            if (pol) {
                changes.policy = pol;
                console.log('### Policy from getRules is', pol);
            } else console.log('### No pol for changes ', changes);

            if (rowName) changes.rowName = rowName;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'getScenarioSchema',
        value: function getScenarioSchema() {
            return {
                fields: [{
                    name: 'clients',
                    type: 'Group',
                    label: 'Applicants',
                    columns: true,
                    width: '240px',
                    summary: "[$first_name + ' ' + $last_name]",
                    fields: [{
                        type: 'Text',
                        name: 'first_name',
                        label: 'First Name',
                        default: 'Client [n]'
                    }, {
                        type: 'Text',
                        name: 'last_name',
                        label: 'Last Name'
                    }, {
                        type: 'Text',
                        name: 'email',
                        label: 'Email'
                    }]
                }, {
                    name: 'children',
                    type: 'Group',
                    label: 'Children',
                    columns: true,
                    summary: '[$age]',
                    fields: [{
                        type: 'Text',
                        name: 'age',
                        label: 'Age'
                    }]
                }, {
                    name: 'existing_properties',
                    horizontal: true,
                    type: 'Group',
                    label: 'Existing Properties [$brackets($currency($existing_properties_total_property_value))]',

                    summary: "[$address + ' ' + $currency($property_value)]",

                    fields: [{
                        type: 'Text',
                        name: 'address',
                        label: 'Address',
                        default: 'Property [n]',
                        compact: true,
                        width: '300px'
                    }, {
                        name: 'property_value',
                        type: 'Currency',
                        label: 'Value',
                        width: '130px',
                        compact: true
                    }, {
                        name: 'investment_property',
                        type: 'Switch',
                        label: 'Investment',
                        width: '130px',
                        compact: true
                    }, {
                        name: 'rental_income',
                        type: 'Payment',
                        label: 'Ongoing Rent',
                        width: '130px',
                        defaultFrequency: 'pw',
                        visible: "[$investment_property && $property_intention != 'selling']"
                    }, {
                        name: 'mortgage_heading',
                        type: 'Section',
                        label: 'Mortgage',
                        horizontal: true,
                        width: '100%',
                        fields: [{
                            name: 'lender',
                            type: 'Text',
                            label: 'Lender',
                            width: '200px'
                        }, {
                            name: 'owing',
                            type: 'Currency',
                            label: 'Owing',
                            width: '130px'
                        }, {
                            name: 'mortgage_payment',
                            type: 'Payment',
                            label: 'Repayment',
                            width: '130px'
                        }],
                        visible: "[$property_intention != 'unencumbered']"

                    }, {
                        name: 'property_intention',
                        type: 'DropdownLabel',
                        label: 'Intention',

                        items: [{ value: 'refinance', text: 'Keeping, Refinance' }, { value: 'keep', text: 'Keeping, No Change' }, { value: 'selling', text: 'Selling' }, { value: 'unencumbered', text: 'No Mortgage' }]
                    }]
                }, {
                    name: 'loan_purpose_section',
                    type: 'Section',
                    label: "Loan Purpose [$brackets($currency($loan_purpose_section_total_currency))]",
                    summary: '[$true_labels]',
                    fields: [{
                        name: 'purchase_property',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Purchase Property'
                    }, {
                        name: 'refinance_property',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Refinance Property'
                    }, {
                        name: 'debt_consolidation',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Debt Consolidation'
                    }, {
                        name: 'cash_out',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Other Cash Out'
                    }, {
                        name: 'cash_out_reason',
                        type: 'Text',
                        label: 'Reason for Cash',
                        visible: '[$cash_out_exists]'
                    }]
                }, {
                    name: 'purchase_details_section',
                    type: 'Section',
                    label: 'About your purchase [$brackets($currency($purchase_details_section_total_currency))]',
                    visible: "[$purchase_property_exists]",
                    summary: '[$true_labels]',

                    fields: [{
                        name: 'owner_occupied_property',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Owner Occupied'
                    }, {
                        name: 'investment_property',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Investment Property'
                    }, {
                        name: 'land_property',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Buying Land'
                    }, {
                        name: 'construction',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Construction'
                    }, {
                        name: 'found_property',
                        type: 'Radio',
                        label: 'Have you found a property',
                        items: [{ text: 'Yes' }, { text: 'No - Preapproval Only', value: 'No' }]
                    }]

                }, {
                    name: 'deposit_section',
                    type: 'Section',
                    label: 'Where is your deposit coming from? [$brackets($currency($deposit_section_total_currency))]',
                    visible: "[$purchase_property_exists]",
                    summary: '[$true_labels]',

                    fields: [{
                        name: 'genuine_savings',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Genuine Savings',
                        visible: "[$existing_properties_count == 0]"
                    }, {
                        name: 'government_grant',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Grant',
                        visible: "[$existing_properties_count == 0]"
                    }, {
                        name: 'property_equity',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Equity in existing property',
                        visible: "[$existing_properties_count > 0]"
                    }, {
                        name: 'gifted_funds',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Gifted Funds'
                    }, {
                        name: 'other_funds',
                        type: 'SwitchHeading',
                        inputType: 'Currency',
                        label: 'Other Funds (not saved)'
                    }, {
                        type: 'Checkbox',
                        label: 'Guarantor',
                        name: 'guarantor_exists',
                        visible: "[$existing_properties_count == 0]"
                    }]
                }, {
                    name: 'clients',
                    type: 'Group',
                    label: 'Incomes',
                    columns: true,
                    width: '240px',
                    hideButtons: true,
                    visible: "[$clients.length > 0]",
                    fields: [{
                        type: 'SectionHeading',
                        label: "[$first_name || 'Income']"
                    }, {
                        type: 'Currency',
                        name: 'work_income',
                        label: 'Job Income'
                    }, {
                        type: 'Radio',
                        name: 'employment_type',
                        label: 'EmploymentType',
                        items: [{ text: 'Permanent Full Time' }, { text: 'Permanent Part Time' }, { text: 'Casual' }]
                    }, {
                        visible: "[$employment_type.startsWith('Permanent')]",
                        name: 'overtime_exists',
                        label: 'Receive Overtime/Allowances',
                        type: 'Checkbox'
                    }, {
                        visible: "[$employment_type.startsWith('Permanent')]",
                        name: 'bonuses_exists',
                        label: 'Receive Bonuses',
                        type: 'Checkbox'
                    }, {
                        visible: "[$employment_type.startsWith('Permanent')]",
                        name: 'salary_sacrifice',
                        label: 'Salary Sacrifice',
                        type: 'Checkbox'
                    }, {
                        visible: "[$employment_type.startsWith('Permanent')]",
                        name: 'company_car',
                        label: 'Company Car',
                        type: 'Checkbox'
                    }, {
                        name: 'self_employed',
                        label: 'Self Employed Income',
                        type: 'Checkbox'
                    }, {
                        name: 'net_se_income',
                        label: 'Net after expenses',
                        type: 'Currency',
                        visible: "[$self_employed]"
                    }, {
                        visible: "[$self_employed]",
                        name: 'sole_trader',
                        label: 'Sole Trader',
                        type: 'Checkbox'
                    }, {
                        visible: "[$self_employed]",

                        name: 'se_company',
                        label: 'Company',
                        type: 'Checkbox'
                    }, {
                        visible: "[$self_employed]",
                        name: 'se_trust',
                        label: 'Trust',
                        type: 'Checkbox'
                    }]
                }, {
                    name: 'extra_income_section',
                    type: 'Section',
                    label: 'Do you have any additional income?',
                    summary: '[$true_labels]',

                    fields: [{
                        name: 'family_payments',
                        type: 'SwitchHeading',
                        inputType: 'Payment',
                        defaultFrequency: 'pf',
                        label: 'Family Payments',
                        visible: "[$children]"
                    }, {
                        name: 'child_support',
                        type: 'SwitchHeading',
                        inputType: 'Payment',
                        defaultFrequency: 'pm',
                        label: 'Child Support',
                        visible: "[$children]"
                    }, {
                        name: 'government_payments',
                        type: 'SwitchHeading',
                        inputType: 'Payment',
                        defaultFrequency: 'pf',
                        label: 'Government Payments',
                        title: 'Government'
                    }, {
                        name: 'rental_income_estimate',
                        type: 'SwitchHeading',
                        inputType: 'Payment',
                        defaultFrequency: 'pw',
                        label: 'Rental Income',
                        title: 'Rent'
                    }, {
                        name: 'investment_income',
                        type: 'SwitchHeading',
                        inputType: 'Payment',
                        defaultFrequency: 'pa',
                        label: 'Investment Income',
                        title: 'Investments'
                    }, {
                        visible: "[$investment_income_exists]",
                        name: 'investment_income_details',
                        type: 'Text',
                        label: 'Investment Income Details'
                    }]
                }, {
                    horizontal: true,
                    type: 'group',
                    name: 'personal_loans',
                    label: 'Personal/Car Loans [$brackets($currency($personal_loans_total_payment), " pm")]',
                    summary: '[$description]',
                    fields: [{
                        type: 'Text',
                        name: 'description',
                        label: 'Description',
                        default: 'Loan [n]'
                    }, {
                        name: 'payment',
                        type: 'Payment',
                        label: 'Payment',
                        defaultFrequency: 'pm',
                        width: '130px',
                        total: ['total']
                    }, {
                        name: 'balance',
                        type: 'Currency',
                        label: 'Balance Owing',
                        width: '130px'
                    }, {
                        name: 'personal_loan_intention',
                        type: 'DropdownLabel',
                        label: 'Intention',
                        items: [{ value: 'keep', text: 'Keeping, No Change' }, { value: 'refinance', text: 'Close with Loan Funds' }, { value: 'close', text: 'Close with Own Funds' }],
                        default: 'keep'
                    }]
                }, {
                    horizontal: true,
                    type: 'group',
                    name: 'cards',
                    label: 'Credit/Store Cards [$brackets($currency($cards_total_card_limit), " lmt")]',
                    summary: "[$description + ' ' + $currency($card_limit)]",
                    fields: [{
                        default: 'Credit Card [n]',
                        name: 'description',
                        type: 'Text',
                        label: 'Description'
                    }, {
                        name: 'card_limit',
                        type: 'Currency',
                        label: 'Card Limit',
                        width: '130px'
                    }, {
                        name: 'card_intention',
                        type: 'DropdownLabel',
                        label: 'Intention',
                        items: [{ value: 'keep', text: 'Keeping, No Change' }, { value: 'refinance', text: 'Close with Loan Funds' }, { value: 'close', text: 'Close with Own Funds' }],
                        default: 'keep'
                    }]
                }, {
                    name: 'special_circumstances',
                    type: 'Section',
                    label: 'More Specifics',
                    summary: '[$true_labels]',
                    fields: [{
                        name: 'mature',
                        type: 'Checkbox',
                        title: 'Over 45',
                        label: 'Over 45 years old'
                    }, {
                        name: 'bad_credit',
                        type: 'Checkbox',
                        title: 'Bad Credit',
                        label: 'Credit defaults, late payments or similar'
                    }, {
                        name: 'previous_companies',
                        type: 'Checkbox',
                        title: 'Prev Companies',
                        label: 'Previous companies or trusts no longer used'
                    }, {
                        name: 'relationship_section',
                        type: 'SectionHeading',
                        label: 'Relationships'
                    }, {
                        name: 'separating',
                        type: 'Checkbox',
                        title: 'Separating',
                        label: 'Separating from partner'
                    }, {
                        name: 'paying_child_support',
                        type: 'Checkbox',
                        title: 'CSA',
                        label: 'Paying child support'
                    }, {
                        name: 'paying_commitments',
                        type: 'Checkbox',
                        title: 'Partner debts',
                        label: 'Partner has debts, cards, child support or commitments not listed here'
                    }]
                }]
            };
        }
    }, {
        key: 'getTestSchema',
        value: function getTestSchema() {
            return {
                fields: [{
                    type: 'Text',
                    name: 'first_name',
                    label: 'First Name'
                }, {
                    type: 'Text',
                    name: 'last_name',
                    label: 'Last Name'
                }, {
                    type: 'Text',
                    name: 'email',
                    label: 'Email'
                }, {
                    type: 'Checkbox',
                    name: 'friends',
                    label: 'Has Friends'
                }, {
                    type: 'Currency',
                    name: 'spend',
                    label: 'Monthly Spend'
                }, {
                    type: 'File',
                    name: 'contract',
                    label: 'Contract Doc'
                }, {
                    type: 'Html',
                    name: 'signature',
                    label: 'Signature'
                }, {
                    type: 'Payment',
                    name: 'payment',
                    label: 'Payment'
                }, {
                    type: 'Number',
                    name: 'count',
                    label: 'Count of People'
                }, {
                    type: 'Link',
                    name: 'address',
                    label: 'Web Address'
                }, {
                    type: 'Switch',
                    name: 'fast',
                    label: 'Fast Mode'
                }, {
                    type: 'SectionHeading',
                    name: '',
                    label: 'Better Stuff'
                }, {
                    type: 'Radio',
                    items: [{ text: 'One', value: '1' }, { text: 'Two', value: '2' }],
                    name: 'favouriteNumber',
                    label: 'Favourite Number'
                }, {
                    type: 'Group',
                    name: 'ages',
                    label: 'Ages',
                    fields: [{
                        type: 'Text',
                        name: 'age',
                        label: 'Age'
                    }]
                }]
            };
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_Store__ = __webpack_require__(31);






var CodeHelpers = function () {
    function CodeHelpers() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CodeHelpers);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CodeHelpers, null, [{
        key: 'run_copy_element_attribute',
        value: function run_copy_element_attribute() {
            console.log('copying attribute...');
        }
    }]);

    return CodeHelpers;
}();

/* harmony default export */ __webpack_exports__["a"] = (CodeHelpers);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var DynamicControlHelpers = function () {
    function DynamicControlHelpers() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DynamicControlHelpers);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DynamicControlHelpers, null, [{
        key: 'dynamicControlTypes',
        value: function dynamicControlTypes() {
            var types = [{ value: 'tf', text: 'Text Field', control: 'v-text-field' }, { value: 'ta', text: 'Text Area', control: 'v-textarea' }, { value: 'ls', text: 'Dropdown List', control: 'v-select' }];

            return types;
        }
    }]);

    return DynamicControlHelpers;
}();

/* harmony default export */ __webpack_exports__["a"] = (DynamicControlHelpers);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_LookupData__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_Firestore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utilities__ = __webpack_require__(6);











var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'randomInt',
        value: function randomInt(digits) {
            var str = '';
            for (var n = 0; n < digits; n++) {
                str += __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__["a" /* default */].randomInt(9).toString();
            }
            return str;
        }
    }, {
        key: 'fakeContacts',
        value: function fakeContacts(count) {

            var contacts = [];

            for (var n = 0; n < count; n++) {
                var contact = {
                    _id: __WEBPACK_IMPORTED_MODULE_8__data_Firestore__["a" /* default */].getId(),
                    image: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].faker().image.avatar(),
                    firstName: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].faker().name.firstName(),
                    lastName: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].faker().name.lastName(),
                    mobile: this.randomMobile(),
                    tags: {}
                };

                contact.email = this.fakeEmail(contact.firstName, contact.lastName);

                contacts.push(contact);
            }
            return contacts;
        }
    }, {
        key: 'fakeGroups',
        value: function fakeGroups(contacts) {
            var _this = this;

            contacts.forEach(function (contact) {
                for (var p = 0; p < __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__["a" /* default */].randomInt(4); p++) {
                    var group = __WEBPACK_IMPORTED_MODULE_6__helpers_StringHelpers__["a" /* default */].toCamelCase(__WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__["a" /* default */].randomFromArray(_this.groups).name);
                    contact.tags[group] = true;
                }
            });
        }
    }, {
        key: 'fakeRelationships',
        value: function fakeRelationships(contacts) {

            var relationships = [];

            contacts.forEach(function (contact) {
                var hasPartner = __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__["a" /* default */].randomInt(5) == 1;

                if (hasPartner) {
                    var availableContacts = contacts.filter(function (contact) {
                        return !contact.hasPartner;
                    });
                    var partner = __WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__["a" /* default */].randomFromArray(availableContacts);

                    __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].relateContacts(contact, 'Partner', partner, 'Partner', relationships);
                }

                var relationshipNames = __WEBPACK_IMPORTED_MODULE_5__helpers_LookupData__["a" /* default */].relationships().filter(function (o) {
                    return o.text != 'Partner';
                });

                if (contacts.length > 5) {
                    for (var p = 1; p < __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__["a" /* default */].randomInt(2); p++) {
                        var related = __WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__["a" /* default */].randomFromArray(contacts);
                        var relation = __WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__["a" /* default */].randomFromArray(relationshipNames);
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ContactHelpers__["a" /* default */].relateContacts(contact, relation.text, related, relation.relatedText, relationships);
                    }
                }
            });

            return relationships;
        }
    }, {
        key: 'randomMobile',
        value: function randomMobile() {
            return '04' + this.randomInt(2) + ' ' + this.randomInt(3) + ' ' + this.randomInt(3);
        }
    }, {
        key: 'fakeEmail',
        value: function fakeEmail(firstName, lastName) {
            var domains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'bigpond.net.au', 'outlook.com'];
            var domain = __WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__["a" /* default */].randomFromArray(domains);
            var joinString = __WEBPACK_IMPORTED_MODULE_7__helpers_ArrayHelpers__["a" /* default */].randomFromArray(['', '_', '.', '', '.']);
            var r1 = __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__["a" /* default */].randomInt(3);
            var r2 = __WEBPACK_IMPORTED_MODULE_3__helpers_NumberHelpers__["a" /* default */].randomInt(3);

            var n1 = (r1 < 3 ? firstName : firstName[0]).toLowerCase();
            var n2 = (r2 < 3 ? lastName : lastName[0]).toLowerCase();

            return n1 + joinString + n2 + '@' + domain;
        }
    }]);

    return _class;
}();

_class.groups = [{ name: 'Clients', colour: '#31B404', members: 983 }, { name: 'First Home Buyers', members: 14 }, { name: 'Investors', colour: '#FE2E9A', members: 87 }, { name: 'Marketing #4', colour: '#31B404', members: 44 }, { name: 'Builders', members: 13, colour: '#AC58FA' }, { name: 'Agents', colour: '#0080FF', members: 20 }];
/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);




var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'toggleSelection',
        value: function toggleSelection(item) {
            if (this.isSelected(item)) {
                this.unselect(item);
            } else this.select(item);
        }
    }, {
        key: 'getSelectedItems',
        value: function getSelectedItems(arr) {
            return arr.filter(function (item) {
                return item._selected;
            });
        }
    }, {
        key: 'selectOne',
        value: function selectOne(item, arr) {
            this.unselectAll(arr);
            this.select(item);
        }
    }, {
        key: 'unselectAll',
        value: function unselectAll(arr) {
            var _this = this;

            arr.forEach(function (item) {
                _this.unselect(item);
            });
        }
    }, {
        key: 'select',
        value: function select(item) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(item, '_selected', true);
        }
    }, {
        key: 'unselect',
        value: function unselect(item) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(item, '_selected');
        }
    }, {
        key: 'isSelected',
        value: function isSelected(item) {
            return Boolean(item._selected);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementHelpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataHelpers__ = __webpack_require__(3);






var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: "transferClientsFromTransaction",
        value: function transferClientsFromTransaction(transactionKey) {
            __WEBPACK_IMPORTED_MODULE_3__ElementHelpers__["a" /* default */].fetchContactsForRole(transactionKey, 'Client').then(function (contacts) {
                var msRef = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getTenantRef().child('milestones').child(transactionKey);
                contacts.forEach(function (contact) {
                    var contactRef = msRef.child('clients').child(contact.key);
                    var newContact = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contact);
                    delete newContact.key;
                    delete newContact.role;
                    contactRef.set(newContact);
                });
            });
        }
    }, {
        key: "transferBrokerAndProcessor",
        value: function transferBrokerAndProcessor(transactionKey) {
            var msRef = __WEBPACK_IMPORTED_MODULE_4__DataHelpers__["a" /* default */].getTenantRef().child('milestones').child(transactionKey);
            __WEBPACK_IMPORTED_MODULE_3__ElementHelpers__["a" /* default */].fetchContactsForRole(transactionKey, 'Broker').then(function (contacts) {
                if (contacts && contacts.length) {
                    var brokerRef = msRef.child('broker');
                    var broker = contacts[0];
                    var newContact = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, broker);
                    delete newContact.role;
                    brokerRef.set(newContact);
                }
            });
            __WEBPACK_IMPORTED_MODULE_3__ElementHelpers__["a" /* default */].fetchContactsForRole(transactionKey, 'Processor').then(function (contacts) {
                if (contacts && contacts.length) {
                    var processorRef = msRef.child('processor');
                    var processor = contacts[0];
                    var newContact = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, processor);
                    delete newContact.role;
                    processorRef.set(newContact);
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StringHelpers__ = __webpack_require__(5);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'initialiseObj',
        value: function initialiseObj(obj) {
            if (!obj.text) obj.text = '';
            if (!obj.html) obj.html = '';
            return obj;
        }
    }, {
        key: 'append',
        value: function append() {
            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var str = arguments[1];
            var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            obj = this.initialiseObj(obj);

            var text = str;
            var html = str;

            if (attributes.bold && attributes.underline) {
                text = '###### ' + text + ' ######';
                html = '<b><u>' + html + '</u></b>';
            } else {
                if (attributes.bold) {
                    text = '*** ' + text + ' ***';
                    html = '<b>' + html + '</b>';
                }
                if (attributes.underline) {
                    text = '--- ' + text + ' ---';
                    html = '<u>' + html + '</u>';
                }
            }

            if (attributes.newline) {
                text = text + '\n';
                html = html + '<br/>';
            }

            obj.text += text;
            obj.html += html;
            return obj;
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StringHelpers__ = __webpack_require__(5);








var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'tagsToString',
        value: function tagsToString(tagsObj) {
            return this.tagsToArray(tagsObj).join(', ');
        }
    }, {
        key: 'tagsToArray',
        value: function tagsToArray(tagsObj) {
            var tagsArr = [];
            for (var prop in tagsObj) {
                tagsArr.push(__WEBPACK_IMPORTED_MODULE_5__StringHelpers__["a" /* default */].camelToNormal(prop));
            }
            return tagsArr;
        }
    }, {
        key: 'addTag',
        value: function addTag(tagObj, name) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var tagName = __WEBPACK_IMPORTED_MODULE_5__StringHelpers__["a" /* default */].toCamelCase(name);

            var updateCount = tagObj[tagName] ? 0 : 1;

            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(tagObj, tagName, true);

            return updateCount;
        }
    }, {
        key: 'addTagToItems',
        value: function addTagToItems(tagItem, items) {
            var _this = this;

            var result = { added: 0, existed: 0 };
            items.forEach(function (item) {
                if (_this.addTag(item.tags, tagItem.name)) result.added += 1;else result.existed += 1;
            });
            result.message = (result.added ? result.added.toString() + ' members added. ' : '') + (result.existed ? result.existed.toString() + ' already existed.' : '');

            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(tagItem, 'members', (tagItem.members || 0) + result.added);

            return result;
        }
    }, {
        key: 'removeTag',
        value: function removeTag(tagObj, name) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var tagName = __WEBPACK_IMPORTED_MODULE_5__StringHelpers__["a" /* default */].toCamelCase(name);

            var updateCount = tagObj.hasOwnProperty(tagName) ? 1 : 0;

            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].delete(tagObj, tagName);

            return updateCount;
        }
    }, {
        key: 'removeTagFromItems',
        value: function removeTagFromItems(tagItem, items) {
            var _this2 = this;

            var result = { removed: 0, omitted: 0 };
            items.forEach(function (item) {
                if (_this2.removeTag(item.tags, tagItem.name)) result.removed += 1;else result.omitted += 1;
            });
            result.message = (result.removed ? result.removed.toString() + ' members removed. ' : '') + (result.omitted ? result.omitted.toString() + ' omitted.' : '');

            var newMemberCount = tagItem.members - result.removed;
            if (newMemberCount < 1) newMemberCount = 0;

            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(tagItem, 'members', newMemberCount);

            return result;
        }
    }, {
        key: 'tagExists',
        value: function tagExists(tagObj, name) {
            var tagName = __WEBPACK_IMPORTED_MODULE_5__StringHelpers__["a" /* default */].toCamelCase(name);
            if (!tagObj) return false;
            return !!tagObj[tagName];
        }
    }, {
        key: 'tagDate',
        value: function tagDate(tagObj, name) {
            var tagName = __WEBPACK_IMPORTED_MODULE_5__StringHelpers__["a" /* default */].toCamelCase(name) + 'Date';

            if (!tagObj) return null;
            return tagObj[tagName] || null;
        }
    }, {
        key: 'tagUser',
        value: function tagUser(tagObj, name) {
            var tagName = __WEBPACK_IMPORTED_MODULE_5__StringHelpers__["a" /* default */].toCamelCase(name) + 'User';

            if (!tagObj) return null;
            return tagObj[tagName] || null;
        }
    }, {
        key: 'itemsWithTag',
        value: function itemsWithTag(arr, tagName) {
            return arr.filter(function (o) {
                return o.tags && o.tags[tagName];
            });
        }
    }, {
        key: 'itemsWithoutTag',
        value: function itemsWithoutTag(arr, tagName) {
            return arr.filter(function (o) {
                return !o.tags || !o.tags[tagName];
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_Store__ = __webpack_require__(31);







var UserHelpers = function () {
    function UserHelpers() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserHelpers);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserHelpers, null, [{
        key: 'officesList',
        value: function officesList() {
            var offices = [];
            var userKey = __WEBPACK_IMPORTED_MODULE_5__store_Store__["a" /* default */].getters.uid;
            if (userKey) {
                var ref = __WEBPACK_IMPORTED_MODULE_2__DataHelpers__["a" /* default */].getRootRef().child('users').child(userKey).child('offices');
                console.log('UserHelpers > officesList > Ref', ref.toString());
                ref.on('value', function (snap) {
                    offices = __WEBPACK_IMPORTED_MODULE_3__FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                });
            }
            return offices;
        }
    }]);

    return UserHelpers;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (UserHelpers);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_Store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase_database__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuefire__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portal_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_html5_editor__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_html5_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_html5_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_croppa__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_croppa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_async_computed__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_textarea_autosize__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_NumberHelpers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_google_charts__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ckeditor_ckeditor5_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ckeditor_ckeditor5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__ckeditor_ckeditor5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__forms_FormBlock__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__forms_FormBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__forms_FormBlock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__forms_ControlList__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__forms_ControlList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__forms_ControlList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__forms_DynamicControl__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__forms_DynamicControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__forms_DynamicControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__builder_InterfaceField__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__builder_InterfaceField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__builder_InterfaceField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__flow_Flow__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__flow_Flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__flow_Flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__screens_ElementControl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__screens_ElementControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__screens_ElementControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_LayoutPanel__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ui_elements_LayoutPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ui_elements_LayoutPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify__);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuefire___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_portal_vue___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_html5_editor___default.a, { hiddenModules: ['info', 'hr', 'undo', 'font', 'align', 'unlink'] });





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_croppa___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_youtube_embed__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_async_computed__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_textarea_autosize__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_google_charts__["default"]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__ckeditor_ckeditor5_vue___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(432), { locale: 'en_AU' });


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('FormBlock', __WEBPACK_IMPORTED_MODULE_22__forms_FormBlock___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ControlList', __WEBPACK_IMPORTED_MODULE_23__forms_ControlList___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('DynamicControl', __WEBPACK_IMPORTED_MODULE_24__forms_DynamicControl___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('InterfaceField', __WEBPACK_IMPORTED_MODULE_25__builder_InterfaceField___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('Flow', __WEBPACK_IMPORTED_MODULE_26__flow_Flow___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ElementControl', __WEBPACK_IMPORTED_MODULE_27__screens_ElementControl___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('LayoutPanel', __WEBPACK_IMPORTED_MODULE_28__ui_elements_LayoutPanel___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('showButKeepInner', {
    bind: function bind(el, bindings) {
        debugger;
        bindings.def.wrap = function (el) {
            while (el.nextElementSibling && el.nextElementSibling.dataset.moved) {
                el.appendChild(el.nextElementSibling).removeAttribute('data-moved');
            }
            el.hidden = false;
        };

        bindings.def.unwrap = function (el) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(el.children).forEach(function (child) {
                el.insertAdjacentElement('afterend', child).setAttribute('data-moved', true);
            });
            el.hidden = true;
        };
    },
    inserted: function inserted(el, bindings) {
        debugger;
        bindings.def[bindings.value ? 'wrap' : 'unwrap'](el);
    },
    update: function update(el, bindings) {
        bindings.def[bindings.value ? 'wrap' : 'unwrap'](el);
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('longDate', function (value) {
    if (value) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(__WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].backwardsToDate(value), 'dd MMMM yy');else return '';
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('dueString', function (dateString) {
    if (!dateString) return '';
    var date = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].backwardsToDate(dateString);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["b" /* isValid */])(date)) return '';
    return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].dueString(date);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('shortDate', function (dateString) {
    if (!dateString) return '';
    var date = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].toDate(dateString);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(date, 'd/M');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('date', function (dateString) {
    if (!dateString || dateString === true) return '';

    var date = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].toDate(dateString);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(date, 'dd/MM/yy');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('time', function (dateString) {
    if (!dateString) return '';

    var date = __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].toDate(dateString);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_date_fns__["a" /* format */])(date, 'dd/MM/yy hh:mma').toLowerCase();
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('fromNow', function (date) {
    return __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].fromNow(date);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('tag', function (str) {
    return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].restoreSpaces(str);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('timeAgo', function (date) {
    return __WEBPACK_IMPORTED_MODULE_29__helpers_DateHelpers__["a" /* default */].timeAgo(date);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('fullName', function (contact) {
    return __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].fullName(contact);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('phoneNumbers', function (contact) {
    return __WEBPACK_IMPORTED_MODULE_13__helpers_ContactHelpers__["a" /* default */].phoneNumbers(contact);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('phone', function (str) {
    return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].formatPhone(str);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('number', function (value) {
    return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].formatNumber(value);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('stamp', function (value) {
    return __WEBPACK_IMPORTED_MODULE_19__helpers_DataHelpers__["a" /* default */].formatStamp(value);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('space', function (value) {
    value = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].camelToNormal(value);
    value = __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].snakeToNormal(value);
    return value;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('thousands', function (value) {
    return __WEBPACK_IMPORTED_MODULE_18__helpers_NumberHelpers__["a" /* default */].abbreviateNumber(value);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('currency', function (value) {
    return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].formatCurrency(value);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('cents', function (value) {
    return __WEBPACK_IMPORTED_MODULE_12__helpers_StringHelpers__["a" /* default */].formatCurrencyWithCents(value);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_vuetify___default.a);

var vuetify = new __WEBPACK_IMPORTED_MODULE_30_vuetify___default.a();

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
    template: '<App/>',
    store: __WEBPACK_IMPORTED_MODULE_5__store_Store__["a" /* default */],
    vuetify: vuetify,
    components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var state = {
    alert: {
        visible: false,
        text: ''
    }
};

var getters = {

    alert: function alert(state) {
        return state.alert;
    }

};

var actions = {
    showAlert: function showAlert(context, alert) {
        console.log('AlertsStore > showAlert');
        context.commit('alert', alert);
    },
    clearAlert: function clearAlert(context) {
        console.log('AlertsStore > clearAlert');
        context.commit('alert', { visible: false, text: '' });
    }
};

var mutations = {
    alert: function alert(state, _alert) {
        state.alert = _alert;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(43);


var db = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* default */].database();

var state = {
    clipboard: {
        element: null,
        elements: null,
        action: null
    }
};

var getters = {

    clipboard: function clipboard(state) {
        return state.clipboard;
    }
};

var actions = {};

var mutations = {
    clipboard: function clipboard(state, _clipboard) {
        state.clipboard = _clipboard;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_FireData__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_util__);









var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].database();

var state = {
    recentContacts: [],
    recentContactsForUser: [],

    searchContacts1: [],
    searchContacts2: [],
    searchTerm: '',
    shallowSearch: false
};

var getters = {
    getRecentContactsForUser: function getRecentContactsForUser(state) {
        return state.recentContactsForUser;
    },
    getExpandedRecentContacts: function getExpandedRecentContacts(state) {
        var arr = [];
        state.recentContactsForUser.forEach(function (item) {
            var ref = db.ref('tenants').child(item.tenantKey).child('contacts').child(item.key);
            ref.on('value', function (snap) {
                arr.push(__WEBPACK_IMPORTED_MODULE_3__data_FireData__["a" /* default */].snapToObj(snap));
            });
        });
        return arr;
    },


    shallowSearch: function shallowSearch(state) {
        return state.shallowSearch;
    },

    searchTerm: function searchTerm(state) {
        return state.searchTerm;
    },

    recentContacts: function recentContacts(state) {
        return state.recentContacts;
    },
    searchResults: function searchResults(state) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.searchContacts1, state.searchContacts2);
    },
    contacts: function contacts(state, getters) {
        var searchTerm = getters.searchTerm;
        console.log('ContactsStore > contacts > searchTerm', searchTerm);
        var names = __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].searchNames(searchTerm);

        var searchContacts = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].unionByKey(state.searchContacts1, state.searchContacts2);
        var combinedContacts = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].unionByKey(state.recentContacts, searchContacts);

        return combinedContacts.filter(function (o) {
            if (!o.firstName || !o.lastName) return true;

            if (o.firstName.startsWith(names.primaryName) && o.lastName.startsWith(names.secondaryName)) return true;

            if (o.lastName.startsWith(names.primaryName) && o.firstName.startsWith(names.secondaryName)) return true;

            return false;
        }).slice(0, 20);
    }
};

var actions = {
    loadContactsToArray: function loadContactsToArray(context, payload) {

        if (__WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].isMobileSearch(payload.search)) {
            var mobRef = db.ref('tenants/' + context.getters.tenantKey + '/contacts').orderByChild('mobileSearch').equalTo(payload.search).limitToLast(20);
            mobRef.on('value', function (snap) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotPushArray(snap, payload.contacts);
                console.log('found by mobile', payload.contacts);
            });
            return;
        }

        var names = __WEBPACK_IMPORTED_MODULE_5__helpers_ContactHelpers__["a" /* default */].searchNames(payload.search);
        var primaryName = names.primaryName;

        console.log('store > loadContactsToArray', primaryName);

        var ref1 = db.ref('tenants/' + context.getters.tenantKey + '/contacts').orderByChild('firstName').startAt(primaryName).endAt(primaryName + '\uF8FF').limitToLast(20);
        ref1.on('value', function (snap) {
            console.log('store > loadContactsToArray > snap1', snap.val());
            __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotPushArray(snap, payload.contacts);

            var ref2 = db.ref('tenants/' + context.getters.tenantKey + '/contacts').orderByChild('lastName').startAt(primaryName).endAt(primaryName + '\uF8FF').limitToLast(20);
            ref2.on('value', function (snap) {
                console.log('store > loadContactsToArray > snap2', snap.val());
                __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotPushArray(snap, payload.contacts);
            });
        });

        console.log('store > loadContactsToArray', payload);
    },
    loadRecentContacts: function loadRecentContacts(context) {
        if (!context.getters.status('recentContacts')) {
            context.commit('status', {
                name: 'recentContacts',
                status: 'Loading'
            });

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/contacts').orderByChild('user').equalTo(null).limitToLast(10);
            ref.on('value', function (snap) {
                var items = __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap, true);
                context.commit('recentContacts', items);
                context.commit('status', {
                    name: 'recentContacts',
                    status: 'Loaded'
                });
            });

            setTimeout(function () {
                ref = db.ref('tenants/' + context.getters.tenantKey + '/contacts').orderByChild('user').equalTo(null).limitToLast(100);
                ref.on('value', function (snap) {
                    var items = __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap, true);
                    context.commit('recentContacts', items);
                });
            }, 2000);
        }
    }
};

var mutations = {
    addRecentContactForUser: function addRecentContactForUser(state, recent) {
        console.log('ContactsStore > addRecentContactForUser');
        __WEBPACK_IMPORTED_MODULE_6__helpers_ListHelpers__["a" /* default */].delete(recent, state.recentContactsForUser);
        state.recentContactsForUser.unshift(recent);
        if (state.recentContactsForUser.length > 10) state.recentContactsForUser.pop();
    },
    setRecentContactsForUser: function setRecentContactsForUser(state, recents) {
        state.recentContactsForUser = recents;
    },
    shallowSearch: function shallowSearch(state, value) {
        state.shallowSearch = value;
    },
    searchTerm: function searchTerm(state, _searchTerm) {
        state.searchTerm = _searchTerm;
    },
    recentContacts: function recentContacts(state, _recentContacts) {
        state.recentContacts = _recentContacts;
    },
    searchContacts1: function searchContacts1(state, results) {
        state.searchContacts1 = results;
    },
    searchContacts2: function searchContacts2(state, results) {
        state.searchContacts2 = results;
    },
    clearSearchContacts: function clearSearchContacts(state) {
        state.searchContacts1 = [];
        state.searchContacts2 = [];
    },
    searchResults: function searchResults(state, results) {
        state.searchResults = results;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__ = __webpack_require__(58);






var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].database();

var state = {
    groups: []
};

var getters = {

    groups: function groups(state) {
        return state.groups;
    }

};

var actions = {
    fetchAllGroups: function fetchAllGroups(context) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (context.getters.groups.length) {
                resolve(context.getters.groups);
                return;
            }

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/groups');
            ref.on('value', function (snap) {
                console.log('store > fetchAllgroups (first load)');
                var groups = [];
                snap.forEach(function (item) {
                    var group = {
                        key: item.key,
                        name: item.val().name,
                        role: item.val().role,
                        stamp: item.val().stamp
                    };
                    groups.push(group);
                });
                groups = groups.sort(function (a, b) {
                    return a.name > b.name;
                });
                context.commit('groups', groups);
                resolve(groups);
            });
        });
    }
};

var mutations = {
    groups: function groups(state, _groups) {
        state.groups = _groups;
    },
    deleteGroup: function deleteGroup(state, group) {
        __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__["a" /* default */].delete(group, state.groups);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_NiceData__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_util__);










var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].database();

var state = {
    tasks: [],
    selectedTask: null
};

var getters = {
    tasks: function tasks(state) {
        return state.tasks;
    },
    selectedTask: function selectedTask(state) {
        return state.selectedTask;
    }
};

var actions = {
    loadTasks: function loadTasks(context) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/tasks');
            var transactionKey = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTransactionKey();

            ref.orderByChild('transactionKey').equalTo(transactionKey).on('value', function (snap) {
                __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].log('store > loadTasks (first load)');
                var tasks = __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                context.commit('setTasks', tasks);
                resolve('loaded');
            });
        });
    },
    selectTask: function selectTask(context, obj) {
        context.commit('setSelectedTask', obj);
        context.commit('allCommentsMode', false);
    },
    saveTask: function saveTask(context, obj) {
        __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].log('TasksStore > saveTask', obj);
        obj.key = __WEBPACK_IMPORTED_MODULE_7__data_NiceData__["a" /* default */].safelyGetKey(obj) || __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getKey();
        obj.transactionKey = obj.transactionKey || context.getters.transaction.key;
        obj.clients = obj.clients || context.getters.transaction.clients;
        obj.tenantKey = obj.tenantKey || context.getters.tenantKey;
        obj.due = obj.due || __WEBPACK_IMPORTED_MODULE_5__helpers_DateHelpers__["a" /* default */].businessDaysFromNow(1).formatBackwards();
        obj.assigned = obj.assigned || context.getters.user;
        var newObj = __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__["a" /* default */].prepareSave(obj);
        context.commit('saveTask', newObj);
        var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef().child('tasks');
        __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(newObj, ref);
    },
    deleteTask: function deleteTask(context, obj) {
        __WEBPACK_IMPORTED_MODULE_6__helpers_Utilities__["a" /* default */].log('TasksStore > deleteTask', obj);
        context.commit('deleteTask', obj);
        var ref = __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getTenantRef().child('tasks');
        __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].deleteFromFirebase(obj, ref);
    }
};

var mutations = {
    setTasks: function setTasks(state, newVal) {
        state.tasks = newVal;
    },
    setSelectedTask: function setSelectedTask(state, newVal) {
        state.selectedTask = newVal;
    },
    saveTask: function saveTask(state, task) {
        __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__["a" /* default */].save(task, state.tasks, 0);
    },
    deleteTask: function deleteTask(state, task) {
        __WEBPACK_IMPORTED_MODULE_4__helpers_ListHelpers__["a" /* default */].delete(task, state.tasks);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__ = __webpack_require__(3);






var db = __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* default */].database();

var state = {
    templates: []
};

var getters = {

    templates: function templates(state) {
        return state.templates;
    },
    loadedTemplates: function loadedTemplates(state) {
        return state.loadedTemplates;
    }

};

var actions = {
    loadTemplates: function loadTemplates(context) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (context.getters.loadedTemplates) resolve(context.getters.templates);

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/templates');
            ref.on('value', function (snap) {
                console.log('store > loadedTemplates');
                var templates = __WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap).sort(function (a, b) {
                    if (a.group < b.group) return -1;
                    if (a.group > b.group) return 1;
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                });
                context.commit('templates', templates);
                context.commit('loadedTemplates', true);
                resolve(templates);
            });
        });
    },
    saveTemplate: function saveTemplate(context, payload) {
        var key = payload.key || payload['.key'] || __WEBPACK_IMPORTED_MODULE_3__helpers_DataHelpers__["a" /* default */].getKey();
        var ref = db.ref('tenants/' + context.getters.tenantKey + '/templates/' + key);
        ref.update(__WEBPACK_IMPORTED_MODULE_2__helpers_FirebaseHelpers__["a" /* default */].cloneWithoutKey(payload));
    },
    deleteTemplate: function deleteTemplate(context, payload) {
        var key = payload.key || payload['.key'];
        var ref = db.ref('tenants/' + context.getters.tenantKey + '/templates/' + key);
        ref.remove();
    }
};

var mutations = {
    templates: function templates(state, _templates) {
        state.templates = _templates;
    },
    loadedTemplates: function loadedTemplates(state, val) {
        state.loadedTemplates = val;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_ListHelpers__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(18);










var db = __WEBPACK_IMPORTED_MODULE_3__firebase__["a" /* default */].database();

var state = {
    transaction: {},
    transactions: [],
    transactionTemplates: [],
    transactionComments: [],
    allCommentsMode: false,
    masters: {}
};

var getters = {
    transaction: function transaction(state) {
        if (!state.transaction.key) {
            var transactionString = localStorage.getItem('transaction');
            if (transactionString) {
                state.transaction = JSON.parse(transactionString) || {};
            }
        }

        return state.transaction;
    },
    transactionTemplates: function transactionTemplates(state) {
        return state.transactionTemplates;
    },
    allCommentsMode: function allCommentsMode(state) {
        return state.allCommentsMode;
    },
    transactionRef: function transactionRef(state) {
        return __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTenantRef().child('transaction').child(state.transaction.key);
    },
    transactionComments: function transactionComments(state) {
        return state.transactionComments;
    },
    masters: function masters(state) {
        return state.masters;
    }

};

var actions = {
    loadTransaction: function loadTransaction(context, transactionKey) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            if (context.getters.transaction.key == transactionKey) {
                resolve(context.getters.transaction);
            } else {
                context.commit('setTransaction', { key: transactionKey, loading: true });
                context.commit('setTransactionComments', []);
                context.commit('setElements', []);
            }

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/transactions/' + transactionKey + '/details');
            ref.once('value', function (snapItem) {

                var item = snapItem.val();
                if (!item) {
                    console.log('No transaction found at ' + ref.toString());
                    reject('No transaction found');
                    return;
                }

                item.key = transactionKey;
                context.commit('setTransaction', item);
                __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('transaction-store > loadTransaction (from DB)');
                resolve(item);
            });
        });
    },
    loadTransactionTemplates: function loadTransactionTemplates(context) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            if (context.getters.transactionTemplates.length > 0) {
                resolve('cached');
                return;
            }

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/transactionTemplates');
            ref.on('value', function (snap) {
                console.log('store > loadTransactionTemplates (first load)');
                var transactionTemplates = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                context.commit('setTransactionTemplates', transactionTemplates);
                resolve('loaded');
            });
        });
    },
    loadTransactionComments: function loadTransactionComments(context) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            if (context.getters.transactionComments.length > 0) {
                resolve('cached');
                return;
            }

            var ref = db.ref('tenants/' + context.getters.tenantKey + '/transactions/' + context.getters.transaction.key + '/comments');

            ref.once('value', function (snap) {
                console.log('store > loadTransactionComments (first load)');
                var transactionComments = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap, true);
                context.commit('setTransactionComments', transactionComments);
                resolve('loaded');
            });
        });
    },
    loadMaster: function loadMaster(context) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

            var masterKey = context.getters.transaction.masterKey;
            if (!masterKey) {
                __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('loadMaster > No masterKey');
                resolve('No Master Key');
                return;
            }

            if (context.getters.masters[masterKey]) {
                __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('loadMaster > Master key already loaded');
                resolve('Cached');
                return;
            }

            var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTenantRef().child('transactions').child(masterKey).child('elements');
            ref.on('value', function (snap) {
                var masterElements = __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].snapshotToArray(snap);
                context.commit('setMaster', { key: masterKey, elements: masterElements });
                __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('transaction-store > loadMaster - first load');
                resolve('Loaded');
            });
        });
    },
    saveTransaction: function saveTransaction(context, obj) {
        __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('TransactionsStore > saveTransaction', obj);
        var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, obj);
        context.commit('setTransaction', newObj);
        setTimeout(function () {
            var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('details');
            __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(newObj, ref);
        }, 1000);
    },
    saveTransactionComment: function saveTransactionComment(context, obj) {
        __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('TransactionsStore > saveTransactionComment', obj);
        var newObj = __WEBPACK_IMPORTED_MODULE_6__helpers_ListHelpers__["a" /* default */].prepareSave(obj);
        context.commit('saveTransactionComment', newObj);
        var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('comments');
        __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].saveToFirebase(newObj, ref);
    },
    deleteTransactionComment: function deleteTransactionComment(context, obj) {
        __WEBPACK_IMPORTED_MODULE_7__helpers_Utilities__["a" /* default */].log('TransactionsStore > deleteTransactionComment', obj);
        context.commit('deleteTransactionComment', obj);
        var ref = __WEBPACK_IMPORTED_MODULE_5__helpers_DataHelpers__["a" /* default */].getTransactionRef().child('comments');
        __WEBPACK_IMPORTED_MODULE_4__helpers_FirebaseHelpers__["a" /* default */].deleteFromFirebase(obj, ref);
    }
};

var mutations = {
    groups: function groups(state, _groups) {
        state.groups = _groups;
    },
    setTransaction: function setTransaction(state, newVal) {

        state.transaction = newVal;
        if (!newVal.loading) localStorage.setItem('transaction', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newVal));
    },
    setTransactionTemplates: function setTransactionTemplates(state, newVal) {
        state.transactionTemplates = newVal;
    },
    setTransactionComments: function setTransactionComments(state, newVal) {
        state.transactionComments = newVal;
    },
    saveTransactionComment: function saveTransactionComment(state, newVal) {
        __WEBPACK_IMPORTED_MODULE_6__helpers_ListHelpers__["a" /* default */].save(newVal, state.transactionComments, 0);
    },
    deleteTransactionComment: function deleteTransactionComment(state, comment) {
        __WEBPACK_IMPORTED_MODULE_6__helpers_ListHelpers__["a" /* default */].delete(comment, state.transactionComments);
    },
    setMaster: function setMaster(state, payload) {
        __WEBPACK_IMPORTED_MODULE_8_vue__["default"].set(state.masters, payload.key, payload.elements);
    },
    allCommentsMode: function allCommentsMode(state, payload) {
        state.allCommentsMode = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(18);









var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, null, [{
        key: 'unshiftUnique',
        value: function unshiftUnique(array, object) {
            var idx = array.findIndex(function (o) {
                return o._key == object._key;
            });
            if (idx == -1) array.unshift(object);
        }
    }, {
        key: 'prepareSave',
        value: function prepareSave(obj) {
            var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
            if (!newObj._key) {
                newObj._key = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getKey();
            }
            newObj.stamp = __WEBPACK_IMPORTED_MODULE_4__helpers_DataHelpers__["a" /* default */].getStamp();
            return newObj;
        }
    }, {
        key: 'save',
        value: function save(obj, arr, position) {
            if (this.update(obj, arr)) return;

            var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);
            if (position === 0) arr.unshift(newObj);else arr.push(newObj);
        }
    }, {
        key: 'update',
        value: function update(obj, arr) {
            var idx = arr.findIndex(function (o) {
                return o._key == (obj._key || obj.meta._key);
            });
            if (idx >= 0) {
                var existingObj = arr[idx];
                var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existingObj, obj);
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(arr, idx, newObj);
                return true;
            } else return false;
        }
    }, {
        key: 'delete',
        value: function _delete(obj, arr) {

            var idx = arr.findIndex(function (o) {
                return o._key == (obj._key || obj.meta._key);
            });
            if (idx >= 0) arr.splice(idx, 1);else __WEBPACK_IMPORTED_MODULE_5__helpers_Utilities__["a" /* default */].log('ListHelpers > delete > Cant find object', obj);
        }
    }, {
        key: 'selectSingle',
        value: function selectSingle(obj, array) {
            var previouslySelected = Boolean(obj._selected);

            this.unselectAll(array);
            this.changeSelection(obj, !previouslySelected);
        }
    }, {
        key: 'selectMulti',
        value: function selectMulti(obj) {
            this.changeSelection(obj);
        }
    }, {
        key: 'selectRange',
        value: function selectRange(obj, array) {
            var selectedItems = this.getSelectedItems(array);
            if (selectedItems.length < 1) {
                this.changeSelection(obj);
                return;
            }
            var lastSelected = selectedItems[selectedItems.length - 1];
            var index1 = array.indexOf(lastSelected);
            var index2 = array.indexOf(obj);

            var lowerIndex = Math.min(index1, index2);
            var upperIndex = Math.max(index1, index2);

            for (var n = lowerIndex; n <= upperIndex; n++) {
                var _obj = array[n];
                this.changeSelection(_obj, true);
            }
        }
    }, {
        key: 'changeSelection',
        value: function changeSelection(obj, value) {
            if (value == null) value = !Boolean(obj._selected);

            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(obj, '_selected', value);
        }
    }, {
        key: 'getSelectedItems',
        value: function getSelectedItems(array) {
            return array.filter(function (o) {
                return o._selected;
            });
        }
    }, {
        key: 'unselectAll',
        value: function unselectAll(array) {
            var _this = this;

            this.getSelectedItems(array).forEach(function (item) {
                _this.changeSelection(item, false);
            });
        }
    }, {
        key: 'selectedOrClicked',
        value: function selectedOrClicked(obj, selectedObjects) {
            var idx = selectedObjects.findIndex(function (o) {
                return o._key == obj._key;
            });
            if (idx >= 0) return selectedObjects;else return [obj];
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1256)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(2645),
  /* scopeId */
  "data-v-af5f665a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(2612),
  /* scopeId */
  "data-v-780e4da0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(2535),
  /* scopeId */
  "data-v-49e9601a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1248)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(2637),
  /* scopeId */
  "data-v-a2c158be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1123)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(2511),
  /* scopeId */
  "data-v-3bc1b3c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1261)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(2650),
  /* scopeId */
  "data-v-bbb472c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1280)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(2669),
  /* scopeId */
  "data-v-f5b18230",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1266)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(2655),
  /* scopeId */
  "data-v-c708a500",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1059)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(2446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1086)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(2473),
  /* scopeId */
  "data-v-1bb2d7cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1159)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(2547),
  /* scopeId */
  "data-v-5232021a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(2610),
  /* scopeId */
  "data-v-76653662",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1165)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(2553),
  /* scopeId */
  "data-v-56593f40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1166)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(2554),
  /* scopeId */
  "data-v-566756c1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1277)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(2666),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1099)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(2486),
  /* scopeId */
  "data-v-2452cc54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1250)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(2639),
  /* scopeId */
  "data-v-a654324c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1131)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(2519),
  /* scopeId */
  "data-v-3f2f583f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1238)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(2626),
  /* scopeId */
  "data-v-8a1e8e98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1265)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(2654),
  /* scopeId */
  "data-v-c4a6913e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1267)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(2656),
  /* scopeId */
  "data-v-c7538e28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1057)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(2444),
  /* scopeId */
  "data-v-0b6413c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1251)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(2640),
  /* scopeId */
  "data-v-aaa62db6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1072)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(2459),
  /* scopeId */
  "data-v-143e7f29",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(2491),
  /* scopeId */
  "data-v-2c4bc956",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1096)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(2483),
  /* scopeId */
  "data-v-2398737a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1130)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(2518),
  /* scopeId */
  "data-v-3ec390d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1283)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(2672),
  /* scopeId */
  "data-v-fee590b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1102)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(2490),
  /* scopeId */
  "data-v-2bbecee4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(2614),
  /* scopeId */
  "data-v-785fae7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1088)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(2475),
  /* scopeId */
  "data-v-1d5239fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1095)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(2482),
  /* scopeId */
  "data-v-23889970",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(2609),
  /* scopeId */
  "data-v-758e3b35",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(2615),
  /* scopeId */
  "data-v-790c7d35",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1097)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(2484),
  /* scopeId */
  "data-v-23bcda91",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(2595),
  /* scopeId */
  "data-v-6e6c5b58",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1062)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(2449),
  /* scopeId */
  "data-v-0ecbd30a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(2611),
  /* scopeId */
  "data-v-7677a87d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1262)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(2651),
  /* scopeId */
  "data-v-bfe7c99e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(2524),
  /* scopeId */
  "data-v-406f2a23",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1071)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(2458),
  /* scopeId */
  "data-v-1431b1f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1085)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(2472),
  /* scopeId */
  "data-v-1b5a8950",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1259)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(2648),
  /* scopeId */
  "data-v-b6e45f52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(2621),
  /* scopeId */
  "data-v-7eefc5c9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1079)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(2466),
  /* scopeId */
  "data-v-18a7261a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1172)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(2560),
  /* scopeId */
  "data-v-58da40aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(2581),
  /* scopeId */
  "data-v-631cb630",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(2603),
  /* scopeId */
  "data-v-73e2ad5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1149)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(2537),
  /* scopeId */
  "data-v-4dc0f7f1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(2525),
  /* scopeId */
  "data-v-42e2fc17",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1229)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(2617),
  /* scopeId */
  "data-v-7a3bf2e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1148)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(2536),
  /* scopeId */
  "data-v-4b98b370",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1070)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(2457),
  /* scopeId */
  "data-v-132f39f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1083)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(2470),
  /* scopeId */
  "data-v-1a7a882e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(2551),
  /* scopeId */
  "data-v-538dd261",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1077)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(2464),
  /* scopeId */
  "data-v-181e3d5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1273)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(2662),
  /* scopeId */
  "data-v-e7a0eaf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(2529),
  /* scopeId */
  "data-v-464ae727",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1081)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(2468),
  /* scopeId */
  "data-v-18cc94f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1246)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(2634),
  /* scopeId */
  "data-v-9af8156c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(2585),
  /* scopeId */
  "data-v-6978a2db",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1276)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(2665),
  /* scopeId */
  "data-v-ec214e00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1074)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(2461),
  /* scopeId */
  "data-v-159fc42b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(2605),
  /* scopeId */
  "data-v-74939ac1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1066)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(2453),
  /* scopeId */
  "data-v-112a8f47",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1064)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(2451),
  /* scopeId */
  "data-v-1021b610",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1272)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(2661),
  /* scopeId */
  "data-v-df759b92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1237)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(2625),
  /* scopeId */
  "data-v-8790c204",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1082)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(2469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1154)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(2542),
  /* scopeId */
  "data-v-503a7874",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(2597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1274)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(2663),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1142)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(2530),
  /* scopeId */
  "data-v-465554e0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1171)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(2559),
  /* scopeId */
  "data-v-58744f96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1132)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(2520),
  /* scopeId */
  "data-v-3f7a10cf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1245)
__webpack_require__(1244)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(2632),
  /* scopeId */
  "data-v-9918ab98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1228)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(2616),
  /* scopeId */
  "data-v-7a0d7391",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(2583),
  /* scopeId */
  "data-v-6839f1ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(2531),
  /* scopeId */
  "data-v-467d54d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(2579),
  /* scopeId */
  "data-v-620fe7b3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1041)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(2428),
  /* scopeId */
  "data-v-031ac46a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(2602),
  /* scopeId */
  "data-v-73099c7b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1281)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(2670),
  /* scopeId */
  "data-v-fc78492c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1089)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(2476),
  /* scopeId */
  "data-v-1e94f4af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1044)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(2431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1240)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(2628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(2578),
  /* scopeId */
  "data-v-6064625a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1078)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(2465),
  /* scopeId */
  "data-v-18a1d0fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(2608),
  /* scopeId */
  "data-v-751ede09",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1073)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(2460),
  /* scopeId */
  "data-v-1581ecfb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(2528),
  /* scopeId */
  "data-v-459bbcbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1120)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(2508),
  /* scopeId */
  "data-v-3a813b62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1241)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(2629),
  /* scopeId */
  "data-v-941bce0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1125)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(2513),
  /* scopeId */
  "data-v-3d75bc7f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1090)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(2477),
  /* scopeId */
  "data-v-20c5b4a1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1279)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(2668),
  /* scopeId */
  "data-v-f53a2fba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(2557),
  /* scopeId */
  "data-v-57a87883",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1161)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(2549),
  /* scopeId */
  "data-v-52cd94c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1065)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(2452),
  /* scopeId */
  "data-v-1044eaa5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1043)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(2430),
  /* scopeId */
  "data-v-035ce890",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1271)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(2660),
  /* scopeId */
  "data-v-cf835c42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1087)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(2474),
  /* scopeId */
  "data-v-1d18e2cb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(2501),
  /* scopeId */
  "data-v-31f90fee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1068)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(2455),
  /* scopeId */
  "data-v-11d0c3f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1253)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(2642),
  /* scopeId */
  "data-v-aec2fb54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(2580),
  /* scopeId */
  "data-v-62dc2e62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1039)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(2426),
  /* scopeId */
  "data-v-01a99c42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1118)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(2506),
  /* scopeId */
  "data-v-38cdaa4c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1260)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(2649),
  /* scopeId */
  "data-v-b9640556",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(2596),
  /* scopeId */
  "data-v-6ed66d06",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1051)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(2438),
  /* scopeId */
  "data-v-074973f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1247)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(2636),
  /* scopeId */
  "data-v-9c581106",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(2538),
  /* scopeId */
  "data-v-4e350072",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1242)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(2630),
  /* scopeId */
  "data-v-95de312c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1173)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(2561),
  /* scopeId */
  "data-v-597e894a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(2487),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(2575),
  /* scopeId */
  "data-v-5ff581fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1258)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(2647),
  /* scopeId */
  "data-v-b2233fae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(2592),
  /* scopeId */
  "data-v-6d965685",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(2569),
  /* scopeId */
  "data-v-5d10a83c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1110)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(2498),
  /* scopeId */
  "data-v-2ffe7e24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(2577),
  /* scopeId */
  "data-v-5ffdc6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1049)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(2436),
  /* scopeId */
  "data-v-06bb27fd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(2600),
  /* scopeId */
  "data-v-7273a082",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(2572),
  /* scopeId */
  "data-v-5ed90ad5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(2573),
  /* scopeId */
  "data-v-5f13e460",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(2624),
  /* scopeId */
  "data-v-85d80284",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(2503),
  /* scopeId */
  "data-v-3664b6e9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(2582),
  /* scopeId */
  "data-v-652d019c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(2533),
  /* scopeId */
  "data-v-478d60e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1164)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(2552),
  /* scopeId */
  "data-v-550eb268",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(2633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1048)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(2435),
  /* scopeId */
  "data-v-06703c46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1255)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(2644),
  /* scopeId */
  "data-v-af404dbe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(2587),
  /* scopeId */
  "data-v-699bd659",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1053)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(2440),
  /* scopeId */
  "data-v-0825d48c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(2620),
  /* scopeId */
  "data-v-7ee93d68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(2604),
  /* scopeId */
  "data-v-747afc63",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1061)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(2448),
  /* scopeId */
  "data-v-0e92f24a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(2505),
  /* scopeId */
  "data-v-38041d4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1282)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(2671),
  /* scopeId */
  "data-v-feba07c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1275)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(2664),
  /* scopeId */
  "data-v-e9d0c018",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(2567),
  /* scopeId */
  "data-v-5ce00c6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1167)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(2555),
  /* scopeId */
  "data-v-576c99fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1084)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(2471),
  /* scopeId */
  "data-v-1ada4ca8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1076)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(2463),
  /* scopeId */
  "data-v-1784ac19",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1155)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(2543),
  /* scopeId */
  "data-v-507ed4d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(2586),
  /* scopeId */
  "data-v-6989b809",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1231)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(2619),
  /* scopeId */
  "data-v-7e6b230d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(2598),
  /* scopeId */
  "data-v-71f1ae1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1152)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(2540),
  /* scopeId */
  "data-v-4f404ce5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(2613),
  /* scopeId */
  "data-v-784b258f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1055)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(2442),
  /* scopeId */
  "data-v-09c26d72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1126)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(2514),
  /* scopeId */
  "data-v-3d90f7e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1100)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(2488),
  /* scopeId */
  "data-v-2982c9ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(2591),
  /* scopeId */
  "data-v-6bda9b36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1056)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(2443),
  /* scopeId */
  "data-v-0adf0f7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(2527),
  /* scopeId */
  "data-v-4478cf9b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1063)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(2450),
  /* scopeId */
  "data-v-0ee7f3b2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1178)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(2566),
  /* scopeId */
  "data-v-5c613c48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1060)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(2447),
  /* scopeId */
  "data-v-0e314736",
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1257)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(2646),
  /* scopeId */
  "data-v-b1ed547e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1128)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(2516),
  /* scopeId */
  "data-v-3dcd0382",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1230)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(2618),
  /* scopeId */
  "data-v-7d6a16d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(2521),
  /* scopeId */
  "data-v-3fabfa66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(2570),
  /* scopeId */
  "data-v-5d7fa647",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1160)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(2548),
  /* scopeId */
  "data-v-52b11722",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(2635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(2526),
  /* scopeId */
  "data-v-43eb34b7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(2623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Field Name"
    },
    on: {
      "change": _vm.setIdentifier
    },
    model: {
      value: (_vm.field.name),
      callback: function($$v) {
        _vm.$set(_vm.field, "name", $$v)
      },
      expression: "field.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field Identifier",
      "disabled": Boolean(_vm.field._id)
    },
    on: {
      "dblclick": _vm.setIdentifier
    },
    model: {
      value: (_vm.field.identifier),
      callback: function($$v) {
        _vm.$set(_vm.field, "identifier", $$v)
      },
      expression: "field.identifier"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fieldTypes,
      "item-text": "name",
      "item-value": "name",
      "label": "Field Type"
    },
    model: {
      value: (_vm.field.type),
      callback: function($$v) {
        _vm.$set(_vm.field, "type", $$v)
      },
      expression: "field.type"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.controlTypes,
      "item-text": "name",
      "item-value": "name",
      "label": "Control Type"
    },
    model: {
      value: (_vm.field.control),
      callback: function($$v) {
        _vm.$set(_vm.field, "control", $$v)
      },
      expression: "field.control"
    }
  }), _vm._v(" "), (_vm.field.type == 'List') ? _c('v-text-field', {
    attrs: {
      "label": "Options"
    },
    model: {
      value: (_vm.field.options),
      callback: function($$v) {
        _vm.$set(_vm.field, "options", $$v)
      },
      expression: "field.options"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.type == 'Calculated') ? _c('v-text-field', {
    attrs: {
      "label": "Expression"
    },
    model: {
      value: (_vm.field.expression),
      callback: function($$v) {
        _vm.$set(_vm.field, "expression", $$v)
      },
      expression: "field.expression"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.field._id) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 2427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.isConfirming) ? _c('v-btn', {
    staticClass: "delete-button error",
    class: {
      active: _vm.isConfirming
    },
    nativeOn: {
      "click": function($event) {
        return _vm.raiseDeleteEvent($event)
      }
    }
  }, [_vm._v("Delete")]) : _c('v-btn', {
    staticClass: "delete-button grey--text",
    class: {
      active: !_vm.isConfirming
    },
    attrs: {
      "disabled": _vm.disabled,
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmDelete($event)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "100"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.notifyChangesMenuClicked
    }
  }, [_c('v-list-item-title', [_vm._v("Notify Office of Changes")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [(_vm.checklistKey) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('ChecklistDetails', {
    attrs: {
      "pageSettings": _vm.pageSettings,
      "checklistKey": _vm.checklistKey,
      "mode": "Client"
    },
    on: {
      "change": _vm.documentChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-text light-text"
  }, [_vm._v("Click on a document to upload files or see more information")])], 1) : [_c('NoRecordsPlaceholder', {
    attrs: {
      "message": "No checklist specified"
    }
  })]], 2), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('AdvancedDialog', {
    attrs: {
      "record": _vm.addDocumentDialog.record,
      "settings": _vm.addDocumentDialog.settings,
      "fields": _vm.addDocumentDialog.fields
    },
    on: {
      "save": _vm.saveDocumentForCategory
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-list"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    ref: "search",
    staticStyle: {
      "margin": "6px 8px"
    },
    attrs: {
      "filled": "",
      "dense": "",
      "rounded": "",
      "placeholder": "Search...",
      "hide-details": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "auto"
    }
  }, [_c('v-list-item-group', [_vm._t("top"), _vm._v(" "), _vm._l((_vm.itemsList), function(item, idx) {
    return _c('v-list-item', {
      key: idx,
      class: {
        selected: _vm.isSelected(item)
      },
      attrs: {
        "input-value": _vm.value && item._id == _vm.value._id
      },
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(item.title || item.name || item.text) + "\n                    ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                        " + _vm._s(item.value || item.details || item.text) + "\n                    ")])], 1)], 1)
  }), _vm._v(" "), _vm._t("bottom")], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.lender) + " Documents\n\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "nudge-bottom": 7,
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.lenders), function(lender) {
    return _c('v-list-item', {
      key: lender.name,
      on: {
        "click": function($event) {
          return _vm.setLender(lender.name)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(lender.name))])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    key: "general",
    on: {
      "click": function($event) {
        return _vm.setLender('General')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("General Options")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category['.key'],
      staticClass: "pa-3"
    }, [_c('h4', [_vm._v(_vm._s(category.name) + "\n        "), _c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            staticClass: "blue--text",
            attrs: {
              "icon": ""
            }
          }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.showDocumentDialog(null, category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add " + _vm._s(category.name) + " Heading")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.requirementsForCategory(category.name)), function(requirement) {
      return _c('div', {
        key: requirement['.key']
      }, [_c('v-toolbar', {
        staticClass: "primary",
        attrs: {
          "dark": ""
        },
        nativeOn: {
          "dblclick": function($event) {
            $event.stopPropagation();
            return _vm.showDocumentDialog(requirement, null)
          }
        }
      }, [_c('v-toolbar-title', {
        staticStyle: {
          "user-select": "none"
        }
      }, [_vm._v(_vm._s(requirement.name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.showRequirementDialog(null, requirement)
          }
        }
      }, [_c('v-icon', [_vm._v("add_circle")])], 1)], 1), _vm._v(" "), (_vm.lender != 'General') ? [_c('v-expansion-panel', _vm._l((_vm.requestsForRequirement(requirement['.key'])), function(request) {
        return _c('v-expansion-panel-content', {
          key: request['.key'],
          staticClass: "blue lighten-3"
        }, [_c('div', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_vm._v(_vm._s(request.name))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
          staticClass: "grey lighten-3",
          staticStyle: {
            "min-height": "100px"
          }
        }, [_c('v-btn', {
          staticClass: "grey--text",
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "outlined": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showRequirementDialog(request, null)
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('v-row', {
          attrs: {
            "wrap": ""
          }
        }, [_c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Description")]), _c('br'), _vm._v("\n                            " + _vm._s(request.description)), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Instructions")]), _c('br'), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s((request.instructions))
          }
        }), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Things to Check")]), _c('br'), _vm._v(" "), _c('ul', _vm._l((request.checklist), function(check) {
          return _c('li', {
            key: check['key']
          }, [_vm._v("\n                                " + _vm._s(check.text) + "\n                                ")])
        }), 0), _vm._v(" "), _c('br')])], 1)], 1)], 1)], 1)
      }), 1)] : _vm._e(), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.generalRequestsForRequirement(requirement['.key'])), function(request, i) {
        return _c('v-expansion-panel-content', {
          key: i
        }, [_c('div', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_vm._v(_vm._s(request.name))]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
          staticClass: "grey lighten-3",
          staticStyle: {
            "min-height": "100px"
          }
        }, [(_vm.lender == 'General') ? _c('v-btn', {
          staticClass: "grey--text",
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "outlined": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showRequirementDialog(request, null)
            }
          }
        }, [_vm._v("Edit")]) : _c('v-btn', {
          staticClass: "grey--text",
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "outlined": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.copyToLender(request)
            }
          }
        }, [_vm._v("Copy to " + _vm._s(_vm.lender))]), _vm._v(" "), _c('v-row', {
          attrs: {
            "wrap": ""
          }
        }, [_c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Description")]), _c('br'), _vm._v("\n                            " + _vm._s(request.description)), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Download Link")]), _c('br'), _vm._v(" "), _c('a', {
          attrs: {
            "target": "_blank",
            "href": request.download
          }
        }, [_vm._v(_vm._s(request.download))]), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Instructions")]), _c('br'), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s((request.instructions))
          }
        }), _c('br'), _c('br')]), _vm._v(" "), _c('v-col', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [_c('b', [_vm._v("Things to Check")]), _c('br'), _vm._v(" "), _c('ul', _vm._l((request.checklist), function(check) {
          return _c('li', {
            key: check.key
          }, [_vm._v("\n                                " + _vm._s(check.text) + "\n                                ")])
        }), 0), _vm._v(" "), _c('br')])], 1)], 1)], 1)], 1)
      }), 1), _vm._v(" "), _c('br')], 2)
    })], 2)
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-overlay": true,
      "persistent": ""
    },
    model: {
      value: (_vm.documentDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog, "visible", $$v)
      },
      expression: "documentDialog.visible"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h3', {
    staticClass: "mb-0 grey--text text--darken-2"
  }, [_vm._v(_vm._s(_vm.documentDialog.model.category.name) + " Document")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "name": "document-name",
      "label": "Document Name",
      "id": "document-name"
    },
    model: {
      value: (_vm.documentDialog.model.name),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.model, "name", $$v)
      },
      expression: "documentDialog.model.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "grey--text"
  }, [_vm._v("Importance")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "10",
      "step": "1"
    },
    model: {
      value: (_vm.documentDialog.model.importance),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.model, "importance", $$v)
      },
      expression: "documentDialog.model.importance"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.documentDialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.documentDialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.requirementDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog, "visible", $$v)
      },
      expression: "requirementDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-tabs', {
    attrs: {
      "color": "primary",
      "id": "mobile-tabs-1",
      "grow": "",
      "scroll-bars": "",
      "dark": ""
    },
    model: {
      value: (_vm.dialogTab),
      callback: function($$v) {
        _vm.dialogTab = $$v
      },
      expression: "dialogTab"
    }
  }, [_c('v-tab', {
    key: 1
  }, [_vm._v("\n                " + _vm._s(_vm.requirementDialog.model.requirementName) + "\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 2
  }, [_vm._v("\n                Instructions\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 3
  }, [_vm._v("\n                Checklist\n            ")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "name": "document-name",
      "label": "Document Name"
    },
    model: {
      value: (_vm.requirementDialog.model.name),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "name", $$v)
      },
      expression: "requirementDialog.model.name"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "3",
      "name": "document-description",
      "label": "Description"
    },
    model: {
      value: (_vm.requirementDialog.model.description),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "description", $$v)
      },
      expression: "requirementDialog.model.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "document-download",
      "label": "Download Link"
    },
    model: {
      value: (_vm.requirementDialog.model.download),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "download", $$v)
      },
      expression: "requirementDialog.model.download"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('v-text-field', {
    attrs: {
      "name": "document-expiry-days",
      "label": "Expiry Days"
    },
    model: {
      value: (_vm.requirementDialog.model.expiryDays),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "expiryDays", $$v)
      },
      expression: "requirementDialog.model.expiryDays"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "150px"
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "hide-details": "",
      "label": "Not Required",
      "color": "primary"
    },
    model: {
      value: (_vm.requirementDialog.model.notRequired),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "notRequired", $$v)
      },
      expression: "requirementDialog.model.notRequired"
    }
  })], 1)])]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "label": "Importance",
      "min": "0",
      "max": "10",
      "step": "1"
    },
    model: {
      value: (_vm.requirementDialog.model.importance),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "importance", $$v)
      },
      expression: "requirementDialog.model.importance"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pa-3"
  }, [_c('v-textarea', {
    attrs: {
      "rows": "8",
      "name": "document-description",
      "label": "Instructions"
    },
    model: {
      value: (_vm.requirementDialog.model.instructions),
      callback: function($$v) {
        _vm.$set(_vm.requirementDialog.model, "instructions", $$v)
      },
      expression: "requirementDialog.model.instructions"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pa-3"
  }, [_vm._l((_vm.requirementDialog.model.checklist), function(check, index) {
    return _c('div', {
      key: check['.key']
    }, [_c('DeleteButton', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.requirementsDialog.model.checklist.splice(index, 1)
        }
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "85%"
      },
      model: {
        value: (check.text),
        callback: function($$v) {
          _vm.$set(check, "text", $$v)
        },
        expression: "check.text"
      }
    })], 1)
  }), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Add Check Item"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCheckItem($event)
      }
    },
    model: {
      value: (_vm.newCheckItem),
      callback: function($$v) {
        _vm.newCheckItem = $$v
      },
      expression: "newCheckItem"
    }
  })], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.requirementDialog.model['.key']) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteRequirement(_vm.requirementDialog.model['.key'])
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requirementDialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.requirementDialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 2)
},staticRenderFns: []}

/***/ }),
/* 2432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expand-transition', [(_vm.isVisible) ? _c('div', {
    style: (_vm.blockStyle(_vm.schema)),
    attrs: {
      "title": _vm.schema.name
    },
    on: {
      "click": _vm.formBlockClicked
    }
  }, [(_vm.controlName) ? _c(_vm.controlName, {
    tag: "component",
    attrs: {
      "schema": _vm.mergedSchema,
      "value": _vm.value,
      "context": _vm.context
    },
    on: {
      "change": _vm.change,
      "focus": _vm.focus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shouldRenderFields) ? _c('div', {
    staticClass: "control-group",
    class: {
      horizontal: _vm.horizontal
    }
  }, [_vm._l((_vm.childFields), function(field, fieldIndex) {
    return [_c('FormBlock', {
      key: fieldIndex,
      attrs: {
        "schema": field,
        "value": _vm.value,
        "horizontal": _vm.schema.horizontal,
        "context": _vm.context
      },
      on: {
        "change": _vm.change,
        "focus": _vm.focus
      }
    })]
  })], 2) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "error-messages": _vm.emailValidationError,
      "rules": _vm.emailRules,
      "value": _vm.value,
      "autocomplete": "off",
      "hide-details": _vm.hideDetails,
      "prepend-icon": _vm.icon
    },
    on: {
      "input": _vm.emailInput,
      "change": _vm.validateEmail
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.status == 'Checking') ? _c('v-progress-circular', {
          attrs: {
            "size": "20",
            "width": "2",
            "color": "info",
            "indeterminate": ""
          }
        }) : _vm._e(), _vm._v(" "), (_vm.status == '') ? _c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check_circle")]) : _vm._e()]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.confirmationVisible) ? _c('v-text-field', {
    ref: "confirmation",
    attrs: {
      "label": "Confirm Email",
      "autocomplete": "off",
      "hide-details": _vm.hideDetails,
      "prepend-icon": _vm.confirmationIcon
    },
    model: {
      value: (_vm.confirmation),
      callback: function($$v) {
        _vm.confirmation = $$v
      },
      expression: "confirmation"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base-input"
  }, [_c('div', {
    staticClass: "base-input-label"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "base-input-box"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "base-input-messages"
  }, [_vm._v("\n        " + _vm._s(_vm.hint) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 2435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-list-item', {
      key: item.meta.listKey,
      attrs: {
        "title": item.meta.listHover
      },
      on: {
        "click": function($event) {
          return _vm.$emit('click', item)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(item.meta.listIcon || 'folder'))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.meta.listTitle))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.meta.listDetails))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.componentName, {
    tag: "component",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.emitInput
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "draggable-container",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": {
        animation: 350,
        group: 'elements',
        handle: '.draggable-handle'
      }
    },
    on: {
      "end": _vm.afterDrag
    }
  }, [(!_vm.items || _vm.items.length < 1) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("mdi-comment-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "grey--text text--lighten-1 pl-2"
  }, [_vm._v("No Data")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "draggable-item",
      class: {
        selected: item._selected
      },
      staticStyle: {
        "display": "inline-block"
      },
      style: (_vm.itemStyle),
      attrs: {
        "title": item.order,
        "data-order": item.order,
        "data-id": item._id
      },
      on: {
        "click": [function($event) {
          $event.stopPropagation();
        }, function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.unselectAll()
        }, function($event) {
          if (!$event.metaKey) { return null; }
          return _vm.selectMulti(item)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          return _vm.selectMulti(item)
        }, function($event) {
          if (!$event.shiftKey) { return null; }
          return _vm.selectRange(item)
        }]
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "99%",
        "max-width": "99%"
      }
    }, [_vm._t("default", [_c('ObjectViewer', {
      attrs: {
        "item": item
      }
    })], {
      "item": item
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "pt-1",
      staticStyle: {
        "margin-left": "-3px",
        "margin-right": "-3px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "draggable-handle clickable",
            staticStyle: {
              "margin-top": "-1px"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_vm._t("menu", null, {
      "item": item,
      "selectedItems": _vm.selectedItems
    }), _vm._v(" "), _c('v-list-item', [_c('v-list-item-title', [_vm._v("Sortable List Menu")])], 1)], 2)], 1)], 1)])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    ref: "contactSearch",
    staticStyle: {
      "max-width": "200px",
      "margin-top": "25px"
    },
    attrs: {
      "rounded": "",
      "flat": "",
      "solo-inverted": "",
      "dense": "",
      "return-object": "",
      "hide-no-data": "",
      "full-width": "",
      "prepend-inner-icon": "search",
      "label": "Search...",
      "item-text": "fullName",
      "item-value": "objectID",
      "items": _vm.contacts,
      "search-input": _vm.search,
      "no-filter": ""
    },
    on: {
      "change": _vm.select,
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-item-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": data.item.image
          }
        })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.fullNameHighlighted)
          }
        }), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.bestContact(data.item)))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.jump(data.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-forwardburger")])], 1)], 1)]]
      }
    }]),
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.upcomingDays()), function(day) {
    return _c('div', {
      key: day.date,
      staticClass: "day-box",
      class: [_vm.sameDay(day.date, _vm.value) ? 'blue lighten-1 white--text' : ''],
      style: ({
        marginRight: day.friday ? '15px' : '5px'
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.updateDate(day.date)
        }
      }
    }, [_vm._v(_vm._s(day.initial))])
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "transition": "v-slide-y-transition",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "grey--text",
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }]),
    model: {
      value: (_vm.stepModalVisible),
      callback: function($$v) {
        _vm.stepModalVisible = $$v
      },
      expression: "stepModalVisible"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.scheduleDate),
      callback: function($$v) {
        _vm.scheduleDate = $$v
      },
      expression: "scheduleDate"
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "x-slow-fade"
    }
  }, [(_vm.imageNumber == 1) ? _c('img', {
    key: "img1",
    staticClass: "round white-border shadow absolute",
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.src1,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imageNumber == 2) ? _c('img', {
    key: "img2",
    staticClass: "round white-border shadow absolute",
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": _vm.src2,
      "alt": ""
    }
  }) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 2441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "white",
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "z-index": "1000"
    }
  }, [_c('ImageEditor', {
    attrs: {
      "item": _vm.contact
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    ref: "firstName",
    attrs: {
      "label": "First Name",
      "rules": _vm.requiredRules
    },
    on: {
      "change": _vm.checkGenderAndDuplicates
    },
    model: {
      value: (_vm.contact.firstName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "firstName", $$v)
      },
      expression: "contact.firstName"
    }
  }), _vm._v(" "), (_vm.advanced) ? _c('v-text-field', {
    attrs: {
      "label": "Preferred Name"
    },
    model: {
      value: (_vm.contact.preferredName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "preferredName", $$v)
      },
      expression: "contact.preferredName"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "rules": _vm.requiredRules
    },
    on: {
      "change": _vm.checkDuplicates
    },
    model: {
      value: (_vm.contact.lastName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "lastName", $$v)
      },
      expression: "contact.lastName"
    }
  }), _vm._v(" "), _c('UniqueContactEnforcer', {
    ref: "enforcer",
    attrs: {
      "contact": _vm.contact
    }
  }), _vm._v(" "), (_vm.advanced || _vm.contact.business) ? _c('v-text-field', {
    attrs: {
      "label": "Business"
    },
    model: {
      value: (_vm.contact.business),
      callback: function($$v) {
        _vm.$set(_vm.contact, "business", $$v)
      },
      expression: "contact.business"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced || _vm.contact.phone) ? _c('v-text-field', {
    attrs: {
      "label": "Phone"
    },
    model: {
      value: (_vm.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.contact, "phone", $$v)
      },
      expression: "contact.phone"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mobile",
      "rules": _vm.mobileRules
    },
    model: {
      value: (_vm.contact.mobile),
      callback: function($$v) {
        _vm.$set(_vm.contact, "mobile", $$v)
      },
      expression: "contact.mobile"
    }
  }), _vm._v(" "), (_vm.advanced || _vm.contact.fax) ? _c('v-text-field', {
    attrs: {
      "label": "Fax "
    },
    model: {
      value: (_vm.contact.fax),
      callback: function($$v) {
        _vm.$set(_vm.contact, "fax", $$v)
      },
      expression: "contact.fax"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced || _vm.contact.address) ? _c('v-text-field', {
    attrs: {
      "label": "Address "
    },
    model: {
      value: (_vm.contact.address),
      callback: function($$v) {
        _vm.$set(_vm.contact, "address", $$v)
      },
      expression: "contact.address"
    }
  }) : _vm._e(), _vm._v(" "), _c('EmailBox', {
    ref: "email",
    attrs: {
      "hide-details": false
    },
    model: {
      value: (_vm.contact.email),
      callback: function($$v) {
        _vm.$set(_vm.contact, "email", $$v)
      },
      expression: "contact.email"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "multiple": "",
      "value": _vm.selectedGroups,
      "label": "Groups",
      "chips": "",
      "items": _vm.availableGroups
    },
    on: {
      "input": _vm.updateGroups
    }
  }), _vm._v(" "), (_vm.advanced) ? _c('v-textarea', {
    attrs: {
      "label": "Notes"
    },
    model: {
      value: (_vm.contact.notes),
      callback: function($$v) {
        _vm.$set(_vm.contact, "notes", $$v)
      },
      expression: "contact.notes"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.advanced) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.advanced = true
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")]), _vm._v("Advanced")], 1) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('v-select', {
    attrs: {
      "clearable": "",
      "items": ['Male', 'Female', 'Other'],
      "label": "Gender"
    },
    on: {
      "change": _vm.checkImage
    },
    model: {
      value: (_vm.contact.gender),
      callback: function($$v) {
        _vm.$set(_vm.contact, "gender", $$v)
      },
      expression: "contact.gender"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('v-text-field', {
    attrs: {
      "label": "Middle Name"
    },
    model: {
      value: (_vm.contact.middleName),
      callback: function($$v) {
        _vm.$set(_vm.contact, "middleName", $$v)
      },
      expression: "contact.middleName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.advanced) ? _c('DateTime', {
    attrs: {
      "date-only": "",
      "label": "Date of Birth",
      "short": ""
    },
    model: {
      value: (_vm.contact.dob),
      callback: function($$v) {
        _vm.$set(_vm.contact, "dob", $$v)
      },
      expression: "contact.dob"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "clearable": "",
      "items": _vm.users,
      "label": "Owner",
      "item-text": "meta.fullName",
      "item-value": "key",
      "return-object": ""
    },
    model: {
      value: (_vm.contact.owner),
      callback: function($$v) {
        _vm.$set(_vm.contact, "owner", $$v)
      },
      expression: "contact.owner"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": Boolean(_vm.contact.meta.key),
      "items": _vm.officesList,
      "label": "Office",
      "item-text": "name",
      "item-value": "meta.key"
    },
    model: {
      value: (_vm.contact.meta.tenantKey),
      callback: function($$v) {
        _vm.$set(_vm.contact.meta, "tenantKey", $$v)
      },
      expression: "contact.meta.tenantKey"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.sendSMS,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-combobox', {
    attrs: {
      "single-line": "",
      "label": "Recipients",
      "chips": "",
      "multiple": "",
      "items": _vm.contactsWithMobiles,
      "return-object": "",
      "item-text": "fullName"
    },
    model: {
      value: (_vm.sms.recipients),
      callback: function($$v) {
        _vm.$set(_vm.sms, "recipients", $$v)
      },
      expression: "sms.recipients"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": 3,
      "label": _vm.prefix,
      "hint": _vm.suffix,
      "persistent-hint": ""
    },
    model: {
      value: (_vm.sms.message),
      callback: function($$v) {
        _vm.$set(_vm.sms, "message", $$v)
      },
      expression: "sms.message"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.tagArray), function(tag, tagIndex) {
    return _c('v-chip', {
      key: tagIndex,
      staticClass: "mr-1 mt-1",
      attrs: {
        "close": "",
        "dark": "",
        "color": tag.colour
      },
      on: {
        "click:close": function($event) {
          return _vm.remove(tag)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("space")(tag._id)))])
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "40/60"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Templates for " + _vm._s(_vm.officeName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', [_c('v-list-item-title', [_vm._v("Office " + _vm._s(_vm.tenantKey))])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToTemplateMaintenance
    }
  }, [_c('v-list-item-title', [_vm._v("Template Maintenance")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col1",
      "pa-3": ""
    },
    slot: "col1"
  }, [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "flex-basis": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "no-border full-width",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.visibleTemplates), function(tmpl) {
    return _c('v-list-item', {
      key: tmpl.key,
      class: {
        'border-transparent': true, 'blue-hilight': (_vm.template.key == tmpl.key)
      },
      attrs: {
        "disabled": _vm.editing
      },
      on: {
        "click": function($event) {
          return _vm.selectTemplate(tmpl)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(tmpl.group) + " - " + _vm._s(tmpl.name))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(tmpl.subject))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [_c('div', {
    staticClass: "ml-4 mr-2"
  }, [_c('div', [_c('div', [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Group",
      "prepend-icon": "note"
    },
    model: {
      value: (_vm.template.group),
      callback: function($$v) {
        _vm.$set(_vm.template, "group", $$v)
      },
      expression: "template.group"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Name",
      "prepend-icon": "widgets"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  })], 1)]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Subject"
    },
    model: {
      value: (_vm.template.subject),
      callback: function($$v) {
        _vm.$set(_vm.template, "subject", $$v)
      },
      expression: "template.subject"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('HtmlEditor', {
    model: {
      value: (_vm.template.body),
      callback: function($$v) {
        _vm.$set(_vm.template, "body", $$v)
      },
      expression: "template.body"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "color": "primary",
      "hide-details": "",
      "label": "Personal Template",
      "light": ""
    },
    model: {
      value: (_vm.template.personal),
      callback: function($$v) {
        _vm.$set(_vm.template, "personal", $$v)
      },
      expression: "template.personal"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('DeleteButton', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.template.key
    },
    on: {
      "delete": _vm.deleteTemplate
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "",
      "text": "",
      "color": "grey"
    },
    on: {
      "click": _vm.viewHtml
    }
  }, [_c('v-icon', [_vm._v("text_fields")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.editing,
      "color": "primary"
    },
    on: {
      "click": _vm.saveTemplate
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.editing
    },
    on: {
      "click": _vm.cancelEditing
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": !_vm.template.key || _vm.editing
    },
    on: {
      "click": _vm.copyTemplate
    }
  }, [_vm._v("Make a Copy")]), _vm._v(" "), (_vm.viewHtmlBox) ? _c('v-textarea', {
    attrs: {
      "label": "HTML View",
      "rows": 10
    },
    model: {
      value: (_vm.template.body),
      callback: function($$v) {
        _vm.$set(_vm.template, "body", $$v)
      },
      expression: "template.body"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.bodyPartClicked
    }
  }, [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-bottom": 0
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "btn full-width",
          class: {
            outline: _vm.outline, disabled: _vm.disabled, hoverable: !_vm.disabled && _vm.menuOnly
          },
          staticStyle: {
            "display": "flex"
          }
        }, on), [_c('div', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple",
            value: (!this.disabled),
            expression: "!this.disabled"
          }],
          ref: "textPart",
          staticClass: "text-part",
          class: {
            hoverable: !_vm.disabled && !_vm.menuOnly, clickable: !_vm.disabled, 'menu-only': _vm.menuOnly
          },
          on: {
            "click": _vm.textPartClicked
          }
        }, [_vm._t("default", [_vm._v("\n                " + _vm._s(_vm.buttonText) + "\n                ")])], 2), _vm._v(" "), _c('div', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple",
            value: (!this.disabled),
            expression: "!this.disabled"
          }],
          staticClass: "button-part",
          class: {
            hoverable: !_vm.disabled && !_vm.menuOnly
          },
          on: {
            "click": _vm.buttonPartClicked
          }
        }, [_c('v-icon', {
          staticStyle: {
            "margin-right": "-2px",
            "margin-left": "-2px"
          }
        }, [_vm._v("mdi-menu-down")])], 1)])]
      }
    }], null, true),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(menu, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.emitClick(menu)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(menu.text))])], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "leftVisible": false
    }
  }, [(_vm.vtwo) ? _c('div', {
    staticClass: "red lighten-3 pa-4"
  }, [_vm._v("\n    This is an outdated version of Taco. Please update your links to https://taco.insightprocessing.com.au\n")]) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Taco")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.tenantKey == '1') ? _c('AlgoliaContacts', {
    ref: "algoliaSearch",
    on: {
      "select": _vm.showActionsForAlgoliaContact,
      "jump": _vm.goToLatestTransaction
    }
  }) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "bottom": "",
      "origin": "top left",
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "xcolor": "blue darken-3",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("mdi-account-plus")])], 1)]
      }
    }]),
    model: {
      value: (_vm.addMenuVisible),
      callback: function($$v) {
        _vm.addMenuVisible = $$v
      },
      expression: "addMenuVisible"
    }
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.addClients
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("supervisor_account")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Add Client")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.editContact(null)
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Add Contact")])], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "max-height": 510,
      "left": "",
      "bottom": "",
      "origin": "top left",
      "nudge-bottom": 43,
      "nudge-right": 21,
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("menu")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/living')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Living Expense Tool")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/' + _vm.tenantKey + '/charts/select')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Charts")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/' + _vm.tenantKey + '/charts/rotate')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Cycle Charts")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/' + _vm.tenantKey + '/transaction/' + _vm.masterKey)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Open Master Template")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.emailOfficeInvite
    }
  }, [_c('v-list-item-title', [_vm._v("Send Invite")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.isChatting = !_vm.isChatting
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Chat Visible")]), _vm._v(" "), (_vm.isChatting) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1), _vm._v(" "), (_vm.isInsight) ? _c('v-list-item', {
    on: {
      "click": _vm.test
    }
  }, [_c('v-list-item-title', [_vm._v("Testing")])], 1) : _vm._e(), _vm._v(" "), (_vm.isInsight) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/billing')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Billing")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.reassignTasksDialog.settings.visible = true
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Reassign All Tasks")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.lookupDataDialog.settings.visible = true
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Lookup Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/mail-log')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Email Logs")])], 1), _vm._v(" "), (_vm.isInsight) ? _c('v-list-item', {
    on: {
      "click": _vm.reindexContacts
    }
  }, [_c('v-list-item-title', [_vm._v("Reindex Contacts")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.tasksByLenderSettings.condensed = !_vm.tasksByLenderSettings.condensed
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Condensed")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/download')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Contacts Download")])], 1)], 1)], 1), _vm._v(" "), (_vm.loadingMessage) ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "indeterminate": ""
    },
    on: {
      "click": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingMessage) ? _c('v-menu', {
    staticClass: "account-menu",
    attrs: {
      "min-width": "260",
      "left": "",
      "bottom": "",
      "origin": "top left",
      "nudge-top": 0,
      "nudge-right": 0,
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('img', {
          staticClass: "round clickable",
          attrs: {
            "width": "35",
            "height": "35",
            "src": _vm.userImage
          }
        })])]
      }
    }], null, false, 855373697)
  }, [_vm._v(" "), _c('div', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "width": "100%",
      "padding-left": "16px",
      "padding-top": "14px",
      "padding-bottom": "4px",
      "font-size": "1.2em"
    }
  }, [_c('img', {
    staticClass: "round clickable",
    staticStyle: {
      "float": "right",
      "margin-top": "-8px",
      "margin-right": "6px"
    },
    attrs: {
      "width": "35",
      "height": "35",
      "src": _vm.userImage
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("fullName")(_vm.user)))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "grey--text",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/preferences')
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Preferences")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.showActivityHistory
    }
  }, [_c('v-list-item-action', [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("restore")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("My Activity History")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "scroll"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "white",
    staticStyle: {
      "width": "100%",
      "padding": "10px 16px 16px 16px",
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "primary mr-1",
    nativeOn: {
      "click": function($event) {
        return _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary"
  }, [_vm._v("Close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('table', {
    staticStyle: {
      "margin-top": "3px",
      "margin-bottom": "-2px",
      "margin-left": "17px"
    }
  }, [_c('tr', [_c('td', [_c('v-icon', {
    staticStyle: {
      "margin-top": "3px",
      "margin-right": "7px"
    }
  }, [_vm._v("mdi-account-circle")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "nudge-bottom": 10,
      "max-height": 300,
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "display": "flex",
            "margin-top": "5px"
          }
        }, on), [_c('div', {
          staticStyle: {
            "font-size": "16px",
            "color": "#666",
            "white-space": "nowrap",
            "cursor": "pointer"
          }
        }, [_vm._v("\n                            " + _vm._s(_vm.tasksHeading) + "\n                        ")]), _vm._v(" "), _c('div', [_c('v-icon', [_vm._v("mdi-menu-down")])], 1)])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showMyTasks()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("My Tasks")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.officesWithUsers), function(office, officeIndex) {
    return [_c('v-list-item', {
      key: officeIndex,
      attrs: {
        "xclass": "grey lighten-4"
      },
      on: {
        "click": function($event) {
          return _vm.showOfficeTasks(office)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(office.name))])], 1), _vm._v(" "), _c('v-divider', {
      key: 'd1' + officeIndex
    }), _vm._v(" "), _vm._l((office.users), function(userItem, userIndex) {
      return _c('v-list-item', {
        key: officeIndex + '-' + userIndex,
        on: {
          "click": function($event) {
            return _vm.showUserTasks(office, userItem)
          }
        }
      }, [_c('v-list-item-title', {
        staticStyle: {
          "font-weight": "100"
        }
      }, [_vm._v(_vm._s(userItem.firstName) + " " + _vm._s(userItem.lastName))])], 1)
    }), _vm._v(" "), (office.users.length) ? _c('v-divider', {
      key: 'd2' + officeIndex
    }) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('td', [_c('v-icon', {
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_vm._v("mdi-calendar-range")])], 1), _vm._v(" "), _c('td', {
    staticClass: "pt-1"
  }, [_c('LabelMenu', {
    attrs: {
      "menus": [{
        value: 'Today'
      }, {
        value: 'Week'
      }, {
        value: 'All Upcoming'
      }]
    },
    model: {
      value: (_vm.searchDuration),
      callback: function($$v) {
        _vm.searchDuration = $$v
      },
      expression: "searchDuration"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "width": "50"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.goToDashboards
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("insert_chart")])], 1)], 1)])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "mb-3"
  }, [_c('Announcements'), _vm._v(" "), _c('TaskWarnings', {
    attrs: {
      "tasks": _vm.filteredLocalTasks
    }
  }), _vm._v(" "), (_vm.searchDuration != 'Week') ? _c('TasksByLender', {
    attrs: {
      "settings": _vm.tasksByLenderSettings,
      "tasks": _vm.filteredLocalTasks
    },
    on: {
      "clicked": _vm.taskClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchDuration == 'Week') ? _c('KanbanView', {
    attrs: {
      "stages": _vm.kanbanViewStages,
      "items": _vm.filteredLocalTasks,
      "fieldPath": "due"
    },
    on: {
      "move": _vm.kanbanMoved,
      "click": _vm.taskClicked
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var task = ref.item;

        return [_c('div', {
          staticClass: "hoverable clickable",
          staticStyle: {
            "position": "relative",
            "margin": "2px",
            "border-radius": "3px",
            "padding": "5px",
            "width": "236px",
            "border": "dotted 1px #ccc"
          }
        }, [(task.important) ? _c('div', {
          staticStyle: {
            "position": "absolute",
            "width": "12px",
            "height": "12px",
            "top": "4px",
            "right": "4px",
            "background-color": "rgba(23, 124, 224, 0.6)",
            "border-radius": "5px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(task.clients) + " "), _c('span', {
          staticClass: "light-text"
        }, [_vm._v(_vm._s(task.title))])])]
      }
    }], null, false, 801679173)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-text"
  }, [(_vm.overdueFilteredTasks.length) ? _c('v-btn', {
    staticClass: "mt-4",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "rounded": "",
      "depressed": "",
      "dark": "",
      "color": "red lighten-2"
    },
    on: {
      "click": _vm.bringForward
    }
  }, [_vm._v("\n                    Reschedule " + _vm._s(_vm.overdueFilteredTasks.length) + " Overdue to Today\n                ")]) : _vm._e(), _vm._v(" "), (_vm.search.length) ? _c('div', {
    staticClass: "ma-4"
  }, [_c('div', {
    staticClass: "light-text"
  }, [_vm._v("Tasks are filtered based on search text")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v("\n                        Clear Search\n                    ")])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.filteredLocalTasks.length) ? _c('NoRecordsPlaceholder', [_vm._v("\n                No tasks\n            ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {}, [(_vm.debugInfinite) ? _c('div') : _vm._e(), _vm._v(" "), _c('OfficeChooser', {
    staticStyle: {
      "padding": "8px",
      "margin-bottom": "-16px"
    },
    attrs: {
      "buttonStyle": "background-color: rgba(0,0,0,0.4);color:white;"
    }
  })], 1), _vm._v(" "), _c('ContactSearch', {
    ref: "contactSearch",
    staticClass: "no-padding ma-2",
    attrs: {
      "global": true
    },
    on: {
      "click": _vm.contactClicked,
      "add": function($event) {
        _vm.addMenuVisible = true
      },
      "search": _vm.contactSearchChanged,
      "jump": _vm.goToLatestTransaction
    }
  })], 1), _vm._v(" "), [(_vm.renameTransactionDialog.visible) ? _c('v-dialog', {
    attrs: {
      "min-width": "300",
      "max-width": "300",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.renameTransactionDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.renameTransactionDialog, "visible", $$v)
      },
      expression: "renameTransactionDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container rounded pa-3"
  }, [_c('v-text-field', {
    ref: "oldTransactionName",
    attrs: {
      "label": "Rename to",
      "placeholder": "Transaction Name",
      "value": _vm.renameTransactionDialog.transaction.description,
      "hint": "Enter to continue..."
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveRename($event)
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "min-width": "500",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.actionDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.actionDialog, "visible", $$v)
      },
      expression: "actionDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm._f("fullName")(_vm.actionDialog.model)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [(_vm.isInsight) ? [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openFirebase(_vm.actionDialog.model.meta.key)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.viewContactTransactionData(_vm.actionDialog.model.meta.key)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View Contact Transaction Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.viewUserData(_vm.actionDialog.model.meta.key)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View User Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showContactMaintenance(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Contact Maintenance")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showCharge(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Charge Invoice")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.editPreferences(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Edit Preferences")])], 1)] : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.viewEmailLogs(_vm.actionDialog.model.email)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View Mail Logs")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.removeUserStatus(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Remove User Status")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blue lighten-4",
    staticStyle: {
      "padding": "7px 20px 7px 20px"
    }
  }, [(_vm.actionDialog.model.partner) ? [_vm._v("\n                    Partner: "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.switchToPartner(_vm.actionDialog.model.partner.key)
      }
    }
  }, [_vm._v(_vm._s(_vm.actionDialog.model.partner.firstName + ' ' + _vm.actionDialog.model.partner.lastName))]), _vm._v(" | \n                    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.removeSpouse(_vm.actionDialog.model)
      }
    }
  }, [_vm._v("Separate")])] : [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectSpouse(_vm.actionDialog.model)
      }
    }
  }, [_vm._v("Add Partner")])]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('CommunicationBar', {
    attrs: {
      "contact": _vm.actionDialog.model
    }
  }), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "ripple": false,
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticStyle: {
      "margin-bottom": "-15px"
    }
  }, [_vm._v("Transactions")]), _vm._v(" "), _vm._l((_vm.actionDialog.transactions), function(transaction, transactionIndex) {
    return [_c('v-list-item', {
      key: transaction.key || transaction['.key'],
      attrs: {
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.openTransaction(transaction)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      attrs: {
        "src": _vm.imagePath(transaction)
      }
    })]), _vm._v(" "), _c('v-list-item-content', {
      attrs: {
        "ripple": false
      }
    }, [_c('v-list-item-title', {
      attrs: {
        "ripple": false
      }
    }, [_vm._v("\n                                " + _vm._s(transaction.name) + _vm._s(transaction.description) + "  \n                            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm._f("longDate")(transaction.created)))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "grey"
            }
          }, [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openTransaction(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Open Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openChecklist(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Open Checklist")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.renameTransaction(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Rename Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteTransaction(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Transaction")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-divider', {
      key: 'd1-' + transactionIndex
    })]
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addTransactionForContact(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "text--lighten-1 grey--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add Transaction\n                    ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("New transaction for " + _vm._s(_vm.actionDialog.model.firstName))])], 1)], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editContact(_vm.actionDialog.model)
      }
    }
  }, [_vm._v("Edit Contact")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.actionDialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "min-width": "500",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-overlay": true,
      "scrollable": ""
    },
    model: {
      value: (_vm.transactionDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog, "visible", $$v)
      },
      expression: "transactionDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("New File for " + _vm._s(_vm.transactionDialog.contact.firstName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body pa-3"
  }, [_c('v-text-field', {
    ref: "transactionName",
    attrs: {
      "label": "Transaction Name",
      "hint": "eg. Refinance home with cashout to purchase car"
    },
    model: {
      value: (_vm.transactionDialog.model.description),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog.model, "description", $$v)
      },
      expression: "transactionDialog.model.description"
    }
  }), _vm._v(" "), (_vm.transactionDialog.contact.partner) ? [_c('v-checkbox', {
    attrs: {
      "label": ("Joint with " + (_vm.transactionDialog.contact.partner.firstName)),
      "color": "primary"
    },
    model: {
      value: (_vm.transactionDialog.withPartner),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog, "withPartner", $$v)
      },
      expression: "transactionDialog.withPartner"
    }
  })] : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.transactionTemplates,
      "label": "Template",
      "item-value": "meta.key",
      "item-text": "description"
    },
    model: {
      value: (_vm.transactionDialog.model.masterKey),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog.model, "masterKey", $$v)
      },
      expression: "transactionDialog.model.masterKey"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.transactionDialog.model.description.length < 1
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transactionDialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transactionDialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])]), _vm._v(" "), _c('ContactSelector', {
    attrs: {
      "visible": _vm.contactSelector.visible,
      "title": _vm.contactSelector.title,
      "data": _vm.contactSelector.data
    },
    on: {
      "select": _vm.linkSpouse,
      "cancel": function($event) {
        _vm.contactSelector.visible = false
      }
    }
  }), _vm._v(" "), _c('ContactEditor', {
    attrs: {
      "settings": _vm.contactEditor.settings,
      "contactItem": _vm.contactEditor.contact
    }
  }), _vm._v(" "), _c('AddClients', {
    attrs: {
      "visible": _vm.addClientsVisible,
      "title": "Add Clients"
    },
    on: {
      "save": _vm.savedClients,
      "cancel": function($event) {
        _vm.addClientsVisible = false
      }
    }
  }), _vm._v(" "), _c('GenericListDialog', {
    attrs: {
      "items": _vm.genericListDialog.items,
      "settings": _vm.genericListDialog.settings,
      "clickHandler": _vm.logItemClicked
    }
  }), _vm._v(" "), _c('MaintenanceDialog', {
    attrs: {
      "initialProgram": "tc",
      "item": _vm.maintenanceDialog.item,
      "settings": _vm.maintenanceDialog.settings
    }
  }), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    }
  }), _vm._v(" "), (_vm.chargeDialog.settings.visible) ? _c('ChargeDialog', {
    attrs: {
      "settings": _vm.chargeDialog.settings,
      "charge": _vm.chargeDialog.charge
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reassignTasksDialog.settings.visible) ? _c('ReassignTasksDialog', {
    attrs: {
      "settings": _vm.reassignTasksDialog.settings
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lookupDataDialog.settings.visible) ? _c('LookupDataDialog', {
    attrs: {
      "settings": _vm.lookupDataDialog.settings
    }
  }) : _vm._e(), _vm._v(" "), _c('KeyPress', {
    attrs: {
      "key-code": 191,
      "event": "keyup"
    },
    on: {
      "pressed": _vm.setSearchFocus
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),
/* 2447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.remaining < 1) ? [_vm._v("\n        Saved   \n    ")] : [_vm._v("\n        Saving in " + _vm._s(_vm.remaining) + "s...   \n        "), _c('a', {
    on: {
      "click": function($event) {
        _vm.remaining = 0
      }
    }
  }, [_vm._v("Save Now")]), _vm._v(" | \n        "), _c('a', {
    on: {
      "click": _vm.revert
    }
  }, [_vm._v("Revert")])]], 2)
},staticRenderFns: []}

/***/ }),
/* 2448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kanban-container"
  }, _vm._l((_vm.stages), function(stage) {
    return _c('div', {
      key: stage.value,
      staticClass: "kanban-region elevation-3"
    }, [_c('div', {
      staticClass: "pa-2",
      staticStyle: {
        "background-color": "#eee",
        "border-radius": "5px",
        "font-weight": "600",
        "color": "#666"
      }
    }, [_vm._v("\n            " + _vm._s(stage.text) + " \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pa-2 kanban-body"
    }, [_c('div', {
      staticClass: "kanban-counter"
    }, [_vm._v(_vm._s(_vm.getItemsForRegion(stage.value).length))]), _vm._v(" "), _c('draggable', {
      key: stage.value,
      staticClass: "draggable-container",
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "min-height": "200px"
      },
      attrs: {
        "data-stage": stage.value,
        "data-stage-text": stage.text,
        "options": {
          animation: 350,
          group: 'kanban',
          xxxhandle: '.menu-icon'
        }
      },
      on: {
        "end": _vm.afterDrag
      }
    }, _vm._l((_vm.getItemsForRegion(stage.value)), function(item) {
      return _c('div', {
        key: _vm.getItemId(item),
        attrs: {
          "data-id": _vm.getItemId(item)
        },
        on: {
          "click": function($event) {
            return _vm.itemClicked(item)
          }
        }
      }, [_vm._t("default", [_c('div', {
        staticClass: "kanban-item hoverable clickable"
      }, [_vm._v("\n                    " + _vm._s(item.clients) + " "), _c('span', {
        staticClass: "light-text"
      }, [_vm._v(_vm._s(item.title))]), _vm._v("asdfasdf\n                    ")])], {
        "item": item
      })], 2)
    }), 0)], 1)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    staticClass: "pa-10 white ma-7 elevation-3",
    staticStyle: {
      "position": "relative",
      "xbackground-color": "rgba(0,0,0,0.0)"
    }
  }, [_c('FormControl', {
    attrs: {
      "schema": _vm.sampleSchema
    },
    on: {
      "change": _vm.formChanged
    },
    model: {
      value: (_vm.sampleRecord),
      callback: function($$v) {
        _vm.sampleRecord = $$v
      },
      expression: "sampleRecord"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}

/***/ }),
/* 2450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.importantTasks.length) ? _c('div', {
    staticClass: "important-tasks"
  }, [_c('div', {
    staticStyle: {
      "font-size": "10px",
      "color": "#666"
    }
  }, [_vm._v("\n            Important Clients\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "clickable"
  }, _vm._l((_vm.importantTasks), function(importantTask) {
    return _c('v-chip', {
      key: importantTask.meta.key,
      staticClass: "mr-1",
      attrs: {
        "title": importantTask.title,
        "dark": "",
        "color": _vm.importantTaskColour(importantTask)
      },
      on: {
        "click": function($event) {
          return _vm.taskClicked(importantTask)
        }
      }
    }, [_vm._v("\n                " + _vm._s(importantTask.clients) + "\n        ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "-8px",
      "margin-left": "85px",
      "color": "#bbb"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.transactionCount + ' client' + (_vm.transactionCount != 1 ? 's' : '')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, _vm._l((_vm.lenderTasks), function(lender, index) {
    return _c('div', {
      key: index,
      staticClass: "picture-card"
    }, [_c('div', {
      staticClass: "round-picture subtle-shadow picture-card-picture",
      style: (("background-image:url(/static/images/lenders/" + (encodeURI(lender.name)) + ".jpg)")),
      attrs: {
        "title": lender.name
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "elevation-2",
      staticStyle: {
        "border-radius": "8px",
        "padding": "6px",
        "background-color": "white"
      }
    }, _vm._l((lender.transactions), function(transaction, transactionIndex) {
      return _c('div', {
        key: transactionIndex,
        staticClass: "transaction-card clickable",
        on: {
          "click": function($event) {
            return _vm.transactionClicked(transaction)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-10px",
          "margin-right": "-10px"
        }
      }, [_c('a', {
        staticClass: "transparent",
        attrs: {
          "target": "_blank",
          "href": _vm.transactionLink(transaction),
          "title": "Open in new Tab"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('v-btn', {
        staticClass: "open-in-new",
        attrs: {
          "text": "",
          "icon": "",
          "color": "grey"
        }
      }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)]), _vm._v(" "), _c('b', [_vm._v(_vm._s(transaction.clients || 'No Name'))]), _c('v-btn', {
        staticClass: "no-focus",
        attrs: {
          "small": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "small": "",
          "color": "grey lighten-2"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.loadTransactionDetails(transaction)
          }
        }
      }, [_vm._v("mdi-chevron-down-circle")])], 1), _vm._v(" "), _c('v-expand-transition', [(_vm.settings.condensed) ? _c('span', _vm._l((transaction.tasks), function(task) {
        return _c('span', {
          key: task._key,
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.taskClicked(task)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(task.title) + "\n                        ")])
      }), 0) : _vm._e(), _vm._v(" "), (transaction.description) ? _c('div', [_vm._v("\n                        " + _vm._s(transaction.description) + " \n                        "), (transaction.broker) ? _c('span', {
        staticClass: "light-text small-text"
      }, [_vm._v(" (Broker: " + _vm._s(transaction.broker) + ")")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.settings.condensed) ? _c('div', {
        staticClass: "pt-1"
      }, _vm._l((transaction.tasks), function(task) {
        return _c('div', {
          key: task.key,
          staticClass: "pa-1 task-row hover-container clickable",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.taskClicked(task)
            }
          }
        }, [_c('ul', [_c('li', [(_vm.daysTillDue(task) < 0) ? _c('div', {
          staticClass: "red darken-1",
          staticStyle: {
            "border-radius": "2px",
            "margin-bottom": "-1px",
            "margin-right": "2px",
            "width": "12px",
            "height": "12px",
            "background-color": "#ccc",
            "display": "inline-block"
          }
        }) : _vm._e(), _vm._v(" "), (task.sectionTitle) ? _c('span', [_vm._v(_vm._s(task.sectionTitle) + " >")]) : _vm._e(), _vm._v("\n                                " + _vm._s(task.title || task.text) + "\n                                "), (_vm.settings.showInitials) ? _c('b', [_vm._v(_vm._s(_vm.initials(task.assigned)))]) : _vm._e(), _vm._v(" "), (task.important) ? _c('Flag', {
          attrs: {
            "primary": ""
          }
        }, [_vm._v("Important")]) : _vm._e(), _vm._v(" "), _c('flag', [_vm._v(_vm._s(task.status))]), _vm._v(" "), (_vm.daysTillDue(task) != 0) ? _c('span', {
          staticClass: "grey--text text--lighten-1"
        }, [_vm._v(" (" + _vm._s(_vm._f("dueString")(task.due)) + ")")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "task-edit show-on-hover",
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openTask(task)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "grey"
          }
        }, [_vm._v("edit")])], 1)], 1)])])
      }), 0) : _vm._e()], 1)
    }), 0)])])
  }), 0), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "color": "primary",
      "input-value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('UserChooser', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-heading mb-3"
  }, [_vm._v(_vm._s(_vm.schema.label))])
},staticRenderFns: []}

/***/ }),
/* 2454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticClass: "mr-1 element-button elevation-0",
    attrs: {
      "fab": "",
      "small": "",
      "color": _vm.buttonClass
    },
    on: {
      "click": _vm.showDialog
    }
  }, [(_vm.linkedFileCount) ? _c('v-badge', [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.linkedFileCount))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "blue darken-1"
    }
  }, [_vm._v("attach_file")])], 1) : _c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("attach_file")])], 1), _vm._v(" "), _c('FileDialog', {
    attrs: {
      "element": _vm.element,
      "files": _vm.files,
      "settings": _vm.fileDialog.settings
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Team Name"
    },
    model: {
      value: (_vm.team.name),
      callback: function($$v) {
        _vm.$set(_vm.team, "name", $$v)
      },
      expression: "team.name"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "fade-in-only grey--text",
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "250px",
      "color": "#ccc"
    }
  }, [_vm._v("chat_bubble_outline")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#aaa",
      "padding-left": "18px",
      "margin-top": "-10px"
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      },
      "focus": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LabelMenu', {
    staticStyle: {
      "color": "#888"
    },
    attrs: {
      "value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "menus": _vm.schema.items,
      "underline": "black"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white"
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('div', {
    staticClass: "ma-3 pa-3 white text-align-center"
  }, [_c('h5', [_vm._v("Welcome to Taco")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "120 ",
      "src": "/static/images/taco.jpg"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("This page is going to look awesome when I think of something cool and witty to say here.")])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [(_vm.signInEnabled) ? _c('div', {
    staticClass: "ma-3 pa-3 grey lighten-2 text-align-center"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.signInEnabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("\n                    Login with Google\n                ")])], 1) : _c('div', {
    staticClass: "ma-3 pa-3 grey lighten-2 text-align-center"
  }, [_c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('br')], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "400px"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('CurrencyBox', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    staticClass: "compact",
    attrs: {
      "outlined": "",
      "value": _vm.value,
      "mandatory": false,
      "label": _vm.schema.label
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  }, _vm._l((_vm.schema.items), function(item, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "value": _vm.value,
      "label": _vm.label,
      "items": _vm.ranges,
      "hint": _vm.hint,
      "return-object": ""
    },
    on: {
      "change": _vm.selectionChanged
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "prefix": "$"
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_vm._v("\n     \n    "), _c('v-btn', {
    staticStyle: {
      "margin": "10px 0 10px 0"
    },
    attrs: {
      "slot": "right",
      "color": "primary"
    },
    on: {
      "click": _vm.run
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.element.title))])], 1)
},staticRenderFns: []}

/***/ }),
/* 2466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    ref: "textbox",
    attrs: {
      "label": _vm.label,
      "xxxv-on": "on",
      "append-icon": "today",
      "hide-details": ""
    },
    on: {
      "dblclick": function($event) {
        _vm.menuVisible = !_vm.menuVisible
      },
      "change": _vm.setTextValue,
      "click:append": _vm.calendarClicked
    },
    model: {
      value: (_vm.textValue),
      callback: function($$v) {
        _vm.textValue = $$v
      },
      expression: "textValue"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "right": "",
      "nudge-top": -3,
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "full-width"
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "height": "300px",
      "background-color": "white",
      "padding": "7px"
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "no-title": ""
    },
    model: {
      value: (_vm.calendarValue),
      callback: function($$v) {
        _vm.calendarValue = $$v
      },
      expression: "calendarValue"
    }
  }), _vm._v(" "), (!_vm.dateOnly) ? _c('div', {
    staticStyle: {
      "background-color": "white",
      "height": "100%",
      "overflow-y": "scroll",
      "flex-grow": "1",
      "color": "#444"
    }
  }, _vm._l((25), function(n) {
    return _c('div', {
      key: n,
      staticClass: "ma-1 time-hoverable clickable time",
      class: {
        'blue-hilight': _vm.isSelected(n)
      },
      on: {
        "click": function($event) {
          _vm.setTime(_vm.getTimeHalfHourly(n))
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getTimeHalfHourly(n)) + "\n                    ")])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.past) ? _c('div', {
    staticStyle: {
      "background-color": "white",
      "height": "100%",
      "overflow-y": "scroll",
      "flex-grow": "1",
      "color": "#444"
    }
  }, [_c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": _vm.clearDate
    }
  }, [_vm._v("\n                        Clear\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(0)
      }
    }
  }, [_vm._v("\n                        Today\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(1)
      }
    }
  }, [_vm._v("\n                        Tomorrow\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(3)
      }
    }
  }, [_vm._v("\n                        3 Days\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(7)
      }
    }
  }, [_vm._v("\n                        1 Week\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(14)
      }
    }
  }, [_vm._v("\n                        2 Weeks\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(21)
      }
    }
  }, [_vm._v("\n                        3 Weeks\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(30)
      }
    }
  }, [_vm._v("\n                        1 Month\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.past) ? _c('div', {
    staticStyle: {
      "background-color": "white",
      "height": "100%",
      "overflow-y": "scroll",
      "flex-grow": "1",
      "color": "#444"
    }
  }, [_c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": _vm.clearDate
    }
  }, [_vm._v("\n                        Clear\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(-1)
      }
    }
  }, [_vm._v("\n                        Yesterday\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(-2)
      }
    }
  }, [_vm._v("\n                        2 Days Ago\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(-3)
      }
    }
  }, [_vm._v("\n                        3 Days Ago\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(-7)
      }
    }
  }, [_vm._v("\n                        1 Week Ago\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(-14)
      }
    }
  }, [_vm._v("\n                        2 Weeks Ago\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ma-1 shortcut time-hoverable clickable",
    on: {
      "click": function($event) {
        return _vm.setDays(-30)
      }
    }
  }, [_vm._v("\n                        1 Month Ago\n                    ")])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.schema.label))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.editorValue),
      callback: function($$v) {
        _vm.editorValue = $$v
      },
      expression: "editorValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "title": "Taco Billing",
      "right-visible": false
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Taco Billing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showingSummary = !_vm.showingSummary
            }
          }
        }, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show Summary")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.mine = !_vm.mine;
              _vm.loadInvoices()
            }
          }
        }, on), [_c('v-icon', [_vm._v("account_circle")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Invoices to Me")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.loadInvoices
          }
        }, on), [_c('v-icon', [_vm._v("refresh")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Refresh List")])])], 1), _vm._v(" "), _c('template', {
    slot: "left"
  }, [_c('div', {
    staticClass: "pa-2 lighten-1 ma-2",
    class: {
      green: _vm.isLastMonth(_vm.month), red: !_vm.isLastMonth(_vm.month)
    },
    staticStyle: {
      "border-radius": "30px"
    }
  }, [_c('div', {
    staticClass: "display-flex full-width"
  }, [_c('v-btn', {
    attrs: {
      "color": "white",
      "icon": ""
    },
    on: {
      "click": _vm.decrementMonth
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-left-circle-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "heading center-text mt-1",
    staticStyle: {
      "flex-grow": "1",
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.monthFormatted))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "white",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.incrementMonth(1)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-right-circle-outline")])], 1)], 1)]), _vm._v(" "), (_vm.grandTotal !== 0) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.grandTotal)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                        total for month\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdministrator && _vm.viewingPreviousMonth) ? [(_vm.invoicesNeedingValidation.length) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.invoicesNeedingValidation.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            invoices needing validation\n                        ")])]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": _vm.requestValidationMultiple
    }
  }, [_vm._v("Request")])], 1) : _vm._e(), _vm._v(" "), (_vm.invoicesReadyToSend.length) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.invoicesReadyToSend.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            invoices ready to send\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.processorsReadyToMakeLength) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.processorsReadyToMakeLength) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            processors ready to invoice\n                        ")])]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": _vm.makeInvoiceMultiple
    }
  }, [_vm._v("Make Invoices")])], 1) : _vm._e(), _vm._v(" "), (_vm.insightInvoicesAllSent) ? _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.insightInvoicesPaid.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            insight invoices paid out of " + _vm._s(_vm.insightInvoices.length) + "\n                        ")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "min-width": "100px"
          },
          attrs: {
            "rounded": "",
            "color": "primary"
          },
          on: {
            "click": _vm.emailAllInvoicesToBookkeeper
          }
        }, on), [_vm._v("Bookkeeper")])]
      }
    }], null, false, 4238557427)
  }, [_vm._v(" "), _c('span', [_vm._v("Email Invoices to Bookkeeper")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa-4 rounded white ma-3 center-text"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "pa-1 flex-col-sm",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "-6px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.invoicesPaid.length) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "element-label pa-1 uppercase",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                            insight invoices paid out of " + _vm._s(_vm.invoices.length) + "\n                        ")])])])] : _vm._e()], 2), _vm._v(" "), (!_vm.invoices.length) ? _c('NoRecordsPlaceholder', {
    attrs: {
      "delay": 2000
    }
  }, [_vm._v("\n                No Invoices\n        ")]) : _vm._e(), _vm._v(" "), (_vm.showingSummary) ? _c('div', {
    staticClass: "white pa-5 rounded ma-3"
  }, _vm._l((_vm.invoicesBySender), function(sender, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm._f("fullName")(sender.from)))]), _vm._v(" "), _vm._l((sender.invoices), function(invoice, formIndex) {
      return _c('div', {
        key: formIndex
      }, [_c('v-icon', [_vm._v("mdi-checkbox-blank-outline")]), _vm._v("\n                    " + _vm._s(_vm._f("fullName")(invoice.to)) + " " + _vm._s(_vm._f("cents")(invoice.total * 1.1)) + " (incl gst)\n                    "), _c('span', {
        staticClass: "light-text"
      }, [_vm._v("(" + _vm._s(_vm.getInvoiceId(invoice)) + ")")]), _vm._v(" "), (_vm.invoiceHasTag(invoice, 'paid')) ? _c('span', [_vm._v(" *** PAID ***")]) : _vm._e()], 1)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.showingSummary) ? _vm._l((_vm.invoicesBySender), function(sender, index) {
    return _c('div', {
      key: index,
      staticClass: "elevation-1 white rounded ma-3 pa-3 no-print-border",
      staticStyle: {
        "max-width": "800px"
      }
    }, [_c('div', {
      staticClass: "display-flex no-print"
    }, [_c('v-avatar', {
      staticClass: "mr-2",
      attrs: {
        "size": "60"
      }
    }, [_c('img', {
      attrs: {
        "src": sender.from.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-col-grow"
    }, [_c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm._f("fullName")(sender.from)))]), _vm._v(" "), (_vm.senderNeedsInvoicing(sender)) ? _c('v-btn', {
      staticClass: "mb-2",
      attrs: {
        "color": "orange lighten-3",
        "depressed": "",
        "rounded": ""
      },
      on: {
        "click": function($event) {
          return _vm.makeInvoiceSingle(sender)
        }
      }
    }, [_vm._v("\n                        Create Processor Invoice\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "blue--text",
      staticStyle: {
        "font-size": "30px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(sender.consultantTotal)) + "\n                    "), _c('div', {
      staticClass: "element-label center-text full-width text-uppercase",
      staticStyle: {
        "margin-top": "-5px"
      }
    }, [_vm._v(_vm._s(sender.invoices.length) + " Invoice/s")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "grey lighten-4 pa-2 rounded"
    }, _vm._l((sender.invoices), function(invoice) {
      return _c('div', {
        key: invoice.meta.key,
        staticClass: "white rounded ma-2 pa-3"
      }, [_c('div', {
        staticClass: "display-flex no-print"
      }, [_c('div', {
        staticClass: "flex-col-grow"
      }, [_c('div', {
        staticClass: "heading mb-2"
      }, [_vm._v("\n                            " + _vm._s(_vm._f("fullName")(invoice.to)) + "\n                            "), (!_vm.mine) ? _c('v-menu', {
        attrs: {
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({}, on), [_vm._v("keyboard_arrow_down")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.showCharge(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add Charge for " + _vm._s(invoice.to.firstName))])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.resetInvoice(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Reset Workflow")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.populateEntities(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Populate Entities")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.debugInvoice(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Debug Invoice")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.emailMe(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Email Invoice to Me")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.openInvoice(invoice)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Open in New Window")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('StatusLine', {
        attrs: {
          "available-stages": _vm.billingStagesVisible
        },
        model: {
          value: (invoice.tags),
          callback: function($$v) {
            _vm.$set(invoice, "tags", $$v)
          },
          expression: "invoice.tags"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-top": "20px"
        }
      }, [_c('div', {
        attrs: {
          "xxstyle": "border:solid 4px #ccc;padding:8px;border-radius:10px;"
        }
      }, [_c('div', {
        staticClass: "heading center-text",
        staticStyle: {
          "padding-top": "18px",
          "margin-left": "8px"
        }
      }, [_vm._v(_vm._s(_vm._f("cents")(invoice.total * 1.1)))])])])]), _vm._v(" "), _c('div', {
        staticClass: "pa-2 no-print"
      }, [((!_vm.isInvoiceReadyToSend(invoice) && (!invoice.meta.preview)) || !_vm.viewingPreviousMonth) ? _c('v-btn', {
        attrs: {
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.previewInvoice(invoice)
          }
        }
      }, [_vm._v("\n                            Preview " + _vm._s(invoice.charges.length) + " Charges\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.viewingPreviousMonth && !_vm.mine) ? [(_vm.isAdministrator && !_vm.invoiceHasTag(invoice, 'validation requested')) ? _c('v-btn', {
        attrs: {
          "color": "blue lighten-3",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.requestValidation(invoice)
          }
        }
      }, [_vm._v("\n                                Request Validation\n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.invoiceHasTag(invoice, 'valid')) ? _c('v-btn', {
        attrs: {
          "color": "blue lighten-3",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.validate(invoice)
          }
        }
      }, [_vm._v("\n                                Validate\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.isInvoiceReadyToSend(invoice)) ? _c('v-btn', {
        attrs: {
          "color": "primary",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.previewInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                Ready To Send\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.invoiceHasTag(invoice, 'sent') && !_vm.invoiceHasTag(invoice, 'paid')) ? [_c('v-btn', {
        attrs: {
          "color": "blue lighten-3",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.markPaid(invoice)
          }
        }
      }, [_vm._v("\n                                    Payment Received\n                                ")])] : _vm._e()] : _vm._e(), _vm._v(" "), (invoice.total === 0 && !_vm.mine) ? _c('v-btn', {
        attrs: {
          "dark": "",
          "color": "red darken-1",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.deleteInvoice(invoice)
          }
        }
      }, [_vm._v("\n                            Delete Invoice\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.isInvoiceReadyToMake(invoice)) ? _c('div', {
        staticClass: "orange--text small-text"
      }, [_vm._v("Ready to Make")]) : _vm._e()], 2), _vm._v(" "), _c('v-expand-transition', [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (invoice.meta.preview),
          expression: "invoice.meta.preview"
        }],
        staticClass: "invoice"
      }, [_c('v-icon', {
        staticClass: "no-print",
        staticStyle: {
          "position": "absolute",
          "right": "5px",
          "top": "5px"
        },
        attrs: {
          "color": "red lighten-3"
        },
        on: {
          "click": function($event) {
            return _vm.$set(invoice.meta, 'preview', false)
          }
        }
      }, [_vm._v("\n                            cancel\n                        ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding": "18px"
        }
      }, [_c('Invoice', {
        key: invoice.meta.key,
        attrs: {
          "invoice": invoice
        },
        on: {
          "delete-charge": _vm.deleteCharge
        }
      })], 1), _vm._v(" "), (!_vm.mine) ? _c('div', {
        staticClass: "center-text no-print pa-3"
      }, [(_vm.invoiceHasTag(invoice, 'valid') && !_vm.invoiceHasTag(invoice, 'sent') && _vm.viewingPreviousMonth) ? [_c('v-btn', {
        staticClass: "no-print",
        attrs: {
          "color": "primary",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.sendInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                    Send Invoice\n                                ")]), _vm._v(" "), _c('a', {
        staticClass: "ml-3 no-print",
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.skipSendInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                    I sent it previously\n                                ")])] : _vm._e(), _vm._v(" "), (_vm.invoiceHasTag(invoice, 'sent')) ? _c('v-btn', {
        staticClass: "no-print",
        attrs: {
          "color": "primary",
          "depressed": "",
          "rounded": ""
        },
        on: {
          "click": function($event) {
            return _vm.sendInvoice(invoice)
          }
        }
      }, [_vm._v("\n                                Resend Invoice\n                            ")]) : _vm._e()], 2) : _vm._e()], 1)])], 1)
    }), 0)])
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "right"
  }), _vm._v(" "), (_vm.chargeDialog.settings.visible) ? _c('ChargeDialog', {
    attrs: {
      "settings": _vm.chargeDialog.settings,
      "charge": _vm.chargeDialog.charge
    },
    on: {
      "saved": _vm.loadInvoices
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('YesNo', {
    attrs: {
      "label": _vm.schema.label,
      "question": _vm.schema.question,
      "color": "blue",
      "value": _vm.value[_vm.schema.name]
    },
    on: {
      "input": function($event) {
        return _vm.$emit('change', $event)
      },
      "focus": function($event) {
        return _vm.$emit('focus', $event)
      }
    },
    nativeOn: {
      "contextmenu": function($event) {
        $event.preventDefault();
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialiseDialog
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.programItems
    },
    model: {
      value: (_vm.program),
      callback: function($$v) {
        _vm.program = $$v
      },
      expression: "program"
    }
  }), _vm._v(" "), (_vm.program == 'tc') ? _c('v-text-field', {
    attrs: {
      "label": "Contact Key"
    },
    model: {
      value: (_vm.contactKey),
      callback: function($$v) {
        _vm.contactKey = $$v
      },
      expression: "contactKey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.program == 'tot') ? _c('v-text-field', {
    attrs: {
      "label": "Template Key"
    },
    model: {
      value: (_vm.templateKey),
      callback: function($$v) {
        _vm.templateKey = $$v
      },
      expression: "templateKey"
    }
  }) : _vm._e(), _vm._v(" "), (this.program == 'tcu' || this.program == 'ttu') ? _c('UserChooser', {
    attrs: {
      "label": "User"
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tenants,
      "item-text": "name",
      "item-value": "meta.key",
      "label": "Source Tenant"
    },
    model: {
      value: (_vm.sourceTenant),
      callback: function($$v) {
        _vm.sourceTenant = $$v
      },
      expression: "sourceTenant"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tenants.filter(function (o) { return o.meta.key != _vm.sourceTenant; }),
      "item-text": "name",
      "item-value": "meta.key",
      "label": "Destination Tenant"
    },
    model: {
      value: (_vm.destinationTenant),
      callback: function($$v) {
        _vm.destinationTenant = $$v
      },
      expression: "destinationTenant"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Remove from Source"
    },
    model: {
      value: (_vm.move),
      callback: function($$v) {
        _vm.move = $$v
      },
      expression: "move"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Simulate Writes"
    },
    model: {
      value: (_vm.simulateWrites),
      callback: function($$v) {
        _vm.simulateWrites = $$v
      },
      expression: "simulateWrites"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Simulate Deletes"
    },
    model: {
      value: (_vm.simulateDeletes),
      callback: function($$v) {
        _vm.simulateDeletes = $$v
      },
      expression: "simulateDeletes"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.run
    }
  }, [_vm._v("Go")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Results"
    },
    model: {
      value: (_vm.output),
      callback: function($$v) {
        _vm.output = $$v
      },
      expression: "output"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('BaseInput', {
    attrs: {
      "label": _vm.schema.label
    }
  }, [(_vm.isUploading) ? _vm._l((_vm.uploading), function(upload) {
    return _c('div', {
      key: upload.name,
      staticClass: "file-row",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIcon(upload.type)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-wrap",
      staticStyle: {
        "color": "#888",
        "flex-grow": "1",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(upload.name.replace(/-.{6}\./, '.')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "100px",
        "padding-top": "18px"
      }
    }, [_c('v-progress-linear', {
      model: {
        value: (upload.progress),
        callback: function($$v) {
          _vm.$set(upload, "progress", $$v)
        },
        expression: "upload.progress"
      }
    })], 1)])
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.targetValue), function(file, idx) {
    return _c('div', {
      key: file.name
    }, [_c('DocumentView', {
      attrs: {
        "url": _vm.targetValue[idx].url,
        "type": _vm.targetValue[0].type
      }
    }, [_c('div', {
      staticClass: "file-row",
      class: {
        single: !_vm.schema.multiple
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIcon(file.type)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-wrap",
      staticStyle: {
        "color": "#888",
        "flex-grow": "1",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(file.name.replace(/-.{6}\./, '.')))]), _vm._v(" "), _c('div', [_c('ConfirmIcon', {
      staticStyle: {
        "top": "4px"
      },
      attrs: {
        "small": "",
        "corner": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(file)
        }
      }
    })], 1)])])], 1)
  }), _vm._v(" "), (_vm.uploaderVisible) ? _c('div', {
    staticClass: "display-flex full-width xxxpt-1"
  }, [_c('div', {
    staticClass: "file-upload",
    class: {
      'has-files': _vm.targetValue.length
    },
    staticStyle: {
      "flex-grow": "1"
    }
  }, [(_vm.linking) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    ref: "url",
    staticClass: "quick-input",
    staticStyle: {
      "margin": "-3px 0 -4px 0"
    },
    attrs: {
      "placeholder": "https://www.link.com/file  (ESC to Cancel)",
      "type": "text"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.hideLinking($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }) : _c('UploadWrapper', {
    attrs: {
      "multiple": _vm.schema.multiple
    },
    on: {
      "click": function($event) {},
      "select": _vm.uploadFiles
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-upload")]), _vm._v("Drag or Click to Upload\n                ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "file-upload",
    staticStyle: {
      "flex-basis": "100px",
      "border-left": "solid 1px #ccc",
      "position": "relative"
    },
    on: {
      "click": _vm.link
    }
  }, [(!_vm.linking) ? _c('div', {
    staticClass: "link-or elevation-1"
  }, [_vm._v("OR")]) : _vm._e(), _vm._v("\n                Link\n            ")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "100%"
    }
  }, [_c('div', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "condensed": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Templates")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_vm._v("\n                left column...\n            ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, _vm._l((_vm.sections), function(section) {
    return _c('Section', {
      key: section.key,
      attrs: {
        "section": section
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blue lighten-5",
    staticStyle: {
      "width": "300px",
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "condensed": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Editor")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('portal-target', {
    attrs: {
      "name": "sidebar"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "oldClass": "{'text-align-right': element.align == 'right'}"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _c('SortableList', {
    staticStyle: {
      "padding": "5px",
      "border-radius": "4px"
    },
    attrs: {
      "items": _vm.files,
      "itemWidth": "50%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var file = ref.item;

        return [_c('div', {
          staticClass: "clickable",
          staticStyle: {
            "padding": "2px 4px",
            "margin": "3px",
            "display": "flex",
            "border-radius": "8px",
            "background-color": "rgba(255,255,255,0.5)",
            "border": "solid 1px #ddd"
          }
        }, [_c('div', {
          staticClass: "pt-1 pr-1"
        }, [_c('v-icon', {
          attrs: {
            "large": "",
            "color": "blue lighten-2"
          }
        }, [_vm._v("mdi-file-document-outline")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "12px",
            "padding-top": "3px"
          }
        }, [_vm._v(_vm._s(_vm.fileNameFromStoragePath(file.url)))])])]
      }
    }, {
      key: "menu",
      fn: function(slotProps) {
        return [_c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.deleteFileFromGroup(slotProps.item)
            }
          }
        }, [_c('v-list-tile-title', [_vm._v("Delete this File")])], 1), _vm._v(" "), (slotProps.selectedItems.length > 1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              return _vm.deleteSelectedFiles(slotProps.selectedItems)
            }
          }
        }, [_c('v-list-tile-title', [_vm._v("Delete " + _vm._s(slotProps.selectedItems.length) + " Selected")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "transparent",
          attrs: {
            "href": slotProps.item.url,
            "target": "_blank"
          }
        }, [_c('v-list-tile', {
          on: {
            "click": function($event) {}
          }
        }, [_c('v-list-tile-title', [_vm._v("Open")])], 1)], 1)]
      }
    }])
  })], 1)]), _vm._v(" "), (!_vm.element.value) ? _c('template', {
    slot: "right"
  }, [_c('UploadWrapper', {
    on: {
      "click": _vm.doNothing,
      "select": _vm.uploadFiles
    }
  }, [_c('v-btn', {
    attrs: {
      "outline": "",
      "color": _vm.element.color,
      "disabled": _vm.element.disabled || _vm.uploading
    }
  }, [(_vm.uploading) ? _c('v-progress-circular', {
    attrs: {
      "size": "24",
      "indeterminate": "",
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.uploading) ? _c('span', [_vm._v("Upload")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step.type == 'heading') ? _c('div', {
    staticClass: "heading-label"
  }, [_vm._v(_vm._s(_vm.step.title))]) : _vm._e(), _vm._v(" "), (_vm.step.type == 'task') ? _c('div', {
    staticClass: "new-item-label"
  }, [_vm._v("\n        " + _vm._s(_vm.step.title) + "\n        "), (_vm.step.description && !_vm.step.expanded) ? _c('div', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.step.description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step.type == 'text') ? _c('v-text-field', {
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "value": _vm.step.value,
      "label": _vm.step.title,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.type == 'true-false/switch') ? _c('v-switch', {
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "color": "blue",
      "value": _vm.step.value,
      "label": _vm.step.title,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.type == 'true-false/checkbox') ? _c('v-checkbox', {
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "color": "blue",
      "value": _vm.step.value,
      "label": _vm.step.title,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateValue
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.type == 'file/upload') ? _c('FileUpload', {
    attrs: {
      "step": _vm.step
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Task Details",
      "settings": _vm.settings
    },
    on: {
      "save": _vm.saveDocument,
      "show": _vm.initialise
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Document Name"
    },
    model: {
      value: (_vm.document.name),
      callback: function($$v) {
        _vm.$set(_vm.document, "name", $$v)
      },
      expression: "document.name"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hide-details": "",
      "rows": "3",
      "label": "Description"
    },
    model: {
      value: (_vm.document.description),
      callback: function($$v) {
        _vm.$set(_vm.document, "description", $$v)
      },
      expression: "document.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Special Note",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.note),
      callback: function($$v) {
        _vm.$set(_vm.document, "note", $$v)
      },
      expression: "document.note"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Received",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.received),
      callback: function($$v) {
        _vm.$set(_vm.document, "received", $$v)
      },
      expression: "document.received"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Show Advanced Details",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.advanced),
      callback: function($$v) {
        _vm.$set(_vm.form, "advanced", $$v)
      },
      expression: "form.advanced"
    }
  })], 1), _vm._v(" "), (_vm.form.advanced) ? [_c('div', {
    staticClass: "section-heading mt-4"
  }, [_vm._v("Advanced")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Download Link",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.download),
      callback: function($$v) {
        _vm.$set(_vm.document, "download", $$v)
      },
      expression: "document.download"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Save as Template",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.saveAsTemplate),
      callback: function($$v) {
        _vm.$set(_vm.form, "saveAsTemplate", $$v)
      },
      expression: "form.saveAsTemplate"
    }
  }), _vm._v(" "), (_vm.form.saveAsTemplate) ? [_c('v-select', {
    attrs: {
      "items": _vm.lenders,
      "hide-details": "",
      "label": "Lender"
    },
    model: {
      value: (_vm.document.lender),
      callback: function($$v) {
        _vm.$set(_vm.document, "lender", $$v)
      },
      expression: "document.lender"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Category"
    },
    model: {
      value: (_vm.document.category),
      callback: function($$v) {
        _vm.$set(_vm.document, "category", $$v)
      },
      expression: "document.category"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Title"
    },
    model: {
      value: (_vm.document.title),
      callback: function($$v) {
        _vm.$set(_vm.document, "title", $$v)
      },
      expression: "document.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Option Name"
    },
    model: {
      value: (_vm.document.option),
      callback: function($$v) {
        _vm.$set(_vm.document, "option", $$v)
      },
      expression: "document.option"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Global",
      "hide-details": ""
    },
    model: {
      value: (_vm.document.global),
      callback: function($$v) {
        _vm.$set(_vm.document, "global", $$v)
      },
      expression: "document.global"
    }
  })] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('textarea-autosize', {
    ref: "commentBox",
    staticClass: "quick-input white-background add-comment",
    attrs: {
      "placeholder": _vm.placeHolder,
      "min-height": 30,
      "max-height": 350,
      "type": "text"
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 68) { return null; }
        if (!$event.ctrlKey) { return null; }
        $event.preventDefault();
        return _vm.demoData($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 68) { return null; }
        if (!$event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.demoData($event)
      }],
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.saveComment($event)
      }
    },
    model: {
      value: (_vm.currentComment.text),
      callback: function($$v) {
        _vm.$set(_vm.currentComment, "text", $$v)
      },
      expression: "currentComment.text"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1px",
      "margin-left": "-6px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.showAllComments
    }
  }, [_c('v-list-item-title', [_vm._v("Show All")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.snippets), function(snippet) {
    return _c('v-list-item', {
      key: snippet.title,
      on: {
        "click": function($event) {
          return _vm.useSnippet(snippet)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(snippet.title))])], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.key,
      staticClass: "comment selectable hoverable",
      class: {
        selected: comment.selected, important: comment.important
      },
      on: {
        "click": [function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.selectSingle(comment)
        }, function($event) {
          if (!$event.shiftKey) { return null; }
          return _vm.selectRange(comment)
        }, function($event) {
          if (!$event.metaKey) { return null; }
          return _vm.selectMulti(comment)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          return _vm.selectMulti(comment)
        }]
      }
    }, [_c('div', {
      staticClass: "indicator"
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-1px",
        "margin-right": "-7px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeTask(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Task Me Tomorrow")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.scheduleTask(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Schedule Task")])], 1), _vm._v(" "), (!comment.important) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeImportant(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Important")])], 1) : _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.removeImportant(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Not Important")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editComment(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteComment(comment)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1)], 1)], 1)], 1), _vm._v(" "), (comment.complete) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check_circle_outline")]) : _vm._e(), _vm._v(" "), _c('span', {
      class: {
        'comment-complete': comment.complete, 'comment-milestone': comment.milestone
      },
      domProps: {
        "innerHTML": _vm._s(_vm.lineBreaks(comment.text))
      }
    }), _vm._v(" "), (comment.complete) ? _c('span', [_vm._v("- Completed")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "grey--text text--lighten small-text"
    }, [_vm._v(_vm._s(_vm.stamp(comment)))])], 1)])
  }), _vm._v(" "), (!_vm.allCommentsMode) ? _c('div', {
    staticClass: "grey--text",
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.comments.length || 'No') + " '" + _vm._s(_vm.commentType) + "' comments \n        "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAllComments($event)
      }
    }
  }, [_vm._v("Show all")])]) : _vm._e(), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "offset-y": "",
      "nudge-right": 10,
      "max-height": 400
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "div-button rounded",
          staticStyle: {
            "display": "flex"
          }
        }, on), [_c('img', {
          staticClass: "round",
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "width": "30",
            "height": "30",
            "src": _vm.image
          }
        }), _vm._v(" "), _c('div', {
          staticStyle: {
            "line-height": "1.5"
          }
        }, [_c('div', {
          staticStyle: {
            "xmargin-top": "-5px",
            "color": "#888",
            "font-size": "9px",
            "text-align": "left",
            "text-transform": "uppercase"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.label) + "\n              ")]), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-top": "-4px",
            "font-size": "14px"
          }
        }, [_vm._v(_vm._s(_vm.fullName(_vm.value)))])])])]
      }
    }], null, false, 761187896)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.users), function(user) {
    return _c('v-list-item', {
      key: user.uid,
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      staticStyle: {
        "height": "28px",
        "width": "28px"
      },
      attrs: {
        "src": user.image
      }
    })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.fullName(user)))])], 1)], 1)
  }), 1)], 1)], 1) : _c('div', [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "offset-y": "",
      "nudge-right": 10
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "div-button rounded display-flex"
        }, on), [_c('v-icon', {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "large": "",
            "color": "grey lighten-2"
          }
        }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-top": "5px",
            "color": "#888"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.label) + "\n          ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.users), function(user) {
    return _c('v-list-item', {
      key: user.uid,
      on: {
        "click": function($event) {
          return _vm.selectUser(user)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      staticStyle: {
        "height": "28px",
        "width": "28px"
      },
      attrs: {
        "src": user.image
      }
    })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(_vm.fullName(user)))])], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-icon",
    class: {
      corner: _vm.corner
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-top": 18
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "border-radius": "99px",
            "background-color": "rgba(255,255,255,0.3)"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
            }
          }
        }, on), [_c('v-btn', {
          attrs: {
            "small": _vm.small,
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "small": _vm.small
          }
        }, [_vm._v("close")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "pa-4 center-text"
  }, [_c('div', [_vm._v("\n                Are you sure?\n            ")]), _vm._v(" "), _c('div', [_c('v-icon', {
    staticClass: "alert-icon grey--text text--lighten-2",
    class: {
      small: _vm.small
    }
  }, [_vm._v("mdi-alert-circle")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "error",
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-select', {
    attrs: {
      "items": _vm.typeOptions,
      "disabled": _vm.isTypeDisabled,
      "label": "Type",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.type),
      callback: function($$v) {
        _vm.$set(_vm.element, "type", $$v)
      },
      expression: "element.type"
    }
  }), _vm._v(" "), (_vm.isVisible('title')) ? _c('v-text-field', {
    attrs: {
      "label": "Title",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.title),
      callback: function($$v) {
        _vm.$set(_vm.element, "title", $$v)
      },
      expression: "element.title"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('name')) ? _c('v-text-field', {
    attrs: {
      "label": "Name",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.name),
      callback: function($$v) {
        _vm.$set(_vm.element, "name", $$v)
      },
      expression: "element.name"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Display")]), _vm._v(" "), (_vm.isVisible('width')) ? _c('v-slider', {
    staticClass: "mr-1",
    attrs: {
      "hide-details": "",
      "label": _vm.widthLabel,
      "step": 10
    },
    model: {
      value: (_vm.element.width),
      callback: function($$v) {
        _vm.$set(_vm.element, "width", $$v)
      },
      expression: "element.width"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('height')) ? _c('v-select', {
    attrs: {
      "items": _vm.heightOptions,
      "label": "Height",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.height),
      callback: function($$v) {
        _vm.$set(_vm.element, "height", $$v)
      },
      expression: "element.height"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('background-colour')) ? _c('ColourBar', {
    attrs: {
      "colours": ['#eee', '#ddd', '#dff3fe'],
      "label": "Background Colour"
    },
    model: {
      value: (_vm.element.background),
      callback: function($$v) {
        _vm.$set(_vm.element, "background", $$v)
      },
      expression: "element.background"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Data")]), _vm._v(" "), (_vm.isVisible('table')) ? _c('v-text-field', {
    attrs: {
      "label": "Table"
    },
    model: {
      value: (_vm.element.table),
      callback: function($$v) {
        _vm.$set(_vm.element, "table", $$v)
      },
      expression: "element.table"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('default-value-textarea')) ? _c('v-textarea', {
    attrs: {
      "rows": "3",
      "label": "Default Value"
    },
    model: {
      value: (_vm.element.defaultValue),
      callback: function($$v) {
        _vm.$set(_vm.element, "defaultValue", $$v)
      },
      expression: "element.defaultValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('options')) ? _c('v-text-field', {
    attrs: {
      "label": "Available Options",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.options),
      callback: function($$v) {
        _vm.$set(_vm.element, "options", $$v)
      },
      expression: "element.options"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Actions")]), _vm._v(" "), (_vm.isVisible('add-column')) ? _c('v-btn', {
    staticClass: "element-action-button",
    attrs: {
      "outline": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buttonClicked('add-column')
      }
    }
  }, [_vm._v("Add Column")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('save-section')) ? _c('v-btn', {
    staticClass: "element-action-button",
    attrs: {
      "outline": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buttonClicked('save-section')
      }
    }
  }, [_vm._v("Save Section")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('clone-element')) ? _c('v-btn', {
    staticClass: "element-action-button",
    attrs: {
      "outline": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buttonClicked('clone-element')
      }
    }
  }, [_vm._v("Clone Element")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "leftVisible": false,
      "uniform-colour": ""
    }
  }, [_c('v-app-bar', {
    attrs: {
      "slot": "header",
      "flat": "",
      "dark": "",
      "dense": "",
      "color": "blue"
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v("John and June Citizen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('ToolbarSearch', {
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.page.saveAll()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Save All")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "raised-desktop"
  }, [_c('Flow', {
    attrs: {
      "id": _vm.flowId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "raised-desktop white-background",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('StepDesigner'), _vm._v(" "), _c('FlowActivity')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "persistent": ""
    },
    model: {
      value: (_vm.makingActivity),
      callback: function($$v) {
        _vm.makingActivity = $$v
      },
      expression: "makingActivity"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    attrs: {
      "id": "activityDescription"
    },
    model: {
      value: (_vm.page.newComment),
      callback: function($$v) {
        _vm.$set(_vm.page, "newComment", $$v)
      },
      expression: "page.newComment"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    staticClass: "white-background",
    staticStyle: {
      "position": "relative",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('ListList', {
    attrs: {
      "items": _vm.items
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "5px",
      "bottom": "10px",
      "width": "60px"
    }
  }, [_c('v-btn', {
    attrs: {
      "right": "",
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "large": ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)], 1), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "pa-10 white ma-7 elevation-3",
    staticStyle: {
      "position": "relative",
      "xbackground-color": "rgba(0,0,0,0.0)"
    }
  }, [_c('ConfirmIcon', {
    attrs: {
      "corner": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteCurrent()
      }
    }
  }), _vm._v(" "), _c('FormControl', {
    ref: "itemForm",
    attrs: {
      "schema": _vm.proofSchema
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}

/***/ }),
/* 2484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.step) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('v-system-bar', {
    staticClass: "mb-5",
    attrs: {
      "window": "",
      "rounded": ""
    }
  }, [_vm._v(_vm._s(_vm.step.title))]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Title",
      "hide-details": ""
    },
    model: {
      value: (_vm.step.title),
      callback: function($$v) {
        _vm.$set(_vm.step, "title", $$v)
      },
      expression: "step.title"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Used in templates and formulas",
      "dense": ""
    },
    model: {
      value: (_vm.usedInTemplates),
      callback: function($$v) {
        _vm.usedInTemplates = $$v
      },
      expression: "usedInTemplates"
    }
  }), _vm._v(" "), (_vm.usedInTemplates) ? _c('v-text-field', {
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Name"
    },
    model: {
      value: (_vm.step.name),
      callback: function($$v) {
        _vm.$set(_vm.step, "name", $$v)
      },
      expression: "step.name"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Type",
      "items": _vm.stepTypes
    },
    model: {
      value: (_vm.step.type),
      callback: function($$v) {
        _vm.$set(_vm.step, "type", $$v)
      },
      expression: "step.type"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "xoutlined": "",
      "dense": "",
      "label": "Importance",
      "items": _vm.importanceLevels
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticStyle: {
            "padding-left": "10px",
            "background-size": "120px",
            "background-position": "0px 0px",
            "width": "100%",
            "min-width": "200px"
          },
          style: (_vm.getBackgroundStyle(item.value))
        }, [_vm._v(_vm._s(item.text))])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticStyle: {
            "padding-left": "10px",
            "background-size": "120px",
            "background-position": "0px 0px",
            "width": "100%",
            "min-width": "200px"
          },
          style: (_vm.getBackgroundStyle(item.value))
        }, [_vm._v(_vm._s(item.text))])]
      }
    }], null, false, 2106109692),
    model: {
      value: (_vm.step.important),
      callback: function($$v) {
        _vm.$set(_vm.step, "important", $$v)
      },
      expression: "step.important"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.prefix) ? [_vm._v(_vm._s(_vm.prefix))] : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-bottom": 0
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({
          staticClass: "label-menu",
          class: {
            'label-menu-hoverable': !_vm.underline
          }
        }, on), [_c('span', {
          class: {
            'dotted-underline': _vm.underline
          }
        }, [_vm._v("\n                " + _vm._s(_vm.buttonText) + "\n            ")]), _vm._v(" "), (!_vm.underline) ? _c('v-icon', [_vm._v("mdi-menu-down")]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(menu, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.menuClicked(menu)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(menu.text || menu.value))])], 1)
  }), 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "left-wider": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Taco Email Logs")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.loading == 'loaded') ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }], null, false, 892639569)
  }, [_vm._v(" "), _c('v-list', [(_vm.isAdministrator) ? _c('v-list-item', {
    on: {
      "click": _vm.showAll
    }
  }, [_c('v-list-item-title', [_vm._v("Show All")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.testMail('sendgrid')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Send Me a Test")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.testMail('smtp2go')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Send Me Test via Smtp2Go")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
    on: {
      "click": _vm.openConsole
    }
  }, [_c('v-list-item-title', [_vm._v("Open in Console")])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (this.loading == 'loading') ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "indeterminate": ""
    },
    on: {
      "click": function($event) {
        this.loading = ''
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "grey lighten-2",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [(_vm.email) ? _c('v-chip', {
    staticClass: "ma-3",
    attrs: {
      "color": "primary",
      "close": ""
    },
    on: {
      "click:close": function($event) {
        return _vm.setEmail(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.email.split('@')[0]))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.logs), function(log, logIndex) {
    return _c('div', {
      key: logIndex,
      staticClass: "clickable log-tile",
      class: {
        'blue-hilight': _vm.isLogSelected(log)
      },
      on: {
        "click": function($event) {
          return _vm.selectLog(log._id)
        }
      }
    }, [_c('div', {
      staticClass: "bullet",
      class: {
        'green': _vm.logAllSuccessful(log), 'red': _vm.logHasProblems(log)
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.summariseTo(log.email.to)))]), _vm._v(" "), _c('span', {
      staticClass: "small-text light-text"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(log.createdAt)))]), _c('br'), _vm._v("\n            " + _vm._s(log.email.subject) + "\n        ")])
  }), _vm._v(" "), (this.limit == this.logs.length) ? _c('div', {
    staticClass: "pa-2"
  }, [_c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.limit = _vm.limit + 100
      }
    }
  }, [_vm._v("More")])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', [(this.logId && this.loading == 'loaded') ? _c('div', {
    staticClass: "pa-5 main-content"
  }, [_c('div', {
    staticClass: "pa-3 white rounded elevation-0"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("To")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listTo(_vm.selectedLog.email.to)))])]), _vm._v(" "), (_vm.listTo(_vm.selectedLog.email.cc)) ? _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Cc")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listTo(_vm.selectedLog.email.cc)))])]) : _vm._e(), _vm._v(" "), (_vm.listTo(_vm.selectedLog.email.bcc)) ? _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Bcc")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listTo(_vm.selectedLog.email.bcc)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("From")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedLog.email.from))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Subject")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedLog.email.subject))])]), _vm._v(" "), (_vm.selectedLog.email.attachments && _vm.selectedLog.email.attachments.length) ? _c('tr', [_c('td', {
    staticClass: "layout-heading"
  }, [_vm._v("Files")]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.attachmentsToHtml(_vm.selectedLog.email.attachments))
    }
  })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "solid 1px #ddd",
      "padding-top": "12px",
      "margin-top": "7px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLog.email.body)
    }
  })])])])]), _vm._v(" "), (!_vm.advanced) ? _c('v-btn', {
    staticClass: "mt-5",
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.advanced = true
      }
    }
  }, [_vm._v("Advanced")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-5 ml-2",
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("Resend")]), _vm._v(" "), (_vm.advanced && _vm.selectedLog.info) ? _c('div', {
    staticClass: "pa-3 white rounded elevation-2 mt-3 word-wrap"
  }, [_c('b', [_vm._v("Accepted addresses:")]), _c('br'), _vm._v(" "), _vm._l((_vm.selectedLog.info.accepted), function(address, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                    " + _vm._s(address) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Rejected addresses:")]), _c('br'), _vm._v(" "), _vm._l((_vm.selectedLog.info.rejected), function(address, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n                    " + _vm._s(address) + "\n                ")])
  }), _vm._v(" "), (_vm.selectedLog.info.rejected.length === 0) ? _c('div', [_vm._v("None")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Nerdy Stuff")]), _c('br'), _vm._v("\n                mailId: " + _vm._s(_vm.selectedLog.mailId) + "\n                sendgridId: " + _vm._s(_vm.selectedLog.sendgridId) + "\n                " + _vm._s(JSON.stringify(_vm.selectedLog.info)) + "\n                "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Statuses")]), _vm._v(" "), _vm._l((_vm.selectedLog.statuses), function(statusVal, statusName, index) {
    return _c('div', {
      key: 'sts-' + index
    }, [_c('b', [_vm._v(_vm._s(statusName))]), _vm._v(" " + _vm._s(statusVal) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Events")]), _vm._v(" "), _vm._l((_vm.selectedLog.events), function(event, eventName, index) {
    return _c('div', {
      key: 'evt-' + index
    }, [_c('b', [_vm._v(_vm._s(eventName))]), _vm._v("\n                    " + _vm._s(JSON.stringify(event)) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Activity")]), _vm._v(" "), _vm._l((_vm.selectedLog.activities), function(activity, index) {
    return _c('div', {
      key: 'act-' + index
    }, [_c('b', [_vm._v(_vm._s(activity.event))]), _vm._v(" " + _vm._s(JSON.stringify(activity)) + "\n                ")])
  }), _vm._v(" "), _c('b', [_vm._v("Email")]), _vm._v("\n                " + _vm._s(JSON.stringify(_vm.selectedLog.email)) + "\n            ")], 2) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.selectedLog._id) ? _c('div', {
    staticClass: "pa-6 ma-5 white rounded activity-panel"
  }, [(_vm.queuedActivity(_vm.selectedLog)) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-icon', {
    staticClass: "blue--text",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "5px"
    }
  }, [_vm._v("view_week")]), _vm._v(" "), _c('div', {
    staticClass: "activity-description"
  }, [_vm._v(_vm._s(_vm.queuedActivity(_vm.selectedLog).event) + " " + _vm._s(_vm._f("time")(_vm.queuedActivity(_vm.selectedLog).time)))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vertical-line show-line"
  }), _vm._v(" "), (_vm.sentActivity(_vm.selectedLog)) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-icon', {
    staticClass: "blue--text",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "5px"
    }
  }, [_vm._v("local_post_office")]), _vm._v(" "), _c('div', {
    staticClass: "activity-description"
  }, [_vm._v(_vm._s(_vm.sentActivity(_vm.selectedLog).event) + " " + _vm._s(_vm._f("time")(_vm.sentActivity(_vm.selectedLog).time)))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vertical-line show-line"
  }), _vm._v(" "), (_vm.selectedLog.info) ? [_vm._l((_vm.selectedLog.info.accepted), function(email, index) {
    return _c('div', {
      key: 'eml-' + index,
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('v-tooltip', {
      attrs: {
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            staticClass: "recipient-bubble hoverable clickable",
            staticStyle: {
              "display": "flex"
            },
            on: {
              "click": function($event) {
                return _vm.setEmail(email)
              }
            }
          }, on), [_c('v-icon', {
            staticClass: "mr-1 grey--text"
          }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', [_c('div', {
            staticStyle: {
              "font-size": "14px",
              "margin-top": "-2px"
            }
          }, [_vm._v(_vm._s(email.split('@')[0]))]), _vm._v(" "), _c('div', {
            staticStyle: {
              "font-size": "10px",
              "margin-top": "-3px",
              "color": "#777"
            }
          }, [_vm._v("@" + _vm._s(email.split('@')[1]))])])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("See all my emails to " + _vm._s(email.split('@')[0]))])]), _vm._v(" "), _c('div', {
      staticClass: "vertical-line show-line"
    }), _vm._v(" "), _vm._l((_vm.getActivitiesForEmail(email)), function(activity, index) {
      return _c('div', {
        key: 'ue-' + index
      }, [_c('div', {
        staticStyle: {
          "display": "flex"
        }
      }, [(activity.event != 'deferred' && activity.event != 'bounce' && activity.event != 'open' && activity.event != 'dropped') ? _c('v-icon', {
        staticClass: "activity-icon blue--text"
      }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" "), (activity.event == 'deferred') ? _c('v-icon', {
        staticClass: "activity-icon orange--text"
      }, [_vm._v("watch_later")]) : _vm._e(), _vm._v(" "), (activity.event == 'bounce' || activity.event == 'dropped') ? _c('v-icon', {
        staticClass: "activity-icon red--text"
      }, [_vm._v("offline_bolt")]) : _vm._e(), _vm._v(" "), (activity.event == 'open') ? _c('v-icon', {
        staticClass: "activity-icon blue--text"
      }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "activity-description"
      }, [_vm._v(_vm._s(activity.event) + " " + _vm._s(_vm._f("time")(activity.time)))])], 1), _vm._v(" "), _c('div', {
        staticClass: "vertical-line",
        class: {
          'show-line': (index < _vm.getActivitiesForEmail(email).length - 1)
        }
      }, [_vm._v("\n                        " + _vm._s(activity.message) + "\n                    ")])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-5 small-text light-text"
  }, [_vm._v("\n            Sent with Taco " + _vm._s(_vm.selectedLog.provider) + "\n        ")])]), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    style: ({
      zIndex: _vm.options.zIndex
    }),
    attrs: {
      "max-width": _vm.options.width
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": _vm.options.color,
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.message),
      expression: "!!message"
    }],
    staticClass: "pa-4"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary darken-1",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-box",
    class: _vm.colourClass
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.menuVisible = !_vm.menuVisible
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n        "), _c('v-menu', {
    staticClass: "button",
    attrs: {
      "value": _vm.menuVisible,
      "left": "",
      "nudge-bottom": 7,
      "nudge-right": 9,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "small": "",
            "icon": ""
          }
        }, on), [_c('v-icon', {
          staticClass: "button"
        }, [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.optionsList), function(item, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.selectItem(item)
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', {
      class: _vm.textColourClass(item.colour)
    }, [_vm._v("label")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.label))])], 1)], 1)
  }), 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-list",
    class: {
      horizontal: _vm.horizontal
    }
  }, _vm._l((_vm.schema), function(field, fieldIndex) {
    return _c('div', {
      key: fieldIndex,
      style: (_vm.sectionStyle(field))
    }, [_c('DynamicControl', {
      key: fieldIndex,
      attrs: {
        "value": _vm.value[field.name],
        "context": _vm.context,
        "record": _vm.value,
        "schema": field
      },
      on: {
        "change": function($event) {
          var i = arguments.length, argsArray = Array(i);
          while ( i-- ) argsArray[i] = arguments[i];

          return _vm.emitChanges.apply(void 0, argsArray.concat( [field.name] ))
        }
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " white-background pa-5 rounded ma-1"
  }, _vm._l((_vm.$page.activities), function(activity) {
    return _c('div', {
      staticClass: "flow-activity clickable hoverable ma-1"
    }, [_c('SpeechBubble', {
      attrs: {
        "activity": activity
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    staticClass: "white-background",
    staticStyle: {
      "position": "relative",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "white responsive-boundary",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FormBlock', {
    ref: "block",
    attrs: {
      "schema": _vm.scenarioSchema,
      "context": _vm.formContext
    },
    on: {
      "change": _vm.formChanged
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa-4 white",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v("\n\n        " + _vm._s(_vm.formContext.focusedField) + "\n        "), _c('Activities', {
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "activities": _vm.someComments
    }
  }), _vm._v(" "), _vm._l((_vm.requests), function(request) {
    return _c('div', {
      key: request._id
    }, [_vm._v("\n            " + _vm._s(request.name) + "\n            "), _c('div', {
      staticClass: "light-text"
    }, [_vm._v("\n                " + _vm._s(_vm.policyAsText(request.policy)) + "\n            ")])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-view",
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._t("default", [(_vm.hasImage) ? _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": " ",
      "src": _vm.url
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasPdf) ? [_c('object', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "data": _vm.url,
      "type": _vm.type
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n                alt: "), _c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("Open")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "dark": "",
      "color": "grey lighten-1 mb-3",
      "width": 150
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("Open")])] : _vm._e()])], 2), _vm._v(" "), (_vm.dialogVisible) ? _c('div', {
    staticClass: "simple-dialog",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "centered",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.hasImage) ? _c('div', {
    staticStyle: {
      "max-height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "top",
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": " ",
      "src": _vm.url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.hasPdf) ? _c('object', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%%",
      "width": "800px",
      "height": "800px"
    },
    attrs: {
      "data": _vm.url,
      "type": "application/pdf"
    }
  }, [_vm._v("\n                alt: "), _c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("Open")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hover-bar"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "border-right": "solid 1px #555"
    }
  }, [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                    New Tab\n                ")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("\n                    Close\n                ")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.fields), function(field, index) {
    return _c('InterfaceField', {
      key: index,
      attrs: {
        "field": field,
        "record": _vm.record,
        "settings": {
          editing: false
        },
        "element": field
      },
      on: {
        "change": _vm.fieldChanged,
        "input": _vm.fieldInput,
        "button": _vm.buttonClicked
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-layout"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "search",
    staticClass: "search-box no-border",
    class: {
      showing: _vm.searchVisible
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keydown": [_vm.debouncedRunSearch, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterRunSearch($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelSearch($event)
      }],
      "blur": _vm.lostFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": _vm.toggleSearchVisibility
    }
  }, [(_vm.searchVisible) ? _c('v-icon', [_vm._v("close")]) : _c('v-icon', [_vm._v("search")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.page.sections), function(section) {
    return _c('SectionLayout', {
      key: section.key,
      attrs: {
        "section": section
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('v-card', {
    staticClass: "show-print"
  }, [_c('v-card-title', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.dialogTitle || 'Send Email'))]), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.minimise
    }
  }, [_c('v-icon', [_vm._v("remove")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": ("/templates/" + (_vm.template.key)),
      "target": "_blank"
    }
  }, [_c('v-list-item', {
    on: {
      "click": function($event) {
        1
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Open this Template")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {}
    }
  }, [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": _vm.mailToLink,
      "target": "_blank"
    }
  }, [_c('v-list-item-title', [_vm._v("Send via my normal Email")])], 1)]), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.sendTestEmail
    }
  }, [_c('v-list-item-title', [_vm._v("Send a Test Email")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "max-height": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "recipient-heading"
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('ContactAutocomplete', {
    key: 1,
    attrs: {
      "items": _vm.contactsWithEmail
    },
    on: {
      "change": _vm.mergeGreeting
    },
    model: {
      value: (_vm.email.to),
      callback: function($$v) {
        _vm.$set(_vm.email, "to", $$v)
      },
      expression: "email.to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-1 recipient-heading"
  }, [_c('div', {
    staticClass: "hoverable clickable rounded full-height pr-2 pt-1",
    class: {
      'blue-hilight': _vm.hasRecipientsCopied
    },
    on: {
      "click": function($event) {
        _vm.showCC = !_vm.showCC
      }
    }
  }, [_vm._v("\n                            CC\n                        ")])])]), _vm._v(" "), (_vm.showCC) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "recipient-heading"
  }, [_vm._v("Cc")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('ContactAutocomplete', {
    attrs: {
      "items": _vm.contactsWithEmail
    },
    model: {
      value: (_vm.email.cc),
      callback: function($$v) {
        _vm.$set(_vm.email, "cc", $$v)
      },
      expression: "email.cc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "recipient-heading"
  }, [_vm._v("Bcc")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('ContactAutocomplete', {
    attrs: {
      "items": _vm.contactsWithEmail
    },
    model: {
      value: (_vm.email.bcc),
      callback: function($$v) {
        _vm.$set(_vm.email, "bcc", $$v)
      },
      expression: "email.bcc"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "0px 20px 0px 20px",
      "font-size": "14px"
    },
    attrs: {
      "label": "Subject",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.subjectChanged
    },
    model: {
      value: (_vm.email.subject),
      callback: function($$v) {
        _vm.$set(_vm.email, "subject", $$v)
      },
      expression: "email.subject"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pt-2",
    staticStyle: {
      "width": "70px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "text": "",
            "color": "grey"
          }
        }, on), [_c('v-badge', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_c('span', {
          attrs: {
            "slot": "badge"
          },
          slot: "badge"
        }, [_vm._v(_vm._s(_vm.templates.length))]), _vm._v(" "), _c('v-icon', [_vm._v("more")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.templates), function(template) {
    return _c('v-list-item', {
      key: template.key,
      on: {
        "click": function($event) {
          return _vm.selectTemplate(template)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(template.name))])], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('HtmlEditor', {
    model: {
      value: (_vm.email.body),
      callback: function($$v) {
        _vm.$set(_vm.email, "body", $$v)
      },
      expression: "email.body"
    }
  }), _vm._v(" "), (_vm.showAttachments) ? _c('div', [_c('v-combobox', {
    staticStyle: {
      "margin": "0px 20px 0px 20px"
    },
    attrs: {
      "items": _vm.files,
      "single-line": "",
      "hide-details": "",
      "label": "Attachments",
      "chips": "",
      "multiple": "",
      "return-object": "",
      "item-text": "fileName"
    },
    model: {
      value: (_vm.email.attachments),
      callback: function($$v) {
        _vm.$set(_vm.email, "attachments", $$v)
      },
      expression: "email.attachments"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "3px",
      "flex-grow": "1"
    },
    attrs: {
      "xxxclass": "v-box clickable"
    }
  }, [(_vm.from.special) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("alternate_email")])], 1)]
      }
    }], null, false, 3468281524)
  }, [_vm._v(" "), _c('span', [_vm._v("Sending via " + _vm._s(_vm.from.email))])]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showAttachments = !_vm.showAttachments
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey darken-1"
          }
        }, [_vm._v("attach_file")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Attachments")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.urgent = !_vm.urgent
            }
          }
        }, on), [(_vm.urgent) ? _c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("notifications")]) : _c('v-icon', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("notifications")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Alert by SMS")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.print
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("print")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Print email")])]), _vm._v(" "), (_vm.urgent) ? _c('span', {
    staticClass: "grey--text"
  }, [_vm._v("SMS will also be sent")]) : _vm._e(), _vm._v(" "), (_vm.validationErrors) ? _c('span', {
    staticClass: "red--text",
    domProps: {
      "innerHTML": _vm._s(_vm.validationErrors)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "padding": "3px",
      "min-width": "220px"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.cancelClicked
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (this.validationErrors) ? [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": "",
            "disabled": ""
          }
        }, on), [_vm._v("Send")])]
      }
    }], null, false, 3493161756)
  }, [_vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.validationErrors)
    }
  })])] : [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.sendClicked
    }
  }, [_vm._v(_vm._s(_vm.sendLabel))])]], 2)])])], 1)], 1), _vm._v(" "), (_vm.settings.minimised) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "width": "300px"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.dialogTitle))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.maximise
    }
  }, [_c('v-icon', [_vm._v("web_asset")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-layout"
  }, [_c('div', {
    staticClass: "no-print"
  }, [_vm._t("header", [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "flat": "",
      "dark": "",
      "dense": "",
      "xxstyle": "z-index:8;position:fixed;"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.rightColumnActive = !_vm.rightColumnActive
      }
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-area",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.leftVisible) ? _c('div', {
    staticClass: "column left-column no-print",
    class: {
      'active': _vm.leftColumnActive, 'wider': _vm.leftWider, 'uniform': _vm.uniformColour
    }
  }, [_vm._t("left", [_vm._v("\n                Left slot "), _vm._l((20), function(n) {
    return _c('span', [_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!")])
  }), _vm._v(" End left slot\n            ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "middleColumn",
    staticClass: "column middle-column",
    attrs: {
      "id": "middle-column"
    }
  }, [_vm._t("default", [_vm._v("\n                Default slot "), _vm._l((30), function(n) {
    return _c('span', [_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!")])
  }), _vm._v(" End default slot                \n            ")])], 2), _vm._v(" "), (_vm.rightVisible) ? _c('div', {
    staticClass: "column right-column no-print",
    class: {
      'active': _vm.rightColumnActive, 'uniform': _vm.uniformColour
    }
  }, [_vm._t("right", [_vm._v("\n                Right slot "), _vm._l((20), function(n) {
    return _c('span', [_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!")])
  }), _vm._v(" End right slot\n            ")])], 2) : _vm._e(), _vm._v(" "), (_vm.leftButtonVisible) ? _c('div', {
    staticClass: "expander left-expander clickable no-print",
    class: {
      'active': _vm.leftColumnActive
    },
    on: {
      "click": _vm.expandLeft
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_right")])], 1) : _vm._e(), _vm._v(" "), (_vm.rightButtonVisible) ? _c('div', {
    staticClass: "expander clickable right-expander no-print",
    class: {
      'active': _vm.rightColumnActive
    },
    on: {
      "click": _vm.expandRight
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), (_vm.leftColumnActive) ? _c('div', {
    staticClass: "overlay left-overlay",
    on: {
      "click": _vm.overlayClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightColumnActive) ? _c('div', {
    staticClass: "overlay right-overlay",
    on: {
      "click": _vm.overlayClicked
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    ref: "textbox",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.label,
      "value": _vm.displayDate,
      "hide-details": _vm.hideDetails,
      "persistent-hint": !_vm.hideDetails,
      "hint": _vm.dueString(_vm.value)
    },
    on: {
      "change": _vm.changed,
      "focus": _vm.focused,
      "blur": _vm.blurred,
      "dblclick": function($event) {
        $event.stopPropagation();
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", [_vm._v("\n    ** AutomaticScroll Component **\n")])], 2)
},staticRenderFns: []}

/***/ }),
/* 2500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.duplicate) ? _c('v-alert', {
    attrs: {
      "dense": "",
      "text": "",
      "dismissible": "",
      "icon": "offline_bolt",
      "type": "warning"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.duplicate.firstName) + " " + _vm._s(_vm.duplicate.lastName) + " (" + _vm._s(_vm.duplicate.email) + ") already exists. Only proceed if you are sure this is not a duplicate.\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Action Name"
    },
    model: {
      value: (_vm.action.name),
      callback: function($$v) {
        _vm.$set(_vm.action, "name", $$v)
      },
      expression: "action.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field"
    },
    model: {
      value: (_vm.action.field),
      callback: function($$v) {
        _vm.$set(_vm.action, "field", $$v)
      },
      expression: "action.field"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.actionTypes,
      "item-text": "name",
      "item-value": "name",
      "label": "Action Type"
    },
    model: {
      value: (_vm.action.type),
      callback: function($$v) {
        _vm.$set(_vm.action, "type", $$v)
      },
      expression: "action.type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Expression"
    },
    model: {
      value: (_vm.action.expression),
      callback: function($$v) {
        _vm.$set(_vm.action, "expression", $$v)
      },
      expression: "action.expression"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "label": "Create"
    },
    model: {
      value: (_vm.action.operationCreate),
      callback: function($$v) {
        _vm.$set(_vm.action, "operationCreate", $$v)
      },
      expression: "action.operationCreate"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "label": "Update"
    },
    model: {
      value: (_vm.action.operationUpdate),
      callback: function($$v) {
        _vm.$set(_vm.action, "operationUpdate", $$v)
      },
      expression: "action.operationUpdate"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "single-line": "",
      "hide-details": "",
      "label": "Delete"
    },
    model: {
      value: (_vm.action.operationDelete),
      callback: function($$v) {
        _vm.$set(_vm.action, "operationDelete", $$v)
      },
      expression: "action.operationDelete"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.action._id) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 2502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "checklist"
  }, [_vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category.meta.key,
      staticStyle: {
        "xxxxxbackground-color": "#fafafa",
        "max-width": "800px"
      }
    }, [_c('v-menu', {
      staticClass: "full-width",
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [(!_vm.clientOrEmail) ? _c('div', _vm._g({
            staticClass: "section-heading full-width hoverable",
            on: {
              "dblclick": function($event) {
                return _vm.editCategory(category)
              }
            }
          }, on), [_vm._v("\n                " + _vm._s(category.name) + "\n            ")]) : _vm._e()]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('add-category-document', category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add " + _vm._s(category.name) + " Document")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteCategory(category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Category")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.sortCategories
      }
    }, [_c('v-list-item-title', [_vm._v("Sort Categories")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addCategory
      }
    }, [_c('v-list-item-title', [_vm._v("Add Another Category")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.policiesForCategory(category)), function(policy) {
      return _c('div', {
        key: policy.meta.key,
        staticClass: "item-pulse"
      }, [_c('v-menu', {
        staticClass: "xxxxdisplay-block hoverable",
        attrs: {
          "offset-y": "",
          "disabled": _vm.clientOrEmail
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('div', _vm._g({
              staticStyle: {
                "font-size": "20px",
                "color": "#1976d2",
                "padding": "2px 5px"
              },
              on: {
                "dblclick": function($event) {
                  return _vm.editPolicy(policy)
                }
              }
            }, on), [_vm._v(_vm._s(policy.name))])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.editPolicy(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Edit this Policy")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.sortPoliciesForCategory(category)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Sort " + _vm._s(category.name) + " Policies")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deletePolicy(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete this Policy")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.firstOptionForPolicy(policy).name) ? [_c('v-menu', {
        attrs: {
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [(_vm.mode == 'Template') ? _c('b', _vm._g({
              staticClass: "hoverable",
              staticStyle: {
                "padding": "2px 5px"
              },
              on: {
                "dblclick": function($event) {
                  _vm.editOption(_vm.firstOptionForPolicy(policy))
                }
              }
            }, on), [_vm._v(_vm._s(_vm.firstOptionForPolicy(policy).name))]) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            _vm.editOption(_vm.firstOptionForPolicy(policy))
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Edit this Option")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.sortOptionsForPolicy(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Sort " + _vm._s(policy.name) + " Options")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            _vm.deleteOption(_vm.firstOptionForPolicy(policy))
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete this Option")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.documentsForOption(_vm.firstOptionForPolicy(policy))), function(document) {
        return [_c('div', {
          key: 'd-' + document.meta.key,
          staticClass: "no-print",
          staticStyle: {
            "float": "right",
            "margin-top": "10px"
          }
        }, [(!_vm.clientOrEmail) ? _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
            }
          }], null, true),
          model: {
            value: (document.meta.menuOpen),
            callback: function($$v) {
              _vm.$set(document.meta, "menuOpen", $$v)
            },
            expression: "document.meta.menuOpen"
          }
        }, [_vm._v(" "), (_vm.mode == 'Consultant') ? _c('div', {
          staticClass: "pa-3 white-background"
        }, [_c('v-switch', {
          staticClass: "compact",
          attrs: {
            "hide-details": "",
            "color": "green",
            "label": "Received"
          },
          on: {
            "change": function($event) {
              return _vm.switchReceived(document)
            }
          },
          model: {
            value: (document.received),
            callback: function($$v) {
              _vm.$set(document, "received", $$v)
            },
            expression: "document.received"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('div', {
          on: {
            "click": function($event) {
              document.meta.menuOpen = false
            }
          }
        }, [_c('v-list', [_c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.addDocument(_vm.firstOptionForPolicy(policy).meta.key)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Add Document Here")])], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$emit('add-category-document', category)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Add Different " + _vm._s(category.name) + " Doc")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.editDocument(document)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Edit Document")])], 1), _vm._v(" "), (_vm.documentsForOption(_vm.firstOptionForPolicy(policy)).length > 1) ? _c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.sortDocumentsForOption(_vm.firstOptionForPolicy(policy))
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Sort Documents")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.deleteDocument(document)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Delete Document")])], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.deleteOption(_vm.firstOptionForPolicy(policy))
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Delete Entire Option")])], 1)], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('ChecklistDocument', {
          key: document.meta.key,
          attrs: {
            "document": document,
            "pageSettings": _vm.pageSettings
          },
          on: {
            "open": _vm.editDocument
          }
        })]
      }), _vm._v(" "), (_vm.mode == 'Template') ? _c('div', [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.addDocument(_vm.firstOptionForPolicy(policy).meta.key)
          }
        }
      }, [_vm._v("Add a Document")]), _vm._v(" \n                ")]) : _vm._e()] : _vm._e(), _vm._v(" "), ((_vm.optionsForPolicy(policy).length > 1) && _vm.mode != 'Email') ? _c('div', {
        staticClass: "mb-3"
      }, [_c('span', [_vm._v("Other Options: ")]), _vm._v(" "), _vm._l((_vm.remainingOptionsForPolicy(policy)), function(option, index) {
        return _c('span', {
          key: index + 1
        }, [_c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.optionLinkClicked(option)
            }
          }
        }, [_vm._v(_vm._s(option.name))]), _vm._v("  \n                ")])
      })], 2) : _vm._e(), _vm._v(" "), ((_vm.optionsForPolicy(policy).length > 1) && _vm.mode == 'Email') ? _c('div', {
        staticClass: "mb-3",
        staticStyle: {
          "color": "#888"
        }
      }, [_vm._v("\n                There are other options available for this one. Go to the online checklist and you can switch between them.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'Template') ? _c('span', [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.addOption(policy.meta.key)
          }
        }
      }, [_vm._v("Add an Option")]), _vm._v(" \n            ")]) : _vm._e()], 2)
    }), _vm._v(" "), (_vm.mode == 'Template') ? _c('div', [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.addPolicy(category.name)
        }
      }
    }, [_vm._v("Add a Policy")]), _vm._v(" \n        ")]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.mode == 'Template') ? _c('div', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addCategory($event)
      }
    }
  }, [_vm._v("Add a Category")]), _vm._v(" \n    ")]) : _vm._e()], 2), _vm._v(" "), _c('AdvancedDialog', {
    attrs: {
      "record": _vm.editDialog.record,
      "settings": _vm.editDialog.settings,
      "fields": _vm.editDialog.fields
    },
    on: {
      "save": _vm.saveRecord,
      "delete": _vm.deleteRecord,
      "menu": _vm.editDialogMenu
    }
  }), _vm._v(" "), _c('SortDialog', {
    attrs: {
      "items": _vm.sortDialog.items,
      "dataRef": _vm.sortDialog.dataRef,
      "settings": _vm.sortDialog.settings
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "quickInput",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ElementSummary"
  }, [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(this.elements.length) + " items\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "quick-input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.elements), function(element) {
    return _c('tr', {
      key: element.key,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.log(element)
        }
      }
    }, [_c('td', [_c('span', {
      attrs: {
        "title": element.name
      }
    }, [_vm._v(_vm._s(element.title || element.key))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(element.value))])])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 2504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activity) ? _c('div', {
    staticClass: "speech-container"
  }, [(!_vm.isCurrentUser) ? _c('div', {
    staticClass: "mr-3 pt-1 ml-1"
  }, [_c('ContactImage', {
    attrs: {
      "contact": _vm.currentUser,
      "size": 33
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "speech-bubble",
    class: {
      'current-user': _vm.isCurrentUser, 'other-user': !_vm.isCurrentUser
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activity.description) + "\n    ")]), _vm._v(" "), (_vm.isCurrentUser) ? _c('div', {
    staticClass: "ml-3 pt-1"
  }, [_c('ContactImage', {
    attrs: {
      "contact": _vm.currentUser,
      "size": 33
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "transparent",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._t("default", [_vm._v("Go")])], 2)
},staticRenderFns: []}

/***/ }),
/* 2506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout"
  }, [_c('template', {
    slot: "header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "flat": "",
      "dark": "",
      "dense": "",
      "xxstyle": "z-index:8;position:fixed;"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_c('span', {
    staticClass: "clickable heading-button",
    on: {
      "click": function($event) {
        return _vm.showTeamDetails(_vm.activeTeam)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeTeam.name))]), _vm._v(" "), (_vm.activeTeam.name && _vm.activeCollection.name) ? _c('span', [_vm._v(">")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clickable heading-button",
    on: {
      "click": function($event) {
        return _vm.showCollectionDetails(_vm.activeCollection)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeCollection.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.showBulkUpdate
    }
  }, [_c('v-list-item-title', [_vm._v("Bulk Update")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.rightColumnActive = !_vm.rightColumnActive
      }
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "left"
  }, [_c('v-select', {
    staticClass: "ma-2",
    attrs: {
      "value": _vm.teamId,
      "items": _vm.teamsItems.concat( [{
        value: 'add',
        text: 'Add New Team'
      }]),
      "single-line": ""
    },
    on: {
      "change": _vm.selectTeam
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.collections), function(collection) {
    return _c('v-list-item', {
      key: collection._id,
      on: {
        "click": function($event) {
          return _vm.selectCollection(collection)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("folder")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(collection.name))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Collection")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "color": "grey lighten-2"
    },
    on: {
      "click": function($event) {
        return _vm.showCollectionDetails(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-3 ma-3"
  }, [_c('div', {
    staticClass: "white-background pa-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Fields")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "small": "",
      "right": "",
      "bottom": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showFieldDetails(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-background pa-3"
  }, _vm._l((_vm.collection.fields), function(field) {
    return _c('div', {
      key: field._id,
      staticClass: "field hoverable clickable",
      on: {
        "click": function($event) {
          return _vm.showFieldDetails(field)
        }
      }
    }, [_vm._v("\n                " + _vm._s(field.name) + " - "), _c('flag', [_vm._v(_vm._s(field.type))])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "elevation-3 ma-3"
  }, [_c('div', {
    staticClass: "white-background pa-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Data")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "small": "",
      "right": "",
      "bottom": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showDataDetails(null, _vm.collection.fields)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-background pa-3"
  }, [_c('table', {
    staticClass: "full-width",
    staticStyle: {
      "border-collapse": "collapse"
    }
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, _vm._l((_vm.collection.fields), function(field) {
    return _c('td', [_vm._v(_vm._s(field.name))])
  }), 0), _vm._v(" "), _vm._l((_vm.collection.data), function(row) {
    return _c('tr', {
      staticClass: "clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.showDataDetails(row, _vm.collection.fields)
        }
      }
    }, _vm._l((_vm.collection.fields), function(field) {
      return _c('td', [_c('div', {
        staticStyle: {
          "max-height": "60px",
          "overflow": "auto",
          "min-width": "60px"
        }
      }, [_c('Merger', {
        attrs: {
          "row": row,
          "field": field
        }
      })], 1)])
    }), 0)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "elevation-3 ma-3"
  }, [_c('div', {
    staticClass: "white-background pa-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "small": "",
      "right": "",
      "bottom": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showActionDetails(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-background pa-3"
  }, [_c('table', {
    staticClass: "full-width",
    staticStyle: {
      "border-collapse": "collapse"
    }
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v("Field")]), _vm._v(" "), _c('td', [_vm._v("Type")])]), _vm._v(" "), _vm._l((_vm.collection.actions), function(action) {
    return _c('tr', {
      key: action._id,
      staticClass: "clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.showActionDetails(action)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(action.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.field))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.type))])])
  })], 2)])]), _vm._v(" "), _c('template', {
    slot: "right"
  }), _vm._v(" "), _c('TeamDialog', {
    attrs: {
      "settings": _vm.teamDialog.settings,
      "team": _vm.teamDialog.team
    },
    on: {
      "save": _vm.saveTeam
    }
  }), _vm._v(" "), _c('CollectionDialog', {
    attrs: {
      "settings": _vm.collectionDialog.settings,
      "collection": _vm.collectionDialog.collection
    },
    on: {
      "save": _vm.saveCollection
    }
  }), _vm._v(" "), _c('FieldDialog', {
    attrs: {
      "settings": _vm.fieldDialog.settings,
      "field": _vm.fieldDialog.field
    },
    on: {
      "save": _vm.saveField,
      "delete": _vm.deleteField
    }
  }), _vm._v(" "), _c('ActionDialog', {
    attrs: {
      "settings": _vm.actionDialog.settings,
      "action": _vm.actionDialog.action
    },
    on: {
      "save": _vm.saveAction,
      "delete": _vm.deleteAction
    }
  }), _vm._v(" "), _c('DataDialog', {
    attrs: {
      "settings": _vm.dataDialog.settings,
      "row": _vm.dataDialog.row,
      "fields": _vm.dataDialog.fields
    },
    on: {
      "save": _vm.saveData,
      "delete": _vm.deleteData
    }
  }), _vm._v(" "), (_vm.bulkUpdateDialog.settings.visible) ? _c('BulkUpdateDialog', {
    attrs: {
      "settings": _vm.bulkUpdateDialog.settings
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "22px"
    },
    attrs: {
      "color": "grey",
      "small": ""
    }
  }, [_vm._v("group")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "persistent": true,
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.settings.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.adding = !_vm.adding
      }
    }
  }, [(_vm.adding) ? _c('v-icon', [_vm._v("list")]) : _c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), (_vm.adding) ? _c('div', {
    staticClass: "dialog-body pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Group Name",
      "hint": "Singular (not plural) eg Client"
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Can be a role in a transaction"
    },
    model: {
      value: (_vm.group.role),
      callback: function($$v) {
        _vm.$set(_vm.group, "role", $$v)
      },
      expression: "group.role"
    }
  })], 1) : _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-list', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.groups), function(group, i) {
    return [_c('v-list-item', {
      class: {
        'blue-hilight': _vm.isSelected(group)
      },
      staticStyle: {
        "border": "solid 1px transparent"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(group)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      attrs: {
        "src": 'https://placeimg.com/40/40/people/' + i
      }
    })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(group.name) + "\n                    ")]), _vm._v(" "), (group.role) ? _c('v-list-item-subtitle', [_c('Flag', {
      attrs: {
        "value": "Role"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-menu', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
              }
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "grey darken-1"
            }
          }, [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.deleteGroup(group)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete group")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')]
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.adding = !_vm.adding
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey--text text--lighten-2",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add Group")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("No results. Add a new one?")])], 1)], 1)], 2)], 1), _vm._v(" "), (_vm.adding) ? _c('div', {
    staticClass: "dialog-footer"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": !_vm.group.name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveAndSelect($event)
      }
    }
  }, [_vm._v("Save and Select")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.settings.multiselect) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.done($event)
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 2508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('DateRangeList', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-page"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_vm._t("header", [_c('div', {
    staticClass: "sample-content"
  }, [_vm._l((50), function(n) {
    return [_vm._v("Header ")]
  })], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    style: (_vm.contentStyle)
  }, _vm._l((_vm.columnList), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "layout-column",
      style: ({
        'flex-basis': column.width
      }),
      attrs: {
        "id": 'col' + (index + 1)
      }
    }, [_c('div', {
      staticClass: "layout-column-padder"
    }, [_vm._t('col' + (index + 1), [_c('div', {
      staticClass: "sample-content"
    }, [_vm._l((400), function(n) {
      return [_vm._v("Column " + _vm._s(index) + " ")]
    })], 2)])], 2)])
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._t("footer", [_c('div', {
    staticStyle: {
      "height": "15px"
    }
  })])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dialogs"
    }
  }, [_vm._t("dialogs")], 2)])
},staticRenderFns: []}

/***/ }),
/* 2510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-label pl-1 pt-2"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "colour-frame"
  }, [_c('div', {
    staticClass: "clickable colour-item elevation-1 transparent-checkers",
    style: (_vm.colourItemStyle(null)),
    attrs: {
      "title": "Transparent"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input', null)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.colours), function(colour) {
    return _c('div', {
      key: colour,
      staticClass: "clickable colour-item elevation-1",
      style: (_vm.colourItemStyle(colour)),
      on: {
        "click": function($event) {
          return _vm.$emit('input', colour)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 2511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto",
      "background-color": "#eee"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "absolute": "",
      "flat": "",
      "dark": "",
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Components")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "top": "48px"
    },
    attrs: {
      "absolute": "",
      "mobile-break-point": 900,
      "width": 240
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-title', {
    staticClass: "title"
  }, [_vm._v("\n            Application\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-action', [_c('v-icon', [_vm._v("security")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Security")])], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-list-item-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("People")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticStyle: {
      "top": "48px",
      "background-color": "#ddd"
    },
    attrs: {
      "right": "",
      "absolute": "",
      "mobile-break-point": 1200,
      "width": 350
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((100), function(n) {
    return _c('span', {
      staticStyle: {
        "color": "#bbb"
      }
    }, [_vm._v("Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita quam nobis fugiat iusto illum officia facilis dolor debitis assumenda, sit iure odio laboriosam autem obcaecati minima repudiandae, quidem cupiditate aliquam! ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "main-page"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#eee",
      "padding": "0 5px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "max-width": "600px"
    }
  }, [_c('SectionLayout', {
    attrs: {
      "section-properties": {
        title: 'Personal Details',
      }
    }
  }, [_c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'First Name',
        complete: true,
        icon: 'account_circle',
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "First Name",
      "xxxbox": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "right-button",
    attrs: {
      "slot": "right",
      "small": "",
      "outline": "",
      "color": "grey"
    },
    slot: "right"
  }, [_vm._v("Lookup")])], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Last Name',
        complete: false
      }
    }
  }, [_c('LayoutReadOnly', {
    attrs: {
      "label": "Middle Name",
      "value": "Jenson"
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        complete: true
      }
    }
  }, [_c('LayoutReadOnly', {
    attrs: {
      "label": "Preferred Name (or Nickname)",
      "value": "PJ"
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Last Name',
        complete: false
      }
    }
  }, [_c('LayoutReadOnly', {
    attrs: {
      "label": "Spouses Name",
      "value": "Maria"
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Last Name',
        complete: false
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "xxxbox": "",
      "hide-details": ""
    }
  })], 1), _vm._v(" "), _c('ElementLayout', {
    attrs: {
      "element-properties": {
        title: 'Favourite Colour',
        complete: false
      }
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Favourite Colour",
      "hide-details": "",
      "items": ['Red', 'Orange', 'Yellow', 'Green']
    }
  })], 1)], 1), _vm._v(" "), _c('SectionLayout', {
    attrs: {
      "section-properties": {
        title: 'Contact Preferences',
      }
    }
  }, [_vm._v("\n                Section 2\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "elevation-2 pa-3 mb-2 mt-5",
    staticStyle: {
      "background-color": "white"
    }
  }, [_vm._v("\n\n        Contact Autocomplete\n        "), _c('ContactAutocomplete', {
    attrs: {
      "items": _vm.contacts,
      "single-line": ""
    },
    model: {
      value: (_vm.selectedContacts),
      callback: function($$v) {
        _vm.selectedContacts = $$v
      },
      expression: "selectedContacts"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        DateTime\n        "), _c('DateTime', {
    attrs: {
      "label": "Appointment Time"
    },
    model: {
      value: (_vm.dateAndTime),
      callback: function($$v) {
        _vm.dateAndTime = $$v
      },
      expression: "dateAndTime"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        Dynamic Control\n        "), _c('DynamicControl', {
    attrs: {
      "field": _vm.specialField
    },
    model: {
      value: (_vm.specialValue),
      callback: function($$v) {
        _vm.specialValue = $$v
      },
      expression: "specialValue"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-container"
  }, [_vm._t("default"), _vm._v(" "), _c('input', {
    attrs: {
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.upload($event.target.files)
      }
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-section"
  })
},staticRenderFns: []}

/***/ }),
/* 2514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Sort Items",
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialise
    }
  }, [_c('draggable', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": {
        animation: 350,
        group: 'items',
        xxxhandle: '.draggable-handle'
      }
    },
    on: {
      "end": _vm.afterDrag
    },
    model: {
      value: (_vm.localItems),
      callback: function($$v) {
        _vm.localItems = $$v
      },
      expression: "localItems"
    }
  }, _vm._l((_vm.localItems), function(item) {
    return _c('div', {
      key: item.meta.key,
      staticClass: "list-tile clickable hoverable",
      attrs: {
        "data-order": item.order
      },
      on: {
        "click": function($event) {
          return _vm.itemClicked(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-2px",
        "margin-right": "-15px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "draggable-handle",
            staticStyle: {
              "color": "#ddd"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addItem
      }
    }, [_c('v-list-item-title', [_vm._v("Add New")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._t("default", [_vm._v("    \n                 " + _vm._s(item.name) + "\n            ")], null, item)], 2)
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 2515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    ref: "textbox",
    class: {
      'compact-element': _vm.compact
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": _vm.label,
      "value": _vm.longFormat,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine
    },
    on: {
      "change": _vm.changed
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.contactElements), function(element) {
    return _c('div', {
      key: element.key,
      staticClass: "workflow-contact clickable",
      on: {
        "click": function($event) {
          return _vm.contactClicked(element)
        }
      }
    }, [_c('div', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(_vm._f("fullName")(element.contact)))]), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "9px"
      }
    }, [(element.contact.preferredName) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "background-color": "yellow",
        "display": "inline-block",
        "line-height": "0.9em"
      }
    }, [_vm._v("Prefer " + _vm._s(element.contact.preferredName))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(element.roles.join('/')))])]), _vm._v(" "), _c('ContactImage', {
      attrs: {
        "contact": element.contact,
        "size": 46
      }
    }), _vm._v(" "), (!element.contact.notes) ? _c('div', {
      staticStyle: {
        "margin-top": "0px"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.bestNumber(element.contact)) + "\n        ")]) : _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            staticStyle: {
              "text-decoration": "underline",
              "text-decoration-style": "double",
              "text-decoration-color": "#aaa",
              "margin-top": "-8px"
            }
          }, on), [_vm._v("\n                    " + _vm._s(_vm.bestNumber(element.contact)) + "\n                ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(element.contact.notes))])])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "min-width": "600",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-details": "",
      "hide-overlay": false,
      "retain-focus": false,
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('v-card', {
    ref: "dialogDOM",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0",
    staticStyle: {
      "flex-grow": "0"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.settings.title || 'Select'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("header")], 2)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "5px",
      "flex-grow": "1",
      "display": "flex"
    },
    style: (_vm.bodyStyle)
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "scroll",
      "height": "100%"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', [_vm._t("sidebar")], 2)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "flex-grow": "0",
      "padding": "10px"
    }
  }, [_c('div', [_vm._t("footer")], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.settings.closeOnly) ? [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.settings.cancelLabel || 'Cancel'))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.settings.saveLabel || 'Save'))])] : _vm._e(), _vm._v(" "), (_vm.settings.closeOnly) ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.editing) ? _c('span', [_vm._v("Editing")]) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [(_vm.canWrite(_vm.policiesDoc)) ? _c('v-list-item', [_c('v-list-item-title', [_c('v-switch', {
    staticClass: "ml-4",
    attrs: {
      "label": "Edit Mode"
    },
    model: {
      value: (_vm.editing),
      callback: function($$v) {
        _vm.editing = $$v
      },
      expression: "editing"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canWrite(_vm.policiesDoc)) ? _c('v-list-item', {
    on: {
      "click": _vm.downloadBackups
    }
  }, [_c('v-list-item-title', [_vm._v("Download Policy Backup")])], 1) : _vm._e(), _vm._v(" "), (_vm.canWrite(_vm.policiesDoc) && _vm.editing && _vm.selectedRequirement) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.addSpecialChecks('statements')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Add statement checks")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.startCreation()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Start Creation")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "white-background",
    staticStyle: {
      "position": "relative",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('ListList', {
    attrs: {
      "items": _vm.lenders
    },
    on: {
      "click": _vm.resetPolicy
    },
    model: {
      value: (_vm.lender),
      callback: function($$v) {
        _vm.lender = $$v
      },
      expression: "lender"
    }
  }, [_c('v-list-item', {
    attrs: {
      "slot": "top",
      "input-value": false
    },
    on: {
      "click": function($event) {
        _vm.lender = null
      }
    },
    slot: "top"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("General Requirements")])], 1)], 1), _vm._v(" "), (_vm.canWrite(_vm.lendersDoc) && _vm.editing) ? _c('v-list-item', {
    attrs: {
      "slot": "bottom",
      "input-value": false
    },
    on: {
      "click": _vm.addLender
    },
    slot: "bottom"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add a Lender")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "display-flex",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin": "6px 20px"
    },
    attrs: {
      "filled": "",
      "dense": "",
      "rounded": "",
      "placeholder": "Search...",
      "hide-details": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return [(_vm.filterPolicies(category.policies).length) ? _c('div', {
      key: category.name,
      staticClass: "white ma-5 elevation-3",
      staticStyle: {
        "position": "relative",
        "padding": "60px 40px 20px 40px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "position": "absolute",
        "top": "0",
        "left": "0",
        "right": "0",
        "font-size": "16px",
        "text-align": "center",
        "letter-spacing": "3px",
        "padding": "8px",
        "background-color": "#eee",
        "color": "#888",
        "text-transform": "uppercase"
      }
    }, [_vm._v("\n            " + _vm._s(category.name) + "\n            "), (_vm.editing) ? _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addPolicy(category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add another " + _vm._s(category.name) + " policy")])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filterPolicies(category.policies)), function(policy) {
      return _c('div', {
        key: policy._id,
        staticClass: "mb-6 policy-container",
        on: {
          "click": function($event) {
            _vm.selectedPolicy = policy
          }
        }
      }, [_c('div', {
        staticStyle: {
          "margin-bottom": "0px",
          "color": "#666",
          "font-weight": "bold"
        }
      }, [_c('div', {
        staticClass: "policy-box",
        staticStyle: {
          "display": "inline"
        },
        on: {
          "click": function($event) {
            _vm.selectedRequirement = null
          }
        }
      }, [_c('EditableText', {
        attrs: {
          "plain": "",
          "read-only": !_vm.editing,
          "inline": ""
        },
        model: {
          value: (policy.name),
          callback: function($$v) {
            _vm.$set(policy, "name", $$v)
          },
          expression: "policy.name"
        }
      })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
        staticStyle: {
          "display": "inline",
          "margin-left": "-6px"
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": "",
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({
              attrs: {
                "color": "grey lighten-2"
              }
            }, on), [_vm._v("more_vert")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.addPolicy(category)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add another " + _vm._s(category.name) + " policy")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deletePolicy(policy, category)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete policy")])], 1), _vm._v(" "), (!policy._stipulation._default) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.revertToGeneric(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Revert " + _vm._s(_vm.lender.name) + " back to generic policy")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (policy._stipulation) ? _vm._l((policy._stipulation.options), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex,
          staticClass: "options-section",
          class: {
            specific: !policy._stipulation._default
          }
        }, [(optionIndex != 0) ? _c('div', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "padding": "3px"
          }
        }, [_vm._v("   (OR)")]) : _vm._e(), _vm._v(" "), _vm._l((option.requirements), function(requirement, requirementIndex) {
          return _c('div', {
            key: requirementIndex,
            staticStyle: {
              "display": "inline"
            }
          }, [(requirementIndex != 0) ? _c('div', {
            staticStyle: {
              "display": "inline",
              "font-size": "14px",
              "font-weight": "bold",
              "padding": "3px 0 3px 3px"
            }
          }, [_vm._v("AND")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "hoverable requirement-box",
            class: {
              hilight: _vm.isRequirementHilighted(requirement)
            },
            staticStyle: {
              "display": "inline"
            },
            on: {
              "click": function($event) {
                _vm.selectedRequirement = requirement
              }
            }
          }, [_c('EditableText', {
            attrs: {
              "read-only": !_vm.editing,
              "plain": "",
              "inline": ""
            },
            on: {
              "change": function($event) {
                return _vm.savePolicy(policy, $event)
              }
            },
            model: {
              value: (requirement.description),
              callback: function($$v) {
                _vm.$set(requirement, "description", $$v)
              },
              expression: "requirement.description"
            }
          })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
            staticStyle: {
              "display": "inline",
              "margin": "0 -8px"
            }
          }, [_c('v-menu', {
            attrs: {
              "offset-y": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "grey lighten-2"
                  }
                }, on), [_vm._v("more_vert")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.addRequirement(option)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("AND (another requirement)")])], 1), _vm._v(" "), _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.addOption(policy)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("OR (alternative requirements)")])], 1), _vm._v(" "), (option.requirements.length > 1) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.deleteRequirement(requirement, option, policy)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Delete Requirement")])], 1) : _vm._e(), _vm._v(" "), (option.requirements.length == 1 && policy._stipulation.options.length > 1) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.deleteOption(policy, optionIndex)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Delete Entire Option")])], 1) : _vm._e(), _vm._v(" "), (optionIndex) ? _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.makePreferredRequirement(option, policy)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Make This the Preferred Option")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()])
        })], 2)
      }) : _vm._e(), _vm._v(" "), (_vm.lender && policy._stipulation._default) ? _c('div', {
        staticClass: "light-text small-text"
      }, [_vm._v("\n                * Not " + _vm._s(_vm.lender.name) + " specific. \n                "), (_vm.editing) ? _c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.makeLenderRequirements(policy)
          }
        }
      }, [_vm._v("Specify")]) : _vm._e()]) : _vm._e()], 2)
    })], 2) : _vm._e()]
  }), _vm._v(" "), (_vm.canWrite(_vm.policiesDoc)) ? _c('v-btn', {
    on: {
      "click": _vm.saveAll
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "white-background pa-6 full-height",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.lender && !_vm.selectedPolicy) ? [(_vm.editing) ? _c('FormControl', {
    attrs: {
      "value": _vm.lender,
      "schema": _vm.lenderSchema
    },
    on: {
      "input": _vm.updateLender
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('FormControl', {
    attrs: {
      "value": _vm.lender,
      "schema": _vm.lenderSchemaRO
    },
    on: {
      "input": _vm.updateLender
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.selectedPolicy) ? [_c('FormControl', {
    attrs: {
      "value": _vm.selectedPolicy,
      "schema": _vm.policySchema
    },
    on: {
      "input": _vm.updatePolicy
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedPolicy && !_vm.selectedPolicy._stipulation._default) ? [_c('FormControl', {
    attrs: {
      "value": _vm.selectedPolicy._stipulation,
      "schema": _vm.stipulationSchema
    },
    on: {
      "input": _vm.updateStipulation
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedRequirement) ? [_c('div', {
    staticClass: "section-heading mb-3"
  }, [_vm._v("Requirement")]), _vm._v(" "), _c('FormControl', {
    attrs: {
      "value": _vm.selectedRequirement,
      "schema": _vm.requirementSchema
    },
    on: {
      "input": _vm.updateRequirement
    }
  })] : _vm._e(), _vm._v(" "), (_vm.editing) ? [_c('Permissions', {
    attrs: {
      "document": _vm.policiesDoc
    }
  }), _vm._v(" "), _c('Permissions', {
    attrs: {
      "document": _vm.lenderStipulationsDoc,
      "label": "Lender Permissions"
    },
    on: {
      "change": _vm.saveLenderStipulations
    }
  })] : _vm._e()], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 2519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Preferences")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.loadingMessage) ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.debugMyRecord
    }
  }, [_c('v-list-item-title', [_vm._v("Debug my Record")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-5 grey--text"
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.$router.push('/templates')
      }
    }
  }, [_vm._v("Templates")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.sendTestEmail
    }
  }, [_vm._v("Test Email")])], 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "color": "blue"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: 0,
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("\n        Email\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 1,
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("\n        SMS\n    ")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("\n        Billing\n    ")]), _vm._v(" "), _c('v-tab-item', {
    key: 0
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_vm._v("\n                        Email Signature"), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px",
      "height": "200px"
    }
  }, [_c('HtmlEditor', {
    attrs: {
      "height": 180
    },
    model: {
      value: (_vm.email.signature),
      callback: function($$v) {
        _vm.$set(_vm.email, "signature", $$v)
      },
      expression: "email.signature"
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Automatic CC"
    },
    model: {
      value: (_vm.email.cc),
      callback: function($$v) {
        _vm.$set(_vm.email, "cc", $$v)
      },
      expression: "email.cc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Automatic BCC"
    },
    model: {
      value: (_vm.email.bcc),
      callback: function($$v) {
        _vm.$set(_vm.email, "bcc", $$v)
      },
      expression: "email.bcc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email for Billing"
    },
    model: {
      value: (_vm.email.billing),
      callback: function($$v) {
        _vm.$set(_vm.email, "billing", $$v)
      },
      expression: "email.billing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element-label"
  }, [_vm._v("Outbound email can come from the brokers email address")]), _vm._v(" "), _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "label": "Send from Broker",
      "xhide-details": ""
    },
    model: {
      value: (_vm.email.broker),
      callback: function($$v) {
        _vm.$set(_vm.email, "broker", $$v)
      },
      expression: "email.broker"
    }
  }), _vm._v(" "), _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "label": "Copy me Privately",
      "hide-details": ""
    },
    model: {
      value: (_vm.email.copyMe),
      callback: function($$v) {
        _vm.$set(_vm.email, "copyMe", $$v)
      },
      expression: "email.copyMe"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "element-label"
  }, [_vm._v("Everything will be copied to you. Email will be tagged with 'TACO-SENT' so you can autofilter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "Prefix SMS With"
    },
    model: {
      value: (_vm.sms.prefix),
      callback: function($$v) {
        _vm.$set(_vm.sms, "prefix", $$v)
      },
      expression: "sms.prefix"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Suffix SMS With"
    },
    model: {
      value: (_vm.sms.suffix),
      callback: function($$v) {
        _vm.$set(_vm.sms, "suffix", $$v)
      },
      expression: "sms.suffix"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Email for Billing (if different to yours)"
    },
    model: {
      value: (_vm.billing.email),
      callback: function($$v) {
        _vm.$set(_vm.billing, "email", $$v)
      },
      expression: "billing.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Direct Debit Ref"
    },
    model: {
      value: (_vm.billing.directDebitRef),
      callback: function($$v) {
        _vm.$set(_vm.billing, "directDebitRef", $$v)
      },
      expression: "billing.directDebitRef"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Billing Entity and Address"
    },
    model: {
      value: (_vm.billing.entity),
      callback: function($$v) {
        _vm.$set(_vm.billing, "entity", $$v)
      },
      expression: "billing.entity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "max-width": "600px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', [_c('span', {
    staticClass: "heading",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.expense.name))]), (!_vm.expense.optional) ? _c('span', {
    staticClass: "heading ml-2"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "expense-subheading"
  }, [_vm._v(_vm._s(_vm.expense.hint))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-slider', {
    attrs: {
      "max": _vm.expense.max,
      "min": 0,
      "step": 10,
      "thumb-label": ""
    },
    on: {
      "end": _vm.sliderFinished
    },
    model: {
      value: (_vm.expense.value),
      callback: function($$v) {
        _vm.$set(_vm.expense, "value", $$v)
      },
      expression: "expense.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "expense-amount",
    staticStyle: {
      "flex": "0 0 110px",
      "text-align": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.displayExpense) + "\n        "), _c('v-btn', {
    staticStyle: {
      "width": "25px",
      "height": "25px"
    },
    attrs: {
      "fab": "",
      "small": "",
      "dark": "",
      "color": "grey lighten-1",
      "icon": ""
    },
    on: {
      "click": _vm.showDetails
    }
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1)], 1)]), _vm._v(" "), ((!_vm.isInRange) && _vm.hasValue) ? _c('div', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [(_vm.rangeError) ? _c('div', {
    staticClass: "pa-2 no-print grey--text text--darken-1"
  }, [_c('v-icon', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "color": "red lighten-2"
    }
  }, [_vm._v("report_problem")]), _vm._v(" "), (_vm.expense.name == 'Other') ? _c('span', [_vm._v("Please give specifics")]) : _c('span', [_vm._v("This is " + _vm._s(_vm.higherOrLower) + " than expected, Your lender will require an explanation why.")])], 1) : _vm._e(), _vm._v(" "), _c('v-textarea', {
    staticClass: "no-print mt-2",
    attrs: {
      "outline": "",
      "label": "",
      "single-line": "",
      "rows": 2
    },
    model: {
      value: (_vm.expense.explanation),
      callback: function($$v) {
        _vm.$set(_vm.expense, "explanation", $$v)
      },
      expression: "expense.explanation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "print-only"
  }, [_vm._v("Client comment: " + _vm._s(_vm.expense.explanation))])], 1) : _vm._e(), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "settings": _vm.breakdownDialog.settings
    },
    on: {
      "save": _vm.saveBreakdown
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "inset-text mb-3"
  }, [_c('span', {
    staticStyle: {
      "background-color": "yellow"
    }
  }, [_vm._v("Optional.")]), _vm._v(" You can use the categories below to work out your " + _vm._s(_vm.expense.name) + " expense in more detail.\n        ")]), _vm._v(" "), _vm._l((_vm.expense.breakdown), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "pa-2",
      staticStyle: {
        "display": "flex",
        "width": "100%",
        "font-size": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1 0 0"
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "150px"
      }
    }, [_vm._v("\n                $ "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "expense-box show-border",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "value", $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.breakdownTotal) ? _c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "font-size": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1 0 0"
    }
  }, [_vm._v("\n                Total\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-basis": "150px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(this.breakdownTotal)) + "\n            ")])]) : _vm._e()], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(true) ? _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "white-background mail-item clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.toggleExpansion(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "truncate",
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('strong', [_vm._v(_vm._s(item.email.subject))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "100px",
        "margin-left": "10px",
        "text-align": "right",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(_vm._f("fromNow")(item.createdAt)))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, _vm._l((item.email.to), function(recipient) {
      return _c('div', {
        key: recipient.to,
        staticClass: "email-address truncate",
        attrs: {
          "title": recipient.email
        }
      }, [_vm._v("\n                " + _vm._s(recipient.email) + " \n            ")])
    }), 0), _vm._v(" "), (_vm.showTo) ? _c('div', {
      staticClass: "email-heading"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.textBody(item.email.body, item.expanded)))])])
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Task Details",
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": _vm.saveTask
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    ref: "focus",
    attrs: {
      "label": "Task Description"
    },
    model: {
      value: (_vm.task.title),
      callback: function($$v) {
        _vm.$set(_vm.task, "title", $$v)
      },
      expression: "task.title"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-large"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px",
      "flex-grow": "1"
    }
  }, [_c('UserChooser', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "contact": _vm.user,
      "contacts": _vm.users,
      "label": "Assigned To"
    },
    on: {
      "select": _vm.userSelected
    },
    model: {
      value: (_vm.task.assigned),
      callback: function($$v) {
        _vm.$set(_vm.task, "assigned", $$v)
      },
      expression: "task.assigned"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm._f("dueString")(_vm.task.due)) + "\n                    "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm._f("stamp")(_vm.task.stamp)))])]), _vm._v(" "), _c('div', {
    staticClass: "small-text light-text"
  }, [_vm._v(_vm._s(_vm.task.hint))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": _vm.pickerClicked
    },
    model: {
      value: (_vm.task.due),
      callback: function($$v) {
        _vm.$set(_vm.task, "due", $$v)
      },
      expression: "task.due"
    }
  })], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('DeleteButton', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "delete": function($event) {
        return _vm.deleteTask(_vm.task)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": "",
            "color": (_vm.task.important ? 'primary' : 'grey lighten-1'),
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.$set(_vm.task, 'important', !_vm.task.important)
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-alert-circle")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Important")])]), _vm._v(" "), (_vm.showEmailNotification) ? _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "text": "",
            "color": (_vm.sendEmailNotification ? 'primary' : 'grey lighten-1'),
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.sendEmailNotification = !_vm.sendEmailNotification
            }
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }], null, false, 540679804)
  }, [_vm._v(" "), _c('span', [_vm._v("Send notification to " + _vm._s(_vm.notificationRecipient))])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": "",
      "div": "",
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "Home"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "persistent": ""
    },
    model: {
      value: (_vm.loginDialogVisible),
      callback: function($$v) {
        _vm.loginDialogVisible = $$v
      },
      expression: "loginDialogVisible"
    }
  }, [_c('v-card', [_c('div', {
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-card-text', [(_vm.showLoginButton) ? _c('div', {
    staticClass: "center-text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.2em",
      "padding-bottom": "10px"
    }
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Holy guacamole. You need to be signed in to access this page")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "120px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "/static/images/taco.jpg"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.loginEnabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signIn($event)
      }
    }
  }, [_vm._v("\n                Login with Google\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showSigningIn) ? _c('div', {
    staticClass: "center-text",
    staticStyle: {
      "padding-top": "120px"
    }
  }, [_c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n            Signing In...\n        ")], 1) : _vm._e()])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "timeout": _vm.alert.timeout
    },
    on: {
      "click": _vm.clearAlert
    },
    model: {
      value: (_vm.alert.visible),
      callback: function($$v) {
        _vm.$set(_vm.alert, "visible", $$v)
      },
      expression: "alert.visible"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.alert.message) + "\n        "), (_vm.alert.button) ? _c('v-btn', {
    attrs: {
      "text": "",
      "dark": ""
    }
  }, [_vm._v("Got It")]) : _vm._e()], 1), _vm._v(" "), (_vm.isChatting) ? _c('ChatWindow') : _vm._e(), _vm._v(" "), _c('EmailIndicator', {
    ref: "emailIndicator"
  }), _vm._v(" "), _c('ConfirmDialog', {
    ref: "confirm"
  }), _vm._v(" "), _c('YouTubeDialog', {
    ref: "youtube"
  }), _vm._v(" "), _c('FormDialog', {
    ref: "formDialog"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.textValue,
      "label": _vm.schema.label,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "prefix": "$"
    },
    on: {
      "change": _vm.change,
      "focus": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-heading mb-3",
    staticStyle: {
      "background-color": "#bbb"
    }
  }, [_vm._v(_vm._s(_vm.schema.label))])
},staticRenderFns: []}

/***/ }),
/* 2526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('draggable', {
    attrs: {
      "options": {
        animation: 350,
        handle: '.menu-icon'
      }
    },
    on: {
      "end": _vm.delayedSave
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item hoverable clickable",
      on: {
        "click": function($event) {
          return _vm.toggleItem(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', [_c('div', {
      staticClass: "truncate pr-2"
    }, [(item.status == 'NA') ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("highlight_off")]) : _c('v-icon', {
      class: {
        'green--text': item.status == 'C', 'grey--text': item.status == 'NA', 'grey--text text--lighten-2': item.status == 'O'
      }
    }, [_vm._v("check_circle_outline")])], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding-top": "2px"
      }
    }, [(_vm.isCapitalised(item.text)) ? _c('span', {
      staticStyle: {
        "margin-top": "12px",
        "background-color": "#ddd",
        "border-radius": "5px",
        "font-weight": "bold",
        "font-size": "0.9em",
        "padding": "5px 8px"
      }
    }, [_vm._v(_vm._s(item.text))]) : _c('span', {
      staticStyle: {
        "margin-top": "12px"
      }
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "nudge-width": 200
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("keyboard_arrow_down")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": _vm.showAddItem
      }
    }, [_c('v-list-item-title', [_vm._v("Add Item")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Item")])], 1)], 1)], 1)], 1)])])
  }), 0), _vm._v(" "), (!_vm.items.length && !_vm.editing) ? _c('div', {
    staticClass: "list-item hoverable clickable",
    on: {
      "click": _vm.showAddItem
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("add_circle_outline")]), _vm._v("\n        Add Items\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem),
      expression: "newItem"
    }],
    ref: "addTextbox",
    staticClass: "quick-input",
    attrs: {
      "type": "text",
      "placeholder": "Add an item..."
    },
    domProps: {
      "value": (_vm.newItem)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelEditing($event)
      },
      "blur": _vm.cancelEditing,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItem = $event.target.value
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticStyle: {
      "padding": "0px 20px 20px 20px"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "margin-right": "14px"
    },
    attrs: {
      "src": "static/images/amigo.png",
      "width": "80",
      "height": "80",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Hey Amigo")]), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_vm._v("\n            I thought I was blind!"), _c('br'), _vm._v("You have "), _c('b', [_vm._v(_vm._s(_vm.oldTasks.length))]), _vm._v(" tasks here that are more than 30 days expired. Want me to kill them?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pa-2 red--text"
  }, [_vm._v("\n            " + _vm._s(_vm.clients) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "tw-action",
    on: {
      "click": function($event) {
        _vm.moreTime = true
      }
    }
  }, [_vm._v("give me more time")]), _vm._v(" "), _c('v-btn', {
    staticClass: "tw-action error",
    on: {
      "click": _vm.killOldTasks
    }
  }, [_vm._v("take them out")])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('DateTime', {
    attrs: {
      "date-only": true,
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed || !_vm.itemCount
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [_vm._v(_vm._s(_vm.groupTitle) + "\n            "), (_vm.itemCount && !_vm.readOnly) ? _c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")]) : _vm._e()], 1), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticClass: "group-heading-buttons",
    class: {
      collapsed: _vm.collapsed
    }
  }, [(_vm.itemCount) ? _c('div', {
    staticClass: "group-heading-button",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.subtract($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-minus")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group-heading-button",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")])], 1)]) : _vm._e()]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed) ? _c('div', [_c('draggable', {
    staticClass: "draggable-container",
    class: {
      columns: _vm.schema.columns, 'read-only': _vm.readOnly
    },
    attrs: {
      "value": _vm.value,
      "animation": "350",
      "group": "elements",
      "handle": ".menu-handle"
    },
    on: {
      "input": _vm.draggableInput
    }
  }, _vm._l((_vm.value), function(record, recordIndex) {
    return _c('div', {
      key: recordIndex,
      staticClass: "group-item-area",
      class: {
        'read-only': _vm.readOnly
      },
      style: (_vm.columnStyle)
    }, [(!_vm.readOnly) ? _c('div', {
      staticClass: "menu-handle",
      staticStyle: {
        "position": "absolute",
        "right": "-2px",
        "top": "5px"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey lighten-1"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteItem(recordIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "inputs-area"
    }, [_c('ControlList', {
      attrs: {
        "horizontal": _vm.schema.horizontal,
        "schema": _vm.schemaFields,
        "value": record
      },
      on: {
        "change": function($event) {
          var i = arguments.length, argsArray = Array(i);
          while ( i-- ) argsArray[i] = arguments[i];

          return _vm.emitChanges.apply(void 0, argsArray.concat( [recordIndex] ))
        }
      }
    })], 1)])
  }), 0)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "font-size": "24px",
      "color": "#888"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formatMillions(_vm.totalAmount)) + "\n            "), _c('LabelMenu', {
    attrs: {
      "labelClass": "heading",
      "menus": [{
          value: 'active',
          text: 'Active'
        },
        {
          value: 'settlement_confirmed_date',
          text: 'Settlements'
        },
        {
          value: 'approved_date',
          text: 'Approvals'
        },
        {
          value: 'submitted_date',
          text: 'Submissions'
        },
        {
          value: 'lead_taken_date',
          text: 'Leads Taken'
        } ]
    },
    model: {
      value: (_vm.dateFilter),
      callback: function($$v) {
        _vm.dateFilter = $$v
      },
      expression: "dateFilter"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.filteredLoanCount) + " Deals Shown")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-3 ml-3"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), (_vm.dateFilter !== 'active') ? _c('DateRange', {
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded"
  }, [(_vm.dateFilter == 'active') ? _c('GChart', {
    staticClass: "g-chart",
    attrs: {
      "type": "PieChart",
      "data": _vm.lenderSpread,
      "options": _vm.googleChartOptions
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.filteredLoans), function(loan) {
    return _c('tr', {
      key: loan.meta.key
    }, [_c('td', [_c('a', {
      staticClass: "transparent",
      attrs: {
        "href": _vm.transactionLink(loan.meta.key),
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.clientNames(loan.clients)) + "\n                    ")])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("date")(loan[_vm.dateFilter])) + "\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "margin": "0 15px 3px 5px"
      },
      attrs: {
        "src": '/static/images/lenders/' + loan.lender + '.jpg',
        "alt": "",
        "width": "50"
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(loan.lender))])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.fullName(loan.broker)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(loan.total_new_money)) + "\n                ")])])
  }), 0)], 1), _vm._v(" "), (false) ? _c('NoRecordsPlaceholder', [_vm._v("\n        No Records\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-text-field', {
    ref: "searchText",
    staticClass: "ma-2",
    attrs: {
      "hide-details": "",
      "label": "Search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _vm._l((_vm.menu.categories), function(category) {
    return _c('div', {
      key: category.category.name
    }, [_c('div', {
      staticClass: "heading pa-2"
    }, [_vm._v(_vm._s(category.category.name))]), _vm._v(" "), _c('div', {
      staticClass: "scroll",
      staticStyle: {
        "max-height": "200px",
        "border-bottom": "dotted 2px #d8d8d8"
      }
    }, [_vm._l((category.policies), function(policy) {
      return [_c('v-tooltip', {
        key: policy.key,
        attrs: {
          "right": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [(_vm.matchesSearch(policy.name)) ? _c('div', _vm._g({
              directives: [{
                name: "ripple",
                rawName: "v-ripple"
              }],
              key: policy.name,
              staticClass: "list-tile clickable hoverable",
              class: {
                'blue-hilight': _vm.isSelected(policy.name)
              },
              on: {
                "click": function($event) {
                  return _vm.$emit('click', policy)
                }
              }
            }, on), [_vm._v("\n                        " + _vm._s(policy.name) + " \n                    ")]) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(policy.templateName))])])]
    }), _vm._v(" "), (!_vm.search) ? _c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      staticClass: "list-tile clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.addDocument(category.category)
        }
      }
    }, [_vm._v("\n                Add " + _vm._s(category.category.name) + " Doc\n            ")]) : _vm._e()], 2)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialiseDialog
    }
  }, [_c('template', {
    slot: "header"
  }, [(_vm.linkedKeys.length) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mt-1",
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }], null, false, 1793895034)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.unlinkAllFiles
    }
  }, [_c('v-list-item-title', [_vm._v("Unlink All Files")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "float": "right",
      "width": "150px"
    },
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, [_c('div', {
    staticClass: "grey--text",
    staticStyle: {
      "text-align": "center",
      "padding": "4px"
    }
  }, [_vm._v("\n            " + _vm._s(this.selectedKeys.length || 'None') + " selected\n            "), (this.selectedKeys.length) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectedKeys = []
      }
    }
  }, [_vm._v("Clear")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grey--text",
    staticStyle: {
      "padding": "0px 0px 5px 26px"
    }
  }, [_vm._v("\n            " + _vm._s(this.linkedKeys.length || 'None') + " linked\n            "), (this.linkedKeys.length) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectLinkedKeys($event)
      }
    }
  }, [_vm._v("Select")]) : _vm._e()]), _vm._v(" "), (this.selectedKeys.length) ? [(_vm.linkButtonVisible) ? _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.linkSelectedFiles
    }
  }, [_vm._v("Link")]) : _vm._e(), _vm._v(" "), (_vm.selectedLinkedKeys.length) ? _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.unlinkSelectedFiles
    }
  }, [_vm._v("Un-link")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.emailFiles
    }
  }, [_vm._v("Email")]), _c('br')] : _vm._e(), _vm._v(" "), (this.selectedKeys.length == 1) ? [_c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.renameFile
    }
  }, [_vm._v("Rename")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.copyLink
    }
  }, [_vm._v("Copy Link")])] : _vm._e(), _vm._v(" "), _c('UploadWrapper', {
    on: {
      "select": _vm.uploadFiles
    }
  }, [_c('v-btn', {
    staticClass: "mt-1  mr-1 mb-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Upload")])], 1), _vm._v(" "), (this.selectedKeys.length > 1 && !_vm.isMobile) ? [_c('v-btn', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "90%"
    },
    on: {
      "click": _vm.downloadZip
    }
  }, [_vm._v("Save to Zip")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "10px",
      "padding-left": "10px",
      "min-height": "400px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "quick-input no-focus",
    staticStyle: {
      "width": "100%",
      "margin-top": "8px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.filesDisplay), function(file) {
    return _c('v-list-item', {
      key: file.key,
      staticClass: "blue-select",
      class: {
        'selected': _vm.isSelected(file.key)
      },
      attrs: {
        "title": file.title + ' (' + file.name + ')'
      },
      on: {
        "click": [function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.selectSingle(file)
        }, function($event) {
          if (!$event.metaKey) { return null; }
          return _vm.selectMulti(file)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          return _vm.selectMulti(file)
        }, function($event) {
          if (!$event.shiftKey) { return null; }
          return _vm.selectRange(file)
        }]
      }
    }, [_c('v-list-item-avatar', [(_vm.isLinked(file.key)) ? _c('v-btn', {
      staticClass: "mt-1 primary",
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("insert_link")])], 1) : _c('v-icon', {
      attrs: {
        "large": "",
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIconString(file)))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                    " + _vm._s(_vm.getFileName(file)) + " "), _c('span', {
      staticClass: "light-text small-text"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(file.stamp.date)))])]), _vm._v(" "), _c('v-list-item-subtitle', [_c('span', {
      attrs: {
        "title": file.originalName
      }
    }, [_vm._v(_vm._s(file.originalName))])])], 1), _vm._v(" "), _c('v-list-item-action', [(file.loading) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#888"
      }
    }, [_vm._v(_vm._s(file.progress) + "% ")]), _vm._v(" "), _c('v-progress-circular', {
      staticClass: "grey--text",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "size": 20,
        "width": 2,
        "indeterminate": ""
      }
    })], 1) : [_c('a', {
      ref: 'download' + file.key,
      refInFor: true,
      staticClass: "transparent",
      attrs: {
        "href": file.value,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "mt-1 grey--text",
      attrs: {
        "icon": ""
      },
      on: {
        "xxclick": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-file-image")])], 1)], 1)]], 2)], 1)
  }), 1)], 1), _vm._v(" "), (this.selectedKeys.length) ? _c('template', {
    slot: "footer"
  }, [_c('DeleteButton', {
    on: {
      "delete": _vm.deleteSelectedFiles
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email
    },
    on: {
      "sent": function($event) {}
    }
  }), _vm._v(" "), _c('InputDialog', {
    attrs: {
      "settings": _vm.inputDialog.settings
    },
    on: {
      "save": _vm.changeFileName
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expansion-panel"
  }, [_c('div', {
    staticClass: "ep-heading",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "ep-expander-icon"
  }, [_c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")])], 1), _vm._v(" "), _vm._t("heading", [_vm._v("\n            Details\n        ")])], 2), _vm._v(" "), _c('v-expand-transition', [(!_vm.collapsed) ? _c('div', {
    staticClass: "ep-body"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._t("default", [_vm._v("\n            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est molestias praesentium ea laboriosam obcaecati fugit, culpa, laborum ad sequi et iusto quasi natus sunt tempora vel incidunt dolorum veritatis voluptatibus!\n        ")])], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.element.na || _vm.parent.viewNaFields) ? _c('div', {
    staticClass: "layout-element"
  }, [(!_vm.parent.hideIndicators) ? _c('div', {
    staticClass: "indicator-column"
  }, [_c('div', {
    staticClass: "layout-indicator shadow-pulse",
    class: {
      complete: _vm.element.value
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.parent.hideIcons) ? _c('div', {
    staticClass: "icon-column"
  }, [_vm._t("left", [(_vm.element.icon) ? _c('v-icon', {
    staticClass: "layout-icon",
    attrs: {
      "color": "grey"
    }
  }, [_vm._v(_vm._s(_vm.element.icon))]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "controls-column"
  }, [_c('div', {
    staticClass: "control-c2"
  }, [(_vm.element.na) ? _c('div', {
    staticClass: "na-overlay"
  }, [_vm._v("NOT APPLICABLE")]) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v("No Content")])], 2), _vm._v(" "), _c('div', {
    staticClass: "control-c3"
  }, [_vm._t("right")], 2)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grey--text text--darken-2",
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "oldClass": "{'text-align-right': field.align == 'right'}"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.field.title))]), _vm._v(" "), (_vm.uploading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.record[_vm.field.name]), function(file, fileIndex) {
    return _c('div', {
      key: fileIndex
    }, [_c('a', {
      attrs: {
        "href": file.url,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.fileNameFromStoragePath(file.url)) + "\n            ")]), _vm._v(" \n            "), _c('v-icon', {
      attrs: {
        "small": "",
        "color": "grey lighten-1",
        "xxstyle": "float:right"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFileFromGroup(file)
        }
      }
    }, [_vm._v("cancel")])], 1)
  })], 2), _vm._v(" "), _c('div', [_c('UploadWrapper', {
    on: {
      "click": _vm.doNothing,
      "select": _vm.uploadFiles
    }
  }, [_c('v-btn', {
    attrs: {
      "color": _vm.field.color,
      "disabled": _vm.field.disabled
    }
  }, [_vm._v(_vm._s(_vm.field.title))])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-heading"
  }, [_c('div', {
    staticClass: "checkbox-column",
    attrs: {
      "title": _vm.checkboxName
    }
  }, [_c('v-checkbox', {
    staticClass: "compact",
    attrs: {
      "label": _vm.schema.label,
      "hide-details": ""
    },
    model: {
      value: (_vm.checkboxValue),
      callback: function($$v) {
        _vm.checkboxValue = $$v
      },
      expression: "checkboxValue"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.checkboxValue) ? _c('div', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('FormBlock', {
    ref: "theInput",
    attrs: {
      "horizontal": _vm.schema.horizontal,
      "schema": _vm.modifiedSchema,
      "value": _vm.value,
      "context": _vm.context
    },
    on: {
      "change": _vm.emitInputChange
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [_c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")]), _vm._v("\n             " + _vm._s(_vm.schema.label) + "\n            "), (_vm.summary && _vm.collapsed) ? _c('div', {
    staticClass: "summary-text"
  }, [_vm._v(" (" + _vm._s(_vm.summary) + ")")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed) ? _c('div', {
    staticClass: "expanded-area",
    staticStyle: {
      "border-top": "solid 1px #ddd"
    }
  }, [(!_vm.schema.fields) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.schema.columns), function(columnSchema, csIndex) {
    return _c('div', {
      key: csIndex,
      staticClass: "form-block"
    }, [_c('FormBlock', {
      attrs: {
        "horizontal": _vm.schema.horizontal,
        "schema": columnSchema,
        "value": _vm.value,
        "context": _vm.context
      },
      on: {
        "change": _vm.emitChanges
      }
    })], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.schema.fields) ? _c('div', {
    staticClass: "form-block"
  }, [_c('FormBlock', {
    attrs: {
      "horizontal": _vm.schema.horizontal,
      "schema": _vm.modifiedSchema,
      "value": _vm.value,
      "context": _vm.context
    },
    on: {
      "change": _vm.emitChanges
    }
  })], 1) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "chat-button-outer",
    class: {
      'blue-pulse': _vm.mode == 'alert'
    }
  }, [_c('div', {
    staticClass: "elevation-5 chat-button-inner",
    class: {
      'blue-chat-button': _vm.mode == 'alert', 'white-chat-button': _vm.mode == 'open'
    },
    on: {
      "click": _vm.buttonClicked,
      "dblclick": _vm.changeMode
    }
  }, [_c('v-icon', {
    staticClass: "button-icon",
    attrs: {
      "large": ""
    }
  }, [_vm._v("mdi-chat")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chat-window-outer",
    class: {
      'active': (_vm.mode == 'open')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "elevation-1 chat-window-inner"
  }, [_c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "position": "relative",
      "flex-basis": "1px",
      "background-color": "#eee",
      "border-bottom": "solid 1px #aaa",
      "border-radius": "10px 10px 0 0"
    }
  }, [_c('v-icon', {
    staticClass: "clickable close-chat",
    staticStyle: {
      "font-size": "22px",
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "top": "5px",
      "right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'idle'
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('LabelMenu', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "menus": _vm.menuItems
    },
    model: {
      value: (_vm.office),
      callback: function($$v) {
        _vm.office = $$v
      },
      expression: "office"
    }
  })], 1), _vm._v(" "), _c('ScrollDownDiv', {
    ref: "history",
    staticClass: "pa-2",
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "auto"
    },
    on: {
      "change": _vm.chatsAdded
    }
  }, [(_vm.messages.length == _vm.messageLimit) ? _c('div', {
    staticClass: "hoverable clickable light-text small-text",
    on: {
      "click": function($event) {
        _vm.messageLimit += 10
      }
    }
  }, [_vm._v("Show More History")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message._id,
      staticClass: "chat-message",
      class: {
        reversed: _vm.isMyMessage(message)
      },
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticClass: "chat-message-picture",
      staticStyle: {
        "flex-basis": "40px"
      },
      attrs: {
        "src": message.user.image
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('div', {
      staticClass: "chat-message-text",
      class: {
        'chat-message-blue': _vm.isMyMessage(message)
      }
    }, [_vm._v("\n                            " + _vm._s(message.text) + " "), _c('span', {
      staticClass: "light-text small-text"
    }, [_vm._v(_vm._s(_vm._f("timeAgo")(message.createdAt)))])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "flex-basis": "35px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    ref: "messageText",
    staticClass: "quick-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.saveMessage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  })])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('draggable', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": {
        animation: 350,
        group: 'items',
        handle: '.draggable-handle'
      }
    },
    on: {
      "end": _vm.afterDrag
    },
    model: {
      value: (_vm.localItems),
      callback: function($$v) {
        _vm.localItems = $$v
      },
      expression: "localItems"
    }
  }, _vm._l((_vm.localItems), function(item) {
    return _c('div', {
      key: item.meta.key,
      staticClass: "list-tile clickable hoverable",
      attrs: {
        "data-order": item.order
      },
      on: {
        "click": function($event) {
          return _vm.itemClicked(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-2px",
        "margin-right": "-15px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "draggable-handle",
            staticStyle: {
              "color": "#ddd"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addItem
      }
    }, [_c('v-list-item-title', [_vm._v("Add New")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._t("default", [_vm._v("    \n                 " + _vm._s(item.name) + "\n            ")], null, item)], 2)
  }), 0), _vm._v(" "), _c('AdvancedDialog', {
    attrs: {
      "record": _vm.editDialog.record,
      "settings": _vm.editDialog.settings,
      "fields": _vm.fields
    },
    on: {
      "save": _vm.saveRecord,
      "delete": _vm.deleteRecord
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": _vm.reassignAll
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('UserChooser', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "contact": _vm.fromUser,
      "contacts": _vm.users,
      "label": "Assign From"
    },
    on: {
      "select": _vm.loadTasksForUser
    },
    model: {
      value: (_vm.fromUser),
      callback: function($$v) {
        _vm.fromUser = $$v
      },
      expression: "fromUser"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('UserChooser', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "contact": _vm.toUser,
      "contacts": _vm.users,
      "label": "Reassign To"
    },
    on: {
      "select": function($event) {
        _vm.hasDestination = true
      }
    },
    model: {
      value: (_vm.toUser),
      callback: function($$v) {
        _vm.toUser = $$v
      },
      expression: "toUser"
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v("For the next " + _vm._s(_vm.days) + " days")]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 0,
      "max": 28
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#999"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tasks.length) + " tasks\n            ")])], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": _vm.tasks.length == 0
    },
    on: {
      "click": _vm.reassign
    }
  }, [_vm._v("Assign")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.value) ? _c('span', {
    class: _vm.mainClass
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e(), _vm._v(" "), (!_vm.value && this.$slots.default && this.$slots.default[0].text.length) ? _c('span', {
    class: _vm.mainClass
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-6"
  }, [_c('Invoice', {
    attrs: {
      "invoice": _vm.invoice
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pdfcrowd-remove mt-5",
    attrs: {
      "href": "//pdfcrowd.com/url_to_pdf/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": ""
    }
  }, [_vm._v("\n            Save to PDF\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasMultipleOffices) ? _c('div', {
    staticClass: "office-chooser center-text full-width"
  }, [_c('v-menu', {
    staticClass: "full-width",
    attrs: {
      "offset-y": "",
      "max-height": "400",
      "nudge-bottom": "0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "office-chooser-button div-button rounded center-text full-width",
          class: _vm.buttonClass,
          style: (_vm.buttonStyle)
        }, on), [_c('div', [_c('v-icon', {
          staticStyle: {
            "color": "inherit",
            "padding-top": "3px"
          }
        }, [_vm._v("mdi-account-supervisor-circle")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex-grow": "1",
            "padding": "3px 3px 3px 6px",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          }
        }, [_vm._v(_vm._s(_vm.currentOffice.name))]), _vm._v(" "), _c('div', {
          staticStyle: {
            "padding": "5px 3px 3px 6px"
          }
        }, [_vm._v(_vm._s(_vm.activeCount))]), _vm._v(" "), _c('v-icon', {
          staticStyle: {
            "color": "inherit",
            "padding-top": "2px"
          }
        }, [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 3530031947),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), (_vm.debugInfinite) ? _c('div') : _vm._e(), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/preferences')
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-settings")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Preferences")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.offices), function(office) {
    return _c('v-list-item', {
      key: office.meta.key,
      class: {
        'blue-hilight': _vm.isCurrentOffice(office.meta.key)
      },
      on: {
        "click": function($event) {
          return _vm.switchToOffice(office)
        }
      }
    }, [_c('v-list-item-action', [_c('v-checkbox', {
      attrs: {
        "input-value": office.active
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleOffice(office)
        }
      }
    })], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(office.name) + " (" + _vm._s(office.meta.key) + ")")]), _vm._v(" "), _c('v-list-item-icon', [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey lighten-1"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.onlyOffice(office)
              }
            }
          }, on), [_vm._v("explore")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("View Only " + _vm._s(office.name))])])], 1)], 1)
  })], 2)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          directives: [{
            name: "ripple",
            rawName: "v-ripple"
          }],
          staticClass: "contact-avatar clickable",
          style: (_vm.imageStyle)
        }, on), [_vm._v("\n            " + _vm._s(_vm.initials) + "\n        ")])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.contact && _vm.contact.image && _vm.size < 35) ? _c('img', {
    staticStyle: {
      "width": "40px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.contact.image
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fullName))])])])
},staticRenderFns: []}

/***/ }),
/* 2545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px",
      "margin-top": "15px"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.images), function(path) {
    return _c('img', {
      key: path,
      staticClass: "round white-border shadow",
      staticStyle: {
        "margin-left": "-15px",
        "margin-top": "-15px"
      },
      attrs: {
        "width": _vm.size,
        "height": _vm.size,
        "src": path,
        "alt": ""
      }
    })
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),
/* 2546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'section-layout': (_vm.parent), 'no-padding': _vm.section.flat
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sectionClicked(_vm.section)
      }
    }
  }, [(!_vm.section.hideTitle) ? _c('div', {
    staticClass: "section-title",
    attrs: {
      "data-key": _vm.section.key
    }
  }, [_c('div', [_vm._v("\n            " + _vm._s(_vm.section.title) + "\n        ")]), _vm._v(" "), _c('div', [_c('div', [_c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": "",
      "nudge-bottom": 6
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "margin": "-4px 0"
          },
          attrs: {
            "text": "",
            "icon": "",
            "color": "grey lighten-1"
          }
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down_circle")])], 1)]
      }
    }], null, false, 1693287487)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-item-title', [_vm._v("Menu Text")])], 1)], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel",
    class: {
      'raised': !_vm.section.flat, 'white-background': !_vm.section.flat, 'no-padding': _vm.section.flat
    }
  }, [_vm._t("default"), _vm._v(" "), _c('ul', {
    staticClass: "link-button-group"
  }, [(_vm.fieldsNotApplicable.length && !_vm.section.viewNaFields) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.$set(_vm.section, 'viewNaFields', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.fieldsNotApplicable.length) + " NA fields")]) : _vm._e(), _vm._v(" "), (_vm.section.viewNaFields && _vm.fieldsNotApplicable.length) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.$set(_vm.section, 'viewNaFields', false)
      }
    }
  }, [_vm._v("Hide NA fields")]) : _vm._e()])], 2)])
},staticRenderFns: []}

/***/ }),
/* 2547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', [_c('v-icon', {
    staticStyle: {
      "font-size": "40px",
      "float": "left",
      "vertical-align": "middle",
      "margin-right": "10px"
    }
  }, [_vm._v("fingerprint")]), _vm._v(" "), _c('div', {
    staticClass: "heading",
    staticStyle: {
      "margin": "5px 0px 15px 0px"
    }
  }, [_vm._v("Welcome to Taco")]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticStyle: {
      "color": "grey",
      "font-size": "12px"
    }
  }, [_vm._v("You are signed in as " + _vm._s(_vm.user.email) + " \n    "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign Out")])]) : _vm._e(), _vm._v(" "), _c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v("\n    Join " + _vm._s(_vm.officeName || ' an Office') + "\n    "), _c('small', [_vm._v("Enter credentials to join.")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Invite Code"
    },
    on: {
      "change": _vm.updateOfficeName
    },
    model: {
      value: (_vm.inviteCode),
      callback: function($$v) {
        _vm.inviteCode = $$v
      },
      expression: "inviteCode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "type": "password",
      "label": "Pin Number"
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-3",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.joinOffice($event)
      }
    }
  }, [_vm._v("Join")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("Create your profile")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "First Name",
      "browser-autocomplete": "false"
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Last Name",
      "browser-autocomplete": "false"
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Email",
      "browser-autocomplete": "false"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Mobile"
    },
    model: {
      value: (_vm.user.mobile),
      callback: function($$v) {
        _vm.$set(_vm.user, "mobile", $$v)
      },
      expression: "user.mobile"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-3",
    nativeOn: {
      "click": function($event) {
        return _vm.createProfile($event)
      }
    }
  }, [_vm._v("Create")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.step > 3
    }
  }, [_vm._v("Start using Taco")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("\n            Gracias. You are ready to begin. To find out more about Taco, "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.google.com/search?q=taco"
    }
  }, [_vm._v("click here")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-3",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_vm._v("Start Using Taco")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 4000
    },
    model: {
      value: (_vm.snackbarShow),
      callback: function($$v) {
        _vm.snackbarShow = $$v
      },
      expression: "snackbarShow"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar) + "\n    "), _c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("fingerprint")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask),
      expression: "newTask"
    }],
    staticClass: "quick-input",
    staticStyle: {
      "margin-bottom": "10px",
      "background-color": "white"
    },
    attrs: {
      "type": "text",
      "placeholder": "Add a task..."
    },
    domProps: {
      "value": (_vm.newTask)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.preventDefault();
        return _vm.quickSaveTask(_vm.newTask)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTask = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      key: task.key,
      staticClass: "task selectable clickable hoverable",
      class: {
        selected: _vm.isTaskSelected(task)
      },
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.selectSingle(task)
        },
        "dblclick": function($event) {
          return _vm.openTask(task)
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
          if ('button' in $event && $event.button !== 2) { return null; }
          return _vm.increment(task, 1)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
          if ('button' in $event && $event.button !== 0) { return null; }
          return _vm.increment(task, -1)
        }]
      }
    }, [_c('div', {
      staticClass: "indicator"
    }, [_c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-1px",
        "margin-right": "-7px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.openTask(task)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.toggleImportant(task)
        }
      }
    }, [_c('v-list-item-title', [(task.important) ? _c('span', [_vm._v("Not ")]) : _vm._e(), _vm._v("Important\n                        ")])], 1), _vm._v(" "), (_vm.tasks.length > 1) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.deleteTask(task)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.tasks.length == 1) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteTask(task, true)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete + Stop Follow Up")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "1%",
        "margin-top": "-22px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-checkbox', {
      on: {
        "change": function($event) {
          return _vm.taskChecked(task)
        }
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(task.title))]), (task.important) ? _c('flag', [_vm._v("Important")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.daysTillDue(task) < 1) ? _c('div', {
      class: _vm.dueIndicatorClass(task),
      staticStyle: {
        "border-radius": "2px",
        "margin-bottom": "-1px",
        "margin-right": "2px",
        "width": "12px",
        "height": "12px",
        "background-color": "#ccc",
        "display": "inline-block"
      }
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm._f("dueString")(task.due))), _c('span', {
      staticStyle: {
        "font-size": "11px",
        "color": "#aaa",
        "margin-left": "4px"
      }
    }, [_vm._v(_vm._s(_vm._f("fullName")(task.assigned)))])], 1)])])])
  }), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('v-radio-group', {
    staticClass: "compact",
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('v-radio', {
      key: option,
      attrs: {
        "color": "primary",
        "label": option,
        "value": option
      }
    })
  }), 1), _vm._v(" "), _c('template', {
    slot: "menu"
  }, [_c('v-list-item', {
    on: {
      "click": _vm.log
    }
  }, [_c('v-list-item-title', [_vm._v("Special Option Menu")])], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scroller",
    staticStyle: {
      "overflow-y": "auto",
      "scroll-behavior": "smooth"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 2551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-checkbox', {
    staticClass: "compact",
    attrs: {
      "color": "primary",
      "input-value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Sort Items",
      "settings": _vm.settings
    },
    on: {
      "save": _vm.save,
      "show": _vm.initialise
    }
  }, [_c('div', {
    staticClass: "pa-2"
  }, [_c('v-btn-toggle', {
    attrs: {
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.exportPreferences),
      callback: function($$v) {
        _vm.exportPreferences = $$v
      },
      expression: "exportPreferences"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Main\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Contacts\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Files\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Comments\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    }
  }, [_vm._v("\n        Emails\n        ")])], 1), _vm._v(" "), _c('v-btn-toggle', {
    staticClass: "ml-2",
    attrs: {
      "dense": "",
      "mandatory": ""
    },
    model: {
      value: (_vm.exportFormat),
      callback: function($$v) {
        _vm.exportFormat = $$v
      },
      expression: "exportFormat"
    }
  }, [_c('v-btn', [_vm._v("\n            HTML\n        ")]), _vm._v(" "), _c('v-btn', [_vm._v("\n            Text\n        ")])], 1)], 1), _vm._v(" "), (_vm.exportFormat == _vm.exportFormatOptions.HTML) ? _c('div', {
    ref: "export",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "max-width": "600px"
    }
  }, [(_vm.exportPreferences.includes(_vm.exportOptions.TRANSACTION)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v(_vm._s(_vm.transactionDetails.clients))]), _vm._v(" "), _vm._l((_vm.importantElements), function(element) {
    return _c('div', {
      key: element.key,
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bolder",
        "padding": "10px",
        "flex-basis": "200px",
        "min-width": "200px",
        "background-color": "#ddd",
        "margin": "1px"
      }
    }, [_vm._v("\n                " + _vm._s(element.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "10px",
        "flex-grow": "1"
      },
      domProps: {
        "innerHTML": _vm._s(element.value)
      }
    })])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.CONTACTS)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Contacts")]), _vm._v(" "), _vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      key: contact['.key'],
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "title": JSON.stringify(contact)
      }
    }, [_c('img', {
      staticStyle: {
        "flex-basis": "40px",
        "margin": "5px",
        "border-radius": "50%"
      },
      attrs: {
        "src": contact.image,
        "width": "60px"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "3px"
      }
    }, [_c('div', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(_vm._f("fullName")(contact)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "color": "#555"
      }
    }, [_vm._v(_vm._s(_vm.phoneNumbers(contact)))])])])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.FILES)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Files")]), _vm._v(" "), _vm._l((_vm.fileElements), function(element) {
    return _c('a', {
      key: element.key,
      attrs: {
        "href": element.value,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "hoverable",
      staticStyle: {
        "width": "100px",
        "padding": "10px",
        "display": "inline-block"
      },
      attrs: {
        "title": element.title
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imagePath,
        "width": "80px"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(element.title))])])])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.COMMENTS)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Comment History")]), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment['.key'],
      staticStyle: {
        "padding": "10px"
      }
    }, [_vm._v("\n            " + _vm._s(comment.text) + " "), _c('span', {
      staticStyle: {
        "color": "#888"
      }
    }, [_vm._v(" - " + _vm._s(_vm._f("fullName")(comment.stamp)) + " " + _vm._s(_vm._f("date")(comment.stamp.date)))])])
  })] : _vm._e(), _vm._v(" "), (_vm.exportPreferences.includes(_vm.exportOptions.EMAILS)) ? [_c('div', {
    style: (_vm.headingStyle)
  }, [_vm._v("Email History")]), _vm._v(" "), _vm._l((_vm.mailLog), function(mailLogItem) {
    return _c('div', {
      key: mailLogItem['id'],
      staticStyle: {
        "padding": "10px"
      }
    }, [_vm._v("\n            From: " + _vm._s(mailLogItem.email.from) + " "), _c('br'), _vm._v("\n            To: " + _vm._s(mailLogItem.email.to.map(function (recipient) { return recipient.email; }).join(', ')) + " "), _c('br'), _vm._v("\n            Subject: " + _vm._s(mailLogItem.email.subject)), _c('br'), _vm._v("\n            Body: " + _vm._s(_vm.removeHtml(mailLogItem.email.body))), _c('br'), _c('br')])
  })] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.exportFormat == _vm.exportFormatOptions.TEXT) ? _c('div', {
    staticClass: "full-width pa-3"
  }, [_c('textarea', {
    staticStyle: {
      "width": "100%",
      "border": "solid 1px #eee"
    },
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": _vm.allText
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "rightVisible": true
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('ElementMenu', {
    attrs: {
      "root": _vm.settingsElement,
      "activeKey": _vm.activeMenuKey
    },
    on: {
      "click": _vm.elementMenuClicked
    }
  })], 1), _vm._v(" "), _c('AutomaticScroll', {
    attrs: {
      "scrolling-element-id": "middle-column",
      "active-section-key": _vm.activeMenuKey,
      "section-element-class": "section-title"
    },
    on: {
      "change": _vm.scrolled
    }
  }, [_c('ElementControl', {
    attrs: {
      "element": _vm.activeElement
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xxray flow-page"
  }, [_c('div', {
    staticClass: "flow-title"
  }, [_vm._v("\n        Title\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flow-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flow-col flow-col-main"
  }, [_c('div', {
    staticClass: "flow-panel-outer light-text"
  }, [_c('div', {
    staticClass: "flow-panel"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "border": "solid 3px red"
    }
  }, [_c('YesNo', {
    attrs: {
      "color": "primary",
      "label": "Work Income",
      "question": "Do you receive any income from work?"
    },
    model: {
      value: (_vm.yesorno1),
      callback: function($$v) {
        _vm.yesorno1 = $$v
      },
      expression: "yesorno1"
    }
  }), _vm._v(" "), _c('YesNo', {
    attrs: {
      "color": "primary",
      "label": "Government Income",
      "question": "Do you receive family payments or other government income?"
    },
    model: {
      value: (_vm.yesorno2),
      callback: function($$v) {
        _vm.yesorno2 = $$v
      },
      expression: "yesorno2"
    }
  }), _vm._v(" "), _c('YesNo', {
    attrs: {
      "color": "primary",
      "question": "Do you receive family payments or other government income?"
    },
    model: {
      value: (_vm.yesorno2),
      callback: function($$v) {
        _vm.yesorno2 = $$v
      },
      expression: "yesorno2"
    }
  }), _vm._v(" "), _c('YesNo', {
    attrs: {
      "color": "primary",
      "label": "Government Income"
    },
    model: {
      value: (_vm.yesorno2),
      callback: function($$v) {
        _vm.yesorno2 = $$v
      },
      expression: "yesorno2"
    }
  })], 1), _vm._v(" "), _c('v-switch')], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-col flow-col-left"
  }, [_c('span', {
    staticClass: "light-text"
  }, [_vm._v("\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-panel-outer light-text"
  }, [_c('div', {
    staticClass: "flow-panel",
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "dotted 1px green",
      "display": "flex",
      "min-height": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "flex-basis": "50px",
      "text-transform": "uppercase",
      "background-color": "#ddd"
    }
  }, [_c('div', {
    staticStyle: {
      "letter-spacing": "2px",
      "margin-left": "34px",
      "margin-top": "20px",
      "transform": "rotate(90deg)",
      "transform-origin": "0 0"
    }
  }, [_vm._v("\n                                Identification\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "position": "relative",
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "elevation-1",
    staticStyle: {
      "border-radius": "100px",
      "background-color": "white",
      "padding": "10px 20px",
      "position": "relative",
      "left": "30px",
      "margin": "10px"
    }
  }, [_vm._v("\n                                Drivers license and Passport\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1",
    staticStyle: {
      "border-radius": "100px",
      "background-color": "white",
      "padding": "10px 20px",
      "position": "relative",
      "left": "30px",
      "margin": "10px"
    }
  }, [_vm._v("\n                                Visa and proof of residency\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1",
    staticStyle: {
      "border-radius": "100px",
      "background-color": "white",
      "padding": "10px 20px",
      "position": "relative",
      "left": "30px",
      "margin": "10px"
    }
  }, [_vm._v("\n                                Registration form (attached)\n                            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-col flow-col-right"
  }, [_c('div', {
    staticClass: "flow-panel-outer light-text"
  }, [_c('div', {
    staticClass: "flow-panel"
  }, [_c('object', {
    attrs: {
      "data": "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd",
      "type": "application/pdf",
      "width": "500",
      "height": "500"
    }
  }, [_vm._v("\n        alt : "), _c('a', {
    attrs: {
      "href": "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd"
    }
  }, [_vm._v("test.pdf")])])])])])
}]}

/***/ }),
/* 2555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('span', {
    staticStyle: {
      "color": "grey"
    }
  }, [_vm._v(_vm._s(_vm.settings.path))]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.element.value || '',
      "auto-height": true
    },
    on: {
      "change": _vm.htmlChanged
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer-region",
    class: {
      focused: _vm.focused, dark: _vm.dark, plain: _vm.plain, inline: _vm.inline, 'read-only': _vm.readOnly
    }
  }, [_c('div', {
    ref: "editRegion",
    staticClass: "dotted-underline edit-region",
    attrs: {
      "contenteditable": !_vm.readOnly
    },
    on: {
      "focus": _vm.gotFocus,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return $event.target.blur()
      }],
      "blur": _vm.changed,
      "mousedown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.value))])])
},staticRenderFns: []}

/***/ }),
/* 2557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "5px 3px 0px 0px"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.increment(-1)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "5px 6px 0px 0px"
    },
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.increment(1)
      }
    }
  }, [_vm._v("+")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "5px 5px 15px 5px"
    }
  }, [(_vm.contact && _vm.contact.mobile) ? _c('span', [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": 'tel:' + _vm.contact.mobile.replace(/\D/g, '')
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": "",
      "disabled": _vm.isMobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "large": "",
            "icon": "",
            "outlined": "",
            "color": "grey"
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("phone")])], 1)]
      }
    }], null, false, 2159970966)
  }, [_vm._v(" "), _c('span', [_vm._v("Call " + _vm._s(_vm._f("phone")(_vm.contact.mobile)))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.contact && _vm.contact.mobile) ? _c('span', [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": 'sms://' + _vm.contact.mobile.replace(/\D/g, '')
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.isMobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "large": "",
            "icon": "",
            "outlined": "",
            "color": "grey"
          },
          on: {
            "click": _vm.showSMS
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("textsms")])], 1)]
      }
    }], null, false, 1308817873)
  }, [_vm._v(" "), _c('span', [_vm._v("Send SMS")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.contact && _vm.contact.email) ? _c('span', [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.isMobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "large": "",
            "icon": "",
            "outlined": "",
            "color": "grey"
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showEmail()
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("email")])], 1)]
      }
    }], null, false, 1953691049)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.contact.email))])])], 1) : _vm._e(), _vm._v(" "), (_vm.contact && _vm.contact.fax) ? _c('span', [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.isMobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "large": "",
            "icon": "",
            "outlined": "",
            "color": "grey"
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showEmail({
                fax: true
              })
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-fax")])], 1)]
      }
    }], null, false, 2407731170)
  }, [_vm._v(" "), _c('span', [_vm._v("Fax " + _vm._s(_vm._f("phone")(_vm.contact.fax)))])])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.isMobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "large": "",
            "icon": "",
            "outlined": "",
            "color": "grey"
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.expandedView = !_vm.expandedView
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("account_box")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("More details")])]), _vm._v(" "), (_vm.expandedView) ? _c('div', {
    staticStyle: {
      "color": "#666"
    }
  }, [_c('table', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('tr', [_c('td', [_c('ContactImage', {
    attrs: {
      "contact": _vm.contact,
      "size": 80
    }
  })], 1), _vm._v(" "), _c('td', [_c('table', {
    staticStyle: {
      "padding": "5px"
    }
  }, [(_vm.contact.mobile) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.mobile))])]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.phone))])]) : _vm._e(), _vm._v(" "), (_vm.contact.fax) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Fax")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.fax))])]) : _vm._e(), _vm._v(" "), (_vm.contact.business) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Business")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.business))])]) : _vm._e(), _vm._v(" "), (_vm.contact.email) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.email))])]) : _vm._e(), _vm._v(" "), (_vm.contact.address) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Address")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.address))])]) : _vm._e(), _vm._v(" "), (_vm.contact.dob) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("DOB")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.contact.dob)))])]) : _vm._e(), _vm._v(" "), (_vm.contact.middleName) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Middle Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.middleName))])]) : _vm._e(), _vm._v(" "), (_vm.contact.owner) ? _c('tr', [_c('td', {
    staticClass: "title-column"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fullName(_vm.contact.owner)))])]) : _vm._e(), _vm._v(" "), (_vm.contact.groups) ? _c('tr', [_c('td', {
    staticClass: "title-column",
    attrs: {
      "valign": "middle"
    }
  }, [_vm._v("Groups")]), _vm._v(" "), _c('td', _vm._l((_vm.objectToArray(_vm.contact.groups)), function(item) {
    return _c('v-chip', {
      key: item,
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.contact.notes) ? _c('tr', [_c('td', {
    staticClass: "title-column",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contact.notes))])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.showingSMS) ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('v-textarea', {
    ref: "smsText",
    attrs: {
      "outline": "",
      "rows": "3",
      "label": _vm.smsPrefix,
      "hint": _vm.smsSuffix,
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.sendSMSMessage($event)
      }
    },
    model: {
      value: (_vm.smsMessage),
      callback: function($$v) {
        _vm.smsMessage = $$v
      },
      expression: "smsMessage"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('v-menu', {
    attrs: {
      "left": "",
      "nudge-top": -34,
      "nudge-left": 13,
      "max-height": "355"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "grey",
            "text": "",
            "icon": "",
            "href": "#"
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }], null, false, 3081475497)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.templates), function(template) {
    return _c('v-list-item', {
      key: template['.key'],
      on: {
        "click": function($event) {
          return _vm.selectSMSTemplate(template)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(template.name))])], 1)
  }), 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width"
  }, [_c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v("Submissions")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded"
  }, [_vm._v("\n\n        This month " + _vm._s(_vm.formatMillions(_vm.amountSubmittedThis)) + "\n        "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "height": "8",
      "rounded": "",
      "value": _vm.amountSubmittedThis / _vm.targetSubmissions * 100
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "light-text"
  }, [_vm._v("Target " + _vm._s(_vm.targetSubmissionsMillions) + " with " + _vm._s(_vm.daysThisMonth - _vm.dayOfMonth) + " days remaining")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "color": "grey",
      "height": "8",
      "rounded": "",
      "value": _vm.dayOfMonth / _vm.daysThisMonth * 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded "
  }, [_vm._v("\n        Last month " + _vm._s(_vm.formatMillions(_vm.amountSubmittedLast)) + "\n        "), _c('v-progress-linear', {
    attrs: {
      "height": "8",
      "color": "purple",
      "rounded": "",
      "value": _vm.amountSubmittedLast / _vm.targetSubmissions * 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v("Settlements")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded"
  }, [_vm._v("\n        This month " + _vm._s(_vm.formatMillions(_vm.amountSettledThis)) + "\n        "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "height": "8",
      "rounded": "",
      "value": _vm.amountSettledThis / _vm.targetSubmissions * 100
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "light-text"
  }, [_vm._v("Target " + _vm._s(_vm.targetSettlementsMillions) + " with " + _vm._s(_vm.daysThisMonth - _vm.dayOfMonth) + " days remaining")]), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "mb-4",
    attrs: {
      "color": "grey",
      "height": "8",
      "rounded": "",
      "value": _vm.dayOfMonth / _vm.daysThisMonth * 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 rounded mb-10"
  }, [_vm._v("\n        Last month " + _vm._s(_vm.formatMillions(_vm.amountSettledLast)) + "\n        "), _c('v-progress-linear', {
    attrs: {
      "height": "8",
      "color": "purple",
      "rounded": "",
      "value": _vm.amountSettledLast / _vm.targetSubmissions * 100
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog.settings.visible = true
      }
    }
  }, [_vm._v("Set Targets")]), _vm._v(" "), (false) ? _c('NoRecordsPlaceholder', [_vm._v("\n        Nothing tomorrow!\n    ")]) : _vm._e(), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Settings",
      "settings": _vm.dialog.settings
    },
    on: {
      "close": function($event) {
        return _vm.saveSettings()
      }
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('div', [_vm._v("Target Submissions " + _vm._s(_vm.targetSubmissionsMillions))]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "30000000",
      "step": "100000"
    },
    model: {
      value: (_vm.targetSubmissions),
      callback: function($$v) {
        _vm.targetSubmissions = $$v
      },
      expression: "targetSubmissions"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Target Settlements " + _vm._s(_vm.targetSettlementsMillions))]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": "0",
      "max": "30000000",
      "step": "100000"
    },
    model: {
      value: (_vm.targetSettlements),
      callback: function($$v) {
        _vm.targetSettlements = $$v
      },
      expression: "targetSettlements"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": ""
    },
    on: {
      "keydown": _vm.checkForNumber,
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grey--text"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _vm._l((_vm.upcomingDates), function(day) {
    return _c('div', {
      key: day.date,
      staticClass: "calendar-day display-flex"
    }, [_c('div', [_c('span', {
      staticStyle: {
        "margin-right": "15px",
        "font-size": "16px",
        "font-weight": "800",
        "color": "#bbb"
      }
    }, [_vm._v(_vm._s(day.weekday))]), _c('br'), _vm._v("\n            " + _vm._s(day.shortDate) + " "), _c('br')]), _vm._v(" "), _c('div', [_vm._l((day.events), function(event) {
      return _c('div', {
        key: event.key,
        staticClass: "mt-1 mr-1"
      }, [_c('Flag', {
        attrs: {
          "primary": ""
        }
      }, [_vm._v(_vm._s(event.title))])], 1)
    }), _vm._v(" "), _vm._l((day.tasks), function(task) {
      return _c('div', {
        key: task.key,
        staticClass: "mt-1 mr-1"
      }, [_c('flag', {
        staticStyle: {
          "max-width": "100%"
        }
      }, [_vm._v(_vm._s(task.title) + " (task)")])], 1)
    })], 2)])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-html5-editor', {
    ref: "vueHtml5Editor",
    attrs: {
      "content": _vm.value || '',
      "auto-height": false,
      "height": _vm.height
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expand-transition', [(_vm.isVisible) ? _c('div', [(!_vm.schema._root || !_vm.schema._root.readOnly || _vm.schema.type == 'Group' || _vm.schema.type == 'Section Heading') ? _c(_vm.controlName, {
    tag: "component",
    attrs: {
      "schema": _vm.mergedSchema,
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  }) : [(_vm.schema.type == 'File') ? _c('FileView', {
    attrs: {
      "schema": _vm.mergedSchema,
      "value": _vm.value
    }
  }) : _c('div', [(_vm.value) ? [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("\n                        " + _vm._s(_vm.mergedSchema.label) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  })] : _vm._e()], 2)]], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width"
  }, [_c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v(_vm._s(_vm.chart.name))]), _vm._v(" "), _c('div', {
    staticClass: "date-section"
  }, _vm._l((_vm.todaysTransactions), function(transaction, n) {
    return _c('div', {
      key: 'today' + n,
      staticClass: "shadow date-card"
    }, [_c('ImageGroup', {
      staticStyle: {
        "margin-top": "-20px"
      },
      attrs: {
        "images": _vm.clientImages(transaction.clients),
        "size": 70
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm.clientNames(transaction.clients)))]), _vm._v(" "), _c('div', {
      staticClass: "heading",
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(transaction.title))]), _vm._v(" "), _c('div', {
      staticClass: "date-bar",
      style: ({
        'background-color': transaction.color
      })
    })], 1)
  }), 0), _vm._v(" "), (!_vm.todaysTransactions.length) ? _c('NoRecordsPlaceholder', [_vm._v("\n        Nothing today!\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-heading mt-2 mb-2 ml-1"
  }, [_vm._v("Tomorrow")]), _vm._v(" "), _c('div', {
    staticClass: "date-section"
  }, _vm._l((_vm.tomorrowsTransactions), function(transaction, m) {
    return _c('div', {
      key: 'today' + m,
      staticClass: "shadow date-card"
    }, [_c('ImageGroup', {
      staticStyle: {
        "margin-top": "-20px"
      },
      attrs: {
        "images": _vm.clientImages(transaction.clients),
        "size": 70
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm.clientNames(transaction.clients)))]), _vm._v(" "), _c('div', {
      staticClass: "heading",
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(transaction.title))]), _vm._v(" "), _c('div', {
      staticClass: "date-bar",
      style: ({
        'background-color': transaction.color
      })
    })], 1)
  }), 0), _vm._v(" "), (!_vm.tomorrowsTransactions.length) ? _c('NoRecordsPlaceholder', [_vm._v("\n        Nothing tomorrow!\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Edit Details",
      "settings": _vm.settings
    },
    on: {
      "save": _vm.saveRecord,
      "show": _vm.show
    }
  }, [_c('v-menu', {
    attrs: {
      "slot": "header",
      "offset-y": ""
    },
    slot: "header",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(menu) {
    return _c('v-list-item', {
      key: menu.name,
      on: {
        "click": function($event) {
          return _vm.menuClicked(menu)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(menu.title))])], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-3"
  }, _vm._l((_vm.fields), function(field, index) {
    return _c('InterfaceField', {
      key: index,
      attrs: {
        "field": field,
        "record": _vm.record,
        "settings": {
          editing: false
        },
        "element": field
      }
    })
  }), 1), _vm._v(" "), (_vm.settings.deleteButton) ? _c('DeleteButton', {
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": _vm.deleteButtonClicked
    },
    slot: "footer"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 2566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mySheet),
      expression: "mySheet"
    }],
    staticClass: "display-flex full-width timer-container",
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('div', [_c('v-icon', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("timer")])], 1), _vm._v(" "), _c('div', {
    staticClass: "timer-text"
  }, [_vm._v("\n            Today: " + _vm._s(_vm.durationToday) + ". Total " + _vm._s(_vm.durationTotal) + "\n            "), (_vm.paused) ? _c('span', [_vm._v("(Paused)")]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "expanded-section"
  }, [_c('table', [_vm._l((_vm.sheets), function(sheet) {
    return _c('tr', {
      key: sheet._id
    }, [_c('td', [_vm._v("\n                " + _vm._s(sheet.userName) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.duration(sheet.total)) + "\n            ")])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                 Total Time\n            ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.duration(_vm.allUserTotal)) + "\n            ")])])], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Sort Items",
      "settings": _vm.settings
    }
  }, [_c('div', {
    staticClass: "pa-2"
  }, [_c('ListList', {
    ref: "list",
    attrs: {
      "items": _vm.items
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "1px 3px 1px 3px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    staticClass: "no-border",
    staticStyle: {
      "padding": "8px",
      "border": "solid 0px #888",
      "color": "#666",
      "width": "100%",
      "font-size": "15px"
    },
    attrs: {
      "slot": "reference",
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    },
    slot: "reference"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "1%"
    }
  }, [(_vm.searchMode) ? _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "color": "grey darken-1",
      "small": ""
    }
  }, [_vm._v("close")])], 1) : _c('GroupSelector', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "settings": {
        multiselect: false,
        title: 'Show Contacts for Group'
      }
    },
    on: {
      "select": _vm.groupSelected
    }
  })], 1)])])]), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "padding-top": "0px",
      "border-radius": "6px"
    },
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.contacts), function(contact, i) {
    return [_c('v-list-item', {
      key: contact.meta.tenantKey + '|' + contact.meta.key,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.contactClicked(contact)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_c('ContactImage', {
      attrs: {
        "contact": contact,
        "size": 45
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                " + _vm._s(_vm._f("fullName")(contact)) + "\n                "), (contact.partner) ? _c('span', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v(" and " + _vm._s(contact.partner.firstName))]) : _vm._e()]), _vm._v(" "), _c('v-list-item-subtitle', {
      staticStyle: {
        "line-height": "1.5"
      }
    }, [(contact.preferredName) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "background-color": "yellow",
        "display": "inline-block",
        "line-height": "0.9em"
      }
    }, [_vm._v("Prefer"), _c('br'), _vm._v(_vm._s(contact.preferredName))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("phoneNumbers")(contact)) + " \n                "), _c('flag', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "value": _vm.initials(contact.owner),
        "title": _vm.officeNameFromKey(contact.meta.tenantKey)
      }
    }), _vm._v(" "), (contact.user) ? _c('flag', {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "value": "User",
        "purple": "",
        "title": contact.meta.key
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.$listeners.jump) ? _c('ListJumpButton', {
      attrs: {
        "tooltip": "Jump to Latest Transaction"
      },
      on: {
        "click": function($event) {
          return _vm.jump(contact)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      key: 'd-' + i
    })]
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "grey--text pa-3"
  }, [_c('v-progress-circular', {
    staticStyle: {
      "display": "block",
      "margin": "auto"
    },
    attrs: {
      "indeterminate": "",
      "color": "grey lighten-1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.noResults) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('add')
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "grey--text text--lighten-2",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add Contact")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("No results. Add a new one?")])], 1)], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._t("default", [_vm._l((_vm.items), function(item) {
    return [_c('ObjectViewer', {
      attrs: {
        "item": item
      }
    })]
  })], {
    "items": _vm.items,
    "teams": _vm.teamNames
  }), _vm._v(" "), (_vm.status == 'loading') ? [_vm._t("loader", [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "grey--text",
    attrs: {
      "indeterminate": ""
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.moreItemsAvailable) ? [_vm._t("more", [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.itemLimit += _vm.limit
      }
    }
  }, [_vm._v("Load More...")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.status == 'loaded' && _vm.items.length == 0) ? [_vm._t("empty", [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "text-align": "center",
      "font-size": "20px",
      "color": "rgba(68,68,68,0.2)"
    }
  }, [_vm._v("\n                No Data\n            ")])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.tabs), function(tab) {
    return [(_vm.milestonesForTab(tab.key).length) ? _c('div', {
      key: tab.key,
      staticClass: "heading"
    }, [_vm._v(_vm._s(tab.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.milestonesForTab(tab.key)), function(element) {
      return [(element.type != 'Section' && element.type != 'Tab') ? _c('div', {
        key: element.key,
        staticClass: "hoverable pa-1",
        staticStyle: {
          "display": "flex",
          "border-radius": "5px"
        },
        on: {
          "click": function($event) {
            return _vm.$emit('jump', element)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "padding-top": "5px"
        }
      }, [_c('v-icon', {
        attrs: {
          "color": (element.value || element.complete ? 'green' : 'grey lighten-2'),
          "large": ""
        }
      }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('div', {
        staticClass: "grey--text text--darken-1",
        staticStyle: {
          "flex-grow": "1",
          "padding-top": "10px",
          "padding-left": "10px"
        }
      }, [_vm._v("\n                    " + _vm._s(element.title)), (element.value || element.complete) ? _c('div', {
        staticClass: "small-text",
        staticStyle: {
          "padding-top": "0",
          "padding-left": "0"
        }
      }, [_vm._v(_vm._s(_vm._f("stamp")(element.stamp)))]) : _vm._e()]), _vm._v(" "), _c('div', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('v-menu', {
        attrs: {
          "left": "",
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-btn', _vm._g({
              attrs: {
                "color": "grey",
                "text": "",
                "icon": ""
              }
            }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.complete(element)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Complete")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.notApplicable(element)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Not Applicable")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.$emit('jump', element)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Go Here")])], 1)], 1)], 1)], 1)]) : _vm._e()]
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showDialog,
      "hide": _vm.hideDialog
    }
  }, [_c('div', {
    staticClass: "pa-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Type of Filter",
      "items": ['Visible']
    },
    model: {
      value: (_vm.filter.type),
      callback: function($$v) {
        _vm.$set(_vm.filter, "type", $$v)
      },
      expression: "filter.type"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Element Name",
      "items": _vm.masterNames
    },
    model: {
      value: (_vm.filter.name),
      callback: function($$v) {
        _vm.$set(_vm.filter, "name", $$v)
      },
      expression: "filter.name"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "label": "Operator",
      "items": _vm.operators.map(function (o) { return o.name; })
    },
    model: {
      value: (_vm.filter.operator),
      callback: function($$v) {
        _vm.$set(_vm.filter, "operator", $$v)
      },
      expression: "filter.operator"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "multiple": "",
      "chips": "",
      "label": "Is one of the following",
      "items": _vm.masterChoices
    },
    model: {
      value: (_vm.filter.values),
      callback: function($$v) {
        _vm.$set(_vm.filter, "values", $$v)
      },
      expression: "filter.values"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "min-width": "600",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-details": "",
      "xpersistent": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.goToElementMaintenance
    }
  }, [_c('v-list-item-title', [_vm._v("Maintenance")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "element-title-bar"
  }, [_vm._v(_vm._s(_vm.model.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Details'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Details'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("subject")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Details")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Advanced'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Advanced'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("category")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Advanced")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Display'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Display'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("visibility")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Display")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Filters'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Filters'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("blur_linear")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Filters")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    class: {
      'active-tab': _vm.tab == 'Tasks'
    },
    on: {
      "click": function($event) {
        _vm.tab = 'Tasks'
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("dns")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Tasks")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [(_vm.tab == 'Details') ? [(!_vm.typeHasValue) ? _c('v-select', {
    attrs: {
      "items": _vm.typeOptions,
      "label": "Type"
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    ref: "focus",
    attrs: {
      "label": "Title"
    },
    on: {
      "blur": _vm.setDefaultName
    },
    model: {
      value: (_vm.model.title),
      callback: function($$v) {
        _vm.$set(_vm.model, "title", $$v)
      },
      expression: "model.title"
    }
  }), _vm._v(" "), (_vm.model.type == 'Text') ? _c('v-checkbox', {
    attrs: {
      "label": "Multi-line"
    },
    model: {
      value: (_vm.model.multiLine),
      callback: function($$v) {
        _vm.$set(_vm.model, "multiLine", $$v)
      },
      expression: "model.multiLine"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('Value')) ? _c('v-textarea', {
    attrs: {
      "label": "Value",
      "rows": 3
    },
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.type == 'List' || _vm.model.type == 'Options' || _vm.model.type == 'Status') ? _c('v-text-field', {
    ref: "optionsText",
    attrs: {
      "label": "Options"
    },
    model: {
      value: (_vm.model.options),
      callback: function($$v) {
        _vm.$set(_vm.model, "options", $$v)
      },
      expression: "model.options"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.type == 'List') ? _c('v-checkbox', {
    attrs: {
      "label": "Allow custom text"
    },
    model: {
      value: (_vm.model.allowCustomText),
      callback: function($$v) {
        _vm.$set(_vm.model, "allowCustomText", $$v)
      },
      expression: "model.allowCustomText"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.nameHasValue) ? _c('v-text-field', {
    attrs: {
      "label": "Field Name"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.type == 'Tab') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Button') ? [_c('v-select', {
    attrs: {
      "items": _vm.buttonActionOptions,
      "label": "Button Action"
    },
    model: {
      value: (_vm.model.buttonAction),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonAction", $$v)
      },
      expression: "model.buttonAction"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.buttonElementsOptions,
      "label": "Elements Affected"
    },
    model: {
      value: (_vm.model.buttonElements),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonElements", $$v)
      },
      expression: "model.buttonElements"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "How many"
    },
    model: {
      value: (_vm.model.buttonElementCount),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonElementCount", $$v)
      },
      expression: "model.buttonElementCount"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.buttonIconOptions,
      "label": "Button Icon",
      "clearable": ""
    },
    model: {
      value: (_vm.model.buttonIcon),
      callback: function($$v) {
        _vm.$set(_vm.model, "buttonIcon", $$v)
      },
      expression: "model.buttonIcon"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Blue"
    },
    model: {
      value: (_vm.model.primary),
      callback: function($$v) {
        _vm.$set(_vm.model, "primary", $$v)
      },
      expression: "model.primary"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Email') ? [_c('v-text-field', {
    attrs: {
      "label": "Email Template Group"
    },
    model: {
      value: (_vm.model.emailGroup),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailGroup", $$v)
      },
      expression: "model.emailGroup"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email Template Name"
    },
    model: {
      value: (_vm.model.emailName),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailName", $$v)
      },
      expression: "model.emailName"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "clearable": "",
      "label": "Send to Role"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Message when completed"
    },
    model: {
      value: (_vm.model.completeMessage),
      callback: function($$v) {
        _vm.$set(_vm.model, "completeMessage", $$v)
      },
      expression: "model.completeMessage"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Send to Field"
    },
    model: {
      value: (_vm.model.toField),
      callback: function($$v) {
        _vm.$set(_vm.model, "toField", $$v)
      },
      expression: "model.toField"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'SMS') ? [_c('v-text-field', {
    attrs: {
      "label": "Message"
    },
    model: {
      value: (_vm.model.message),
      callback: function($$v) {
        _vm.$set(_vm.model, "message", $$v)
      },
      expression: "model.message"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Send to Role"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Contact Selector') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Role",
      "chips": ""
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Contact') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Role"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'User Chooser') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Role",
      "chips": ""
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Lookup') ? [_c('v-text-field', {
    attrs: {
      "label": "Lookup Path",
      "hint": "eg. [lender]/[broker]/Broker Id"
    },
    model: {
      value: (_vm.model.lookup),
      callback: function($$v) {
        _vm.$set(_vm.model, "lookup", $$v)
      },
      expression: "model.lookup"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Show in Help Panel",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.help),
      callback: function($$v) {
        _vm.$set(_vm.model, "help", $$v)
      },
      expression: "model.help"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Global",
      "hint": "All users share accross the system"
    },
    model: {
      value: (_vm.model.global),
      callback: function($$v) {
        _vm.$set(_vm.model, "global", $$v)
      },
      expression: "model.global"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Widget') ? [_c('v-select', {
    attrs: {
      "items": _vm.widgetOptions,
      "label": "Which Widget"
    },
    model: {
      value: (_vm.model.widget),
      callback: function($$v) {
        _vm.$set(_vm.model, "widget", $$v)
      },
      expression: "model.widget"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": [1, 2],
      "label": "Widget Version"
    },
    model: {
      value: (_vm.model.version),
      callback: function($$v) {
        _vm.$set(_vm.model, "version", $$v)
      },
      expression: "model.version"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Scheduler') ? [_c('v-combobox', {
    attrs: {
      "items": ['1', '2', '3', '4', '5', '6', '7', '10', '14', '21'],
      "label": "Days till follow up"
    },
    model: {
      value: (_vm.model.days),
      callback: function($$v) {
        _vm.$set(_vm.model, "days", $$v)
      },
      expression: "model.days"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Task Text"
    },
    model: {
      value: (_vm.model.taskText),
      callback: function($$v) {
        _vm.$set(_vm.model, "taskText", $$v)
      },
      expression: "model.taskText"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.roles,
      "label": "Assign to Role",
      "hint": "Leave blank for current user"
    },
    model: {
      value: (_vm.model.role),
      callback: function($$v) {
        _vm.$set(_vm.model, "role", $$v)
      },
      expression: "model.role"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Charge') ? [_c('CurrencyBox', {
    attrs: {
      "label": "Amount"
    },
    model: {
      value: (_vm.model.amount),
      callback: function($$v) {
        _vm.$set(_vm.model, "amount", $$v)
      },
      expression: "model.amount"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Date') ? [_c('v-switch', {
    attrs: {
      "label": "Short Format",
      "color": "primary"
    },
    model: {
      value: (_vm.model.short),
      callback: function($$v) {
        _vm.$set(_vm.model, "short", $$v)
      },
      expression: "model.short"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Relative to Another Date")]), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Source Element Name",
      "items": _vm.dateElementNames,
      "clearable": ""
    },
    model: {
      value: (_vm.model.relativeTo),
      callback: function($$v) {
        _vm.$set(_vm.model, "relativeTo", $$v)
      },
      expression: "model.relativeTo"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Html') ? [_c('v-textarea', {
    attrs: {
      "label": "Html to Display"
    },
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Jump') ? [_c('v-combobox', {
    attrs: {
      "items": _vm.elementNames,
      "label": "Jump to Element"
    },
    model: {
      value: (_vm.model.target),
      callback: function($$v) {
        _vm.$set(_vm.model, "target", $$v)
      },
      expression: "model.target"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'File') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'File Upload') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Target File Name"
    },
    model: {
      value: (_vm.model.targetName),
      callback: function($$v) {
        _vm.$set(_vm.model, "targetName", $$v)
      },
      expression: "model.targetName"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Outstanding') ? [_c('v-textarea', {
    attrs: {
      "rows": 3,
      "label": "Outstanding Item"
    },
    model: {
      value: (_vm.model.text),
      callback: function($$v) {
        _vm.$set(_vm.model, "text", $$v)
      },
      expression: "model.text"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": 3,
      "label": "Response"
    },
    model: {
      value: (_vm.model.response),
      callback: function($$v) {
        _vm.$set(_vm.model, "response", $$v)
      },
      expression: "model.response"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.statusOptions,
      "label": "Status"
    },
    model: {
      value: (_vm.model.status),
      callback: function($$v) {
        _vm.$set(_vm.model, "status", $$v)
      },
      expression: "model.status"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type == 'Exporter') ? [_c('v-switch', {
    attrs: {
      "label": "Complete",
      "color": "primary"
    },
    model: {
      value: (_vm.model.complete),
      callback: function($$v) {
        _vm.$set(_vm.model, "complete", $$v)
      },
      expression: "model.complete"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.model.type != 'Tab') ? _c('v-slider', {
    attrs: {
      "label": ("Width (" + (_vm.model.width) + "%)"),
      "step": 10
    },
    model: {
      value: (_vm.model.width),
      callback: function($$v) {
        _vm.$set(_vm.model, "width", $$v)
      },
      expression: "model.width"
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.tab == 'Advanced') ? _c('div', {
    staticStyle: {
      "height": "600px"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.typeOptions,
      "label": "Element Type"
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field Name"
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Used in dashboards",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.dashboards),
      callback: function($$v) {
        _vm.$set(_vm.model, "dashboards", $$v)
      },
      expression: "model.dashboards"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Locked",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.locked),
      callback: function($$v) {
        _vm.$set(_vm.model, "locked", $$v)
      },
      expression: "model.locked"
    }
  }), _vm._v(" "), (_vm.model.type == 'Switch' || _vm.model.type == 'Slider') ? _c('v-checkbox', {
    attrs: {
      "label": "Label on Top",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.labelTop),
      callback: function($$v) {
        _vm.$set(_vm.model, "labelTop", $$v)
      },
      expression: "model.labelTop"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Milestone",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.milestone),
      callback: function($$v) {
        _vm.$set(_vm.model, "milestone", $$v)
      },
      expression: "model.milestone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Transaction Field"
    },
    model: {
      value: (_vm.model.transactionField),
      callback: function($$v) {
        _vm.$set(_vm.model, "transactionField", $$v)
      },
      expression: "model.transactionField"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.clearValue
    }
  }, [_vm._v("Clear Value")])], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 'Display') ? _c('div', [(_vm.isContainer) ? _c('v-checkbox', {
    attrs: {
      "label": "Reverse Items",
      "hint": "Shows elements in reverse order",
      "hide-details": "",
      "xpersistent-hint": ""
    },
    model: {
      value: (_vm.model.reverse),
      callback: function($$v) {
        _vm.$set(_vm.model, "reverse", $$v)
      },
      expression: "model.reverse"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Compact",
      "hint": "Takes up less space",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.compact),
      callback: function($$v) {
        _vm.$set(_vm.model, "compact", $$v)
      },
      expression: "model.compact"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Hide Heading",
      "hint": "Takes up less space",
      "hide-details": "",
      "xpersistent-hint": ""
    },
    model: {
      value: (_vm.model.hideHeading),
      callback: function($$v) {
        _vm.$set(_vm.model, "hideHeading", $$v)
      },
      expression: "model.hideHeading"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Show Hint",
      "hint": "Shows in expanded mode",
      "hide-details": "",
      "xpersistent-hint": ""
    },
    model: {
      value: (_vm.model.showHint),
      callback: function($$v) {
        _vm.$set(_vm.model, "showHint", $$v)
      },
      expression: "model.showHint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Collapsable",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.collapsable),
      callback: function($$v) {
        _vm.$set(_vm.model, "collapsable", $$v)
      },
      expression: "model.collapsable"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Don't Print",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.dontPrint),
      callback: function($$v) {
        _vm.$set(_vm.model, "dontPrint", $$v)
      },
      expression: "model.dontPrint"
    }
  }), _vm._v(" "), (_vm.model.order) ? _c('v-text-field', {
    attrs: {
      "label": "Sort Order",
      "disabled": ""
    },
    model: {
      value: (_vm.model.order),
      callback: function($$v) {
        _vm.$set(_vm.model, "order", $$v)
      },
      expression: "model.order"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 'Formula') ? _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Value"
    },
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "disabled": "",
      "label": "Result",
      "hide-details": ""
    },
    model: {
      value: (_vm.formulaResult),
      callback: function($$v) {
        _vm.formulaResult = $$v
      },
      expression: "formulaResult"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tab == 'Filters') ? _c('div', [(!this.filterArray.length) ? _c('div', [_vm._v("\n                    No Filters\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterArray), function(filter) {
    return _c('div', {
      key: filter.name,
      staticClass: "action-panel"
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "50px",
        "padding": "8px"
      }
    }, [_c('v-icon', [_vm._v("visibility")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding": "8px"
      }
    }, [_vm._v("\n                        " + _vm._s(filter.type) + " when "), _c('b', [_vm._v(_vm._s(filter.name))]), _vm._v(" " + _vm._s(filter.operator.toLowerCase()) + ": '" + _vm._s(filter.values.join('/')) + "'\n                    ")]), _vm._v(" "), _c('div', [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "ripple": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "grey lighten-1"
            }
          }, [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editFilter(filter)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit Filter")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteFilter(filter)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Filter")])], 1)], 1)], 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-btn', {
    on: {
      "click": _vm.addFilter
    }
  }, [_vm._v("Add Filter")])], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.tab == 'Tasks') ? _c('div', [_c('div', {
    staticClass: "small-text",
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_vm._v("Automatic tasks can be added to your task list when input for this element is completed.")]), _vm._v(" "), _c('v-list', {
    staticClass: "selectable",
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_vm._l(((_vm.model.tasks || [])), function(task, taskIndex) {
    return _c('v-list-item', {
      key: taskIndex,
      class: {
        active: task == _vm.editingTask
      },
      on: {
        "click": function($event) {
          _vm.editingTask = task
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("dns")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(task.title)
      }
    }), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(task.assigned) + " in " + _vm._s(task.days) + " days")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteAutomaticTask(task)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.addAutomaticTask
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add an automatic task")])], 1), _vm._v(" "), _c('v-list-item-action')], 1)], 2), _vm._v(" "), (_vm.editingTask) ? [_c('div', {
    staticClass: "section"
  }, [_vm._v("Task Details")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Task Text"
    },
    model: {
      value: (_vm.editingTask.title),
      callback: function($$v) {
        _vm.$set(_vm.editingTask, "title", $$v)
      },
      expression: "editingTask.title"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roles,
      "label": "Assign to Role"
    },
    model: {
      value: (_vm.editingTask.role),
      callback: function($$v) {
        _vm.$set(_vm.editingTask, "role", $$v)
      },
      expression: "editingTask.role"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": ['1', '2', '3', '4', '5', '6', '7', '10', '14', '21'],
      "label": "Days"
    },
    model: {
      value: (_vm.editingTask.days),
      callback: function($$v) {
        _vm.$set(_vm.editingTask, "days", $$v)
      },
      expression: "editingTask.days"
    }
  })] : _vm._e()], 2) : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [
    [(this.model.key) ? _c('DeleteButton', {
      staticStyle: {
        "float": "left"
      },
      on: {
        "delete": _vm.deleteElement
      }
    }) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.cancel($event)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": "",
        "disabled": !_vm.valid
      },
      nativeOn: {
        "click": function($event) {
          return _vm.save($event)
        }
      }
    }, [_vm._v("Save")])]
  ], 2)])]), _vm._v(" "), _c('FilterEditor', {
    attrs: {
      "settings": _vm.filterEditorDialog.settings,
      "elements": _vm.filterEditorDialog.elements,
      "filterProp": _vm.filterEditorDialog.filter
    },
    on: {
      "save": _vm.saveFilter,
      "delete": _vm.deleteFilter
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.element.type == 'Section') ? _c('div', {
    staticClass: "section-bar",
    class: {
      selected: _vm.element.key == _vm.selectedSectionKey
    }
  }, [_vm._v("\n        " + _vm._s(_vm.element.title) + "\n        "), (_vm.element.status) ? _c('span', {
    staticStyle: {
      "font-size": "0.7em"
    }
  }, [_vm._v("(" + _vm._s(_vm.element.status) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "30px",
      "float": "right",
      "margin-top": "-2px"
    }
  }, [_c('v-icon', {
    staticClass: "section-star",
    class: {
      complete: _vm.element.complete
    },
    on: {
      "click": _vm.toggleSectionComplete
    }
  }, [_vm._v("star_rate")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Divider') ? _c('hr', {
    staticStyle: {
      "border": "solid 0.5px #cccccc"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Text') ? [(_vm.element.multiLine) ? _c('v-textarea', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _c('v-text-field', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Percent') ? _c('v-text-field', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "suffix": "%",
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Rating') ? [_c('div', {
    staticStyle: {
      "margin-top": "2px",
      "font-size": "12px",
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.saveValue(_vm.element)
      }
    }
  }, [_c('v-rating', {
    class: {
      'element-compact': _vm.element.compact
    },
    staticStyle: {
      "margin-left": "-9px",
      "margin-top": "-7px"
    },
    attrs: {
      "color": "yellow darken-2",
      "background-color": "grey lighten-2",
      "xfull-icon": "favorite",
      "xempty-icon": "favorite_border",
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Slider') ? _c('div', [(!_vm.element.compact) ? _c('div', {
    staticClass: "grey--text text--darken-2 truncate",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s((_vm.element.labelTop ? _vm.element.title : ' ')))]) : _vm._e(), _vm._v(" "), _c('v-slider', {
    attrs: {
      "label": (_vm.element.labelTop ? '' : _vm.element.title),
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.element.type == 'List') ? [(_vm.element.allowCustomText) ? _c('v-combobox', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "id": _vm.element.key,
      "clearable": "",
      "items": _vm.splitOptions(_vm.element),
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _c('v-autocomplete', {
    class: {
      'element-compact': _vm.element.compact
    },
    attrs: {
      "id": _vm.element.key,
      "clearable": "",
      "items": _vm.splitOptions(_vm.element),
      "label": _vm.element.title,
      "hide-details": !_vm.element.showHint,
      "single-line": _vm.element.compact
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Options') ? [(!_vm.element.compact) ? _c('div', {
    staticClass: "grey--text text--darken-2 truncate",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "0px",
      "margin-bottom": "-15px"
    }
  }, [_vm._v(_vm._s(_vm.element.title))]) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": false,
      "hide-details": !_vm.element.showHint
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }, _vm._l((_vm.splitOptions(_vm.element)), function(option) {
    return _c('v-radio', {
      key: option,
      attrs: {
        "label": option,
        "value": option,
        "color": "primary"
      }
    })
  }), 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checkbox List') ? [(!_vm.element.compact) ? _c('div', {
    staticClass: "grey--text text--darken-2 truncate",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v(_vm._s(_vm.element.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.splitOptions(_vm.element)), function(option) {
    return _c('v-checkbox', {
      key: option,
      staticClass: "checkbox-list",
      attrs: {
        "label": option,
        "value": option,
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.saveValue(_vm.element)
        }
      },
      model: {
        value: (_vm.checkboxListValue),
        callback: function($$v) {
          _vm.checkboxListValue = $$v
        },
        expression: "checkboxListValue"
      }
    })
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Heading') ? _c('div', {
    staticClass: "element-heading"
  }, [_vm._v("\n        " + _vm._s(_vm.element.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Switch') ? [_c('v-switch', {
    attrs: {
      "label": (_vm.element.labelTop ? '' : _vm.element.title),
      "hide-details": !_vm.element.showHint,
      "color": "primary"
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checkbox') ? [_c('v-checkbox', {
    attrs: {
      "label": _vm.element.title,
      "color": "primary",
      "hide-details": !_vm.element.showHint
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'DateTime') ? [_c('DateTime', {
    attrs: {
      "label": _vm.element.title
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Date') ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('DateBox', {
    ref: 'datebox' + _vm.element.key,
    staticClass: "field-width",
    attrs: {
      "label": _vm.element.title,
      "hide-details": _vm.hideHint(_vm.element),
      "single-line": _vm.element.compact,
      "disabled": _vm.element.locked,
      "short": _vm.element.short,
      "baseDate": _vm.getValueFromName(_vm.element.relativeTo)
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "left": "",
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "small": "",
            "color": "grey lighten-4"
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("arrow_drop_down_circle")])], 1)]
      }
    }], null, false, 2389600186),
    model: {
      value: (_vm.dateMenuVisible),
      callback: function($$v) {
        _vm.dateMenuVisible = $$v
      },
      expression: "dateMenuVisible"
    }
  }, [_vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "mini-menu-bar"
  }, [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), _c('v-date-picker', {
    staticClass: "elevation-0",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.datePickerChanged,
      "dblclick": function($event) {
        _vm.dateMenuVisible = false
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.element.value,
      "text": ""
    },
    on: {
      "click": _vm.makeTaskFromDate
    }
  }, [_vm._v("Make Task")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dateMenuVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Currency') ? _c('CurrencyBox', {
    staticClass: "field-width",
    attrs: {
      "label": _vm.element.title,
      "hide-details": _vm.hideHint(_vm.element),
      "single-line": _vm.element.compact,
      "disabled": _vm.element.locked
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Status') ? _c('StatusBox', {
    attrs: {
      "options": _vm.element.options
    },
    on: {
      "input": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Button') ? [_c('v-btn', {
    staticStyle: {
      "margin-top": "13px",
      "margin-left": "-8px",
      "margin-right": "-6px"
    },
    attrs: {
      "color": (_vm.element.primary ? 'primary' : 'grey lighten-2'),
      "icon": Boolean(_vm.element.buttonIcon)
    },
    on: {
      "click": function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('button', _vm.element)
      }
    }
  }, [(_vm.element.buttonIcon) ? _c('v-icon', [_vm._v(_vm._s(_vm.element.buttonIcon))]) : _vm._e(), _vm._v(" "), (!_vm.element.buttonIcon) ? [_vm._v(_vm._s(_vm.element.title))] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'User Chooser') ? [_c('UserChooser', {
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "role": _vm.element.role,
      "label": _vm.element.title
    },
    model: {
      value: (_vm.userChooserUser),
      callback: function($$v) {
        _vm.userChooserUser = $$v
      },
      expression: "userChooserUser"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Email') ? [_c('ElementButton', {
    attrs: {
      "element": _vm.element,
      "icon": "email"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'email', _vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'SMS') ? [(_vm.element.complete) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('ElementButton', _vm._g({
          attrs: {
            "element": _vm.element,
            "icon": "chat"
          }
        }, on))]
      }
    }], null, false, 1938783601)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'sms', _vm.element)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Send Another")])], 1)], 1)], 1) : _c('ElementButton', {
    attrs: {
      "element": _vm.element,
      "icon": "sms"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'sms', _vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Contact Selector') ? [_vm._l((_vm.contactElementsForRole(_vm.element.role)), function(contactElement) {
    return _c('div', {
      key: contactElement.key
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({}, on), [_c('ElementButton', {
            attrs: {
              "complete": true,
              "text": _vm.fullName(contactElement.contact) + ' (' + contactElement.role + ')',
              "element": _vm.element,
              "icon": "account_circle"
            }
          })], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('action', 'contact-view', contactElement)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("View")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('action', 'contact', _vm.element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add another " + _vm._s(contactElement.role))])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('action', 'contact-remove', contactElement)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Remove " + _vm._s(contactElement.role))])], 1)], 1)], 1)], 1)
  }), _vm._v(" "), (!_vm.contactElementsForRole(_vm.element.role).length) ? _c('ElementButton', {
    attrs: {
      "element": _vm.element,
      "text": _vm.element.title,
      "icon": "account_circle"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('action', 'contact', _vm.element)
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.element.type == 'File') ? [_c('div', {
    staticClass: "element-button"
  }, [_vm._v("File: " + _vm._s(_vm.element.name))])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'File Upload') ? [(!_vm.element.compact) ? _c('div', {
    staticStyle: {
      "height": "10px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-left": "0px"
    }
  }, [_c('UploadElement', {
    staticStyle: {
      "align-self": "top"
    },
    attrs: {
      "element": _vm.element
    },
    on: {
      "menu": _vm.uploadElementMenu
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "16px",
      "padding": "3px",
      "align-self": "center"
    }
  }, [_vm._v(_vm._s(_vm.element.title))])], 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Widget' && _vm.element.widget == 'Outstandings Diagram') ? [_c('OutstandingsDiagram', {
    on: {
      "click": function($event) {
        void _vm.x
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Scheduler') ? [_c('ElementButton', {
    attrs: {
      "xxxv-on": "on",
      "element": _vm.element,
      "text": (_vm.element.complete ? 'Scheduled: ' : 'Schedule ') + _vm.element.title,
      "icon": "today"
    },
    on: {
      "click": function($event) {
        return _vm.showTaskDialog(_vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Exporter') ? [_c('ElementButton', {
    attrs: {
      "xxxv-on": "on",
      "element": _vm.element,
      "text": "Export to CRM",
      "icon": "mdi-database-export"
    },
    on: {
      "click": function($event) {
        return _vm.exportHistory(_vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Charge') ? [_c('ElementButton', {
    attrs: {
      "xxxv-on": "on",
      "element": _vm.element,
      "text": (_vm.element.value ? _vm.element.value : _vm.element.title),
      "icon": "monetization_on"
    },
    on: {
      "click": function($event) {
        return _vm.showChargeDialog(_vm.element)
      }
    }
  }), _vm._v(" "), (_vm.chargeDialogData.settings.visible) ? _c('ChargeDialog', {
    attrs: {
      "settings": _vm.chargeDialogData.settings,
      "charge": _vm.chargeDialogData.charge
    },
    on: {
      "saved": _vm.chargeSaved
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Lookup') ? [(!_vm.element.help) ? _c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "hint": _vm.merge(_vm.element.lookup)
    },
    on: {
      "change": function($event) {
        return _vm.saveValue(_vm.element)
      }
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  }) : _c('div', {
    staticStyle: {
      "font-size": "16px"
    },
    style: ({
      'padding-top': (_vm.element.compact ? '2px' : '21px')
    })
  }, [_c('a', {
    class: {
      'grey--text': !_vm.element.value
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('action', 'display-lookup', _vm.element)
      }
    }
  }, [_vm._v(_vm._s(_vm.element.title))])])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Html') ? [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.merge(_vm.element.value))
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'LoanAttributes') ? [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("\n            " + _vm._s(_vm.element.title) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.loanAttributes()) + "\n        ")])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Jump') ? [_c('ElementButton', {
    attrs: {
      "complete": _vm.isTargetComplete(_vm.element),
      "element": _vm.element,
      "icon": "gps_fixed"
    },
    on: {
      "click": function($event) {
        return _vm.jumpFromElement(_vm.element)
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Outstanding') ? [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "text-selectable",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.element.text) + "\n\n                "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "display": "inline-block",
            "cursor": "pointer"
          }
        }, on), [_c('flag', {
          attrs: {
            "error": _vm.element.status && _vm.element.status.indexOf('Waiting') > -1,
            "success": _vm.element.status && _vm.element.status.indexOf('Sent') > -1,
            "purple": _vm.element.status == 'Settlement Condition',
            "orange": _vm.element.status == 'Waiting for Broker',
            "darkred": _vm.element.status == 'Waiting for Processor'
          }
        }, [_vm._v(_vm._s(_vm.element.status))])], 1)]
      }
    }], null, false, 3179923581)
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.statusOptions), function(option, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.updateElementProperty(_vm.element, 'status', option)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(option))])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.bulkChangeOutstandings('Waiting', 'Ready to Send')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("All Ready")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.bulkChangeOutstandings('Ready to Send', 'Sent')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("All Sent")])], 1)], 2)], 1), _vm._v(" "), _vm._l((_vm.element.linkedFileKeys), function(linkedFileKey) {
    return [_c('a', {
      key: linkedFileKey,
      staticClass: "transparent",
      attrs: {
        "href": _vm.fileFromId(linkedFileKey).value,
        "target": "_blank"
      }
    }, [_c('flag', {
      staticClass: "clickable",
      attrs: {
        "white": ""
      }
    }, [_vm._v(_vm._s(_vm.fileFromId(linkedFileKey).fileName))])], 1)]
  }), _vm._v(" "), _c('div', {
    staticClass: "grey--text"
  }, [_vm._v("\n                " + _vm._s(_vm.element.response) + "\n                ")])], 2), _vm._v(" "), _c('div', [_c('UploadElement', {
    staticStyle: {
      "align-self": "top"
    },
    attrs: {
      "element": _vm.element
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checklist') ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "padding-left": "4px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleChecklist(_vm.element)
      }
    }
  }, [_c('div', [_c('v-progress-circular', {
    attrs: {
      "value": _vm.element.percent || 0,
      "color": "blue",
      "width": 6,
      "size": 30,
      "rotate": -90
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "font-size": "16px",
      "color": "#555",
      "padding-left": "10px",
      "padding-top": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.element.title))]), _vm._v(" "), (_vm.element.collapsed) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "0px"
    }
  }, [_vm._v("keyboard_arrow_down")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-expand-transition', [(!_vm.element.collapsed) ? _c('checklist', {
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "list": _vm.element.checklist,
      "passBack": {
        element: _vm.element
      }
    },
    on: {
      "save": _vm.saveChecklist
    }
  }) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Widget') ? [(_vm.element.widget == 'Import Outstandings') ? _c('ImportItems', {
    attrs: {
      "compact": _vm.element.compact
    },
    on: {
      "importItems": _vm.importItems,
      "saveState": _vm.saveState
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Element Summary') ? _c('ElementSummary') : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Loan Diagram') ? [(_vm.element.version == '2') ? _c('HomeLoan', {
    ref: "hld",
    attrs: {
      "homeLoan": _vm.element.diagram2,
      "passBack": {
        element: _vm.element
      }
    },
    on: {
      "save": _vm.saveLoanDiagram2,
      "change": _vm.loanDiagramChanged
    }
  }) : _c('LoanDiagram', {
    attrs: {
      "diagram": _vm.element.diagram,
      "passBack": {
        element: _vm.element
      }
    },
    on: {
      "save": _vm.saveLoanDiagram
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Transaction Summary') ? _c('TransactionSummary', {
    on: {
      "jump": _vm.jumpToElement,
      "save": _vm.saveElement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.widget == 'Coming Up') ? _c('ComingUp', {
    attrs: {
      "element": _vm.element
    },
    on: {
      "jump": _vm.jumpToElement,
      "save": _vm.saveElement
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  }), _vm._v(" "), (_vm.element.type == 'Exporter' && _vm.exporterDialog.settings.visible) ? _c('ExporterDialog', {
    attrs: {
      "elements": _vm.elements,
      "settings": _vm.exporterDialog.settings
    },
    on: {
      "save": _vm.exportSave
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control",
    class: _vm.formClass
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.value) ? _c('ControlList', {
    attrs: {
      "value": _vm.value,
      "schema": _vm.schemaFields,
      "context": _vm.childContext
    },
    on: {
      "change": _vm.emitChanges
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "5px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "pa-1"
  }, [_c('img', {
    staticClass: "round",
    staticStyle: {
      "border": "solid 1px #eee",
      "width": "40px",
      "height": "40px"
    },
    attrs: {
      "src": "/static/images/user-placeholder.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pa-1"
  }, [_vm._v("\n        " + _vm._s(_vm._f("fullName")(_vm.contact)) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 2576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-container",
    on: {
      "click": _vm.wrapperClicked
    }
  }, [_vm._t("default"), _vm._v(" "), _c('input', {
    attrs: {
      "multiple": _vm.multiple,
      "type": "file"
    },
    on: {
      "change": _vm.emitChanges
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-combobox', {
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "items": _vm.commonRanges.map(function (o) { return o.text; }),
      "label": _vm.label,
      "xxxappend-outer-icon": "event"
    },
    model: {
      value: (_vm.rangeText),
      callback: function($$v) {
        _vm.rangeText = $$v
      },
      expression: "rangeText"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "18px 0 0 5px"
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.showCalendar
    }
  }, [_vm._v("event")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "white-background",
    on: {
      "click": _vm.closeIfApplicable
    }
  }, [_c('div', {
    staticClass: "pa-3 primary white--text"
  }, [_vm._v("\n                " + _vm._s(_vm.dialogTitle) + "\n            ")]), _vm._v(" "), (_vm.dialogVisible) ? _c('v-date-picker', {
    attrs: {
      "range": "",
      "no-title": "",
      "locale": "en-AU"
    },
    model: {
      value: (_vm.pickerDates),
      callback: function($$v) {
        _vm.pickerDates = $$v
      },
      expression: "pickerDates"
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout"
  }, [_c('template', {
    slot: "header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "flat": "",
      "dark": "",
      "dense": "",
      "xxstyle": "z-index:8;position:fixed;"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Taco")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('ToolbarSearch', {
    ref: "searchBox",
    attrs: {
      "debounced": ""
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.makeContacts
    }
  }, [_c('v-list-item-title', [_vm._v("Make 100 Contacts")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.makeGroups
    }
  }, [_c('v-list-item-title', [_vm._v("Make Initial Groups")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.createInitialTeams
    }
  }, [_c('v-list-item-title', [_vm._v("Make Initial Teams For This User")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.initSearchFields
    }
  }, [_c('v-list-item-title', [_vm._v("Initialise Search Fields")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "left"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#e0e0e0",
      "height": "100%"
    }
  }, [_c('DataLoader', {
    ref: "groupsData",
    attrs: {
      "collection": "groups",
      "sort-field": "name",
      "limit": 40
    },
    on: {
      "loaded": _vm.groupsLoaded
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var groups = ref.items;

        return [_c('OneOrMoreList', {
          ref: "groupsList",
          attrs: {
            "items": groups,
            "icon": "mdi-account-group"
          },
          on: {
            "add": _vm.addGroup,
            "expanded": _vm.groupExpanded,
            "contracted": _vm.groupContracted,
            "selection-change": function($event) {
              return _vm.resetContactSelection(false)
            }
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function() {
              return [_c('div', {
                staticClass: "ml-3 mr-3"
              }, [_c('div', {
                staticClass: "element-label"
              }, [_vm._v("Show contacts that are in")]), _vm._v(" "), _c('v-btn-toggle', {
                attrs: {
                  "borderless": "",
                  "dense": ""
                },
                model: {
                  value: (_vm.joinSets),
                  callback: function($$v) {
                    _vm.joinSets = $$v
                  },
                  expression: "joinSets"
                }
              }, [_c('v-btn', {
                attrs: {
                  "value": "intersection"
                }
              }, [_c('span', {
                staticClass: "hidden-sm-and-down"
              }, [_vm._v("All Groups")]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-vector-intersection")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "value": "union"
                }
              }, [_c('span', {
                staticClass: "hidden-sm-and-down"
              }, [_vm._v("Any Group")]), _vm._v(" "), _c('v-icon', {
                attrs: {
                  "right": ""
                }
              }, [_vm._v("mdi-vector-arrange-below")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
                on: {
                  "click": function($event) {}
                }
              }, [_c('v-list-item-title', [_vm._v("Do Something")])], 1)]
            },
            proxy: true
          }, {
            key: "title",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "swatch-container"
              }, [_c('v-chip', {
                staticStyle: {
                  "margin": "0px 5px 0 -3px",
                  "width": "44px",
                  "text-align": "center"
                },
                attrs: {
                  "dark": "",
                  "small": "",
                  "color": item.colour || '#ccc'
                }
              }, [_vm._v(_vm._s(item.members || '0'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.name))])], 1)]
            }
          }, {
            key: "content",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "pa-2"
              }, [_c('v-form', [_c('v-text-field', {
                ref: "name",
                attrs: {
                  "label": "Name",
                  "hide-details": ""
                },
                model: {
                  value: (item.name),
                  callback: function($$v) {
                    _vm.$set(item, "name", $$v)
                  },
                  expression: "item.name"
                }
              }), _vm._v(" "), _c('v-switch', {
                attrs: {
                  "color": "blue",
                  "label": "Favourite",
                  "hide-details": ""
                },
                model: {
                  value: (item.favourite),
                  callback: function($$v) {
                    _vm.$set(item, "favourite", $$v)
                  },
                  expression: "item.favourite"
                }
              }), _vm._v(" "), _c('ColourBar', {
                staticClass: "mt-2",
                attrs: {
                  "colours": _vm.colours,
                  "label": "Colour"
                },
                model: {
                  value: (item.colour),
                  callback: function($$v) {
                    _vm.$set(item, "colour", $$v)
                  },
                  expression: "item.colour"
                }
              })], 1), _vm._v(" "), _c('div', {
                staticClass: "element-label mt-4"
              }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
                staticClass: "action-menu"
              }, [_vm._v("Email Group")]), _vm._v(" "), _c('div', {
                staticClass: "action-menu"
              }, [_vm._v("Delete Group")]), _vm._v(" "), (_vm.selectedContacts.length > 0) ? _c('div', {
                staticClass: "action-menu",
                on: {
                  "click": function($event) {
                    return _vm.addToGroup(item)
                  }
                }
              }, [_vm._v("Add Selected Contacts")]) : _vm._e()], 1)]
            }
          }], null, true)
        })]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_c('v-btn', {
    staticClass: "full-width grey--text text--darken-1",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "color": "grey lighten-2",
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("Add a Group")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa-3 elevation-1 ma-3",
    staticStyle: {
      "overflow": "auto",
      "background-color": "#f0f0f0"
    }
  }, [_c('DataLoader', {
    ref: "contactsData",
    attrs: {
      "collection": "contacts",
      "search": _vm.contactSearch,
      "conditions": _vm.groupsFilter,
      "sort-field": _vm.sortField,
      "limit": 40
    },
    on: {
      "loading": _vm.contactsLoading,
      "loaded": _vm.contactsLoaded
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var contacts = ref.items;

        return [_c('OneOrMoreList', {
          ref: "contactsList",
          attrs: {
            "lock": Boolean(_vm.lock || _vm.addingRelationship),
            "hide-expander": "",
            "width": "350px",
            "items": contacts,
            "icon": "mdi-account-user"
          },
          on: {
            "selection-change": _vm.contactSelectionChanged
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function() {
              return [_c('v-list-item', {
                on: {
                  "click": function($event) {}
                }
              }, [_c('v-list-item-title', [_vm._v("Do Something")])], 1)]
            },
            proxy: true
          }, {
            key: "title",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "swatch-container"
              }, [_c('img', {
                staticClass: "contact-image mr-2",
                attrs: {
                  "src": item.image,
                  "alt": ""
                },
                on: {
                  "click": function($event) {
                    return _vm.avatarClicked(item)
                  }
                }
              }), _vm._v(" "), _c('div', {
                staticClass: "contact-details"
              }, [_c('div', [_vm._v("\n                                    " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + " "), (item.hasPartner) ? _c('span', {
                staticStyle: {
                  "font-weight": "300"
                }
              }, [_vm._v(" +")]) : _vm._e()]), _vm._v(" "), _c('div', {
                staticStyle: {
                  "font-weight": "300"
                }
              }, [_vm._v("\n                                    " + _vm._s(item.mobile) + " \n                                ")]), _vm._v(" "), _c('div', {
                staticClass: "small-text",
                staticStyle: {
                  "font-weight": "300"
                }
              }, [_vm._v("\n                                    " + _vm._s(_vm.getItemTeamName(item)) + " \n                                ")])]), _vm._v(" "), _c('v-btn', {
                staticStyle: {
                  "margin-top": "-3px"
                },
                attrs: {
                  "icon": "",
                  "color": "grey lighten-1"
                },
                on: {
                  "click": function($event) {
                    $event.stopPropagation();
                    return _vm.sendEmail(item)
                  },
                  "mousedown": function($event) {
                    $event.stopPropagation();
                  }
                }
              }, [_c('v-icon', [_vm._v("email")])], 1)], 1)]
            }
          }], null, true)
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [(_vm.lock) ? _c('div', {
    key: "lock",
    staticClass: "panel-multi pa-3 mb-3 rounded display-flex",
    staticStyle: {
      "border": "dotted 4px #2E9AFE",
      "background-color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lock) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue",
      "small": "",
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetContactSelection(true)
      }
    }
  }, [_vm._v("Clear")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedContacts.length > 0) ? _c('div', {
    key: "base",
    staticClass: "panel-multi white pa-3 rounded",
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.lock) ? _c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "top": "5px",
      "right": "5px",
      "z-index": "100"
    },
    attrs: {
      "color": (_vm.lock ? 'blue' : 'grey lighten-2'),
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.lock = 'Selection is locked on'
      }
    }
  }, [_c('v-icon', [_vm._v("lock")])], 1) : _vm._e(), _vm._v(" "), _c('ContactImages', {
    attrs: {
      "contacts": _vm.selectedContacts,
      "partners": _vm.contactsArePartners
    }
  }), _vm._v(" "), (_vm.selectedContacts.length == 1) ? _c('div', [_c('div', {
    key: "one"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "10",
      "flex-basis": "200px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "First Name",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.firstName),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "firstName", $$v)
      },
      expression: "selectedContact.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.lastName),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "lastName", $$v)
      },
      expression: "selectedContact.lastName"
    }
  })], 1)]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.email),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "email", $$v)
      },
      expression: "selectedContact.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mobile",
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedContact.mobile),
      callback: function($$v) {
        _vm.$set(_vm.selectedContact, "mobile", $$v)
      },
      expression: "selectedContact.mobile"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedContacts.length == 2) ? _c('div', {
    key: "two",
    staticClass: "white pa-3 rounded panel-multi"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-content": "center",
      "font-size": "12px",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "text-align": "center"
    }
  }, [(_vm.addingRelationship) ? _c('v-select', {
    staticStyle: {
      "width": "110px",
      "margin": "0 auto"
    },
    attrs: {
      "items": _vm.relationshipNames,
      "return-object": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.newRelationship),
      callback: function($$v) {
        _vm.newRelationship = $$v
      },
      expression: "newRelationship"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "text-align": "center"
    }
  }, [(_vm.addingRelationship) ? _c('v-text-field', {
    staticStyle: {
      "width": "110px",
      "margin": "0 auto"
    },
    attrs: {
      "value": _vm.newRelationship.relatedText,
      "hide-details": ""
    },
    on: {
      "keydown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stretch-contents mt-3"
  }, [(_vm.addingRelationship) ? [_c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.saveRelationship
    }
  }, [_vm._v("\n                            Save Relationship\n                        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.addingRelationship = false
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])] : _vm._e(), _vm._v(" "), (!_vm.addingRelationship) ? [(_vm.contactsArePartners) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.separatePartners
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "grey"
    }
  }, [_vm._v("mdi-heart-broken")]), _vm._v("\n                            Separate\n                        ")], 1) : _vm._e(), _vm._v(" "), (_vm.contactsCouldBePartners) ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.makePartners
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "grey"
    }
  }, [_vm._v("mdi-heart")]), _vm._v("\n                            Make Partners\n                        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.contactsArePartners && !_vm.contactsCouldBePartners && !_vm.differentTeams) ? _c('div', {
    staticClass: "small-text light-text center-text"
  }, [_vm._v("\n                            Contacts have existing partner/s\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.differentTeams) ? _c('div', {
    staticClass: "small-text light-text center-text"
  }, [_vm._v("\n                            Contacts have different teams\n                        ")]) : _vm._e(), _vm._v(" "), (!_vm.differentTeams) ? _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.addingRelationship = true
      }
    }
  }, [_vm._v("\n                            Relate Contacts\n                        ")]) : _vm._e()] : _vm._e()], 2)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length == 0) ? _c('div', {
    staticClass: "white pa-3 rounded mt-0"
  }, [_c('div', {
    staticClass: "element-label mb-2"
  }, [_vm._v("Sorted by " + _vm._s(_vm.sortField))]), _vm._v(" "), _c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.sortField = _vm.alternateSortField
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-sort")]), _vm._v("\n                    Sort by " + _vm._s(_vm.alternateSortField) + "\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length > 0) ? _c('div', {
    staticClass: "white pa-3 rounded mt-4"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("Groups")]), _vm._v(" "), (this.selectedContacts.length == 1) ? _c('TagsView', {
    attrs: {
      "tags": _vm.selectedContact.tags,
      "available-tags": this.groups
    },
    on: {
      "remove": _vm.removeFromGroup
    }
  }) : _vm._e(), _vm._v(" "), _c('GroupDropdown', {
    staticClass: "full-width",
    attrs: {
      "buttonClass": "mt-2",
      "groups": _vm.groups,
      "label": "Add to Group"
    },
    on: {
      "new": _vm.addToNewGroup,
      "select": _vm.addToGroup
    }
  }), _vm._v(" "), (this.selectedContacts.length != 1) ? _c('GroupDropdown', {
    staticClass: "full-width",
    attrs: {
      "buttonClass": "mt-2",
      "groups": _vm.groups,
      "label": "Remove from Group",
      "existing-only": ""
    },
    on: {
      "select": _vm.removeFromGroup
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length == 1) ? _c('div', {
    key: "relationships",
    staticClass: "white pa-3 rounded mt-4"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("Relationships")]), _vm._v(" "), _c('DataLoader', {
    attrs: {
      "collection": "relationships",
      "conditions": _vm.relationshipsFilter,
      "limit": 10
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var relationships = ref.items;

        return [_vm._l((relationships), function(relationship) {
          return [_c('v-menu', {
            key: relationship._id,
            attrs: {
              "offset-y": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({
                  key: relationship._id,
                  staticClass: "hoverable clickable",
                  staticStyle: {
                    "display": "flex",
                    "padding": "4px"
                  }
                }, on), [_c('img', {
                  staticClass: "contact-image white-border shadow",
                  staticStyle: {
                    "height": "40px",
                    "width": "40px",
                    "margin-right": "20px"
                  },
                  attrs: {
                    "alt": "",
                    "src": relationship.relatedImage
                  }
                }), _vm._v(" "), _c('div', {
                  staticStyle: {
                    "flex-grow": "1",
                    "font-size": "14px"
                  }
                }, [_c('div', [_vm._v("\n                                        " + _vm._s(relationship.relatedFirstName) + " " + _vm._s(relationship.relatedLastName) + "\n                                    ")]), _vm._v(" "), _c('div', {
                  staticStyle: {
                    "font-weight": "300"
                  }
                }, [_vm._v("\n                                        " + _vm._s(relationship.relatedRelationship) + "\n                                    ")])])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.goToRelated(relationship)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Go to " + _vm._s(relationship.relatedFirstName))])], 1), _vm._v(" "), _c('v-list-item', {
            on: {
              "click": function($event) {
                return _vm.removeRelationship(relationship)
              }
            }
          }, [_c('v-list-item-title', [_vm._v("Remove this relationship")])], 1)], 1)], 1)]
        })]
      }
    }, {
      key: "empty",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "24px",
            "padding": "3px 3px 0 3px"
          }
        }, [_vm._v("🤔")]), _vm._v(" "), _c('div', {
          staticClass: "light-text",
          staticStyle: {
            "font-size": "14px"
          }
        }, [_vm._v("Totally unrelated")])])]
      },
      proxy: true
    }], null, false, 2260953761),
    model: {
      value: (_vm.singleRelationships),
      callback: function($$v) {
        _vm.singleRelationships = $$v
      },
      expression: "singleRelationships"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.addRelationshipToIndividual
    }
  }, [_vm._v("Add Relationship")])], 1) : _vm._e(), _vm._v(" "), (this.selectedContacts.length > 0) ? _c('div', {
    key: "groups",
    staticClass: "white pa-3 rounded mt-4"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v("Download to Excel")]), _vm._v(" "), _c('VueJsonToCsv', {
    attrs: {
      "jsonData": _vm.downloadableContacts,
      "labels": _vm.downloadableLabels(_vm.downloadableContacts)
    },
    on: {
      "success": _vm.downloadComplete
    }
  }, [_c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "depressed": "",
      "rounded": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey lighten-1",
      "left": ""
    }
  }, [_vm._v("mdi-cloud-download")]), _vm._v("\n                    Download\n                ")], 1)], 1)], 1) : _vm._e()])])], 2)
},staticRenderFns: []}

/***/ }),
/* 2579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "30/70"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', [_c('v-list-item-title', [_vm._v("Do Something")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no-print",
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_c('AdvancedList', {
    attrs: {
      "items": _vm.templates,
      "data-ref": _vm.listRef
    },
    on: {
      "click": _vm.selectTemplate
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [(_vm.checklistKey) ? [_c('AdvancedPanel', {
    staticClass: "no-print",
    attrs: {
      "fields": _vm.templateDetailsPanel.fields,
      "record": _vm.templateDetails,
      "recordRef": _vm.listItemRef,
      "settings": _vm.templateDetailsPanel.settings
    },
    on: {
      "button": _vm.templateDetailsButton,
      "field-change": _vm.templateDetailsFieldChanged
    }
  }), _vm._v(" "), _c('ChecklistDetails', {
    ref: "templateDetails",
    attrs: {
      "checklistKey": _vm.checklistKey,
      "mode": "Template"
    }
  })] : [_c('NoRecordsPlaceholder', {
    attrs: {
      "message": "Select a Template"
    }
  })]], 2), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('AdvancedDialog', {
    attrs: {
      "record": _vm.addDocumentDialog.record,
      "settings": _vm.addDocumentDialog.settings,
      "fields": _vm.addDocumentDialog.fields
    },
    on: {
      "save": _vm.saveDocumentForCategory
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('v-menu', {
    attrs: {
      "slot": "header",
      "right": "",
      "offset-y": ""
    },
    slot: "header",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("keyboard_arrow_down")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.debugRecord
    }
  }, [_c('v-list-item-title', [_vm._v("Debug Record")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('ElementControl', {
    attrs: {
      "element": _vm.page
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(true) ? _c('DeleteButton', {
    on: {
      "delete": _vm.deleteButtonClicked
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "label": _vm.schema.label,
      "hide-details": "",
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "suffix": _vm.abbreviation,
      "prefix": "$",
      "append-icon": "keyboard_arrow_down"
    },
    on: {
      "blur": _vm.emitAmountChange,
      "click:append": _vm.toggleFrequency
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-indicator clickable",
    class: {
      visible: _vm.visible
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/mail-log')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('div', {
    staticClass: "email-indicator-text"
  }, [_vm._v("\n        " + _vm._s(_vm.currentStatus) + "\n        "), _c('div', {
    staticClass: "truncate email-indicator-subtext"
  }, [_vm._v(_vm._s(_vm.emailToValue))])]), _vm._v(" "), _c('div', [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": "",
      "color": "white"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("close_circle_outline")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.documents), function(document) {
    return _c('div', {
      key: document.title,
      staticClass: "pa-3 item-pulse border-transparent transition clickable hoverable document-item",
      staticStyle: {
        "border-radius": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.documentClicked(document)
        }
      }
    }, [(!document.received) ? [(!document.received) ? _c('v-btn', {
      staticClass: "big-tick",
      staticStyle: {
        "margin-top": "-15px",
        "margin-right": "-15px"
      },
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.markAsReceived(document)
        }
      }
    }, [_vm._v("check_circle")])], 1) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(document.name))]), _vm._v(" "), _c('span', {
      staticClass: "elevation-1 ",
      staticStyle: {
        "background-color": "darkorange",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                " + _vm._s(document.title) + "\n            ")]), _c('br'), _vm._v("\n\n            " + _vm._s(document.description) + "\n            "), (document.download) ? [_c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": document.download,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return false($event)
        }
      }
    }, [_c('button', {
      staticStyle: {
        "margin-top": "5px",
        "margin-bottom": "0px",
        "color": "#444",
        "background-color": "white",
        "border-radius": "3px",
        "border": "solid 1px #c0c0c0",
        "padding": "5px 18px 5px 18px",
        "user-select": "none"
      }
    }, [_vm._v("Download")])])] : _vm._e()] : [_c('b', [_vm._v(_vm._s(document.name))]), _vm._v(" "), _c('span', {
      staticClass: "elevation-1 ",
      staticStyle: {
        "background-color": "green",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                Received\n            ")])]], 2)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.table) ? _c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    }
  }, [_c('tr', _vm._l((_vm.table.fields), function(field) {
    return _c('td', {
      key: 'hdr-' + field.name,
      staticClass: "no-wrap",
      class: _vm.cellClass(field),
      staticStyle: {
        "color": "#777",
        "font-weight": "bolder",
        "padding": "8px",
        "max-width": "150px",
        "border-bottom": "solid 1px #ddd"
      }
    }, [_vm._v("\n            " + _vm._s(field.title) + "\n        ")])
  }), 0), _vm._v(" "), _vm._l((_vm.table.records), function(record) {
    return _c('tr', {
      key: record['.key'],
      staticClass: "hoverable"
    }, _vm._l((_vm.table.fields), function(field) {
      return _c('td', {
        key: field.name,
        staticClass: "no-wrap",
        class: _vm.cellClass(field),
        staticStyle: {
          "color": "#444",
          "padding": "7px 12px",
          "max-width": "150px",
          "border-bottom": "solid 1px #ddd"
        }
      }, [_vm._v("\n            " + _vm._s(record[field.name]) + "\n        ")])
    }), 0)
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": ""
    },
    on: {
      "keydown": _vm.checkForNumber,
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialogVisible) ? _c('v-dialog', {
    attrs: {
      "min-width": "150",
      "max-width": "450",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container rounded pa-3"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Copy Contact to Offices")]), _vm._v(" "), _c('ChipSelector', {
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    },
    attrs: {
      "items": _vm.offices
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('v-btn', {
      attrs: {
        "text": ""
      },
      on: {
        "click": _vm.showDialog
      }
    }, [_vm._v("Image")])], _vm._v(" "), _c('v-dialog', {
      attrs: {
        "max-width": "235",
        "min-width": "100",
        "transition": "v-fade-transition",
        "hide-overlay": false,
        "scrollable": ""
      },
      model: {
        value: (_vm.dialogVisible),
        callback: function($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible"
      }
    }, [_c('div', {
      staticClass: "dialog-container"
    }, [_c('div', {
      staticClass: "dialog-body",
      staticStyle: {
        "padding": "25px 35px 0px 35px"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.title) + "\n                ")]), _vm._v(" "), _c('croppa', {
      attrs: {
        "width": 150,
        "height": 150,
        "quality": 1,
        "placeholder": "Choose...",
        "placeholder-font-size": 16,
        "disabled": false,
        "prevent-white-space": true,
        "show-remove-button": true,
        "remove-button-size": 20
      },
      on: {
        "zoom": _vm.imageChanged,
        "move": _vm.imageChanged,
        "file-choose": _vm.imageChanged,
        "image-remove": _vm.imageChanged
      },
      model: {
        value: (_vm.imageObject),
        callback: function($$v) {
          _vm.imageObject = $$v
        },
        expression: "imageObject"
      }
    }, [_c('img', {
      attrs: {
        "slot": "initial",
        "crossOrigin": "Anonymous",
        "src": _vm.displayImage
      },
      slot: "initial"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "dialog-footer"
    }, [(_vm.uploading) ? _c('v-progress-circular', {
      staticStyle: {
        "margin-right": "30px"
      },
      attrs: {
        "indeterminate": "",
        "color": "primary"
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.uploading) ? _c('v-btn', {
      attrs: {
        "disabled": !_vm.dirty,
        "text": ""
      },
      on: {
        "click": _vm.upload
      }
    }, [_vm._v("Keep")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": ""
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible = false
        }
      }
    }, [_vm._v("Cancel")])], 1)])])
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": Boolean(_vm.validationErrors)
    },
    on: {
      "save": _vm.save,
      "show": _vm.dialogShown
    }
  }, [_c('div', {
    staticClass: "pa-3 full-width",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-basis": "200px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "180px",
      "color": "#ddd"
    }
  }, [_vm._v("mdi-face-agent")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('DateTime', {
    staticClass: "mb-4",
    attrs: {
      "date-only": "",
      "past": ""
    },
    model: {
      value: (_vm.charge.date),
      callback: function($$v) {
        _vm.$set(_vm.charge, "date", $$v)
      },
      expression: "charge.date"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "return-object": false,
      "items": _vm.chargeDescriptions,
      "label": "Description",
      "hide-details": ""
    },
    on: {
      "change": _vm.updatePrice
    },
    model: {
      value: (_vm.charge.description),
      callback: function($$v) {
        _vm.$set(_vm.charge, "description", $$v)
      },
      expression: "charge.description"
    }
  }), _vm._v(" "), _c('CurrencyBox', {
    staticClass: "mt-2",
    attrs: {
      "label": "Amount"
    },
    model: {
      value: (_vm.charge.amount),
      callback: function($$v) {
        _vm.$set(_vm.charge, "amount", $$v)
      },
      expression: "charge.amount"
    }
  }), _vm._v(" "), _c('UserChooser', {
    staticClass: "mb-3",
    attrs: {
      "label": "Broker"
    },
    model: {
      value: (_vm.charge.to),
      callback: function($$v) {
        _vm.$set(_vm.charge, "to", $$v)
      },
      expression: "charge.to"
    }
  }), _vm._v(" "), _c('UserChooser', {
    staticClass: "mb-3",
    attrs: {
      "label": "Processor"
    },
    model: {
      value: (_vm.charge.from),
      callback: function($$v) {
        _vm.$set(_vm.charge, "from", $$v)
      },
      expression: "charge.from"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Clients"
    },
    model: {
      value: (_vm.charge.clients),
      callback: function($$v) {
        _vm.$set(_vm.charge, "clients", $$v)
      },
      expression: "charge.clients"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-text light-text"
  }, [_vm._v("Broker Name: " + _vm._s(_vm.charge.brokerName))])], 1)]), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [(_vm.validationErrors) ? _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          attrs: {
            "color": "red"
          }
        }, on), [_vm._v("errors")])]
      }
    }], null, false, 3195893709)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.validationErrors))])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex",
    staticStyle: {
      "width": "100%",
      "padding": "0px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  }, [(_vm.question) ? _c('div', {
    class: {
      'no-label-question': !_vm.label
    },
    staticStyle: {
      "padding-right": "8px",
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v("\n        " + _vm._s(_vm.question) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.question) ? _c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "yesno-container",
    class: {
      yes: _vm.value == 'Yes', 'no-value': !_vm.value
    },
    on: {
      "click": _vm.buttonClicked,
      "dblclick": function($event) {
        return _vm.setValue(null)
      }
    }
  }, [_c('div', {
    staticClass: "yesno-slot",
    class: _vm.slotClass
  }), _vm._v(" "), _c('div', {
    staticClass: "yesno-button",
    class: _vm.buttonClass
  }, [(!_vm.value) ? _c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "hoverable",
    staticStyle: {
      "padding": "9px",
      "text-align": "center",
      "flex-grow": "1",
      "border-right": "solid 1px #ddd",
      "border-top-left-radius": "14px",
      "border-bottom-left-radius": "14px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setValue('No')
      }
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('div', {
    staticClass: "hoverable",
    staticStyle: {
      "padding": "9px",
      "text-align": "center",
      "flex-grow": "1",
      "border-top-right-radius": "14px",
      "border-bottom-right-radius": "14px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setValue('Yes')
      }
    }
  }, [_vm._v("YES")])]) : _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.value) + "\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 2590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-combobox', {
    staticClass: "compact",
    attrs: {
      "items": _vm.itemsFormatted,
      "multiple": "",
      "chips": "",
      "return-object": "",
      "hide-details": "",
      "label": _vm.label
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.selectedItemsFormatted)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": _vm.getImage(data.item)
          }
        })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        }), _vm._v(" "), _c('v-list-item-subtitle', {
          domProps: {
            "innerHTML": _vm._s(data.item.email)
          }
        })], 1)]
      }
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-chip', _vm._g({
                staticClass: "chip--select-multi",
                attrs: {
                  "input-value": data.selected,
                  "close": ""
                },
                on: {
                  "click:close": function($event) {
                    return _vm.remove(data.item)
                  }
                }
              }, on), [_c('v-avatar', {
                staticStyle: {
                  "height": "40px",
                  "width": "40px",
                  "margin-right": "10px"
                }
              }, [_c('img', {
                attrs: {
                  "src": _vm.getImage(data.item)
                }
              })]), _vm._v("\n                " + _vm._s(data.item.text) + "\n            ")], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getHintText(data.item)))])])]
      }
    }]),
    model: {
      value: (_vm.selectedItemsFormatted),
      callback: function($$v) {
        _vm.selectedItemsFormatted = $$v
      },
      expression: "selectedItemsFormatted"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-line",
    style: (_vm.controlStyle)
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "4px",
      "background-color": "#bbb"
    },
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "position": "relative",
      "top": "-4px"
    }
  }, _vm._l((_vm.availableStages), function(stage, index) {
    return _c('div', {
      key: index,
      staticClass: " status-stage",
      class: {
        completed: _vm.tagExists(stage)
      },
      style: (_vm.statusStageStyle)
    }, [(_vm.tagExists(stage)) ? _c('div', {
      staticClass: "stage-circle blue",
      style: (_vm.stageCircleStyle)
    }, [_c('v-icon', {
      attrs: {
        "color": "white"
      }
    }, [_vm._v("check")])], 1) : _c('div', {
      staticClass: "stage-circle",
      style: (_vm.stageCircleStyle)
    }, [_c('span', {
      staticStyle: {
        "padding-left": "7px"
      }
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "stage-label"
    }, [_vm._v(_vm._s(stage.name))]), _vm._v(" "), _c('div', {
      staticClass: "stage-sublabel"
    }, [_vm._v(_vm._s(_vm._f("date")(_vm.tagDate(stage))))]), _vm._v(" "), _c('div', {
      staticClass: "stage-namelabel"
    }, [_vm._v(_vm._s(_vm.tagUser(stage)))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 2592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('GChart', {
    ref: "chart",
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "type": "PieChart",
      "data": _vm.chartData,
      "options": _vm.chartOptions,
      "events": _vm.chartEvents
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.groupedItems), function(group, groupName) {
    return _c('v-expansion-panel-content', {
      key: groupName
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v(_vm._s(groupName))]), _vm._v(" "), _vm._l((group.data), function(item) {
      return _c('v-card', {
        key: item.key
      }, [_c('v-card-text', [_vm._v(_vm._s(item.clients))])], 1)
    })], 2)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {}
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('GenericList', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "click": _vm.listItemClicked
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    class: _vm.fieldOuterClass,
    style: (_vm.fieldOuterStyle)
  }, [(_vm.field.clickToEdit && !_vm.editing) ? _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "display": "flex"
    },
    style: (_vm.fieldStyle)
  }, [_c('div', {
    staticClass: "grey--text text--darken-2",
    attrs: {
      "hide-details": _vm.hideDetails
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlValue)
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "small": "",
      "text": "",
      "icon": "",
      "color": "grey"
    },
    on: {
      "click": _vm.startEditing
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _c('div', {
    class: _vm.fieldClass,
    style: (_vm.fieldStyle),
    on: {
      "click": _vm.fieldClicked
    }
  }, [(_vm.field.type == 'Text') ? [(_vm.field.rows) ? _c('v-textarea', {
    attrs: {
      "rows": _vm.field.rows,
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine,
      "autofocus": _vm.field.focus,
      "clearable": _vm.field.clearable
    },
    on: {
      "change": _vm.changed,
      "blur": _vm.blurred
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine,
      "autofocus": _vm.field.focus,
      "clearable": _vm.field.clearable
    },
    on: {
      "change": _vm.changed,
      "blur": _vm.blurred
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'List') ? [_c('v-select', {
    attrs: {
      "items": _vm.options,
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine,
      "multiple": _vm.field.multiple,
      "chips": _vm.field.multiple,
      "return-object": _vm.field.returnObject
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Checkbox') ? [_c('v-checkbox', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Date') ? [_c('DateTime', {
    attrs: {
      "date-only": "",
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Options') ? [_c('v-radio-group', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('v-radio', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 1)] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Switch') ? [_c('v-switch', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Html') ? [_c('div', {
    staticClass: "grey--text text--darken-2",
    attrs: {
      "hide-details": _vm.hideDetails
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlValue)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Button') ? [_c('v-btn', {
    staticStyle: {
      "margin-top": "12px",
      "margin-bottom": "0px",
      "width": "100%"
    },
    attrs: {
      "color": _vm.field.color
    },
    on: {
      "click": function($event) {
        return _vm.$emit('button', _vm.field)
      }
    }
  }, [_vm._v(_vm._s(_vm.field.title))])] : _vm._e(), _vm._v(" "), (_vm.field.type == 'File') ? [_c('FileField', {
    attrs: {
      "record": _vm.record,
      "field": _vm.field
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Embed') ? [_c('div', {
    ref: "embedded"
  }), _vm._v(" "), (!_vm.field.disabled) ? _c('div', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Link to information"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Group' && _vm.isGroupVisible(_vm.field, _vm.record)) ? [_c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v(_vm._s(_vm.field.title))]), _vm._v(" "), (!_vm.record[_vm.field.name] || _vm.record[_vm.field.name].length < 1) ? _c('div', [_vm._v("\n            No records exist. "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createAndPush($event)
      }
    }
  }, [_vm._v("Create")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.record[_vm.field.name]), function(subRecord, subRecordIndex) {
    return _c('div', {
      key: subRecordIndex,
      staticStyle: {
        "border-left": "solid 5px #ddd",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-wrap": "wrap",
        "width": "100%"
      }
    }, _vm._l((_vm.field.fields), function(subField, index) {
      return _c('InterfaceField', {
        key: index,
        attrs: {
          "field": subField,
          "settings": _vm.settings,
          "record": subRecord
        }
      })
    }), 1), _vm._v(" "), (!_vm.field.disabled) ? _c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-33px"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({}, on), [_vm._v("keyboard_arrow_down")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": _vm.createAndPush
      }
    }, [_c('v-list-item-title', [_vm._v("Add Another")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          _vm.record[_vm.field.name].splice(subRecordIndex, 1)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Item")])], 1)], 1)], 1)], 1) : _vm._e()])
  })] : _vm._e(), _vm._v(" "), (!_vm.field || !_vm.field.type) ? [_c('div', [_vm._v("MISSING FIELD DEFINITION")])] : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', [(!_vm.editors.length) ? _c('div', [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(('First time: ' + _vm.label || 'Permissions')))]), _vm._v("\n\n        No write permissions\n        "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": _vm.initialisePermissions
    }
  }, [_vm._v("Create")])], 1) : _vm._e(), _vm._v(" "), (_vm.canWrite) ? [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.label || 'Permissions'))]), _vm._v(" "), _vm._l((_vm.editors), function(uid) {
    return _c('div', {
      key: uid
    }, [_vm._v("\n            " + _vm._s(uid) + "\n        ")])
  })] : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500",
      "transition": "v-fade-transition",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "20px",
      "text-align": "right"
    }
  }, [_c('transition', {
    attrs: {
      "name": "x-slow-fade"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.primaryImage),
      expression: "primaryImage"
    }],
    staticClass: "round",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "src": _vm.primaryImage
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "x-slow-fade"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.secondaryImage),
      expression: "secondaryImage"
    }],
    staticClass: "round",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "src": _vm.secondaryImage
    }
  })])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body pa-3"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "fullNames",
    attrs: {
      "rules": _vm.namesRules,
      "label": "First and Last Names",
      "hint": _vm.fullNamesHint
    },
    on: {
      "blur": _vm.cleanNames
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.calculateNames($event)
      }
    },
    model: {
      value: (_vm.fullNames),
      callback: function($$v) {
        _vm.fullNames = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "fullNames"
    }
  }), _vm._v(" "), _c('UniqueContactEnforcer', {
    ref: "enforcer1",
    attrs: {
      "contact": _vm.primaryContactName
    }
  }), _vm._v(" "), _c('UniqueContactEnforcer', {
    ref: "enforcer2",
    attrs: {
      "contact": _vm.secondaryContactName
    }
  }), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "-4px"
    },
    attrs: {
      "wrap": ""
    }
  }, [(_vm.couple) ? _c('v-col', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.primaryMobileLabel,
      "prepend-icon": "phone"
    },
    model: {
      value: (_vm.primaryMobile),
      callback: function($$v) {
        _vm.primaryMobile = $$v
      },
      expression: "primaryMobile"
    }
  })], 1) : _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": _vm.primaryMobileLabel,
      "prepend-icon": "phone"
    },
    model: {
      value: (_vm.primaryMobile),
      callback: function($$v) {
        _vm.primaryMobile = $$v
      },
      expression: "primaryMobile"
    }
  })], 1), _vm._v(" "), (_vm.couple) ? _c('v-col', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.secondaryMobileLabel,
      "prepend-icon": "phone"
    },
    model: {
      value: (_vm.secondaryMobile),
      callback: function($$v) {
        _vm.secondaryMobile = $$v
      },
      expression: "secondaryMobile"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('EmailBox', {
    ref: "primaryEmail",
    attrs: {
      "icon": "mail_outline",
      "label": _vm.primaryEmailLabel
    },
    model: {
      value: (_vm.primaryEmail),
      callback: function($$v) {
        _vm.primaryEmail = $$v
      },
      expression: "primaryEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.secondaryFirstName) ? _c('v-col', [_c('EmailBox', {
    ref: "secondaryEmail",
    attrs: {
      "icon": "mail_outline",
      "label": _vm.secondaryEmailLabel
    },
    model: {
      value: (_vm.secondaryEmail),
      callback: function($$v) {
        _vm.secondaryEmail = $$v
      },
      expression: "secondaryEmail"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRules,
      "label": "Transaction Name"
    },
    model: {
      value: (_vm.transactionName),
      callback: function($$v) {
        _vm.transactionName = $$v
      },
      expression: "transactionName"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.transactionTemplates,
      "label": "Template",
      "item-value": "meta.key",
      "item-text": "description"
    },
    model: {
      value: (_vm.masterKey),
      callback: function($$v) {
        _vm.masterKey = $$v
      },
      expression: "masterKey"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "items": _vm.officesList,
      "label": "Office",
      "item-value": "meta.key",
      "item-text": "name"
    },
    model: {
      value: (_vm.tenantKey),
      callback: function($$v) {
        _vm.tenantKey = $$v
      },
      expression: "tenantKey"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "float": "left",
            "margin-right": "8px"
          },
          attrs: {
            "outlined": "",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.clickedSave('Checklist')
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-format-list-checks")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Save and go to checklist")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "float": "left"
          },
          attrs: {
            "outlined": "",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.clickedSave('Transaction')
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-television-guide")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Save and go to transaction")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedCancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedSave($event)
      }
    }
  }, [_vm._v("Save")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 2597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-carousel', {
    attrs: {
      "cycle": "",
      "interval": _vm.seconds * 1000,
      "hide-delimiters": "",
      "show-arrows": false,
      "height": "1000"
    }
  }, _vm._l((_vm.charts), function(chart, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "src": ''
      }
    }, [_c('div', {
      staticStyle: {
        "height": "100%",
        "overflow": "auto"
      }
    }, [_c(chart.type, {
      tag: "component",
      attrs: {
        "chart": chart,
        "tenantKey": _vm.tenantKey
      }
    })], 1)])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "pa-2"
  }, [_vm._v("\n    Speed: "), _vm._l((12), function(n) {
    return _c('a', {
      key: n,
      staticClass: "mr-3",
      on: {
        "click": function($event) {
          return _vm.setSpeed(n * 5)
        }
      }
    }, [_vm._v(_vm._s(n * 5) + " seconds")])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "min-width": "600",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-details": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.dialog.settings, "visible", $$v)
      },
      expression: "dialog.settings.visible"
    }
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding": "5px",
      "flex-grow": "1",
      "display": "flex"
    },
    style: (_vm.bodyStyle)
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "scroll",
      "height": "100%"
    }
  }, [_c('v-expansion-panel', {
    model: {
      value: (_vm.expansionPanelNumber),
      callback: function($$v) {
        _vm.expansionPanelNumber = $$v
      },
      expression: "expansionPanelNumber"
    }
  }, [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Properties (" + _vm._s(_vm.dialog.field.name) + ")")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.dialog.field.name),
      callback: function($$v) {
        _vm.$set(_vm.dialog.field, "name", $$v)
      },
      expression: "dialog.field.name"
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.dialog.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.dialog.field.width),
      callback: function($$v) {
        _vm.$set(_vm.dialog.field, "width", $$v)
      },
      expression: "dialog.field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Layout")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "flex-grow": "0"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.dialog.settings.cancelLabel || 'Cancel'))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.dialog.settings.saveLabel || 'Save'))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border": "dashed 3px #ccc",
      "color": "#bbb",
      "padding": "10px",
      "border-radius": "8px"
    }
  }, [_vm._v("\n        New Component\n    ")])])
}]}

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-btn",
    on: {
      "click": function($event) {
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
        return _vm.buttonClicked($event)
      }
    }
  }, [_c('div', {
    attrs: {
      "title": (_vm.element.width == 10 ? _vm.text : '')
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "24px"
    },
    attrs: {
      "color": (_vm.element.complete || _vm.complete ? 'primary' : 'grey')
    }
  }, [_vm._v(_vm._s(_vm.icon || 'category'))])], 1), _vm._v(" "), (_vm.element.width != 10) ? _c('div', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.text || _vm.element.title) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "control-ro"
  }, [_c('div', {
    staticClass: "label-ro"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "value-ro"
  }, [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 2602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": "30/70"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.showEmail
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email Client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.goToTransaction
          }
        }, on), [_c('v-icon', [_vm._v("ballot")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Go to Transaction")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.goToTransaction
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {}
    }
  }, [_c('LinkNewTab', {
    attrs: {
      "link": '/client-checklist/' + _vm.checklistKey
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Client View")])], 1)], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToTemplates
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Templates")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToOldChecklist
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Old Checklist")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.goToOldChecklist
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Old Checklist")])], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-list-item', {
    on: {
      "click": _vm.downloadAllFiles
    }
  }, [_c('v-list-item-title', [_vm._v("Download All Files (Zip)")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no-print",
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_c('ChecklistMenu', {
    attrs: {
      "menu": _vm.menu
    },
    on: {
      "click": _vm.checklistMenuClicked,
      "add": _vm.addDocumentForCategory
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [_c('v-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    staticClass: "taco-column",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [(!_vm.checklistSummary.documents) ? _c('NoRecordsPlaceholder', [_vm._v("\n                    No items."), _c('br'), _vm._v("\n                    Choose one or more templates -->"), _c('br'), _vm._v("\n                    <-- Select items from the menu\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('ChecklistDetails', {
    ref: "checklistDetails",
    attrs: {
      "transactionKey": _vm.transactionKey,
      "checklistKey": _vm.checklistKey,
      "mode": _vm.checklistDetailsMode,
      "pageSettings": _vm.pageSettings
    },
    on: {
      "add-category-document": _vm.addDocumentForCategory
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "background-color": "yellow"
    }
  }, [_c('ChecklistDetails', {
    ref: "checklistHidden",
    attrs: {
      "transactionKey": _vm.transactionKey,
      "checklistKey": _vm.checklistKey,
      "mode": "Email",
      "pageSettings": _vm.pageSettings
    }
  })], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    staticClass: "no-print",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.selectedItems.length) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "color": "grey lighten-1"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.copyToClipboard($event)
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("assignment_turned_in")])], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Copy to Clipboard")])]), _vm._v(" "), _c('v-tooltip', {
    staticClass: "no-print",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.selectedItems.length) ? _c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "color": "grey lighten-1"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.showEmail($event)
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          }
        }, [_vm._v("email")])], 1) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email to Client")])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "pa-3 no-print",
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "8px"
    },
    attrs: {
      "xxxxv-if": "transactionKey",
      "xs12": "",
      "sm12": "",
      "md5": "",
      "lg4": "",
      "row": ""
    }
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._v("Templates")]), _vm._v(" "), _c('AdvancedPanel', {
    attrs: {
      "fields": _vm.checklistDetailsPanel.fields,
      "record": _vm.checklistDetails,
      "recordRef": _vm.listRef
    },
    on: {
      "field-change": _vm.checklistDetailsFieldChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Next Followup")]), _vm._v("\n            " + _vm._s(_vm._f("dueString")(_vm.followUpTask.due)) + "\n            "), _c('Scheduler', {
    on: {
      "change": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.due),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "due", $$v)
      },
      expression: "followUpTask.due"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('UserChooser', {
    attrs: {
      "label": "Assigned To"
    },
    on: {
      "select": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.assigned),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "assigned", $$v)
      },
      expression: "followUpTask.assigned"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-heading mt-4 mb-2"
  }, [_vm._v("Checklist Comments")]), _vm._v(" "), _c('TransactionComments')], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    }
  }), _vm._v(" "), _c('AdvancedDialog', {
    attrs: {
      "record": _vm.addDocumentDialog.record,
      "settings": _vm.addDocumentDialog.settings,
      "fields": _vm.addDocumentDialog.fields
    },
    on: {
      "save": _vm.saveDocumentForCategory
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    staticClass: "compact",
    attrs: {
      "outlined": "",
      "value": _vm.value[_vm.schema.name],
      "mandatory": false,
      "label": _vm.schema.label,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  }, _vm._l((_vm.schema.items), function(item, index) {
    return _c('v-radio', {
      key: index,
      attrs: {
        "label": item.text || item.value,
        "value": item.value || item.text
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 2604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": _vm.save
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-text-field', {
    ref: "focus",
    attrs: {
      "label": this.settings.title
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [_vm._v(_vm._s(_vm.schema.label) + "\n            "), _c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")])], 1)]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed) ? _c('div', {
    staticClass: "pt-3 pl-3"
  }, [_c('ControlList', {
    attrs: {
      "horizontal": _vm.schema.horizontal,
      "schema": _vm.schemaFields,
      "value": _vm.value
    },
    on: {
      "change": _vm.emitChanges
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-page"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_vm._t("header", [_c('div', {
    staticClass: "sample-content"
  }, [_vm._l((50), function(n) {
    return [_vm._v("Header ")]
  })], 2)])], 2), _vm._v(" "), _c('div', [_c('v-navigation-drawer', {
    attrs: {
      "mobile-break-point": 800
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-list-item', [_c('v-list-item-title', {
    staticClass: "title"
  }, [_vm._v("\n                Application\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-list-item', {
      key: item.title,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    style: (_vm.contentStyle)
  }, _vm._l((_vm.columnList), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "layout-column",
      style: ({
        'flex-basis': column.width
      }),
      attrs: {
        "id": 'col' + (index + 1)
      }
    }, [_c('div', {
      staticClass: "layout-column-padder"
    }, [_vm._t('col' + (index + 1), [_c('div', {
      staticClass: "sample-content"
    }, [_vm._l((400), function(n) {
      return [_vm._v("Column " + _vm._s(index) + " ")]
    })], 2)])], 2)])
  }), 0)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._t("footer", [(_vm.isMichelle) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "10px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "color": "grey lighten-2",
      "large": ""
    }
  }, [_vm._v("sentiment_satisfied_alt")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "15px"
    }
  })])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dialogs"
    }
  }, [_vm._t("dialogs")], 2)])
},staticRenderFns: []}

/***/ }),
/* 2607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500",
      "min-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    staticStyle: {
      "width": "100%"
    },
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title || 'Select a Contact'))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleAdding($event)
      }
    }
  }, [(_vm.adding) ? _c('v-icon', [_vm._v("list")]) : _c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [(_vm.adding) ? _c('div', {
    staticClass: "pa-4"
  }, [_c('ContactDetails', {
    ref: "contactDetails",
    attrs: {
      "contact": _vm.contact
    }
  })], 1) : [_c('ContactSearch', {
    attrs: {
      "role": _vm.data.role,
      "visible": _vm.dialogVisible
    },
    on: {
      "click": _vm.select,
      "add": _vm.toggleAdding
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.adding) ? [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveAndSelect($event)
      }
    }
  }, [_vm._v("Save and Select")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedCancel($event)
      }
    }
  }, [_vm._v("Cancel")])] : [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedCancel($event)
      }
    }
  }, [_vm._v("Cancel")])]], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 2608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title-button"
  }, [_vm._v("\n    " + _vm._s(_vm.step.title) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 2610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', [_c('div', {
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_vm._v("\n        This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1. This is my custom column 1.  \n    ")])])
},staticRenderFns: []}

/***/ }),
/* 2611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities"
  }, [_c('ScrollDownDiv', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.activities), function(activity, activityIndex) {
    return [_c('SpeechBubble', {
      key: activityIndex,
      staticClass: "mb-3",
      attrs: {
        "activity": activity
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-basis": "40px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCommentText),
      expression: "newCommentText"
    }],
    staticClass: "add-comment-box",
    attrs: {
      "type": "text",
      "placeholder": "Add a comment..."
    },
    domProps: {
      "value": (_vm.newCommentText)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.saveComment($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCommentText = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 2612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings
    },
    on: {
      "show": _vm.initialiseDialog
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Main")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.element.title),
      callback: function($$v) {
        _vm.$set(_vm.element, "title", $$v)
      },
      expression: "element.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.element.name),
      callback: function($$v) {
        _vm.$set(_vm.element, "name", $$v)
      },
      expression: "element.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Display")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": [1, 2],
      "label": "Columns"
    },
    model: {
      value: (_vm.element.columns),
      callback: function($$v) {
        _vm.$set(_vm.element, "columns", $$v)
      },
      expression: "element.columns"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, _vm._l((_vm.element.columns), function(column, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-right": "5px",
        "flex-grow": "1"
      }
    }, [_c('div', {
      staticClass: "section-heading vertical-margin"
    }, [_vm._v("Column " + _vm._s(index + 1))]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Title"
      },
      model: {
        value: (column.title),
        callback: function($$v) {
          _vm.$set(column, "title", $$v)
        },
        expression: "column.title"
      }
    })], 1)
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expand-transition', [(_vm.transactions.length > 1) ? _c('div', _vm._l((_vm.transactions), function(transaction) {
    return _c('div', {
      key: transaction['.key'],
      staticClass: "simultaneous-transaction",
      class: {
        'active': transaction.active, 'hoverable': !transaction.active, 'clickable': !transaction.active
      },
      on: {
        "click": function($event) {
          return _vm.goToAnother(transaction['.key'])
        }
      }
    }, [_vm._v("\n        " + _vm._s(transaction.description) + " "), _c('span', {
      staticClass: "subtle"
    }, [_vm._v(_vm._s(_vm._f("shortDate")(transaction.created)))]), _vm._v(" "), _c('a', {
      staticClass: "transparent",
      attrs: {
        "href": _vm.getLink(transaction['.key']),
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(!transaction.active) ? _c('v-btn', {
      staticStyle: {
        "float": "right",
        "margin-right": "-7px",
        "margin-top": "-3px"
      },
      attrs: {
        "color": "grey darken-1",
        "icon": "",
        "text": "",
        "small": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1)])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xxray flow-step",
    class: {
      'selected': _vm.step._selected, 'active': _vm.isActive(_vm.step), 'complete': _vm.step.complete, 'expanded': _vm.step.expanded, 'no-margin': (_vm.level == 500)
    },
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": 'step' + _vm.step._id
    },
    on: {
      "blur": function($event) {
        return _vm.stepBlur(_vm.step)
      }
    }
  }, [_c('div', {
    staticClass: "header-outer",
    style: (_vm.flowStepStyle)
  }, [_c('div', {
    staticClass: "flow-step-header",
    class: {
      expanded: _vm.step.expanded, selected: _vm.step._selected, 'flow-step-line': _vm.hasLines(_vm.step), condensed: _vm.step.type == 'checkbox'
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.stepFocus(_vm.step)
      }
    }
  }, [_c('div', {
    staticClass: "flow-step-indicator",
    class: {
      active: _vm.isActive(_vm.step), selected: _vm.step._selected
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flow-step-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stepIconClicked(_vm.step)
      },
      "xxxxxmousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flow-step-icon-shadow"
  }, [_c('v-progress-circular', {
    staticClass: "blue-background",
    attrs: {
      "indeterminate": _vm.step._loading,
      "rotate": 270,
      "size": 36,
      "width": 2,
      "value": _vm.step.percent,
      "color": "blue lighten-2"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin": "2px"
    },
    attrs: {
      "large": "",
      "color": _vm.getIconColour(_vm.step)
    }
  }, [_vm._v(_vm._s(_vm.getIconName(_vm.step)))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flow-step-content",
    on: {
      "click": function($event) {
        return _vm.clicked($event, _vm.step)
      }
    }
  }, [_c('div', {
    staticClass: "flow-step-input"
  }, [(_vm.isActive(_vm.step) && _vm.$page.designing) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.step.title),
      expression: "step.title"
    }],
    ref: "newStep",
    staticClass: "new-item-text",
    attrs: {
      "type": "text",
      "placeholder": "New Item..."
    },
    domProps: {
      "value": (_vm.step.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.step, "title", $event.target.value)
      }
    }
  }) : [_c('StepSelector', {
    attrs: {
      "step": _vm.step
    },
    on: {
      "track-changes": _vm.trackChanges
    }
  })]], 2), _vm._v(" "), (_vm.showScheduler()) ? _c('div', {
    staticClass: "flow-step-schedule"
  }, [_c('DueIndicator', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "task": _vm.step
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flow-step-handle"
  }, [(_vm.step.children) ? _c('div', {
    staticClass: "round pa-1 hoverable clickable",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.iconClicked(_vm.step, $event)
      }
    }
  }, [_c('div', {
    staticClass: "drag-handle"
  }, [_c('v-icon', {
    staticClass: "expander-icon",
    class: {
      expanded: _vm.step.expanded
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("arrow_drop_down")])], 1)]) : _c('div', {
    staticClass: "round pa-1 hoverable clickable",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.iconClicked(_vm.step, $event)
      }
    }
  }, [_c('div', {
    staticClass: "drag-handle"
  }, [_c('v-icon', {
    staticClass: "expander-icon",
    class: {
      expanded: _vm.step.expanded
    },
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("more_vert")])], 1)])])])]), _vm._v(" "), (_vm.step.expanded) ? _c('div', {
    staticClass: "flow-step-expander",
    class: {
      expanded: _vm.step.expanded, 'elevation-3': (_vm.level == 500), 'ma-1': false
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "expanded-content"
  }, [_vm._l((_vm.step.children), function(child) {
    return [_c('Flow', {
      key: 'child' + child,
      attrs: {
        "id": child,
        "level": _vm.level + 1
      }
    })]
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({}, on), [(_vm.task.due) ? _c('div', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple"
          }],
          staticClass: "due-chip",
          style: ({
            'background-color': _vm.dueColour,
            opacity: _vm.dueOpacity
          })
        }, [(_vm.task.assigned) ? _c('ContactImage', {
          attrs: {
            "contact": _vm.task.assigned,
            "size": 28,
            "emptyTooltip": "Not Assigned"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "due-content"
        }, [_vm._v("\n                    " + _vm._s(_vm.fromNow(_vm.task.due)) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.task.due) ? _c('div', {
          staticClass: "hoverable round pa-1",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("event")])], 1) : _vm._e()])]
      }
    }]),
    model: {
      value: (_vm.calendarVisible),
      callback: function($$v) {
        _vm.calendarVisible = $$v
      },
      expression: "calendarVisible"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "white-background columns-on-wide popup-content"
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "flat": ""
    },
    on: {
      "input": function($event) {
        _vm.calendarVisible = false
      }
    },
    model: {
      value: (_vm.backwardsDate),
      callback: function($$v) {
        _vm.backwardsDate = $$v
      },
      expression: "backwardsDate"
    }
  }), _vm._v(" "), (_vm.task.due) ? _c('div', {
    staticStyle: {
      "padding": "10px 10px 10px 10px",
      "border": "solid 1px #ddd",
      "width": "290px",
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      key: contact._id,
      staticClass: "inline-block",
      staticStyle: {
        "margin": "3px"
      },
      on: {
        "click": function($event) {
          _vm.task.assigned = contact;
          _vm.calendarVisible = false
        }
      }
    }, [_c('ContactImage', {
      attrs: {
        "size": 48,
        "contact": contact
      }
    })], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "width": "105px",
      "margin-top": "5px"
    },
    attrs: {
      "color": "red",
      "text": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.clearSchedule()
      }
    }
  }, [_vm._v("Clear")])], 2) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hoverable clickable pa-2 rounded",
    staticStyle: {
      "display": "flex",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.openDocument
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin": "2px 20px 0px 6px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.documentStyling.path,
      "width": "50",
      "height": "50",
      "alt": "Document",
      "title": "Document"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.document.name)), _c('br'), _vm._v(" "), (_vm.documentStyling.status) ? _c('span', {
    staticClass: "subtle",
    style: ({
      color: _vm.documentStyling.textColour
    })
  }, [_vm._v(_vm._s(_vm.documentStyling.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.document.date) ? _c('span', {
    style: ({
      color: _vm.freshness.textColour
    })
  }, [_vm._v(_vm._s(_vm.freshness.text))]) : _vm._e(), _vm._v(" "), (_vm.document.messageToClient) ? _c('div', {
    staticStyle: {
      "background-color": "rgba(255, 230, 0, 0.6)",
      "padding-left": "5px",
      "padding-right": "5px",
      "border-radius": "7px"
    }
  }, [_vm._v(_vm._s(_vm.document.messageToClient))]) : _vm._e(), _vm._v(" "), (!_vm.document.received) ? [_c('ul', {
    staticStyle: {
      "color": "grey"
    }
  }, _vm._l((_vm.document.checks), function(check, index) {
    return _c('li', {
      key: index,
      style: (_vm.checkStyle(check))
    }, [_vm._v(_vm._s(check.check))])
  }), 0), _vm._v(" "), _vm._l((_vm.document.links), function(link, index2) {
    return _c('a', {
      key: index2,
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": link.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "hoverable clickable rounded-corners",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "opacity": "0.4",
        "margin": "2px 6px 0px 6px",
        "vertical-align": "middle"
      },
      attrs: {
        "src": "https://taco.insightprocessing.com.au/static/images/cloud-download.png",
        "width": "30",
        "height": "30",
        "title": "Download",
        "alt": "Download"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#666",
        "padding": "7px 4px"
      }
    }, [_vm._v(_vm._s(link.display))])])])
  })] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 2617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "color": "primary",
      "input-value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "hide-details": true,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "max-height": "250px",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.fileElements), function(file) {
    return _c('a', {
      key: file.key,
      staticClass: "transparent",
      attrs: {
        "target": "_blank",
        "href": file.value
      }
    }, [_c('div', {
      key: file.key,
      staticClass: "workflow-file hover-darken clickable",
      on: {
        "click": function($event) {
          return _vm.fileClicked(file)
        }
      }
    }, [(!file.loading) ? _c('v-icon', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      },
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("attachment")]) : _vm._e(), _vm._v(" "), (file.loading) ? _c('v-progress-circular', {
      staticClass: "grey--text",
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      },
      attrs: {
        "size": 20,
        "width": 2,
        "indeterminate": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "nudge-width": 200
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticStyle: {
              "margin-right": "11px"
            },
            attrs: {
              "color": "grey"
            }
          }, on), [_vm._v("keyboard_arrow_down")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('menu', 'delete', file)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('menu', 'email', file)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Email")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(_vm._s(file.title))])], 1)])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-list"
  }, [_c('div', {
    staticClass: "items-section"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "item-container",
      style: (_vm.itemContainerStyle)
    }, [_c('div', {
      staticClass: "item-row clickable",
      class: {
        selected: item._selected, hover: item == _vm.hoveredItem, expanded: item == _vm.expandedItem
      }
    }, [_c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      staticClass: "item-title",
      on: {
        "click": function($event) {
          return _vm.itemClicked(item)
        }
      }
    }, [_c('div', {
      staticClass: "item-check-column",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleSelection(item)
        }
      }
    }, [(item._selected) ? _c('v-icon', [_vm._v("check_box")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('div', {
      staticClass: "item-text-column",
      on: {
        "mouseenter": function($event) {
          return _vm.itemHovered(item)
        },
        "mouseleave": function($event) {
          return _vm.itemNotHovered(item)
        }
      }
    }, [_vm._t("title", [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")], {
      "item": item
    })], 2), _vm._v(" "), (!_vm.hideExpander) ? _c('div', {
      staticClass: "item-button-column"
    }, [_c('v-btn', {
      attrs: {
        "color": "grey darken-1",
        "icon": "",
        "text": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.buttonClicked(item)
        },
        "mousedown": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-content"
    }, [(item == _vm.expandedItem) ? _c('div', [_vm._t("content", [_c('div', {
      staticStyle: {
        "padding": "10px",
        "font-size": "14px",
        "color": "#ccc"
      }
    }, [_vm._v("\n                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero nam animi fugiat consequatur neque ea natus. Velit commodi porro modi excepturi consequatur ex, debitis, perferendis error earum deserunt inventore odit!\n                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero nam animi fugiat consequatur neque ea natus. Velit commodi porro modi excepturi consequatur ex, debitis, perferendis error earum deserunt inventore odit!\n                            ")])], {
      "item": item
    })], 2) : _vm._e()])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 2620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-expand-transition', [(_vm.isCompact) ? _c('div', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.makeCompact(false)
      }
    }
  }, [_vm._v("Add Outstandings")])], 1) : _vm._e()]), _vm._v(" "), _c('v-expand-transition', [(!_vm.isCompact) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "quick-input",
    attrs: {
      "rows": "7",
      "placeholder": "Paste items and separate with new line. Click save..."
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.demoData($event)
      }
    }
  }, [_vm._v("Sample")]), _vm._v(" | \n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('val')
      }
    }
  }, [_vm._v("Val")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('cos')
      }
    }
  }, [_vm._v("COS")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('pay')
      }
    }
  }, [_vm._v("Payslips")]), _vm._v(" |\n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickText('lmi')
      }
    }
  }, [_vm._v("LMI")]), _vm._v(" \n            "), (_vm.items.length) ? _c('v-btn', {
    on: {
      "click": _vm.saveItems
    }
  }, [_vm._v("Save " + _vm._s(_vm.items.length) + " Items")]) : _vm._e(), _vm._v(" "), (!_vm.items.length) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.makeCompact(true)
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.schema.label))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.editorValue),
      callback: function($$v) {
        _vm.editorValue = $$v
      },
      expression: "editorValue"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Draggable', {
    staticClass: "panel",
    class: {
      selected: _vm.isSelected
    },
    style: (_vm.panelStyle),
    attrs: {
      "options": {
        animation: 350,
        group: _vm.parentName,
        xxxhandle: '.menu-icon'
      }
    },
    on: {
      "end": _vm.afterDrag
    },
    nativeOn: {
      "click": function($event) {
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.selectPanel(_vm.panel)
      }
    },
    model: {
      value: (_vm.tree.panels),
      callback: function($$v) {
        _vm.$set(_vm.tree, "panels", $$v)
      },
      expression: "tree.panels"
    }
  }, [(_vm.isSelected) ? _c('div', {
    staticClass: "overlay-heading higher"
  }, [_vm._v("\n        " + _vm._s(_vm.panel.name) + "\n        "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "dark": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.navigateUp($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "1px"
    },
    attrs: {
      "dark": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showDialog($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("more_horiz")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.panel.placeholderText) ? _c('div', {
    domProps: {
      "textContent": _vm._s(this.placeholderText)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.tree.panels), function(panel) {
    return _c('LayoutPanel', {
      key: panel.name,
      attrs: {
        "tree": _vm.getChildTree(panel),
        "parent": _vm.tree
      }
    })
  }), _vm._v(" "), _c('PanelDialog', {
    attrs: {
      "dialog": _vm.panelDialog
    },
    on: {
      "save": _vm.saveField
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "responsive",
      rawName: "v-responsive",
      value: (_vm.contactRowSizes),
      expression: "contactRowSizes"
    }],
    staticClass: "contact-row"
  }, [_c('img', {
    staticClass: "contact-image round white-border shadow mr-2",
    attrs: {
      "src": _vm.contact.image,
      "alt": _vm.contact.firstName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-details"
  }, [_c('div', [_vm._v(_vm._s(_vm.contact.firstName) + " " + _vm._s(_vm.contact.lastName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.contact.mobile))])])])
},staticRenderFns: []}

/***/ }),
/* 2624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deep-orange--text text--darken-1 element-scheduler clickable",
    on: {
      "click": function($event) {
        return _vm.scheduleDays(_vm.element.scheduleDays)
      }
    }
  }, [_vm._v("\n    Schedule for " + _vm._s(_vm.element.scheduleDays) + " days?\n        "), _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": "",
      "max-height": "300"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "margin": "-3px"
          },
          attrs: {
            "text": "",
            "icon": "",
            "color": "deep-orange"
          }
        }, on), [_c('v-icon', [_vm._v("arrow_drop_down_circle")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.scheduleDays(_vm.element.scheduleDays)
      }
    }
  }, [_vm._v("\n                Schedule " + _vm._s(_vm.element.scheduleDays) + " Days\n            ")]), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.scheduleDays(-1)
      }
    }
  }, [_vm._v("\n                Schedule Custom Date\n            ")]), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.scheduleDays(-2)
      }
    }
  }, [_vm._v("\n                No thanks\n            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.menuItems), function(menuItem, index) {
    return [(menuItem.days != _vm.element.scheduleDays) ? _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.scheduleDays(menuItem.days)
        }
      }
    }, [_vm._v("\n                " + _vm._s(menuItem.description) + "\n            ")]) : _vm._e()]
  })], 2)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 2625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('YesNo', {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.schema.label,
      "question": _vm.schema.question,
      "color": "blue",
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-print",
    staticStyle: {
      "background-color": "#ddd",
      "height": "100%",
      "display": "flex",
      "flex-direction": "column",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Templates")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "elevation-3",
    staticStyle: {
      "margin": "20px auto",
      "width": "210mm"
    }
  }, [_c('div', {
    staticClass: "show-print",
    staticStyle: {
      "width": "210mm",
      "background-color": "white",
      "padding": "20mm 30mm"
    }
  }, [_vm._v("\n    Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi dolorum provident dolore ab pariatur rem, molestiae vero libero facilis numquam? Accusantium quia dignissimos fugiat cumque natus delectus vel temporibus voluptas.\n    Consectetur debitis similique ipsam voluptatem libero doloribus soluta, ullam consequatur pariatur cum sequi illo omnis molestias necessitatibus. Debitis id neque perspiciatis consectetur provident praesentium quibusdam fugit eveniet excepturi. Ullam, vel.\n    Ipsa et, incidunt praesentium expedita nesciunt, iusto quia pariatur fugit similique vel quis tempore, aspernatur excepturi a vitae suscipit rem! Laborum nihil atque ullam eligendi sunt aspernatur, nemo sint delectus?\n    At odio ea voluptatibus esse architecto consequatur maxime tempora, assumenda hic incidunt? Incidunt voluptate reiciendis laboriosam? Est, vitae architecto ad enim quia, ea necessitatibus placeat ex tempore iste labore nulla.\n    Ut pariatur velit tenetur laborum, porro dicta maiores exercitationem eligendi distinctio, optio quam modi aliquid facilis eum ratione sint temporibus culpa veritatis corrupti, esse sunt. Repellendus et facilis at? Numquam!\n    Dolores accusantium autem et ipsum aut adipisci obcaecati aperiam, optio delectus cum saepe velit eaque at harum numquam facere architecto assumenda voluptates incidunt odit corrupti minima? Quos quia rerum illum.\n    Neque in recusandae deserunt dolore corrupti. Reprehenderit molestiae ducimus iure? Quidem doloribus voluptates pariatur sapiente ipsa nulla molestias perferendis vero enim odit? Temporibus dolore eaque, illum quis explicabo quasi sed.\n    Esse minima blanditiis fuga? Nam rerum magnam excepturi praesentium esse dignissimos? Tempora minima aliquid et doloremque repellat totam. Nesciunt, aliquam excepturi ad esse dolorem vero sunt perferendis debitis ullam voluptate!\n    Laboriosam numquam expedita dignissimos pariatur fugiat doloremque quod voluptas, officiis repellat odio magni quibusdam adipisci, est totam cupiditate. Officia quos laborum expedita voluptatum consequuntur facere consectetur dolorum vero reprehenderit architecto.\n    Assumenda, ipsam harum. Quae velit veritatis, quisquam reiciendis vitae commodi dolorem est hic culpa qui cum incidunt necessitatibus dolor quam iusto explicabo? Suscipit qui, veritatis quam molestias obcaecati beatae veniam! Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis mollitia explicabo maxime minus, corrupti dolorem repellendus odit facilis incidunt, omnis in nostrum cumque eius quod sequi. Vitae modi iusto ex.\n    Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi dolorum provident dolore ab pariatur rem, molestiae vero libero facilis numquam? Accusantium quia dignissimos fugiat cumque natus delectus vel temporibus voluptas.\n    Consectetur debitis similique ipsam voluptatem libero doloribus soluta, ullam consequatur pariatur cum sequi illo omnis molestias necessitatibus. Debitis id neque perspiciatis consectetur provident praesentium quibusdam fugit eveniet excepturi. Ullam, vel.\n    Ipsa et, incidunt praesentium expedita nesciunt, iusto quia pariatur fugit similique vel quis tempore, aspernatur excepturi a vitae suscipit rem! Laborum nihil atque ullam eligendi sunt aspernatur, nemo sint delectus?\n    At odio ea voluptatibus esse architecto consequatur maxime tempora, assumenda hic incidunt? Incidunt voluptate reiciendis laboriosam? Est, vitae architecto ad enim quia, ea necessitatibus placeat ex tempore iste labore nulla.\n    Ut pariatur velit tenetur laborum, porro dicta maiores exercitationem eligendi distinctio, optio quam modi aliquid facilis eum ratione sint temporibus culpa veritatis corrupti, esse sunt. Repellendus et facilis at? Numquam!\n    Dolores accusantium autem et ipsum aut adipisci obcaecati aperiam, optio delectus cum saepe velit eaque at harum numquam facere architecto assumenda voluptates incidunt odit corrupti minima? Quos quia rerum illum.\n    Neque in recusandae deserunt dolore corrupti. Reprehenderit molestiae ducimus iure? Quidem doloribus voluptates pariatur sapiente ipsa nulla molestias perferendis vero enim odit? Temporibus dolore eaque, illum quis explicabo quasi sed.\n    Esse minima blanditiis fuga? Nam rerum magnam excepturi praesentium esse dignissimos? Tempora minima aliquid et doloremque repellat totam. Nesciunt, aliquam excepturi ad esse dolorem vero sunt perferendis debitis ullam voluptate!\n    Laboriosam numquam expedita dignissimos pariatur fugiat doloremque quod voluptas, officiis repellat odio magni quibusdam adipisci, est totam cupiditate. Officia quos laborum expedita voluptatum consequuntur facere consectetur dolorum vero reprehenderit architecto.\n    Assumenda, ipsam harum. Quae velit veritatis, quisquam reiciendis vitae commodi dolorem est hic culpa qui cum incidunt necessitatibus dolor quam iusto explicabo? Suscipit qui, veritatis quam molestias obcaecati beatae veniam! Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis mollitia explicabo maxime minus, corrupti dolorem repellendus odit facilis incidunt, omnis in nostrum cumque eius quod sequi. Vitae modi iusto ex.\n    ")])])
}]}

/***/ }),
/* 2627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "invoice",
    attrs: {
      "id": 'invoice' + _vm.invoice.meta.key
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("INVOICE "), _c('span', {
    staticStyle: {
      "color": "#bbb"
    }
  }, [_vm._v(_vm._s(_vm.getInvoiceId(_vm.invoice)))])]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.invoice.to.firstName) + " " + _vm._s(_vm.invoice.to.lastName) + " (invoice date " + _vm._s(_vm.invoiceDate) + ")"), _c('br'), _vm._v("\n                " + _vm._s(_vm.invoice.to.entity) + "\n            ")])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.invoice.from.entity || _vm.invoice.from.firstName + ' ' + _vm.invoice.from.lastName)), _c('br'), _vm._v("\n                " + _vm._s(_vm.invoice.from.address) + " "), _c('b', [_vm._v("Ph")]), _vm._v(" " + _vm._s(_vm.invoice.from.mobile) + "\n            ")])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v(_vm._s(_vm.invoice.from.abn))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v(_vm._s(_vm.invoice.from.account))])])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, _vm._l((_vm.invoice.charges), function(charge) {
    return _c('tr', {
      key: charge.meta.key
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm._f("date")(charge.date)) + "\n            ")]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('td', _vm._g({
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.formatStamp(charge.stamp)
            }
          }, on), [_vm._v("\n                    " + _vm._s(charge.clients) + "\n                    ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteCharge(charge)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Charge")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.debugCharge(charge)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Debug Charge")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(charge.description) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(charge.brokerName) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                " + _vm._s(charge.amount) + "\n            ")])])
  }), 0), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding": "3px",
      "width": "99%"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.invoice.total)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding": "3px"
    }
  }, [_vm._v("+GST: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("cents")((_vm.invoice.total * 0.1))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding": "3px"
    }
  }, [_vm._v("Amount Payable:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm._f("cents")((_vm.invoice.total * 1.1))))])])])]), _vm._v(" "), _c('small', [_vm._v("* Direct debit is on the " + _vm._s(_vm.nth) + " of each month. Manual payments due by the 15th. Invoice email: " + _vm._s(_vm.invoice.to.email) + " DDR: " + _vm._s(_vm.invoice.to.directDebitRef || '[none]'))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "valign": "top",
      "align": "right"
    }
  }, [_c('b', [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "valign": "top",
      "align": "right"
    }
  }, [_c('b', [_vm._v("From:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("ABN:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Account:")])])
}]}

/***/ }),
/* 2628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "right-visible": false
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('DateRangeList', {
    attrs: {
      "default": "Last month"
    },
    on: {
      "change": _vm.loadData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "disabled": !_vm.admin,
      "color": "primary",
      "label": "Just my invoices"
    },
    model: {
      value: (_vm.currentUserOnly),
      callback: function($$v) {
        _vm.currentUserOnly = $$v
      },
      expression: "currentUserOnly"
    }
  }), _vm._v(" "), (_vm.admin) ? _c('v-select', {
    attrs: {
      "items": ['Client Invoices', 'Processor Invoices', 'All Invoices'],
      "label": "Filter Invoices"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": _vm.areAllInvoicesSelected,
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.selectAllInvoices
          }
        }, on), [_c('v-icon', [_vm._v("mdi-select")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Select All Invoices")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": !_vm.areInvoicesSelected,
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.clearSelectedInvoices
          }
        }, on), [_c('v-icon', [_vm._v("mdi-select-off")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Clear Selections")])]), _vm._v(" "), _c('SplitButton', {
    staticClass: "full-width",
    attrs: {
      "text": _vm.pluralise('Send', this.selectedInvoiceKeys.length, 'Invoice', 'Invoices'),
      "disabled": !_vm.areInvoicesSelected,
      "menus": [{
        text: 'To Client'
      }, {
        text: 'To Processor'
      }, {
        text: 'To Both'
      }, {
        text: 'Send Reminder'
      }, {
        text: 'To Bookkeeper'
      }]
    },
    on: {
      "click": _vm.emailSelectedInvoices
    }
  }), _vm._v(" "), _c('SplitButton', {
    staticClass: "full-width",
    attrs: {
      "menu-only": "",
      "text": _vm.pluralise('Mark', this.selectedInvoiceKeys.length, 'Invoice', 'Invoices'),
      "disabled": !_vm.areInvoicesSelected,
      "menus": [{
        text: 'Sent'
      }, {
        text: 'Paid'
      }, {
        text: 'Outstanding'
      }]
    },
    on: {
      "click": _vm.markInvoices
    }
  }), _vm._v(" "), (_vm.admin) ? _c('v-btn', {
    staticClass: "full-width",
    attrs: {
      "disabled": !_vm.areInvoicesSelected
    },
    on: {
      "click": _vm.makeInsightBills
    }
  }, [_vm._v("Make Insight Bills")]) : _vm._e()], 1), _vm._v(" "), _c('SectionLayout', {
    attrs: {
      "section": _vm.leftPageSection
    }
  })], 1), _vm._v(" "), _vm._l((_vm.billingTableGrouped), function(invoice, invoiceKey) {
    return _c('div', {
      key: invoiceKey,
      ref: 'invoice-' + invoiceKey,
      refInFor: true,
      staticClass: "pa-3 elevation-1 ma-3 white-background invoice-hoverable",
      class: {
        'blue-hilight': _vm.isInvoiceSelected(invoiceKey)
      },
      staticStyle: {
        "overflow": "auto",
        "border": "solid 1px transparent",
        "max-width": "700px"
      },
      on: {
        "click": function($event) {
          return _vm.toggleInvoiceSelection(invoiceKey)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "30px"
      }
    }, [_vm._v("INVOICE "), _c('span', {
      staticStyle: {
        "color": "#bbb"
      }
    }, [_vm._v(_vm._s(_vm.getInvoiceId(invoice)))])]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("To:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice[0].payer.firstName) + " " + _vm._s(invoice[0].payer.lastName) + " (" + _vm._s(invoice[0].payer.email) + ")")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("From:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice[0].recipient.firstName) + " " + _vm._s(invoice[0].recipient.lastName))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("ABN:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getProcessorDetails(invoice[0].recipient.email, 'abn')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "padding": "3px"
      },
      attrs: {
        "align": "right"
      }
    }, [_c('b', [_vm._v("Account:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getProcessorDetails(invoice[0].recipient.email, 'account')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
      attrs: {
        "width": "100%"
      }
    }, _vm._l((invoice), function(charge) {
      return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(_vm._f("date")(charge.charge_date)) + "\n                    ")]), _vm._v(" "), _c('div', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('td', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(charge.client) + "\n                        ")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deleteCharge(charge)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete Charge")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(charge.comment) + "\n                    ")]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v("\n                        " + _vm._s(charge.amount) + " "), (charge.status) ? _c('strong', [_vm._v("*** " + _vm._s(charge.status) + " ***")]) : _vm._e()])])
    }), 0), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right",
        "padding": "3px",
        "width": "99%"
      }
    }, [_vm._v("Total:")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.invoiceTotal(invoice))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right",
        "padding": "3px"
      }
    }, [_vm._v("+GST: ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("cents")((_vm.invoiceTotal(invoice) * 0.1))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right",
        "padding": "3px"
      }
    }, [_vm._v("Amount Payable:")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm._f("cents")((_vm.invoiceTotal(invoice) * 1.1))))])])])]), _vm._v(" "), _c('small', [_vm._v("* Direct debit is on " + _vm._s(_vm._f("shortDate")(_vm.nextTwentieth)) + ". Manual payments due by the 15th.")])])
  }), _vm._v(" "), _c('template', {
    slot: "right"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.options,
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.items || !_vm.items.length) ? _c('span', [_vm._v("No items available")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "mr-1 mb-1",
      attrs: {
        "color": _vm.color(item),
        "text-color": _vm.textColor(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection(item)
        }
      }
    }, [_c('v-avatar', [(item._selected) ? _c('v-icon', {
      attrs: {
        "color": "blue darken-1"
      }
    }, [_vm._v("check_circle")]) : _c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("account_circle")])], 1), _vm._v("\n        " + _vm._s(_vm.bestName(item)))], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 2631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "width": "100%",
      "border-top": "solid 3px grey"
    }
  }, _vm._l((_vm.item), function(property, heading, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "object-viewer-cell object-viewer-heading"
    }, [_vm._v("\n            " + _vm._s(heading) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "object-viewer-cell"
    }, [_vm._v("\n            " + _vm._s(property) + "\n        ")])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "flat": "",
      "dark": "",
      "mb-2": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Monthly Living Expenses " + _vm._s(_vm._f("currency")(_vm.total)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.save
    }
  }, [_c('v-list-item-title', [_vm._v("Save for Later")])], 1), _vm._v(" "), (_vm.step == 2) ? _c('v-list-item', {
    on: {
      "click": _vm.showExample
    }
  }, [_c('v-list-item-title', [_vm._v("Show Example")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "print-only"
  }, [_c('h2', [_vm._v("Living Expense Worksheet for " + _vm._s(_vm.params.name))])]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1 pb-4",
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-stepper', {
    staticClass: "living-expenses",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_c('div', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#444"
    }
  }, [_vm._v("About your household")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#555"
    }
  }, [_vm._v(_vm._s(_vm.houseHoldSummary))])])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "pr-4"
  }, [_c('div', {
    staticClass: "mb-3 inset-text",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                        This should take just a couple of minutes. To comply with government regulation, we need some information about your living expenses. Do not include rent or debts. These are assessed separately.\n                    ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Your Name/s",
      "xhide-details": ""
    },
    on: {
      "change": _vm.nameChanged
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Your Email",
      "xhide-details": ""
    },
    model: {
      value: (_vm.params.email),
      callback: function($$v) {
        _vm.$set(_vm.params, "email", $$v)
      },
      expression: "params.email"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.mode == 'invitation',
      "label": "Consultants Email"
    },
    on: {
      "input": function($event) {
        _vm.linkCopied = false
      }
    },
    model: {
      value: (_vm.params.consultant),
      callback: function($$v) {
        _vm.$set(_vm.params, "consultant", $$v)
      },
      expression: "params.consultant"
    }
  }), _vm._v(" "), (_vm.clientLinkVisible) ? _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.getClientLink($event)
      }
    }
  }, [_vm._v("Get Client Link")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 pa-4 grey lighten-3",
    staticStyle: {
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "12px",
      "color": "#888",
      "margin-top": "-10px",
      "margin-bottom": "-10px"
    }
  }, [_vm._v("Your household")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.adultItems,
      "label": "Adults",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.adultsChanged
    },
    model: {
      value: (_vm.params.adults),
      callback: function($$v) {
        _vm.$set(_vm.params, "adults", $$v)
      },
      expression: "params.adults"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.childrenItems,
      "label": "Dependent Children",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.params.children),
      callback: function($$v) {
        _vm.$set(_vm.params, "children", $$v)
      },
      expression: "params.children"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": ['Low Income', 'Average Income', 'High Income'],
      "label": "Household Income",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.params.income),
      callback: function($$v) {
        _vm.$set(_vm.params, "income", $$v)
      },
      expression: "params.income"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": Boolean(_vm.stepOneValidation)
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("Continue to Next Step")]), _vm._v(" "), _c('div', {
    staticClass: "validation-error"
  }, [_vm._v(_vm._s(_vm.stepOneValidation))])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_c('div', {
    class: {
      clickable: !_vm.stepOneValidation
    },
    on: {
      "click": _vm.stepTwoClicked
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#444"
    }
  }, [_vm._v("Monthly Expenses")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#555"
    }
  }, [_vm._v(_vm._s(_vm.stepTwoSubtitle))])])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    staticClass: "pl-3"
  }, _vm._l((_vm.expenses), function(expense, index) {
    return _c('LivingExpense', {
      key: index,
      attrs: {
        "expense": expense
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": Boolean(_vm.stepTwoValidation),
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('div', {
    staticClass: "validation-error"
  }, [_vm._v(_vm._s(_vm.stepTwoValidation))])], 1)]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.submitted,
      "step": "3"
    }
  }, [_c('div', {
    class: {
      clickable: !_vm.stepTwoValidation
    },
    on: {
      "click": _vm.stepThreeClicked
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#444"
    }
  }, [_vm._v("Submit your information")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "color": "#555"
    }
  })])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [(_vm.submitted) ? _c('div', {
    staticClass: "pa-2 grey--text text--darken-2",
    attrs: {
      "max-width": "500px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "50px",
      "margin-right": "10px",
      "float": "left"
    },
    attrs: {
      "color": "green"
    }
  }, [_vm._v("check_circle_outline")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#999",
      "font-weight": "200"
    }
  }, [_vm._v("Thank you.")]), _vm._v("Your answers have been recorded. You may close this window. \n        ")], 1) : [(!_vm.totalWithinRange) ? _c('div', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [(_vm.totalRangeError) ? _c('div', {
    staticClass: "no-print grey--text text--darken-1"
  }, [_c('v-icon', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    },
    attrs: {
      "color": "red lighten-2"
    }
  }, [_vm._v("report_problem")]), _vm._v(" "), _c('span', [_vm._v("\n                        Your total living expenses of " + _vm._s(_vm.total) + " is " + _vm._s(_vm.totalHigherOrLower) + " than expected, Your lender will require an explanation why. Otherwise you can\n                        "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.step = 2
      }
    }
  }, [_vm._v("go back and review your answers")])])], 1) : _vm._e(), _vm._v(" "), _c('v-textarea', {
    staticClass: "no-print mt-2",
    attrs: {
      "outline": "",
      "label": "",
      "single-line": "",
      "rows": 2
    },
    model: {
      value: (_vm.params.explanation),
      callback: function($$v) {
        _vm.$set(_vm.params, "explanation", $$v)
      },
      expression: "params.explanation"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.submitted) ? _c('div', {
    staticClass: "pa-3 mb-3 elevation-2",
    staticStyle: {
      "border": "solid 1px #ccc",
      "border-radius": "8px",
      "max-width": "500px"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.totalRangeError
    },
    on: {
      "click": _vm.sendSubmission
    }
  }, [_vm._v("Send Now")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#777"
    }
  }, [_vm._v("Ready to Send")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40px",
      "font-weight": "600",
      "display": "inline-block"
    }
  }, [_vm._v("To: ")]), _vm._v(_vm._s(this.params.consultant)), _c('br'), _vm._v(" "), (this.params.email) ? [_c('div', {
    staticStyle: {
      "width": "40px",
      "font-weight": "600",
      "display": "inline-block"
    }
  }, [_vm._v("Cc: ")]), _vm._v(_vm._s(this.params.email) + "\n                ")] : _vm._e()], 2) : _vm._e()], _vm._v(" "), _c('table', {
    ref: "expenses",
    staticStyle: {
      "width": "100%",
      "max-width": "500px",
      "border-collapse": "collapse"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.params.name))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.houseHoldSummary))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    }
  }, [_c('b', [_vm._v("Living Expenses")]), _vm._v(" "), (_vm.params.explanation) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm.params.explanation) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.total)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    }
  }, [_c('b', [_vm._v("Breakdown")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-bottom": "solid 1px #bbb",
      "padding": "8px"
    },
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _vm._l((_vm.expenses), function(expense) {
    return [_c('tr', {
      key: expense.name
    }, [_c('td', {
      staticStyle: {
        "border-bottom": "solid 1px #bbb",
        "padding": "8px"
      }
    }, [_c('b', [_vm._v(_vm._s(expense.name))]), _vm._v(" "), (expense.explanation) ? _c('div', [_vm._v("\n                            " + _vm._s(expense.explanation) + "\n                        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border-bottom": "solid 1px #bbb",
        "padding": "8px"
      },
      attrs: {
        "align": "right",
        "valign": "top"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(expense.value)) + "\n                        "), (expense.na) ? _c('span', [_vm._v("Not Applicable")]) : _vm._e()])])]
  })], 2)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": _vm.formWidth
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-4"
  }, [_c('FormControl', {
    ref: "theForm",
    attrs: {
      "schema": _vm.schema
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": 670
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-4"
  }, [(_vm.visible) ? _c('youtube', {
    attrs: {
      "video-id": _vm.videoId,
      "player-vars": {
        autoplay: 1
      },
      "player-width": "100%"
    },
    on: {
      "ready": _vm.ready,
      "playing": _vm.playing
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [(_vm.visible) ? _c('div', {
    staticClass: "pa-3",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c('div', {
    staticClass: "full-width white-background mb-4 pa-2 rounded elevation-2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px",
      "margin-right": "-5px"
    },
    attrs: {
      "color": "red",
      "icon": "",
      "text": ""
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1), _vm._v(" "), _c('InterfaceField', {
    attrs: {
      "field": _vm.announcementField,
      "record": _vm.announcementRecord
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sectionClass,
    style: (_vm.sectionOuter)
  }, [_c('div', {
    style: (_vm.sectionHeading),
    on: {
      "click": _vm.editSection
    }
  }, [_vm._v("\n        " + _vm._s(_vm.section.title) + " (" + _vm._s(_vm.componentWidth) + ")\n        "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.settings.editing = !_vm.settings.editing
      }
    }
  }, [_vm._v("create")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-content",
    style: (_vm.sectionContentStyle)
  }, _vm._l((_vm.section.columns), function(column, colIndex) {
    return _c('div', {
      key: colIndex,
      staticClass: "column-outer",
      style: (_vm.columnOuterStyle(column))
    }, [_c('div', {
      staticClass: "column-inner",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      style: (_vm.sectionHeading),
      on: {
        "click": function($event) {
          return _vm.editColumn(colIndex)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(column.title) + "\n                    ")]), _vm._v(" "), _c('draggable', {
      staticClass: "column-detail draggable-container",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "options": {
          animation: 350,
          group: 'elements',
          xxxhandle: '.menu-icon'
        }
      },
      on: {
        "end": _vm.afterDrag
      },
      model: {
        value: (column.elements),
        callback: function($$v) {
          _vm.$set(column, "elements", $$v)
        },
        expression: "column.elements"
      }
    }, [_vm._l((column.elements), function(element, elIndex) {
      return [_c('ControlElement', {
        key: elIndex,
        attrs: {
          "element": element,
          "settings": _vm.pageSettings
        },
        on: {
          "click": _vm.elementClicked
        }
      })]
    })], 2)], 1)])
  }), 0), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "sidebar"
    }
  }, [_c('EditPanel', {
    staticClass: "pa-2",
    attrs: {
      "element": _vm.elementEditing
    },
    on: {
      "button-click": _vm.editPanelButtonClick
    }
  })], 1), _vm._v(" "), _c('ElementDialog', {
    attrs: {
      "settings": _vm.elementDialog.settings,
      "element": _vm.section
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.element) ? _c('div', {
    staticClass: "element-control",
    attrs: {
      "xxxxclass": {
        'full-height': !(_vm.parent)
      },
      "id": _vm.element.title
    }
  }, [(_vm.componentName && _vm.element.type != 'Group') ? _c(_vm.componentName, {
    tag: "component",
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    },
    on: {
      "change": _vm.valueChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Group') ? _c('SectionLayout', {
    attrs: {
      "section": _vm.element,
      "parent": _vm.parent
    }
  }, [_c('SortableList', {
    attrs: {
      "items": _vm.element.elements
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('ElementControl', {
          attrs: {
            "element": item,
            "parent": _vm.element
          }
        })]
      }
    }, {
      key: "menu",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$set(item, 'value', null)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Clear Value")])], 1), _vm._v(" "), (!item.na) ? _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$set(item, 'na', true)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Not Applicable")])], 1) : _vm._e(), _vm._v(" "), (item.na) ? _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$set(item, 'na', null)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Mark Applicable")])], 1) : _vm._e()]
      }
    }], null, false, 2663346918)
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Templates")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.programItems
    },
    model: {
      value: (_vm.program),
      callback: function($$v) {
        _vm.program = $$v
      },
      expression: "program"
    }
  }), _vm._v(" "), (this.program == 'cno') ? [_c('v-text-field', {
    attrs: {
      "label": "Create office number (eg. 001)"
    },
    model: {
      value: (_vm.newOfficeNumber),
      callback: function($$v) {
        _vm.newOfficeNumber = $$v
      },
      expression: "newOfficeNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Office Name"
    },
    model: {
      value: (_vm.newOfficeName),
      callback: function($$v) {
        _vm.newOfficeName = $$v
      },
      expression: "newOfficeName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Pin (4 digit)"
    },
    model: {
      value: (_vm.newOfficePin),
      callback: function($$v) {
        _vm.newOfficePin = $$v
      },
      expression: "newOfficePin"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.singleItem) ? _c('v-text-field', {
    attrs: {
      "label": "Source Item Key"
    },
    model: {
      value: (_vm.itemKey),
      callback: function($$v) {
        _vm.itemKey = $$v
      },
      expression: "itemKey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.singleItem) ? _c('v-text-field', {
    attrs: {
      "disabled": "",
      "value": _vm.transactionKey,
      "label": "Transaction Key"
    }
  }) : _vm._e(), _vm._v(" "), (this.program == 'tcu' || this.program == 'ttu') ? _c('UserChooser', {
    attrs: {
      "label": "User"
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tenants,
      "item-text": "name",
      "item-value": "meta.key",
      "label": "Source Tenant"
    },
    model: {
      value: (_vm.sourceTenant),
      callback: function($$v) {
        _vm.sourceTenant = $$v
      },
      expression: "sourceTenant"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "items": _vm.tenantList.filter(function (o) { return o.meta.key != _vm.sourceTenant; }),
      "multiple": "",
      "chips": "",
      "item-text": "name",
      "item-value": "meta.key",
      "label": "Destination Tenant"
    },
    model: {
      value: (_vm.destinationTenant),
      callback: function($$v) {
        _vm.destinationTenant = $$v
      },
      expression: "destinationTenant"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.destinationTenant = _vm.tenantList.filter(function (o) { return parseInt(o.meta.key) < 900 && o.meta.key != _vm.sourceTenant; })
      }
    }
  }, [_vm._v("All Mortgage Tenants")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-switch', {
    attrs: {
      "color": "primary",
      "label": "Remove from Source"
    },
    model: {
      value: (_vm.move),
      callback: function($$v) {
        _vm.move = $$v
      },
      expression: "move"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Simulate Writes"
    },
    model: {
      value: (_vm.simulateWrites),
      callback: function($$v) {
        _vm.simulateWrites = $$v
      },
      expression: "simulateWrites"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Simulate Deletes"
    },
    model: {
      value: (_vm.simulateDeletes),
      callback: function($$v) {
        _vm.simulateDeletes = $$v
      },
      expression: "simulateDeletes"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.run
    }
  }, [_vm._v("Go")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Results"
    },
    model: {
      value: (_vm.output),
      callback: function($$v) {
        _vm.output = $$v
      },
      expression: "output"
    }
  })], 2)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LayoutContainer', {
    attrs: {
      "columns": _vm.columnSplits
    }
  }, [_c('template', {
    slot: "header"
  }, [(_vm.isMaster) ? _c('div', {
    staticClass: "pa-2 red--text red lighten-4"
  }, [_vm._v("\n        Warning: you're in " + _vm._s(_vm.officeName) + " master. Changes affect all client files.\n        "), _c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "red"
    },
    attrs: {
      "href": "/templates",
      "target": "_blank"
    }
  }, [_vm._v("Open Doc Templates")])]) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    on: {
      "click": function($event) {
        return _vm.setSpecialTab('home')
      }
    }
  }, [_c('span', {
    staticClass: "heading-button",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.transaction.clients))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "active-indicator",
    class: {
      'active': _vm.isTransactionActive
    }
  }), _vm._v(" "), _c('ToolbarSearch', {
    on: {
      "search": _vm.searchWithinTransaction
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "size": 20,
      "width": 2,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200,
      "max-height": "400"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }], null, false, 1568013183)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', [_c('a', {
    staticClass: "transparent",
    attrs: {
      "href": ("/" + _vm.tenantKey + "/transaction/" + (_vm.transaction.masterKey)),
      "target": "_blank"
    }
  }, [_c('v-list-item-title', [_vm._v("Open the Master Template")])], 1)]), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push(("/" + _vm.tenantKey + "/document-checklist/" + _vm.transactionKey))
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Checklist")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.deleteAll
    }
  }, [_c('v-list-item-title', [_vm._v("Delete All Fields")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.deleteTransaction
    }
  }, [_c('v-list-item-title', [_vm._v("Delete Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.importTab(_vm.selectedTab)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Refresh Current Tab")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showTransactionHistory()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Activity History")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.testFunction
    }
  }, [_c('v-list-item-title', [_vm._v("Test Function")])], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Advanced")]), _vm._v(" "), (!_vm.isMaster) ? _c('v-list-item', {
    on: {
      "click": _vm.makeTemplate
    }
  }, [_c('v-list-item-title', [_vm._v("Make this a Template")])], 1) : _vm._e(), _vm._v(" "), (_vm.isMaster) ? _c('v-list-item', {
    on: {
      "click": _vm.removeTemplate
    }
  }, [_c('v-list-item-title', [_vm._v("Remove as template")])], 1) : _vm._e(), _vm._v(" "), (_vm.columnSplits != '50/50') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.columnSplits = '50/50'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Bigger Comments Column")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.debugMode = !_vm.debugMode
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Debug Mode")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3",
    attrs: {
      "value": _vm.debugMode
    }
  })], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
    on: {
      "click": _vm.viewMilestone
    }
  }, [_c('v-list-item-title', [_vm._v("View Milstone in Console")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('div', [_c('div', {
    staticClass: "tab no-select",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.key,
      on: {
        "click": function($event) {
          return _vm.selectTab(tab)
        }
      }
    }, [_c('div', {
      key: tab.key,
      staticClass: "tab clickable",
      class: {
        selected: tab == _vm.selectedTab
      }
    }, [_c('div', {
      staticClass: "clickable",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('v-icon', {
      staticClass: "tab-icon",
      class: {
        'complete': tab.complete
      },
      staticStyle: {
        "margin-top": "-5px",
        "margin-right": "5px"
      }
    }, [_vm._v("star")]), _vm._v(" "), _c('div', {
      staticClass: "no-select no-wrap"
    }, [_vm._v(_vm._s(tab.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-right": "-15px",
        "margin-top": "-2px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editTab(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit Tab")])], 1), _vm._v(" "), (_vm.clipboard.items.length == 0) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.moveTabToClipboard(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Cut")])], 1) : _vm._e(), _vm._v(" "), (_vm.clipboard.action == 'Tab') ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.pasteTabFromClipboard(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Paste")])], 1) : _vm._e(), _vm._v(" "), (!tab.complete) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.completeElement(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Complete")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.importTab(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Refresh Tab")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.reseedOrder
      }
    }, [_c('v-list-item-title', [_vm._v("Reseed Sort Order")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.tabMaintenance(tab)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Element Maintenance")])], 1) : _vm._e()], 1)], 1)], 1)], 1)])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('div', {
    staticClass: "tab no-select",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', [(!_vm.isLoading) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticClass: "tab no-select"
        }, on), [_c('v-icon', {
          staticStyle: {
            "margin-top": "-3px"
          },
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("settings")])], 1)]
      }
    }], null, false, 763598367)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.addTab
    }
  }, [_c('v-list-item-title', [_vm._v("Add Tab")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.refreshTabs
    }
  }, [_c('v-list-item-title', [_vm._v("Refresh Tabs")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.setSpecialTab('settings')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Transaction Settings")])], 1)], 1)], 1) : _vm._e()], 1)], 2)])], 1), _vm._v(" "), _c('div', {
    ref: "col1",
    attrs: {
      "slot": "col1"
    },
    slot: "col1"
  }, [_c('div', {
    staticClass: "flex-grid"
  }, _vm._l((_vm.tabElements), function(element) {
    return _c('div', {
      key: element.key,
      ref: element.name,
      refInFor: true,
      staticClass: "element clickable",
      class: {
        selected: _vm.isElementSelected(element), important: element.important, compact: element.compact
      },
      style: (_vm.getElementStyle(element)),
      on: {
        "dblclick": function($event) {
          return _vm.elementDoubleClicked(element)
        },
        "click": function($event) {
          if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) { return null; }
          return _vm.elementClicked(element)
        },
        "!click": [function($event) {
          if (!$event.metaKey) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMulti(element)
        }, function($event) {
          if (!$event.ctrlKey) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMulti(element)
        }]
      }
    }, [_c('table', {
      staticStyle: {
        "table-layout": "fixed",
        "width": "100%",
        "max-width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "99%",
        "padding": "0px",
        "border-radius": "6px"
      },
      style: ({
        'opacity': (element.na ? 0.3 : 'inherit'),
        'background-color': _vm.getElementBackground(element)
      })
    }, [_c('elementItem', {
      attrs: {
        "element": element
      },
      on: {
        "select": _vm.selectSingle,
        "change": _vm.storeElementValue,
        "button": _vm.buttonElementClicked,
        "action": _vm.actionElement,
        "save-lookup": _vm.saveLookup
      }
    })], 1), _vm._v(" "), (element.value && element.value.length > 10 && element.value.startsWith('http') && element.type != 'File') ? _c('td', {
      attrs: {
        "width": "50px"
      }
    }, [_c('a', {
      staticClass: "transparent",
      attrs: {
        "href": element.value,
        "target": "_blank"
      }
    }, [_c('v-btn', {
      staticClass: "elevation-0",
      attrs: {
        "small": "",
        "fab": "",
        "color": "blue lighten-4"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("public")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15px",
        "padding": "0px"
      },
      style: (_vm.menuContainerStyle(element)),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      staticStyle: {
        "margin-left": "-5px",
        "margin-right": "-8px"
      },
      attrs: {
        "left": "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [(!_vm.isElementSelected(element)) ? [(element.type == 'Text') ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addToComments(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add to Comments")])], 1) : _vm._e(), _vm._v(" "), (element.type == 'Text') ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.sendElementToNewWindow(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Send to New Window")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeTaskFromElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Make Task")])], 1), _vm._v(" "), (!element.important) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.makeImportant(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Important")])], 1) : _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.removeImportant(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Not Important")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.showElementHistory(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("History")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.toggleNotApplicable(element)
        }
      }
    }, [_c('v-list-item-title', [(!element.na) ? [_vm._v("Not ")] : _vm._e(), _vm._v("Applicable\n                                        ")], 2)], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addAfterElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("New Element")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.selectMulti(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Select")])], 1), _vm._v(" "), (_vm.clipboard.items.length) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.pasteFromClipboard(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Paste")])], 1) : _vm._e()] : [_c('v-list-item', {
      on: {
        "click": _vm.cloneSelectedElements
      }
    }, [_c('v-list-item-title', [_vm._v("Clone")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.moveToClipboard('Cut')
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Cut")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.moveToClipboard('Copy')
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Copy")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteElements(_vm.selectedElements)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.addFilter(_vm.selectedElements)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add Filter")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.elementMaintenance(_vm.selectedElements)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Element Maintenance")])], 1) : _vm._e()]], 2)], 1)], 1)])]), _vm._v(" "), (element.scheduleVisible) ? _c('ElementScheduler', {
      attrs: {
        "element": element
      },
      on: {
        "schedule": _vm.scheduleClicked
      }
    }) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#eee",
      "border-radius": "8px",
      "padding": "10px"
    },
    attrs: {
      "slot": "col2"
    },
    slot: "col2"
  }, [_c('TimeTracker', {
    staticClass: "mt-0 mb-1 mr-1",
    attrs: {
      "related-id": _vm.transactionKey,
      "title": _vm.transaction.clients,
      "payload": _vm.timeTrackerPayload
    }
  }), _vm._v(" "), _c('SimultaneousTransactions', {
    attrs: {
      "transactionKey": _vm.transactionKey
    }
  }), _vm._v(" "), (_vm.clipboard.items.length) ? _c('div', {
    staticClass: "clipboard"
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-right": "10px"
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "grey"
    }
  }, [_vm._v("assignment")])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "padding": "4px 8px 4px 8px",
      "float": "right",
      "border": "solid 1px #888"
    },
    on: {
      "click": _vm.clearClipboard
    }
  }, [_vm._v("Clear")]), _vm._v("\n        Clipboard (" + _vm._s(this.clipboard.action) + ")"), _c('br'), _vm._v("\n        " + _vm._s(this.clipboard.items.map(function (o) { return o.title; }).join(', ')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": function($event) {
        _vm.importantVisible = !_vm.importantVisible
      }
    }
  }, [(_vm.importantVisible) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")]) : _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v("\n        Important Stuff\n\n    ")], 1), _vm._v(" "), _c('v-expand-transition', [(_vm.importantVisible) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.importantElements), function(element) {
    return _c('v-menu', {
      key: element.key,
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            key: element.key,
            staticClass: "clickable hoverable",
            staticStyle: {
              "display": "flex",
              "color": "#555",
              "padding": "7px",
              "border-top": "dotted 1px #ccc",
              "width": "100%"
            }
          }, on), [(element.type != 'Widget') ? _c('div', {
            staticStyle: {
              "font-weight": "500",
              "width": "120px",
              "margin-right": "10px"
            }
          }, [_vm._v("\n                        " + _vm._s(element.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
            staticStyle: {
              "flex-grow": "1",
              "font-weight": "400",
              "margin-right": "3px",
              "overflow": "auto"
            }
          }, [(element.type != 'Rating') ? _c('div', {
            staticClass: "text-selectable",
            staticStyle: {
              "overflow-x": "auto"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.formatElement(element))
            }
          }) : _vm._e(), _vm._v(" "), (element.widget == 'Outstandings Diagram') ? _c('OutstandingsDiagram') : _vm._e(), _vm._v(" "), _c('div', {
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.ratingClicked(element)
              }
            }
          }, [(element.type == 'Rating') ? _c('v-rating', {
            staticStyle: {
              "margin-top": "-10px",
              "margin-left": "-10px",
              "margin-bottom": "-10px"
            },
            attrs: {
              "color": "yellow darken-2",
              "background-color": "grey lighten-2"
            },
            model: {
              value: (element.value),
              callback: function($$v) {
                _vm.$set(element, "value", $$v)
              },
              expression: "element.value"
            }
          }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
            staticStyle: {
              "flex-basis": "0"
            }
          }, [_c('v-icon', {
            staticStyle: {
              "font-size": "12px"
            },
            attrs: {
              "color": "grey lighten-1"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.removeImportant(element)
              }
            }
          }, [_vm._v("clear")])], 1)])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.jumpToElement(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Jump to Tab")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.copyToClipboard(element)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Copy to Clipboard")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 2) : _vm._e()]), _vm._v(" "), (!_vm.contactsVisible) ? _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": function($event) {
        _vm.contactsVisible = true
      }
    }
  }, [(_vm.contactsVisible) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")]) : _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v("\n        Show Contacts\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-expand-transition', [(_vm.contactsVisible) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "300",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "width": "100%"
          }
        }, on), [_vm._v("\n                    Add Contact\n                ")])]
      }
    }], null, false, 1263856287)
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.roles), function(role) {
    return _c('v-list-item', {
      key: role,
      on: {
        "click": function($event) {
          return _vm.addContact(role)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(role))])], 1)
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.addContact('Other')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Other")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "flex-basis": "35px",
      "flex-grow": "0",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.contactsVisible = false
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-top": "-2px",
      "margin-left": "-3px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1)]), _vm._v(" "), _c('TransactionContacts', {
    attrs: {
      "contactElements": _vm.contactElementsUnique
    },
    on: {
      "click": _vm.viewContact
    }
  }), _vm._v(" "), (_vm.clients.length == 2) ? _c('div', {
    staticClass: "pb-3 pl-2 "
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.emailBothClients($event)
      }
    }
  }, [_vm._v("\n                Email Both Clients\n            ")]), _vm._v(" \n            "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.clipboardBothClients($event)
      }
    }
  }, [_vm._v("\n                Both to Clipboard\n            ")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": _vm.showFileDialog
    }
  }, [(_vm.uploadingCount) ? [_c('v-progress-circular', {
    staticClass: "grey--text",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": 20,
      "width": 2,
      "indeterminate": ""
    }
  }), _vm._v("\n            Uploading " + _vm._s(_vm.uploadingCount) + " Files\n        ")] : [_vm._v("\n            " + _vm._s(this.fileElements && this.fileElements.length ? this.fileElements.length : 'No') + " Files\n        ")], _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("mdi-dots-horizontal")])], 2), _vm._v(" "), _c('TransactionTasks'), _vm._v(" "), _c('TransactionComments'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-button hoverable clickable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px",
      "background-color": "#ddd"
    },
    on: {
      "click": _vm.mailLogClick
    }
  }, [(_vm.emailsVisible) ? _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_up")]) : _c('v-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "-2px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v("\n        Emails\n    ")], 1), _vm._v(" "), _c('v-expand-transition', [(_vm.emailsVisible) ? _c('div', {
    staticClass: "light-text"
  }, [_c('TransactionMail', {
    attrs: {
      "items": _vm.mailLog,
      "showTo": true
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('template', {
    slot: "dialogs"
  }, [_c('ElementDialog', {
    attrs: {
      "settings": _vm.elementDialog.settings,
      "model": _vm.elementDialog.model
    },
    on: {
      "save": _vm.saveElement,
      "delete": _vm.deleteElement
    }
  }), _vm._v(" "), _c('LookupDialog', {
    attrs: {
      "settings": _vm.lookupDialog.settings,
      "element": _vm.lookupDialog.element
    },
    on: {
      "save": _vm.saveLookupFromDialog
    }
  }), _vm._v(" "), _c('FilterEditor', {
    attrs: {
      "settings": _vm.filterEditorDialog.settings,
      "elements": _vm.filterEditorDialog.elements,
      "model": _vm.filterEditorDialog.model
    },
    on: {
      "save": _vm.saveFilter,
      "delete": _vm.deleteFilter
    }
  }), _vm._v(" "), _c('ContactSelector', {
    attrs: {
      "visible": _vm.contactSelector.visible,
      "title": _vm.contactSelector.title,
      "data": _vm.contactSelector.data
    },
    on: {
      "select": _vm.linkContactFromElement,
      "cancel": function($event) {
        _vm.contactSelector.visible = false
      }
    }
  }), _vm._v(" "), _c('TransactionContact', {
    attrs: {
      "settings": _vm.transactionContactDialog.settings,
      "title": "",
      "transactionKey": _vm.transactionKey,
      "element": _vm.transactionContactDialog.element
    },
    on: {
      "close": function($event) {
        _vm.transactionContactDialog.settings.visible = false
      },
      "unlink": _vm.unlinkContact,
      "edit-element": _vm.editElement,
      "refresh": _vm.refreshContact
    }
  }), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    },
    on: {
      "sent": _vm.sentEmailMessage
    }
  }), _vm._v(" "), _c('SmsDialog', {
    attrs: {
      "settings": _vm.smsDialog.settings,
      "recipients": _vm.smsDialog.recipients,
      "message": _vm.smsDialog.message,
      "returnObject": _vm.smsDialog.returnObject
    },
    on: {
      "sent": _vm.sentSMSMessage
    }
  }), _vm._v(" "), _c('FileDialog', {
    attrs: {
      "files": _vm.fileElements,
      "settings": _vm.fileDialog.settings
    }
  }), _vm._v(" "), _c('TaskDialog', {
    attrs: {
      "task": _vm.taskDialog.model,
      "settings": _vm.taskDialog.settings
    },
    on: {
      "save": _vm.saveTask
    }
  }), _vm._v(" "), _c('GenericListDialog', {
    attrs: {
      "items": _vm.genericListDialog.items,
      "settings": _vm.genericListDialog.settings,
      "clickHandler": _vm.genericListDialog.clickHandler
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 2641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("Outstandings > " + _vm._s(_vm.sentCount) + " sent, " + _vm._s(_vm.readyCount) + "  ready, " + _vm._s(_vm.waitingCount) + "  waiting")]), _vm._v(" "), (_vm.totalCount) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "border-radius": "20px"
    }
  }, [_c('div', {
    staticClass: "colour-bar green",
    staticStyle: {
      "border-radius": "10px 0 0 10px"
    },
    style: ({
      'flex-grow': _vm.sentCount
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "colour-bar grey lighten-1",
    style: ({
      'flex-grow': _vm.readyCount
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "colour-bar red",
    staticStyle: {
      "border-radius": "0 10px 10px 0"
    },
    style: ({
      'flex-grow': _vm.waitingCount
    })
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Collection Name"
    },
    model: {
      value: (_vm.collection.name),
      callback: function($$v) {
        _vm.$set(_vm.collection, "name", $$v)
      },
      expression: "collection.name"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Log Changes",
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.collection.logChanges),
      callback: function($$v) {
        _vm.$set(_vm.collection, "logChanges", $$v)
      },
      expression: "collection.logChanges"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "element-label"
  }, [_vm._v(_vm._s(_vm.schema.label))]), _vm._v(" "), (_vm.value && _vm.value.length > 1) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "gap": "6px",
      "margin-bottom": "6px"
    }
  }, _vm._l((_vm.value), function(file, fileIndex) {
    return _c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: fileIndex,
      staticStyle: {
        "padding": "2px 10px",
        "background-color": "#eee",
        "border-radius": "8px",
        "cursor": "pointer",
        "user-select": "none",
        "border": "solid 1px #ccc"
      },
      on: {
        "click": function($event) {
          _vm.selectedFile = _vm.value[fileIndex]
        }
      }
    }, [_vm._v("\n            " + _vm._s(fileIndex + 1) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.selectedFile) ? _c('div', {
    staticStyle: {
      "padding": "5px",
      "border": "solid 1px #ccc",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "-35px"
    }
  }, [(_vm.selectedFile) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', [_c('a', _vm._g({
          staticClass: "transparent",
          attrs: {
            "href": _vm.selectedFile.url,
            "target": "_new"
          }
        }, on), [_c('v-btn', {
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("exit_to_app")])], 1)], 1)])]
      }
    }], null, false, 1716959338)
  }, [_vm._v(" "), _c('span', [_vm._v("Open in New Tab")])]) : _vm._e()], 1), _vm._v(" "), (_vm.hasImage) ? [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.selectedFile.url
    }
  })] : _c('div', [_c('object', {
    staticStyle: {
      "height": "500px",
      "width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "data": _vm.selectedFile.url,
      "type": _vm.selectedFile.type
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedFile.url
    }
  }, [_vm._v("Open " + _vm._s(_vm.schema.label))])])])], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "full-width",
          class: _vm.buttonClass,
          attrs: {
            "rounded": "",
            "depressed": ""
          },
          on: {
            "click": _vm.initialiseDropdown
          }
        }, on), [_vm._v(_vm._s(_vm.label))])]
      }
    }]),
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_vm._v(" "), _c('v-list', [(!_vm.existingOnly) ? _c('div', {
    staticClass: "display-flex ma-3"
  }, [_c('v-text-field', {
    ref: "group",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "label": "Name of Group",
      "hide-details": ""
    },
    model: {
      value: (_vm.groupName),
      callback: function($$v) {
        _vm.groupName = $$v
      },
      expression: "groupName"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "14px"
    },
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": _vm.newGroup
    }
  }, [_vm._v("Go")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group, groupIndex) {
    return _c('v-list-item', {
      key: groupIndex,
      on: {
        "click": function($event) {
          return _vm.select(group)
        }
      }
    }, [_c('v-chip', {
      staticStyle: {
        "margin": "0px 5px 0 -3px",
        "width": "44px",
        "text-align": "center"
      },
      attrs: {
        "dark": "",
        "small": "",
        "color": group.colour || '#ccc'
      }
    }, [_vm._v(_vm._s(group.members || '0'))]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(_vm._f("space")(group._id)))])], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.elementOuterClass,
    style: (_vm.elementOuterStyle)
  }, [_c('div', {
    class: _vm.elementClass,
    style: (_vm.elementStyle),
    on: {
      "click": _vm.elementClicked
    }
  }, [(_vm.element.type == 'Text') ? [_c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'List') ? [_c('v-select', {
    attrs: {
      "items": _vm.options,
      "label": _vm.element.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Checkbox') ? [_c('v-checkbox', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.element.type == 'Html') ? [_c('div', {
    staticClass: "grey--text text--darken-2",
    attrs: {
      "hide-details": _vm.hideDetails
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlValue)
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 2646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "persistent": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.showCopyToOffices
    }
  }, [_c('v-list-item-title', [_vm._v("Copy to Offices")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.clientToClipboard
    }
  }, [_c('v-list-item-title', [_vm._v("Copy to Clipboard")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('CommunicationBar', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "expanded": "",
      "contact": _vm.elementAsContact
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "div-button display-flex clickable mr-2",
    on: {
      "click": _vm.clickedEditContact
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', [_c('b', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Edit " + _vm._s(_vm.firstName))]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "350",
      "color": "#888"
    }
  }, [_vm._v("Name, phone, email for every future transaction")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "div-button display-flex clickable mr-2",
    on: {
      "click": _vm.showElementDialog
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("share")]), _vm._v(" "), _c('div', [_c('b', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Change Association")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "350",
      "color": "#888"
    }
  }, [_vm._v("Role and comments for this transaction only")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": function($event) {
        return _vm.unlinkContact(_vm.elementAsContact)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.refreshContact
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)])]), _vm._v(" "), _c('ContactEditor', {
    attrs: {
      "settings": _vm.contactEditor.settings,
      "contactItem": _vm.contactEditor.contact
    },
    on: {
      "saved": _vm.contactSaved
    }
  }), _vm._v(" "), _c('OfficeSelectionDialog', {
    attrs: {
      "settings": _vm.officeSelectionDialog.settings
    },
    on: {
      "select": _vm.copyToOffices
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "contact-images",
    class: {
      expanded: _vm.contacts.length > 7
    }
  }, [_c('ImageFader', {
    staticClass: "contact-image white-border shadow ",
    style: (_vm.contactOneStyle),
    attrs: {
      "src": _vm.imageOne,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "contact-image white-border shadow ",
    style: (_vm.contactTwoStyle),
    attrs: {
      "src": _vm.imageTwo,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "contact-image white-border shadow ",
    style: (_vm.contactThreeStyle),
    attrs: {
      "src": _vm.imageThree,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-label contact-label-1 ",
    class: {
      visible: this.contacts.length == 2
    }
  }, [_vm._v("\n        " + _vm._s(_vm.contactLabel(_vm.contacts[0])) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contact-label contact-label-2",
    class: {
      visible: this.contacts.length == 2
    }
  }, [_vm._v("\n        " + _vm._s(_vm.contactLabel(_vm.contacts[1])) + "\n    ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "contact-heart",
    class: {
      hidden: !_vm.partners
    },
    attrs: {
      "color": "red lighten-2"
    }
  }, [_vm._v("\n        mdi-heart\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "group-label",
    class: {
      hidden: _vm.contacts.length < 3, lowered: _vm.contacts.length > 7
    },
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.selectedNames) + " (" + _vm._s(_vm.contacts.length) + ")")]), _vm._v(" "), (_vm.contacts.length > 3) ? _c('div', {
    staticStyle: {
      "padding-left": "11px",
      "padding-top": "2px"
    }
  }, [_c('ImageGroup', {
    attrs: {
      "images": _vm.limitedContacts.map(function (o) { return o.image; })
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 2648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed || !_vm.itemCount
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [(_vm.itemCount && !_vm.readOnly) ? _c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.groupTitle) + "\n            "), (_vm.summary && _vm.collapsed) ? _c('div', {
    staticClass: "summary-text"
  }, [_vm._v(" (" + _vm._s(_vm.summary) + ")")]) : _vm._e()], 1), _vm._v(" "), (!_vm.readOnly && !_vm.schema.hideButtons) ? _c('div', {
    staticClass: "group-heading-buttons",
    class: {
      collapsed: _vm.collapsed
    }
  }, [(_vm.itemCount) ? _c('div', {
    staticClass: "group-heading-button",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.subtract($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-minus")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group-heading-button",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")])], 1)]) : _vm._e()]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed && _vm.targetValue.length) ? _c('div', [_c('draggable', {
    staticClass: "draggable-container",
    class: {
      columns: _vm.schema.columns, 'read-only': _vm.readOnly
    },
    attrs: {
      "value": _vm.targetValue,
      "animation": "350",
      "group": "elements",
      "handle": ".menu-handle"
    },
    on: {
      "input": _vm.draggableInput
    }
  }, _vm._l((_vm.targetValue), function(record, recordIndex) {
    return _c('div', {
      key: recordIndex,
      staticClass: "group-item-area",
      class: {
        'read-only': _vm.readOnly
      },
      staticStyle: {
        "position": "relative"
      },
      style: (_vm.columnStyle)
    }, [_c('transition', {
      attrs: {
        "name": "slow-fade"
      }
    }, [(_vm.targetValue.length > 1) ? _c('div', {
      staticStyle: {
        "z-index": "3",
        "position": "absolute",
        "left": "-8px",
        "top": "-8px",
        "width": "40px",
        "height": "40px",
        "background-color": "rgba(190,190,190,0.5)",
        "color": "white",
        "text-align": "center",
        "border-radius": "20px",
        "font-size": "24px",
        "font-weight": "600",
        "padding-top": "3px"
      }
    }, [_vm._v("\n                        " + _vm._s(recordIndex + 1) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (!_vm.readOnly && !_vm.schema.hideButtons) ? _c('div', {
      staticClass: "menu-handle",
      staticStyle: {
        "position": "absolute",
        "right": "-2px",
        "top": "5px"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "grey lighten-1"
            }
          }, on), [_vm._v("more_vert")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteItem(recordIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "inputs-area"
    }, [_c('FormBlock', {
      attrs: {
        "horizontal": _vm.schema.horizontal,
        "schema": _vm.modifiedSchema,
        "value": _vm.targetValue[recordIndex],
        "context": _vm.context
      },
      on: {
        "change": function($event) {
          return _vm.emitChanges($event, recordIndex)
        }
      }
    })], 1)], 1)
  }), 0)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.save,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Team Name"
    },
    model: {
      value: (_vm.team.name),
      callback: function($$v) {
        _vm.$set(_vm.team, "name", $$v)
      },
      expression: "team.name"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}

/***/ }),
/* 2651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-checkbox', {
    staticClass: "compact",
    attrs: {
      "color": "primary",
      "input-value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "hide-details": true,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder,
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "min-width": "500",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "scrollable": "",
      "hide-overlay": false,
      "persistent": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.resetContactImage()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Reset Image")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body pa-4"
  }, [_c('ContactDetails', {
    ref: "contactDetails",
    attrs: {
      "contact": _vm.contact
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.contact.meta.key) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": _vm.deleteContact
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveContact($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelEdit($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 2653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-menu mt-2 ml-3"
  }, _vm._l((_vm.root.elements), function(element) {
    return _c('div', {
      key: element.title
    }, [_c('div', {
      staticClass: "menu-item page hoverable clickable",
      class: {
        'active': _vm.isActive(element), 'complete': element.percent > 54
      },
      on: {
        "click": function($event) {
          return _vm.nodeClicked(element, null)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('div', {
      staticClass: "behind-circular"
    }, [_c('v-progress-circular', {
      staticClass: "solid",
      staticStyle: {
        "border-radius": "4px",
        "margin": "-1px"
      },
      attrs: {
        "background-color": "grey lighten-2",
        "color": "blue lighten-1",
        "width": 5,
        "size": 35,
        "rotate": 265,
        "value": element.percent
      }
    }, [(element.percent > 0) ? _c('v-icon', {
      staticClass: "check-icon",
      attrs: {
        "color": "blue darken-1"
      }
    }, [_vm._v(_vm._s((element.percent == 100 ? 'check' : 'more_horiz')))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
      staticClass: "arrow-icon",
      attrs: {
        "color": "blue darken-1"
      }
    }, [_vm._v(_vm._s(element.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding": "5px",
        "border-radius": "0 18px 18px 0"
      }
    }, [_vm._v(_vm._s(element.title))]), _vm._v(" "), _c('div', {
      staticClass: "callout"
    })]), _vm._v(" "), _c('v-expand-transition', [(element.expanded) ? _c('div', {
      staticClass: "sections"
    }, _vm._l((element.elements), function(subElement) {
      return _c('div', {
        key: subElement.title,
        staticClass: "menu-item section hoverable clickable",
        class: {
          'active': _vm.isActive(subElement), 'complete': subElement.complete
        },
        on: {
          "click": function($event) {
            return _vm.nodeClicked(element, subElement)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex-basis": "40px"
        }
      }, [_c('div', {
        staticClass: "horizontal-branch"
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding": "10px 5px",
          "flex-grow": "1"
        }
      }, [_vm._v("\n                    " + _vm._s(subElement.title) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "callout"
      })])
    }), 0) : _vm._e()])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "pa-5"
  }, [_c('p', [_vm._v("\n            Insight Processing is committed to providing you with the best possible customer service experience. Insight Processing is bound by the Privacy Act 1988, which sets out a number of principles concerning the privacy of individuals.\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Collection of your personal information")]), _c('br'), _vm._v("\n            There are many aspects of the site which can be viewed without providing personal information, however, for access to future Insight Processing customer support features you are required to submit personally identifiable information. This may include but not limited to a unique username and password, or provide sensitive information in the recovery of your lost password.\n\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Sharing of your personal information")]), _c('br'), _vm._v("\n            We may occasionally hire other companies to provide services on our behalf, including but not limited to handling customer support enquiries, processing transactions or customer freight shipping. Those companies will be permitted to obtain only the personal information they need to deliver the service. Insight Processing takes reasonable steps to ensure that these organisations are bound by confidentiality and privacy obligations in relation to the protection of your personal information.\n\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Use of your personal information")]), _c('br'), _vm._v("\n            For each visitor to reach the site, we expressively collect the following non-personally identifiable information, including but not limited to browser type, version and language, operating system, pages viewed while browsing the Site, page access times and referring website address. This collected information is used solely internally for the purpose of gauging visitor traffic, trends and delivering personalized content to you while you are at this Site.\n\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            From time to time, we may use customer information for new, unanticipated uses not previously disclosed in our privacy notice. If our information practices change at some time in the future we will use for these new purposes only, data collected from the time of the policy change forward will adhere to our updated practices.\n\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Changes to this Privacy Policy")]), _c('br'), _vm._v("\n            Insight Processing reserves the right to make amendments to this Privacy Policy at any time. If you have objections to the Privacy Policy, you should not access or use the Site.\n\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Accessing Your Personal Information")]), _c('br'), _vm._v("\n            You have a right to access your personal information, subject to exceptions allowed by law. If you would like to do so, please let us know. You may be required to put your request in writing for security reasons. Insight Processing reserves the right to charge a fee for searching for, and providing access to, your information on a per request basis.\n\n        ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Contacting us")]), _c('br'), _vm._v("\n            Insight Processing welcomes your comments regarding this Privacy Policy. If you have any questions about this Privacy Policy and would like further information, please contact us by any of the following means during business hours Monday to Friday.\n            \n\n        ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}

/***/ }),
/* 2655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout",
    attrs: {
      "title": 'Download Contacts - ' + _vm.officeName,
      "rightVisible": true
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('div', {
    staticStyle: {
      "padding": "60px"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "120",
      "color": "#ddd"
    }
  }, [_vm._v("arrow_circle_down")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa-5"
  }, [_vm._v("\n            Contacts will be downloaded to CSV (comma separated) which will open in Excel."), _c('br'), _c('br'), _vm._v("\n            \n            You have " + _vm._s(_vm.contacts.length) + " contacts\n            "), _c('br'), _c('br'), _vm._v(" "), _c('vue-json-to-csv', {
    attrs: {
      "json-data": _vm.contacts,
      "labels": {
        firstName: {
          title: 'First name'
        },
        lastName: {
          title: 'Last name'
        },
        mobile: {
          title: 'Mobile'
        },
        email: {
          title: 'Email'
        },
        address: {
          title: 'Address'
        },
      },
      "csv-title": "Contacts"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("\n    Download\n  ")])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_vm._v("\n \n            ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 2656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Settings")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('LayoutPanel', {
    attrs: {
      "tree": _vm.page
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "flow-area white-background",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "group": "elements",
      "handle": ".drag-handle",
      "animation": 350
    },
    on: {
      "end": _vm.moved
    },
    model: {
      value: (_vm.flow.steps),
      callback: function($$v) {
        _vm.$set(_vm.flow, "steps", $$v)
      },
      expression: "flow.steps"
    }
  }, _vm._l((_vm.flow.steps), function(step) {
    return _c('div', {
      key: step._id,
      on: {
        "keydown": function($event) {
          $event.stopPropagation();
          return _vm.keyPressed($event, step)
        }
      }
    }, [_c('Step', {
      ref: ("step" + (step._id)),
      refInFor: true,
      attrs: {
        "step": step,
        "level": _vm.level
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 2658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width"
  }, [_c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v(_vm._s(_vm.chart.name))]), _vm._v(" "), (!_vm.chart.columns) ? _c('p', [_vm._v("No Columns")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "chart-outline"
  }, [_c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.chart.columns), function(column) {
    return _c('td', {
      staticClass: "chart-column"
    }, [_c('div', {
      staticClass: "chart-header"
    }, [_vm._v("\n                " + _vm._s(column.title) + "\n            ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.transactions), function(transaction) {
    return _c('tr', {
      staticClass: "chart-row"
    }, [_c('td', {
      staticStyle: {
        "background-color": "#ccc",
        "width": "8px",
        "padding": "0"
      }
    }), _vm._v(" "), _vm._l((_vm.chart.columns), function(column) {
      return _c('td', {
        staticClass: "chart-column"
      }, [_c('div', {
        staticClass: "chart-cell"
      }, [_c('a', {
        staticClass: "transparent",
        attrs: {
          "href": _vm.transactionLink(transaction.meta.key),
          "target": "_blank"
        }
      }, [_c('ChartControl', {
        attrs: {
          "record": transaction,
          "definition": column
        }
      })], 1)])])
    })], 2)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 2659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.homeLoan) ? _c('div', {
    ref: "mainDiagram",
    on: {
      "mousemove": function($event) {
        return _vm.drag($event)
      },
      "mouseup": function($event) {
        return _vm.endDrag($event)
      }
    }
  }, [_vm._l((_vm.homeLoan.groups), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex,
      staticClass: "xxxray",
      staticStyle: {
        "padding": "2px",
        "margin-bottom": "5px",
        "overflow-x": "scroll"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#aaa",
        "font-size": "12px",
        "padding": "2px"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.groupTitle(groupIndex)) + ": " + _vm._s(_vm._f("currency")(_vm.totalLoans(group))) + " total.\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "position": "relative"
      }
    }, [_vm._l((group.loans), function(loan, loanIndex) {
      return _c('div', {
        key: 'loan' + loanIndex,
        staticClass: "loan no-select",
        class: {
          dragging: loan._dragStart && loan._dragMode != 'splitter'
        },
        staticStyle: {
          "display": "flex"
        },
        style: (_vm.loanStyle(loan, group)),
        on: {
          "mousedown": function($event) {
            return _vm.startLoanDrag($event, loan)
          },
          "dblclick": function($event) {
            return _vm.editLoan(loan)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex-grow": "1",
          "padding": "4px 6px",
          "border": "solid 3px rgba(0,0,0,0.1)",
          "margin": "2px",
          "border-radius": "5px",
          "color": "white",
          "font-weight": "500"
        },
        style: (_vm.loanBarStyle(loan))
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-4px"
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": "",
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({
              attrs: {
                "color": "white",
                "small": ""
              }
            }, on), [_vm._v("keyboard_arrow_down")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.editLoan(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Edit Loan")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.addLoan(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add Loan")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.split(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Split Loan")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.split(loan, true)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Duplicate Loan")])], 1), _vm._v(" "), (group.loans.length > 1) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deleteLoan(loan)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete Loan")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v("\n\n                    " + _vm._s(_vm.loanTitle(loan)) + " "), (loan.rate) ? _c('span', {
        staticStyle: {
          "color": "white",
          "font-weight": "300",
          "xfont-size": "14px"
        }
      }, [_vm._v("@ "), _c('EditableText', {
        attrs: {
          "dark": ""
        },
        model: {
          value: (loan.rate),
          callback: function($$v) {
            _vm.$set(loan, "rate", $$v)
          },
          expression: "loan.rate"
        }
      }), _vm._v("%")], 1) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "white-space": "nowrap",
          "display": "inline-block",
          "line-height": "16px",
          "xfont-size": "14px",
          "font-weight": "300"
        }
      }, [_c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.loanPurposeOptions
        },
        model: {
          value: (loan.investment),
          callback: function($$v) {
            _vm.$set(loan, "investment", $$v)
          },
          expression: "loan.investment"
        }
      }), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.fixedOptions
        },
        model: {
          value: (loan.fixed),
          callback: function($$v) {
            _vm.$set(loan, "fixed", $$v)
          },
          expression: "loan.fixed"
        }
      }), _vm._v(" "), (loan.fixed) ? _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.rateLockOptions
        },
        model: {
          value: (loan.rateLock),
          callback: function($$v) {
            _vm.$set(loan, "rateLock", $$v)
          },
          expression: "loan.rateLock"
        }
      }) : _vm._e(), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.ioOptions
        },
        model: {
          value: (loan.io),
          callback: function($$v) {
            _vm.$set(loan, "io", $$v)
          },
          expression: "loan.io"
        }
      })], 1)]), _vm._v(" "), _c('div', {
        key: 'loanHandle' + loanIndex,
        staticClass: "loan-handle mt-1",
        class: {
          dragging: loan._dragStart && loan._dragMode == 'splitter'
        },
        attrs: {
          "color": "grey"
        },
        on: {
          "mousedown": function($event) {
            return _vm.$set(loan, '_dragMode', 'splitter')
          }
        }
      })])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "8px 2px 8px 5px",
        "width": "70px"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getLVR(group)) + "%\n            ")])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, _vm._l((group.properties), function(property, propertyIndex) {
      return _c('div', {
        key: 'property' + propertyIndex,
        staticClass: "property no-select",
        class: {
          dragging: Boolean(property._dragStart)
        },
        staticStyle: {
          "color": "white",
          "display": "flex",
          "border": "solid 3px rgba(0,0,0,0.1)",
          "margin": "2px",
          "border-radius": "5px",
          "flex-grow": "1"
        },
        style: (_vm.propertyStyle(property, group)),
        on: {
          "mousedown": function($event) {
            return _vm.startPropertyDrag($event, property)
          },
          "dblclick": function($event) {
            return _vm.editProperty(property)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "padding": "4px 6px",
          "font-weight": "500",
          "flex-grow": "1"
        }
      }, [_c('div', {
        staticStyle: {
          "float": "right",
          "margin-top": "-4px"
        }
      }, [_c('v-menu', {
        attrs: {
          "offset-y": "",
          "left": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-icon', _vm._g({
              attrs: {
                "color": "white",
                "small": ""
              }
            }, on), [_vm._v("keyboard_arrow_down")])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.addProperty(property)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Add Property")])], 1), _vm._v(" "), (group.properties.length > 1) ? _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deleteProperty(property)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete Property")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v("\n\n                    " + _vm._s(_vm._f("thousands")(property.value)) + "\n                    "), _c('span', {
        staticStyle: {
          "font-weight": "300",
          "xfont-size": "14px"
        }
      }, [_c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.existingPropertyOptions
        },
        model: {
          value: (property.existing),
          callback: function($$v) {
            _vm.$set(property, "existing", $$v)
          },
          expression: "property.existing"
        }
      }), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.investmentPropertyOptions
        },
        model: {
          value: (property.investment),
          callback: function($$v) {
            _vm.$set(property, "investment", $$v)
          },
          expression: "property.investment"
        }
      }), _vm._v(" "), _c('LabelMenu', {
        attrs: {
          "underline": "white",
          "menus": _vm.propertyTypes
        },
        model: {
          value: (property.type),
          callback: function($$v) {
            _vm.$set(property, "type", $$v)
          },
          expression: "property.type"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-weight": "300"
        }
      }, [_vm._v(_vm._s(property.address))])])])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-links"
  }, [_c('a', {
    staticClass: "bottom-link",
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("Add Group")]), _vm._v(" |\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('a', _vm._g({
          staticClass: "bottom-link",
          on: {
            "click": function($event) {}
          }
        }, on), [_vm._v("Delete Group")])]
      }
    }], null, false, 4058488063)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.homeLoan.groups), function(group, groupIndex) {
    return _c('v-list-item', {
      key: 'dg' + groupIndex,
      on: {
        "click": function($event) {
          return _vm.deleteGroup(groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.groupTitle(groupIndex)))])], 1)
  }), 1)], 1), _vm._v(" |\n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Copy")]), _vm._v(" | \n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": function($event) {
        return _vm.$set(_vm.homeLoan, 'summaryVisible', !_vm.homeLoan.summaryVisible)
      }
    }
  }, [_vm._v(_vm._s(_vm.homeLoan.summaryVisible ? 'Hide Summary' : 'Summary'))]), _vm._v(" |\n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": function($event) {
        return _vm.$set(_vm.homeLoan, 'locked', !_vm.homeLoan.locked)
      }
    }
  }, [_vm._v(_vm._s(_vm.homeLoan.locked ? 'Unlock' : 'Lock'))]), _vm._v(" |\n        "), _c('a', {
    staticClass: "bottom-link",
    on: {
      "click": _vm.help
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('Timer', {
    attrs: {
      "seconds": 9,
      "watch": _vm.homeLoan
    },
    on: {
      "run": _vm.saveDiagram
    }
  })], 1)], 1), _vm._v(" "), (_vm.homeLoan.summaryVisible) ? _c('div', {
    staticClass: "summary"
  }, _vm._l((_vm.shortSummary), function(attribute) {
    return _c('div', {
      key: attribute.name,
      attrs: {
        "title": attribute.name
      }
    }, [_vm._v("\n            " + _vm._s(attribute.title) + ": " + _vm._s(attribute.value) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "simple",
    staticClass: "simple-version-div",
    staticStyle: {
      "font-size": "16px",
      "max-width": "800px"
    }
  }, [_vm._l((_vm.homeLoan.groups), function(group, groupIndex) {
    return [_c('div', {
      key: 'gh' + groupIndex,
      staticStyle: {
        "color": "#888",
        "font-size": "14px",
        "padding": "2px"
      }
    }, [_vm._v(_vm._s(_vm.groupTitle(groupIndex)) + ": " + _vm._s(_vm._f("currency")(_vm.totalLoans(group))) + " total.")]), _vm._v(" "), _c('table', {
      key: 'sgl' + groupIndex,
      attrs: {
        "cellspacing": "5",
        "width": "100%"
      }
    }, [_c('tr', [_vm._l((group.loans), function(loan, loanIndex) {
      return _c('td', {
        key: 'sl' + loanIndex,
        staticStyle: {
          "color": "white",
          "border-radius": "5px",
          "padding": "5px",
          "min-width": "150px"
        },
        style: (_vm.loanBarStyle(loan, group)),
        attrs: {
          "width": _vm.percentage(loan, group) + '%',
          "valign": "top"
        }
      }, [_c('strong', [_vm._v(_vm._s(_vm.loanTitle(loan)))]), _vm._v(" " + _vm._s(_vm.loanDetails(loan)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getLVR(group)) + "%\n                ")])], 2)]), _vm._v(" "), _c('table', {
      key: 'sgp' + groupIndex,
      staticStyle: {
        "margin-top": "-5px"
      },
      attrs: {
        "cellspacing": "5",
        "width": "100%"
      }
    }, [_c('tr', _vm._l((group.properties), function(property, propertyIndex) {
      return _c('td', {
        key: 'sp' + propertyIndex,
        staticStyle: {
          "color": "white",
          "border-radius": "5px",
          "padding": "5px",
          "min-width": "150px"
        },
        style: (_vm.propertyColour(property, group) + 'width:' + _vm.percentage(property, group) + '%'),
        attrs: {
          "valign": "top"
        }
      }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(property.value)))]), _vm._v(" " + _vm._s(_vm.propertyDetails(property)) + "\n                ")])
    }), 0)])]
  })], 2), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Loan Details",
      "settings": _vm.loanDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveLoan(_vm.loanDialog.loan)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "blue--text text--darken-2",
    staticStyle: {
      "margin-top": "-15px"
    },
    style: ({
      'visibility': _vm.activeLoanPayment ? 'visible' : 'hidden'
    })
  }, [(_vm.loanDialog.loan.io) ? _c('span', [_vm._v("IO ")]) : _vm._e(), _vm._v("\n                Repayment " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment)) + "pm\n                 | " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment * 12 / 52)) + "pw\n\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('currency-box', {
    ref: "focus",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Base Amount"
    },
    model: {
      value: (_vm.loanDialog.loan.amount),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "amount", _vm._n($$v))
      },
      expression: "loanDialog.loan.amount"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.lmiOptions,
      "label": "LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmiType),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmiType", $$v)
      },
      expression: "loanDialog.loan.lmiType"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "Est LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmi),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmi", _vm._n($$v))
      },
      expression: "loanDialog.loan.lmi"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Rate %"
    },
    model: {
      value: (_vm.loanDialog.loan.rate),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rate", _vm._n($$v))
      },
      expression: "loanDialog.loan.rate"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.yearsOptions,
      "label": "Years"
    },
    model: {
      value: (_vm.loanDialog.loan.years),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "years", $$v)
      },
      expression: "loanDialog.loan.years"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "New Money (if different)"
    },
    model: {
      value: (_vm.loanDialog.loan.newMoney),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "newMoney", $$v)
      },
      expression: "loanDialog.loan.newMoney"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-2",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "gap": "15px"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Package",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.package),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "package", $$v)
      },
      expression: "loanDialog.loan.package"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Special",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.special),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "special", $$v)
      },
      expression: "loanDialog.loan.special"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Investment",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.investment),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "investment", $$v)
      },
      expression: "loanDialog.loan.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Existing Debt Keeping",
      "hide-details": ""
    },
    model: {
      value: (_vm.loanDialog.loan.existing),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "existing", $$v)
      },
      expression: "loanDialog.loan.existing"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.fixedOptions,
      "label": (_vm.loanDialog.loan.fixed ? 'Fixed Period' : 'Fixed or Variable')
    },
    model: {
      value: (_vm.loanDialog.loan.fixed),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "fixed", _vm._n($$v))
      },
      expression: "loanDialog.loan.fixed"
    }
  }), _vm._v(" "), (_vm.loanDialog.loan.fixed) ? _c('div', {
    staticStyle: {
      "flex-basis": "180px"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Rate Lock"
    },
    model: {
      value: (_vm.loanDialog.loan.rateLock),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rateLock", $$v)
      },
      expression: "loanDialog.loan.rateLock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.ioOptions,
      "label": (_vm.loanDialog.loan.io ? 'Interest Only Period' : 'P&I or IO')
    },
    model: {
      value: (_vm.loanDialog.loan.io),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "io", _vm._n($$v))
      },
      expression: "loanDialog.loan.io"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Product",
      "hint": "Include any offers or rebates"
    },
    model: {
      value: (_vm.loanDialog.loan.product),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "product", $$v)
      },
      expression: "loanDialog.loan.product"
    }
  })], 1)]), _vm._v(" "), _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        _vm.deleteLoan(_vm.loanDialog.loan._originalLoan);
        _vm.loanDialog.settings.visible = false;
      }
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Propety Details",
      "settings": _vm.propertyDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveProperty(_vm.propertyDialog.property)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('currency-box', {
    ref: "focus",
    attrs: {
      "label": "Value"
    },
    model: {
      value: (_vm.propertyDialog.property.value),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "value", _vm._n($$v))
      },
      expression: "propertyDialog.property.value"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Investment"
    },
    model: {
      value: (_vm.propertyDialog.property.investment),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "investment", $$v)
      },
      expression: "propertyDialog.property.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Existing"
    },
    model: {
      value: (_vm.propertyDialog.property.existing),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "existing", $$v)
      },
      expression: "propertyDialog.property.existing"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address"
    },
    model: {
      value: (_vm.propertyDialog.property.address),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "address", $$v)
      },
      expression: "propertyDialog.property.address"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "label": "Type"
    },
    model: {
      value: (_vm.propertyDialog.property.type),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.property, "type", $$v)
      },
      expression: "propertyDialog.property.type"
    }
  })], 1), _vm._v(" "), (!_vm.homeLoan.locked) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        _vm.deleteProperty(_vm.propertyDialog.property._originalProperty);
        _vm.propertyDialog.settings.visible = false;
      }
    },
    slot: "footer"
  }) : _vm._e()], 1)], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.element.title,
      "disabled": _vm.element.disabled,
      "hide-details": true,
      "single-line": false
    },
    on: {
      "change": _vm.fieldChanged
    },
    model: {
      value: (_vm.element.value),
      callback: function($$v) {
        _vm.$set(_vm.element, "value", $$v)
      },
      expression: "element.value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('BaseInput', {
    attrs: {
      "label": _vm.schema.label
    }
  }, [(_vm.isUploading) ? _vm._l((_vm.uploading), function(upload) {
    return _c('div', {
      key: upload.name,
      staticClass: "file-row",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIcon(upload.type)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-wrap",
      staticStyle: {
        "color": "#888",
        "flex-grow": "1",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(upload.name.replace(/-.{6}\./, '.')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "100px",
        "padding-top": "18px"
      }
    }, [_c('v-progress-linear', {
      model: {
        value: (upload.progress),
        callback: function($$v) {
          _vm.$set(upload, "progress", $$v)
        },
        expression: "upload.progress"
      }
    })], 1)])
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.value), function(file, idx) {
    return _c('div', {
      key: file.name
    }, [_c('DocumentView', {
      attrs: {
        "url": _vm.value[idx].url,
        "type": _vm.value[0].type
      }
    }, [_c('div', {
      staticClass: "file-row",
      class: {
        single: !_vm.schema.multiple
      }
    }, [_c('div', {
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v(_vm._s(_vm.fileIcon(file.type)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "no-wrap",
      staticStyle: {
        "color": "#888",
        "flex-grow": "1",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(file.name.replace(/-.{6}\./, '.')))]), _vm._v(" "), _c('div', [_c('ConfirmIcon', {
      staticStyle: {
        "top": "4px"
      },
      attrs: {
        "small": "",
        "corner": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(file)
        }
      }
    })], 1)])])], 1)
  }), _vm._v(" "), (_vm.uploaderVisible) ? _c('div', {
    staticClass: "display-flex full-width xxxpt-1"
  }, [_c('div', {
    staticClass: "file-upload",
    class: {
      'has-files': _vm.value && _vm.value.length
    },
    staticStyle: {
      "flex-grow": "1"
    }
  }, [(_vm.linking) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    ref: "url",
    staticClass: "quick-input",
    staticStyle: {
      "margin": "-3px 0 -4px 0"
    },
    attrs: {
      "placeholder": "https://www.link.com/file  (ESC to Cancel)",
      "type": "text"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.hideLinking($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }) : _c('UploadWrapper', {
    attrs: {
      "multiple": _vm.schema.multiple
    },
    on: {
      "click": function($event) {},
      "select": _vm.uploadFiles
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-upload")]), _vm._v("Drag or Click to Upload\n                ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "file-upload",
    staticStyle: {
      "flex-basis": "100px",
      "border-left": "solid 1px #ccc",
      "position": "relative"
    },
    on: {
      "click": _vm.link
    }
  }, [(!_vm.linking) ? _c('div', {
    staticClass: "link-or elevation-1"
  }, [_vm._v("OR")]) : _vm._e(), _vm._v("\n                Link\n            ")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 2663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "rightVisible": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Charts")]), _vm._v(" "), _vm._l((_vm.charts), function(chart) {
    return _c('v-list-item', {
      key: chart.title,
      class: {
        'active-list-item': _vm.isChartActive(chart)
      },
      on: {
        "click": function($event) {
          _vm.activeChart = chart
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-chart-bar")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
      domProps: {
        "innerHTML": _vm._s(chart.name)
      }
    })], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c(_vm.activeChart.type, {
    tag: "component",
    attrs: {
      "chart": _vm.activeChart,
      "tenantKey": _vm.tenantKey
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 2664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "xxxstyle": "max-width:100%"
    }
  }, [_c('div', {
    ref: "diagram"
  }, [_vm._l((_vm.groups), function(group, groupIndex) {
    return _c('div', {
      key: groupIndex,
      staticClass: "diagram-group",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "right": "-11px",
        "top": "-11px",
        "background-color": "white"
      }
    }, [_c('v-menu', {
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "color": "primary"
            }
          }, on), [_vm._v("add_circle")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editLoan(null, null, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add loan")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editProperty(null, null, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add property")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addGroup
      }
    }, [_c('v-list-item-title', [_vm._v("Add group")])], 1), _vm._v(" "), (_vm.groups.length > 1) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.removeGroup(groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Remove group")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.copyToClipboard
      }
    }, [_c('v-list-item-title', [_vm._v("Copy to Clipboard")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          _vm.wordWrap = !_vm.wordWrap
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Word Wrap")]), _vm._v(" "), (_vm.wordWrap) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._l((group.loans), function(loan, loanIndex) {
      return _c('div', {
        key: loanIndex,
        class: _vm.loanClass(loan),
        staticStyle: {
          "display": "flex"
        },
        style: ({
          'flex-basis': loan.meta.width + '%',
          'flex-shrink': loan.meta.width
        }),
        on: {
          "click": function($event) {
            return _vm.editLoan(loan, loanIndex, groupIndex)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "flex-grow": "1"
        }
      }, [_c('span', {
        staticClass: "amount"
      }, [_vm._v(_vm._s(_vm._f("thousands")(loan.meta.amountTotal)))]), _vm._v("\n                        " + _vm._s(_vm.loanDescription(loan)) + "\n                    ")])])
    }), _vm._v(" "), _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            staticClass: "diagram-space diagram-bar",
            style: ({
              'flex-basis': (100 - group.lvr) + '%'
            })
          }, on), [_vm._v(_vm._s(group.lvr) + "%")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(92, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("92%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(90, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("90%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(88, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("88%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(85, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("85%")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.adjustLVR(80, groupIndex)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("80%")])], 1)], 1)], 1)], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, _vm._l((group.properties), function(property, propertyIndex) {
      return _c('div', {
        key: propertyIndex,
        class: _vm.propertyClass(property),
        style: ({
          'flex-basis': property.meta.width + '%'
        }),
        on: {
          "click": function($event) {
            return _vm.editProperty(property, propertyIndex, groupIndex)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(_vm._f("thousands")(property.value)) + "\n                    "), (property.address && _vm.$vuetify.breakpoint.mdAndUp) ? _c('span', {
        staticStyle: {
          "color": "rgba(255, 255, 255, 0.7)"
        }
      }, [_vm._v(" - " + _vm._s(property.address))]) : _vm._e(), _vm._v(" "), (property.existing) ? _c('span', [_vm._v(" (Existing)")]) : _vm._e()])
    }), 0)])
  }), _vm._v(" "), _c('div', [_vm._l((_vm.summary), function(attribute) {
    return [(_vm.isPositiveAmount(attribute.value)) ? _c('v-chip', {
      key: attribute.name,
      staticClass: "attribute-chip mt-1 mr-1 grey--text text--darken-1",
      class: {
        selected: attribute == _vm.selectedAttribute
      },
      attrs: {
        "title": attribute.name,
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.selectAttribute(attribute)
        }
      }
    }, [_vm._v(_vm._s(attribute.title) + ": " + _vm._s(_vm._f("currency")(attribute.value)))]) : _vm._e()]
  })], 2)], 2), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Loan Details",
      "settings": _vm.loanDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveLoan(_vm.loanDialog.loan)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "blue--text text--darken-2",
    staticStyle: {
      "margin-top": "-15px"
    },
    style: ({
      'visibility': _vm.activeLoanPayment ? 'visible' : 'hidden'
    })
  }, [(_vm.loanDialog.loan.io) ? _c('span', [_vm._v("IO ")]) : _vm._e(), _vm._v("\n                Repayment " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment)) + "pm\n                 | " + _vm._s(_vm._f("currency")(_vm.activeLoanPayment * 12 / 52)) + "pw\n\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('currency-box', {
    ref: "focus",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Base Amount"
    },
    model: {
      value: (_vm.loanDialog.loan.amount),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "amount", _vm._n($$v))
      },
      expression: "loanDialog.loan.amount"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.lmiOptions,
      "label": "LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmiType),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmiType", $$v)
      },
      expression: "loanDialog.loan.lmiType"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "Est LMI"
    },
    model: {
      value: (_vm.loanDialog.loan.lmi),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "lmi", _vm._n($$v))
      },
      expression: "loanDialog.loan.lmi"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "Rate %"
    },
    model: {
      value: (_vm.loanDialog.loan.rate),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rate", _vm._n($$v))
      },
      expression: "loanDialog.loan.rate"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.yearsOptions,
      "label": "Years"
    },
    model: {
      value: (_vm.loanDialog.loan.years),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "years", $$v)
      },
      expression: "loanDialog.loan.years"
    }
  }), _vm._v(" "), _c('currency-box', {
    attrs: {
      "label": "New Money (if different)"
    },
    model: {
      value: (_vm.loanDialog.loan.newMoney),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "newMoney", $$v)
      },
      expression: "loanDialog.loan.newMoney"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Package"
    },
    model: {
      value: (_vm.loanDialog.loan.package),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "package", $$v)
      },
      expression: "loanDialog.loan.package"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "Special"
    },
    model: {
      value: (_vm.loanDialog.loan.special),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "special", $$v)
      },
      expression: "loanDialog.loan.special"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "Investment"
    },
    model: {
      value: (_vm.loanDialog.loan.investment),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "investment", $$v)
      },
      expression: "loanDialog.loan.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "Existing Debt Keeping"
    },
    model: {
      value: (_vm.loanDialog.loan.existing),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "existing", $$v)
      },
      expression: "loanDialog.loan.existing"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "items": _vm.fixedOptions,
      "item-text": "display",
      "item-value": "years",
      "label": (_vm.loanDialog.loan.fixed ? 'Fixed Period' : 'Fixed or Variable')
    },
    model: {
      value: (_vm.loanDialog.loan.fixed),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "fixed", _vm._n($$v))
      },
      expression: "loanDialog.loan.fixed"
    }
  }), _vm._v(" "), (_vm.loanDialog.loan.fixed) ? _c('div', {
    staticStyle: {
      "flex-basis": "180px"
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Rate Lock"
    },
    model: {
      value: (_vm.loanDialog.loan.rateLock),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "rateLock", $$v)
      },
      expression: "loanDialog.loan.rateLock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.ioOptions,
      "item-text": "display",
      "item-value": "years",
      "label": (_vm.loanDialog.loan.io ? 'Interest Only Period' : 'P&I or IO')
    },
    model: {
      value: (_vm.loanDialog.loan.io),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "io", _vm._n($$v))
      },
      expression: "loanDialog.loan.io"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Product",
      "hint": "Include any offers or rebates"
    },
    model: {
      value: (_vm.loanDialog.loan.product),
      callback: function($$v) {
        _vm.$set(_vm.loanDialog.loan, "product", $$v)
      },
      expression: "loanDialog.loan.product"
    }
  })], 1)]), _vm._v(" "), (_vm.allowDeleteLoan(_vm.loanDialog.loan)) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteLoan(_vm.loanDialog.loan)
      }
    },
    slot: "footer"
  }) : _vm._e()], 1), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "title": "Propety Details",
      "settings": _vm.propertyDialog.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {
        return _vm.saveProperty(_vm.propertyDialog.model)
      }
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('currency-box', {
    ref: "focus",
    attrs: {
      "label": "Value"
    },
    model: {
      value: (_vm.propertyDialog.model.value),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "value", _vm._n($$v))
      },
      expression: "propertyDialog.model.value"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Investment"
    },
    model: {
      value: (_vm.propertyDialog.model.investment),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "investment", $$v)
      },
      expression: "propertyDialog.model.investment"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Existing"
    },
    model: {
      value: (_vm.propertyDialog.model.existing),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "existing", $$v)
      },
      expression: "propertyDialog.model.existing"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address"
    },
    model: {
      value: (_vm.propertyDialog.model.address),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "address", $$v)
      },
      expression: "propertyDialog.model.address"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.propertyTypes,
      "label": "Type"
    },
    model: {
      value: (_vm.propertyDialog.model.type),
      callback: function($$v) {
        _vm.$set(_vm.propertyDialog.model, "type", $$v)
      },
      expression: "propertyDialog.model.type"
    }
  })], 1), _vm._v(" "), (_vm.allowDeleteProperty(_vm.propertyDialog.model)) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "slot": "footer"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteProperty(_vm.propertyDialog.model)
      }
    },
    slot: "footer"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "suffix": _vm.abbreviation,
      "prefix": "$",
      "append-icon": "keyboard_arrow_down"
    },
    on: {
      "blur": _vm.emitAmountChange,
      "click:append": _vm.toggleFrequency
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Document Checklist")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.showDocumentDialog(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add_circle")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.lender) + "\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.lenders), function(lender) {
    return _c('v-list-item', {
      key: lender.key,
      on: {
        "click": function($event) {
          return _vm.showDocumentDialog(null, _vm.category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(lender.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.documents), function(document) {
    return _c('div', {
      key: document.key
    }, [_c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(document.title))]), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_c('b', [_vm._v(_vm._s(_vm.getPreferredOption(document).title))])]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.getPreferredOption(document).description) + " \n             | "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOptionDialog(document.key, document.preferredIndex, _vm.getPreferredOption(document))
        }
      }
    }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
      staticClass: "mb-3 mt-3"
    }, [_vm._v("\n            Other Options: \n            "), _vm._l((document.options), function(option, index) {
      return [(true) ? _c('span', {
        key: index
      }, [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setPreferredIndex(document, index)
          }
        }
      }, [_vm._v(_vm._s(option.title))]), _vm._v(" | \n                ")]) : _vm._e()]
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showOptionDialog(document.key, null, null)
        }
      }
    }, [_vm._v("Create New Option")])], 2)])
  })], 2), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "settings": _vm.documentDialog.settings
    },
    on: {
      "save": _vm.saveDocumentDialog
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-text-field', {
    ref: "documentTitle",
    attrs: {
      "label": "Title",
      "maxlength": "30"
    },
    on: {
      "change": _vm.setDefaultName
    },
    model: {
      value: (_vm.documentDialog.document.title),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.document, "title", $$v)
      },
      expression: "documentDialog.document.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.documentDialog.document.name),
      callback: function($$v) {
        _vm.$set(_vm.documentDialog.document, "name", $$v)
      },
      expression: "documentDialog.document.name"
    }
  })], 1)]), _vm._v(" "), _c('DialogBox', {
    attrs: {
      "settings": _vm.optionDialog.settings
    },
    on: {
      "save": _vm.saveOptionDialog
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-text-field', {
    ref: "optionTitle",
    attrs: {
      "label": "Title",
      "maxlength": "30"
    },
    model: {
      value: (_vm.optionDialog.option.title),
      callback: function($$v) {
        _vm.$set(_vm.optionDialog.option, "title", $$v)
      },
      expression: "optionDialog.option.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description"
    },
    model: {
      value: (_vm.optionDialog.option.description),
      callback: function($$v) {
        _vm.$set(_vm.optionDialog.option, "description", $$v)
      },
      expression: "optionDialog.option.description"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 2667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#eee",
      "height": "100%"
    }
  }, [(_vm.definition.type == 'pd') ? _c('div', {
    staticClass: "progress-control padded",
    class: _vm.controlClass,
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    }
  }, [_c('div', {}, [_c('v-icon', {
    staticStyle: {
      "font-size": "45px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "no-wrap",
    staticStyle: {
      "text-align": "center",
      "flex-grow": "1"
    }
  }, [_vm._v(_vm._s(_vm.dateInWords || 'Waiting'))])]) : _vm._e(), _vm._v(" "), (_vm.definition.type == 'pc') ? _c('div', {
    staticClass: "progress-control contact",
    class: _vm.controlClass,
    staticStyle: {
      "display": "flex",
      "height": "100%",
      "align-items": "center"
    }
  }, [_c('ImageGroup', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px",
      "flex-basis": "70px"
    },
    attrs: {
      "images": _vm.clientImages
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-wrap",
    staticStyle: {
      "font-size": "16px",
      "padding": "15px"
    }
  }, [_vm._v(_vm._s(_vm.clientNames || ' '))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_c('div', {
    staticClass: "element-label",
    staticStyle: {
      "height": "24px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploading),
      expression: "uploading"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "20",
      "width": "2",
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('croppa', {
    staticStyle: {
      "border": "solid 2px #bbb",
      "border-radius": "0px"
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "quality": 1,
      "placeholder": _vm.placeholder,
      "placeholder-font-size": 14,
      "file-size-limit": 100000,
      "placeholder-color": "#999",
      "disabled": false,
      "prevent-white-space": true,
      "canvas-color": "white",
      "show-remove-button": true,
      "remove-button-size": 20,
      "initial-image": _vm.element.value
    },
    on: {
      "file-size-exceed": _vm.fileSizeExceeded,
      "zoom": _vm.imageChanged,
      "move": _vm.imageChanged,
      "file-choose": _vm.imageChanged,
      "image-remove": _vm.imageRemoved
    },
    model: {
      value: (_vm.imageObject),
      callback: function($$v) {
        _vm.imageObject = $$v
      },
      expression: "imageObject"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle) + " \n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "max-width": "800px"
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.dashes), function(dash) {
    return _c('v-list-item', {
      key: dash.name,
      on: {
        "click": function($event) {
          return _vm.selectDash(dash)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("insert_chart")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(dash.name))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(dash.section) + " - " + _vm._s(dash.field))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [(!_vm.editMode) ? _c('div', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "z-index": "1000"
    },
    attrs: {
      "color": "grey lighten-2",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.editMode = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Dashboard', {
    attrs: {
      "dash": _vm.dash
    }
  })], 1) : _c('div', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.dash.name),
      callback: function($$v) {
        _vm.$set(_vm.dash, "name", $$v)
      },
      expression: "dash.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Section"
    },
    model: {
      value: (_vm.dash.section),
      callback: function($$v) {
        _vm.$set(_vm.dash, "section", $$v)
      },
      expression: "dash.section"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field"
    },
    model: {
      value: (_vm.dash.field),
      callback: function($$v) {
        _vm.$set(_vm.dash, "field", $$v)
      },
      expression: "dash.field"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveDash(_vm.dash)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.editMode = false
      }
    }
  }, [_vm._v("Cancel")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "taco-container"
  }, [_c('v-toolbar', {
    staticClass: "primary no-print",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.liveTransaction.details.clients) + " " + _vm._s(_vm.lender) + " Documents\n\n        "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "nudge-bottom": 8,
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_vm._l((_vm.lenders), function(lender) {
    return _c('v-list-item', {
      key: lender.name,
      on: {
        "click": function($event) {
          return _vm.setLender(lender.name)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(lender.name))])], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    key: "general",
    on: {
      "click": function($event) {
        return _vm.setLender('General')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("General Options")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.showEmail
          }
        }, on), [_c('v-icon', [_vm._v("email")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email Client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "dark": "",
            "icon": ""
          },
          on: {
            "click": _vm.goToTransaction
          }
        }, on), [_c('v-icon', [_vm._v("ballot")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Go to Transaction")])]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.goToTransaction
    }
  }, [_c('v-list-item-title', [_vm._v("Go to Transaction")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "taco-content"
  }, [_c('v-col', {
    staticClass: "no-print taco-column",
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px 15px 20px"
    }
  }, [_c('v-text-field', {
    ref: "searchText",
    attrs: {
      "hide-details": "",
      "label": "Search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category['.key'],
      staticStyle: {
        "padding": "3px 10px 3px 10px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "1.3em",
        "padding": "0px 10px 0px 10px"
      }
    }, [_c('v-btn', {
      staticClass: "primary--text",
      staticStyle: {
        "float": "right",
        "margin-top": "-5px"
      },
      attrs: {
        "icon": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDialog(null, category)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "font-size": "2.1em"
      }
    }, [_vm._v("add_circle")])], 1), _vm._v("        \n        " + _vm._s(category.name) + "\n    ")], 1), _vm._v(" "), _c('div', {
      staticClass: "hide-scroll",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "hide-scroll-inner",
      staticStyle: {
        "max-height": "196px"
      }
    }, _vm._l((_vm.requirementsForCategory(category.name)), function(requirement) {
      return _c('div', {
        key: requirement['.key']
      }, [_c('div', {
        staticClass: "truncate pa-2 ma-2 border-grey hoverable clickable",
        class: {
          'blue-hilight': _vm.collectionContainsKey(_vm.selectedItems, requirement['.key'])
        },
        on: {
          "click": function($event) {
            return _vm.itemClicked(requirement)
          }
        }
      }, [_vm._v("\n            " + _vm._s(requirement.name) + "\n        ")])])
    }), 0)])])
  })], 2), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "8",
      "sm": "12"
    }
  }, [_c('v-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    staticClass: "taco-column",
    attrs: {
      "md": "8",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [(_vm.selectedItemsSorted.length == 0) ? _c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "margin-top": "30px",
      "width": "100%",
      "text": "align:center"
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-2",
    staticStyle: {
      "font-size": "300px"
    }
  }, [_vm._v("layers")]), _vm._v(" "), _c('p', {
    staticClass: "grey--text text--lighten-1",
    staticStyle: {
      "margin": "20px",
      "font-size": "1.3em"
    }
  }, [_vm._v("No items. Click on the document types to the left to start your list")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "checklist"
  }, [_vm._l((_vm.selectedItemsSorted), function(item) {
    return [_c('div', {
      key: item['.key'],
      staticClass: "border-transparent transition clickable hoverable",
      class: {
        'blue-hilight': item['.key'] == _vm.activeItem
      },
      staticStyle: {
        "color": "#444",
        "padding": "7px 15px 7px 15px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.listItemClicked(item)
        }
      }
    }, [(!item.notRequired) ? [(!item.received && !item.checked) ? [_c('b', {
      staticStyle: {
        "margin-bottom": "2px"
      }
    }, [(item.flag) ? _c('span', [_vm._v("(" + _vm._s(item.flag) + ") ")]) : _vm._e(), _vm._v(_vm._s(item.name))]), _vm._v(" "), (!item.received && !item.checked) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkorange",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(item.requirementName))]) : _vm._e(), _vm._v(" "), (item.description) ? [_c('br'), _vm._v(" " + _vm._s(item.description) + "\n                        ")] : _vm._e(), _vm._v(" "), (item.note) ? [_c('br'), _c('span', {
      staticStyle: {
        "padding": "2px 5px 2px 5px",
        "background-color": "yellow"
      }
    }, [_vm._v(_vm._s(item.note))])] : _vm._e(), _vm._v(" "), (item.download) ? [_c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": item.download,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return false($event)
        }
      }
    }, [_c('button', {
      staticStyle: {
        "margin-top": "5px",
        "margin-bottom": "0px",
        "color": "#444",
        "background-color": "white",
        "border-radius": "3px",
        "border": "solid 1px #c0c0c0",
        "padding": "5px 18px 5px 18px",
        "user-select": "none"
      }
    }, [_vm._v("Download")])])] : _vm._e()] : [_c('b', {
      staticStyle: {
        "margin-bottom": "2px",
        "color": "#444"
      }
    }, [(item.flag) ? _c('span', [_vm._v("(" + _vm._s(item.flag) + ") ")]) : _vm._e(), _vm._v(_vm._s(item.name))]), _vm._v(" "), (item.received) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkgreen",
        "padding-top": "2px",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("Received")]) : _vm._e(), _vm._v(" "), (item.checked) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkgreen",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v("Checked")]) : _vm._e(), _vm._v(" "), (_vm.documentExpired(item)) ? _c('span', {
      staticClass: "elevation-1",
      staticStyle: {
        "background-color": "darkred",
        "padding": "2px 5px 2px 5px",
        "border-radius": "3px",
        "color": "white",
        "font-weight": "bold",
        "margin-left": "4px",
        "font-size": "0.85em",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm.documentExpired(item)))]) : _vm._e()]] : [_c('i', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(item.description))])]], 2)]
  })], 2), _vm._v(" "), (_vm.selectedItems.length) ? _c('v-btn', _vm._g({
    attrs: {
      "dark": "",
      "rounded": "",
      "color": "blue lighten-1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyToClipboard($event)
      }
    }
  }, _vm.on), [_vm._v("\n        Copy to Clipboard\n    ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    staticClass: "no-print",
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.selectedItems.length) ? _c('v-btn', _vm._g({
          attrs: {
            "rounded": "",
            "color": "blue lighten-2"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.showEmail($event)
            }
          }
        }, on), [_vm._v("\n            Copy to Clipboard\n        ")]) : _vm._e()]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Email to Client")])]), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), (_vm.transactionKey) ? _c('v-col', {
    staticClass: "pa-3 no-print",
    attrs: {
      "md": "4",
      "sm": "12",
      "row": ""
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Next Followup")]), _vm._v("\n    " + _vm._s(_vm._f("dueString")(_vm.followUpTask.due)) + "\n    "), _c('Scheduler', {
    on: {
      "change": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.due),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "due", $$v)
      },
      expression: "followUpTask.due"
    }
  }), _vm._v(" "), _c('UserChooser', {
    attrs: {
      "label": "Assigned To"
    },
    on: {
      "select": _vm.saveFollowupTask
    },
    model: {
      value: (_vm.followUpTask.assigned),
      callback: function($$v) {
        _vm.$set(_vm.followUpTask, "assigned", $$v)
      },
      expression: "followUpTask.assigned"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "heading mt-4 mb-2"
  }, [_vm._v("Checklist Comments")]), _vm._v(" "), _c('TransactionComments')], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-overlay": true,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('v-tabs', {
    attrs: {
      "color": "primary",
      "id": "mobile-tabs-1",
      "dark": ""
    },
    model: {
      value: (_vm.dialogTab),
      callback: function($$v) {
        _vm.dialogTab = $$v
      },
      expression: "dialogTab"
    }
  }, [_c('v-tab', {
    key: 1
  }, [_vm._v("\n                Details\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 2
  }, [_vm._v("\n                Advanced\n            ")]), _vm._v(" "), _c('v-tab', {
    key: 3
  }, [_vm._v("\n                Checklist\n            ")]), _vm._v(" "), _c('v-tab-item', {
    key: 1
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "name": "document-name",
      "label": "Document Name"
    },
    model: {
      value: (_vm.documentName),
      callback: function($$v) {
        _vm.documentName = $$v
      },
      expression: "documentName"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "hide-details": "",
      "rows": "3",
      "name": "document-description",
      "label": "Description"
    },
    model: {
      value: (_vm.documentDescription),
      callback: function($$v) {
        _vm.documentDescription = $$v
      },
      expression: "documentDescription"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "document-note",
      "label": "Special Note",
      "hide-details": ""
    },
    model: {
      value: (_vm.documentNote),
      callback: function($$v) {
        _vm.documentNote = $$v
      },
      expression: "documentNote"
    }
  }), _vm._v(" "), _c('br'), _vm._v("Flag   \n                    "), _c('v-btn-toggle', {
    attrs: {
      "text": ""
    },
    model: {
      value: (_vm.documentFlag),
      callback: function($$v) {
        _vm.documentFlag = $$v
      },
      expression: "documentFlag"
    }
  }, [_c('v-btn', {
    key: "LATER",
    attrs: {
      "text": "",
      "value": "LATER"
    }
  }, [_vm._v("Later")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couple),
      expression: "couple"
    }],
    attrs: {
      "text": "",
      "value": _vm.client1
    }
  }, [_vm._v(_vm._s(_vm.client1))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couple),
      expression: "couple"
    }],
    attrs: {
      "text": "",
      "value": _vm.client2
    }
  }, [_vm._v(_vm._s(_vm.client2))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couple),
      expression: "couple"
    }],
    key: "BOTH",
    attrs: {
      "text": "",
      "value": "BOTH"
    }
  }, [_vm._v("Both")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-switch', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "color": "primary",
      "xhide-details": "",
      "label": "Received"
    },
    model: {
      value: (_vm.documentReceived),
      callback: function($$v) {
        _vm.documentReceived = $$v
      },
      expression: "documentReceived"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('v-switch', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "color": "primary",
      "hide-details": "",
      "label": "Checked"
    },
    model: {
      value: (_vm.documentChecked),
      callback: function($$v) {
        _vm.documentChecked = $$v
      },
      expression: "documentChecked"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": true,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Document Date",
            "value": _vm.documentDateString,
            "prepend-icon": "event",
            "readonly": ""
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.dialogDateMenu),
      callback: function($$v) {
        _vm.dialogDateMenu = $$v
      },
      expression: "dialogDateMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    model: {
      value: (_vm.documentDate),
      callback: function($$v) {
        _vm.documentDate = $$v
      },
      expression: "documentDate"
    }
  }, [
    [_c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": "-50px"
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.documentDate = null
        }
      }
    }, [_vm._v("Clear")])], 1)]
  ], 2)], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-tab-item', {
    key: 2
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-card-text', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "document-download",
      "label": "Download Link"
    },
    model: {
      value: (_vm.documentDownload),
      callback: function($$v) {
        _vm.documentDownload = $$v
      },
      expression: "documentDownload"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "document-expiry-days",
      "label": "Days to Expire"
    },
    model: {
      value: (_vm.documentExpiryDays),
      callback: function($$v) {
        _vm.documentExpiryDays = $$v
      },
      expression: "documentExpiryDays"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "8",
      "name": "document-description",
      "label": "Instructions"
    },
    model: {
      value: (_vm.documentInstructions),
      callback: function($$v) {
        _vm.documentInstructions = $$v
      },
      expression: "documentInstructions"
    }
  })], 1)], 1)]), _vm._v(" "), _c('v-tab-item', {
    key: 3
  }, [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-card-text', {
    attrs: {
      "height": "100%"
    }
  }, [_vm._l((_vm.documentChecklist), function(check, index) {
    return _c('div', {
      key: check.text
    }, [_c('DeleteButton', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          return _vm.documentChecklist.splice(index, 1)
        }
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "85%"
      },
      attrs: {
        "hide-details": "",
        "label": 'Check ' + (index + 1)
      },
      model: {
        value: (check.text),
        callback: function($$v) {
          _vm.$set(check, "text", $$v)
        },
        expression: "check.text"
      }
    })], 1)
  }), _vm._v(" "), _c('div', [_c('v-text-field', {
    attrs: {
      "label": "Add Check Item"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addCheckItem($event)
      }
    },
    model: {
      value: (_vm.newCheckItem),
      callback: function($$v) {
        _vm.newCheckItem = $$v
      },
      expression: "newCheckItem"
    }
  })], 1)], 2)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [(_vm.documentKey) ? _c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": function($event) {
        return _vm.deleteRequirement(_vm.documentKey)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 4000
    },
    model: {
      value: (_vm.snackbarshow),
      callback: function($$v) {
        _vm.snackbarshow = $$v
      },
      expression: "snackbarshow"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar) + "\n    "), _c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("assignment_turned_in")])], 1), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    }
  }), _vm._v(" "), _c('SupplierDocumentDialog', {
    attrs: {
      "settings": _vm.supplierDocumentDialog.settings,
      "document": _vm.supplierDocumentDialog.document
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tooltip', {
    attrs: {
      "left": "",
      "open-delay": 500
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          directives: [{
            name: "ripple",
            rawName: "v-ripple"
          }],
          staticClass: "list-jump",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.clicked($event)
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-menu-right")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tooltip))])])
},staticRenderFns: []}

/***/ }),
/* 2672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [(!_vm.profile) ? _c('div', [_vm._v("\n        No profile found "), _c('v-btn', {
    on: {
      "click": _vm.makeProfile
    }
  }, [_vm._v("Make")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa-10 white ma-7 elevation-3",
    staticStyle: {
      "position": "relative",
      "xbackground-color": "rgba(0,0,0,0.0)"
    }
  }, [_c('div', {
    staticClass: "heading mb-3"
  }, [_vm._v("Your Personal Profile")]), _vm._v(" "), _c('FormControl', {
    attrs: {
      "schema": _vm.profileSchema
    },
    model: {
      value: (_vm.profile),
      callback: function($$v) {
        _vm.profile = $$v
      },
      expression: "profile"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}

/***/ })
],[727]);


// WEBPACK FOOTER //
// static/js/app.86172022a62c9e7ddfb0.js